import * as Wl from "react";
import Ma, { isValidElement as eE, useLayoutEffect as Uk, useEffect as wt, useRef as Pt, useCallback as Pr, useMemo as qr, useState as Kt, useReducer as tE, createContext as Za, useContext as Qo, Fragment as nE, createRef as Yk, forwardRef as Ex } from "react";
import { s as Y9, c as $k } from "./sprinkles-DyY-9xTy.js";
/* empty css                              */
import { v as nh, b as Wk } from "./vars-BxiGwZcN.js";
var zk = Object.defineProperty, qk = Object.defineProperties, Gk = Object.getOwnPropertyDescriptors, p5 = Object.getOwnPropertySymbols, rE = Object.prototype.hasOwnProperty, aE = Object.prototype.propertyIsEnumerable, d_ = (e, n, a) => n in e ? zk(e, n, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[n] = a, Q = (e, n) => {
  for (var a in n || (n = {}))
    rE.call(n, a) && d_(e, a, n[a]);
  if (p5)
    for (var a of p5(n))
      aE.call(n, a) && d_(e, a, n[a]);
  return e;
}, De = (e, n) => qk(e, Gk(n)), Ue = (e, n) => {
  var a = {};
  for (var i in e)
    rE.call(e, i) && n.indexOf(i) < 0 && (a[i] = e[i]);
  if (e != null && p5)
    for (var i of p5(e))
      n.indexOf(i) < 0 && aE.call(e, i) && (a[i] = e[i]);
  return a;
}, Kk = Object.defineProperty, Qk = Object.defineProperties, Xk = Object.getOwnPropertyDescriptors, m5 = Object.getOwnPropertySymbols, oE = Object.prototype.hasOwnProperty, iE = Object.prototype.propertyIsEnumerable, h_ = (e, n, a) => n in e ? Kk(e, n, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[n] = a, Ct = (e, n) => {
  for (var a in n || (n = {}))
    oE.call(n, a) && h_(e, a, n[a]);
  if (m5)
    for (var a of m5(n))
      iE.call(n, a) && h_(e, a, n[a]);
  return e;
}, pn = (e, n) => Qk(e, Xk(n)), Fp = (e, n) => {
  var a = {};
  for (var i in e)
    oE.call(e, i) && n.indexOf(i) < 0 && (a[i] = e[i]);
  if (e != null && m5)
    for (var i of m5(e))
      n.indexOf(i) < 0 && iE.call(e, i) && (a[i] = e[i]);
  return a;
};
function A4(...e) {
}
function Jk(e, n) {
  if (e === n)
    return !0;
  if (!e || !n || typeof e != "object" || typeof n != "object")
    return !1;
  const a = Object.keys(e), i = Object.keys(n), { length: h } = a;
  if (i.length !== h)
    return !1;
  for (const g of a)
    if (e[g] !== n[g])
      return !1;
  return !0;
}
function j4(e, n) {
  if (eL(e)) {
    const a = tL(n) ? n() : n;
    return e(a);
  }
  return e;
}
function eL(e) {
  return typeof e == "function";
}
function tL(e) {
  return typeof e == "function";
}
function g5(e) {
  return typeof e == "object" && e != null;
}
function nL(e) {
  return typeof e == "number" ? Math.floor(e) === e : String(Math.floor(Number(e))) === e;
}
function vf(e, n) {
  return typeof Object.hasOwn == "function" ? Object.hasOwn(e, n) : Object.prototype.hasOwnProperty.call(e, n);
}
function xl(...e) {
  return (...n) => {
    for (const a of e)
      typeof a == "function" && a(...n);
  };
}
function rL(...e) {
  return e.filter(Boolean).join(" ") || void 0;
}
function Mx(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function aL(e, n) {
  const a = Ct({}, e);
  for (const i of n)
    vf(a, i) && delete a[i];
  return a;
}
function oL(e, n) {
  const a = {};
  for (const i of n)
    vf(e, i) && (a[i] = e[i]);
  return a;
}
function lE(e) {
  return e;
}
function Ht(e, n) {
  if (!e)
    throw typeof n != "string" ? new Error("Invariant failed") : new Error(n);
}
function iL(e) {
  return Object.keys(e);
}
function O2(e, ...n) {
  const a = typeof e == "function" ? e(...n) : e;
  return a == null ? !1 : !a;
}
function wf(e) {
  return e.disabled || e["aria-disabled"] === !0 || e["aria-disabled"] === "true";
}
function Pa(e) {
  const n = {};
  for (const a in e)
    e[a] !== void 0 && (n[a] = e[a]);
  return n;
}
function ht(...e) {
  for (const n of e)
    if (n !== void 0)
      return n;
}
function $9(e, n) {
  typeof e == "function" ? e(n) : e && (e.current = n);
}
function lL(e) {
  return !(!e || !eE(e) || !("ref" in e));
}
function uL(e) {
  return lL(e) ? e.ref : null;
}
function sL(e, n) {
  const a = Q({}, e);
  for (const i in n) {
    if (!vf(n, i))
      continue;
    if (i === "className") {
      const g = "className";
      a[g] = e[g] ? `${e[g]} ${n[g]}` : n[g];
      continue;
    }
    if (i === "style") {
      const g = "style";
      a[g] = e[g] ? Q(Q({}, e[g]), n[g]) : n[g];
      continue;
    }
    const h = n[i];
    if (typeof h == "function" && i.startsWith("on")) {
      const g = e[i];
      if (typeof g == "function") {
        a[i] = (...m) => {
          h(...m), g(...m);
        };
        continue;
      }
    }
    a[i] = h;
  }
  return a;
}
var Bp = cL();
function cL() {
  var e;
  return typeof window < "u" && !!((e = window.document) != null && e.createElement);
}
function aa(e) {
  return e ? e.ownerDocument || e : document;
}
function uE(e) {
  return aa(e).defaultView || window;
}
function yf(e, n = !1) {
  const { activeElement: a } = aa(e);
  if (!(a != null && a.nodeName))
    return null;
  if (Tx(a) && a.contentDocument)
    return yf(
      a.contentDocument.body,
      n
    );
  if (n) {
    const i = a.getAttribute("aria-activedescendant");
    if (i) {
      const h = aa(a).getElementById(i);
      if (h)
        return h;
    }
  }
  return a;
}
function pa(e, n) {
  return e === n || e.contains(n);
}
function Tx(e) {
  return e.tagName === "IFRAME";
}
function N0(e) {
  const n = e.tagName.toLowerCase();
  return n === "button" ? !0 : n === "input" && e.type ? fL.indexOf(e.type) !== -1 : !1;
}
var fL = [
  "button",
  "color",
  "file",
  "image",
  "reset",
  "submit"
];
function Ox(e, n) {
  return "matches" in e ? e.matches(n) : "msMatchesSelector" in e ? e.msMatchesSelector(n) : e.webkitMatchesSelector(n);
}
function sE(e) {
  const n = e;
  return n.offsetWidth > 0 || n.offsetHeight > 0 || e.getClientRects().length > 0;
}
function cE(e, n) {
  if ("closest" in e)
    return e.closest(n);
  do {
    if (Ox(e, n))
      return e;
    e = e.parentElement || e.parentNode;
  } while (e !== null && e.nodeType === 1);
  return null;
}
function yl(e) {
  try {
    const n = e instanceof HTMLInputElement && e.selectionStart !== null, a = e.tagName === "TEXTAREA";
    return n || a || !1;
  } catch {
    return !1;
  }
}
function W9(e) {
  return e.isContentEditable || yl(e);
}
function dL(e) {
  if (yl(e))
    return e.value;
  if (e.isContentEditable) {
    const n = aa(e).createRange();
    return n.selectNodeContents(e), n.toString();
  }
  return "";
}
function z9(e) {
  let n = 0, a = 0;
  if (yl(e))
    n = e.selectionStart || 0, a = e.selectionEnd || 0;
  else if (e.isContentEditable) {
    const i = aa(e).getSelection();
    if (i != null && i.rangeCount && i.anchorNode && pa(e, i.anchorNode) && i.focusNode && pa(e, i.focusNode)) {
      const h = i.getRangeAt(0), g = h.cloneRange();
      g.selectNodeContents(e), g.setEnd(h.startContainer, h.startOffset), n = g.toString().length, g.setEnd(h.endContainer, h.endOffset), a = g.toString().length;
    }
  }
  return { start: n, end: a };
}
function sh(e, n) {
  const a = ["dialog", "menu", "listbox", "tree", "grid"], i = e == null ? void 0 : e.getAttribute("role");
  return i && a.indexOf(i) !== -1 ? i : n;
}
function Dx(e, n) {
  var a;
  const i = {
    menu: "menuitem",
    listbox: "option",
    tree: "treeitem"
  }, h = sh(e);
  return h && (a = i[h]) != null ? a : n;
}
function Ax(e) {
  if (!e)
    return null;
  if (e.clientHeight && e.scrollHeight > e.clientHeight) {
    const { overflowY: n } = getComputedStyle(e);
    if (n !== "visible" && n !== "hidden")
      return e;
  } else if (e.clientWidth && e.scrollWidth > e.clientWidth) {
    const { overflowX: n } = getComputedStyle(e);
    if (n !== "visible" && n !== "hidden")
      return e;
  }
  return Ax(e.parentElement) || document.scrollingElement || document.body;
}
function x9(e, ...n) {
  /text|search|password|tel|url/i.test(e.type) && e.setSelectionRange(...n);
}
function hL() {
  return Bp && !!navigator.maxTouchPoints;
}
function jx() {
  return Bp ? /mac|iphone|ipad|ipod/i.test(navigator.platform) : !1;
}
function kx() {
  return Bp && jx() && /apple/i.test(navigator.vendor);
}
function vL() {
  return Bp && /firefox\//i.test(navigator.userAgent);
}
function pL() {
  return Bp && navigator.platform.startsWith("Mac") && !hL();
}
function fE(e) {
  return !!(e.currentTarget && !pa(e.currentTarget, e.target));
}
function Si(e) {
  return e.target === e.currentTarget;
}
function Lx(e) {
  const n = e.currentTarget;
  if (!n)
    return !1;
  const a = jx();
  if (a && !e.metaKey || !a && !e.ctrlKey)
    return !1;
  const i = n.tagName.toLowerCase();
  return i === "a" || i === "button" && n.type === "submit" || i === "input" && n.type === "submit";
}
function Ix(e) {
  const n = e.currentTarget;
  if (!n)
    return !1;
  const a = n.tagName.toLowerCase();
  return e.altKey ? a === "a" || a === "button" && n.type === "submit" || a === "input" && n.type === "submit" : !1;
}
function mL(e, n, a) {
  const i = new Event(n, a);
  return e.dispatchEvent(i);
}
function Rp(e, n) {
  const a = new FocusEvent("blur", n), i = e.dispatchEvent(a), h = pn(Ct({}, n), { bubbles: !0 });
  return e.dispatchEvent(new FocusEvent("focusout", h)), i;
}
function gL(e, n, a) {
  const i = new KeyboardEvent(n, a);
  return e.dispatchEvent(i);
}
function v_(e, n) {
  const a = new MouseEvent("click", n);
  return e.dispatchEvent(a);
}
function Qd(e, n) {
  const a = n || e.currentTarget, i = e.relatedTarget;
  return !i || !pa(a, i);
}
function D2(e, n, a) {
  const i = requestAnimationFrame(() => {
    e.removeEventListener(n, h, !0), a();
  }), h = () => {
    cancelAnimationFrame(i), a();
  };
  return e.addEventListener(n, h, {
    once: !0,
    capture: !0
  }), i;
}
function Go(e, n, a, i = window) {
  const h = [];
  try {
    i.document.addEventListener(e, n, a);
    for (const m of Array.from(i.frames))
      h.push(Go(e, n, a, m));
  } catch {
  }
  return () => {
    try {
      i.document.removeEventListener(e, n, a);
    } catch {
    }
    h.forEach((m) => m());
  };
}
var dE = Q({}, Wl), p_ = dE.useId, m_ = dE.useInsertionEffect, Ln = Bp ? Uk : wt;
function Hx(e) {
  const [n] = Kt(e);
  return n;
}
function hE(e) {
  const n = Pt(e);
  return Ln(() => {
    n.current = e;
  }), n;
}
function nt(e) {
  const n = Pt(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return m_ ? m_(() => {
    n.current = e;
  }) : n.current = e, Pr((...a) => {
    var i;
    return (i = n.current) == null ? void 0 : i.call(n, ...a);
  }, []);
}
function In(...e) {
  return qr(() => {
    if (e.some(Boolean))
      return (n) => {
        e.forEach((a) => $9(a, n));
      };
  }, e);
}
function Na(e) {
  if (p_) {
    const i = p_();
    return e || i;
  }
  const [n, a] = Kt(e);
  return Ln(() => {
    if (e || n)
      return;
    const i = Math.random().toString(36).substr(2, 6);
    a(`id-${i}`);
  }, [e, n]), e || n;
}
function ch(e, n) {
  const a = (g) => {
    if (typeof g == "string")
      return g;
  }, [i, h] = Kt(() => a(n));
  return Ln(() => {
    const g = e && "current" in e ? e.current : e;
    h((g == null ? void 0 : g.tagName.toLowerCase()) || a(n));
  }, [e, n]), i;
}
function vE(e, n, a) {
  const [i, h] = Kt(a);
  return Ln(() => {
    const g = e && "current" in e ? e.current : e;
    if (!g)
      return;
    const m = () => {
      const b = g.getAttribute(n);
      b != null && h(b);
    }, S = new MutationObserver(m);
    return S.observe(g, { attributeFilter: [n] }), m(), () => S.disconnect();
  }, [e, n]), i;
}
function R1(e, n) {
  const a = Pt(!1);
  wt(() => {
    if (a.current)
      return e();
    a.current = !0;
  }, n), wt(
    () => () => {
      a.current = !1;
    },
    []
  );
}
function wL(e, n) {
  const a = Pt(!1);
  Ln(() => {
    if (a.current)
      return e();
    a.current = !0;
  }, n), Ln(
    () => () => {
      a.current = !1;
    },
    []
  );
}
function j5() {
  return tE(() => [], []);
}
function rr(e) {
  return nt(
    typeof e == "function" ? e : () => e
  );
}
function Bn(e, n, a = []) {
  const i = Pr(
    (h) => (e.wrapElement && (h = e.wrapElement(h)), n(h)),
    [...a, e.wrapElement]
  );
  return De(Q({}, e), { wrapElement: i });
}
function Zx(e = !1, n) {
  const [a, i] = Kt(null);
  return { portalRef: In(i, n), portalNode: a, domReady: !e || a };
}
function pE(e, n, a) {
  const i = e.onLoadedMetadataCapture, h = qr(() => Object.assign(() => {
  }, De(Q({}, i), { [n]: a })), [i, n, a]);
  return [i == null ? void 0 : i[n], { onLoadedMetadataCapture: h }];
}
function mE() {
  return wt(() => {
    Go("mousemove", xL, !0), Go("mousedown", Xg, !0), Go("mouseup", Xg, !0), Go("keydown", Xg, !0), Go("scroll", Xg, !0);
  }, []), nt(() => Px);
}
var Px = !1, g_ = 0, w_ = 0;
function yL(e) {
  const n = e.movementX || e.screenX - g_, a = e.movementY || e.screenY - w_;
  return g_ = e.screenX, w_ = e.screenY, n || a || process.env.NODE_ENV === "test";
}
function xL(e) {
  yL(e) && (Px = !0);
}
function Xg() {
  Px = !1;
}
function I2(e, n) {
  const a = e.__unstableInternals;
  return Ht(a, "Invalid store"), a[n];
}
function ho(e, ...n) {
  let a = e, i = a, h = Symbol(), g = A4;
  const m = /* @__PURE__ */ new Set(), S = /* @__PURE__ */ new Set(), b = /* @__PURE__ */ new Set(), R = /* @__PURE__ */ new Set(), D = /* @__PURE__ */ new Set(), T = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ new WeakMap(), j = (pe) => (b.add(pe), () => b.delete(pe)), I = () => {
    const pe = m.size, J = Symbol();
    m.add(J);
    const me = () => {
      m.delete(J), !m.size && g();
    };
    if (pe)
      return me;
    const oe = iL(a).map(
      (Se) => xl(
        ...n.map((Re) => {
          var _e;
          const Ye = (_e = Re == null ? void 0 : Re.getState) == null ? void 0 : _e.call(Re);
          if (Ye && vf(Ye, Se))
            return Ea(Re, [Se], (ue) => {
              ie(
                Se,
                ue[Se],
                // @ts-expect-error - Not public API. This is just to prevent
                // infinite loops.
                !0
              );
            });
        })
      )
    ), ge = [];
    b.forEach((Se) => ge.push(Se()));
    const ce = n.map(k5);
    return g = xl(...oe, ...ge, ...ce), me;
  }, Z = (pe, J, me = R) => (me.add(J), A.set(J, pe), () => {
    var oe;
    (oe = T.get(J)) == null || oe(), T.delete(J), A.delete(J), me.delete(J);
  }), N = (pe, J) => Z(pe, J), B = (pe, J) => (T.set(J, J(a, a)), Z(pe, J)), $ = (pe, J) => (T.set(J, J(a, i)), Z(pe, J, D)), W = (pe) => ho(oL(a, pe), G), z = (pe) => ho(aL(a, pe), G), Y = () => a, ie = (pe, J, me = !1) => {
    if (!vf(a, pe))
      return;
    const oe = j4(J, a[pe]);
    if (oe === a[pe])
      return;
    me || n.forEach((Re) => {
      var _e;
      (_e = Re == null ? void 0 : Re.setState) == null || _e.call(Re, pe, oe);
    });
    const ge = a;
    a = pn(Ct({}, a), { [pe]: oe });
    const ce = Symbol();
    h = ce, S.add(pe);
    const Se = (Re, _e, Ye) => {
      var ue;
      const Ae = A.get(Re), Pe = (dt) => Ye ? Ye.has(dt) : dt === pe;
      (!Ae || Ae.some(Pe)) && ((ue = T.get(Re)) == null || ue(), T.set(Re, Re(a, _e)));
    };
    R.forEach((Re) => {
      Se(Re, ge);
    }), queueMicrotask(() => {
      if (h !== ce)
        return;
      const Re = a;
      D.forEach((_e) => {
        Se(_e, i, S);
      }), i = Re, S.clear();
    });
  }, G = {
    getState: Y,
    setState: ie,
    __unstableInternals: {
      setup: j,
      init: I,
      subscribe: N,
      sync: B,
      batch: $,
      pick: W,
      omit: z
    }
  };
  return G;
}
function Ha(e, ...n) {
  if (e)
    return I2(e, "setup")(...n);
}
function k5(e, ...n) {
  if (e)
    return I2(e, "init")(...n);
}
function gE(e, ...n) {
  if (e)
    return I2(e, "subscribe")(...n);
}
function Ea(e, ...n) {
  if (e)
    return I2(e, "sync")(...n);
}
function A2(e, ...n) {
  if (e)
    return I2(e, "batch")(...n);
}
function Pp(e, ...n) {
  if (e)
    return I2(e, "omit")(...n);
}
function wE(e, ...n) {
  if (e)
    return I2(e, "pick")(...n);
}
function Up(...e) {
  const n = e.reduce((i, h) => {
    var g;
    const m = (g = h == null ? void 0 : h.getState) == null ? void 0 : g.call(h);
    return m ? Ct(Ct({}, i), m) : i;
  }, {});
  return ho(n, ...e);
}
function fh(e, n) {
  if (process.env.NODE_ENV === "production" || !n)
    return;
  const a = Object.entries(e).filter(([g, m]) => g.startsWith("default") && m !== void 0).map(([g]) => {
    var m;
    const S = g.replace("default", "");
    return `${((m = S[0]) == null ? void 0 : m.toLowerCase()) || ""}${S.slice(1)}`;
  });
  if (!a.length)
    return;
  const i = n.getState();
  if (a.filter(
    (g) => vf(i, g)
  ).length)
    throw new Error(
      `Passing a store prop in conjunction with a default state is not supported.

const store = useSelectStore();
<SelectProvider store={store} defaultValue="Apple" />
                ^             ^

Instead, pass the default state to the topmost store:

const store = useSelectStore({ defaultValue: "Apple" });
<SelectProvider store={store} />

See https://github.com/ariakit/ariakit/pull/2745 for more details.

If there's a particular need for this, please submit a feature request at https://github.com/ariakit/ariakit
`
    );
}
var R4 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function yE(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var q9 = { exports: {} }, S9 = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var y_;
function SL() {
  if (y_) return S9;
  y_ = 1;
  var e = Ma;
  function n(T, A) {
    return T === A && (T !== 0 || 1 / T === 1 / A) || T !== T && A !== A;
  }
  var a = typeof Object.is == "function" ? Object.is : n, i = e.useState, h = e.useEffect, g = e.useLayoutEffect, m = e.useDebugValue;
  function S(T, A) {
    var j = A(), I = i({ inst: { value: j, getSnapshot: A } }), Z = I[0].inst, N = I[1];
    return g(function() {
      Z.value = j, Z.getSnapshot = A, b(Z) && N({ inst: Z });
    }, [T, j, A]), h(function() {
      return b(Z) && N({ inst: Z }), T(function() {
        b(Z) && N({ inst: Z });
      });
    }, [T]), m(j), j;
  }
  function b(T) {
    var A = T.getSnapshot;
    T = T.value;
    try {
      var j = A();
      return !a(T, j);
    } catch {
      return !0;
    }
  }
  function R(T, A) {
    return A();
  }
  var D = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? R : S;
  return S9.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : D, S9;
}
var C9 = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var x_;
function CL() {
  return x_ || (x_ = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = Ma, n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function a(W) {
      {
        for (var z = arguments.length, Y = new Array(z > 1 ? z - 1 : 0), ie = 1; ie < z; ie++)
          Y[ie - 1] = arguments[ie];
        i("error", W, Y);
      }
    }
    function i(W, z, Y) {
      {
        var ie = n.ReactDebugCurrentFrame, G = ie.getStackAddendum();
        G !== "" && (z += "%s", Y = Y.concat([G]));
        var pe = Y.map(function(J) {
          return String(J);
        });
        pe.unshift("Warning: " + z), Function.prototype.apply.call(console[W], console, pe);
      }
    }
    function h(W, z) {
      return W === z && (W !== 0 || 1 / W === 1 / z) || W !== W && z !== z;
    }
    var g = typeof Object.is == "function" ? Object.is : h, m = e.useState, S = e.useEffect, b = e.useLayoutEffect, R = e.useDebugValue, D = !1, T = !1;
    function A(W, z, Y) {
      D || e.startTransition !== void 0 && (D = !0, a("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var ie = z();
      if (!T) {
        var G = z();
        g(ie, G) || (a("The result of getSnapshot should be cached to avoid an infinite loop"), T = !0);
      }
      var pe = m({
        inst: {
          value: ie,
          getSnapshot: z
        }
      }), J = pe[0].inst, me = pe[1];
      return b(function() {
        J.value = ie, J.getSnapshot = z, j(J) && me({
          inst: J
        });
      }, [W, ie, z]), S(function() {
        j(J) && me({
          inst: J
        });
        var oe = function() {
          j(J) && me({
            inst: J
          });
        };
        return W(oe);
      }, [W]), R(ie), ie;
    }
    function j(W) {
      var z = W.getSnapshot, Y = W.value;
      try {
        var ie = z();
        return !g(Y, ie);
      } catch {
        return !0;
      }
    }
    function I(W, z, Y) {
      return z();
    }
    var Z = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", N = !Z, B = N ? I : A, $ = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : B;
    C9.useSyncExternalStore = $, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), C9;
}
process.env.NODE_ENV === "production" ? q9.exports = SL() : q9.exports = CL();
var bL = q9.exports;
const _L = /* @__PURE__ */ yE(bL);
var { useSyncExternalStore: RL } = _L, EL = () => () => {
};
function Ia(e, n = lE) {
  const a = Wl.useCallback(
    (h) => e ? gE(e, null, h) : EL(),
    [e]
  ), i = () => {
    const h = typeof n == "string" ? n : null, g = typeof n == "function" ? n : null, m = e == null ? void 0 : e.getState();
    if (g)
      return g(m);
    if (m && h && vf(m, h))
      return m[h];
  };
  return RL(a, i, i);
}
function lr(e, n, a, i) {
  const h = vf(n, a) ? n[a] : void 0, g = i ? n[i] : void 0, m = hE({ value: h, setValue: g });
  Ln(() => Ea(e, [a], (S, b) => {
    const { value: R, setValue: D } = m.current;
    D && S[a] !== b[a] && S[a] !== R && D(S[a]);
  }), [e, a]), Ln(() => {
    if (h !== void 0)
      return e.setState(a, h), A2(e, [a], () => {
        h !== void 0 && e.setState(a, h);
      });
  });
}
function Ci(e, n) {
  const [a, i] = Wl.useState(() => e(n));
  Ln(() => k5(a), [a]);
  const h = Wl.useCallback(
    (S) => Ia(a, S),
    [a]
  ), g = Wl.useMemo(
    () => De(Q({}, a), { useState: h }),
    [a, h]
  ), m = nt(() => {
    i((S) => e(Q(Q({}, n), S.getState())));
  });
  return [g, m];
}
function ML(e, n) {
  return !!(n.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_PRECEDING);
}
function TL(e) {
  const n = e.map((i, h) => [h, i]);
  let a = !1;
  return n.sort(([i, h], [g, m]) => {
    const S = h.element, b = m.element;
    return S === b || !S || !b ? 0 : ML(S, b) ? (i > g && (a = !0), -1) : (i < g && (a = !0), 1);
  }), a ? n.map(([i, h]) => h) : e;
}
function OL(e) {
  var n;
  const a = e.find((g) => !!g.element), i = [...e].reverse().find((g) => !!g.element);
  let h = (n = a == null ? void 0 : a.element) == null ? void 0 : n.parentElement;
  for (; h && (i != null && i.element); ) {
    if (i && h.contains(i.element))
      return h;
    h = h.parentElement;
  }
  return aa(h).body;
}
function DL(e) {
  return e == null ? void 0 : e.__unstablePrivateStore;
}
function L5(e = {}) {
  var n;
  fh(e, e.store);
  const a = (n = e.store) == null ? void 0 : n.getState(), i = ht(
    e.items,
    a == null ? void 0 : a.items,
    e.defaultItems,
    []
  ), h = new Map(i.map((A) => [A.id, A])), g = {
    items: i,
    renderedItems: ht(a == null ? void 0 : a.renderedItems, [])
  }, m = DL(e.store), S = ho(
    { items: i, renderedItems: g.renderedItems },
    m
  ), b = ho(g, e.store), R = (A) => {
    const j = TL(A);
    S.setState("renderedItems", j), b.setState("renderedItems", j);
  };
  Ha(b, () => k5(S)), Ha(S, () => A2(S, ["items"], (A) => {
    b.setState("items", A.items);
  })), Ha(S, () => A2(S, ["renderedItems"], (A) => {
    let j = !0, I = requestAnimationFrame(() => {
      const { renderedItems: $ } = b.getState();
      A.renderedItems !== $ && R(A.renderedItems);
    });
    if (typeof IntersectionObserver != "function")
      return () => cancelAnimationFrame(I);
    const Z = () => {
      if (j) {
        j = !1;
        return;
      }
      cancelAnimationFrame(I), I = requestAnimationFrame(() => R(A.renderedItems));
    }, N = OL(A.renderedItems), B = new IntersectionObserver(Z, { root: N });
    for (const $ of A.renderedItems)
      $.element && B.observe($.element);
    return () => {
      cancelAnimationFrame(I), B.disconnect();
    };
  }));
  const D = (A, j, I = !1) => {
    let Z;
    return j((B) => {
      const $ = B.findIndex(({ id: z }) => z === A.id), W = B.slice();
      if ($ !== -1) {
        Z = B[$];
        const z = Ct(Ct({}, Z), A);
        W[$] = z, h.set(A.id, z);
      } else
        W.push(A), h.set(A.id, A);
      return W;
    }), () => {
      j((B) => {
        if (!Z)
          return I && h.delete(A.id), B.filter(({ id: z }) => z !== A.id);
        const $ = B.findIndex(({ id: z }) => z === A.id);
        if ($ === -1)
          return B;
        const W = B.slice();
        return W[$] = Z, h.set(A.id, Z), W;
      });
    };
  }, T = (A) => D(
    A,
    (j) => S.setState("items", j),
    !0
  );
  return pn(Ct({}, b), {
    registerItem: T,
    renderItem: (A) => xl(
      T(A),
      D(
        A,
        (j) => S.setState("renderedItems", j)
      )
    ),
    item: (A) => {
      if (!A)
        return null;
      let j = h.get(A);
      if (!j) {
        const { items: I } = b.getState();
        j = I.find((Z) => Z.id === A), j && h.set(A, j);
      }
      return j || null;
    },
    // @ts-expect-error Internal
    __unstablePrivateStore: S
  });
}
function Nx(e, n, a) {
  return R1(n, [a.store]), lr(e, a, "items", "setItems"), e;
}
function xE(e = {}) {
  const [n, a] = Ci(L5, e);
  return Nx(n, a, e);
}
var G9 = { exports: {} }, E4 = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var S_;
function AL() {
  if (S_) return E4;
  S_ = 1;
  var e = Ma, n = Symbol.for("react.element"), a = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, h = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, g = { key: !0, ref: !0, __self: !0, __source: !0 };
  function m(S, b, R) {
    var D, T = {}, A = null, j = null;
    R !== void 0 && (A = "" + R), b.key !== void 0 && (A = "" + b.key), b.ref !== void 0 && (j = b.ref);
    for (D in b) i.call(b, D) && !g.hasOwnProperty(D) && (T[D] = b[D]);
    if (S && S.defaultProps) for (D in b = S.defaultProps, b) T[D] === void 0 && (T[D] = b[D]);
    return { $$typeof: n, type: S, key: A, ref: j, props: T, _owner: h.current };
  }
  return E4.Fragment = a, E4.jsx = m, E4.jsxs = m, E4;
}
var M4 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var C_;
function jL() {
  return C_ || (C_ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ma, n = Symbol.for("react.element"), a = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), h = Symbol.for("react.strict_mode"), g = Symbol.for("react.profiler"), m = Symbol.for("react.provider"), S = Symbol.for("react.context"), b = Symbol.for("react.forward_ref"), R = Symbol.for("react.suspense"), D = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), A = Symbol.for("react.lazy"), j = Symbol.for("react.offscreen"), I = Symbol.iterator, Z = "@@iterator";
    function N(X) {
      if (X === null || typeof X != "object")
        return null;
      var We = I && X[I] || X[Z];
      return typeof We == "function" ? We : null;
    }
    var B = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function $(X) {
      {
        for (var We = arguments.length, lt = new Array(We > 1 ? We - 1 : 0), vt = 1; vt < We; vt++)
          lt[vt - 1] = arguments[vt];
        W("error", X, lt);
      }
    }
    function W(X, We, lt) {
      {
        var vt = B.ReactDebugCurrentFrame, bn = vt.getStackAddendum();
        bn !== "" && (We += "%s", lt = lt.concat([bn]));
        var Kn = lt.map(function(dn) {
          return String(dn);
        });
        Kn.unshift("Warning: " + We), Function.prototype.apply.call(console[X], console, Kn);
      }
    }
    var z = !1, Y = !1, ie = !1, G = !1, pe = !1, J;
    J = Symbol.for("react.module.reference");
    function me(X) {
      return !!(typeof X == "string" || typeof X == "function" || X === i || X === g || pe || X === h || X === R || X === D || G || X === j || z || Y || ie || typeof X == "object" && X !== null && (X.$$typeof === A || X.$$typeof === T || X.$$typeof === m || X.$$typeof === S || X.$$typeof === b || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      X.$$typeof === J || X.getModuleId !== void 0));
    }
    function oe(X, We, lt) {
      var vt = X.displayName;
      if (vt)
        return vt;
      var bn = We.displayName || We.name || "";
      return bn !== "" ? lt + "(" + bn + ")" : lt;
    }
    function ge(X) {
      return X.displayName || "Context";
    }
    function ce(X) {
      if (X == null)
        return null;
      if (typeof X.tag == "number" && $("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof X == "function")
        return X.displayName || X.name || null;
      if (typeof X == "string")
        return X;
      switch (X) {
        case i:
          return "Fragment";
        case a:
          return "Portal";
        case g:
          return "Profiler";
        case h:
          return "StrictMode";
        case R:
          return "Suspense";
        case D:
          return "SuspenseList";
      }
      if (typeof X == "object")
        switch (X.$$typeof) {
          case S:
            var We = X;
            return ge(We) + ".Consumer";
          case m:
            var lt = X;
            return ge(lt._context) + ".Provider";
          case b:
            return oe(X, X.render, "ForwardRef");
          case T:
            var vt = X.displayName || null;
            return vt !== null ? vt : ce(X.type) || "Memo";
          case A: {
            var bn = X, Kn = bn._payload, dn = bn._init;
            try {
              return ce(dn(Kn));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Se = Object.assign, Re = 0, _e, Ye, ue, Ae, Pe, dt, Ze;
    function qe() {
    }
    qe.__reactDisabledLog = !0;
    function Je() {
      {
        if (Re === 0) {
          _e = console.log, Ye = console.info, ue = console.warn, Ae = console.error, Pe = console.group, dt = console.groupCollapsed, Ze = console.groupEnd;
          var X = {
            configurable: !0,
            enumerable: !0,
            value: qe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: X,
            log: X,
            warn: X,
            error: X,
            group: X,
            groupCollapsed: X,
            groupEnd: X
          });
        }
        Re++;
      }
    }
    function ot() {
      {
        if (Re--, Re === 0) {
          var X = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Se({}, X, {
              value: _e
            }),
            info: Se({}, X, {
              value: Ye
            }),
            warn: Se({}, X, {
              value: ue
            }),
            error: Se({}, X, {
              value: Ae
            }),
            group: Se({}, X, {
              value: Pe
            }),
            groupCollapsed: Se({}, X, {
              value: dt
            }),
            groupEnd: Se({}, X, {
              value: Ze
            })
          });
        }
        Re < 0 && $("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Nt = B.ReactCurrentDispatcher, Tn;
    function Qt(X, We, lt) {
      {
        if (Tn === void 0)
          try {
            throw Error();
          } catch (bn) {
            var vt = bn.stack.trim().match(/\n( *(at )?)/);
            Tn = vt && vt[1] || "";
          }
        return `
` + Tn + X;
      }
    }
    var Hn = !1, ar;
    {
      var Wn = typeof WeakMap == "function" ? WeakMap : Map;
      ar = new Wn();
    }
    function zn(X, We) {
      if (!X || Hn)
        return "";
      {
        var lt = ar.get(X);
        if (lt !== void 0)
          return lt;
      }
      var vt;
      Hn = !0;
      var bn = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Kn;
      Kn = Nt.current, Nt.current = null, Je();
      try {
        if (We) {
          var dn = function() {
            throw Error();
          };
          if (Object.defineProperty(dn.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(dn, []);
            } catch (la) {
              vt = la;
            }
            Reflect.construct(X, [], dn);
          } else {
            try {
              dn.call();
            } catch (la) {
              vt = la;
            }
            X.call(dn.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (la) {
            vt = la;
          }
          X();
        }
      } catch (la) {
        if (la && vt && typeof la.stack == "string") {
          for (var ln = la.stack.split(`
`), Da = vt.stack.split(`
`), Rr = ln.length - 1, Er = Da.length - 1; Rr >= 1 && Er >= 0 && ln[Rr] !== Da[Er]; )
            Er--;
          for (; Rr >= 1 && Er >= 0; Rr--, Er--)
            if (ln[Rr] !== Da[Er]) {
              if (Rr !== 1 || Er !== 1)
                do
                  if (Rr--, Er--, Er < 0 || ln[Rr] !== Da[Er]) {
                    var Fa = `
` + ln[Rr].replace(" at new ", " at ");
                    return X.displayName && Fa.includes("<anonymous>") && (Fa = Fa.replace("<anonymous>", X.displayName)), typeof X == "function" && ar.set(X, Fa), Fa;
                  }
                while (Rr >= 1 && Er >= 0);
              break;
            }
        }
      } finally {
        Hn = !1, Nt.current = Kn, ot(), Error.prepareStackTrace = bn;
      }
      var Io = X ? X.displayName || X.name : "", mt = Io ? Qt(Io) : "";
      return typeof X == "function" && ar.set(X, mt), mt;
    }
    function qn(X, We, lt) {
      return zn(X, !1);
    }
    function Gn(X) {
      var We = X.prototype;
      return !!(We && We.isReactComponent);
    }
    function wr(X, We, lt) {
      if (X == null)
        return "";
      if (typeof X == "function")
        return zn(X, Gn(X));
      if (typeof X == "string")
        return Qt(X);
      switch (X) {
        case R:
          return Qt("Suspense");
        case D:
          return Qt("SuspenseList");
      }
      if (typeof X == "object")
        switch (X.$$typeof) {
          case b:
            return qn(X.render);
          case T:
            return wr(X.type);
          case A: {
            var vt = X, bn = vt._payload, Kn = vt._init;
            try {
              return wr(Kn(bn));
            } catch {
            }
          }
        }
      return "";
    }
    var Ta = Object.prototype.hasOwnProperty, jr = {}, Mt = B.ReactDebugCurrentFrame;
    function fn(X) {
      if (X) {
        var We = wr(X.type);
        Mt.setExtraStackFrame(We);
      } else
        Mt.setExtraStackFrame(null);
    }
    function Sn(X, We, lt, vt, bn) {
      {
        var Kn = Function.call.bind(Ta);
        for (var dn in X)
          if (Kn(X, dn)) {
            var ln = void 0;
            try {
              if (typeof X[dn] != "function") {
                var Da = Error((vt || "React class") + ": " + lt + " type `" + dn + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof X[dn] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Da.name = "Invariant Violation", Da;
              }
              ln = X[dn](We, dn, vt, lt, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Rr) {
              ln = Rr;
            }
            ln && !(ln instanceof Error) && (fn(bn), $("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", vt || "React class", lt, dn, typeof ln), fn(null)), ln instanceof Error && !(ln.message in jr) && (jr[ln.message] = !0, fn(bn), $("Failed %s type: %s", lt, ln.message), fn(null));
          }
      }
    }
    var jt = Array.isArray;
    function On(X) {
      return jt(X);
    }
    function Gr(X) {
      {
        var We = typeof Symbol == "function" && Symbol.toStringTag, lt = We && X[Symbol.toStringTag] || X.constructor.name || "Object";
        return lt;
      }
    }
    function Ge(X) {
      try {
        return !1;
      } catch {
        return !0;
      }
    }
    function $t(X) {
      return "" + X;
    }
    function Cn(X) {
      if (Ge())
        return $("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Gr(X)), $t(X);
    }
    var gn = B.ReactCurrentOwner, cr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Qe, at, Lt;
    Lt = {};
    function Un(X) {
      if (Ta.call(X, "ref")) {
        var We = Object.getOwnPropertyDescriptor(X, "ref").get;
        if (We && We.isReactWarning)
          return !1;
      }
      return X.ref !== void 0;
    }
    function dr(X) {
      if (Ta.call(X, "key")) {
        var We = Object.getOwnPropertyDescriptor(X, "key").get;
        if (We && We.isReactWarning)
          return !1;
      }
      return X.key !== void 0;
    }
    function ga(X, We) {
      if (typeof X.ref == "string" && gn.current && We && gn.current.stateNode !== We) {
        var lt = ce(gn.current.type);
        Lt[lt] || ($('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ce(gn.current.type), X.ref), Lt[lt] = !0);
      }
    }
    function Nr(X, We) {
      {
        var lt = function() {
          Qe || (Qe = !0, $("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", We));
        };
        lt.isReactWarning = !0, Object.defineProperty(X, "key", {
          get: lt,
          configurable: !0
        });
      }
    }
    function Oa(X, We) {
      {
        var lt = function() {
          at || (at = !0, $("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", We));
        };
        lt.isReactWarning = !0, Object.defineProperty(X, "ref", {
          get: lt,
          configurable: !0
        });
      }
    }
    var br = function(X, We, lt, vt, bn, Kn, dn) {
      var ln = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: X,
        key: We,
        ref: lt,
        props: dn,
        // Record the component responsible for creating this element.
        _owner: Kn
      };
      return ln._store = {}, Object.defineProperty(ln._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ln, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: vt
      }), Object.defineProperty(ln, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: bn
      }), Object.freeze && (Object.freeze(ln.props), Object.freeze(ln)), ln;
    };
    function _r(X, We, lt, vt, bn) {
      {
        var Kn, dn = {}, ln = null, Da = null;
        lt !== void 0 && (Cn(lt), ln = "" + lt), dr(We) && (Cn(We.key), ln = "" + We.key), Un(We) && (Da = We.ref, ga(We, bn));
        for (Kn in We)
          Ta.call(We, Kn) && !cr.hasOwnProperty(Kn) && (dn[Kn] = We[Kn]);
        if (X && X.defaultProps) {
          var Rr = X.defaultProps;
          for (Kn in Rr)
            dn[Kn] === void 0 && (dn[Kn] = Rr[Kn]);
        }
        if (ln || Da) {
          var Er = typeof X == "function" ? X.displayName || X.name || "Unknown" : X;
          ln && Nr(dn, Er), Da && Oa(dn, Er);
        }
        return br(X, ln, Da, bn, vt, gn.current, dn);
      }
    }
    var kr = B.ReactCurrentOwner, O1 = B.ReactDebugCurrentFrame;
    function to(X) {
      if (X) {
        var We = wr(X.type);
        O1.setExtraStackFrame(We);
      } else
        O1.setExtraStackFrame(null);
    }
    var Jo;
    Jo = !1;
    function D1(X) {
      return typeof X == "object" && X !== null && X.$$typeof === n;
    }
    function W0() {
      {
        if (kr.current) {
          var X = ce(kr.current.type);
          if (X)
            return `

Check the render method of \`` + X + "`.";
        }
        return "";
      }
    }
    function z0(X) {
      return "";
    }
    var A1 = {};
    function q0(X) {
      {
        var We = W0();
        if (!We) {
          var lt = typeof X == "string" ? X : X.displayName || X.name;
          lt && (We = `

Check the top-level render call using <` + lt + ">.");
        }
        return We;
      }
    }
    function As(X, We) {
      {
        if (!X._store || X._store.validated || X.key != null)
          return;
        X._store.validated = !0;
        var lt = q0(We);
        if (A1[lt])
          return;
        A1[lt] = !0;
        var vt = "";
        X && X._owner && X._owner !== kr.current && (vt = " It was passed a child from " + ce(X._owner.type) + "."), to(X), $('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', lt, vt), to(null);
      }
    }
    function js(X, We) {
      {
        if (typeof X != "object")
          return;
        if (On(X))
          for (var lt = 0; lt < X.length; lt++) {
            var vt = X[lt];
            D1(vt) && As(vt, We);
          }
        else if (D1(X))
          X._store && (X._store.validated = !0);
        else if (X) {
          var bn = N(X);
          if (typeof bn == "function" && bn !== X.entries)
            for (var Kn = bn.call(X), dn; !(dn = Kn.next()).done; )
              D1(dn.value) && As(dn.value, We);
        }
      }
    }
    function _i(X) {
      {
        var We = X.type;
        if (We == null || typeof We == "string")
          return;
        var lt;
        if (typeof We == "function")
          lt = We.propTypes;
        else if (typeof We == "object" && (We.$$typeof === b || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        We.$$typeof === T))
          lt = We.propTypes;
        else
          return;
        if (lt) {
          var vt = ce(We);
          Sn(lt, X.props, "prop", vt, X);
        } else if (We.PropTypes !== void 0 && !Jo) {
          Jo = !0;
          var bn = ce(We);
          $("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", bn || "Unknown");
        }
        typeof We.getDefaultProps == "function" && !We.getDefaultProps.isReactClassApproved && $("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ei(X) {
      {
        for (var We = Object.keys(X.props), lt = 0; lt < We.length; lt++) {
          var vt = We[lt];
          if (vt !== "children" && vt !== "key") {
            to(X), $("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", vt), to(null);
            break;
          }
        }
        X.ref !== null && (to(X), $("Invalid attribute `ref` supplied to `React.Fragment`."), to(null));
      }
    }
    var ti = {};
    function ku(X, We, lt, vt, bn, Kn) {
      {
        var dn = me(X);
        if (!dn) {
          var ln = "";
          (X === void 0 || typeof X == "object" && X !== null && Object.keys(X).length === 0) && (ln += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Da = z0();
          Da ? ln += Da : ln += W0();
          var Rr;
          X === null ? Rr = "null" : On(X) ? Rr = "array" : X !== void 0 && X.$$typeof === n ? (Rr = "<" + (ce(X.type) || "Unknown") + " />", ln = " Did you accidentally export a JSX literal instead of a component?") : Rr = typeof X, $("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Rr, ln);
        }
        var Er = _r(X, We, lt, bn, Kn);
        if (Er == null)
          return Er;
        if (dn) {
          var Fa = We.children;
          if (Fa !== void 0)
            if (vt)
              if (On(Fa)) {
                for (var Io = 0; Io < Fa.length; Io++)
                  js(Fa[Io], X);
                Object.freeze && Object.freeze(Fa);
              } else
                $("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              js(Fa, X);
        }
        if (Ta.call(We, "key")) {
          var mt = ce(X), la = Object.keys(We).filter(function(Zu) {
            return Zu !== "key";
          }), Hu = la.length > 0 ? "{key: someKey, " + la.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ti[mt + Hu]) {
            var G0 = la.length > 0 ? "{" + la.join(": ..., ") + ": ...}" : "{}";
            $(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Hu, mt, G0, mt), ti[mt + Hu] = !0;
          }
        }
        return X === i ? ei(Er) : _i(Er), Er;
      }
    }
    function ql(X, We, lt) {
      return ku(X, We, lt, !0);
    }
    function Lu(X, We, lt) {
      return ku(X, We, lt, !1);
    }
    var Iu = Lu, Cl = ql;
    M4.Fragment = i, M4.jsx = Iu, M4.jsxs = Cl;
  }()), M4;
}
process.env.NODE_ENV === "production" ? G9.exports = AL() : G9.exports = jL();
var d = G9.exports;
function ke(e) {
  const n = Wl.forwardRef((a, i) => e(De(Q({}, a), { ref: i })));
  return n.displayName = e.displayName || e.name, n;
}
function Va(e, n) {
  return Wl.memo(e, n);
}
function Ie(e, n) {
  const a = n, { wrapElement: i, render: h } = a, g = Ue(a, ["wrapElement", "render"]), m = In(n.ref, uL(h));
  let S;
  if (Wl.isValidElement(h)) {
    const b = De(Q({}, h.props), { ref: m });
    S = Wl.cloneElement(h, sL(g, b));
  } else h ? S = h(g) : S = /* @__PURE__ */ d.jsx(e, Q({}, g));
  return i ? i(S) : S;
}
function He(e) {
  const n = (a = {}) => e(a);
  return n.displayName = e.name, n;
}
function bi(e = [], n = []) {
  const a = Wl.createContext(void 0), i = Wl.createContext(void 0), h = () => Wl.useContext(a), g = (R = !1) => {
    const D = Wl.useContext(i), T = h();
    return R ? D : D || T;
  }, m = () => {
    const R = Wl.useContext(i), D = h();
    if (!(R && R === D))
      return D;
  }, S = (R) => e.reduceRight(
    (D, T) => /* @__PURE__ */ d.jsx(T, De(Q({}, R), { children: D })),
    /* @__PURE__ */ d.jsx(a.Provider, Q({}, R))
  );
  return {
    context: a,
    scopedContext: i,
    useContext: h,
    useScopedContext: g,
    useProviderContext: m,
    ContextProvider: S,
    ScopedContextProvider: (R) => /* @__PURE__ */ d.jsx(S, De(Q({}, R), { children: n.reduceRight(
      (D, T) => /* @__PURE__ */ d.jsx(T, De(Q({}, R), { children: D })),
      /* @__PURE__ */ d.jsx(i.Provider, Q({}, R))
    ) }))
  };
}
var I5 = bi(), SE = I5.useContext, kL = I5.useProviderContext, Vx = I5.ContextProvider, Fx = I5.ScopedContextProvider, LL = "div", IL = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = kL();
    return i = i || g, h = Bn(
      h,
      (m) => /* @__PURE__ */ d.jsx(Fx, { value: i, children: m }),
      [i]
    ), Pa(h);
  }
), HL = ke(function(n) {
  const a = IL(n);
  return Ie(LL, a);
});
function ZL(e = {}) {
  const n = xE(e);
  return /* @__PURE__ */ d.jsx(Vx, { value: n, children: e.children });
}
var PL = "div", dh = He(
  function(n) {
    var a = n, {
      store: i,
      shouldRegisterItem: h = !0,
      getItem: g = lE,
      element: m
    } = a, S = Ue(a, [
      "store",
      "shouldRegisterItem",
      "getItem",
      // @ts-expect-error This prop may come from a collection renderer.
      "element"
    ]);
    const b = SE();
    i = i || b;
    const R = Na(S.id), D = Pt(m);
    return wt(() => {
      const T = D.current;
      if (!R || !T || !h)
        return;
      const A = g({ id: R, element: T });
      return i == null ? void 0 : i.renderItem(A);
    }, [R, h, g, i]), S = De(Q({}, S), {
      ref: In(D, S.ref)
    }), Pa(S);
  }
), NL = ke(function(n) {
  const a = dh(n);
  return Ie(PL, a);
});
function VL(e = {}) {
  var n;
  fh(e, e.store);
  const a = (n = e.store) == null ? void 0 : n.getState(), i = {
    value: ht(
      e.value,
      a == null ? void 0 : a.value,
      e.defaultValue,
      !1
    )
  }, h = ho(i, e.store);
  return pn(Ct({}, h), {
    setValue: (g) => h.setState("value", g)
  });
}
function FL(e, n, a) {
  return R1(n, [a.store]), lr(e, a, "value", "setValue"), e;
}
function W4(e = {}) {
  const [n, a] = Ci(VL, e);
  return FL(n, a, e);
}
var CE = bi(), bE = CE.useContext, BL = CE.ContextProvider, _E = Za(!1), RE = Za(!0), Bx = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], summary, iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function UL(e) {
  return parseInt(e.getAttribute("tabindex") || "0", 10) < 0;
}
function Z0(e) {
  return !(!Ox(e, Bx) || !sE(e) || cE(e, "[inert]"));
}
function w5(e) {
  if (!Z0(e) || UL(e))
    return !1;
  if (!("form" in e) || !e.form || e.checked || e.type !== "radio")
    return !0;
  const n = e.form.elements.namedItem(e.name);
  if (!n || !("length" in n))
    return !0;
  const a = yf(e);
  return !a || a === e || !("form" in a) || a.form !== e.form || a.name !== e.name;
}
function Ux(e, n) {
  const a = Array.from(
    e.querySelectorAll(Bx)
  );
  n && a.unshift(e);
  const i = a.filter(Z0);
  return i.forEach((h, g) => {
    if (Tx(h) && h.contentDocument) {
      const m = h.contentDocument.body;
      i.splice(g, 1, ...Ux(m));
    }
  }), i;
}
function Yp(e, n, a) {
  const i = Array.from(
    e.querySelectorAll(Bx)
  ), h = i.filter(w5);
  return n && w5(e) && h.unshift(e), h.forEach((g, m) => {
    if (Tx(g) && g.contentDocument) {
      const S = g.contentDocument.body, b = Yp(
        S,
        !1,
        a
      );
      h.splice(m, 1, ...b);
    }
  }), !h.length && a ? i : h;
}
function H5(e, n, a) {
  const [i] = Yp(
    e,
    n,
    a
  );
  return i || null;
}
function YL(e, n, a, i) {
  const h = yf(e), g = Ux(e, n), m = g.indexOf(h);
  return g.slice(m + 1).find(w5) || null || null || null;
}
function b9(e, n) {
  return YL(
    document.body,
    !1
  );
}
function $L(e, n, a, i) {
  const h = yf(e), g = Ux(e, n).reverse(), m = g.indexOf(h);
  return g.slice(m + 1).find(w5) || null || null || null;
}
function b_(e, n) {
  return $L(
    document.body,
    !1
  );
}
function j2(e) {
  const n = yf(e);
  if (!n)
    return !1;
  if (n === e)
    return !0;
  const a = n.getAttribute("aria-activedescendant");
  return a ? a === e.id : !1;
}
function rh(e) {
  const n = yf(e);
  if (!n)
    return !1;
  if (pa(e, n))
    return !0;
  const a = n.getAttribute("aria-activedescendant");
  return !a || !("id" in e) ? !1 : a === e.id ? !0 : !!e.querySelector(`#${CSS.escape(a)}`);
}
function EE(e) {
  !rh(e) && Z0(e) && e.focus();
}
function WL(e) {
  var n;
  const a = (n = e.getAttribute("tabindex")) != null ? n : "";
  e.setAttribute("data-tabindex", a), e.setAttribute("tabindex", "-1");
}
function Op(e, n) {
  Yp(e, n).forEach(WL);
}
function y5(e) {
  const n = e.querySelectorAll("[data-tabindex]"), a = (i) => {
    const h = i.getAttribute("data-tabindex");
    i.removeAttribute("data-tabindex"), h ? i.setAttribute("tabindex", h) : i.removeAttribute("tabindex");
  };
  e.hasAttribute("data-tabindex") && a(e), n.forEach(a);
}
function zL(e, n) {
  "scrollIntoView" in e ? (e.focus({ preventScroll: !0 }), e.scrollIntoView(Ct({ block: "nearest", inline: "nearest" }, n))) : e.focus();
}
var qL = "div", __ = kx(), GL = [
  "text",
  "search",
  "url",
  "tel",
  "email",
  "password",
  "number",
  "date",
  "month",
  "week",
  "time",
  "datetime",
  "datetime-local"
];
function KL(e) {
  const { tagName: n, readOnly: a, type: i } = e;
  return n === "TEXTAREA" && !a || n === "SELECT" && !a ? !0 : n === "INPUT" && !a ? GL.includes(i) : !!e.isContentEditable;
}
function QL(e) {
  return e.getAttribute("role") !== "combobox" ? !1 : !!e.dataset.name;
}
function XL(e) {
  return "labels" in e ? e.labels : null;
}
function R_(e) {
  return e.tagName.toLowerCase() === "input" && e.type ? e.type === "radio" || e.type === "checkbox" : !1;
}
function JL(e) {
  return e ? e === "button" || e === "summary" || e === "input" || e === "select" || e === "textarea" || e === "a" : !0;
}
function eI(e) {
  return e ? e === "button" || e === "input" || e === "select" || e === "textarea" : !0;
}
function tI(e, n, a, i, h) {
  return e ? n ? a && !i ? -1 : void 0 : a ? h : h || 0 : h;
}
function _9(e, n) {
  return nt((a) => {
    e == null || e(a), !a.defaultPrevented && n && (a.stopPropagation(), a.preventDefault());
  });
}
var Yx = !0;
function nI(e) {
  const n = e.target;
  n && "hasAttribute" in n && (n.hasAttribute("data-focus-visible") || (Yx = !1));
}
function rI(e) {
  e.metaKey || e.ctrlKey || e.altKey || (Yx = !0);
}
var H2 = He(
  function(n) {
    var a = n, {
      focusable: i = !0,
      accessibleWhenDisabled: h,
      autoFocus: g,
      onFocusVisible: m
    } = a, S = Ue(a, [
      "focusable",
      "accessibleWhenDisabled",
      "autoFocus",
      "onFocusVisible"
    ]);
    const b = Pt(null);
    wt(() => {
      i && (Go("mousedown", nI, !0), Go("keydown", rI, !0));
    }, [i]), __ && wt(() => {
      if (!i)
        return;
      const _e = b.current;
      if (!_e || !R_(_e))
        return;
      const Ye = XL(_e);
      if (!Ye)
        return;
      const ue = () => queueMicrotask(() => _e.focus());
      return Ye.forEach((Ae) => Ae.addEventListener("mouseup", ue)), () => {
        Ye.forEach(
          (Ae) => Ae.removeEventListener("mouseup", ue)
        );
      };
    }, [i]);
    const R = i && wf(S), D = !!R && !h, [T, A] = Kt(!1);
    wt(() => {
      i && D && T && A(!1);
    }, [i, D, T]), wt(() => {
      if (!i || !T)
        return;
      const _e = b.current;
      if (!_e || typeof IntersectionObserver > "u")
        return;
      const Ye = new IntersectionObserver(() => {
        Z0(_e) || A(!1);
      });
      return Ye.observe(_e), () => Ye.disconnect();
    }, [i, T]);
    const j = _9(
      S.onKeyPressCapture,
      R
    ), I = _9(
      S.onMouseDownCapture,
      R
    ), Z = _9(S.onClickCapture, R), N = S.onMouseDown, B = nt((_e) => {
      if (N == null || N(_e), _e.defaultPrevented || !i)
        return;
      const Ye = _e.currentTarget;
      if (!__ || fE(_e) || !N0(Ye) && !R_(Ye))
        return;
      let ue = !1;
      const Ae = () => {
        ue = !0;
      }, Pe = { capture: !0, once: !0 };
      Ye.addEventListener("focusin", Ae, Pe), D2(Ye, "mouseup", () => {
        Ye.removeEventListener("focusin", Ae, !0), !ue && EE(Ye);
      });
    }), $ = (_e, Ye) => {
      if (Ye && (_e.currentTarget = Ye), !i)
        return;
      const ue = _e.currentTarget;
      ue && j2(ue) && (m == null || m(_e), !_e.defaultPrevented && A(!0));
    }, W = S.onKeyDownCapture, z = nt((_e) => {
      if (W == null || W(_e), _e.defaultPrevented || !i || T || _e.metaKey || _e.altKey || _e.ctrlKey || !Si(_e))
        return;
      const Ye = _e.currentTarget;
      queueMicrotask(() => $(_e, Ye));
    }), Y = S.onFocusCapture, ie = nt((_e) => {
      if (Y == null || Y(_e), _e.defaultPrevented || !i)
        return;
      if (!Si(_e)) {
        A(!1);
        return;
      }
      const Ye = _e.currentTarget, ue = () => $(_e, Ye);
      Yx || KL(_e.target) ? queueMicrotask(ue) : QL(_e.target) ? D2(_e.target, "focusout", ue) : A(!1);
    }), G = S.onBlur, pe = nt((_e) => {
      G == null || G(_e), i && Qd(_e) && A(!1);
    }), J = Qo(RE), me = nt((_e) => {
      i && g && _e && J && queueMicrotask(() => {
        j2(_e) || Z0(_e) && _e.focus();
      });
    }), oe = ch(b), ge = i && JL(oe), ce = i && eI(oe), Se = S.style, Re = qr(() => D ? Q({ pointerEvents: "none" }, Se) : Se, [D, Se]);
    return S = De(Q({
      "data-focus-visible": i && T || void 0,
      "data-autofocus": g || void 0,
      "aria-disabled": R || void 0
    }, S), {
      ref: In(b, me, S.ref),
      style: Re,
      tabIndex: tI(
        i,
        D,
        ge,
        ce,
        S.tabIndex
      ),
      disabled: ce && D ? !0 : void 0,
      // TODO: Test Focusable contentEditable.
      contentEditable: R ? void 0 : S.contentEditable,
      onKeyPressCapture: j,
      onClickCapture: Z,
      onMouseDownCapture: I,
      onMouseDown: B,
      onKeyDownCapture: z,
      onFocusCapture: ie,
      onBlur: pe
    }), Pa(S);
  }
), aI = ke(function(n) {
  const a = H2(n);
  return Ie(qL, a);
}), oI = "button";
function E_(e) {
  if (!e.isTrusted)
    return !1;
  const n = e.currentTarget;
  return e.key === "Enter" ? N0(n) || n.tagName === "SUMMARY" || n.tagName === "A" : e.key === " " ? N0(n) || n.tagName === "SUMMARY" || n.tagName === "INPUT" || n.tagName === "SELECT" : !1;
}
var iI = Symbol("command"), Z5 = He(
  function(n) {
    var a = n, { clickOnEnter: i = !0, clickOnSpace: h = !0 } = a, g = Ue(a, ["clickOnEnter", "clickOnSpace"]);
    const m = Pt(null), S = ch(m), b = g.type, [R, D] = Kt(
      () => !!S && N0({ tagName: S, type: b })
    );
    wt(() => {
      m.current && D(N0(m.current));
    }, []);
    const [T, A] = Kt(!1), j = Pt(!1), I = wf(g), [Z, N] = pE(g, iI, !0), B = g.onKeyDown, $ = nt((Y) => {
      B == null || B(Y);
      const ie = Y.currentTarget;
      if (Y.defaultPrevented || Z || I || !Si(Y) || yl(ie) || ie.isContentEditable)
        return;
      const G = i && Y.key === "Enter", pe = h && Y.key === " ", J = Y.key === "Enter" && !i, me = Y.key === " " && !h;
      if (J || me) {
        Y.preventDefault();
        return;
      }
      if (G || pe) {
        const oe = E_(Y);
        if (G) {
          if (!oe) {
            Y.preventDefault();
            const ge = Y, ce = Ue(ge, ["view"]), Se = () => v_(ie, ce);
            vL() ? D2(ie, "keyup", Se) : queueMicrotask(Se);
          }
        } else pe && (j.current = !0, oe || (Y.preventDefault(), A(!0)));
      }
    }), W = g.onKeyUp, z = nt((Y) => {
      if (W == null || W(Y), Y.defaultPrevented || Z || I || Y.metaKey)
        return;
      const ie = h && Y.key === " ";
      if (j.current && ie && (j.current = !1, !E_(Y))) {
        Y.preventDefault(), A(!1);
        const G = Y.currentTarget, pe = Y, J = Ue(pe, ["view"]);
        queueMicrotask(() => v_(G, J));
      }
    });
    return g = De(Q(Q({
      "data-active": T || void 0,
      type: R ? "button" : void 0
    }, N), g), {
      ref: In(m, g.ref),
      onKeyDown: $,
      onKeyUp: z
    }), g = H2(g), g;
  }
), lI = ke(function(n) {
  const a = Z5(n);
  return Ie(oI, a);
}), ME = "input";
function M_(e, n) {
  n ? e.indeterminate = !0 : e.indeterminate && (e.indeterminate = !1);
}
function uI(e, n) {
  return e === "input" && (!n || n === "checkbox");
}
function T_(e) {
  return Array.isArray(e) ? e.toString() : e;
}
var $x = He(
  function(n) {
    var a = n, {
      store: i,
      name: h,
      value: g,
      checked: m,
      defaultChecked: S
    } = a, b = Ue(a, [
      "store",
      "name",
      "value",
      "checked",
      "defaultChecked"
    ]);
    const R = bE();
    i = i || R;
    const [D, T] = Kt(S ?? !1), A = Ia(i, (J) => {
      if (m !== void 0)
        return m;
      if ((J == null ? void 0 : J.value) === void 0)
        return D;
      if (g != null) {
        if (Array.isArray(J.value)) {
          const me = T_(g);
          return J.value.includes(me);
        }
        return J.value === g;
      }
      return Array.isArray(J.value) ? !1 : typeof J.value == "boolean" ? J.value : !1;
    }), j = Pt(null), I = ch(j, ME), Z = uI(I, b.type), N = A ? A === "mixed" : void 0, B = A === "mixed" ? !1 : A, $ = wf(b), [W, z] = j5();
    wt(() => {
      const J = j.current;
      J && (M_(J, N), !Z && (J.checked = B, h !== void 0 && (J.name = h), g !== void 0 && (J.value = `${g}`)));
    }, [W, N, Z, B, h, g]);
    const Y = b.onChange, ie = nt((J) => {
      if ($) {
        J.stopPropagation(), J.preventDefault();
        return;
      }
      if (M_(J.currentTarget, N), Z || (J.currentTarget.checked = !J.currentTarget.checked, z()), Y == null || Y(J), J.defaultPrevented)
        return;
      const me = J.currentTarget.checked;
      T(me), i == null || i.setValue((oe) => {
        if (g == null)
          return me;
        const ge = T_(g);
        return Array.isArray(oe) ? me ? oe.includes(ge) ? oe : [...oe, ge] : oe.filter((ce) => ce !== ge) : oe === ge ? !1 : ge;
      });
    }), G = b.onClick, pe = nt((J) => {
      G == null || G(J), !J.defaultPrevented && (Z || ie(J));
    });
    return b = Bn(
      b,
      (J) => /* @__PURE__ */ d.jsx(_E.Provider, { value: B, children: J }),
      [B]
    ), b = De(Q({
      role: Z ? void 0 : "checkbox",
      type: Z ? "checkbox" : void 0,
      "aria-checked": A
    }, b), {
      ref: In(j, b.ref),
      onChange: ie,
      onClick: pe
    }), b = Z5(Q({ clickOnEnter: !Z }, b)), Pa(Q({
      name: Z ? h : void 0,
      value: Z ? g : void 0,
      checked: B
    }, b));
  }
), TE = ke(function(n) {
  const a = $x(n);
  return Ie(ME, a);
});
function sI(e = {}) {
  const n = W4(e);
  return /* @__PURE__ */ d.jsx(BL, { value: n, children: e.children });
}
var cI = "span", fI = /* @__PURE__ */ d.jsx(
  "svg",
  {
    display: "block",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    viewBox: "0 0 16 16",
    height: "1em",
    width: "1em",
    children: /* @__PURE__ */ d.jsx("polyline", { points: "4,8 7,12 12,4" })
  }
);
function dI(e) {
  return e.checked ? e.children || fI : typeof e.children == "function" ? e.children : null;
}
var P5 = He(
  function(n) {
    var a = n, { store: i, checked: h } = a, g = Ue(a, ["store", "checked"]);
    const m = Qo(_E);
    h = h ?? m;
    const S = dI({ checked: h, children: g.children });
    return g = De(Q({
      "aria-hidden": !0
    }, g), {
      children: S,
      style: Q({
        width: "1em",
        height: "1em",
        pointerEvents: "none"
      }, g.style)
    }), Pa(g);
  }
), hI = ke(function(n) {
  const a = P5(n);
  return Ie(cI, a);
}), OE = "button", hh = He(
  function(n) {
    const a = Pt(null), i = ch(a, OE), [h, g] = Kt(
      () => !!i && N0({ tagName: i, type: n.type })
    );
    return wt(() => {
      a.current && g(N0(a.current));
    }, []), n = De(Q({
      role: !h && i !== "a" ? "button" : void 0
    }, n), {
      ref: In(a, n.ref)
    }), n = Z5(n), n;
  }
), N5 = ke(function(n) {
  const a = hh(n);
  return Ie(OE, a);
});
function O_() {
  return new Promise((e) => requestAnimationFrame(() => e()));
}
function i5(e) {
  return Object.keys(e).some((n) => g5(e[n]) ? i5(e[n]) : !!e[n]);
}
function uf(e, n, a) {
  var i;
  const [h, ...g] = Array.isArray(n) ? n : `${n}`.split(".");
  return h == null || !e ? a : g.length ? uf(e[h], g, a) : (i = e[h]) != null ? i : a;
}
function Mp(e, n, a) {
  const [i, ...h] = Array.isArray(n) ? n : `${n}`.split(".");
  if (i == null)
    return e;
  const g = i, m = nL(g), b = (m ? e || [] : e || {})[g], R = h.length && (Array.isArray(b) || g5(b)) ? Mp(b, h, a) : a;
  if (m) {
    const D = Number(g);
    if (e && Array.isArray(e))
      return [
        ...e.slice(0, D),
        R,
        ...e.slice(D + 1)
      ];
    const T = [];
    return T[D] = R, T;
  }
  return pn(Ct({}, e), { [g]: R });
}
function K9(e, n) {
  const a = {}, i = Object.keys(e);
  for (const h of i) {
    const g = e[h];
    Array.isArray(g) ? a[h] = g.map((m) => g5(m) ? K9(m, n) : n) : g5(g) ? a[h] = K9(g, n) : a[h] = n;
  }
  return a;
}
function DE(e, n = []) {
  return {
    get(i, h) {
      if (["toString", "valueOf", Symbol.toPrimitive].includes(h))
        return () => n.join(".");
      const g = [...n, h], m = g.join(".");
      if (e[m])
        return e[m];
      const S = new Proxy(i, DE(e, g));
      return e[m] = S, S;
    }
  };
}
function vI(e) {
  return e == null ? void 0 : e.__unstableCallbacks;
}
function pI() {
  const e = /* @__PURE__ */ Object.create(null);
  return new Proxy(/* @__PURE__ */ Object.create(null), DE(e));
}
function mI(e = {}) {
  var n;
  fh(e, e.store);
  const a = (n = e.store) == null ? void 0 : n.getState(), i = L5(e), h = ht(
    e.values,
    a == null ? void 0 : a.values,
    e.defaultValues,
    {}
  ), g = ht(
    e.errors,
    a == null ? void 0 : a.errors,
    e.defaultErrors,
    {}
  ), m = ht(
    e.touched,
    a == null ? void 0 : a.touched,
    e.defaultTouched,
    {}
  ), S = pn(Ct({}, i.getState()), {
    values: h,
    errors: g,
    touched: m,
    validating: ht(a == null ? void 0 : a.validating, !1),
    submitting: ht(a == null ? void 0 : a.submitting, !1),
    submitSucceed: ht(a == null ? void 0 : a.submitSucceed, 0),
    submitFailed: ht(a == null ? void 0 : a.submitFailed, 0),
    valid: !i5(g)
  }), b = ho(S, i, e.store), R = vI(e.store), D = R == null ? void 0 : R.getState(), T = {
    validate: (D == null ? void 0 : D.validate) || [],
    submit: (D == null ? void 0 : D.submit) || []
  }, A = ho(T, R);
  Ha(b, () => k5(A));
  const j = async () => {
    b.setState("validating", !0), b.setState("errors", {});
    const I = A.getState().validate;
    try {
      for (const Z of I)
        await Z(b.getState());
      return await O_(), !i5(b.getState().errors);
    } finally {
      b.setState("validating", !1);
    }
  };
  return pn(Ct(Ct({}, i), b), {
    names: pI(),
    setValues: (I) => b.setState("values", I),
    getValue: (I) => uf(b.getState().values, I),
    setValue: (I, Z) => b.setState("values", (N) => {
      const B = uf(N, I), $ = j4(Z, B);
      return $ === B ? N : Mp(N, I, $);
    }),
    pushValue: (I, Z) => b.setState("values", (N) => {
      const B = uf(N, I, []);
      return Mp(N, I, [...B, Z]);
    }),
    removeValue: (I, Z) => b.setState("values", (N) => {
      const B = uf(N, I, []);
      return Mp(N, I, [
        ...B.slice(0, Z),
        null,
        ...B.slice(Z + 1)
      ]);
    }),
    setErrors: (I) => b.setState("errors", I),
    getError: (I) => uf(b.getState().errors, I),
    setError: (I, Z) => b.setState("errors", (N) => {
      const B = uf(N, I), $ = j4(Z, B);
      return $ === B ? N : Mp(N, I, $);
    }),
    setTouched: (I) => b.setState("touched", I),
    getFieldTouched: (I) => !!uf(b.getState().touched, I),
    setFieldTouched: (I, Z) => b.setState("touched", (N) => {
      const B = uf(N, I), $ = j4(Z, B);
      return $ === B ? N : Mp(N, I, $);
    }),
    onValidate: (I) => (A.setState("validate", (Z) => [...Z, I]), () => {
      A.setState(
        "validate",
        (Z) => Z.filter((N) => N !== I)
      );
    }),
    validate: j,
    onSubmit: (I) => (A.setState("submit", (Z) => [...Z, I]), () => {
      A.setState(
        "submit",
        (Z) => Z.filter((N) => N !== I)
      );
    }),
    submit: async () => {
      b.setState("submitting", !0), b.setState("touched", K9(b.getState().values, !0));
      try {
        if (await j()) {
          const I = A.getState().submit;
          for (const Z of I)
            await Z(b.getState());
          if (await O_(), !i5(b.getState().errors))
            return b.setState("submitSucceed", (Z) => Z + 1), !0;
        }
        return b.setState("submitFailed", (I) => I + 1), !1;
      } catch (I) {
        throw b.setState("submitFailed", (Z) => Z + 1), I;
      } finally {
        b.setState("submitting", !1);
      }
    },
    reset: () => {
      b.setState("values", h), b.setState("errors", g), b.setState("touched", m), b.setState("validating", !1), b.setState("submitting", !1), b.setState("submitSucceed", 0), b.setState("submitFailed", 0);
    },
    // @ts-expect-error Internal
    __unstableCallbacks: A
  });
}
function gI(e, n, a) {
  e = Nx(e, n, a), lr(e, a, "values", "setValues"), lr(e, a, "errors", "setErrors"), lr(e, a, "touched", "setTouched");
  const i = Pr(
    (m) => e.useState(() => e.getValue(m)),
    [e]
  ), h = Pr(
    (m) => {
      m = nt(m);
      const S = e.useState("items");
      wt(() => e.onValidate(m), [S, m]);
    },
    [e]
  ), g = Pr(
    (m) => {
      m = nt(m);
      const S = e.useState("items");
      wt(() => e.onSubmit(m), [S, m]);
    },
    [e]
  );
  return qr(
    () => De(Q({}, e), {
      useValue: i,
      useValidate: h,
      useSubmit: g
    }),
    []
  );
}
function Wx(e = {}) {
  const [n, a] = Ci(mI, e);
  return gI(n, a, e);
}
var zx = bi(
  [Vx],
  [Fx]
), Sl = zx.useContext, wI = zx.ContextProvider, yI = zx.ScopedContextProvider, AE = "form";
function xI(e, n) {
  return n.some(
    (a) => a.type === "field" && a.element === e
  );
}
function SI(e) {
  return e.find(
    (n) => {
      var a;
      return n.type === "field" && ((a = n.element) == null ? void 0 : a.getAttribute("aria-invalid")) === "true";
    }
  );
}
var CI = He(function(n) {
  var a = n, {
    store: i,
    validateOnChange: h = !0,
    validateOnBlur: g = !0,
    resetOnUnmount: m = !1,
    resetOnSubmit: S = !0,
    autoFocusOnSubmit: b = !0
  } = a, R = Ue(a, [
    "store",
    "validateOnChange",
    "validateOnBlur",
    "resetOnUnmount",
    "resetOnSubmit",
    "autoFocusOnSubmit"
  ]);
  const D = Sl();
  i = i || D, Ht(
    i,
    process.env.NODE_ENV !== "production" && "Form must receive a `store` prop or be wrapped in a FormProvider component."
  );
  const T = Pt(null), A = i.useState("values"), j = i.useState("submitSucceed"), I = i.useState("submitFailed"), Z = i.useState("items"), N = Hx(A);
  wt(
    () => m ? i == null ? void 0 : i.reset : void 0,
    [m, i]
  ), R1(() => {
    h && A !== N && (i == null || i.validate());
  }, [h, A, N, i]), wt(() => {
    S && j && (i == null || i.reset());
  }, [S, j, i]);
  const [B, $] = Kt(!1);
  wt(() => {
    if (!B || !I)
      return;
    const me = SI(Z), oe = me == null ? void 0 : me.element;
    oe && ($(!1), oe.focus(), yl(oe) && oe.select());
  }, [b, I, Z]);
  const W = R.onSubmit, z = nt((me) => {
    W == null || W(me), !me.defaultPrevented && (me.preventDefault(), i == null || i.submit(), b && $(!0));
  }), Y = R.onBlur, ie = nt((me) => {
    Y == null || Y(me), !me.defaultPrevented && g && i && xI(me.target, i.getState().items) && i.validate();
  }), G = R.onReset, pe = nt((me) => {
    G == null || G(me), !me.defaultPrevented && (me.preventDefault(), i == null || i.reset());
  });
  R = Bn(
    R,
    (me) => /* @__PURE__ */ d.jsx(yI, { value: i, children: me }),
    [i]
  );
  const J = ch(T, AE);
  return R = De(Q({
    role: J !== "form" ? "form" : void 0,
    noValidate: !0
  }, R), {
    ref: In(T, R.ref),
    onSubmit: z,
    onBlur: ie,
    onReset: pe
  }), R;
}), jE = ke(function(n) {
  const a = CI(n);
  return Ie(AE, a);
});
function kE(e = {}) {
  const n = Wx(e);
  return /* @__PURE__ */ d.jsx(wI, { value: n, children: e.children });
}
var bI = "input";
function _I(e, n) {
  const a = e.current;
  return a ? a.name === n ? a : a.form ? a.form.elements.namedItem(n) : aa(a).getElementsByName(n)[0] : null;
}
function R9(e, n, a) {
  return e.useState(
    (i) => i.items.find((h) => h.type === a && h.name === n)
  );
}
var z4 = He(
  function(n) {
    var a = n, {
      store: i,
      name: h,
      getItem: g,
      touchOnBlur: m = !0
    } = a, S = Ue(a, [
      "store",
      "name",
      "getItem",
      "touchOnBlur"
    ]);
    const b = Sl();
    i = i || b, Ht(
      i,
      process.env.NODE_ENV !== "production" && "FormControl must be wrapped in a Form component."
    );
    const R = `${h}`, D = Na(S.id), T = Pt(null);
    i.useValidate(async () => {
      const Y = _I(T, R);
      Y && (await Promise.resolve(), "validity" in Y && !Y.validity.valid && (i == null || i.setError(R, Y.validationMessage)));
    });
    const A = Pr(
      (Y) => {
        const ie = De(Q({}, Y), { id: D || Y.id, name: R, type: "field" });
        return g ? g(ie) : ie;
      },
      [D, R, g]
    ), j = S.onBlur, I = rr(m), Z = nt((Y) => {
      j == null || j(Y), !Y.defaultPrevented && I(Y) && (i == null || i.setFieldTouched(R, !0));
    }), N = R9(i, R, "label"), B = R9(i, R, "error"), $ = R9(i, R, "description"), W = rL(
      B == null ? void 0 : B.id,
      $ == null ? void 0 : $.id,
      S["aria-describedby"]
    ), z = i.useState(
      () => !!(i != null && i.getError(R)) && i.getFieldTouched(R)
    );
    return S = De(Q({
      id: D,
      "aria-labelledby": N == null ? void 0 : N.id,
      "aria-invalid": z
    }, S), {
      "aria-describedby": W || void 0,
      ref: In(T, S.ref),
      onBlur: Z
    }), S = dh(De(Q({ store: i }, S), { name: R, getItem: A })), S;
  }
), RI = Va(
  ke(function(n) {
    const a = z4(n);
    return Ie(bI, a);
  })
), EI = "input", MI = He(
  function(n) {
    var a = n, {
      store: i,
      name: h,
      value: g,
      checked: m,
      defaultChecked: S
    } = a, b = Ue(a, [
      "store",
      "name",
      "value",
      "checked",
      "defaultChecked"
    ]);
    const R = Sl();
    i = i || R, Ht(
      i,
      process.env.NODE_ENV !== "production" && "FormCheckbox must be wrapped in a Form component."
    );
    const D = `${h}`, T = W4({
      value: i.useValue(D),
      setValue: (A) => i == null ? void 0 : i.setValue(D, A)
    });
    return b = $x(Q({ store: T, value: g, checked: m }, b)), b = z4(Q({
      store: i,
      name: D,
      "aria-labelledby": void 0
    }, b)), b;
  }
), TI = Va(
  ke(function(n) {
    const a = MI(n);
    return Ie(EI, a);
  })
), OI = "div", DI = He(
  function(n) {
    var a = n, {
      store: i,
      name: h,
      getItem: g
    } = a, m = Ue(a, [
      "store",
      "name",
      "getItem"
    ]);
    const S = Sl();
    i = i || S, Ht(
      i,
      process.env.NODE_ENV !== "production" && "FormDescription must be wrapped in a Form component."
    );
    const b = Na(m.id), R = Pt(null), D = `${h}`, T = Pr(
      (A) => {
        const j = De(Q({}, A), {
          id: b || A.id,
          name: D,
          type: "description"
        });
        return g ? g(j) : j;
      },
      [b, D, g]
    );
    return m = De(Q({
      id: b
    }, m), {
      ref: In(R, m.ref)
    }), m = dh(De(Q({ store: i }, m), { getItem: T })), m;
  }
), AI = Va(
  ke(function(n) {
    const a = DI(n);
    return Ie(OI, a);
  })
), jI = "div", kI = He(
  function(n) {
    var a = n, {
      store: i,
      name: h,
      getItem: g
    } = a, m = Ue(a, [
      "store",
      "name",
      "getItem"
    ]);
    const S = Sl();
    i = i || S, Ht(
      i,
      process.env.NODE_ENV !== "production" && "FormError must be wrapped in a Form component."
    );
    const b = Na(m.id), R = Pt(null), D = `${h}`, T = Pr(
      (j) => {
        const I = De(Q({}, j), { id: b || j.id, name: D, type: "error" });
        return g ? g(I) : I;
      },
      [b, D, g]
    ), A = i.useState(() => {
      const j = i == null ? void 0 : i.getError(D);
      if (j != null && i != null && i.getFieldTouched(D))
        return j;
    });
    return m = De(Q({
      id: b,
      role: "alert",
      children: A
    }, m), {
      ref: In(R, m.ref)
    }), m = dh(De(Q({ store: i }, m), { getItem: T })), m;
  }
), LE = Va(
  ke(function(n) {
    const a = kI(n);
    return Ie(jI, a);
  })
), LI = "input", II = He(
  function(n) {
    return z4(n);
  }
), HI = Va(
  ke(function(n) {
    const a = II(n);
    return Ie(LI, a);
  })
), IE = Za(void 0), ZI = "div", qx = He(
  function(n) {
    const a = Qo(IE), i = Na(n.id);
    return Ln(() => (a == null || a(i), () => a == null ? void 0 : a(void 0)), [a, i]), n = Q({
      id: i,
      "aria-hidden": !0
    }, n), Pa(n);
  }
), PI = ke(function(n) {
  const a = qx(n);
  return Ie(ZI, a);
}), NI = "div", VI = He(
  function(n) {
    var a = n, i = Ue(a, ["store"]);
    return i = qx(i), i;
  }
), FI = ke(function(n) {
  const a = VI(n);
  return Ie(NI, a);
}), BI = "div", Gx = He(
  function(n) {
    const [a, i] = Kt();
    return n = Bn(
      n,
      (h) => /* @__PURE__ */ d.jsx(IE.Provider, { value: i, children: h }),
      []
    ), n = Q({
      role: "group",
      "aria-labelledby": a
    }, n), Pa(n);
  }
), UI = ke(function(n) {
  const a = Gx(n);
  return Ie(BI, a);
}), YI = "div", HE = He(
  function(n) {
    var a = n, i = Ue(a, ["store"]);
    return i = Gx(i), i;
  }
), $I = ke(function(n) {
  const a = HE(n);
  return Ie(YI, a);
}), WI = "input", zI = He(
  function(n) {
    var a = n, { store: i, name: h } = a, g = Ue(a, ["store", "name"]);
    const m = Sl();
    i = i || m, Ht(
      i,
      process.env.NODE_ENV !== "production" && "FormInput must be wrapped in a Form component."
    );
    const S = `${h}`, b = g.onChange, R = nt((T) => {
      b == null || b(T), !T.defaultPrevented && (i == null || i.setValue(S, T.target.value));
    }), D = i.useValue(S);
    return g = De(Q({
      value: D
    }, g), {
      onChange: R
    }), g = H2(g), g = z4(Q({ store: i, name: S }, g)), g;
  }
), Kx = Va(
  ke(function(n) {
    const a = zI(n);
    return Ie(WI, a);
  })
), qI = "label";
function GI(e) {
  return e === "input" || e === "textarea" || e === "select" || e === "meter" || e === "progress";
}
var KI = He(
  function(n) {
    var a = n, {
      store: i,
      name: h,
      getItem: g
    } = a, m = Ue(a, [
      "store",
      "name",
      "getItem"
    ]);
    const S = Sl();
    i = i || S, Ht(
      i,
      process.env.NODE_ENV !== "production" && "FormLabel must be wrapped in a Form component."
    );
    const b = Na(m.id), R = Pt(null), D = `${h}`, T = Pr(
      (B) => {
        const $ = De(Q({}, B), { id: b || B.id, name: D, type: "label" });
        return g ? g($) : $;
      },
      [b, D, g]
    ), A = i.useState(
      (B) => B.items.find(($) => $.type === "field" && $.name === D)
    ), j = ch(A == null ? void 0 : A.element, "input"), I = GI(j), Z = m.onClick, N = nt((B) => {
      if (Z == null || Z(B), B.defaultPrevented || I)
        return;
      const $ = A == null ? void 0 : A.element;
      $ && queueMicrotask(() => {
        const W = H5($, !0, !0);
        W == null || W.focus(), W == null || W.click();
      });
    });
    return m = De(Q({
      id: b,
      render: I ? /* @__PURE__ */ d.jsx("label", {}) : /* @__PURE__ */ d.jsx("span", {}),
      htmlFor: I ? A == null ? void 0 : A.id : void 0
    }, m), {
      ref: In(R, m.ref),
      onClick: N
    }), I || (m = De(Q({}, m), {
      style: Q({
        cursor: "default"
      }, m.style)
    })), m = dh(De(Q({ store: i }, m), { getItem: T })), m;
  }
), ZE = Va(
  ke(function(n) {
    const a = KI(n);
    return Ie(qI, a);
  })
), QI = "button";
function XI(e, n) {
  if (!e)
    return [];
  const a = [];
  for (const i of e) {
    if (i.type !== "field" || !i.name.startsWith(n))
      continue;
    const h = i.name.replace(/(\.\d+)\..+$/, "$1"), g = new RegExp(`^${h}`);
    a.some((m) => g.test(m.name)) || a.push(i);
  }
  return a;
}
var JI = He(
  function(n) {
    var a = n, {
      store: i,
      value: h,
      name: g,
      getItem: m,
      autoFocusOnClick: S = !0
    } = a, b = Ue(a, [
      "store",
      "value",
      "name",
      "getItem",
      "autoFocusOnClick"
    ]);
    const R = Sl();
    i = i || R, Ht(
      i,
      process.env.NODE_ENV !== "production" && "FormPush must be wrapped in a Form component."
    );
    const D = `${g}`, [T, A] = Kt(!1);
    wt(() => {
      var N;
      if (!T)
        return;
      const B = XI(i == null ? void 0 : i.getState().items, D), $ = (N = B == null ? void 0 : B[B.length - 1]) == null ? void 0 : N.element;
      $ && ($.focus(), A(!1));
    }, [i, T, D]);
    const j = Pr(
      (N) => {
        const B = De(Q({}, N), { type: "button", name: D });
        return m ? m(B) : B;
      },
      [D, m]
    ), I = b.onClick, Z = nt((N) => {
      I == null || I(N), !N.defaultPrevented && (i == null || i.pushValue(D, h), S && A(!0));
    });
    return b = De(Q({}, b), {
      onClick: Z
    }), b = hh(b), b = dh(De(Q({ store: i }, b), { getItem: j })), b;
  }
), eH = ke(function(n) {
  const a = JI(n);
  return Ie(QI, a);
}), tH = "div", nH = He(
  function(n) {
    var a = n, i = Ue(a, ["store"]);
    return i = Q({ role: "radiogroup" }, i), i = HE(i), i;
  }
), rH = ke(function(n) {
  const a = nH(n);
  return Ie(tH, a);
}), V5 = bi(
  [Vx],
  [Fx]
), Z2 = V5.useContext, aH = V5.useProviderContext, B0 = V5.ContextProvider, vh = V5.ScopedContextProvider, oH = Za(
  void 0
), PE = Za(
  void 0
), F5 = bi(
  [B0],
  [vh]
), NE = F5.useContext, iH = F5.useProviderContext, lH = F5.ContextProvider, uH = F5.ScopedContextProvider, sH = { id: null };
function cH(e, n, a = !1) {
  const i = e.findIndex((h) => h.id === n);
  return [
    ...e.slice(i + 1),
    ...a ? [sH] : [],
    ...e.slice(0, i)
  ];
}
function fH(e, n) {
  return e.find((a) => !a.disabled);
}
function Xd(e, n) {
  return n && e.item(n) || null;
}
function dH(e) {
  const n = [];
  for (const a of e) {
    const i = n.find((h) => {
      var g;
      return ((g = h[0]) == null ? void 0 : g.rowId) === a.rowId;
    });
    i ? i.push(a) : n.push([a]);
  }
  return n;
}
function VE(e, n = !1) {
  if (yl(e))
    e.setSelectionRange(
      n ? e.value.length : 0,
      e.value.length
    );
  else if (e.isContentEditable) {
    const a = aa(e).getSelection();
    a == null || a.selectAllChildren(e), n && (a == null || a.collapseToEnd());
  }
}
var Q9 = Symbol("FOCUS_SILENTLY");
function hH(e) {
  e[Q9] = !0, e.focus({ preventScroll: !0 });
}
function vH(e) {
  const n = e[Q9];
  return delete e[Q9], n;
}
function k4(e, n, a) {
  return !(!n || n === a || !e.item(n.id));
}
var pH = "button";
function mH(e) {
  return W9(e) ? !0 : e.tagName === "INPUT" && !N0(e);
}
function gH(e, n = !1) {
  const a = e.clientHeight, { top: i } = e.getBoundingClientRect(), h = Math.max(a * 0.875, a - 40) * 1.5, g = n ? a - h + i : h + i;
  return e.tagName === "HTML" ? g + e.scrollTop : g;
}
function wH(e, n = !1) {
  const { top: a } = e.getBoundingClientRect();
  return n ? a + e.clientHeight : a;
}
function D_(e, n, a, i = !1) {
  var h;
  if (!n || !a)
    return;
  const { renderedItems: g } = n.getState(), m = Ax(e);
  if (!m)
    return;
  const S = gH(m, i);
  let b, R;
  for (let D = 0; D < g.length; D += 1) {
    const T = b;
    if (b = a(D), !b)
      break;
    if (b === T)
      continue;
    const A = (h = Xd(n, b)) == null ? void 0 : h.element;
    if (!A)
      continue;
    const I = wH(A, i) - S, Z = Math.abs(I);
    if (i && I <= 0 || !i && I >= 0) {
      R !== void 0 && R < Z && (b = T);
      break;
    }
    R = Z;
  }
  return b;
}
function yH(e, n) {
  return Si(e) ? !1 : k4(n, e.target);
}
function xH(e, n) {
  const a = n.role, [i, h] = Kt(a);
  return Ln(() => {
    const g = e.current;
    g && h(g.getAttribute("role") || a);
  }, [a]), i;
}
function SH(e) {
  return e === "option" || e === "treeitem";
}
function CH(e) {
  return e === "option" || e === "tab" || e === "treeitem" || e === "gridcell" || e === "row" || e === "columnheader" || e === "rowheader";
}
var P2 = He(
  function(n) {
    var a = n, {
      store: i,
      rowId: h,
      preventScrollOnKeyDown: g = !1,
      moveOnKeyPress: m = !0,
      tabbable: S = !1,
      getItem: b,
      "aria-setsize": R,
      "aria-posinset": D
    } = a, T = Ue(a, [
      "store",
      "rowId",
      "preventScrollOnKeyDown",
      "moveOnKeyPress",
      "tabbable",
      "getItem",
      "aria-setsize",
      "aria-posinset"
    ]);
    const A = Z2();
    i = i || A;
    const j = Na(T.id), I = Pt(null), Z = Qo(PE), N = Ia(i, (Ze) => {
      if (h)
        return h;
      if (Ze && Z != null && Z.baseElement && Z.baseElement === Ze.baseElement)
        return Z.id;
    }), $ = wf(T) && !T.accessibleWhenDisabled, W = Pr(
      (Ze) => {
        const qe = De(Q({}, Ze), {
          id: j || Ze.id,
          rowId: N,
          disabled: !!$
        });
        return b ? b(qe) : qe;
      },
      [j, N, $, b]
    ), z = T.onFocus, Y = Pt(!1), ie = nt((Ze) => {
      if (z == null || z(Ze), Ze.defaultPrevented || fE(Ze) || !j || !i || yH(Ze, i))
        return;
      const { virtualFocus: qe, baseElement: Je } = i.getState();
      if (i.setActiveId(j), W9(Ze.currentTarget) && VE(Ze.currentTarget), !qe || !Si(Ze) || mH(Ze.currentTarget) || !(Je != null && Je.isConnected))
        return;
      Y.current = !0, Ze.relatedTarget === Je || k4(i, Ze.relatedTarget) ? hH(Je) : Je.focus();
    }), G = T.onBlurCapture, pe = nt((Ze) => {
      if (G == null || G(Ze), Ze.defaultPrevented)
        return;
      const qe = i == null ? void 0 : i.getState();
      qe != null && qe.virtualFocus && Y.current && (Y.current = !1, Ze.preventDefault(), Ze.stopPropagation());
    }), J = T.onKeyDown, me = rr(g), oe = rr(m), ge = nt((Ze) => {
      if (J == null || J(Ze), Ze.defaultPrevented || !Si(Ze) || !i)
        return;
      const { currentTarget: qe } = Ze, Je = i.getState(), ot = i.item(j), Nt = !!(ot != null && ot.rowId), Tn = Je.orientation !== "horizontal", Qt = Je.orientation !== "vertical", Hn = () => !!(Nt || Qt || !Je.baseElement || !yl(Je.baseElement)), Wn = {
        ArrowUp: (Nt || Tn) && i.up,
        ArrowRight: (Nt || Qt) && i.next,
        ArrowDown: (Nt || Tn) && i.down,
        ArrowLeft: (Nt || Qt) && i.previous,
        Home: () => {
          if (Hn())
            return !Nt || Ze.ctrlKey ? i == null ? void 0 : i.first() : i == null ? void 0 : i.previous(-1);
        },
        End: () => {
          if (Hn())
            return !Nt || Ze.ctrlKey ? i == null ? void 0 : i.last() : i == null ? void 0 : i.next(-1);
        },
        PageUp: () => D_(qe, i, i == null ? void 0 : i.up, !0),
        PageDown: () => D_(qe, i, i == null ? void 0 : i.down)
      }[Ze.key];
      if (Wn) {
        if (W9(qe)) {
          const qn = z9(qe), Gn = Qt && Ze.key === "ArrowLeft", wr = Qt && Ze.key === "ArrowRight", Ta = Tn && Ze.key === "ArrowUp", jr = Tn && Ze.key === "ArrowDown";
          if (wr || jr) {
            const { length: Mt } = dL(qe);
            if (qn.end !== Mt)
              return;
          } else if ((Gn || Ta) && qn.start !== 0)
            return;
        }
        const zn = Wn();
        if (me(Ze) || zn !== void 0) {
          if (!oe(Ze))
            return;
          Ze.preventDefault(), i.move(zn);
        }
      }
    }), ce = Ia(
      i,
      (Ze) => (Ze == null ? void 0 : Ze.baseElement) || void 0
    ), Se = qr(
      () => ({ id: j, baseElement: ce }),
      [j, ce]
    );
    T = Bn(
      T,
      (Ze) => /* @__PURE__ */ d.jsx(oH.Provider, { value: Se, children: Ze }),
      [Se]
    );
    const Re = Ia(
      i,
      (Ze) => !!Ze && Ze.activeId === j
    ), _e = Ia(i, "virtualFocus"), Ye = xH(I, T);
    let ue;
    Re && (SH(Ye) || _e && CH(Ye)) && (ue = !0);
    const Ae = Ia(i, (Ze) => {
      if (R != null)
        return R;
      if (Ze && Z != null && Z.ariaSetSize && Z.baseElement === Ze.baseElement)
        return Z.ariaSetSize;
    }), Pe = Ia(i, (Ze) => {
      if (D != null)
        return D;
      if (!Ze || !(Z != null && Z.ariaPosInSet) || Z.baseElement !== Ze.baseElement)
        return;
      const qe = Ze.renderedItems.filter(
        (Je) => Je.rowId === N
      );
      return Z.ariaPosInSet + qe.findIndex((Je) => Je.id === j);
    }), dt = Ia(i, (Ze) => Ze != null && Ze.renderedItems.length ? Ze.virtualFocus ? !1 : S ? !0 : Ze.activeId === j : !0);
    return T = De(Q({
      id: j,
      "aria-selected": ue,
      "data-active-item": Re || void 0
    }, T), {
      ref: In(I, T.ref),
      tabIndex: dt ? T.tabIndex : -1,
      onFocus: ie,
      onBlurCapture: pe,
      onKeyDown: ge
    }), T = Z5(T), T = dh(De(Q({
      store: i
    }, T), {
      getItem: W,
      shouldRegisterItem: j ? T.shouldRegisterItem : !1
    })), Pa(De(Q({}, T), {
      "aria-setsize": Ae,
      "aria-posinset": Pe
    }));
  }
), X9 = Va(
  ke(function(n) {
    const a = P2(n);
    return Ie(pH, a);
  })
), FE = "input";
function bH(e, n) {
  if (n !== void 0)
    return e != null && n != null ? n === e : !!n;
}
function _H(e, n) {
  return e === "input" && (!n || n === "radio");
}
var Qx = He(function(n) {
  var a = n, {
    store: i,
    name: h,
    value: g,
    checked: m
  } = a, S = Ue(a, [
    "store",
    "name",
    "value",
    "checked"
  ]);
  const b = NE();
  i = i || b;
  const R = Na(S.id), D = Pt(null), T = Ia(
    i,
    (G) => m ?? bH(g, G == null ? void 0 : G.value)
  );
  wt(() => {
    !R || !T || (i == null ? void 0 : i.getState().activeId) === R || i == null || i.setActiveId(R);
  }, [i, T, R]);
  const A = S.onChange, j = ch(D, FE), I = _H(j, S.type), Z = wf(S), [N, B] = j5();
  wt(() => {
    const G = D.current;
    G && (I || (T !== void 0 && (G.checked = T), h !== void 0 && (G.name = h), g !== void 0 && (G.value = `${g}`)));
  }, [N, I, T, h, g]);
  const $ = nt((G) => {
    if (Z) {
      G.preventDefault(), G.stopPropagation();
      return;
    }
    I || (G.currentTarget.checked = !0, B()), A == null || A(G), !G.defaultPrevented && (i == null || i.setValue(g));
  }), W = S.onClick, z = nt((G) => {
    W == null || W(G), !G.defaultPrevented && (I || $(G));
  }), Y = S.onFocus, ie = nt((G) => {
    if (Y == null || Y(G), G.defaultPrevented || !I || !i)
      return;
    const { moves: pe, activeId: J } = i.getState();
    pe && (R && J !== R || $(G));
  });
  return S = De(Q({
    id: R,
    role: I ? void 0 : "radio",
    type: I ? "radio" : void 0,
    "aria-checked": T
  }, S), {
    ref: In(D, S.ref),
    onChange: $,
    onClick: z,
    onFocus: ie
  }), S = P2(Q({
    store: i,
    clickOnEnter: !I
  }, S)), Pa(Q({
    name: I ? h : void 0,
    value: I ? g : void 0,
    checked: T
  }, S));
}), BE = Va(
  ke(function(n) {
    const a = Qx(n);
    return Ie(FE, a);
  })
), RH = "input", EH = He(
  function(n) {
    var a = n, { store: i, name: h, value: g } = a, m = Ue(a, ["store", "name", "value"]);
    const S = Sl();
    i = i || S, Ht(
      i,
      process.env.NODE_ENV !== "production" && "FormRadio must be wrapped in a Form component."
    );
    const b = `${h}`, R = m.onChange, D = nt((j) => {
      R == null || R(j), !j.defaultPrevented && (i == null || i.setValue(b, g));
    }), T = m.checked, A = i.useState(
      () => T ?? (i == null ? void 0 : i.getValue(b)) === g
    );
    return m = De(Q({}, m), {
      checked: A,
      onChange: D
    }), m = Qx(Q({ value: g }, m)), m = z4(Q({
      store: i,
      name: b,
      "aria-labelledby": void 0
    }, m)), m;
  }
), MH = Va(
  ke(function(n) {
    const a = EH(n);
    return Ie(RH, a);
  })
), TH = "button";
function OH(e, n, a) {
  const i = e == null ? void 0 : e.filter(
    (m) => m.type === "field" && m.name.startsWith(n)
  ), h = new RegExp(`^${n}\\.(\\d+)`), g = i == null ? void 0 : i.find((m) => {
    const S = m.name.replace(h, "$1");
    return parseInt(S) > a;
  });
  return g || (i == null ? void 0 : i.reverse().find((m) => {
    const S = m.name.replace(h, "$1");
    return parseInt(S) < a;
  }));
}
function DH(e, n) {
  return e == null ? void 0 : e.find((a) => a.type === "button" && a.name === n);
}
var AH = He(
  function(n) {
    var a = n, {
      store: i,
      name: h,
      index: g,
      autoFocusOnClick: m = !0
    } = a, S = Ue(a, [
      "store",
      "name",
      "index",
      "autoFocusOnClick"
    ]);
    const b = Sl();
    i = i || b, Ht(
      i,
      process.env.NODE_ENV !== "production" && "FormRemove must be wrapped in a Form component."
    );
    const R = `${h}`, D = S.onClick, T = nt((A) => {
      var j;
      if (D == null || D(A), A.defaultPrevented || !i || (i.removeValue(R, g), !m))
        return;
      const { items: I } = i.getState(), Z = OH(I, R, g), N = Z == null ? void 0 : Z.element;
      if (N)
        N.focus(), yl(N) && N.select();
      else {
        const B = DH(I, R);
        (j = B == null ? void 0 : B.element) == null || j.focus();
      }
    });
    return S = De(Q({}, S), {
      onClick: T
    }), S = hh(S), S;
  }
), jH = ke(function(n) {
  const a = AH(n);
  return Ie(TH, a);
}), kH = "button", LH = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = Sl();
    return i = i || g, Ht(
      i,
      process.env.NODE_ENV !== "production" && "FormReset must be wrapped in a Form component."
    ), h = Q({
      type: "reset",
      disabled: i.useState("submitting")
    }, h), h = hh(h), h;
  }
), IH = ke(function(n) {
  const a = LH(n);
  return Ie(kH, a);
}), HH = "button", ZH = He(
  function(n) {
    var a = n, { store: i, accessibleWhenDisabled: h = !0 } = a, g = Ue(a, ["store", "accessibleWhenDisabled"]);
    const m = Sl();
    return i = i || m, Ht(
      i,
      process.env.NODE_ENV !== "production" && "FormSubmit must be wrapped in a Form component."
    ), g = Q({
      type: "submit",
      disabled: i.useState("submitting")
    }, g), g = hh(De(Q({}, g), { accessibleWhenDisabled: h })), g;
  }
), UE = ke(function(n) {
  const a = ZH(n);
  return Ie(HH, a);
}), PH = "span", Xx = He(
  function(n) {
    return n = De(Q({}, n), {
      style: Q({
        border: 0,
        clip: "rect(0 0 0 0)",
        height: "1px",
        margin: "-1px",
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        whiteSpace: "nowrap",
        width: "1px"
      }, n.style)
    }), n;
  }
), NH = ke(function(n) {
  const a = Xx(n);
  return Ie(PH, a);
}), VH = "span", FH = He(
  function(n) {
    return n = De(Q({
      "data-focus-trap": "",
      tabIndex: 0,
      "aria-hidden": !0
    }, n), {
      style: Q({
        // Prevents unintended scroll jumps.
        position: "fixed",
        top: 0,
        left: 0
      }, n.style)
    }), n = Xx(n), n;
  }
), Dp = ke(function(n) {
  const a = FH(n);
  return Ie(VH, a);
}), BH = "div", UH = He(
  function(n) {
    var a = n, { enabled: i = !1 } = a, h = Ue(a, ["enabled"]);
    const g = Pt(null);
    return h = Bn(
      h,
      (m) => {
        const S = () => i ? /* @__PURE__ */ d.jsx(
          Dp,
          {
            onFocus: (b) => {
              const R = g.current;
              if (!R)
                return;
              const D = Yp(R, !0), T = D[0], A = D[D.length - 1];
              if (!D.length) {
                R.focus();
                return;
              }
              b.relatedTarget === T ? A == null || A.focus() : T == null || T.focus();
            }
          }
        ) : null;
        return /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
          S(),
          m,
          S()
        ] });
      },
      [i]
    ), h = De(Q({}, h), {
      ref: In(g, h.ref)
    }), Pa(h);
  }
), YH = ke(function(n) {
  const a = UH(n);
  return Ie(BH, a);
});
function YE(e = {}) {
  const n = Up(
    e.store,
    Pp(e.disclosure, ["contentElement", "disclosureElement"])
  );
  fh(e, n);
  const a = n == null ? void 0 : n.getState(), i = ht(
    e.open,
    a == null ? void 0 : a.open,
    e.defaultOpen,
    !1
  ), h = ht(e.animated, a == null ? void 0 : a.animated, !1), g = {
    open: i,
    animated: h,
    animating: !!h && i,
    mounted: i,
    contentElement: ht(a == null ? void 0 : a.contentElement, null),
    disclosureElement: ht(a == null ? void 0 : a.disclosureElement, null)
  }, m = ho(g, n);
  return Ha(
    m,
    () => Ea(m, ["animated", "animating"], (S) => {
      S.animated || m.setState("animating", !1);
    })
  ), Ha(
    m,
    () => gE(m, ["open"], () => {
      m.getState().animated && m.setState("animating", !0);
    })
  ), Ha(
    m,
    () => Ea(m, ["open", "animating"], (S) => {
      m.setState("mounted", S.open || S.animating);
    })
  ), pn(Ct({}, m), {
    disclosure: e.disclosure,
    setOpen: (S) => m.setState("open", S),
    show: () => m.setState("open", !0),
    hide: () => m.setState("open", !1),
    toggle: () => m.setState("open", (S) => !S),
    stopAnimation: () => m.setState("animating", !1),
    setContentElement: (S) => m.setState("contentElement", S),
    setDisclosureElement: (S) => m.setState("disclosureElement", S)
  });
}
function $E(e, n, a) {
  return R1(n, [a.store, a.disclosure]), lr(e, a, "open", "setOpen"), lr(e, a, "mounted", "setMounted"), lr(e, a, "animated"), Object.assign(e, { disclosure: a.disclosure });
}
function B5(e = {}) {
  const [n, a] = Ci(YE, e);
  return $E(n, a, e);
}
var U5 = bi(), $H = U5.useContext, Jx = U5.useProviderContext, WE = U5.ContextProvider, WH = U5.ScopedContextProvider, zH = "button", qH = Symbol("disclosure"), zE = He(
  function(n) {
    var a = n, { store: i, toggleOnClick: h = !0 } = a, g = Ue(a, ["store", "toggleOnClick"]);
    const m = Jx();
    i = i || m, Ht(
      i,
      process.env.NODE_ENV !== "production" && "Disclosure must receive a `store` prop or be wrapped in a DisclosureProvider component."
    );
    const S = Pt(null), [b, R] = Kt(!1), D = i.useState("disclosureElement"), T = i.useState("open");
    wt(() => {
      let $ = D === S.current;
      D != null && D.isConnected || (i == null || i.setDisclosureElement(S.current), $ = !0), R(T && $);
    }, [D, i, T]);
    const A = g.onClick, j = rr(h), [I, Z] = pE(g, qH, !0), N = nt(($) => {
      A == null || A($), !$.defaultPrevented && (I || j($) && (i == null || i.setDisclosureElement($.currentTarget), i == null || i.toggle()));
    }), B = i.useState("contentElement");
    return g = De(Q(Q({
      "aria-expanded": b,
      "aria-controls": B == null ? void 0 : B.id
    }, Z), g), {
      ref: In(S, g.ref),
      onClick: N
    }), g = hh(g), g;
  }
), GH = ke(function(n) {
  const a = zE(n);
  return Ie(zH, a);
});
function KH(e = {}) {
  const n = B5(e);
  return /* @__PURE__ */ d.jsx(WE, { value: n, children: e.children });
}
var q4 = bi(
  [WE],
  [WH]
), qE = q4.useContext, QH = q4.useScopedContext, Y5 = q4.useProviderContext, GE = q4.ContextProvider, e8 = q4.ScopedContextProvider, KE = Za(void 0), QE = Za(void 0), J9 = { exports: {} }, Ul = {}, Jg = { exports: {} }, E9 = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var A_;
function XH() {
  return A_ || (A_ = 1, function(e) {
    function n(ue, Ae) {
      var Pe = ue.length;
      ue.push(Ae);
      e: for (; 0 < Pe; ) {
        var dt = Pe - 1 >>> 1, Ze = ue[dt];
        if (0 < h(Ze, Ae)) ue[dt] = Ae, ue[Pe] = Ze, Pe = dt;
        else break e;
      }
    }
    function a(ue) {
      return ue.length === 0 ? null : ue[0];
    }
    function i(ue) {
      if (ue.length === 0) return null;
      var Ae = ue[0], Pe = ue.pop();
      if (Pe !== Ae) {
        ue[0] = Pe;
        e: for (var dt = 0, Ze = ue.length, qe = Ze >>> 1; dt < qe; ) {
          var Je = 2 * (dt + 1) - 1, ot = ue[Je], Nt = Je + 1, Tn = ue[Nt];
          if (0 > h(ot, Pe)) Nt < Ze && 0 > h(Tn, ot) ? (ue[dt] = Tn, ue[Nt] = Pe, dt = Nt) : (ue[dt] = ot, ue[Je] = Pe, dt = Je);
          else if (Nt < Ze && 0 > h(Tn, Pe)) ue[dt] = Tn, ue[Nt] = Pe, dt = Nt;
          else break e;
        }
      }
      return Ae;
    }
    function h(ue, Ae) {
      var Pe = ue.sortIndex - Ae.sortIndex;
      return Pe !== 0 ? Pe : ue.id - Ae.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var g = performance;
      e.unstable_now = function() {
        return g.now();
      };
    } else {
      var m = Date, S = m.now();
      e.unstable_now = function() {
        return m.now() - S;
      };
    }
    var b = [], R = [], D = 1, T = null, A = 3, j = !1, I = !1, Z = !1, N = typeof setTimeout == "function" ? setTimeout : null, B = typeof clearTimeout == "function" ? clearTimeout : null, $ = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function W(ue) {
      for (var Ae = a(R); Ae !== null; ) {
        if (Ae.callback === null) i(R);
        else if (Ae.startTime <= ue) i(R), Ae.sortIndex = Ae.expirationTime, n(b, Ae);
        else break;
        Ae = a(R);
      }
    }
    function z(ue) {
      if (Z = !1, W(ue), !I) if (a(b) !== null) I = !0, _e(Y);
      else {
        var Ae = a(R);
        Ae !== null && Ye(z, Ae.startTime - ue);
      }
    }
    function Y(ue, Ae) {
      I = !1, Z && (Z = !1, B(pe), pe = -1), j = !0;
      var Pe = A;
      try {
        for (W(Ae), T = a(b); T !== null && (!(T.expirationTime > Ae) || ue && !oe()); ) {
          var dt = T.callback;
          if (typeof dt == "function") {
            T.callback = null, A = T.priorityLevel;
            var Ze = dt(T.expirationTime <= Ae);
            Ae = e.unstable_now(), typeof Ze == "function" ? T.callback = Ze : T === a(b) && i(b), W(Ae);
          } else i(b);
          T = a(b);
        }
        if (T !== null) var qe = !0;
        else {
          var Je = a(R);
          Je !== null && Ye(z, Je.startTime - Ae), qe = !1;
        }
        return qe;
      } finally {
        T = null, A = Pe, j = !1;
      }
    }
    var ie = !1, G = null, pe = -1, J = 5, me = -1;
    function oe() {
      return !(e.unstable_now() - me < J);
    }
    function ge() {
      if (G !== null) {
        var ue = e.unstable_now();
        me = ue;
        var Ae = !0;
        try {
          Ae = G(!0, ue);
        } finally {
          Ae ? ce() : (ie = !1, G = null);
        }
      } else ie = !1;
    }
    var ce;
    if (typeof $ == "function") ce = function() {
      $(ge);
    };
    else if (typeof MessageChannel < "u") {
      var Se = new MessageChannel(), Re = Se.port2;
      Se.port1.onmessage = ge, ce = function() {
        Re.postMessage(null);
      };
    } else ce = function() {
      N(ge, 0);
    };
    function _e(ue) {
      G = ue, ie || (ie = !0, ce());
    }
    function Ye(ue, Ae) {
      pe = N(function() {
        ue(e.unstable_now());
      }, Ae);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(ue) {
      ue.callback = null;
    }, e.unstable_continueExecution = function() {
      I || j || (I = !0, _e(Y));
    }, e.unstable_forceFrameRate = function(ue) {
      0 > ue || 125 < ue ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : J = 0 < ue ? Math.floor(1e3 / ue) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return A;
    }, e.unstable_getFirstCallbackNode = function() {
      return a(b);
    }, e.unstable_next = function(ue) {
      switch (A) {
        case 1:
        case 2:
        case 3:
          var Ae = 3;
          break;
        default:
          Ae = A;
      }
      var Pe = A;
      A = Ae;
      try {
        return ue();
      } finally {
        A = Pe;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(ue, Ae) {
      switch (ue) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          ue = 3;
      }
      var Pe = A;
      A = ue;
      try {
        return Ae();
      } finally {
        A = Pe;
      }
    }, e.unstable_scheduleCallback = function(ue, Ae, Pe) {
      var dt = e.unstable_now();
      switch (typeof Pe == "object" && Pe !== null ? (Pe = Pe.delay, Pe = typeof Pe == "number" && 0 < Pe ? dt + Pe : dt) : Pe = dt, ue) {
        case 1:
          var Ze = -1;
          break;
        case 2:
          Ze = 250;
          break;
        case 5:
          Ze = 1073741823;
          break;
        case 4:
          Ze = 1e4;
          break;
        default:
          Ze = 5e3;
      }
      return Ze = Pe + Ze, ue = { id: D++, callback: Ae, priorityLevel: ue, startTime: Pe, expirationTime: Ze, sortIndex: -1 }, Pe > dt ? (ue.sortIndex = Pe, n(R, ue), a(b) === null && ue === a(R) && (Z ? (B(pe), pe = -1) : Z = !0, Ye(z, Pe - dt))) : (ue.sortIndex = Ze, n(b, ue), I || j || (I = !0, _e(Y))), ue;
    }, e.unstable_shouldYield = oe, e.unstable_wrapCallback = function(ue) {
      var Ae = A;
      return function() {
        var Pe = A;
        A = Ae;
        try {
          return ue.apply(this, arguments);
        } finally {
          A = Pe;
        }
      };
    };
  }(E9)), E9;
}
var M9 = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var j_;
function JH() {
  return j_ || (j_ = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var n = !1, a = 5;
      function i(Qe, at) {
        var Lt = Qe.length;
        Qe.push(at), m(Qe, at, Lt);
      }
      function h(Qe) {
        return Qe.length === 0 ? null : Qe[0];
      }
      function g(Qe) {
        if (Qe.length === 0)
          return null;
        var at = Qe[0], Lt = Qe.pop();
        return Lt !== at && (Qe[0] = Lt, S(Qe, Lt, 0)), at;
      }
      function m(Qe, at, Lt) {
        for (var Un = Lt; Un > 0; ) {
          var dr = Un - 1 >>> 1, ga = Qe[dr];
          if (b(ga, at) > 0)
            Qe[dr] = at, Qe[Un] = ga, Un = dr;
          else
            return;
        }
      }
      function S(Qe, at, Lt) {
        for (var Un = Lt, dr = Qe.length, ga = dr >>> 1; Un < ga; ) {
          var Nr = (Un + 1) * 2 - 1, Oa = Qe[Nr], br = Nr + 1, _r = Qe[br];
          if (b(Oa, at) < 0)
            br < dr && b(_r, Oa) < 0 ? (Qe[Un] = _r, Qe[br] = at, Un = br) : (Qe[Un] = Oa, Qe[Nr] = at, Un = Nr);
          else if (br < dr && b(_r, at) < 0)
            Qe[Un] = _r, Qe[br] = at, Un = br;
          else
            return;
        }
      }
      function b(Qe, at) {
        var Lt = Qe.sortIndex - at.sortIndex;
        return Lt !== 0 ? Lt : Qe.id - at.id;
      }
      var R = 1, D = 2, T = 3, A = 4, j = 5, I = typeof performance == "object" && typeof performance.now == "function";
      if (I) {
        var Z = performance;
        e.unstable_now = function() {
          return Z.now();
        };
      } else {
        var N = Date, B = N.now();
        e.unstable_now = function() {
          return N.now() - B;
        };
      }
      var $ = 1073741823, W = -1, z = 250, Y = 5e3, ie = 1e4, G = $, pe = [], J = [], me = 1, oe = null, ge = T, ce = !1, Se = !1, Re = !1, _e = typeof setTimeout == "function" ? setTimeout : null, Ye = typeof clearTimeout == "function" ? clearTimeout : null, ue = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function Ae(Qe) {
        for (var at = h(J); at !== null; ) {
          if (at.callback === null)
            g(J);
          else if (at.startTime <= Qe)
            g(J), at.sortIndex = at.expirationTime, i(pe, at);
          else
            return;
          at = h(J);
        }
      }
      function Pe(Qe) {
        if (Re = !1, Ae(Qe), !Se)
          if (h(pe) !== null)
            Se = !0, Ge(dt);
          else {
            var at = h(J);
            at !== null && $t(Pe, at.startTime - Qe);
          }
      }
      function dt(Qe, at) {
        Se = !1, Re && (Re = !1, Cn()), ce = !0;
        var Lt = ge;
        try {
          return Ze(Qe, at);
        } finally {
          oe = null, ge = Lt, ce = !1;
        }
      }
      function Ze(Qe, at) {
        var Lt = at;
        for (Ae(Lt), oe = h(pe); oe !== null && !n && !(oe.expirationTime > Lt && (!Qe || jr())); ) {
          var Un = oe.callback;
          if (typeof Un == "function") {
            oe.callback = null, ge = oe.priorityLevel;
            var dr = oe.expirationTime <= Lt, ga = Un(dr);
            Lt = e.unstable_now(), typeof ga == "function" ? oe.callback = ga : oe === h(pe) && g(pe), Ae(Lt);
          } else
            g(pe);
          oe = h(pe);
        }
        if (oe !== null)
          return !0;
        var Nr = h(J);
        return Nr !== null && $t(Pe, Nr.startTime - Lt), !1;
      }
      function qe(Qe, at) {
        switch (Qe) {
          case R:
          case D:
          case T:
          case A:
          case j:
            break;
          default:
            Qe = T;
        }
        var Lt = ge;
        ge = Qe;
        try {
          return at();
        } finally {
          ge = Lt;
        }
      }
      function Je(Qe) {
        var at;
        switch (ge) {
          case R:
          case D:
          case T:
            at = T;
            break;
          default:
            at = ge;
            break;
        }
        var Lt = ge;
        ge = at;
        try {
          return Qe();
        } finally {
          ge = Lt;
        }
      }
      function ot(Qe) {
        var at = ge;
        return function() {
          var Lt = ge;
          ge = at;
          try {
            return Qe.apply(this, arguments);
          } finally {
            ge = Lt;
          }
        };
      }
      function Nt(Qe, at, Lt) {
        var Un = e.unstable_now(), dr;
        if (typeof Lt == "object" && Lt !== null) {
          var ga = Lt.delay;
          typeof ga == "number" && ga > 0 ? dr = Un + ga : dr = Un;
        } else
          dr = Un;
        var Nr;
        switch (Qe) {
          case R:
            Nr = W;
            break;
          case D:
            Nr = z;
            break;
          case j:
            Nr = G;
            break;
          case A:
            Nr = ie;
            break;
          case T:
          default:
            Nr = Y;
            break;
        }
        var Oa = dr + Nr, br = {
          id: me++,
          callback: at,
          priorityLevel: Qe,
          startTime: dr,
          expirationTime: Oa,
          sortIndex: -1
        };
        return dr > Un ? (br.sortIndex = dr, i(J, br), h(pe) === null && br === h(J) && (Re ? Cn() : Re = !0, $t(Pe, dr - Un))) : (br.sortIndex = Oa, i(pe, br), !Se && !ce && (Se = !0, Ge(dt))), br;
      }
      function Tn() {
      }
      function Qt() {
        !Se && !ce && (Se = !0, Ge(dt));
      }
      function Hn() {
        return h(pe);
      }
      function ar(Qe) {
        Qe.callback = null;
      }
      function Wn() {
        return ge;
      }
      var zn = !1, qn = null, Gn = -1, wr = a, Ta = -1;
      function jr() {
        var Qe = e.unstable_now() - Ta;
        return !(Qe < wr);
      }
      function Mt() {
      }
      function fn(Qe) {
        if (Qe < 0 || Qe > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        Qe > 0 ? wr = Math.floor(1e3 / Qe) : wr = a;
      }
      var Sn = function() {
        if (qn !== null) {
          var Qe = e.unstable_now();
          Ta = Qe;
          var at = !0, Lt = !0;
          try {
            Lt = qn(at, Qe);
          } finally {
            Lt ? jt() : (zn = !1, qn = null);
          }
        } else
          zn = !1;
      }, jt;
      if (typeof ue == "function")
        jt = function() {
          ue(Sn);
        };
      else if (typeof MessageChannel < "u") {
        var On = new MessageChannel(), Gr = On.port2;
        On.port1.onmessage = Sn, jt = function() {
          Gr.postMessage(null);
        };
      } else
        jt = function() {
          _e(Sn, 0);
        };
      function Ge(Qe) {
        qn = Qe, zn || (zn = !0, jt());
      }
      function $t(Qe, at) {
        Gn = _e(function() {
          Qe(e.unstable_now());
        }, at);
      }
      function Cn() {
        Ye(Gn), Gn = -1;
      }
      var gn = Mt, cr = null;
      e.unstable_IdlePriority = j, e.unstable_ImmediatePriority = R, e.unstable_LowPriority = A, e.unstable_NormalPriority = T, e.unstable_Profiling = cr, e.unstable_UserBlockingPriority = D, e.unstable_cancelCallback = ar, e.unstable_continueExecution = Qt, e.unstable_forceFrameRate = fn, e.unstable_getCurrentPriorityLevel = Wn, e.unstable_getFirstCallbackNode = Hn, e.unstable_next = Je, e.unstable_pauseExecution = Tn, e.unstable_requestPaint = gn, e.unstable_runWithPriority = qe, e.unstable_scheduleCallback = Nt, e.unstable_shouldYield = jr, e.unstable_wrapCallback = ot, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(M9)), M9;
}
var k_;
function XE() {
  return k_ || (k_ = 1, process.env.NODE_ENV === "production" ? Jg.exports = XH() : Jg.exports = JH()), Jg.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var L_;
function eZ() {
  if (L_) return Ul;
  L_ = 1;
  var e = Ma, n = XE();
  function a(o) {
    for (var l = "https://reactjs.org/docs/error-decoder.html?invariant=" + o, v = 1; v < arguments.length; v++) l += "&args[]=" + encodeURIComponent(arguments[v]);
    return "Minified React error #" + o + "; visit " + l + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var i = /* @__PURE__ */ new Set(), h = {};
  function g(o, l) {
    m(o, l), m(o + "Capture", l);
  }
  function m(o, l) {
    for (h[o] = l, o = 0; o < l.length; o++) i.add(l[o]);
  }
  var S = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), b = Object.prototype.hasOwnProperty, R = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, D = {}, T = {};
  function A(o) {
    return b.call(T, o) ? !0 : b.call(D, o) ? !1 : R.test(o) ? T[o] = !0 : (D[o] = !0, !1);
  }
  function j(o, l, v, w) {
    if (v !== null && v.type === 0) return !1;
    switch (typeof l) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return w ? !1 : v !== null ? !v.acceptsBooleans : (o = o.toLowerCase().slice(0, 5), o !== "data-" && o !== "aria-");
      default:
        return !1;
    }
  }
  function I(o, l, v, w) {
    if (l === null || typeof l > "u" || j(o, l, v, w)) return !0;
    if (w) return !1;
    if (v !== null) switch (v.type) {
      case 3:
        return !l;
      case 4:
        return l === !1;
      case 5:
        return isNaN(l);
      case 6:
        return isNaN(l) || 1 > l;
    }
    return !1;
  }
  function Z(o, l, v, w, C, E, H) {
    this.acceptsBooleans = l === 2 || l === 3 || l === 4, this.attributeName = w, this.attributeNamespace = C, this.mustUseProperty = v, this.propertyName = o, this.type = l, this.sanitizeURL = E, this.removeEmptyString = H;
  }
  var N = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(o) {
    N[o] = new Z(o, 0, !1, o, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(o) {
    var l = o[0];
    N[l] = new Z(l, 1, !1, o[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(o) {
    N[o] = new Z(o, 2, !1, o.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(o) {
    N[o] = new Z(o, 2, !1, o, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(o) {
    N[o] = new Z(o, 3, !1, o.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(o) {
    N[o] = new Z(o, 3, !0, o, null, !1, !1);
  }), ["capture", "download"].forEach(function(o) {
    N[o] = new Z(o, 4, !1, o, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(o) {
    N[o] = new Z(o, 6, !1, o, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(o) {
    N[o] = new Z(o, 5, !1, o.toLowerCase(), null, !1, !1);
  });
  var B = /[\-:]([a-z])/g;
  function $(o) {
    return o[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(o) {
    var l = o.replace(
      B,
      $
    );
    N[l] = new Z(l, 1, !1, o, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(o) {
    var l = o.replace(B, $);
    N[l] = new Z(l, 1, !1, o, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(o) {
    var l = o.replace(B, $);
    N[l] = new Z(l, 1, !1, o, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(o) {
    N[o] = new Z(o, 1, !1, o.toLowerCase(), null, !1, !1);
  }), N.xlinkHref = new Z("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(o) {
    N[o] = new Z(o, 1, !1, o.toLowerCase(), null, !0, !0);
  });
  function W(o, l, v, w) {
    var C = N.hasOwnProperty(l) ? N[l] : null;
    (C !== null ? C.type !== 0 : w || !(2 < l.length) || l[0] !== "o" && l[0] !== "O" || l[1] !== "n" && l[1] !== "N") && (I(l, v, C, w) && (v = null), w || C === null ? A(l) && (v === null ? o.removeAttribute(l) : o.setAttribute(l, "" + v)) : C.mustUseProperty ? o[C.propertyName] = v === null ? C.type === 3 ? !1 : "" : v : (l = C.attributeName, w = C.attributeNamespace, v === null ? o.removeAttribute(l) : (C = C.type, v = C === 3 || C === 4 && v === !0 ? "" : "" + v, w ? o.setAttributeNS(w, l, v) : o.setAttribute(l, v))));
  }
  var z = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, Y = Symbol.for("react.element"), ie = Symbol.for("react.portal"), G = Symbol.for("react.fragment"), pe = Symbol.for("react.strict_mode"), J = Symbol.for("react.profiler"), me = Symbol.for("react.provider"), oe = Symbol.for("react.context"), ge = Symbol.for("react.forward_ref"), ce = Symbol.for("react.suspense"), Se = Symbol.for("react.suspense_list"), Re = Symbol.for("react.memo"), _e = Symbol.for("react.lazy"), Ye = Symbol.for("react.offscreen"), ue = Symbol.iterator;
  function Ae(o) {
    return o === null || typeof o != "object" ? null : (o = ue && o[ue] || o["@@iterator"], typeof o == "function" ? o : null);
  }
  var Pe = Object.assign, dt;
  function Ze(o) {
    if (dt === void 0) try {
      throw Error();
    } catch (v) {
      var l = v.stack.trim().match(/\n( *(at )?)/);
      dt = l && l[1] || "";
    }
    return `
` + dt + o;
  }
  var qe = !1;
  function Je(o, l) {
    if (!o || qe) return "";
    qe = !0;
    var v = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (l) if (l = function() {
        throw Error();
      }, Object.defineProperty(l.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(l, []);
        } catch (ye) {
          var w = ye;
        }
        Reflect.construct(o, [], l);
      } else {
        try {
          l.call();
        } catch (ye) {
          w = ye;
        }
        o.call(l.prototype);
      }
      else {
        try {
          throw Error();
        } catch (ye) {
          w = ye;
        }
        o();
      }
    } catch (ye) {
      if (ye && w && typeof ye.stack == "string") {
        for (var C = ye.stack.split(`
`), E = w.stack.split(`
`), H = C.length - 1, q = E.length - 1; 1 <= H && 0 <= q && C[H] !== E[q]; ) q--;
        for (; 1 <= H && 0 <= q; H--, q--) if (C[H] !== E[q]) {
          if (H !== 1 || q !== 1)
            do
              if (H--, q--, 0 > q || C[H] !== E[q]) {
                var ee = `
` + C[H].replace(" at new ", " at ");
                return o.displayName && ee.includes("<anonymous>") && (ee = ee.replace("<anonymous>", o.displayName)), ee;
              }
            while (1 <= H && 0 <= q);
          break;
        }
      }
    } finally {
      qe = !1, Error.prepareStackTrace = v;
    }
    return (o = o ? o.displayName || o.name : "") ? Ze(o) : "";
  }
  function ot(o) {
    switch (o.tag) {
      case 5:
        return Ze(o.type);
      case 16:
        return Ze("Lazy");
      case 13:
        return Ze("Suspense");
      case 19:
        return Ze("SuspenseList");
      case 0:
      case 2:
      case 15:
        return o = Je(o.type, !1), o;
      case 11:
        return o = Je(o.type.render, !1), o;
      case 1:
        return o = Je(o.type, !0), o;
      default:
        return "";
    }
  }
  function Nt(o) {
    if (o == null) return null;
    if (typeof o == "function") return o.displayName || o.name || null;
    if (typeof o == "string") return o;
    switch (o) {
      case G:
        return "Fragment";
      case ie:
        return "Portal";
      case J:
        return "Profiler";
      case pe:
        return "StrictMode";
      case ce:
        return "Suspense";
      case Se:
        return "SuspenseList";
    }
    if (typeof o == "object") switch (o.$$typeof) {
      case oe:
        return (o.displayName || "Context") + ".Consumer";
      case me:
        return (o._context.displayName || "Context") + ".Provider";
      case ge:
        var l = o.render;
        return o = o.displayName, o || (o = l.displayName || l.name || "", o = o !== "" ? "ForwardRef(" + o + ")" : "ForwardRef"), o;
      case Re:
        return l = o.displayName || null, l !== null ? l : Nt(o.type) || "Memo";
      case _e:
        l = o._payload, o = o._init;
        try {
          return Nt(o(l));
        } catch {
        }
    }
    return null;
  }
  function Tn(o) {
    var l = o.type;
    switch (o.tag) {
      case 24:
        return "Cache";
      case 9:
        return (l.displayName || "Context") + ".Consumer";
      case 10:
        return (l._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return o = l.render, o = o.displayName || o.name || "", l.displayName || (o !== "" ? "ForwardRef(" + o + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return l;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return Nt(l);
      case 8:
        return l === pe ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof l == "function") return l.displayName || l.name || null;
        if (typeof l == "string") return l;
    }
    return null;
  }
  function Qt(o) {
    switch (typeof o) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return o;
      case "object":
        return o;
      default:
        return "";
    }
  }
  function Hn(o) {
    var l = o.type;
    return (o = o.nodeName) && o.toLowerCase() === "input" && (l === "checkbox" || l === "radio");
  }
  function ar(o) {
    var l = Hn(o) ? "checked" : "value", v = Object.getOwnPropertyDescriptor(o.constructor.prototype, l), w = "" + o[l];
    if (!o.hasOwnProperty(l) && typeof v < "u" && typeof v.get == "function" && typeof v.set == "function") {
      var C = v.get, E = v.set;
      return Object.defineProperty(o, l, { configurable: !0, get: function() {
        return C.call(this);
      }, set: function(H) {
        w = "" + H, E.call(this, H);
      } }), Object.defineProperty(o, l, { enumerable: v.enumerable }), { getValue: function() {
        return w;
      }, setValue: function(H) {
        w = "" + H;
      }, stopTracking: function() {
        o._valueTracker = null, delete o[l];
      } };
    }
  }
  function Wn(o) {
    o._valueTracker || (o._valueTracker = ar(o));
  }
  function zn(o) {
    if (!o) return !1;
    var l = o._valueTracker;
    if (!l) return !0;
    var v = l.getValue(), w = "";
    return o && (w = Hn(o) ? o.checked ? "true" : "false" : o.value), o = w, o !== v ? (l.setValue(o), !0) : !1;
  }
  function qn(o) {
    if (o = o || (typeof document < "u" ? document : void 0), typeof o > "u") return null;
    try {
      return o.activeElement || o.body;
    } catch {
      return o.body;
    }
  }
  function Gn(o, l) {
    var v = l.checked;
    return Pe({}, l, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: v ?? o._wrapperState.initialChecked });
  }
  function wr(o, l) {
    var v = l.defaultValue == null ? "" : l.defaultValue, w = l.checked != null ? l.checked : l.defaultChecked;
    v = Qt(l.value != null ? l.value : v), o._wrapperState = { initialChecked: w, initialValue: v, controlled: l.type === "checkbox" || l.type === "radio" ? l.checked != null : l.value != null };
  }
  function Ta(o, l) {
    l = l.checked, l != null && W(o, "checked", l, !1);
  }
  function jr(o, l) {
    Ta(o, l);
    var v = Qt(l.value), w = l.type;
    if (v != null) w === "number" ? (v === 0 && o.value === "" || o.value != v) && (o.value = "" + v) : o.value !== "" + v && (o.value = "" + v);
    else if (w === "submit" || w === "reset") {
      o.removeAttribute("value");
      return;
    }
    l.hasOwnProperty("value") ? fn(o, l.type, v) : l.hasOwnProperty("defaultValue") && fn(o, l.type, Qt(l.defaultValue)), l.checked == null && l.defaultChecked != null && (o.defaultChecked = !!l.defaultChecked);
  }
  function Mt(o, l, v) {
    if (l.hasOwnProperty("value") || l.hasOwnProperty("defaultValue")) {
      var w = l.type;
      if (!(w !== "submit" && w !== "reset" || l.value !== void 0 && l.value !== null)) return;
      l = "" + o._wrapperState.initialValue, v || l === o.value || (o.value = l), o.defaultValue = l;
    }
    v = o.name, v !== "" && (o.name = ""), o.defaultChecked = !!o._wrapperState.initialChecked, v !== "" && (o.name = v);
  }
  function fn(o, l, v) {
    (l !== "number" || qn(o.ownerDocument) !== o) && (v == null ? o.defaultValue = "" + o._wrapperState.initialValue : o.defaultValue !== "" + v && (o.defaultValue = "" + v));
  }
  var Sn = Array.isArray;
  function jt(o, l, v, w) {
    if (o = o.options, l) {
      l = {};
      for (var C = 0; C < v.length; C++) l["$" + v[C]] = !0;
      for (v = 0; v < o.length; v++) C = l.hasOwnProperty("$" + o[v].value), o[v].selected !== C && (o[v].selected = C), C && w && (o[v].defaultSelected = !0);
    } else {
      for (v = "" + Qt(v), l = null, C = 0; C < o.length; C++) {
        if (o[C].value === v) {
          o[C].selected = !0, w && (o[C].defaultSelected = !0);
          return;
        }
        l !== null || o[C].disabled || (l = o[C]);
      }
      l !== null && (l.selected = !0);
    }
  }
  function On(o, l) {
    if (l.dangerouslySetInnerHTML != null) throw Error(a(91));
    return Pe({}, l, { value: void 0, defaultValue: void 0, children: "" + o._wrapperState.initialValue });
  }
  function Gr(o, l) {
    var v = l.value;
    if (v == null) {
      if (v = l.children, l = l.defaultValue, v != null) {
        if (l != null) throw Error(a(92));
        if (Sn(v)) {
          if (1 < v.length) throw Error(a(93));
          v = v[0];
        }
        l = v;
      }
      l == null && (l = ""), v = l;
    }
    o._wrapperState = { initialValue: Qt(v) };
  }
  function Ge(o, l) {
    var v = Qt(l.value), w = Qt(l.defaultValue);
    v != null && (v = "" + v, v !== o.value && (o.value = v), l.defaultValue == null && o.defaultValue !== v && (o.defaultValue = v)), w != null && (o.defaultValue = "" + w);
  }
  function $t(o) {
    var l = o.textContent;
    l === o._wrapperState.initialValue && l !== "" && l !== null && (o.value = l);
  }
  function Cn(o) {
    switch (o) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function gn(o, l) {
    return o == null || o === "http://www.w3.org/1999/xhtml" ? Cn(l) : o === "http://www.w3.org/2000/svg" && l === "foreignObject" ? "http://www.w3.org/1999/xhtml" : o;
  }
  var cr, Qe = function(o) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(l, v, w, C) {
      MSApp.execUnsafeLocalFunction(function() {
        return o(l, v, w, C);
      });
    } : o;
  }(function(o, l) {
    if (o.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in o) o.innerHTML = l;
    else {
      for (cr = cr || document.createElement("div"), cr.innerHTML = "<svg>" + l.valueOf().toString() + "</svg>", l = cr.firstChild; o.firstChild; ) o.removeChild(o.firstChild);
      for (; l.firstChild; ) o.appendChild(l.firstChild);
    }
  });
  function at(o, l) {
    if (l) {
      var v = o.firstChild;
      if (v && v === o.lastChild && v.nodeType === 3) {
        v.nodeValue = l;
        return;
      }
    }
    o.textContent = l;
  }
  var Lt = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, Un = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Lt).forEach(function(o) {
    Un.forEach(function(l) {
      l = l + o.charAt(0).toUpperCase() + o.substring(1), Lt[l] = Lt[o];
    });
  });
  function dr(o, l, v) {
    return l == null || typeof l == "boolean" || l === "" ? "" : v || typeof l != "number" || l === 0 || Lt.hasOwnProperty(o) && Lt[o] ? ("" + l).trim() : l + "px";
  }
  function ga(o, l) {
    o = o.style;
    for (var v in l) if (l.hasOwnProperty(v)) {
      var w = v.indexOf("--") === 0, C = dr(v, l[v], w);
      v === "float" && (v = "cssFloat"), w ? o.setProperty(v, C) : o[v] = C;
    }
  }
  var Nr = Pe({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function Oa(o, l) {
    if (l) {
      if (Nr[o] && (l.children != null || l.dangerouslySetInnerHTML != null)) throw Error(a(137, o));
      if (l.dangerouslySetInnerHTML != null) {
        if (l.children != null) throw Error(a(60));
        if (typeof l.dangerouslySetInnerHTML != "object" || !("__html" in l.dangerouslySetInnerHTML)) throw Error(a(61));
      }
      if (l.style != null && typeof l.style != "object") throw Error(a(62));
    }
  }
  function br(o, l) {
    if (o.indexOf("-") === -1) return typeof l.is == "string";
    switch (o) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var _r = null;
  function kr(o) {
    return o = o.target || o.srcElement || window, o.correspondingUseElement && (o = o.correspondingUseElement), o.nodeType === 3 ? o.parentNode : o;
  }
  var O1 = null, to = null, Jo = null;
  function D1(o) {
    if (o = Qr(o)) {
      if (typeof O1 != "function") throw Error(a(280));
      var l = o.stateNode;
      l && (l = un(l), O1(o.stateNode, o.type, l));
    }
  }
  function W0(o) {
    to ? Jo ? Jo.push(o) : Jo = [o] : to = o;
  }
  function z0() {
    if (to) {
      var o = to, l = Jo;
      if (Jo = to = null, D1(o), l) for (o = 0; o < l.length; o++) D1(l[o]);
    }
  }
  function A1(o, l) {
    return o(l);
  }
  function q0() {
  }
  var As = !1;
  function js(o, l, v) {
    if (As) return o(l, v);
    As = !0;
    try {
      return A1(o, l, v);
    } finally {
      As = !1, (to !== null || Jo !== null) && (q0(), z0());
    }
  }
  function _i(o, l) {
    var v = o.stateNode;
    if (v === null) return null;
    var w = un(v);
    if (w === null) return null;
    v = w[l];
    e: switch (l) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (w = !w.disabled) || (o = o.type, w = !(o === "button" || o === "input" || o === "select" || o === "textarea")), o = !w;
        break e;
      default:
        o = !1;
    }
    if (o) return null;
    if (v && typeof v != "function") throw Error(a(231, l, typeof v));
    return v;
  }
  var ei = !1;
  if (S) try {
    var ti = {};
    Object.defineProperty(ti, "passive", { get: function() {
      ei = !0;
    } }), window.addEventListener("test", ti, ti), window.removeEventListener("test", ti, ti);
  } catch {
    ei = !1;
  }
  function ku(o, l, v, w, C, E, H, q, ee) {
    var ye = Array.prototype.slice.call(arguments, 3);
    try {
      l.apply(v, ye);
    } catch (Be) {
      this.onError(Be);
    }
  }
  var ql = !1, Lu = null, Iu = !1, Cl = null, X = { onError: function(o) {
    ql = !0, Lu = o;
  } };
  function We(o, l, v, w, C, E, H, q, ee) {
    ql = !1, Lu = null, ku.apply(X, arguments);
  }
  function lt(o, l, v, w, C, E, H, q, ee) {
    if (We.apply(this, arguments), ql) {
      if (ql) {
        var ye = Lu;
        ql = !1, Lu = null;
      } else throw Error(a(198));
      Iu || (Iu = !0, Cl = ye);
    }
  }
  function vt(o) {
    var l = o, v = o;
    if (o.alternate) for (; l.return; ) l = l.return;
    else {
      o = l;
      do
        l = o, l.flags & 4098 && (v = l.return), o = l.return;
      while (o);
    }
    return l.tag === 3 ? v : null;
  }
  function bn(o) {
    if (o.tag === 13) {
      var l = o.memoizedState;
      if (l === null && (o = o.alternate, o !== null && (l = o.memoizedState)), l !== null) return l.dehydrated;
    }
    return null;
  }
  function Kn(o) {
    if (vt(o) !== o) throw Error(a(188));
  }
  function dn(o) {
    var l = o.alternate;
    if (!l) {
      if (l = vt(o), l === null) throw Error(a(188));
      return l !== o ? null : o;
    }
    for (var v = o, w = l; ; ) {
      var C = v.return;
      if (C === null) break;
      var E = C.alternate;
      if (E === null) {
        if (w = C.return, w !== null) {
          v = w;
          continue;
        }
        break;
      }
      if (C.child === E.child) {
        for (E = C.child; E; ) {
          if (E === v) return Kn(C), o;
          if (E === w) return Kn(C), l;
          E = E.sibling;
        }
        throw Error(a(188));
      }
      if (v.return !== w.return) v = C, w = E;
      else {
        for (var H = !1, q = C.child; q; ) {
          if (q === v) {
            H = !0, v = C, w = E;
            break;
          }
          if (q === w) {
            H = !0, w = C, v = E;
            break;
          }
          q = q.sibling;
        }
        if (!H) {
          for (q = E.child; q; ) {
            if (q === v) {
              H = !0, v = E, w = C;
              break;
            }
            if (q === w) {
              H = !0, w = E, v = C;
              break;
            }
            q = q.sibling;
          }
          if (!H) throw Error(a(189));
        }
      }
      if (v.alternate !== w) throw Error(a(190));
    }
    if (v.tag !== 3) throw Error(a(188));
    return v.stateNode.current === v ? o : l;
  }
  function ln(o) {
    return o = dn(o), o !== null ? Da(o) : null;
  }
  function Da(o) {
    if (o.tag === 5 || o.tag === 6) return o;
    for (o = o.child; o !== null; ) {
      var l = Da(o);
      if (l !== null) return l;
      o = o.sibling;
    }
    return null;
  }
  var Rr = n.unstable_scheduleCallback, Er = n.unstable_cancelCallback, Fa = n.unstable_shouldYield, Io = n.unstable_requestPaint, mt = n.unstable_now, la = n.unstable_getCurrentPriorityLevel, Hu = n.unstable_ImmediatePriority, G0 = n.unstable_UserBlockingPriority, Zu = n.unstable_NormalPriority, Sh = n.unstable_LowPriority, Rf = n.unstable_IdlePriority, K0 = null, Gi = null;
  function F2(o) {
    if (Gi && typeof Gi.onCommitFiberRoot == "function") try {
      Gi.onCommitFiberRoot(K0, o, void 0, (o.current.flags & 128) === 128);
    } catch {
    }
  }
  var Ki = Math.clz32 ? Math.clz32 : Mf, B2 = Math.log, Ef = Math.LN2;
  function Mf(o) {
    return o >>>= 0, o === 0 ? 32 : 31 - (B2(o) / Ef | 0) | 0;
  }
  var ni = 64, j1 = 4194304;
  function Gl(o) {
    switch (o & -o) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return o & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return o & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return o;
    }
  }
  function ks(o, l) {
    var v = o.pendingLanes;
    if (v === 0) return 0;
    var w = 0, C = o.suspendedLanes, E = o.pingedLanes, H = v & 268435455;
    if (H !== 0) {
      var q = H & ~C;
      q !== 0 ? w = Gl(q) : (E &= H, E !== 0 && (w = Gl(E)));
    } else H = v & ~C, H !== 0 ? w = Gl(H) : E !== 0 && (w = Gl(E));
    if (w === 0) return 0;
    if (l !== 0 && l !== w && !(l & C) && (C = w & -w, E = l & -l, C >= E || C === 16 && (E & 4194240) !== 0)) return l;
    if (w & 4 && (w |= v & 16), l = o.entangledLanes, l !== 0) for (o = o.entanglements, l &= w; 0 < l; ) v = 31 - Ki(l), C = 1 << v, w |= o[v], l &= ~C;
    return w;
  }
  function Tf(o, l) {
    switch (o) {
      case 1:
      case 2:
      case 4:
        return l + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return l + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Jp(o, l) {
    for (var v = o.suspendedLanes, w = o.pingedLanes, C = o.expirationTimes, E = o.pendingLanes; 0 < E; ) {
      var H = 31 - Ki(E), q = 1 << H, ee = C[H];
      ee === -1 ? (!(q & v) || q & w) && (C[H] = Tf(q, l)) : ee <= l && (o.expiredLanes |= q), E &= ~q;
    }
  }
  function k1(o) {
    return o = o.pendingLanes & -1073741825, o !== 0 ? o : o & 1073741824 ? 1073741824 : 0;
  }
  function Ch() {
    var o = ni;
    return ni <<= 1, !(ni & 4194240) && (ni = 64), o;
  }
  function Ls(o) {
    for (var l = [], v = 0; 31 > v; v++) l.push(o);
    return l;
  }
  function Q0(o, l, v) {
    o.pendingLanes |= l, l !== 536870912 && (o.suspendedLanes = 0, o.pingedLanes = 0), o = o.eventTimes, l = 31 - Ki(l), o[l] = v;
  }
  function bh(o, l) {
    var v = o.pendingLanes & ~l;
    o.pendingLanes = l, o.suspendedLanes = 0, o.pingedLanes = 0, o.expiredLanes &= l, o.mutableReadLanes &= l, o.entangledLanes &= l, l = o.entanglements;
    var w = o.eventTimes;
    for (o = o.expirationTimes; 0 < v; ) {
      var C = 31 - Ki(v), E = 1 << C;
      l[C] = 0, w[C] = -1, o[C] = -1, v &= ~E;
    }
  }
  function X0(o, l) {
    var v = o.entangledLanes |= l;
    for (o = o.entanglements; v; ) {
      var w = 31 - Ki(v), C = 1 << w;
      C & l | o[w] & l && (o[w] |= l), v &= ~C;
    }
  }
  var Zn = 0;
  function _n(o) {
    return o &= -o, 1 < o ? 4 < o ? o & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var _h, J0, tn, Of, vo, Pu = !1, Kl = [], Nu = null, Vr = null, or = null, L1 = /* @__PURE__ */ new Map(), Ho = /* @__PURE__ */ new Map(), wa = [], Vu = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function U2(o, l) {
    switch (o) {
      case "focusin":
      case "focusout":
        Nu = null;
        break;
      case "dragenter":
      case "dragleave":
        Vr = null;
        break;
      case "mouseover":
      case "mouseout":
        or = null;
        break;
      case "pointerover":
      case "pointerout":
        L1.delete(l.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Ho.delete(l.pointerId);
    }
  }
  function Ql(o, l, v, w, C, E) {
    return o === null || o.nativeEvent !== E ? (o = { blockedOn: l, domEventName: v, eventSystemFlags: w, nativeEvent: E, targetContainers: [C] }, l !== null && (l = Qr(l), l !== null && J0(l)), o) : (o.eventSystemFlags |= w, l = o.targetContainers, C !== null && l.indexOf(C) === -1 && l.push(C), o);
  }
  function Y2(o, l, v, w, C) {
    switch (l) {
      case "focusin":
        return Nu = Ql(Nu, o, l, v, w, C), !0;
      case "dragenter":
        return Vr = Ql(Vr, o, l, v, w, C), !0;
      case "mouseover":
        return or = Ql(or, o, l, v, w, C), !0;
      case "pointerover":
        var E = C.pointerId;
        return L1.set(E, Ql(L1.get(E) || null, o, l, v, w, C)), !0;
      case "gotpointercapture":
        return E = C.pointerId, Ho.set(E, Ql(Ho.get(E) || null, o, l, v, w, C)), !0;
    }
    return !1;
  }
  function Rh(o) {
    var l = Et(o.target);
    if (l !== null) {
      var v = vt(l);
      if (v !== null) {
        if (l = v.tag, l === 13) {
          if (l = bn(v), l !== null) {
            o.blockedOn = l, vo(o.priority, function() {
              tn(v);
            });
            return;
          }
        } else if (l === 3 && v.stateNode.current.memoizedState.isDehydrated) {
          o.blockedOn = v.tag === 3 ? v.stateNode.containerInfo : null;
          return;
        }
      }
    }
    o.blockedOn = null;
  }
  function Df(o) {
    if (o.blockedOn !== null) return !1;
    for (var l = o.targetContainers; 0 < l.length; ) {
      var v = I1(o.domEventName, o.eventSystemFlags, l[0], o.nativeEvent);
      if (v === null) {
        v = o.nativeEvent;
        var w = new v.constructor(v.type, v);
        _r = w, v.target.dispatchEvent(w), _r = null;
      } else return l = Qr(v), l !== null && J0(l), o.blockedOn = v, !1;
      l.shift();
    }
    return !0;
  }
  function $2(o, l, v) {
    Df(o) && v.delete(l);
  }
  function em() {
    Pu = !1, Nu !== null && Df(Nu) && (Nu = null), Vr !== null && Df(Vr) && (Vr = null), or !== null && Df(or) && (or = null), L1.forEach($2), Ho.forEach($2);
  }
  function Pn(o, l) {
    o.blockedOn === l && (o.blockedOn = null, Pu || (Pu = !0, n.unstable_scheduleCallback(n.unstable_NormalPriority, em)));
  }
  function Yn(o) {
    function l(C) {
      return Pn(C, o);
    }
    if (0 < Kl.length) {
      Pn(Kl[0], o);
      for (var v = 1; v < Kl.length; v++) {
        var w = Kl[v];
        w.blockedOn === o && (w.blockedOn = null);
      }
    }
    for (Nu !== null && Pn(Nu, o), Vr !== null && Pn(Vr, o), or !== null && Pn(or, o), L1.forEach(l), Ho.forEach(l), v = 0; v < wa.length; v++) w = wa[v], w.blockedOn === o && (w.blockedOn = null);
    for (; 0 < wa.length && (v = wa[0], v.blockedOn === null); ) Rh(v), v.blockedOn === null && wa.shift();
  }
  var Xl = z.ReactCurrentBatchConfig, ec = !0;
  function W2(o, l, v, w) {
    var C = Zn, E = Xl.transition;
    Xl.transition = null;
    try {
      Zn = 1, Af(o, l, v, w);
    } finally {
      Zn = C, Xl.transition = E;
    }
  }
  function z2(o, l, v, w) {
    var C = Zn, E = Xl.transition;
    Xl.transition = null;
    try {
      Zn = 4, Af(o, l, v, w);
    } finally {
      Zn = C, Xl.transition = E;
    }
  }
  function Af(o, l, v, w) {
    if (ec) {
      var C = I1(o, l, v, w);
      if (C === null) Uf(o, l, w, tc, v), U2(o, w);
      else if (Y2(C, o, l, v, w)) w.stopPropagation();
      else if (U2(o, w), l & 4 && -1 < Vu.indexOf(o)) {
        for (; C !== null; ) {
          var E = Qr(C);
          if (E !== null && _h(E), E = I1(o, l, v, w), E === null && Uf(o, l, w, tc, v), E === C) break;
          C = E;
        }
        C !== null && w.stopPropagation();
      } else Uf(o, l, w, null, v);
    }
  }
  var tc = null;
  function I1(o, l, v, w) {
    if (tc = null, o = kr(w), o = Et(o), o !== null) if (l = vt(o), l === null) o = null;
    else if (v = l.tag, v === 13) {
      if (o = bn(l), o !== null) return o;
      o = null;
    } else if (v === 3) {
      if (l.stateNode.current.memoizedState.isDehydrated) return l.tag === 3 ? l.stateNode.containerInfo : null;
      o = null;
    } else l !== o && (o = null);
    return tc = o, null;
  }
  function Eh(o) {
    switch (o) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (la()) {
          case Hu:
            return 1;
          case G0:
            return 4;
          case Zu:
          case Sh:
            return 16;
          case Rf:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var yr = null, Is = null, Qi = null;
  function Mh() {
    if (Qi) return Qi;
    var o, l = Is, v = l.length, w, C = "value" in yr ? yr.value : yr.textContent, E = C.length;
    for (o = 0; o < v && l[o] === C[o]; o++) ;
    var H = v - o;
    for (w = 1; w <= H && l[v - w] === C[E - w]; w++) ;
    return Qi = C.slice(o, 1 < w ? 1 - w : void 0);
  }
  function H1(o) {
    var l = o.keyCode;
    return "charCode" in o ? (o = o.charCode, o === 0 && l === 13 && (o = 13)) : o = l, o === 10 && (o = 13), 32 <= o || o === 13 ? o : 0;
  }
  function Ba() {
    return !0;
  }
  function jf() {
    return !1;
  }
  function po(o) {
    function l(v, w, C, E, H) {
      this._reactName = v, this._targetInst = C, this.type = w, this.nativeEvent = E, this.target = H, this.currentTarget = null;
      for (var q in o) o.hasOwnProperty(q) && (v = o[q], this[q] = v ? v(E) : E[q]);
      return this.isDefaultPrevented = (E.defaultPrevented != null ? E.defaultPrevented : E.returnValue === !1) ? Ba : jf, this.isPropagationStopped = jf, this;
    }
    return Pe(l.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var v = this.nativeEvent;
      v && (v.preventDefault ? v.preventDefault() : typeof v.returnValue != "unknown" && (v.returnValue = !1), this.isDefaultPrevented = Ba);
    }, stopPropagation: function() {
      var v = this.nativeEvent;
      v && (v.stopPropagation ? v.stopPropagation() : typeof v.cancelBubble != "unknown" && (v.cancelBubble = !0), this.isPropagationStopped = Ba);
    }, persist: function() {
    }, isPersistent: Ba }), l;
  }
  var Fu = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(o) {
    return o.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, nc = po(Fu), Z1 = Pe({}, Fu, { view: 0, detail: 0 }), q2 = po(Z1), er, rc, Ua, ac = Pe({}, Z1, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: ic, button: 0, buttons: 0, relatedTarget: function(o) {
    return o.relatedTarget === void 0 ? o.fromElement === o.srcElement ? o.toElement : o.fromElement : o.relatedTarget;
  }, movementX: function(o) {
    return "movementX" in o ? o.movementX : (o !== Ua && (Ua && o.type === "mousemove" ? (er = o.screenX - Ua.screenX, rc = o.screenY - Ua.screenY) : rc = er = 0, Ua = o), er);
  }, movementY: function(o) {
    return "movementY" in o ? o.movementY : rc;
  } }), Th = po(ac), ri = Pe({}, ac, { dataTransfer: 0 }), P1 = po(ri), kf = Pe({}, Z1, { relatedTarget: 0 }), hr = po(kf), Bu = Pe({}, Fu, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Oh = po(Bu), G2 = Pe({}, Fu, { clipboardData: function(o) {
    return "clipboardData" in o ? o.clipboardData : window.clipboardData;
  } }), oc = po(G2), K2 = Pe({}, Fu, { data: 0 }), Dh = po(K2), Q2 = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, X2 = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Ri = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function N1(o) {
    var l = this.nativeEvent;
    return l.getModifierState ? l.getModifierState(o) : (o = Ri[o]) ? !!l[o] : !1;
  }
  function ic() {
    return N1;
  }
  var Lf = Pe({}, Z1, { key: function(o) {
    if (o.key) {
      var l = Q2[o.key] || o.key;
      if (l !== "Unidentified") return l;
    }
    return o.type === "keypress" ? (o = H1(o), o === 13 ? "Enter" : String.fromCharCode(o)) : o.type === "keydown" || o.type === "keyup" ? X2[o.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: ic, charCode: function(o) {
    return o.type === "keypress" ? H1(o) : 0;
  }, keyCode: function(o) {
    return o.type === "keydown" || o.type === "keyup" ? o.keyCode : 0;
  }, which: function(o) {
    return o.type === "keypress" ? H1(o) : o.type === "keydown" || o.type === "keyup" ? o.keyCode : 0;
  } }), If = po(Lf), Ah = Pe({}, ac, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Hs = po(Ah), jh = Pe({}, Z1, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: ic }), Zo = po(jh), Xi = Pe({}, Fu, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Fr = po(Xi), Jl = Pe({}, ac, {
    deltaX: function(o) {
      return "deltaX" in o ? o.deltaX : "wheelDeltaX" in o ? -o.wheelDeltaX : 0;
    },
    deltaY: function(o) {
      return "deltaY" in o ? o.deltaY : "wheelDeltaY" in o ? -o.wheelDeltaY : "wheelDelta" in o ? -o.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Hf = po(Jl), no = [9, 13, 27, 32], lc = S && "CompositionEvent" in window, ai = null;
  S && "documentMode" in document && (ai = document.documentMode);
  var J2 = S && "TextEvent" in window && !ai, kh = S && (!lc || ai && 8 < ai && 11 >= ai), Zf = " ", ev = !1;
  function tv(o, l) {
    switch (o) {
      case "keyup":
        return no.indexOf(l.keyCode) !== -1;
      case "keydown":
        return l.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function nv(o) {
    return o = o.detail, typeof o == "object" && "data" in o ? o.data : null;
  }
  var Zs = !1;
  function V1(o, l) {
    switch (o) {
      case "compositionend":
        return nv(l);
      case "keypress":
        return l.which !== 32 ? null : (ev = !0, Zf);
      case "textInput":
        return o = l.data, o === Zf && ev ? null : o;
      default:
        return null;
    }
  }
  function tm(o, l) {
    if (Zs) return o === "compositionend" || !lc && tv(o, l) ? (o = Mh(), Qi = Is = yr = null, Zs = !1, o) : null;
    switch (o) {
      case "paste":
        return null;
      case "keypress":
        if (!(l.ctrlKey || l.altKey || l.metaKey) || l.ctrlKey && l.altKey) {
          if (l.char && 1 < l.char.length) return l.char;
          if (l.which) return String.fromCharCode(l.which);
        }
        return null;
      case "compositionend":
        return kh && l.locale !== "ko" ? null : l.data;
      default:
        return null;
    }
  }
  var nm = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function uc(o) {
    var l = o && o.nodeName && o.nodeName.toLowerCase();
    return l === "input" ? !!nm[o.type] : l === "textarea";
  }
  function Uu(o, l, v, w) {
    W0(w), l = F1(l, "onChange"), 0 < l.length && (v = new nc("onChange", "change", null, v, w), o.push({ event: v, listeners: l }));
  }
  var Po = null, eu = null;
  function rv(o) {
    Us(o, 0);
  }
  function Pf(o) {
    var l = Tt(o);
    if (zn(l)) return o;
  }
  function rm(o, l) {
    if (o === "change") return l;
  }
  var Ps = !1;
  if (S) {
    var oi;
    if (S) {
      var Nf = "oninput" in document;
      if (!Nf) {
        var av = document.createElement("div");
        av.setAttribute("oninput", "return;"), Nf = typeof av.oninput == "function";
      }
      oi = Nf;
    } else oi = !1;
    Ps = oi && (!document.documentMode || 9 < document.documentMode);
  }
  function ov() {
    Po && (Po.detachEvent("onpropertychange", iv), eu = Po = null);
  }
  function iv(o) {
    if (o.propertyName === "value" && Pf(eu)) {
      var l = [];
      Uu(l, eu, o, kr(o)), js(rv, l);
    }
  }
  function lv(o, l, v) {
    o === "focusin" ? (ov(), Po = l, eu = v, Po.attachEvent("onpropertychange", iv)) : o === "focusout" && ov();
  }
  function am(o) {
    if (o === "selectionchange" || o === "keyup" || o === "keydown") return Pf(eu);
  }
  function Ns(o, l) {
    if (o === "click") return Pf(l);
  }
  function le(o, l) {
    if (o === "input" || o === "change") return Pf(l);
  }
  function Ee(o, l) {
    return o === l && (o !== 0 || 1 / o === 1 / l) || o !== o && l !== l;
  }
  var we = typeof Object.is == "function" ? Object.is : Ee;
  function ut(o, l) {
    if (we(o, l)) return !0;
    if (typeof o != "object" || o === null || typeof l != "object" || l === null) return !1;
    var v = Object.keys(o), w = Object.keys(l);
    if (v.length !== w.length) return !1;
    for (w = 0; w < v.length; w++) {
      var C = v[w];
      if (!b.call(l, C) || !we(o[C], l[C])) return !1;
    }
    return !0;
  }
  function Gt(o) {
    for (; o && o.firstChild; ) o = o.firstChild;
    return o;
  }
  function cn(o, l) {
    var v = Gt(o);
    o = 0;
    for (var w; v; ) {
      if (v.nodeType === 3) {
        if (w = o + v.textContent.length, o <= l && w >= l) return { node: v, offset: l - o };
        o = w;
      }
      e: {
        for (; v; ) {
          if (v.nextSibling) {
            v = v.nextSibling;
            break e;
          }
          v = v.parentNode;
        }
        v = void 0;
      }
      v = Gt(v);
    }
  }
  function Lr(o, l) {
    return o && l ? o === l ? !0 : o && o.nodeType === 3 ? !1 : l && l.nodeType === 3 ? Lr(o, l.parentNode) : "contains" in o ? o.contains(l) : o.compareDocumentPosition ? !!(o.compareDocumentPosition(l) & 16) : !1 : !1;
  }
  function tr() {
    for (var o = window, l = qn(); l instanceof o.HTMLIFrameElement; ) {
      try {
        var v = typeof l.contentWindow.location.href == "string";
      } catch {
        v = !1;
      }
      if (v) o = l.contentWindow;
      else break;
      l = qn(o.document);
    }
    return l;
  }
  function bl(o) {
    var l = o && o.nodeName && o.nodeName.toLowerCase();
    return l && (l === "input" && (o.type === "text" || o.type === "search" || o.type === "tel" || o.type === "url" || o.type === "password") || l === "textarea" || o.contentEditable === "true");
  }
  function om(o) {
    var l = tr(), v = o.focusedElem, w = o.selectionRange;
    if (l !== v && v && v.ownerDocument && Lr(v.ownerDocument.documentElement, v)) {
      if (w !== null && bl(v)) {
        if (l = w.start, o = w.end, o === void 0 && (o = l), "selectionStart" in v) v.selectionStart = l, v.selectionEnd = Math.min(o, v.value.length);
        else if (o = (l = v.ownerDocument || document) && l.defaultView || window, o.getSelection) {
          o = o.getSelection();
          var C = v.textContent.length, E = Math.min(w.start, C);
          w = w.end === void 0 ? E : Math.min(w.end, C), !o.extend && E > w && (C = w, w = E, E = C), C = cn(v, E);
          var H = cn(
            v,
            w
          );
          C && H && (o.rangeCount !== 1 || o.anchorNode !== C.node || o.anchorOffset !== C.offset || o.focusNode !== H.node || o.focusOffset !== H.offset) && (l = l.createRange(), l.setStart(C.node, C.offset), o.removeAllRanges(), E > w ? (o.addRange(l), o.extend(H.node, H.offset)) : (l.setEnd(H.node, H.offset), o.addRange(l)));
        }
      }
      for (l = [], o = v; o = o.parentNode; ) o.nodeType === 1 && l.push({ element: o, left: o.scrollLeft, top: o.scrollTop });
      for (typeof v.focus == "function" && v.focus(), v = 0; v < l.length; v++) o = l[v], o.element.scrollLeft = o.left, o.element.scrollTop = o.top;
    }
  }
  var Ei = S && "documentMode" in document && 11 >= document.documentMode, tu = null, Lh = null, _l = null, Vs = !1;
  function sc(o, l, v) {
    var w = v.window === v ? v.document : v.nodeType === 9 ? v : v.ownerDocument;
    Vs || tu == null || tu !== qn(w) || (w = tu, "selectionStart" in w && bl(w) ? w = { start: w.selectionStart, end: w.selectionEnd } : (w = (w.ownerDocument && w.ownerDocument.defaultView || window).getSelection(), w = { anchorNode: w.anchorNode, anchorOffset: w.anchorOffset, focusNode: w.focusNode, focusOffset: w.focusOffset }), _l && ut(_l, w) || (_l = w, w = F1(Lh, "onSelect"), 0 < w.length && (l = new nc("onSelect", "select", null, l, v), o.push({ event: l, listeners: w }), l.target = tu)));
  }
  function Dn(o, l) {
    var v = {};
    return v[o.toLowerCase()] = l.toLowerCase(), v["Webkit" + o] = "webkit" + l, v["Moz" + o] = "moz" + l, v;
  }
  var ua = { animationend: Dn("Animation", "AnimationEnd"), animationiteration: Dn("Animation", "AnimationIteration"), animationstart: Dn("Animation", "AnimationStart"), transitionend: Dn("Transition", "TransitionEnd") }, cc = {}, fc = {};
  S && (fc = document.createElement("div").style, "AnimationEvent" in window || (delete ua.animationend.animation, delete ua.animationiteration.animation, delete ua.animationstart.animation), "TransitionEvent" in window || delete ua.transitionend.transition);
  function Vf(o) {
    if (cc[o]) return cc[o];
    if (!ua[o]) return o;
    var l = ua[o], v;
    for (v in l) if (l.hasOwnProperty(v) && v in fc) return cc[o] = l[v];
    return o;
  }
  var uv = Vf("animationend"), sv = Vf("animationiteration"), dc = Vf("animationstart"), Rl = Vf("transitionend"), Fs = /* @__PURE__ */ new Map(), Bs = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function Ji(o, l) {
    Fs.set(o, l), g(l, [o]);
  }
  for (var Yu = 0; Yu < Bs.length; Yu++) {
    var Ff = Bs[Yu], Bf = Ff.toLowerCase(), cv = Ff[0].toUpperCase() + Ff.slice(1);
    Ji(Bf, "on" + cv);
  }
  Ji(uv, "onAnimationEnd"), Ji(sv, "onAnimationIteration"), Ji(dc, "onAnimationStart"), Ji("dblclick", "onDoubleClick"), Ji("focusin", "onFocus"), Ji("focusout", "onBlur"), Ji(Rl, "onTransitionEnd"), m("onMouseEnter", ["mouseout", "mouseover"]), m("onMouseLeave", ["mouseout", "mouseover"]), m("onPointerEnter", ["pointerout", "pointerover"]), m("onPointerLeave", ["pointerout", "pointerover"]), g("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), g("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), g("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), g("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), g("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), g("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var el = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), nu = new Set("cancel close invalid load scroll toggle".split(" ").concat(el));
  function El(o, l, v) {
    var w = o.type || "unknown-event";
    o.currentTarget = v, lt(w, l, void 0, o), o.currentTarget = null;
  }
  function Us(o, l) {
    l = (l & 4) !== 0;
    for (var v = 0; v < o.length; v++) {
      var w = o[v], C = w.event;
      w = w.listeners;
      e: {
        var E = void 0;
        if (l) for (var H = w.length - 1; 0 <= H; H--) {
          var q = w[H], ee = q.instance, ye = q.currentTarget;
          if (q = q.listener, ee !== E && C.isPropagationStopped()) break e;
          El(C, q, ye), E = ee;
        }
        else for (H = 0; H < w.length; H++) {
          if (q = w[H], ee = q.instance, ye = q.currentTarget, q = q.listener, ee !== E && C.isPropagationStopped()) break e;
          El(C, q, ye), E = ee;
        }
      }
    }
    if (Iu) throw o = Cl, Iu = !1, Cl = null, o;
  }
  function vr(o, l) {
    var v = l[iu];
    v === void 0 && (v = l[iu] = /* @__PURE__ */ new Set());
    var w = o + "__bubble";
    v.has(w) || (hc(l, o, 2, !1), v.add(w));
  }
  function Ih(o, l, v) {
    var w = 0;
    l && (w |= 4), hc(v, o, w, l);
  }
  var $u = "_reactListening" + Math.random().toString(36).slice(2);
  function Wu(o) {
    if (!o[$u]) {
      o[$u] = !0, i.forEach(function(v) {
        v !== "selectionchange" && (nu.has(v) || Ih(v, !1, o), Ih(v, !0, o));
      });
      var l = o.nodeType === 9 ? o : o.ownerDocument;
      l === null || l[$u] || (l[$u] = !0, Ih("selectionchange", !1, l));
    }
  }
  function hc(o, l, v, w) {
    switch (Eh(l)) {
      case 1:
        var C = W2;
        break;
      case 4:
        C = z2;
        break;
      default:
        C = Af;
    }
    v = C.bind(null, l, v, o), C = void 0, !ei || l !== "touchstart" && l !== "touchmove" && l !== "wheel" || (C = !0), w ? C !== void 0 ? o.addEventListener(l, v, { capture: !0, passive: C }) : o.addEventListener(l, v, !0) : C !== void 0 ? o.addEventListener(l, v, { passive: C }) : o.addEventListener(l, v, !1);
  }
  function Uf(o, l, v, w, C) {
    var E = w;
    if (!(l & 1) && !(l & 2) && w !== null) e: for (; ; ) {
      if (w === null) return;
      var H = w.tag;
      if (H === 3 || H === 4) {
        var q = w.stateNode.containerInfo;
        if (q === C || q.nodeType === 8 && q.parentNode === C) break;
        if (H === 4) for (H = w.return; H !== null; ) {
          var ee = H.tag;
          if ((ee === 3 || ee === 4) && (ee = H.stateNode.containerInfo, ee === C || ee.nodeType === 8 && ee.parentNode === C)) return;
          H = H.return;
        }
        for (; q !== null; ) {
          if (H = Et(q), H === null) return;
          if (ee = H.tag, ee === 5 || ee === 6) {
            w = E = H;
            continue e;
          }
          q = q.parentNode;
        }
      }
      w = w.return;
    }
    js(function() {
      var ye = E, Be = kr(v), $e = [];
      e: {
        var Ne = Fs.get(o);
        if (Ne !== void 0) {
          var st = nc, yt = o;
          switch (o) {
            case "keypress":
              if (H1(v) === 0) break e;
            case "keydown":
            case "keyup":
              st = If;
              break;
            case "focusin":
              yt = "focus", st = hr;
              break;
            case "focusout":
              yt = "blur", st = hr;
              break;
            case "beforeblur":
            case "afterblur":
              st = hr;
              break;
            case "click":
              if (v.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              st = Th;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              st = P1;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              st = Zo;
              break;
            case uv:
            case sv:
            case dc:
              st = Oh;
              break;
            case Rl:
              st = Fr;
              break;
            case "scroll":
              st = q2;
              break;
            case "wheel":
              st = Hf;
              break;
            case "copy":
            case "cut":
            case "paste":
              st = oc;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              st = Hs;
          }
          var St = (l & 4) !== 0, ta = !St && o === "scroll", fe = St ? Ne !== null ? Ne + "Capture" : null : Ne;
          St = [];
          for (var ne = ye, de; ne !== null; ) {
            de = ne;
            var Fe = de.stateNode;
            if (de.tag === 5 && Fe !== null && (de = Fe, fe !== null && (Fe = _i(ne, fe), Fe != null && St.push(Ys(ne, Fe, de)))), ta) break;
            ne = ne.return;
          }
          0 < St.length && (Ne = new st(Ne, yt, null, v, Be), $e.push({ event: Ne, listeners: St }));
        }
      }
      if (!(l & 7)) {
        e: {
          if (Ne = o === "mouseover" || o === "pointerover", st = o === "mouseout" || o === "pointerout", Ne && v !== _r && (yt = v.relatedTarget || v.fromElement) && (Et(yt) || yt[mo])) break e;
          if ((st || Ne) && (Ne = Be.window === Be ? Be : (Ne = Be.ownerDocument) ? Ne.defaultView || Ne.parentWindow : window, st ? (yt = v.relatedTarget || v.toElement, st = ye, yt = yt ? Et(yt) : null, yt !== null && (ta = vt(yt), yt !== ta || yt.tag !== 5 && yt.tag !== 6) && (yt = null)) : (st = null, yt = ye), st !== yt)) {
            if (St = Th, Fe = "onMouseLeave", fe = "onMouseEnter", ne = "mouse", (o === "pointerout" || o === "pointerover") && (St = Hs, Fe = "onPointerLeave", fe = "onPointerEnter", ne = "pointer"), ta = st == null ? Ne : Tt(st), de = yt == null ? Ne : Tt(yt), Ne = new St(Fe, ne + "leave", st, v, Be), Ne.target = ta, Ne.relatedTarget = de, Fe = null, Et(Be) === ye && (St = new St(fe, ne + "enter", yt, v, Be), St.target = de, St.relatedTarget = ta, Fe = St), ta = Fe, st && yt) t: {
              for (St = st, fe = yt, ne = 0, de = St; de; de = B1(de)) ne++;
              for (de = 0, Fe = fe; Fe; Fe = B1(Fe)) de++;
              for (; 0 < ne - de; ) St = B1(St), ne--;
              for (; 0 < de - ne; ) fe = B1(fe), de--;
              for (; ne--; ) {
                if (St === fe || fe !== null && St === fe.alternate) break t;
                St = B1(St), fe = B1(fe);
              }
              St = null;
            }
            else St = null;
            st !== null && Kr($e, Ne, st, St, !1), yt !== null && ta !== null && Kr($e, ta, yt, St, !0);
          }
        }
        e: {
          if (Ne = ye ? Tt(ye) : window, st = Ne.nodeName && Ne.nodeName.toLowerCase(), st === "select" || st === "input" && Ne.type === "file") var xt = rm;
          else if (uc(Ne)) if (Ps) xt = le;
          else {
            xt = am;
            var Zt = lv;
          }
          else (st = Ne.nodeName) && st.toLowerCase() === "input" && (Ne.type === "checkbox" || Ne.type === "radio") && (xt = Ns);
          if (xt && (xt = xt(o, ye))) {
            Uu($e, xt, v, Be);
            break e;
          }
          Zt && Zt(o, Ne, ye), o === "focusout" && (Zt = Ne._wrapperState) && Zt.controlled && Ne.type === "number" && fn(Ne, "number", Ne.value);
        }
        switch (Zt = ye ? Tt(ye) : window, o) {
          case "focusin":
            (uc(Zt) || Zt.contentEditable === "true") && (tu = Zt, Lh = ye, _l = null);
            break;
          case "focusout":
            _l = Lh = tu = null;
            break;
          case "mousedown":
            Vs = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Vs = !1, sc($e, v, Be);
            break;
          case "selectionchange":
            if (Ei) break;
          case "keydown":
          case "keyup":
            sc($e, v, Be);
        }
        var It;
        if (lc) e: {
          switch (o) {
            case "compositionstart":
              var zt = "onCompositionStart";
              break e;
            case "compositionend":
              zt = "onCompositionEnd";
              break e;
            case "compositionupdate":
              zt = "onCompositionUpdate";
              break e;
          }
          zt = void 0;
        }
        else Zs ? tv(o, v) && (zt = "onCompositionEnd") : o === "keydown" && v.keyCode === 229 && (zt = "onCompositionStart");
        zt && (kh && v.locale !== "ko" && (Zs || zt !== "onCompositionStart" ? zt === "onCompositionEnd" && Zs && (It = Mh()) : (yr = Be, Is = "value" in yr ? yr.value : yr.textContent, Zs = !0)), Zt = F1(ye, zt), 0 < Zt.length && (zt = new Dh(zt, o, null, v, Be), $e.push({ event: zt, listeners: Zt }), It ? zt.data = It : (It = nv(v), It !== null && (zt.data = It)))), (It = J2 ? V1(o, v) : tm(o, v)) && (ye = F1(ye, "onBeforeInput"), 0 < ye.length && (Be = new Dh("onBeforeInput", "beforeinput", null, v, Be), $e.push({ event: Be, listeners: ye }), Be.data = It));
      }
      Us($e, l);
    });
  }
  function Ys(o, l, v) {
    return { instance: o, listener: l, currentTarget: v };
  }
  function F1(o, l) {
    for (var v = l + "Capture", w = []; o !== null; ) {
      var C = o, E = C.stateNode;
      C.tag === 5 && E !== null && (C = E, E = _i(o, v), E != null && w.unshift(Ys(o, E, C)), E = _i(o, l), E != null && w.push(Ys(o, E, C))), o = o.return;
    }
    return w;
  }
  function B1(o) {
    if (o === null) return null;
    do
      o = o.return;
    while (o && o.tag !== 5);
    return o || null;
  }
  function Kr(o, l, v, w, C) {
    for (var E = l._reactName, H = []; v !== null && v !== w; ) {
      var q = v, ee = q.alternate, ye = q.stateNode;
      if (ee !== null && ee === w) break;
      q.tag === 5 && ye !== null && (q = ye, C ? (ee = _i(v, E), ee != null && H.unshift(Ys(v, ee, q))) : C || (ee = _i(v, E), ee != null && H.push(Ys(v, ee, q)))), v = v.return;
    }
    H.length !== 0 && o.push({ event: l, listeners: H });
  }
  var ro = /\r\n?/g, im = /\u0000|\uFFFD/g;
  function fv(o) {
    return (typeof o == "string" ? o : "" + o).replace(ro, `
`).replace(im, "");
  }
  function ru(o, l, v) {
    if (l = fv(l), fv(o) !== l && v) throw Error(a(425));
  }
  function U1() {
  }
  var au = null, zu = null;
  function Y1(o, l) {
    return o === "textarea" || o === "noscript" || typeof l.children == "string" || typeof l.children == "number" || typeof l.dangerouslySetInnerHTML == "object" && l.dangerouslySetInnerHTML !== null && l.dangerouslySetInnerHTML.__html != null;
  }
  var Ml = typeof setTimeout == "function" ? setTimeout : void 0, vc = typeof clearTimeout == "function" ? clearTimeout : void 0, tl = typeof Promise == "function" ? Promise : void 0, $s = typeof queueMicrotask == "function" ? queueMicrotask : typeof tl < "u" ? function(o) {
    return tl.resolve(null).then(o).catch(ou);
  } : Ml;
  function ou(o) {
    setTimeout(function() {
      throw o;
    });
  }
  function pc(o, l) {
    var v = l, w = 0;
    do {
      var C = v.nextSibling;
      if (o.removeChild(v), C && C.nodeType === 8) if (v = C.data, v === "/$") {
        if (w === 0) {
          o.removeChild(C), Yn(l);
          return;
        }
        w--;
      } else v !== "$" && v !== "$?" && v !== "$!" || w++;
      v = C;
    } while (v);
    Yn(l);
  }
  function qu(o) {
    for (; o != null; o = o.nextSibling) {
      var l = o.nodeType;
      if (l === 1 || l === 3) break;
      if (l === 8) {
        if (l = o.data, l === "$" || l === "$!" || l === "$?") break;
        if (l === "/$") return null;
      }
    }
    return o;
  }
  function Yf(o) {
    o = o.previousSibling;
    for (var l = 0; o; ) {
      if (o.nodeType === 8) {
        var v = o.data;
        if (v === "$" || v === "$!" || v === "$?") {
          if (l === 0) return o;
          l--;
        } else v === "/$" && l++;
      }
      o = o.previousSibling;
    }
    return null;
  }
  var $1 = Math.random().toString(36).slice(2), Tl = "__reactFiber$" + $1, Gu = "__reactProps$" + $1, mo = "__reactContainer$" + $1, iu = "__reactEvents$" + $1, P = "__reactListeners$" + $1, W1 = "__reactHandles$" + $1;
  function Et(o) {
    var l = o[Tl];
    if (l) return l;
    for (var v = o.parentNode; v; ) {
      if (l = v[mo] || v[Tl]) {
        if (v = l.alternate, l.child !== null || v !== null && v.child !== null) for (o = Yf(o); o !== null; ) {
          if (v = o[Tl]) return v;
          o = Yf(o);
        }
        return l;
      }
      o = v, v = o.parentNode;
    }
    return null;
  }
  function Qr(o) {
    return o = o[Tl] || o[mo], !o || o.tag !== 5 && o.tag !== 6 && o.tag !== 13 && o.tag !== 3 ? null : o;
  }
  function Tt(o) {
    if (o.tag === 5 || o.tag === 6) return o.stateNode;
    throw Error(a(33));
  }
  function un(o) {
    return o[Gu] || null;
  }
  var lu = [], Ol = -1;
  function ao(o) {
    return { current: o };
  }
  function Dt(o) {
    0 > Ol || (o.current = lu[Ol], lu[Ol] = null, Ol--);
  }
  function Rn(o, l) {
    Ol++, lu[Ol] = o.current, o.current = l;
  }
  var go = {}, Br = ao(go), Mr = ao(!1), Ir = go;
  function Mi(o, l) {
    var v = o.type.contextTypes;
    if (!v) return go;
    var w = o.stateNode;
    if (w && w.__reactInternalMemoizedUnmaskedChildContext === l) return w.__reactInternalMemoizedMaskedChildContext;
    var C = {}, E;
    for (E in v) C[E] = l[E];
    return w && (o = o.stateNode, o.__reactInternalMemoizedUnmaskedChildContext = l, o.__reactInternalMemoizedMaskedChildContext = C), C;
  }
  function Ya(o) {
    return o = o.childContextTypes, o != null;
  }
  function $f() {
    Dt(Mr), Dt(Br);
  }
  function dv(o, l, v) {
    if (Br.current !== go) throw Error(a(168));
    Rn(Br, l), Rn(Mr, v);
  }
  function z1(o, l, v) {
    var w = o.stateNode;
    if (l = l.childContextTypes, typeof w.getChildContext != "function") return v;
    w = w.getChildContext();
    for (var C in w) if (!(C in l)) throw Error(a(108, Tn(o) || "Unknown", C));
    return Pe({}, v, w);
  }
  function pr(o) {
    return o = (o = o.stateNode) && o.__reactInternalMemoizedMergedChildContext || go, Ir = Br.current, Rn(Br, o), Rn(Mr, Mr.current), !0;
  }
  function Wf(o, l, v) {
    var w = o.stateNode;
    if (!w) throw Error(a(169));
    v ? (o = z1(o, l, Ir), w.__reactInternalMemoizedMergedChildContext = o, Dt(Mr), Dt(Br), Rn(Br, o)) : Dt(Mr), Rn(Mr, v);
  }
  var Dl = null, q1 = !1, uu = !1;
  function zf(o) {
    Dl === null ? Dl = [o] : Dl.push(o);
  }
  function wo(o) {
    q1 = !0, zf(o);
  }
  function nl() {
    if (!uu && Dl !== null) {
      uu = !0;
      var o = 0, l = Zn;
      try {
        var v = Dl;
        for (Zn = 1; o < v.length; o++) {
          var w = v[o];
          do
            w = w(!0);
          while (w !== null);
        }
        Dl = null, q1 = !1;
      } catch (C) {
        throw Dl !== null && (Dl = Dl.slice(o + 1)), Rr(Hu, nl), C;
      } finally {
        Zn = l, uu = !1;
      }
    }
    return null;
  }
  var Ku = [], Aa = 0, Qu = null, su = 0, sa = [], Ti = 0, ii = null, rl = 1, al = "";
  function Ws(o, l) {
    Ku[Aa++] = su, Ku[Aa++] = Qu, Qu = o, su = l;
  }
  function hv(o, l, v) {
    sa[Ti++] = rl, sa[Ti++] = al, sa[Ti++] = ii, ii = o;
    var w = rl;
    o = al;
    var C = 32 - Ki(w) - 1;
    w &= ~(1 << C), v += 1;
    var E = 32 - Ki(l) + C;
    if (30 < E) {
      var H = C - C % 5;
      E = (w & (1 << H) - 1).toString(32), w >>= H, C -= H, rl = 1 << 32 - Ki(l) + C | v << C | w, al = E + o;
    } else rl = 1 << E | v << C | w, al = o;
  }
  function G1(o) {
    o.return !== null && (Ws(o, 1), hv(o, 1, 0));
  }
  function Xu(o) {
    for (; o === Qu; ) Qu = Ku[--Aa], Ku[Aa] = null, su = Ku[--Aa], Ku[Aa] = null;
    for (; o === ii; ) ii = sa[--Ti], sa[Ti] = null, al = sa[--Ti], sa[Ti] = null, rl = sa[--Ti], sa[Ti] = null;
  }
  var $a = null, No = null, xr = !1, Oi = null;
  function ol(o, l) {
    var v = Ni(5, null, null, 0);
    v.elementType = "DELETED", v.stateNode = l, v.return = o, l = o.deletions, l === null ? (o.deletions = [v], o.flags |= 16) : l.push(v);
  }
  function qf(o, l) {
    switch (o.tag) {
      case 5:
        var v = o.type;
        return l = l.nodeType !== 1 || v.toLowerCase() !== l.nodeName.toLowerCase() ? null : l, l !== null ? (o.stateNode = l, $a = o, No = qu(l.firstChild), !0) : !1;
      case 6:
        return l = o.pendingProps === "" || l.nodeType !== 3 ? null : l, l !== null ? (o.stateNode = l, $a = o, No = null, !0) : !1;
      case 13:
        return l = l.nodeType !== 8 ? null : l, l !== null ? (v = ii !== null ? { id: rl, overflow: al } : null, o.memoizedState = { dehydrated: l, treeContext: v, retryLane: 1073741824 }, v = Ni(18, null, null, 0), v.stateNode = l, v.return = o, o.child = v, $a = o, No = null, !0) : !1;
      default:
        return !1;
    }
  }
  function cu(o) {
    return (o.mode & 1) !== 0 && (o.flags & 128) === 0;
  }
  function Vo(o) {
    if (xr) {
      var l = No;
      if (l) {
        var v = l;
        if (!qf(o, l)) {
          if (cu(o)) throw Error(a(418));
          l = qu(v.nextSibling);
          var w = $a;
          l && qf(o, l) ? ol(w, v) : (o.flags = o.flags & -4097 | 2, xr = !1, $a = o);
        }
      } else {
        if (cu(o)) throw Error(a(418));
        o.flags = o.flags & -4097 | 2, xr = !1, $a = o;
      }
    }
  }
  function ya(o) {
    for (o = o.return; o !== null && o.tag !== 5 && o.tag !== 3 && o.tag !== 13; ) o = o.return;
    $a = o;
  }
  function mc(o) {
    if (o !== $a) return !1;
    if (!xr) return ya(o), xr = !0, !1;
    var l;
    if ((l = o.tag !== 3) && !(l = o.tag !== 5) && (l = o.type, l = l !== "head" && l !== "body" && !Y1(o.type, o.memoizedProps)), l && (l = No)) {
      if (cu(o)) throw K1(), Error(a(418));
      for (; l; ) ol(o, l), l = qu(l.nextSibling);
    }
    if (ya(o), o.tag === 13) {
      if (o = o.memoizedState, o = o !== null ? o.dehydrated : null, !o) throw Error(a(317));
      e: {
        for (o = o.nextSibling, l = 0; o; ) {
          if (o.nodeType === 8) {
            var v = o.data;
            if (v === "/$") {
              if (l === 0) {
                No = qu(o.nextSibling);
                break e;
              }
              l--;
            } else v !== "$" && v !== "$!" && v !== "$?" || l++;
          }
          o = o.nextSibling;
        }
        No = null;
      }
    } else No = $a ? qu(o.stateNode.nextSibling) : null;
    return !0;
  }
  function K1() {
    for (var o = No; o; ) o = qu(o.nextSibling);
  }
  function Di() {
    No = $a = null, xr = !1;
  }
  function oo(o) {
    Oi === null ? Oi = [o] : Oi.push(o);
  }
  var vv = z.ReactCurrentBatchConfig;
  function zs(o, l, v) {
    if (o = v.ref, o !== null && typeof o != "function" && typeof o != "object") {
      if (v._owner) {
        if (v = v._owner, v) {
          if (v.tag !== 1) throw Error(a(309));
          var w = v.stateNode;
        }
        if (!w) throw Error(a(147, o));
        var C = w, E = "" + o;
        return l !== null && l.ref !== null && typeof l.ref == "function" && l.ref._stringRef === E ? l.ref : (l = function(H) {
          var q = C.refs;
          H === null ? delete q[E] : q[E] = H;
        }, l._stringRef = E, l);
      }
      if (typeof o != "string") throw Error(a(284));
      if (!v._owner) throw Error(a(290, o));
    }
    return o;
  }
  function qs(o, l) {
    throw o = Object.prototype.toString.call(l), Error(a(31, o === "[object Object]" ? "object with keys {" + Object.keys(l).join(", ") + "}" : o));
  }
  function pv(o) {
    var l = o._init;
    return l(o._payload);
  }
  function Ju(o) {
    function l(fe, ne) {
      if (o) {
        var de = fe.deletions;
        de === null ? (fe.deletions = [ne], fe.flags |= 16) : de.push(ne);
      }
    }
    function v(fe, ne) {
      if (!o) return null;
      for (; ne !== null; ) l(fe, ne), ne = ne.sibling;
      return null;
    }
    function w(fe, ne) {
      for (fe = /* @__PURE__ */ new Map(); ne !== null; ) ne.key !== null ? fe.set(ne.key, ne) : fe.set(ne.index, ne), ne = ne.sibling;
      return fe;
    }
    function C(fe, ne) {
      return fe = dl(fe, ne), fe.index = 0, fe.sibling = null, fe;
    }
    function E(fe, ne, de) {
      return fe.index = de, o ? (de = fe.alternate, de !== null ? (de = de.index, de < ne ? (fe.flags |= 2, ne) : de) : (fe.flags |= 2, ne)) : (fe.flags |= 1048576, ne);
    }
    function H(fe) {
      return o && fe.alternate === null && (fe.flags |= 2), fe;
    }
    function q(fe, ne, de, Fe) {
      return ne === null || ne.tag !== 6 ? (ne = Kh(de, fe.mode, Fe), ne.return = fe, ne) : (ne = C(ne, de), ne.return = fe, ne);
    }
    function ee(fe, ne, de, Fe) {
      var xt = de.type;
      return xt === G ? Be(fe, ne, de.props.children, Fe, de.key) : ne !== null && (ne.elementType === xt || typeof xt == "object" && xt !== null && xt.$$typeof === _e && pv(xt) === ne.type) ? (Fe = C(ne, de.props), Fe.ref = zs(fe, ne, de), Fe.return = fe, Fe) : (Fe = Bc(de.type, de.key, de.props, null, fe.mode, Fe), Fe.ref = zs(fe, ne, de), Fe.return = fe, Fe);
    }
    function ye(fe, ne, de, Fe) {
      return ne === null || ne.tag !== 4 || ne.stateNode.containerInfo !== de.containerInfo || ne.stateNode.implementation !== de.implementation ? (ne = wd(de, fe.mode, Fe), ne.return = fe, ne) : (ne = C(ne, de.children || []), ne.return = fe, ne);
    }
    function Be(fe, ne, de, Fe, xt) {
      return ne === null || ne.tag !== 7 ? (ne = bu(de, fe.mode, Fe, xt), ne.return = fe, ne) : (ne = C(ne, de), ne.return = fe, ne);
    }
    function $e(fe, ne, de) {
      if (typeof ne == "string" && ne !== "" || typeof ne == "number") return ne = Kh("" + ne, fe.mode, de), ne.return = fe, ne;
      if (typeof ne == "object" && ne !== null) {
        switch (ne.$$typeof) {
          case Y:
            return de = Bc(ne.type, ne.key, ne.props, null, fe.mode, de), de.ref = zs(fe, null, ne), de.return = fe, de;
          case ie:
            return ne = wd(ne, fe.mode, de), ne.return = fe, ne;
          case _e:
            var Fe = ne._init;
            return $e(fe, Fe(ne._payload), de);
        }
        if (Sn(ne) || Ae(ne)) return ne = bu(ne, fe.mode, de, null), ne.return = fe, ne;
        qs(fe, ne);
      }
      return null;
    }
    function Ne(fe, ne, de, Fe) {
      var xt = ne !== null ? ne.key : null;
      if (typeof de == "string" && de !== "" || typeof de == "number") return xt !== null ? null : q(fe, ne, "" + de, Fe);
      if (typeof de == "object" && de !== null) {
        switch (de.$$typeof) {
          case Y:
            return de.key === xt ? ee(fe, ne, de, Fe) : null;
          case ie:
            return de.key === xt ? ye(fe, ne, de, Fe) : null;
          case _e:
            return xt = de._init, Ne(
              fe,
              ne,
              xt(de._payload),
              Fe
            );
        }
        if (Sn(de) || Ae(de)) return xt !== null ? null : Be(fe, ne, de, Fe, null);
        qs(fe, de);
      }
      return null;
    }
    function st(fe, ne, de, Fe, xt) {
      if (typeof Fe == "string" && Fe !== "" || typeof Fe == "number") return fe = fe.get(de) || null, q(ne, fe, "" + Fe, xt);
      if (typeof Fe == "object" && Fe !== null) {
        switch (Fe.$$typeof) {
          case Y:
            return fe = fe.get(Fe.key === null ? de : Fe.key) || null, ee(ne, fe, Fe, xt);
          case ie:
            return fe = fe.get(Fe.key === null ? de : Fe.key) || null, ye(ne, fe, Fe, xt);
          case _e:
            var Zt = Fe._init;
            return st(fe, ne, de, Zt(Fe._payload), xt);
        }
        if (Sn(Fe) || Ae(Fe)) return fe = fe.get(de) || null, Be(ne, fe, Fe, xt, null);
        qs(ne, Fe);
      }
      return null;
    }
    function yt(fe, ne, de, Fe) {
      for (var xt = null, Zt = null, It = ne, zt = ne = 0, ja = null; It !== null && zt < de.length; zt++) {
        It.index > zt ? (ja = It, It = null) : ja = It.sibling;
        var Fn = Ne(fe, It, de[zt], Fe);
        if (Fn === null) {
          It === null && (It = ja);
          break;
        }
        o && It && Fn.alternate === null && l(fe, It), ne = E(Fn, ne, zt), Zt === null ? xt = Fn : Zt.sibling = Fn, Zt = Fn, It = ja;
      }
      if (zt === de.length) return v(fe, It), xr && Ws(fe, zt), xt;
      if (It === null) {
        for (; zt < de.length; zt++) It = $e(fe, de[zt], Fe), It !== null && (ne = E(It, ne, zt), Zt === null ? xt = It : Zt.sibling = It, Zt = It);
        return xr && Ws(fe, zt), xt;
      }
      for (It = w(fe, It); zt < de.length; zt++) ja = st(It, fe, zt, de[zt], Fe), ja !== null && (o && ja.alternate !== null && It.delete(ja.key === null ? zt : ja.key), ne = E(ja, ne, zt), Zt === null ? xt = ja : Zt.sibling = ja, Zt = ja);
      return o && It.forEach(function(ms) {
        return l(fe, ms);
      }), xr && Ws(fe, zt), xt;
    }
    function St(fe, ne, de, Fe) {
      var xt = Ae(de);
      if (typeof xt != "function") throw Error(a(150));
      if (de = xt.call(de), de == null) throw Error(a(151));
      for (var Zt = xt = null, It = ne, zt = ne = 0, ja = null, Fn = de.next(); It !== null && !Fn.done; zt++, Fn = de.next()) {
        It.index > zt ? (ja = It, It = null) : ja = It.sibling;
        var ms = Ne(fe, It, Fn.value, Fe);
        if (ms === null) {
          It === null && (It = ja);
          break;
        }
        o && It && ms.alternate === null && l(fe, It), ne = E(ms, ne, zt), Zt === null ? xt = ms : Zt.sibling = ms, Zt = ms, It = ja;
      }
      if (Fn.done) return v(
        fe,
        It
      ), xr && Ws(fe, zt), xt;
      if (It === null) {
        for (; !Fn.done; zt++, Fn = de.next()) Fn = $e(fe, Fn.value, Fe), Fn !== null && (ne = E(Fn, ne, zt), Zt === null ? xt = Fn : Zt.sibling = Fn, Zt = Fn);
        return xr && Ws(fe, zt), xt;
      }
      for (It = w(fe, It); !Fn.done; zt++, Fn = de.next()) Fn = st(It, fe, zt, Fn.value, Fe), Fn !== null && (o && Fn.alternate !== null && It.delete(Fn.key === null ? zt : Fn.key), ne = E(Fn, ne, zt), Zt === null ? xt = Fn : Zt.sibling = Fn, Zt = Fn);
      return o && It.forEach(function(Nv) {
        return l(fe, Nv);
      }), xr && Ws(fe, zt), xt;
    }
    function ta(fe, ne, de, Fe) {
      if (typeof de == "object" && de !== null && de.type === G && de.key === null && (de = de.props.children), typeof de == "object" && de !== null) {
        switch (de.$$typeof) {
          case Y:
            e: {
              for (var xt = de.key, Zt = ne; Zt !== null; ) {
                if (Zt.key === xt) {
                  if (xt = de.type, xt === G) {
                    if (Zt.tag === 7) {
                      v(fe, Zt.sibling), ne = C(Zt, de.props.children), ne.return = fe, fe = ne;
                      break e;
                    }
                  } else if (Zt.elementType === xt || typeof xt == "object" && xt !== null && xt.$$typeof === _e && pv(xt) === Zt.type) {
                    v(fe, Zt.sibling), ne = C(Zt, de.props), ne.ref = zs(fe, Zt, de), ne.return = fe, fe = ne;
                    break e;
                  }
                  v(fe, Zt);
                  break;
                } else l(fe, Zt);
                Zt = Zt.sibling;
              }
              de.type === G ? (ne = bu(de.props.children, fe.mode, Fe, de.key), ne.return = fe, fe = ne) : (Fe = Bc(de.type, de.key, de.props, null, fe.mode, Fe), Fe.ref = zs(fe, ne, de), Fe.return = fe, fe = Fe);
            }
            return H(fe);
          case ie:
            e: {
              for (Zt = de.key; ne !== null; ) {
                if (ne.key === Zt) if (ne.tag === 4 && ne.stateNode.containerInfo === de.containerInfo && ne.stateNode.implementation === de.implementation) {
                  v(fe, ne.sibling), ne = C(ne, de.children || []), ne.return = fe, fe = ne;
                  break e;
                } else {
                  v(fe, ne);
                  break;
                }
                else l(fe, ne);
                ne = ne.sibling;
              }
              ne = wd(de, fe.mode, Fe), ne.return = fe, fe = ne;
            }
            return H(fe);
          case _e:
            return Zt = de._init, ta(fe, ne, Zt(de._payload), Fe);
        }
        if (Sn(de)) return yt(fe, ne, de, Fe);
        if (Ae(de)) return St(fe, ne, de, Fe);
        qs(fe, de);
      }
      return typeof de == "string" && de !== "" || typeof de == "number" ? (de = "" + de, ne !== null && ne.tag === 6 ? (v(fe, ne.sibling), ne = C(ne, de), ne.return = fe, fe = ne) : (v(fe, ne), ne = Kh(de, fe.mode, Fe), ne.return = fe, fe = ne), H(fe)) : v(fe, ne);
    }
    return ta;
  }
  var hn = Ju(!0), et = Ju(!1), Fo = ao(null), Hr = null, es = null, Q1 = null;
  function fu() {
    Q1 = es = Hr = null;
  }
  function Gf(o) {
    var l = Fo.current;
    Dt(Fo), o._currentValue = l;
  }
  function Wa(o, l, v) {
    for (; o !== null; ) {
      var w = o.alternate;
      if ((o.childLanes & l) !== l ? (o.childLanes |= l, w !== null && (w.childLanes |= l)) : w !== null && (w.childLanes & l) !== l && (w.childLanes |= l), o === v) break;
      o = o.return;
    }
  }
  function Sr(o, l) {
    Hr = o, Q1 = es = null, o = o.dependencies, o !== null && o.firstContext !== null && (o.lanes & l && (Jr = !0), o.firstContext = null);
  }
  function Ai(o) {
    var l = o._currentValue;
    if (Q1 !== o) if (o = { context: o, memoizedValue: l, next: null }, es === null) {
      if (Hr === null) throw Error(a(308));
      es = o, Hr.dependencies = { lanes: 0, firstContext: o };
    } else es = es.next = o;
    return l;
  }
  var Gs = null;
  function Hh(o) {
    Gs === null ? Gs = [o] : Gs.push(o);
  }
  function gc(o, l, v, w) {
    var C = l.interleaved;
    return C === null ? (v.next = v, Hh(l)) : (v.next = C.next, C.next = v), l.interleaved = v, li(o, w);
  }
  function li(o, l) {
    o.lanes |= l;
    var v = o.alternate;
    for (v !== null && (v.lanes |= l), v = o, o = o.return; o !== null; ) o.childLanes |= l, v = o.alternate, v !== null && (v.childLanes |= l), v = o, o = o.return;
    return v.tag === 3 ? v.stateNode : null;
  }
  var za = !1;
  function Kf(o) {
    o.updateQueue = { baseState: o.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function mv(o, l) {
    o = o.updateQueue, l.updateQueue === o && (l.updateQueue = { baseState: o.baseState, firstBaseUpdate: o.firstBaseUpdate, lastBaseUpdate: o.lastBaseUpdate, shared: o.shared, effects: o.effects });
  }
  function du(o, l) {
    return { eventTime: o, lane: l, tag: 0, payload: null, callback: null, next: null };
  }
  function ji(o, l, v) {
    var w = o.updateQueue;
    if (w === null) return null;
    if (w = w.shared, wn & 2) {
      var C = w.pending;
      return C === null ? l.next = l : (l.next = C.next, C.next = l), w.pending = l, li(o, v);
    }
    return C = w.interleaved, C === null ? (l.next = l, Hh(w)) : (l.next = C.next, C.next = l), w.interleaved = l, li(o, v);
  }
  function Qf(o, l, v) {
    if (l = l.updateQueue, l !== null && (l = l.shared, (v & 4194240) !== 0)) {
      var w = l.lanes;
      w &= o.pendingLanes, v |= w, l.lanes = v, X0(o, v);
    }
  }
  function gv(o, l) {
    var v = o.updateQueue, w = o.alternate;
    if (w !== null && (w = w.updateQueue, v === w)) {
      var C = null, E = null;
      if (v = v.firstBaseUpdate, v !== null) {
        do {
          var H = { eventTime: v.eventTime, lane: v.lane, tag: v.tag, payload: v.payload, callback: v.callback, next: null };
          E === null ? C = E = H : E = E.next = H, v = v.next;
        } while (v !== null);
        E === null ? C = E = l : E = E.next = l;
      } else C = E = l;
      v = { baseState: w.baseState, firstBaseUpdate: C, lastBaseUpdate: E, shared: w.shared, effects: w.effects }, o.updateQueue = v;
      return;
    }
    o = v.lastBaseUpdate, o === null ? v.firstBaseUpdate = l : o.next = l, v.lastBaseUpdate = l;
  }
  function Ks(o, l, v, w) {
    var C = o.updateQueue;
    za = !1;
    var E = C.firstBaseUpdate, H = C.lastBaseUpdate, q = C.shared.pending;
    if (q !== null) {
      C.shared.pending = null;
      var ee = q, ye = ee.next;
      ee.next = null, H === null ? E = ye : H.next = ye, H = ee;
      var Be = o.alternate;
      Be !== null && (Be = Be.updateQueue, q = Be.lastBaseUpdate, q !== H && (q === null ? Be.firstBaseUpdate = ye : q.next = ye, Be.lastBaseUpdate = ee));
    }
    if (E !== null) {
      var $e = C.baseState;
      H = 0, Be = ye = ee = null, q = E;
      do {
        var Ne = q.lane, st = q.eventTime;
        if ((w & Ne) === Ne) {
          Be !== null && (Be = Be.next = {
            eventTime: st,
            lane: 0,
            tag: q.tag,
            payload: q.payload,
            callback: q.callback,
            next: null
          });
          e: {
            var yt = o, St = q;
            switch (Ne = l, st = v, St.tag) {
              case 1:
                if (yt = St.payload, typeof yt == "function") {
                  $e = yt.call(st, $e, Ne);
                  break e;
                }
                $e = yt;
                break e;
              case 3:
                yt.flags = yt.flags & -65537 | 128;
              case 0:
                if (yt = St.payload, Ne = typeof yt == "function" ? yt.call(st, $e, Ne) : yt, Ne == null) break e;
                $e = Pe({}, $e, Ne);
                break e;
              case 2:
                za = !0;
            }
          }
          q.callback !== null && q.lane !== 0 && (o.flags |= 64, Ne = C.effects, Ne === null ? C.effects = [q] : Ne.push(q));
        } else st = { eventTime: st, lane: Ne, tag: q.tag, payload: q.payload, callback: q.callback, next: null }, Be === null ? (ye = Be = st, ee = $e) : Be = Be.next = st, H |= Ne;
        if (q = q.next, q === null) {
          if (q = C.shared.pending, q === null) break;
          Ne = q, q = Ne.next, Ne.next = null, C.lastBaseUpdate = Ne, C.shared.pending = null;
        }
      } while (!0);
      if (Be === null && (ee = $e), C.baseState = ee, C.firstBaseUpdate = ye, C.lastBaseUpdate = Be, l = C.shared.interleaved, l !== null) {
        C = l;
        do
          H |= C.lane, C = C.next;
        while (C !== l);
      } else E === null && (C.shared.lanes = 0);
      cl |= H, o.lanes = H, o.memoizedState = $e;
    }
  }
  function Xf(o, l, v) {
    if (o = l.effects, l.effects = null, o !== null) for (l = 0; l < o.length; l++) {
      var w = o[l], C = w.callback;
      if (C !== null) {
        if (w.callback = null, w = v, typeof C != "function") throw Error(a(191, C));
        C.call(w);
      }
    }
  }
  var wc = {}, Al = ao(wc), yc = ao(wc), X1 = ao(wc);
  function hu(o) {
    if (o === wc) throw Error(a(174));
    return o;
  }
  function Zh(o, l) {
    switch (Rn(X1, l), Rn(yc, o), Rn(Al, wc), o = l.nodeType, o) {
      case 9:
      case 11:
        l = (l = l.documentElement) ? l.namespaceURI : gn(null, "");
        break;
      default:
        o = o === 8 ? l.parentNode : l, l = o.namespaceURI || null, o = o.tagName, l = gn(l, o);
    }
    Dt(Al), Rn(Al, l);
  }
  function vu() {
    Dt(Al), Dt(yc), Dt(X1);
  }
  function Ph(o) {
    hu(X1.current);
    var l = hu(Al.current), v = gn(l, o.type);
    l !== v && (Rn(yc, o), Rn(Al, v));
  }
  function xc(o) {
    yc.current === o && (Dt(Al), Dt(yc));
  }
  var Tr = ao(0);
  function Qs(o) {
    for (var l = o; l !== null; ) {
      if (l.tag === 13) {
        var v = l.memoizedState;
        if (v !== null && (v = v.dehydrated, v === null || v.data === "$?" || v.data === "$!")) return l;
      } else if (l.tag === 19 && l.memoizedProps.revealOrder !== void 0) {
        if (l.flags & 128) return l;
      } else if (l.child !== null) {
        l.child.return = l, l = l.child;
        continue;
      }
      if (l === o) break;
      for (; l.sibling === null; ) {
        if (l.return === null || l.return === o) return null;
        l = l.return;
      }
      l.sibling.return = l.return, l = l.sibling;
    }
    return null;
  }
  var Sc = [];
  function kt() {
    for (var o = 0; o < Sc.length; o++) Sc[o]._workInProgressVersionPrimary = null;
    Sc.length = 0;
  }
  var an = z.ReactCurrentDispatcher, Nn = z.ReactCurrentBatchConfig, nr = 0, Vn = null, Ur = null, xa = null, J1 = !1, Cc = !1, pu = 0, be = 0;
  function An() {
    throw Error(a(321));
  }
  function Wt(o, l) {
    if (l === null) return !1;
    for (var v = 0; v < l.length && v < o.length; v++) if (!we(o[v], l[v])) return !1;
    return !0;
  }
  function ki(o, l, v, w, C, E) {
    if (nr = E, Vn = l, l.memoizedState = null, l.updateQueue = null, l.lanes = 0, an.current = o === null || o.memoizedState === null ? rd : is, o = v(w, C), Cc) {
      E = 0;
      do {
        if (Cc = !1, pu = 0, 25 <= E) throw Error(a(301));
        E += 1, xa = Ur = null, l.updateQueue = null, an.current = mu, o = v(w, C);
      } while (Cc);
    }
    if (an.current = t1, l = Ur !== null && Ur.next !== null, nr = 0, xa = Ur = Vn = null, J1 = !1, l) throw Error(a(300));
    return o;
  }
  function Li() {
    var o = pu !== 0;
    return pu = 0, o;
  }
  function io() {
    var o = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return xa === null ? Vn.memoizedState = xa = o : xa = xa.next = o, xa;
  }
  function Xr() {
    if (Ur === null) {
      var o = Vn.alternate;
      o = o !== null ? o.memoizedState : null;
    } else o = Ur.next;
    var l = xa === null ? Vn.memoizedState : xa.next;
    if (l !== null) xa = l, Ur = o;
    else {
      if (o === null) throw Error(a(310));
      Ur = o, o = { memoizedState: Ur.memoizedState, baseState: Ur.baseState, baseQueue: Ur.baseQueue, queue: Ur.queue, next: null }, xa === null ? Vn.memoizedState = xa = o : xa = xa.next = o;
    }
    return xa;
  }
  function ca(o, l) {
    return typeof l == "function" ? l(o) : l;
  }
  function ts(o) {
    var l = Xr(), v = l.queue;
    if (v === null) throw Error(a(311));
    v.lastRenderedReducer = o;
    var w = Ur, C = w.baseQueue, E = v.pending;
    if (E !== null) {
      if (C !== null) {
        var H = C.next;
        C.next = E.next, E.next = H;
      }
      w.baseQueue = C = E, v.pending = null;
    }
    if (C !== null) {
      E = C.next, w = w.baseState;
      var q = H = null, ee = null, ye = E;
      do {
        var Be = ye.lane;
        if ((nr & Be) === Be) ee !== null && (ee = ee.next = { lane: 0, action: ye.action, hasEagerState: ye.hasEagerState, eagerState: ye.eagerState, next: null }), w = ye.hasEagerState ? ye.eagerState : o(w, ye.action);
        else {
          var $e = {
            lane: Be,
            action: ye.action,
            hasEagerState: ye.hasEagerState,
            eagerState: ye.eagerState,
            next: null
          };
          ee === null ? (q = ee = $e, H = w) : ee = ee.next = $e, Vn.lanes |= Be, cl |= Be;
        }
        ye = ye.next;
      } while (ye !== null && ye !== E);
      ee === null ? H = w : ee.next = q, we(w, l.memoizedState) || (Jr = !0), l.memoizedState = w, l.baseState = H, l.baseQueue = ee, v.lastRenderedState = w;
    }
    if (o = v.interleaved, o !== null) {
      C = o;
      do
        E = C.lane, Vn.lanes |= E, cl |= E, C = C.next;
      while (C !== o);
    } else C === null && (v.lanes = 0);
    return [l.memoizedState, v.dispatch];
  }
  function jl(o) {
    var l = Xr(), v = l.queue;
    if (v === null) throw Error(a(311));
    v.lastRenderedReducer = o;
    var w = v.dispatch, C = v.pending, E = l.memoizedState;
    if (C !== null) {
      v.pending = null;
      var H = C = C.next;
      do
        E = o(E, H.action), H = H.next;
      while (H !== C);
      we(E, l.memoizedState) || (Jr = !0), l.memoizedState = E, l.baseQueue === null && (l.baseState = E), v.lastRenderedState = E;
    }
    return [E, w];
  }
  function e0() {
  }
  function bc(o, l) {
    var v = Vn, w = Xr(), C = l(), E = !we(w.memoizedState, C);
    if (E && (w.memoizedState = C, Jr = !0), w = w.queue, Ii(il.bind(null, v, w, o), [o]), w.getSnapshot !== l || E || xa !== null && xa.memoizedState.tag & 1) {
      if (v.flags |= 2048, ns(9, lo.bind(null, v, w, C, l), void 0, null), ba === null) throw Error(a(349));
      nr & 30 || _c(v, l, C);
    }
    return C;
  }
  function _c(o, l, v) {
    o.flags |= 16384, o = { getSnapshot: l, value: v }, l = Vn.updateQueue, l === null ? (l = { lastEffect: null, stores: null }, Vn.updateQueue = l, l.stores = [o]) : (v = l.stores, v === null ? l.stores = [o] : v.push(o));
  }
  function lo(o, l, v, w) {
    l.value = v, l.getSnapshot = w, t0(l) && Rc(o);
  }
  function il(o, l, v) {
    return v(function() {
      t0(l) && Rc(o);
    });
  }
  function t0(o) {
    var l = o.getSnapshot;
    o = o.value;
    try {
      var v = l();
      return !we(o, v);
    } catch {
      return !0;
    }
  }
  function Rc(o) {
    var l = li(o, 1);
    l !== null && _o(l, o, 1, -1);
  }
  function Xs(o) {
    var l = io();
    return typeof o == "function" && (o = o()), l.memoizedState = l.baseState = o, o = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: ca, lastRenderedState: o }, l.queue = o, o = o.dispatch = os.bind(null, Vn, o), [l.memoizedState, o];
  }
  function ns(o, l, v, w) {
    return o = { tag: o, create: l, destroy: v, deps: w, next: null }, l = Vn.updateQueue, l === null ? (l = { lastEffect: null, stores: null }, Vn.updateQueue = l, l.lastEffect = o.next = o) : (v = l.lastEffect, v === null ? l.lastEffect = o.next = o : (w = v.next, v.next = o, o.next = w, l.lastEffect = o)), o;
  }
  function n0() {
    return Xr().memoizedState;
  }
  function Js(o, l, v, w) {
    var C = io();
    Vn.flags |= o, C.memoizedState = ns(1 | l, v, void 0, w === void 0 ? null : w);
  }
  function rs(o, l, v, w) {
    var C = Xr();
    w = w === void 0 ? null : w;
    var E = void 0;
    if (Ur !== null) {
      var H = Ur.memoizedState;
      if (E = H.destroy, w !== null && Wt(w, H.deps)) {
        C.memoizedState = ns(l, v, E, w);
        return;
      }
    }
    Vn.flags |= o, C.memoizedState = ns(1 | l, v, E, w);
  }
  function r0(o, l) {
    return Js(8390656, 8, o, l);
  }
  function Ii(o, l) {
    return rs(2048, 8, o, l);
  }
  function Jf(o, l) {
    return rs(4, 2, o, l);
  }
  function Hi(o, l) {
    return rs(4, 4, o, l);
  }
  function as(o, l) {
    if (typeof l == "function") return o = o(), l(o), function() {
      l(null);
    };
    if (l != null) return o = o(), l.current = o, function() {
      l.current = null;
    };
  }
  function Ec(o, l, v) {
    return v = v != null ? v.concat([o]) : null, rs(4, 4, as.bind(null, l, o), v);
  }
  function e1() {
  }
  function ed(o, l) {
    var v = Xr();
    l = l === void 0 ? null : l;
    var w = v.memoizedState;
    return w !== null && l !== null && Wt(l, w[1]) ? w[0] : (v.memoizedState = [o, l], o);
  }
  function td(o, l) {
    var v = Xr();
    l = l === void 0 ? null : l;
    var w = v.memoizedState;
    return w !== null && l !== null && Wt(l, w[1]) ? w[0] : (o = o(), v.memoizedState = [o, l], o);
  }
  function Nh(o, l, v) {
    return nr & 21 ? (we(v, l) || (v = Ch(), Vn.lanes |= v, cl |= v, o.baseState = !0), l) : (o.baseState && (o.baseState = !1, Jr = !0), o.memoizedState = v);
  }
  function a0(o, l) {
    var v = Zn;
    Zn = v !== 0 && 4 > v ? v : 4, o(!0);
    var w = Nn.transition;
    Nn.transition = {};
    try {
      o(!1), l();
    } finally {
      Zn = v, Nn.transition = w;
    }
  }
  function nd() {
    return Xr().memoizedState;
  }
  function Mc(o, l, v) {
    var w = Hl(o);
    if (v = { lane: w, action: v, hasEagerState: !1, eagerState: null, next: null }, yo(o)) xo(l, v);
    else if (v = gc(o, l, v, w), v !== null) {
      var C = ha();
      _o(v, o, w, C), mn(v, l, w);
    }
  }
  function os(o, l, v) {
    var w = Hl(o), C = { lane: w, action: v, hasEagerState: !1, eagerState: null, next: null };
    if (yo(o)) xo(l, C);
    else {
      var E = o.alternate;
      if (o.lanes === 0 && (E === null || E.lanes === 0) && (E = l.lastRenderedReducer, E !== null)) try {
        var H = l.lastRenderedState, q = E(H, v);
        if (C.hasEagerState = !0, C.eagerState = q, we(q, H)) {
          var ee = l.interleaved;
          ee === null ? (C.next = C, Hh(l)) : (C.next = ee.next, ee.next = C), l.interleaved = C;
          return;
        }
      } catch {
      } finally {
      }
      v = gc(o, l, C, w), v !== null && (C = ha(), _o(v, o, w, C), mn(v, l, w));
    }
  }
  function yo(o) {
    var l = o.alternate;
    return o === Vn || l !== null && l === Vn;
  }
  function xo(o, l) {
    Cc = J1 = !0;
    var v = o.pending;
    v === null ? l.next = l : (l.next = v.next, v.next = l), o.pending = l;
  }
  function mn(o, l, v) {
    if (v & 4194240) {
      var w = l.lanes;
      w &= o.pendingLanes, v |= w, l.lanes = v, X0(o, v);
    }
  }
  var t1 = { readContext: Ai, useCallback: An, useContext: An, useEffect: An, useImperativeHandle: An, useInsertionEffect: An, useLayoutEffect: An, useMemo: An, useReducer: An, useRef: An, useState: An, useDebugValue: An, useDeferredValue: An, useTransition: An, useMutableSource: An, useSyncExternalStore: An, useId: An, unstable_isNewReconciler: !1 }, rd = { readContext: Ai, useCallback: function(o, l) {
    return io().memoizedState = [o, l === void 0 ? null : l], o;
  }, useContext: Ai, useEffect: r0, useImperativeHandle: function(o, l, v) {
    return v = v != null ? v.concat([o]) : null, Js(
      4194308,
      4,
      as.bind(null, l, o),
      v
    );
  }, useLayoutEffect: function(o, l) {
    return Js(4194308, 4, o, l);
  }, useInsertionEffect: function(o, l) {
    return Js(4, 2, o, l);
  }, useMemo: function(o, l) {
    var v = io();
    return l = l === void 0 ? null : l, o = o(), v.memoizedState = [o, l], o;
  }, useReducer: function(o, l, v) {
    var w = io();
    return l = v !== void 0 ? v(l) : l, w.memoizedState = w.baseState = l, o = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: o, lastRenderedState: l }, w.queue = o, o = o.dispatch = Mc.bind(null, Vn, o), [w.memoizedState, o];
  }, useRef: function(o) {
    var l = io();
    return o = { current: o }, l.memoizedState = o;
  }, useState: Xs, useDebugValue: e1, useDeferredValue: function(o) {
    return io().memoizedState = o;
  }, useTransition: function() {
    var o = Xs(!1), l = o[0];
    return o = a0.bind(null, o[1]), io().memoizedState = o, [l, o];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(o, l, v) {
    var w = Vn, C = io();
    if (xr) {
      if (v === void 0) throw Error(a(407));
      v = v();
    } else {
      if (v = l(), ba === null) throw Error(a(349));
      nr & 30 || _c(w, l, v);
    }
    C.memoizedState = v;
    var E = { value: v, getSnapshot: l };
    return C.queue = E, r0(il.bind(
      null,
      w,
      E,
      o
    ), [o]), w.flags |= 2048, ns(9, lo.bind(null, w, E, v, l), void 0, null), v;
  }, useId: function() {
    var o = io(), l = ba.identifierPrefix;
    if (xr) {
      var v = al, w = rl;
      v = (w & ~(1 << 32 - Ki(w) - 1)).toString(32) + v, l = ":" + l + "R" + v, v = pu++, 0 < v && (l += "H" + v.toString(32)), l += ":";
    } else v = be++, l = ":" + l + "r" + v.toString(32) + ":";
    return o.memoizedState = l;
  }, unstable_isNewReconciler: !1 }, is = {
    readContext: Ai,
    useCallback: ed,
    useContext: Ai,
    useEffect: Ii,
    useImperativeHandle: Ec,
    useInsertionEffect: Jf,
    useLayoutEffect: Hi,
    useMemo: td,
    useReducer: ts,
    useRef: n0,
    useState: function() {
      return ts(ca);
    },
    useDebugValue: e1,
    useDeferredValue: function(o) {
      var l = Xr();
      return Nh(l, Ur.memoizedState, o);
    },
    useTransition: function() {
      var o = ts(ca)[0], l = Xr().memoizedState;
      return [o, l];
    },
    useMutableSource: e0,
    useSyncExternalStore: bc,
    useId: nd,
    unstable_isNewReconciler: !1
  }, mu = { readContext: Ai, useCallback: ed, useContext: Ai, useEffect: Ii, useImperativeHandle: Ec, useInsertionEffect: Jf, useLayoutEffect: Hi, useMemo: td, useReducer: jl, useRef: n0, useState: function() {
    return jl(ca);
  }, useDebugValue: e1, useDeferredValue: function(o) {
    var l = Xr();
    return Ur === null ? l.memoizedState = o : Nh(l, Ur.memoizedState, o);
  }, useTransition: function() {
    var o = jl(ca)[0], l = Xr().memoizedState;
    return [o, l];
  }, useMutableSource: e0, useSyncExternalStore: bc, useId: nd, unstable_isNewReconciler: !1 };
  function Zi(o, l) {
    if (o && o.defaultProps) {
      l = Pe({}, l), o = o.defaultProps;
      for (var v in o) l[v] === void 0 && (l[v] = o[v]);
      return l;
    }
    return l;
  }
  function ad(o, l, v, w) {
    l = o.memoizedState, v = v(w, l), v = v == null ? l : Pe({}, l, v), o.memoizedState = v, o.lanes === 0 && (o.updateQueue.baseState = v);
  }
  var od = { isMounted: function(o) {
    return (o = o._reactInternals) ? vt(o) === o : !1;
  }, enqueueSetState: function(o, l, v) {
    o = o._reactInternals;
    var w = ha(), C = Hl(o), E = du(w, C);
    E.payload = l, v != null && (E.callback = v), l = ji(o, E, C), l !== null && (_o(l, o, C, w), Qf(l, o, C));
  }, enqueueReplaceState: function(o, l, v) {
    o = o._reactInternals;
    var w = ha(), C = Hl(o), E = du(w, C);
    E.tag = 1, E.payload = l, v != null && (E.callback = v), l = ji(o, E, C), l !== null && (_o(l, o, C, w), Qf(l, o, C));
  }, enqueueForceUpdate: function(o, l) {
    o = o._reactInternals;
    var v = ha(), w = Hl(o), C = du(v, w);
    C.tag = 2, l != null && (C.callback = l), l = ji(o, C, w), l !== null && (_o(l, o, w, v), Qf(l, o, w));
  } };
  function Vh(o, l, v, w, C, E, H) {
    return o = o.stateNode, typeof o.shouldComponentUpdate == "function" ? o.shouldComponentUpdate(w, E, H) : l.prototype && l.prototype.isPureReactComponent ? !ut(v, w) || !ut(C, E) : !0;
  }
  function gu(o, l, v) {
    var w = !1, C = go, E = l.contextType;
    return typeof E == "object" && E !== null ? E = Ai(E) : (C = Ya(l) ? Ir : Br.current, w = l.contextTypes, E = (w = w != null) ? Mi(o, C) : go), l = new l(v, E), o.memoizedState = l.state !== null && l.state !== void 0 ? l.state : null, l.updater = od, o.stateNode = l, l._reactInternals = o, w && (o = o.stateNode, o.__reactInternalMemoizedUnmaskedChildContext = C, o.__reactInternalMemoizedMaskedChildContext = E), l;
  }
  function o0(o, l, v, w) {
    o = l.state, typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps(v, w), typeof l.UNSAFE_componentWillReceiveProps == "function" && l.UNSAFE_componentWillReceiveProps(v, w), l.state !== o && od.enqueueReplaceState(l, l.state, null);
  }
  function Tc(o, l, v, w) {
    var C = o.stateNode;
    C.props = v, C.state = o.memoizedState, C.refs = {}, Kf(o);
    var E = l.contextType;
    typeof E == "object" && E !== null ? C.context = Ai(E) : (E = Ya(l) ? Ir : Br.current, C.context = Mi(o, E)), C.state = o.memoizedState, E = l.getDerivedStateFromProps, typeof E == "function" && (ad(o, l, E, v), C.state = o.memoizedState), typeof l.getDerivedStateFromProps == "function" || typeof C.getSnapshotBeforeUpdate == "function" || typeof C.UNSAFE_componentWillMount != "function" && typeof C.componentWillMount != "function" || (l = C.state, typeof C.componentWillMount == "function" && C.componentWillMount(), typeof C.UNSAFE_componentWillMount == "function" && C.UNSAFE_componentWillMount(), l !== C.state && od.enqueueReplaceState(C, C.state, null), Ks(o, v, C, w), C.state = o.memoizedState), typeof C.componentDidMount == "function" && (o.flags |= 4194308);
  }
  function ls(o, l) {
    try {
      var v = "", w = l;
      do
        v += ot(w), w = w.return;
      while (w);
      var C = v;
    } catch (E) {
      C = `
Error generating stack: ` + E.message + `
` + E.stack;
    }
    return { value: o, source: l, stack: C, digest: null };
  }
  function id(o, l, v) {
    return { value: o, source: null, stack: v ?? null, digest: l ?? null };
  }
  function i0(o, l) {
    try {
      console.error(l.value);
    } catch (v) {
      setTimeout(function() {
        throw v;
      });
    }
  }
  var Oc = typeof WeakMap == "function" ? WeakMap : Map;
  function Dc(o, l, v) {
    v = du(-1, v), v.tag = 3, v.payload = { element: null };
    var w = l.value;
    return v.callback = function() {
      x0 || (x0 = !0, o1 = w), i0(o, l);
    }, v;
  }
  function Ac(o, l, v) {
    v = du(-1, v), v.tag = 3;
    var w = o.type.getDerivedStateFromError;
    if (typeof w == "function") {
      var C = l.value;
      v.payload = function() {
        return w(C);
      }, v.callback = function() {
        i0(o, l);
      };
    }
    var E = o.stateNode;
    return E !== null && typeof E.componentDidCatch == "function" && (v.callback = function() {
      i0(o, l), typeof w != "function" && (fs === null ? fs = /* @__PURE__ */ new Set([this]) : fs.add(this));
      var H = l.stack;
      this.componentDidCatch(l.value, { componentStack: H !== null ? H : "" });
    }), v;
  }
  function l0(o, l, v) {
    var w = o.pingCache;
    if (w === null) {
      w = o.pingCache = new Oc();
      var C = /* @__PURE__ */ new Set();
      w.set(l, C);
    } else C = w.get(l), C === void 0 && (C = /* @__PURE__ */ new Set(), w.set(l, C));
    C.has(v) || (C.add(v), o = cm.bind(null, o, l, v), l.then(o, o));
  }
  function wv(o) {
    do {
      var l;
      if ((l = o.tag === 13) && (l = o.memoizedState, l = l !== null ? l.dehydrated !== null : !0), l) return o;
      o = o.return;
    } while (o !== null);
    return null;
  }
  function wu(o, l, v, w, C) {
    return o.mode & 1 ? (o.flags |= 65536, o.lanes = C, o) : (o === l ? o.flags |= 65536 : (o.flags |= 128, v.flags |= 131072, v.flags &= -52805, v.tag === 1 && (v.alternate === null ? v.tag = 17 : (l = du(-1, 1), l.tag = 2, ji(v, l, 1))), v.lanes |= 1), o);
  }
  var us = z.ReactCurrentOwner, Jr = !1;
  function Sa(o, l, v, w) {
    l.child = o === null ? et(l, null, v, w) : hn(l, o.child, v, w);
  }
  function Bo(o, l, v, w, C) {
    v = v.render;
    var E = l.ref;
    return Sr(l, C), w = ki(o, l, v, w, E, C), v = Li(), o !== null && !Jr ? (l.updateQueue = o.updateQueue, l.flags &= -2053, o.lanes &= ~C, Uo(o, l, C)) : (xr && v && G1(l), l.flags |= 1, Sa(o, l, w, C), l.child);
  }
  function ss(o, l, v, w, C) {
    if (o === null) {
      var E = v.type;
      return typeof E == "function" && !gd(E) && E.defaultProps === void 0 && v.compare === null && v.defaultProps === void 0 ? (l.tag = 15, l.type = E, Bt(o, l, E, w, C)) : (o = Bc(v.type, null, w, l, l.mode, C), o.ref = l.ref, o.return = l, l.child = o);
    }
    if (E = o.child, !(o.lanes & C)) {
      var H = E.memoizedProps;
      if (v = v.compare, v = v !== null ? v : ut, v(H, w) && o.ref === l.ref) return Uo(o, l, C);
    }
    return l.flags |= 1, o = dl(E, w), o.ref = l.ref, o.return = l, l.child = o;
  }
  function Bt(o, l, v, w, C) {
    if (o !== null) {
      var E = o.memoizedProps;
      if (ut(E, w) && o.ref === l.ref) if (Jr = !1, l.pendingProps = w = E, (o.lanes & C) !== 0) o.flags & 131072 && (Jr = !0);
      else return l.lanes = o.lanes, Uo(o, l, C);
    }
    return yv(o, l, v, w, C);
  }
  function u0(o, l, v) {
    var w = l.pendingProps, C = w.children, E = o !== null ? o.memoizedState : null;
    if (w.mode === "hidden") if (!(l.mode & 1)) l.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Rn(y0, si), si |= v;
    else {
      if (!(v & 1073741824)) return o = E !== null ? E.baseLanes | v : v, l.lanes = l.childLanes = 1073741824, l.memoizedState = { baseLanes: o, cachePool: null, transitions: null }, l.updateQueue = null, Rn(y0, si), si |= o, null;
      l.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, w = E !== null ? E.baseLanes : v, Rn(y0, si), si |= w;
    }
    else E !== null ? (w = E.baseLanes | v, l.memoizedState = null) : w = v, Rn(y0, si), si |= w;
    return Sa(o, l, C, v), l.child;
  }
  function ld(o, l) {
    var v = l.ref;
    (o === null && v !== null || o !== null && o.ref !== v) && (l.flags |= 512, l.flags |= 2097152);
  }
  function yv(o, l, v, w, C) {
    var E = Ya(v) ? Ir : Br.current;
    return E = Mi(l, E), Sr(l, C), v = ki(o, l, v, w, E, C), w = Li(), o !== null && !Jr ? (l.updateQueue = o.updateQueue, l.flags &= -2053, o.lanes &= ~C, Uo(o, l, C)) : (xr && w && G1(l), l.flags |= 1, Sa(o, l, v, C), l.child);
  }
  function Fh(o, l, v, w, C) {
    if (Ya(v)) {
      var E = !0;
      pr(l);
    } else E = !1;
    if (Sr(l, C), l.stateNode === null) Pi(o, l), gu(l, v, w), Tc(l, v, w, C), w = !0;
    else if (o === null) {
      var H = l.stateNode, q = l.memoizedProps;
      H.props = q;
      var ee = H.context, ye = v.contextType;
      typeof ye == "object" && ye !== null ? ye = Ai(ye) : (ye = Ya(v) ? Ir : Br.current, ye = Mi(l, ye));
      var Be = v.getDerivedStateFromProps, $e = typeof Be == "function" || typeof H.getSnapshotBeforeUpdate == "function";
      $e || typeof H.UNSAFE_componentWillReceiveProps != "function" && typeof H.componentWillReceiveProps != "function" || (q !== w || ee !== ye) && o0(l, H, w, ye), za = !1;
      var Ne = l.memoizedState;
      H.state = Ne, Ks(l, w, H, C), ee = l.memoizedState, q !== w || Ne !== ee || Mr.current || za ? (typeof Be == "function" && (ad(l, v, Be, w), ee = l.memoizedState), (q = za || Vh(l, v, q, w, Ne, ee, ye)) ? ($e || typeof H.UNSAFE_componentWillMount != "function" && typeof H.componentWillMount != "function" || (typeof H.componentWillMount == "function" && H.componentWillMount(), typeof H.UNSAFE_componentWillMount == "function" && H.UNSAFE_componentWillMount()), typeof H.componentDidMount == "function" && (l.flags |= 4194308)) : (typeof H.componentDidMount == "function" && (l.flags |= 4194308), l.memoizedProps = w, l.memoizedState = ee), H.props = w, H.state = ee, H.context = ye, w = q) : (typeof H.componentDidMount == "function" && (l.flags |= 4194308), w = !1);
    } else {
      H = l.stateNode, mv(o, l), q = l.memoizedProps, ye = l.type === l.elementType ? q : Zi(l.type, q), H.props = ye, $e = l.pendingProps, Ne = H.context, ee = v.contextType, typeof ee == "object" && ee !== null ? ee = Ai(ee) : (ee = Ya(v) ? Ir : Br.current, ee = Mi(l, ee));
      var st = v.getDerivedStateFromProps;
      (Be = typeof st == "function" || typeof H.getSnapshotBeforeUpdate == "function") || typeof H.UNSAFE_componentWillReceiveProps != "function" && typeof H.componentWillReceiveProps != "function" || (q !== $e || Ne !== ee) && o0(l, H, w, ee), za = !1, Ne = l.memoizedState, H.state = Ne, Ks(l, w, H, C);
      var yt = l.memoizedState;
      q !== $e || Ne !== yt || Mr.current || za ? (typeof st == "function" && (ad(l, v, st, w), yt = l.memoizedState), (ye = za || Vh(l, v, ye, w, Ne, yt, ee) || !1) ? (Be || typeof H.UNSAFE_componentWillUpdate != "function" && typeof H.componentWillUpdate != "function" || (typeof H.componentWillUpdate == "function" && H.componentWillUpdate(w, yt, ee), typeof H.UNSAFE_componentWillUpdate == "function" && H.UNSAFE_componentWillUpdate(w, yt, ee)), typeof H.componentDidUpdate == "function" && (l.flags |= 4), typeof H.getSnapshotBeforeUpdate == "function" && (l.flags |= 1024)) : (typeof H.componentDidUpdate != "function" || q === o.memoizedProps && Ne === o.memoizedState || (l.flags |= 4), typeof H.getSnapshotBeforeUpdate != "function" || q === o.memoizedProps && Ne === o.memoizedState || (l.flags |= 1024), l.memoizedProps = w, l.memoizedState = yt), H.props = w, H.state = yt, H.context = ee, w = ye) : (typeof H.componentDidUpdate != "function" || q === o.memoizedProps && Ne === o.memoizedState || (l.flags |= 4), typeof H.getSnapshotBeforeUpdate != "function" || q === o.memoizedProps && Ne === o.memoizedState || (l.flags |= 1024), w = !1);
    }
    return jc(o, l, v, w, E, C);
  }
  function jc(o, l, v, w, C, E) {
    ld(o, l);
    var H = (l.flags & 128) !== 0;
    if (!w && !H) return C && Wf(l, v, !1), Uo(o, l, E);
    w = l.stateNode, us.current = l;
    var q = H && typeof v.getDerivedStateFromError != "function" ? null : w.render();
    return l.flags |= 1, o !== null && H ? (l.child = hn(l, o.child, null, E), l.child = hn(l, null, q, E)) : Sa(o, l, q, E), l.memoizedState = w.state, C && Wf(l, v, !0), l.child;
  }
  function s0(o) {
    var l = o.stateNode;
    l.pendingContext ? dv(o, l.pendingContext, l.pendingContext !== l.context) : l.context && dv(o, l.context, !1), Zh(o, l.containerInfo);
  }
  function kl(o, l, v, w, C) {
    return Di(), oo(C), l.flags |= 256, Sa(o, l, v, w), l.child;
  }
  var c0 = { dehydrated: null, treeContext: null, retryLane: 0 };
  function kc(o) {
    return { baseLanes: o, cachePool: null, transitions: null };
  }
  function f0(o, l, v) {
    var w = l.pendingProps, C = Tr.current, E = !1, H = (l.flags & 128) !== 0, q;
    if ((q = H) || (q = o !== null && o.memoizedState === null ? !1 : (C & 2) !== 0), q ? (E = !0, l.flags &= -129) : (o === null || o.memoizedState !== null) && (C |= 1), Rn(Tr, C & 1), o === null)
      return Vo(l), o = l.memoizedState, o !== null && (o = o.dehydrated, o !== null) ? (l.mode & 1 ? o.data === "$!" ? l.lanes = 8 : l.lanes = 1073741824 : l.lanes = 1, null) : (H = w.children, o = w.fallback, E ? (w = l.mode, E = l.child, H = { mode: "hidden", children: H }, !(w & 1) && E !== null ? (E.childLanes = 0, E.pendingProps = H) : E = hs(H, w, 0, null), o = bu(o, w, v, null), E.return = l, o.return = l, E.sibling = o, l.child = E, l.child.memoizedState = kc(v), l.memoizedState = c0, o) : d0(l, H));
    if (C = o.memoizedState, C !== null && (q = C.dehydrated, q !== null)) return Vt(o, l, H, w, q, C, v);
    if (E) {
      E = w.fallback, H = l.mode, C = o.child, q = C.sibling;
      var ee = { mode: "hidden", children: w.children };
      return !(H & 1) && l.child !== C ? (w = l.child, w.childLanes = 0, w.pendingProps = ee, l.deletions = null) : (w = dl(C, ee), w.subtreeFlags = C.subtreeFlags & 14680064), q !== null ? E = dl(q, E) : (E = bu(E, H, v, null), E.flags |= 2), E.return = l, w.return = l, w.sibling = E, l.child = w, w = E, E = l.child, H = o.child.memoizedState, H = H === null ? kc(v) : { baseLanes: H.baseLanes | v, cachePool: null, transitions: H.transitions }, E.memoizedState = H, E.childLanes = o.childLanes & ~v, l.memoizedState = c0, w;
    }
    return E = o.child, o = E.sibling, w = dl(E, { mode: "visible", children: w.children }), !(l.mode & 1) && (w.lanes = v), w.return = l, w.sibling = null, o !== null && (v = l.deletions, v === null ? (l.deletions = [o], l.flags |= 16) : v.push(o)), l.child = w, l.memoizedState = null, w;
  }
  function d0(o, l) {
    return l = hs({ mode: "visible", children: l }, o.mode, 0, null), l.return = o, o.child = l;
  }
  function Ll(o, l, v, w) {
    return w !== null && oo(w), hn(l, o.child, null, v), o = d0(l, l.pendingProps.children), o.flags |= 2, l.memoizedState = null, o;
  }
  function Vt(o, l, v, w, C, E, H) {
    if (v)
      return l.flags & 256 ? (l.flags &= -257, w = id(Error(a(422))), Ll(o, l, H, w)) : l.memoizedState !== null ? (l.child = o.child, l.flags |= 128, null) : (E = w.fallback, C = l.mode, w = hs({ mode: "visible", children: w.children }, C, 0, null), E = bu(E, C, H, null), E.flags |= 2, w.return = l, E.return = l, w.sibling = E, l.child = w, l.mode & 1 && hn(l, o.child, null, H), l.child.memoizedState = kc(H), l.memoizedState = c0, E);
    if (!(l.mode & 1)) return Ll(o, l, H, null);
    if (C.data === "$!") {
      if (w = C.nextSibling && C.nextSibling.dataset, w) var q = w.dgst;
      return w = q, E = Error(a(419)), w = id(E, w, void 0), Ll(o, l, H, w);
    }
    if (q = (H & o.childLanes) !== 0, Jr || q) {
      if (w = ba, w !== null) {
        switch (H & -H) {
          case 4:
            C = 2;
            break;
          case 16:
            C = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            C = 32;
            break;
          case 536870912:
            C = 268435456;
            break;
          default:
            C = 0;
        }
        C = C & (w.suspendedLanes | H) ? 0 : C, C !== 0 && C !== E.retryLane && (E.retryLane = C, li(o, C), _o(w, o, C, -1));
      }
      return Gh(), w = id(Error(a(421))), Ll(o, l, H, w);
    }
    return C.data === "$?" ? (l.flags |= 128, l.child = o.child, l = fm.bind(null, o), C._reactRetry = l, null) : (o = E.treeContext, No = qu(C.nextSibling), $a = l, xr = !0, Oi = null, o !== null && (sa[Ti++] = rl, sa[Ti++] = al, sa[Ti++] = ii, rl = o.id, al = o.overflow, ii = l), l = d0(l, w.children), l.flags |= 4096, l);
  }
  function h0(o, l, v) {
    o.lanes |= l;
    var w = o.alternate;
    w !== null && (w.lanes |= l), Wa(o.return, l, v);
  }
  function qa(o, l, v, w, C) {
    var E = o.memoizedState;
    E === null ? o.memoizedState = { isBackwards: l, rendering: null, renderingStartTime: 0, last: w, tail: v, tailMode: C } : (E.isBackwards = l, E.rendering = null, E.renderingStartTime = 0, E.last = w, E.tail = v, E.tailMode = C);
  }
  function uo(o, l, v) {
    var w = l.pendingProps, C = w.revealOrder, E = w.tail;
    if (Sa(o, l, w.children, v), w = Tr.current, w & 2) w = w & 1 | 2, l.flags |= 128;
    else {
      if (o !== null && o.flags & 128) e: for (o = l.child; o !== null; ) {
        if (o.tag === 13) o.memoizedState !== null && h0(o, v, l);
        else if (o.tag === 19) h0(o, v, l);
        else if (o.child !== null) {
          o.child.return = o, o = o.child;
          continue;
        }
        if (o === l) break e;
        for (; o.sibling === null; ) {
          if (o.return === null || o.return === l) break e;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
      w &= 1;
    }
    if (Rn(Tr, w), !(l.mode & 1)) l.memoizedState = null;
    else switch (C) {
      case "forwards":
        for (v = l.child, C = null; v !== null; ) o = v.alternate, o !== null && Qs(o) === null && (C = v), v = v.sibling;
        v = C, v === null ? (C = l.child, l.child = null) : (C = v.sibling, v.sibling = null), qa(l, !1, C, v, E);
        break;
      case "backwards":
        for (v = null, C = l.child, l.child = null; C !== null; ) {
          if (o = C.alternate, o !== null && Qs(o) === null) {
            l.child = C;
            break;
          }
          o = C.sibling, C.sibling = v, v = C, C = o;
        }
        qa(l, !0, v, null, E);
        break;
      case "together":
        qa(l, !1, null, null, void 0);
        break;
      default:
        l.memoizedState = null;
    }
    return l.child;
  }
  function Pi(o, l) {
    !(l.mode & 1) && o !== null && (o.alternate = null, l.alternate = null, l.flags |= 2);
  }
  function Uo(o, l, v) {
    if (o !== null && (l.dependencies = o.dependencies), cl |= l.lanes, !(v & l.childLanes)) return null;
    if (o !== null && l.child !== o.child) throw Error(a(153));
    if (l.child !== null) {
      for (o = l.child, v = dl(o, o.pendingProps), l.child = v, v.return = l; o.sibling !== null; ) o = o.sibling, v = v.sibling = dl(o, o.pendingProps), v.return = l;
      v.sibling = null;
    }
    return l.child;
  }
  function v0(o, l, v) {
    switch (l.tag) {
      case 3:
        s0(l), Di();
        break;
      case 5:
        Ph(l);
        break;
      case 1:
        Ya(l.type) && pr(l);
        break;
      case 4:
        Zh(l, l.stateNode.containerInfo);
        break;
      case 10:
        var w = l.type._context, C = l.memoizedProps.value;
        Rn(Fo, w._currentValue), w._currentValue = C;
        break;
      case 13:
        if (w = l.memoizedState, w !== null)
          return w.dehydrated !== null ? (Rn(Tr, Tr.current & 1), l.flags |= 128, null) : v & l.child.childLanes ? f0(o, l, v) : (Rn(Tr, Tr.current & 1), o = Uo(o, l, v), o !== null ? o.sibling : null);
        Rn(Tr, Tr.current & 1);
        break;
      case 19:
        if (w = (v & l.childLanes) !== 0, o.flags & 128) {
          if (w) return uo(o, l, v);
          l.flags |= 128;
        }
        if (C = l.memoizedState, C !== null && (C.rendering = null, C.tail = null, C.lastEffect = null), Rn(Tr, Tr.current), w) break;
        return null;
      case 22:
      case 23:
        return l.lanes = 0, u0(o, l, v);
    }
    return Uo(o, l, v);
  }
  var fr, fa, xv, Bh;
  fr = function(o, l) {
    for (var v = l.child; v !== null; ) {
      if (v.tag === 5 || v.tag === 6) o.appendChild(v.stateNode);
      else if (v.tag !== 4 && v.child !== null) {
        v.child.return = v, v = v.child;
        continue;
      }
      if (v === l) break;
      for (; v.sibling === null; ) {
        if (v.return === null || v.return === l) return;
        v = v.return;
      }
      v.sibling.return = v.return, v = v.sibling;
    }
  }, fa = function() {
  }, xv = function(o, l, v, w) {
    var C = o.memoizedProps;
    if (C !== w) {
      o = l.stateNode, hu(Al.current);
      var E = null;
      switch (v) {
        case "input":
          C = Gn(o, C), w = Gn(o, w), E = [];
          break;
        case "select":
          C = Pe({}, C, { value: void 0 }), w = Pe({}, w, { value: void 0 }), E = [];
          break;
        case "textarea":
          C = On(o, C), w = On(o, w), E = [];
          break;
        default:
          typeof C.onClick != "function" && typeof w.onClick == "function" && (o.onclick = U1);
      }
      Oa(v, w);
      var H;
      v = null;
      for (ye in C) if (!w.hasOwnProperty(ye) && C.hasOwnProperty(ye) && C[ye] != null) if (ye === "style") {
        var q = C[ye];
        for (H in q) q.hasOwnProperty(H) && (v || (v = {}), v[H] = "");
      } else ye !== "dangerouslySetInnerHTML" && ye !== "children" && ye !== "suppressContentEditableWarning" && ye !== "suppressHydrationWarning" && ye !== "autoFocus" && (h.hasOwnProperty(ye) ? E || (E = []) : (E = E || []).push(ye, null));
      for (ye in w) {
        var ee = w[ye];
        if (q = C != null ? C[ye] : void 0, w.hasOwnProperty(ye) && ee !== q && (ee != null || q != null)) if (ye === "style") if (q) {
          for (H in q) !q.hasOwnProperty(H) || ee && ee.hasOwnProperty(H) || (v || (v = {}), v[H] = "");
          for (H in ee) ee.hasOwnProperty(H) && q[H] !== ee[H] && (v || (v = {}), v[H] = ee[H]);
        } else v || (E || (E = []), E.push(
          ye,
          v
        )), v = ee;
        else ye === "dangerouslySetInnerHTML" ? (ee = ee ? ee.__html : void 0, q = q ? q.__html : void 0, ee != null && q !== ee && (E = E || []).push(ye, ee)) : ye === "children" ? typeof ee != "string" && typeof ee != "number" || (E = E || []).push(ye, "" + ee) : ye !== "suppressContentEditableWarning" && ye !== "suppressHydrationWarning" && (h.hasOwnProperty(ye) ? (ee != null && ye === "onScroll" && vr("scroll", o), E || q === ee || (E = [])) : (E = E || []).push(ye, ee));
      }
      v && (E = E || []).push("style", v);
      var ye = E;
      (l.updateQueue = ye) && (l.flags |= 4);
    }
  }, Bh = function(o, l, v, w) {
    v !== w && (l.flags |= 4);
  };
  function Lc(o, l) {
    if (!xr) switch (o.tailMode) {
      case "hidden":
        l = o.tail;
        for (var v = null; l !== null; ) l.alternate !== null && (v = l), l = l.sibling;
        v === null ? o.tail = null : v.sibling = null;
        break;
      case "collapsed":
        v = o.tail;
        for (var w = null; v !== null; ) v.alternate !== null && (w = v), v = v.sibling;
        w === null ? l || o.tail === null ? o.tail = null : o.tail.sibling = null : w.sibling = null;
    }
  }
  function Ca(o) {
    var l = o.alternate !== null && o.alternate.child === o.child, v = 0, w = 0;
    if (l) for (var C = o.child; C !== null; ) v |= C.lanes | C.childLanes, w |= C.subtreeFlags & 14680064, w |= C.flags & 14680064, C.return = o, C = C.sibling;
    else for (C = o.child; C !== null; ) v |= C.lanes | C.childLanes, w |= C.subtreeFlags, w |= C.flags, C.return = o, C = C.sibling;
    return o.subtreeFlags |= w, o.childLanes = v, l;
  }
  function Sv(o, l, v) {
    var w = l.pendingProps;
    switch (Xu(l), l.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Ca(l), null;
      case 1:
        return Ya(l.type) && $f(), Ca(l), null;
      case 3:
        return w = l.stateNode, vu(), Dt(Mr), Dt(Br), kt(), w.pendingContext && (w.context = w.pendingContext, w.pendingContext = null), (o === null || o.child === null) && (mc(l) ? l.flags |= 4 : o === null || o.memoizedState.isDehydrated && !(l.flags & 256) || (l.flags |= 1024, Oi !== null && (i1(Oi), Oi = null))), fa(o, l), Ca(l), null;
      case 5:
        xc(l);
        var C = hu(X1.current);
        if (v = l.type, o !== null && l.stateNode != null) xv(o, l, v, w, C), o.ref !== l.ref && (l.flags |= 512, l.flags |= 2097152);
        else {
          if (!w) {
            if (l.stateNode === null) throw Error(a(166));
            return Ca(l), null;
          }
          if (o = hu(Al.current), mc(l)) {
            w = l.stateNode, v = l.type;
            var E = l.memoizedProps;
            switch (w[Tl] = l, w[Gu] = E, o = (l.mode & 1) !== 0, v) {
              case "dialog":
                vr("cancel", w), vr("close", w);
                break;
              case "iframe":
              case "object":
              case "embed":
                vr("load", w);
                break;
              case "video":
              case "audio":
                for (C = 0; C < el.length; C++) vr(el[C], w);
                break;
              case "source":
                vr("error", w);
                break;
              case "img":
              case "image":
              case "link":
                vr(
                  "error",
                  w
                ), vr("load", w);
                break;
              case "details":
                vr("toggle", w);
                break;
              case "input":
                wr(w, E), vr("invalid", w);
                break;
              case "select":
                w._wrapperState = { wasMultiple: !!E.multiple }, vr("invalid", w);
                break;
              case "textarea":
                Gr(w, E), vr("invalid", w);
            }
            Oa(v, E), C = null;
            for (var H in E) if (E.hasOwnProperty(H)) {
              var q = E[H];
              H === "children" ? typeof q == "string" ? w.textContent !== q && (E.suppressHydrationWarning !== !0 && ru(w.textContent, q, o), C = ["children", q]) : typeof q == "number" && w.textContent !== "" + q && (E.suppressHydrationWarning !== !0 && ru(
                w.textContent,
                q,
                o
              ), C = ["children", "" + q]) : h.hasOwnProperty(H) && q != null && H === "onScroll" && vr("scroll", w);
            }
            switch (v) {
              case "input":
                Wn(w), Mt(w, E, !0);
                break;
              case "textarea":
                Wn(w), $t(w);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof E.onClick == "function" && (w.onclick = U1);
            }
            w = C, l.updateQueue = w, w !== null && (l.flags |= 4);
          } else {
            H = C.nodeType === 9 ? C : C.ownerDocument, o === "http://www.w3.org/1999/xhtml" && (o = Cn(v)), o === "http://www.w3.org/1999/xhtml" ? v === "script" ? (o = H.createElement("div"), o.innerHTML = "<script><\/script>", o = o.removeChild(o.firstChild)) : typeof w.is == "string" ? o = H.createElement(v, { is: w.is }) : (o = H.createElement(v), v === "select" && (H = o, w.multiple ? H.multiple = !0 : w.size && (H.size = w.size))) : o = H.createElementNS(o, v), o[Tl] = l, o[Gu] = w, fr(o, l, !1, !1), l.stateNode = o;
            e: {
              switch (H = br(v, w), v) {
                case "dialog":
                  vr("cancel", o), vr("close", o), C = w;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  vr("load", o), C = w;
                  break;
                case "video":
                case "audio":
                  for (C = 0; C < el.length; C++) vr(el[C], o);
                  C = w;
                  break;
                case "source":
                  vr("error", o), C = w;
                  break;
                case "img":
                case "image":
                case "link":
                  vr(
                    "error",
                    o
                  ), vr("load", o), C = w;
                  break;
                case "details":
                  vr("toggle", o), C = w;
                  break;
                case "input":
                  wr(o, w), C = Gn(o, w), vr("invalid", o);
                  break;
                case "option":
                  C = w;
                  break;
                case "select":
                  o._wrapperState = { wasMultiple: !!w.multiple }, C = Pe({}, w, { value: void 0 }), vr("invalid", o);
                  break;
                case "textarea":
                  Gr(o, w), C = On(o, w), vr("invalid", o);
                  break;
                default:
                  C = w;
              }
              Oa(v, C), q = C;
              for (E in q) if (q.hasOwnProperty(E)) {
                var ee = q[E];
                E === "style" ? ga(o, ee) : E === "dangerouslySetInnerHTML" ? (ee = ee ? ee.__html : void 0, ee != null && Qe(o, ee)) : E === "children" ? typeof ee == "string" ? (v !== "textarea" || ee !== "") && at(o, ee) : typeof ee == "number" && at(o, "" + ee) : E !== "suppressContentEditableWarning" && E !== "suppressHydrationWarning" && E !== "autoFocus" && (h.hasOwnProperty(E) ? ee != null && E === "onScroll" && vr("scroll", o) : ee != null && W(o, E, ee, H));
              }
              switch (v) {
                case "input":
                  Wn(o), Mt(o, w, !1);
                  break;
                case "textarea":
                  Wn(o), $t(o);
                  break;
                case "option":
                  w.value != null && o.setAttribute("value", "" + Qt(w.value));
                  break;
                case "select":
                  o.multiple = !!w.multiple, E = w.value, E != null ? jt(o, !!w.multiple, E, !1) : w.defaultValue != null && jt(
                    o,
                    !!w.multiple,
                    w.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof C.onClick == "function" && (o.onclick = U1);
              }
              switch (v) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  w = !!w.autoFocus;
                  break e;
                case "img":
                  w = !0;
                  break e;
                default:
                  w = !1;
              }
            }
            w && (l.flags |= 4);
          }
          l.ref !== null && (l.flags |= 512, l.flags |= 2097152);
        }
        return Ca(l), null;
      case 6:
        if (o && l.stateNode != null) Bh(o, l, o.memoizedProps, w);
        else {
          if (typeof w != "string" && l.stateNode === null) throw Error(a(166));
          if (v = hu(X1.current), hu(Al.current), mc(l)) {
            if (w = l.stateNode, v = l.memoizedProps, w[Tl] = l, (E = w.nodeValue !== v) && (o = $a, o !== null)) switch (o.tag) {
              case 3:
                ru(w.nodeValue, v, (o.mode & 1) !== 0);
                break;
              case 5:
                o.memoizedProps.suppressHydrationWarning !== !0 && ru(w.nodeValue, v, (o.mode & 1) !== 0);
            }
            E && (l.flags |= 4);
          } else w = (v.nodeType === 9 ? v : v.ownerDocument).createTextNode(w), w[Tl] = l, l.stateNode = w;
        }
        return Ca(l), null;
      case 13:
        if (Dt(Tr), w = l.memoizedState, o === null || o.memoizedState !== null && o.memoizedState.dehydrated !== null) {
          if (xr && No !== null && l.mode & 1 && !(l.flags & 128)) K1(), Di(), l.flags |= 98560, E = !1;
          else if (E = mc(l), w !== null && w.dehydrated !== null) {
            if (o === null) {
              if (!E) throw Error(a(318));
              if (E = l.memoizedState, E = E !== null ? E.dehydrated : null, !E) throw Error(a(317));
              E[Tl] = l;
            } else Di(), !(l.flags & 128) && (l.memoizedState = null), l.flags |= 4;
            Ca(l), E = !1;
          } else Oi !== null && (i1(Oi), Oi = null), E = !0;
          if (!E) return l.flags & 65536 ? l : null;
        }
        return l.flags & 128 ? (l.lanes = v, l) : (w = w !== null, w !== (o !== null && o.memoizedState !== null) && w && (l.child.flags |= 8192, l.mode & 1 && (o === null || Tr.current & 1 ? ea === 0 && (ea = 3) : Gh())), l.updateQueue !== null && (l.flags |= 4), Ca(l), null);
      case 4:
        return vu(), fa(o, l), o === null && Wu(l.stateNode.containerInfo), Ca(l), null;
      case 10:
        return Gf(l.type._context), Ca(l), null;
      case 17:
        return Ya(l.type) && $f(), Ca(l), null;
      case 19:
        if (Dt(Tr), E = l.memoizedState, E === null) return Ca(l), null;
        if (w = (l.flags & 128) !== 0, H = E.rendering, H === null) if (w) Lc(E, !1);
        else {
          if (ea !== 0 || o !== null && o.flags & 128) for (o = l.child; o !== null; ) {
            if (H = Qs(o), H !== null) {
              for (l.flags |= 128, Lc(E, !1), w = H.updateQueue, w !== null && (l.updateQueue = w, l.flags |= 4), l.subtreeFlags = 0, w = v, v = l.child; v !== null; ) E = v, o = w, E.flags &= 14680066, H = E.alternate, H === null ? (E.childLanes = 0, E.lanes = o, E.child = null, E.subtreeFlags = 0, E.memoizedProps = null, E.memoizedState = null, E.updateQueue = null, E.dependencies = null, E.stateNode = null) : (E.childLanes = H.childLanes, E.lanes = H.lanes, E.child = H.child, E.subtreeFlags = 0, E.deletions = null, E.memoizedProps = H.memoizedProps, E.memoizedState = H.memoizedState, E.updateQueue = H.updateQueue, E.type = H.type, o = H.dependencies, E.dependencies = o === null ? null : { lanes: o.lanes, firstContext: o.firstContext }), v = v.sibling;
              return Rn(Tr, Tr.current & 1 | 2), l.child;
            }
            o = o.sibling;
          }
          E.tail !== null && mt() > a1 && (l.flags |= 128, w = !0, Lc(E, !1), l.lanes = 4194304);
        }
        else {
          if (!w) if (o = Qs(H), o !== null) {
            if (l.flags |= 128, w = !0, v = o.updateQueue, v !== null && (l.updateQueue = v, l.flags |= 4), Lc(E, !0), E.tail === null && E.tailMode === "hidden" && !H.alternate && !xr) return Ca(l), null;
          } else 2 * mt() - E.renderingStartTime > a1 && v !== 1073741824 && (l.flags |= 128, w = !0, Lc(E, !1), l.lanes = 4194304);
          E.isBackwards ? (H.sibling = l.child, l.child = H) : (v = E.last, v !== null ? v.sibling = H : l.child = H, E.last = H);
        }
        return E.tail !== null ? (l = E.tail, E.rendering = l, E.tail = l.sibling, E.renderingStartTime = mt(), l.sibling = null, v = Tr.current, Rn(Tr, w ? v & 1 | 2 : v & 1), l) : (Ca(l), null);
      case 22:
      case 23:
        return qh(), w = l.memoizedState !== null, o !== null && o.memoizedState !== null !== w && (l.flags |= 8192), w && l.mode & 1 ? si & 1073741824 && (Ca(l), l.subtreeFlags & 6 && (l.flags |= 8192)) : Ca(l), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(a(156, l.tag));
  }
  function ud(o, l) {
    switch (Xu(l), l.tag) {
      case 1:
        return Ya(l.type) && $f(), o = l.flags, o & 65536 ? (l.flags = o & -65537 | 128, l) : null;
      case 3:
        return vu(), Dt(Mr), Dt(Br), kt(), o = l.flags, o & 65536 && !(o & 128) ? (l.flags = o & -65537 | 128, l) : null;
      case 5:
        return xc(l), null;
      case 13:
        if (Dt(Tr), o = l.memoizedState, o !== null && o.dehydrated !== null) {
          if (l.alternate === null) throw Error(a(340));
          Di();
        }
        return o = l.flags, o & 65536 ? (l.flags = o & -65537 | 128, l) : null;
      case 19:
        return Dt(Tr), null;
      case 4:
        return vu(), null;
      case 10:
        return Gf(l.type._context), null;
      case 22:
      case 23:
        return qh(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Ic = !1, Or = !1, So = typeof WeakSet == "function" ? WeakSet : Set, ct = null;
  function p0(o, l) {
    var v = o.ref;
    if (v !== null) if (typeof v == "function") try {
      v(null);
    } catch (w) {
      Cr(o, l, w);
    }
    else v.current = null;
  }
  function m0(o, l, v) {
    try {
      v();
    } catch (w) {
      Cr(o, l, w);
    }
  }
  var Cv = !1;
  function bv(o, l) {
    if (au = ec, o = tr(), bl(o)) {
      if ("selectionStart" in o) var v = { start: o.selectionStart, end: o.selectionEnd };
      else {
        v = (v = o.ownerDocument) && v.defaultView || window;
        var w = v.getSelection && v.getSelection();
        if (w && w.rangeCount !== 0) {
          v = w.anchorNode;
          var C = w.anchorOffset, E = w.focusNode;
          w = w.focusOffset;
          var H = 0, q = -1, ee = -1, ye = 0, Be = 0, $e = o, Ne = null;
          e: for (; ; ) {
            for (var st; $e !== v || C !== 0 && $e.nodeType !== 3 || (q = H + C), $e !== E || w !== 0 && $e.nodeType !== 3 || (ee = H + w), $e.nodeType === 3 && (H += $e.nodeValue.length), (st = $e.firstChild) !== null; )
              Ne = $e, $e = st;
            for (; ; ) {
              if ($e === o) break e;
              if (Ne === v && ++ye === C && (q = H), Ne === E && ++Be === w && (ee = H), (st = $e.nextSibling) !== null) break;
              $e = Ne, Ne = $e.parentNode;
            }
            $e = st;
          }
          v = q === -1 || ee === -1 ? null : { start: q, end: ee };
        } else v = null;
      }
      v = v || { start: 0, end: 0 };
    } else v = null;
    for (zu = { focusedElem: o, selectionRange: v }, ec = !1, ct = l; ct !== null; ) if (l = ct, o = l.child, (l.subtreeFlags & 1028) !== 0 && o !== null) o.return = l, ct = o;
    else for (; ct !== null; ) {
      l = ct;
      try {
        var yt = l.alternate;
        if (l.flags & 1024) switch (l.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (yt !== null) {
              var St = yt.memoizedProps, ta = yt.memoizedState, fe = l.stateNode, ne = fe.getSnapshotBeforeUpdate(l.elementType === l.type ? St : Zi(l.type, St), ta);
              fe.__reactInternalSnapshotBeforeUpdate = ne;
            }
            break;
          case 3:
            var de = l.stateNode.containerInfo;
            de.nodeType === 1 ? de.textContent = "" : de.nodeType === 9 && de.documentElement && de.removeChild(de.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(a(163));
        }
      } catch (Fe) {
        Cr(l, l.return, Fe);
      }
      if (o = l.sibling, o !== null) {
        o.return = l.return, ct = o;
        break;
      }
      ct = l.return;
    }
    return yt = Cv, Cv = !1, yt;
  }
  function yu(o, l, v) {
    var w = l.updateQueue;
    if (w = w !== null ? w.lastEffect : null, w !== null) {
      var C = w = w.next;
      do {
        if ((C.tag & o) === o) {
          var E = C.destroy;
          C.destroy = void 0, E !== void 0 && m0(l, v, E);
        }
        C = C.next;
      } while (C !== w);
    }
  }
  function g0(o, l) {
    if (l = l.updateQueue, l = l !== null ? l.lastEffect : null, l !== null) {
      var v = l = l.next;
      do {
        if ((v.tag & o) === o) {
          var w = v.create;
          v.destroy = w();
        }
        v = v.next;
      } while (v !== l);
    }
  }
  function sd(o) {
    var l = o.ref;
    if (l !== null) {
      var v = o.stateNode;
      switch (o.tag) {
        case 5:
          o = v;
          break;
        default:
          o = v;
      }
      typeof l == "function" ? l(o) : l.current = o;
    }
  }
  function cd(o) {
    var l = o.alternate;
    l !== null && (o.alternate = null, cd(l)), o.child = null, o.deletions = null, o.sibling = null, o.tag === 5 && (l = o.stateNode, l !== null && (delete l[Tl], delete l[Gu], delete l[iu], delete l[P], delete l[W1])), o.stateNode = null, o.return = null, o.dependencies = null, o.memoizedProps = null, o.memoizedState = null, o.pendingProps = null, o.stateNode = null, o.updateQueue = null;
  }
  function Hc(o) {
    return o.tag === 5 || o.tag === 3 || o.tag === 4;
  }
  function xu(o) {
    e: for (; ; ) {
      for (; o.sibling === null; ) {
        if (o.return === null || Hc(o.return)) return null;
        o = o.return;
      }
      for (o.sibling.return = o.return, o = o.sibling; o.tag !== 5 && o.tag !== 6 && o.tag !== 18; ) {
        if (o.flags & 2 || o.child === null || o.tag === 4) continue e;
        o.child.return = o, o = o.child;
      }
      if (!(o.flags & 2)) return o.stateNode;
    }
  }
  function Il(o, l, v) {
    var w = o.tag;
    if (w === 5 || w === 6) o = o.stateNode, l ? v.nodeType === 8 ? v.parentNode.insertBefore(o, l) : v.insertBefore(o, l) : (v.nodeType === 8 ? (l = v.parentNode, l.insertBefore(o, v)) : (l = v, l.appendChild(o)), v = v._reactRootContainer, v != null || l.onclick !== null || (l.onclick = U1));
    else if (w !== 4 && (o = o.child, o !== null)) for (Il(o, l, v), o = o.sibling; o !== null; ) Il(o, l, v), o = o.sibling;
  }
  function ll(o, l, v) {
    var w = o.tag;
    if (w === 5 || w === 6) o = o.stateNode, l ? v.insertBefore(o, l) : v.appendChild(o);
    else if (w !== 4 && (o = o.child, o !== null)) for (ll(o, l, v), o = o.sibling; o !== null; ) ll(o, l, v), o = o.sibling;
  }
  var Yr = null, Co = !1;
  function Ga(o, l, v) {
    for (v = v.child; v !== null; ) Uh(o, l, v), v = v.sibling;
  }
  function Uh(o, l, v) {
    if (Gi && typeof Gi.onCommitFiberUnmount == "function") try {
      Gi.onCommitFiberUnmount(K0, v);
    } catch {
    }
    switch (v.tag) {
      case 5:
        Or || p0(v, l);
      case 6:
        var w = Yr, C = Co;
        Yr = null, Ga(o, l, v), Yr = w, Co = C, Yr !== null && (Co ? (o = Yr, v = v.stateNode, o.nodeType === 8 ? o.parentNode.removeChild(v) : o.removeChild(v)) : Yr.removeChild(v.stateNode));
        break;
      case 18:
        Yr !== null && (Co ? (o = Yr, v = v.stateNode, o.nodeType === 8 ? pc(o.parentNode, v) : o.nodeType === 1 && pc(o, v), Yn(o)) : pc(Yr, v.stateNode));
        break;
      case 4:
        w = Yr, C = Co, Yr = v.stateNode.containerInfo, Co = !0, Ga(o, l, v), Yr = w, Co = C;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!Or && (w = v.updateQueue, w !== null && (w = w.lastEffect, w !== null))) {
          C = w = w.next;
          do {
            var E = C, H = E.destroy;
            E = E.tag, H !== void 0 && (E & 2 || E & 4) && m0(v, l, H), C = C.next;
          } while (C !== w);
        }
        Ga(o, l, v);
        break;
      case 1:
        if (!Or && (p0(v, l), w = v.stateNode, typeof w.componentWillUnmount == "function")) try {
          w.props = v.memoizedProps, w.state = v.memoizedState, w.componentWillUnmount();
        } catch (q) {
          Cr(v, l, q);
        }
        Ga(o, l, v);
        break;
      case 21:
        Ga(o, l, v);
        break;
      case 22:
        v.mode & 1 ? (Or = (w = Or) || v.memoizedState !== null, Ga(o, l, v), Or = w) : Ga(o, l, v);
        break;
      default:
        Ga(o, l, v);
    }
  }
  function w0(o) {
    var l = o.updateQueue;
    if (l !== null) {
      o.updateQueue = null;
      var v = o.stateNode;
      v === null && (v = o.stateNode = new So()), l.forEach(function(w) {
        var C = Av.bind(null, o, w);
        v.has(w) || (v.add(w), w.then(C, C));
      });
    }
  }
  function ui(o, l) {
    var v = l.deletions;
    if (v !== null) for (var w = 0; w < v.length; w++) {
      var C = v[w];
      try {
        var E = o, H = l, q = H;
        e: for (; q !== null; ) {
          switch (q.tag) {
            case 5:
              Yr = q.stateNode, Co = !1;
              break e;
            case 3:
              Yr = q.stateNode.containerInfo, Co = !0;
              break e;
            case 4:
              Yr = q.stateNode.containerInfo, Co = !0;
              break e;
          }
          q = q.return;
        }
        if (Yr === null) throw Error(a(160));
        Uh(E, H, C), Yr = null, Co = !1;
        var ee = C.alternate;
        ee !== null && (ee.return = null), C.return = null;
      } catch (ye) {
        Cr(C, l, ye);
      }
    }
    if (l.subtreeFlags & 12854) for (l = l.child; l !== null; ) fd(l, o), l = l.sibling;
  }
  function fd(o, l) {
    var v = o.alternate, w = o.flags;
    switch (o.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (ui(l, o), bo(o), w & 4) {
          try {
            yu(3, o, o.return), g0(3, o);
          } catch (St) {
            Cr(o, o.return, St);
          }
          try {
            yu(5, o, o.return);
          } catch (St) {
            Cr(o, o.return, St);
          }
        }
        break;
      case 1:
        ui(l, o), bo(o), w & 512 && v !== null && p0(v, v.return);
        break;
      case 5:
        if (ui(l, o), bo(o), w & 512 && v !== null && p0(v, v.return), o.flags & 32) {
          var C = o.stateNode;
          try {
            at(C, "");
          } catch (St) {
            Cr(o, o.return, St);
          }
        }
        if (w & 4 && (C = o.stateNode, C != null)) {
          var E = o.memoizedProps, H = v !== null ? v.memoizedProps : E, q = o.type, ee = o.updateQueue;
          if (o.updateQueue = null, ee !== null) try {
            q === "input" && E.type === "radio" && E.name != null && Ta(C, E), br(q, H);
            var ye = br(q, E);
            for (H = 0; H < ee.length; H += 2) {
              var Be = ee[H], $e = ee[H + 1];
              Be === "style" ? ga(C, $e) : Be === "dangerouslySetInnerHTML" ? Qe(C, $e) : Be === "children" ? at(C, $e) : W(C, Be, $e, ye);
            }
            switch (q) {
              case "input":
                jr(C, E);
                break;
              case "textarea":
                Ge(C, E);
                break;
              case "select":
                var Ne = C._wrapperState.wasMultiple;
                C._wrapperState.wasMultiple = !!E.multiple;
                var st = E.value;
                st != null ? jt(C, !!E.multiple, st, !1) : Ne !== !!E.multiple && (E.defaultValue != null ? jt(
                  C,
                  !!E.multiple,
                  E.defaultValue,
                  !0
                ) : jt(C, !!E.multiple, E.multiple ? [] : "", !1));
            }
            C[Gu] = E;
          } catch (St) {
            Cr(o, o.return, St);
          }
        }
        break;
      case 6:
        if (ui(l, o), bo(o), w & 4) {
          if (o.stateNode === null) throw Error(a(162));
          C = o.stateNode, E = o.memoizedProps;
          try {
            C.nodeValue = E;
          } catch (St) {
            Cr(o, o.return, St);
          }
        }
        break;
      case 3:
        if (ui(l, o), bo(o), w & 4 && v !== null && v.memoizedState.isDehydrated) try {
          Yn(l.containerInfo);
        } catch (St) {
          Cr(o, o.return, St);
        }
        break;
      case 4:
        ui(l, o), bo(o);
        break;
      case 13:
        ui(l, o), bo(o), C = o.child, C.flags & 8192 && (E = C.memoizedState !== null, C.stateNode.isHidden = E, !E || C.alternate !== null && C.alternate.memoizedState !== null || ($h = mt())), w & 4 && w0(o);
        break;
      case 22:
        if (Be = v !== null && v.memoizedState !== null, o.mode & 1 ? (Or = (ye = Or) || Be, ui(l, o), Or = ye) : ui(l, o), bo(o), w & 8192) {
          if (ye = o.memoizedState !== null, (o.stateNode.isHidden = ye) && !Be && o.mode & 1) for (ct = o, Be = o.child; Be !== null; ) {
            for ($e = ct = Be; ct !== null; ) {
              switch (Ne = ct, st = Ne.child, Ne.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  yu(4, Ne, Ne.return);
                  break;
                case 1:
                  p0(Ne, Ne.return);
                  var yt = Ne.stateNode;
                  if (typeof yt.componentWillUnmount == "function") {
                    w = Ne, v = Ne.return;
                    try {
                      l = w, yt.props = l.memoizedProps, yt.state = l.memoizedState, yt.componentWillUnmount();
                    } catch (St) {
                      Cr(w, v, St);
                    }
                  }
                  break;
                case 5:
                  p0(Ne, Ne.return);
                  break;
                case 22:
                  if (Ne.memoizedState !== null) {
                    sl($e);
                    continue;
                  }
              }
              st !== null ? (st.return = Ne, ct = st) : sl($e);
            }
            Be = Be.sibling;
          }
          e: for (Be = null, $e = o; ; ) {
            if ($e.tag === 5) {
              if (Be === null) {
                Be = $e;
                try {
                  C = $e.stateNode, ye ? (E = C.style, typeof E.setProperty == "function" ? E.setProperty("display", "none", "important") : E.display = "none") : (q = $e.stateNode, ee = $e.memoizedProps.style, H = ee != null && ee.hasOwnProperty("display") ? ee.display : null, q.style.display = dr("display", H));
                } catch (St) {
                  Cr(o, o.return, St);
                }
              }
            } else if ($e.tag === 6) {
              if (Be === null) try {
                $e.stateNode.nodeValue = ye ? "" : $e.memoizedProps;
              } catch (St) {
                Cr(o, o.return, St);
              }
            } else if (($e.tag !== 22 && $e.tag !== 23 || $e.memoizedState === null || $e === o) && $e.child !== null) {
              $e.child.return = $e, $e = $e.child;
              continue;
            }
            if ($e === o) break e;
            for (; $e.sibling === null; ) {
              if ($e.return === null || $e.return === o) break e;
              Be === $e && (Be = null), $e = $e.return;
            }
            Be === $e && (Be = null), $e.sibling.return = $e.return, $e = $e.sibling;
          }
        }
        break;
      case 19:
        ui(l, o), bo(o), w & 4 && w0(o);
        break;
      case 21:
        break;
      default:
        ui(
          l,
          o
        ), bo(o);
    }
  }
  function bo(o) {
    var l = o.flags;
    if (l & 2) {
      try {
        e: {
          for (var v = o.return; v !== null; ) {
            if (Hc(v)) {
              var w = v;
              break e;
            }
            v = v.return;
          }
          throw Error(a(160));
        }
        switch (w.tag) {
          case 5:
            var C = w.stateNode;
            w.flags & 32 && (at(C, ""), w.flags &= -33);
            var E = xu(o);
            ll(o, E, C);
            break;
          case 3:
          case 4:
            var H = w.stateNode.containerInfo, q = xu(o);
            Il(o, q, H);
            break;
          default:
            throw Error(a(161));
        }
      } catch (ee) {
        Cr(o, o.return, ee);
      }
      o.flags &= -3;
    }
    l & 4096 && (o.flags &= -4097);
  }
  function dd(o, l, v) {
    ct = o, hd(o);
  }
  function hd(o, l, v) {
    for (var w = (o.mode & 1) !== 0; ct !== null; ) {
      var C = ct, E = C.child;
      if (C.tag === 22 && w) {
        var H = C.memoizedState !== null || Ic;
        if (!H) {
          var q = C.alternate, ee = q !== null && q.memoizedState !== null || Or;
          q = Ic;
          var ye = Or;
          if (Ic = H, (Or = ee) && !ye) for (ct = C; ct !== null; ) H = ct, ee = H.child, H.tag === 22 && H.memoizedState !== null ? Yh(C) : ee !== null ? (ee.return = H, ct = ee) : Yh(C);
          for (; E !== null; ) ct = E, hd(E), E = E.sibling;
          ct = C, Ic = q, Or = ye;
        }
        ul(o);
      } else C.subtreeFlags & 8772 && E !== null ? (E.return = C, ct = E) : ul(o);
    }
  }
  function ul(o) {
    for (; ct !== null; ) {
      var l = ct;
      if (l.flags & 8772) {
        var v = l.alternate;
        try {
          if (l.flags & 8772) switch (l.tag) {
            case 0:
            case 11:
            case 15:
              Or || g0(5, l);
              break;
            case 1:
              var w = l.stateNode;
              if (l.flags & 4 && !Or) if (v === null) w.componentDidMount();
              else {
                var C = l.elementType === l.type ? v.memoizedProps : Zi(l.type, v.memoizedProps);
                w.componentDidUpdate(C, v.memoizedState, w.__reactInternalSnapshotBeforeUpdate);
              }
              var E = l.updateQueue;
              E !== null && Xf(l, E, w);
              break;
            case 3:
              var H = l.updateQueue;
              if (H !== null) {
                if (v = null, l.child !== null) switch (l.child.tag) {
                  case 5:
                    v = l.child.stateNode;
                    break;
                  case 1:
                    v = l.child.stateNode;
                }
                Xf(l, H, v);
              }
              break;
            case 5:
              var q = l.stateNode;
              if (v === null && l.flags & 4) {
                v = q;
                var ee = l.memoizedProps;
                switch (l.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    ee.autoFocus && v.focus();
                    break;
                  case "img":
                    ee.src && (v.src = ee.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (l.memoizedState === null) {
                var ye = l.alternate;
                if (ye !== null) {
                  var Be = ye.memoizedState;
                  if (Be !== null) {
                    var $e = Be.dehydrated;
                    $e !== null && Yn($e);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(a(163));
          }
          Or || l.flags & 512 && sd(l);
        } catch (Ne) {
          Cr(l, l.return, Ne);
        }
      }
      if (l === o) {
        ct = null;
        break;
      }
      if (v = l.sibling, v !== null) {
        v.return = l.return, ct = v;
        break;
      }
      ct = l.return;
    }
  }
  function sl(o) {
    for (; ct !== null; ) {
      var l = ct;
      if (l === o) {
        ct = null;
        break;
      }
      var v = l.sibling;
      if (v !== null) {
        v.return = l.return, ct = v;
        break;
      }
      ct = l.return;
    }
  }
  function Yh(o) {
    for (; ct !== null; ) {
      var l = ct;
      try {
        switch (l.tag) {
          case 0:
          case 11:
          case 15:
            var v = l.return;
            try {
              g0(4, l);
            } catch (ee) {
              Cr(l, v, ee);
            }
            break;
          case 1:
            var w = l.stateNode;
            if (typeof w.componentDidMount == "function") {
              var C = l.return;
              try {
                w.componentDidMount();
              } catch (ee) {
                Cr(l, C, ee);
              }
            }
            var E = l.return;
            try {
              sd(l);
            } catch (ee) {
              Cr(l, E, ee);
            }
            break;
          case 5:
            var H = l.return;
            try {
              sd(l);
            } catch (ee) {
              Cr(l, H, ee);
            }
        }
      } catch (ee) {
        Cr(l, l.return, ee);
      }
      if (l === o) {
        ct = null;
        break;
      }
      var q = l.sibling;
      if (q !== null) {
        q.return = l.return, ct = q;
        break;
      }
      ct = l.return;
    }
  }
  var _v = Math.ceil, cs = z.ReactCurrentDispatcher, n1 = z.ReactCurrentOwner, Ka = z.ReactCurrentBatchConfig, wn = 0, ba = null, da = null, Qa = 0, si = 0, y0 = ao(0), ea = 0, Zc = null, cl = 0, r1 = 0, Pc = 0, Nc = null, Yo = null, $h = 0, a1 = 1 / 0, ci = null, x0 = !1, o1 = null, fs = null, vd = !1, Su = null, so = 0, ds = 0, S0 = null, Vc = -1, Xa = 0;
  function ha() {
    return wn & 6 ? mt() : Vc !== -1 ? Vc : Vc = mt();
  }
  function Hl(o) {
    return o.mode & 1 ? wn & 2 && Qa !== 0 ? Qa & -Qa : vv.transition !== null ? (Xa === 0 && (Xa = Ch()), Xa) : (o = Zn, o !== 0 || (o = window.event, o = o === void 0 ? 16 : Eh(o.type)), o) : 1;
  }
  function _o(o, l, v, w) {
    if (50 < ds) throw ds = 0, S0 = null, Error(a(185));
    Q0(o, v, w), (!(wn & 2) || o !== ba) && (o === ba && (!(wn & 2) && (r1 |= v), ea === 4 && fl(o, Qa)), $o(o, w), v === 1 && wn === 0 && !(l.mode & 1) && (a1 = mt() + 500, q1 && nl()));
  }
  function $o(o, l) {
    var v = o.callbackNode;
    Jp(o, l);
    var w = ks(o, o === ba ? Qa : 0);
    if (w === 0) v !== null && Er(v), o.callbackNode = null, o.callbackPriority = 0;
    else if (l = w & -w, o.callbackPriority !== l) {
      if (v != null && Er(v), l === 1) o.tag === 0 ? wo(Wh.bind(null, o)) : zf(Wh.bind(null, o)), $s(function() {
        !(wn & 6) && nl();
      }), v = null;
      else {
        switch (_n(w)) {
          case 1:
            v = Hu;
            break;
          case 4:
            v = G0;
            break;
          case 16:
            v = Zu;
            break;
          case 536870912:
            v = Rf;
            break;
          default:
            v = Zu;
        }
        v = kv(v, C0.bind(null, o));
      }
      o.callbackPriority = l, o.callbackNode = v;
    }
  }
  function C0(o, l) {
    if (Vc = -1, Xa = 0, wn & 6) throw Error(a(327));
    var v = o.callbackNode;
    if (b0() && o.callbackNode !== v) return null;
    var w = ks(o, o === ba ? Qa : 0);
    if (w === 0) return null;
    if (w & 30 || w & o.expiredLanes || l) l = pd(o, w);
    else {
      l = w;
      var C = wn;
      wn |= 2;
      var E = Ev();
      (ba !== o || Qa !== l) && (ci = null, a1 = mt() + 500, Cu(o, l));
      do
        try {
          Mv();
          break;
        } catch (q) {
          Rv(o, q);
        }
      while (!0);
      fu(), cs.current = E, wn = C, da !== null ? l = 0 : (ba = null, Qa = 0, l = ea);
    }
    if (l !== 0) {
      if (l === 2 && (C = k1(o), C !== 0 && (w = C, l = Fc(o, C))), l === 1) throw v = Zc, Cu(o, 0), fl(o, w), $o(o, mt()), v;
      if (l === 6) fl(o, w);
      else {
        if (C = o.current.alternate, !(w & 30) && !lm(C) && (l = pd(o, w), l === 2 && (E = k1(o), E !== 0 && (w = E, l = Fc(o, E))), l === 1)) throw v = Zc, Cu(o, 0), fl(o, w), $o(o, mt()), v;
        switch (o.finishedWork = C, o.finishedLanes = w, l) {
          case 0:
          case 1:
            throw Error(a(345));
          case 2:
            u1(o, Yo, ci);
            break;
          case 3:
            if (fl(o, w), (w & 130023424) === w && (l = $h + 500 - mt(), 10 < l)) {
              if (ks(o, 0) !== 0) break;
              if (C = o.suspendedLanes, (C & w) !== w) {
                ha(), o.pingedLanes |= o.suspendedLanes & C;
                break;
              }
              o.timeoutHandle = Ml(u1.bind(null, o, Yo, ci), l);
              break;
            }
            u1(o, Yo, ci);
            break;
          case 4:
            if (fl(o, w), (w & 4194240) === w) break;
            for (l = o.eventTimes, C = -1; 0 < w; ) {
              var H = 31 - Ki(w);
              E = 1 << H, H = l[H], H > C && (C = H), w &= ~E;
            }
            if (w = C, w = mt() - w, w = (120 > w ? 120 : 480 > w ? 480 : 1080 > w ? 1080 : 1920 > w ? 1920 : 3e3 > w ? 3e3 : 4320 > w ? 4320 : 1960 * _v(w / 1960)) - w, 10 < w) {
              o.timeoutHandle = Ml(u1.bind(null, o, Yo, ci), w);
              break;
            }
            u1(o, Yo, ci);
            break;
          case 5:
            u1(o, Yo, ci);
            break;
          default:
            throw Error(a(329));
        }
      }
    }
    return $o(o, mt()), o.callbackNode === v ? C0.bind(null, o) : null;
  }
  function Fc(o, l) {
    var v = Nc;
    return o.current.memoizedState.isDehydrated && (Cu(o, l).flags |= 256), o = pd(o, l), o !== 2 && (l = Yo, Yo = v, l !== null && i1(l)), o;
  }
  function i1(o) {
    Yo === null ? Yo = o : Yo.push.apply(Yo, o);
  }
  function lm(o) {
    for (var l = o; ; ) {
      if (l.flags & 16384) {
        var v = l.updateQueue;
        if (v !== null && (v = v.stores, v !== null)) for (var w = 0; w < v.length; w++) {
          var C = v[w], E = C.getSnapshot;
          C = C.value;
          try {
            if (!we(E(), C)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (v = l.child, l.subtreeFlags & 16384 && v !== null) v.return = l, l = v;
      else {
        if (l === o) break;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === o) return !0;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
    }
    return !0;
  }
  function fl(o, l) {
    for (l &= ~Pc, l &= ~r1, o.suspendedLanes |= l, o.pingedLanes &= ~l, o = o.expirationTimes; 0 < l; ) {
      var v = 31 - Ki(l), w = 1 << v;
      o[v] = -1, l &= ~w;
    }
  }
  function Wh(o) {
    if (wn & 6) throw Error(a(327));
    b0();
    var l = ks(o, 0);
    if (!(l & 1)) return $o(o, mt()), null;
    var v = pd(o, l);
    if (o.tag !== 0 && v === 2) {
      var w = k1(o);
      w !== 0 && (l = w, v = Fc(o, w));
    }
    if (v === 1) throw v = Zc, Cu(o, 0), fl(o, l), $o(o, mt()), v;
    if (v === 6) throw Error(a(345));
    return o.finishedWork = o.current.alternate, o.finishedLanes = l, u1(o, Yo, ci), $o(o, mt()), null;
  }
  function zh(o, l) {
    var v = wn;
    wn |= 1;
    try {
      return o(l);
    } finally {
      wn = v, wn === 0 && (a1 = mt() + 500, q1 && nl());
    }
  }
  function l1(o) {
    Su !== null && Su.tag === 0 && !(wn & 6) && b0();
    var l = wn;
    wn |= 1;
    var v = Ka.transition, w = Zn;
    try {
      if (Ka.transition = null, Zn = 1, o) return o();
    } finally {
      Zn = w, Ka.transition = v, wn = l, !(wn & 6) && nl();
    }
  }
  function qh() {
    si = y0.current, Dt(y0);
  }
  function Cu(o, l) {
    o.finishedWork = null, o.finishedLanes = 0;
    var v = o.timeoutHandle;
    if (v !== -1 && (o.timeoutHandle = -1, vc(v)), da !== null) for (v = da.return; v !== null; ) {
      var w = v;
      switch (Xu(w), w.tag) {
        case 1:
          w = w.type.childContextTypes, w != null && $f();
          break;
        case 3:
          vu(), Dt(Mr), Dt(Br), kt();
          break;
        case 5:
          xc(w);
          break;
        case 4:
          vu();
          break;
        case 13:
          Dt(Tr);
          break;
        case 19:
          Dt(Tr);
          break;
        case 10:
          Gf(w.type._context);
          break;
        case 22:
        case 23:
          qh();
      }
      v = v.return;
    }
    if (ba = o, da = o = dl(o.current, null), Qa = si = l, ea = 0, Zc = null, Pc = r1 = cl = 0, Yo = Nc = null, Gs !== null) {
      for (l = 0; l < Gs.length; l++) if (v = Gs[l], w = v.interleaved, w !== null) {
        v.interleaved = null;
        var C = w.next, E = v.pending;
        if (E !== null) {
          var H = E.next;
          E.next = C, w.next = H;
        }
        v.pending = w;
      }
      Gs = null;
    }
    return o;
  }
  function Rv(o, l) {
    do {
      var v = da;
      try {
        if (fu(), an.current = t1, J1) {
          for (var w = Vn.memoizedState; w !== null; ) {
            var C = w.queue;
            C !== null && (C.pending = null), w = w.next;
          }
          J1 = !1;
        }
        if (nr = 0, xa = Ur = Vn = null, Cc = !1, pu = 0, n1.current = null, v === null || v.return === null) {
          ea = 1, Zc = l, da = null;
          break;
        }
        e: {
          var E = o, H = v.return, q = v, ee = l;
          if (l = Qa, q.flags |= 32768, ee !== null && typeof ee == "object" && typeof ee.then == "function") {
            var ye = ee, Be = q, $e = Be.tag;
            if (!(Be.mode & 1) && ($e === 0 || $e === 11 || $e === 15)) {
              var Ne = Be.alternate;
              Ne ? (Be.updateQueue = Ne.updateQueue, Be.memoizedState = Ne.memoizedState, Be.lanes = Ne.lanes) : (Be.updateQueue = null, Be.memoizedState = null);
            }
            var st = wv(H);
            if (st !== null) {
              st.flags &= -257, wu(st, H, q, E, l), st.mode & 1 && l0(E, ye, l), l = st, ee = ye;
              var yt = l.updateQueue;
              if (yt === null) {
                var St = /* @__PURE__ */ new Set();
                St.add(ee), l.updateQueue = St;
              } else yt.add(ee);
              break e;
            } else {
              if (!(l & 1)) {
                l0(E, ye, l), Gh();
                break e;
              }
              ee = Error(a(426));
            }
          } else if (xr && q.mode & 1) {
            var ta = wv(H);
            if (ta !== null) {
              !(ta.flags & 65536) && (ta.flags |= 256), wu(ta, H, q, E, l), oo(ls(ee, q));
              break e;
            }
          }
          E = ee = ls(ee, q), ea !== 4 && (ea = 2), Nc === null ? Nc = [E] : Nc.push(E), E = H;
          do {
            switch (E.tag) {
              case 3:
                E.flags |= 65536, l &= -l, E.lanes |= l;
                var fe = Dc(E, ee, l);
                gv(E, fe);
                break e;
              case 1:
                q = ee;
                var ne = E.type, de = E.stateNode;
                if (!(E.flags & 128) && (typeof ne.getDerivedStateFromError == "function" || de !== null && typeof de.componentDidCatch == "function" && (fs === null || !fs.has(de)))) {
                  E.flags |= 65536, l &= -l, E.lanes |= l;
                  var Fe = Ac(E, q, l);
                  gv(E, Fe);
                  break e;
                }
            }
            E = E.return;
          } while (E !== null);
        }
        Ov(v);
      } catch (xt) {
        l = xt, da === v && v !== null && (da = v = v.return);
        continue;
      }
      break;
    } while (!0);
  }
  function Ev() {
    var o = cs.current;
    return cs.current = t1, o === null ? t1 : o;
  }
  function Gh() {
    (ea === 0 || ea === 3 || ea === 2) && (ea = 4), ba === null || !(cl & 268435455) && !(r1 & 268435455) || fl(ba, Qa);
  }
  function pd(o, l) {
    var v = wn;
    wn |= 2;
    var w = Ev();
    (ba !== o || Qa !== l) && (ci = null, Cu(o, l));
    do
      try {
        um();
        break;
      } catch (C) {
        Rv(o, C);
      }
    while (!0);
    if (fu(), wn = v, cs.current = w, da !== null) throw Error(a(261));
    return ba = null, Qa = 0, ea;
  }
  function um() {
    for (; da !== null; ) Tv(da);
  }
  function Mv() {
    for (; da !== null && !Fa(); ) Tv(da);
  }
  function Tv(o) {
    var l = jv(o.alternate, o, si);
    o.memoizedProps = o.pendingProps, l === null ? Ov(o) : da = l, n1.current = null;
  }
  function Ov(o) {
    var l = o;
    do {
      var v = l.alternate;
      if (o = l.return, l.flags & 32768) {
        if (v = ud(v, l), v !== null) {
          v.flags &= 32767, da = v;
          return;
        }
        if (o !== null) o.flags |= 32768, o.subtreeFlags = 0, o.deletions = null;
        else {
          ea = 6, da = null;
          return;
        }
      } else if (v = Sv(v, l, si), v !== null) {
        da = v;
        return;
      }
      if (l = l.sibling, l !== null) {
        da = l;
        return;
      }
      da = l = o;
    } while (l !== null);
    ea === 0 && (ea = 5);
  }
  function u1(o, l, v) {
    var w = Zn, C = Ka.transition;
    try {
      Ka.transition = null, Zn = 1, sm(o, l, v, w);
    } finally {
      Ka.transition = C, Zn = w;
    }
    return null;
  }
  function sm(o, l, v, w) {
    do
      b0();
    while (Su !== null);
    if (wn & 6) throw Error(a(327));
    v = o.finishedWork;
    var C = o.finishedLanes;
    if (v === null) return null;
    if (o.finishedWork = null, o.finishedLanes = 0, v === o.current) throw Error(a(177));
    o.callbackNode = null, o.callbackPriority = 0;
    var E = v.lanes | v.childLanes;
    if (bh(o, E), o === ba && (da = ba = null, Qa = 0), !(v.subtreeFlags & 2064) && !(v.flags & 2064) || vd || (vd = !0, kv(Zu, function() {
      return b0(), null;
    })), E = (v.flags & 15990) !== 0, v.subtreeFlags & 15990 || E) {
      E = Ka.transition, Ka.transition = null;
      var H = Zn;
      Zn = 1;
      var q = wn;
      wn |= 4, n1.current = null, bv(o, v), fd(v, o), om(zu), ec = !!au, zu = au = null, o.current = v, dd(v), Io(), wn = q, Zn = H, Ka.transition = E;
    } else o.current = v;
    if (vd && (vd = !1, Su = o, so = C), E = o.pendingLanes, E === 0 && (fs = null), F2(v.stateNode), $o(o, mt()), l !== null) for (w = o.onRecoverableError, v = 0; v < l.length; v++) C = l[v], w(C.value, { componentStack: C.stack, digest: C.digest });
    if (x0) throw x0 = !1, o = o1, o1 = null, o;
    return so & 1 && o.tag !== 0 && b0(), E = o.pendingLanes, E & 1 ? o === S0 ? ds++ : (ds = 0, S0 = o) : ds = 0, nl(), null;
  }
  function b0() {
    if (Su !== null) {
      var o = _n(so), l = Ka.transition, v = Zn;
      try {
        if (Ka.transition = null, Zn = 16 > o ? 16 : o, Su === null) var w = !1;
        else {
          if (o = Su, Su = null, so = 0, wn & 6) throw Error(a(331));
          var C = wn;
          for (wn |= 4, ct = o.current; ct !== null; ) {
            var E = ct, H = E.child;
            if (ct.flags & 16) {
              var q = E.deletions;
              if (q !== null) {
                for (var ee = 0; ee < q.length; ee++) {
                  var ye = q[ee];
                  for (ct = ye; ct !== null; ) {
                    var Be = ct;
                    switch (Be.tag) {
                      case 0:
                      case 11:
                      case 15:
                        yu(8, Be, E);
                    }
                    var $e = Be.child;
                    if ($e !== null) $e.return = Be, ct = $e;
                    else for (; ct !== null; ) {
                      Be = ct;
                      var Ne = Be.sibling, st = Be.return;
                      if (cd(Be), Be === ye) {
                        ct = null;
                        break;
                      }
                      if (Ne !== null) {
                        Ne.return = st, ct = Ne;
                        break;
                      }
                      ct = st;
                    }
                  }
                }
                var yt = E.alternate;
                if (yt !== null) {
                  var St = yt.child;
                  if (St !== null) {
                    yt.child = null;
                    do {
                      var ta = St.sibling;
                      St.sibling = null, St = ta;
                    } while (St !== null);
                  }
                }
                ct = E;
              }
            }
            if (E.subtreeFlags & 2064 && H !== null) H.return = E, ct = H;
            else e: for (; ct !== null; ) {
              if (E = ct, E.flags & 2048) switch (E.tag) {
                case 0:
                case 11:
                case 15:
                  yu(9, E, E.return);
              }
              var fe = E.sibling;
              if (fe !== null) {
                fe.return = E.return, ct = fe;
                break e;
              }
              ct = E.return;
            }
          }
          var ne = o.current;
          for (ct = ne; ct !== null; ) {
            H = ct;
            var de = H.child;
            if (H.subtreeFlags & 2064 && de !== null) de.return = H, ct = de;
            else e: for (H = ne; ct !== null; ) {
              if (q = ct, q.flags & 2048) try {
                switch (q.tag) {
                  case 0:
                  case 11:
                  case 15:
                    g0(9, q);
                }
              } catch (xt) {
                Cr(q, q.return, xt);
              }
              if (q === H) {
                ct = null;
                break e;
              }
              var Fe = q.sibling;
              if (Fe !== null) {
                Fe.return = q.return, ct = Fe;
                break e;
              }
              ct = q.return;
            }
          }
          if (wn = C, nl(), Gi && typeof Gi.onPostCommitFiberRoot == "function") try {
            Gi.onPostCommitFiberRoot(K0, o);
          } catch {
          }
          w = !0;
        }
        return w;
      } finally {
        Zn = v, Ka.transition = l;
      }
    }
    return !1;
  }
  function md(o, l, v) {
    l = ls(v, l), l = Dc(o, l, 1), o = ji(o, l, 1), l = ha(), o !== null && (Q0(o, 1, l), $o(o, l));
  }
  function Cr(o, l, v) {
    if (o.tag === 3) md(o, o, v);
    else for (; l !== null; ) {
      if (l.tag === 3) {
        md(l, o, v);
        break;
      } else if (l.tag === 1) {
        var w = l.stateNode;
        if (typeof l.type.getDerivedStateFromError == "function" || typeof w.componentDidCatch == "function" && (fs === null || !fs.has(w))) {
          o = ls(v, o), o = Ac(l, o, 1), l = ji(l, o, 1), o = ha(), l !== null && (Q0(l, 1, o), $o(l, o));
          break;
        }
      }
      l = l.return;
    }
  }
  function cm(o, l, v) {
    var w = o.pingCache;
    w !== null && w.delete(l), l = ha(), o.pingedLanes |= o.suspendedLanes & v, ba === o && (Qa & v) === v && (ea === 4 || ea === 3 && (Qa & 130023424) === Qa && 500 > mt() - $h ? Cu(o, 0) : Pc |= v), $o(o, l);
  }
  function Dv(o, l) {
    l === 0 && (o.mode & 1 ? (l = j1, j1 <<= 1, !(j1 & 130023424) && (j1 = 4194304)) : l = 1);
    var v = ha();
    o = li(o, l), o !== null && (Q0(o, l, v), $o(o, v));
  }
  function fm(o) {
    var l = o.memoizedState, v = 0;
    l !== null && (v = l.retryLane), Dv(o, v);
  }
  function Av(o, l) {
    var v = 0;
    switch (o.tag) {
      case 13:
        var w = o.stateNode, C = o.memoizedState;
        C !== null && (v = C.retryLane);
        break;
      case 19:
        w = o.stateNode;
        break;
      default:
        throw Error(a(314));
    }
    w !== null && w.delete(l), Dv(o, v);
  }
  var jv;
  jv = function(o, l, v) {
    if (o !== null) if (o.memoizedProps !== l.pendingProps || Mr.current) Jr = !0;
    else {
      if (!(o.lanes & v) && !(l.flags & 128)) return Jr = !1, v0(o, l, v);
      Jr = !!(o.flags & 131072);
    }
    else Jr = !1, xr && l.flags & 1048576 && hv(l, su, l.index);
    switch (l.lanes = 0, l.tag) {
      case 2:
        var w = l.type;
        Pi(o, l), o = l.pendingProps;
        var C = Mi(l, Br.current);
        Sr(l, v), C = ki(null, l, w, o, C, v);
        var E = Li();
        return l.flags |= 1, typeof C == "object" && C !== null && typeof C.render == "function" && C.$$typeof === void 0 ? (l.tag = 1, l.memoizedState = null, l.updateQueue = null, Ya(w) ? (E = !0, pr(l)) : E = !1, l.memoizedState = C.state !== null && C.state !== void 0 ? C.state : null, Kf(l), C.updater = od, l.stateNode = C, C._reactInternals = l, Tc(l, w, o, v), l = jc(null, l, w, !0, E, v)) : (l.tag = 0, xr && E && G1(l), Sa(null, l, C, v), l = l.child), l;
      case 16:
        w = l.elementType;
        e: {
          switch (Pi(o, l), o = l.pendingProps, C = w._init, w = C(w._payload), l.type = w, C = l.tag = hm(w), o = Zi(w, o), C) {
            case 0:
              l = yv(null, l, w, o, v);
              break e;
            case 1:
              l = Fh(null, l, w, o, v);
              break e;
            case 11:
              l = Bo(null, l, w, o, v);
              break e;
            case 14:
              l = ss(null, l, w, Zi(w.type, o), v);
              break e;
          }
          throw Error(a(
            306,
            w,
            ""
          ));
        }
        return l;
      case 0:
        return w = l.type, C = l.pendingProps, C = l.elementType === w ? C : Zi(w, C), yv(o, l, w, C, v);
      case 1:
        return w = l.type, C = l.pendingProps, C = l.elementType === w ? C : Zi(w, C), Fh(o, l, w, C, v);
      case 3:
        e: {
          if (s0(l), o === null) throw Error(a(387));
          w = l.pendingProps, E = l.memoizedState, C = E.element, mv(o, l), Ks(l, w, null, v);
          var H = l.memoizedState;
          if (w = H.element, E.isDehydrated) if (E = { element: w, isDehydrated: !1, cache: H.cache, pendingSuspenseBoundaries: H.pendingSuspenseBoundaries, transitions: H.transitions }, l.updateQueue.baseState = E, l.memoizedState = E, l.flags & 256) {
            C = ls(Error(a(423)), l), l = kl(o, l, w, v, C);
            break e;
          } else if (w !== C) {
            C = ls(Error(a(424)), l), l = kl(o, l, w, v, C);
            break e;
          } else for (No = qu(l.stateNode.containerInfo.firstChild), $a = l, xr = !0, Oi = null, v = et(l, null, w, v), l.child = v; v; ) v.flags = v.flags & -3 | 4096, v = v.sibling;
          else {
            if (Di(), w === C) {
              l = Uo(o, l, v);
              break e;
            }
            Sa(o, l, w, v);
          }
          l = l.child;
        }
        return l;
      case 5:
        return Ph(l), o === null && Vo(l), w = l.type, C = l.pendingProps, E = o !== null ? o.memoizedProps : null, H = C.children, Y1(w, C) ? H = null : E !== null && Y1(w, E) && (l.flags |= 32), ld(o, l), Sa(o, l, H, v), l.child;
      case 6:
        return o === null && Vo(l), null;
      case 13:
        return f0(o, l, v);
      case 4:
        return Zh(l, l.stateNode.containerInfo), w = l.pendingProps, o === null ? l.child = hn(l, null, w, v) : Sa(o, l, w, v), l.child;
      case 11:
        return w = l.type, C = l.pendingProps, C = l.elementType === w ? C : Zi(w, C), Bo(o, l, w, C, v);
      case 7:
        return Sa(o, l, l.pendingProps, v), l.child;
      case 8:
        return Sa(o, l, l.pendingProps.children, v), l.child;
      case 12:
        return Sa(o, l, l.pendingProps.children, v), l.child;
      case 10:
        e: {
          if (w = l.type._context, C = l.pendingProps, E = l.memoizedProps, H = C.value, Rn(Fo, w._currentValue), w._currentValue = H, E !== null) if (we(E.value, H)) {
            if (E.children === C.children && !Mr.current) {
              l = Uo(o, l, v);
              break e;
            }
          } else for (E = l.child, E !== null && (E.return = l); E !== null; ) {
            var q = E.dependencies;
            if (q !== null) {
              H = E.child;
              for (var ee = q.firstContext; ee !== null; ) {
                if (ee.context === w) {
                  if (E.tag === 1) {
                    ee = du(-1, v & -v), ee.tag = 2;
                    var ye = E.updateQueue;
                    if (ye !== null) {
                      ye = ye.shared;
                      var Be = ye.pending;
                      Be === null ? ee.next = ee : (ee.next = Be.next, Be.next = ee), ye.pending = ee;
                    }
                  }
                  E.lanes |= v, ee = E.alternate, ee !== null && (ee.lanes |= v), Wa(
                    E.return,
                    v,
                    l
                  ), q.lanes |= v;
                  break;
                }
                ee = ee.next;
              }
            } else if (E.tag === 10) H = E.type === l.type ? null : E.child;
            else if (E.tag === 18) {
              if (H = E.return, H === null) throw Error(a(341));
              H.lanes |= v, q = H.alternate, q !== null && (q.lanes |= v), Wa(H, v, l), H = E.sibling;
            } else H = E.child;
            if (H !== null) H.return = E;
            else for (H = E; H !== null; ) {
              if (H === l) {
                H = null;
                break;
              }
              if (E = H.sibling, E !== null) {
                E.return = H.return, H = E;
                break;
              }
              H = H.return;
            }
            E = H;
          }
          Sa(o, l, C.children, v), l = l.child;
        }
        return l;
      case 9:
        return C = l.type, w = l.pendingProps.children, Sr(l, v), C = Ai(C), w = w(C), l.flags |= 1, Sa(o, l, w, v), l.child;
      case 14:
        return w = l.type, C = Zi(w, l.pendingProps), C = Zi(w.type, C), ss(o, l, w, C, v);
      case 15:
        return Bt(o, l, l.type, l.pendingProps, v);
      case 17:
        return w = l.type, C = l.pendingProps, C = l.elementType === w ? C : Zi(w, C), Pi(o, l), l.tag = 1, Ya(w) ? (o = !0, pr(l)) : o = !1, Sr(l, v), gu(l, w, C), Tc(l, w, C, v), jc(null, l, w, !0, o, v);
      case 19:
        return uo(o, l, v);
      case 22:
        return u0(o, l, v);
    }
    throw Error(a(156, l.tag));
  };
  function kv(o, l) {
    return Rr(o, l);
  }
  function dm(o, l, v, w) {
    this.tag = o, this.key = v, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = l, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = w, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Ni(o, l, v, w) {
    return new dm(o, l, v, w);
  }
  function gd(o) {
    return o = o.prototype, !(!o || !o.isReactComponent);
  }
  function hm(o) {
    if (typeof o == "function") return gd(o) ? 1 : 0;
    if (o != null) {
      if (o = o.$$typeof, o === ge) return 11;
      if (o === Re) return 14;
    }
    return 2;
  }
  function dl(o, l) {
    var v = o.alternate;
    return v === null ? (v = Ni(o.tag, l, o.key, o.mode), v.elementType = o.elementType, v.type = o.type, v.stateNode = o.stateNode, v.alternate = o, o.alternate = v) : (v.pendingProps = l, v.type = o.type, v.flags = 0, v.subtreeFlags = 0, v.deletions = null), v.flags = o.flags & 14680064, v.childLanes = o.childLanes, v.lanes = o.lanes, v.child = o.child, v.memoizedProps = o.memoizedProps, v.memoizedState = o.memoizedState, v.updateQueue = o.updateQueue, l = o.dependencies, v.dependencies = l === null ? null : { lanes: l.lanes, firstContext: l.firstContext }, v.sibling = o.sibling, v.index = o.index, v.ref = o.ref, v;
  }
  function Bc(o, l, v, w, C, E) {
    var H = 2;
    if (w = o, typeof o == "function") gd(o) && (H = 1);
    else if (typeof o == "string") H = 5;
    else e: switch (o) {
      case G:
        return bu(v.children, C, E, l);
      case pe:
        H = 8, C |= 8;
        break;
      case J:
        return o = Ni(12, v, l, C | 2), o.elementType = J, o.lanes = E, o;
      case ce:
        return o = Ni(13, v, l, C), o.elementType = ce, o.lanes = E, o;
      case Se:
        return o = Ni(19, v, l, C), o.elementType = Se, o.lanes = E, o;
      case Ye:
        return hs(v, C, E, l);
      default:
        if (typeof o == "object" && o !== null) switch (o.$$typeof) {
          case me:
            H = 10;
            break e;
          case oe:
            H = 9;
            break e;
          case ge:
            H = 11;
            break e;
          case Re:
            H = 14;
            break e;
          case _e:
            H = 16, w = null;
            break e;
        }
        throw Error(a(130, o == null ? o : typeof o, ""));
    }
    return l = Ni(H, v, l, C), l.elementType = o, l.type = w, l.lanes = E, l;
  }
  function bu(o, l, v, w) {
    return o = Ni(7, o, w, l), o.lanes = v, o;
  }
  function hs(o, l, v, w) {
    return o = Ni(22, o, w, l), o.elementType = Ye, o.lanes = v, o.stateNode = { isHidden: !1 }, o;
  }
  function Kh(o, l, v) {
    return o = Ni(6, o, null, l), o.lanes = v, o;
  }
  function wd(o, l, v) {
    return l = Ni(4, o.children !== null ? o.children : [], o.key, l), l.lanes = v, l.stateNode = { containerInfo: o.containerInfo, pendingChildren: null, implementation: o.implementation }, l;
  }
  function Lv(o, l, v, w, C) {
    this.tag = l, this.containerInfo = o, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Ls(0), this.expirationTimes = Ls(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Ls(0), this.identifierPrefix = w, this.onRecoverableError = C, this.mutableSourceEagerHydrationData = null;
  }
  function yd(o, l, v, w, C, E, H, q, ee) {
    return o = new Lv(o, l, v, q, ee), l === 1 ? (l = 1, E === !0 && (l |= 8)) : l = 0, E = Ni(3, null, null, l), o.current = E, E.stateNode = o, E.memoizedState = { element: w, isDehydrated: v, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Kf(E), o;
  }
  function vm(o, l, v) {
    var w = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: ie, key: w == null ? null : "" + w, children: o, containerInfo: l, implementation: v };
  }
  function Qh(o) {
    if (!o) return go;
    o = o._reactInternals;
    e: {
      if (vt(o) !== o || o.tag !== 1) throw Error(a(170));
      var l = o;
      do {
        switch (l.tag) {
          case 3:
            l = l.stateNode.context;
            break e;
          case 1:
            if (Ya(l.type)) {
              l = l.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        l = l.return;
      } while (l !== null);
      throw Error(a(171));
    }
    if (o.tag === 1) {
      var v = o.type;
      if (Ya(v)) return z1(o, v, l);
    }
    return l;
  }
  function Iv(o, l, v, w, C, E, H, q, ee) {
    return o = yd(v, w, !0, o, C, E, H, q, ee), o.context = Qh(null), v = o.current, w = ha(), C = Hl(v), E = du(w, C), E.callback = l ?? null, ji(v, E, C), o.current.lanes = C, Q0(o, C, w), $o(o, w), o;
  }
  function xd(o, l, v, w) {
    var C = l.current, E = ha(), H = Hl(C);
    return v = Qh(v), l.context === null ? l.context = v : l.pendingContext = v, l = du(E, H), l.payload = { element: o }, w = w === void 0 ? null : w, w !== null && (l.callback = w), o = ji(C, l, H), o !== null && (_o(o, C, H, E), Qf(o, C, H)), H;
  }
  function Sd(o) {
    if (o = o.current, !o.child) return null;
    switch (o.child.tag) {
      case 5:
        return o.child.stateNode;
      default:
        return o.child.stateNode;
    }
  }
  function Xh(o, l) {
    if (o = o.memoizedState, o !== null && o.dehydrated !== null) {
      var v = o.retryLane;
      o.retryLane = v !== 0 && v < l ? v : l;
    }
  }
  function Cd(o, l) {
    Xh(o, l), (o = o.alternate) && Xh(o, l);
  }
  function Hv() {
    return null;
  }
  var s1 = typeof reportError == "function" ? reportError : function(o) {
    console.error(o);
  };
  function bd(o) {
    this._internalRoot = o;
  }
  Uc.prototype.render = bd.prototype.render = function(o) {
    var l = this._internalRoot;
    if (l === null) throw Error(a(409));
    xd(o, l, null, null);
  }, Uc.prototype.unmount = bd.prototype.unmount = function() {
    var o = this._internalRoot;
    if (o !== null) {
      this._internalRoot = null;
      var l = o.containerInfo;
      l1(function() {
        xd(null, o, null, null);
      }), l[mo] = null;
    }
  };
  function Uc(o) {
    this._internalRoot = o;
  }
  Uc.prototype.unstable_scheduleHydration = function(o) {
    if (o) {
      var l = Of();
      o = { blockedOn: null, target: o, priority: l };
      for (var v = 0; v < wa.length && l !== 0 && l < wa[v].priority; v++) ;
      wa.splice(v, 0, o), v === 0 && Rh(o);
    }
  };
  function Jh(o) {
    return !(!o || o.nodeType !== 1 && o.nodeType !== 9 && o.nodeType !== 11);
  }
  function _d(o) {
    return !(!o || o.nodeType !== 1 && o.nodeType !== 9 && o.nodeType !== 11 && (o.nodeType !== 8 || o.nodeValue !== " react-mount-point-unstable "));
  }
  function Zv() {
  }
  function pm(o, l, v, w, C) {
    if (C) {
      if (typeof w == "function") {
        var E = w;
        w = function() {
          var ye = Sd(H);
          E.call(ye);
        };
      }
      var H = Iv(l, w, o, 0, null, !1, !1, "", Zv);
      return o._reactRootContainer = H, o[mo] = H.current, Wu(o.nodeType === 8 ? o.parentNode : o), l1(), H;
    }
    for (; C = o.lastChild; ) o.removeChild(C);
    if (typeof w == "function") {
      var q = w;
      w = function() {
        var ye = Sd(ee);
        q.call(ye);
      };
    }
    var ee = yd(o, 0, !1, null, null, !1, !1, "", Zv);
    return o._reactRootContainer = ee, o[mo] = ee.current, Wu(o.nodeType === 8 ? o.parentNode : o), l1(function() {
      xd(l, ee, v, w);
    }), ee;
  }
  function vs(o, l, v, w, C) {
    var E = v._reactRootContainer;
    if (E) {
      var H = E;
      if (typeof C == "function") {
        var q = C;
        C = function() {
          var ee = Sd(H);
          q.call(ee);
        };
      }
      xd(l, H, o, C);
    } else H = pm(v, l, o, C, w);
    return Sd(H);
  }
  _h = function(o) {
    switch (o.tag) {
      case 3:
        var l = o.stateNode;
        if (l.current.memoizedState.isDehydrated) {
          var v = Gl(l.pendingLanes);
          v !== 0 && (X0(l, v | 1), $o(l, mt()), !(wn & 6) && (a1 = mt() + 500, nl()));
        }
        break;
      case 13:
        l1(function() {
          var w = li(o, 1);
          if (w !== null) {
            var C = ha();
            _o(w, o, 1, C);
          }
        }), Cd(o, 1);
    }
  }, J0 = function(o) {
    if (o.tag === 13) {
      var l = li(o, 134217728);
      if (l !== null) {
        var v = ha();
        _o(l, o, 134217728, v);
      }
      Cd(o, 134217728);
    }
  }, tn = function(o) {
    if (o.tag === 13) {
      var l = Hl(o), v = li(o, l);
      if (v !== null) {
        var w = ha();
        _o(v, o, l, w);
      }
      Cd(o, l);
    }
  }, Of = function() {
    return Zn;
  }, vo = function(o, l) {
    var v = Zn;
    try {
      return Zn = o, l();
    } finally {
      Zn = v;
    }
  }, O1 = function(o, l, v) {
    switch (l) {
      case "input":
        if (jr(o, v), l = v.name, v.type === "radio" && l != null) {
          for (v = o; v.parentNode; ) v = v.parentNode;
          for (v = v.querySelectorAll("input[name=" + JSON.stringify("" + l) + '][type="radio"]'), l = 0; l < v.length; l++) {
            var w = v[l];
            if (w !== o && w.form === o.form) {
              var C = un(w);
              if (!C) throw Error(a(90));
              zn(w), jr(w, C);
            }
          }
        }
        break;
      case "textarea":
        Ge(o, v);
        break;
      case "select":
        l = v.value, l != null && jt(o, !!v.multiple, l, !1);
    }
  }, A1 = zh, q0 = l1;
  var mm = { usingClientEntryPoint: !1, Events: [Qr, Tt, un, W0, z0, zh] }, Yc = { findFiberByHostInstance: Et, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, Pv = { bundleType: Yc.bundleType, version: Yc.version, rendererPackageName: Yc.rendererPackageName, rendererConfig: Yc.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: z.ReactCurrentDispatcher, findHostInstanceByFiber: function(o) {
    return o = ln(o), o === null ? null : o.stateNode;
  }, findFiberByHostInstance: Yc.findFiberByHostInstance || Hv, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var ps = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!ps.isDisabled && ps.supportsFiber) try {
      K0 = ps.inject(Pv), Gi = ps;
    } catch {
    }
  }
  return Ul.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = mm, Ul.createPortal = function(o, l) {
    var v = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!Jh(l)) throw Error(a(200));
    return vm(o, l, null, v);
  }, Ul.createRoot = function(o, l) {
    if (!Jh(o)) throw Error(a(299));
    var v = !1, w = "", C = s1;
    return l != null && (l.unstable_strictMode === !0 && (v = !0), l.identifierPrefix !== void 0 && (w = l.identifierPrefix), l.onRecoverableError !== void 0 && (C = l.onRecoverableError)), l = yd(o, 1, !1, null, null, v, !1, w, C), o[mo] = l.current, Wu(o.nodeType === 8 ? o.parentNode : o), new bd(l);
  }, Ul.findDOMNode = function(o) {
    if (o == null) return null;
    if (o.nodeType === 1) return o;
    var l = o._reactInternals;
    if (l === void 0)
      throw typeof o.render == "function" ? Error(a(188)) : (o = Object.keys(o).join(","), Error(a(268, o)));
    return o = ln(l), o = o === null ? null : o.stateNode, o;
  }, Ul.flushSync = function(o) {
    return l1(o);
  }, Ul.hydrate = function(o, l, v) {
    if (!_d(l)) throw Error(a(200));
    return vs(null, o, l, !0, v);
  }, Ul.hydrateRoot = function(o, l, v) {
    if (!Jh(o)) throw Error(a(405));
    var w = v != null && v.hydratedSources || null, C = !1, E = "", H = s1;
    if (v != null && (v.unstable_strictMode === !0 && (C = !0), v.identifierPrefix !== void 0 && (E = v.identifierPrefix), v.onRecoverableError !== void 0 && (H = v.onRecoverableError)), l = Iv(l, null, o, 1, v ?? null, C, !1, E, H), o[mo] = l.current, Wu(o), w) for (o = 0; o < w.length; o++) v = w[o], C = v._getVersion, C = C(v._source), l.mutableSourceEagerHydrationData == null ? l.mutableSourceEagerHydrationData = [v, C] : l.mutableSourceEagerHydrationData.push(
      v,
      C
    );
    return new Uc(l);
  }, Ul.render = function(o, l, v) {
    if (!_d(l)) throw Error(a(200));
    return vs(null, o, l, !1, v);
  }, Ul.unmountComponentAtNode = function(o) {
    if (!_d(o)) throw Error(a(40));
    return o._reactRootContainer ? (l1(function() {
      vs(null, null, o, !1, function() {
        o._reactRootContainer = null, o[mo] = null;
      });
    }), !0) : !1;
  }, Ul.unstable_batchedUpdates = zh, Ul.unstable_renderSubtreeIntoContainer = function(o, l, v, w) {
    if (!_d(v)) throw Error(a(200));
    if (o == null || o._reactInternals === void 0) throw Error(a(38));
    return vs(o, l, v, !1, w);
  }, Ul.version = "18.3.1-next-f1338f8080-20240426", Ul;
}
var Yl = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var I_;
function tZ() {
  return I_ || (I_ = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = Ma, n = XE(), a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, i = !1;
    function h(t) {
      i = t;
    }
    function g(t) {
      if (!i) {
        for (var r = arguments.length, u = new Array(r > 1 ? r - 1 : 0), c = 1; c < r; c++)
          u[c - 1] = arguments[c];
        S("warn", t, u);
      }
    }
    function m(t) {
      if (!i) {
        for (var r = arguments.length, u = new Array(r > 1 ? r - 1 : 0), c = 1; c < r; c++)
          u[c - 1] = arguments[c];
        S("error", t, u);
      }
    }
    function S(t, r, u) {
      {
        var c = a.ReactDebugCurrentFrame, p = c.getStackAddendum();
        p !== "" && (r += "%s", u = u.concat([p]));
        var x = u.map(function(_) {
          return String(_);
        });
        x.unshift("Warning: " + r), Function.prototype.apply.call(console[t], console, x);
      }
    }
    var b = 0, R = 1, D = 2, T = 3, A = 4, j = 5, I = 6, Z = 7, N = 8, B = 9, $ = 10, W = 11, z = 12, Y = 13, ie = 14, G = 15, pe = 16, J = 17, me = 18, oe = 19, ge = 21, ce = 22, Se = 23, Re = 24, _e = 25, Ye = !0, ue = !1, Ae = !1, Pe = !1, dt = !1, Ze = !0, qe = !1, Je = !0, ot = /* @__PURE__ */ new Set(), Nt = {}, Tn = {};
    function Qt(t, r) {
      Hn(t, r), Hn(t + "Capture", r);
    }
    function Hn(t, r) {
      Nt[t] && m("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", t), Nt[t] = r;
      {
        var u = t.toLowerCase();
        Tn[u] = t, t === "onDoubleClick" && (Tn.ondblclick = t);
      }
      for (var c = 0; c < r.length; c++)
        ot.add(r[c]);
    }
    var ar = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Wn = Object.prototype.hasOwnProperty;
    function zn(t) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, u = r && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return u;
      }
    }
    function qn(t) {
      try {
        return !1;
      } catch {
        return !0;
      }
    }
    function Gn(t) {
      return "" + t;
    }
    function wr(t, r) {
      if (qn())
        return m("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", r, zn(t)), Gn(t);
    }
    function Ta(t) {
      if (qn())
        return m("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", zn(t)), Gn(t);
    }
    function jr(t, r) {
      if (qn())
        return m("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", r, zn(t)), Gn(t);
    }
    function Mt(t, r) {
      if (qn())
        return m("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", r, zn(t)), Gn(t);
    }
    function fn(t) {
      if (qn())
        return m("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", zn(t)), Gn(t);
    }
    function Sn(t) {
      if (qn())
        return m("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", zn(t)), Gn(t);
    }
    var jt = 0, On = 1, Gr = 2, Ge = 3, $t = 4, Cn = 5, gn = 6, cr = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Qe = cr + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", at = new RegExp("^[" + cr + "][" + Qe + "]*$"), Lt = {}, Un = {};
    function dr(t) {
      return Wn.call(Un, t) ? !0 : Wn.call(Lt, t) ? !1 : at.test(t) ? (Un[t] = !0, !0) : (Lt[t] = !0, m("Invalid attribute name: `%s`", t), !1);
    }
    function ga(t, r, u) {
      return r !== null ? r.type === jt : u ? !1 : t.length > 2 && (t[0] === "o" || t[0] === "O") && (t[1] === "n" || t[1] === "N");
    }
    function Nr(t, r, u, c) {
      if (u !== null && u.type === jt)
        return !1;
      switch (typeof r) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (c)
            return !1;
          if (u !== null)
            return !u.acceptsBooleans;
          var p = t.toLowerCase().slice(0, 5);
          return p !== "data-" && p !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Oa(t, r, u, c) {
      if (r === null || typeof r > "u" || Nr(t, r, u, c))
        return !0;
      if (c)
        return !1;
      if (u !== null)
        switch (u.type) {
          case Ge:
            return !r;
          case $t:
            return r === !1;
          case Cn:
            return isNaN(r);
          case gn:
            return isNaN(r) || r < 1;
        }
      return !1;
    }
    function br(t) {
      return kr.hasOwnProperty(t) ? kr[t] : null;
    }
    function _r(t, r, u, c, p, x, _) {
      this.acceptsBooleans = r === Gr || r === Ge || r === $t, this.attributeName = c, this.attributeNamespace = p, this.mustUseProperty = u, this.propertyName = t, this.type = r, this.sanitizeURL = x, this.removeEmptyString = _;
    }
    var kr = {}, O1 = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    O1.forEach(function(t) {
      kr[t] = new _r(
        t,
        jt,
        !1,
        // mustUseProperty
        t,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(t) {
      var r = t[0], u = t[1];
      kr[r] = new _r(
        r,
        On,
        !1,
        // mustUseProperty
        u,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(t) {
      kr[t] = new _r(
        t,
        Gr,
        !1,
        // mustUseProperty
        t.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(t) {
      kr[t] = new _r(
        t,
        Gr,
        !1,
        // mustUseProperty
        t,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(t) {
      kr[t] = new _r(
        t,
        Ge,
        !1,
        // mustUseProperty
        t.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      kr[t] = new _r(
        t,
        Ge,
        !0,
        // mustUseProperty
        t,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      kr[t] = new _r(
        t,
        $t,
        !1,
        // mustUseProperty
        t,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      kr[t] = new _r(
        t,
        gn,
        !1,
        // mustUseProperty
        t,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(t) {
      kr[t] = new _r(
        t,
        Cn,
        !1,
        // mustUseProperty
        t.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var to = /[\-\:]([a-z])/g, Jo = function(t) {
      return t[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      var r = t.replace(to, Jo);
      kr[r] = new _r(
        r,
        On,
        !1,
        // mustUseProperty
        t,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      var r = t.replace(to, Jo);
      kr[r] = new _r(
        r,
        On,
        !1,
        // mustUseProperty
        t,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      var r = t.replace(to, Jo);
      kr[r] = new _r(
        r,
        On,
        !1,
        // mustUseProperty
        t,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(t) {
      kr[t] = new _r(
        t,
        On,
        !1,
        // mustUseProperty
        t.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var D1 = "xlinkHref";
    kr[D1] = new _r(
      "xlinkHref",
      On,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(t) {
      kr[t] = new _r(
        t,
        On,
        !1,
        // mustUseProperty
        t.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var W0 = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, z0 = !1;
    function A1(t) {
      !z0 && W0.test(t) && (z0 = !0, m("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(t)));
    }
    function q0(t, r, u, c) {
      if (c.mustUseProperty) {
        var p = c.propertyName;
        return t[p];
      } else {
        wr(u, r), c.sanitizeURL && A1("" + u);
        var x = c.attributeName, _ = null;
        if (c.type === $t) {
          if (t.hasAttribute(x)) {
            var O = t.getAttribute(x);
            return O === "" ? !0 : Oa(r, u, c, !1) ? O : O === "" + u ? u : O;
          }
        } else if (t.hasAttribute(x)) {
          if (Oa(r, u, c, !1))
            return t.getAttribute(x);
          if (c.type === Ge)
            return u;
          _ = t.getAttribute(x);
        }
        return Oa(r, u, c, !1) ? _ === null ? u : _ : _ === "" + u ? u : _;
      }
    }
    function As(t, r, u, c) {
      {
        if (!dr(r))
          return;
        if (!t.hasAttribute(r))
          return u === void 0 ? void 0 : null;
        var p = t.getAttribute(r);
        return wr(u, r), p === "" + u ? u : p;
      }
    }
    function js(t, r, u, c) {
      var p = br(r);
      if (!ga(r, p, c)) {
        if (Oa(r, u, p, c) && (u = null), c || p === null) {
          if (dr(r)) {
            var x = r;
            u === null ? t.removeAttribute(x) : (wr(u, r), t.setAttribute(x, "" + u));
          }
          return;
        }
        var _ = p.mustUseProperty;
        if (_) {
          var O = p.propertyName;
          if (u === null) {
            var k = p.type;
            t[O] = k === Ge ? !1 : "";
          } else
            t[O] = u;
          return;
        }
        var V = p.attributeName, U = p.attributeNamespace;
        if (u === null)
          t.removeAttribute(V);
        else {
          var ae = p.type, re;
          ae === Ge || ae === $t && u === !0 ? re = "" : (wr(u, V), re = "" + u, p.sanitizeURL && A1(re.toString())), U ? t.setAttributeNS(U, V, re) : t.setAttribute(V, re);
        }
      }
    }
    var _i = Symbol.for("react.element"), ei = Symbol.for("react.portal"), ti = Symbol.for("react.fragment"), ku = Symbol.for("react.strict_mode"), ql = Symbol.for("react.profiler"), Lu = Symbol.for("react.provider"), Iu = Symbol.for("react.context"), Cl = Symbol.for("react.forward_ref"), X = Symbol.for("react.suspense"), We = Symbol.for("react.suspense_list"), lt = Symbol.for("react.memo"), vt = Symbol.for("react.lazy"), bn = Symbol.for("react.scope"), Kn = Symbol.for("react.debug_trace_mode"), dn = Symbol.for("react.offscreen"), ln = Symbol.for("react.legacy_hidden"), Da = Symbol.for("react.cache"), Rr = Symbol.for("react.tracing_marker"), Er = Symbol.iterator, Fa = "@@iterator";
    function Io(t) {
      if (t === null || typeof t != "object")
        return null;
      var r = Er && t[Er] || t[Fa];
      return typeof r == "function" ? r : null;
    }
    var mt = Object.assign, la = 0, Hu, G0, Zu, Sh, Rf, K0, Gi;
    function F2() {
    }
    F2.__reactDisabledLog = !0;
    function Ki() {
      {
        if (la === 0) {
          Hu = console.log, G0 = console.info, Zu = console.warn, Sh = console.error, Rf = console.group, K0 = console.groupCollapsed, Gi = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: F2,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        la++;
      }
    }
    function B2() {
      {
        if (la--, la === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: mt({}, t, {
              value: Hu
            }),
            info: mt({}, t, {
              value: G0
            }),
            warn: mt({}, t, {
              value: Zu
            }),
            error: mt({}, t, {
              value: Sh
            }),
            group: mt({}, t, {
              value: Rf
            }),
            groupCollapsed: mt({}, t, {
              value: K0
            }),
            groupEnd: mt({}, t, {
              value: Gi
            })
          });
        }
        la < 0 && m("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ef = a.ReactCurrentDispatcher, Mf;
    function ni(t, r, u) {
      {
        if (Mf === void 0)
          try {
            throw Error();
          } catch (p) {
            var c = p.stack.trim().match(/\n( *(at )?)/);
            Mf = c && c[1] || "";
          }
        return `
` + Mf + t;
      }
    }
    var j1 = !1, Gl;
    {
      var ks = typeof WeakMap == "function" ? WeakMap : Map;
      Gl = new ks();
    }
    function Tf(t, r) {
      if (!t || j1)
        return "";
      {
        var u = Gl.get(t);
        if (u !== void 0)
          return u;
      }
      var c;
      j1 = !0;
      var p = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var x;
      x = Ef.current, Ef.current = null, Ki();
      try {
        if (r) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (Ce) {
              c = Ce;
            }
            Reflect.construct(t, [], _);
          } else {
            try {
              _.call();
            } catch (Ce) {
              c = Ce;
            }
            t.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ce) {
            c = Ce;
          }
          t();
        }
      } catch (Ce) {
        if (Ce && c && typeof Ce.stack == "string") {
          for (var O = Ce.stack.split(`
`), k = c.stack.split(`
`), V = O.length - 1, U = k.length - 1; V >= 1 && U >= 0 && O[V] !== k[U]; )
            U--;
          for (; V >= 1 && U >= 0; V--, U--)
            if (O[V] !== k[U]) {
              if (V !== 1 || U !== 1)
                do
                  if (V--, U--, U < 0 || O[V] !== k[U]) {
                    var ae = `
` + O[V].replace(" at new ", " at ");
                    return t.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", t.displayName)), typeof t == "function" && Gl.set(t, ae), ae;
                  }
                while (V >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        j1 = !1, Ef.current = x, B2(), Error.prepareStackTrace = p;
      }
      var re = t ? t.displayName || t.name : "", xe = re ? ni(re) : "";
      return typeof t == "function" && Gl.set(t, xe), xe;
    }
    function Jp(t, r, u) {
      return Tf(t, !0);
    }
    function k1(t, r, u) {
      return Tf(t, !1);
    }
    function Ch(t) {
      var r = t.prototype;
      return !!(r && r.isReactComponent);
    }
    function Ls(t, r, u) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Tf(t, Ch(t));
      if (typeof t == "string")
        return ni(t);
      switch (t) {
        case X:
          return ni("Suspense");
        case We:
          return ni("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case Cl:
            return k1(t.render);
          case lt:
            return Ls(t.type);
          case vt: {
            var c = t, p = c._payload, x = c._init;
            try {
              return Ls(x(p));
            } catch {
            }
          }
        }
      return "";
    }
    function Q0(t) {
      switch (t.tag) {
        case j:
          return ni(t.type);
        case pe:
          return ni("Lazy");
        case Y:
          return ni("Suspense");
        case oe:
          return ni("SuspenseList");
        case b:
        case D:
        case G:
          return k1(t.type);
        case W:
          return k1(t.type.render);
        case R:
          return Jp(t.type);
        default:
          return "";
      }
    }
    function bh(t) {
      try {
        var r = "", u = t;
        do
          r += Q0(u), u = u.return;
        while (u);
        return r;
      } catch (c) {
        return `
Error generating stack: ` + c.message + `
` + c.stack;
      }
    }
    function X0(t, r, u) {
      var c = t.displayName;
      if (c)
        return c;
      var p = r.displayName || r.name || "";
      return p !== "" ? u + "(" + p + ")" : u;
    }
    function Zn(t) {
      return t.displayName || "Context";
    }
    function _n(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && m("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case ti:
          return "Fragment";
        case ei:
          return "Portal";
        case ql:
          return "Profiler";
        case ku:
          return "StrictMode";
        case X:
          return "Suspense";
        case We:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case Iu:
            var r = t;
            return Zn(r) + ".Consumer";
          case Lu:
            var u = t;
            return Zn(u._context) + ".Provider";
          case Cl:
            return X0(t, t.render, "ForwardRef");
          case lt:
            var c = t.displayName || null;
            return c !== null ? c : _n(t.type) || "Memo";
          case vt: {
            var p = t, x = p._payload, _ = p._init;
            try {
              return _n(_(x));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function _h(t, r, u) {
      var c = r.displayName || r.name || "";
      return t.displayName || (c !== "" ? u + "(" + c + ")" : u);
    }
    function J0(t) {
      return t.displayName || "Context";
    }
    function tn(t) {
      var r = t.tag, u = t.type;
      switch (r) {
        case Re:
          return "Cache";
        case B:
          var c = u;
          return J0(c) + ".Consumer";
        case $:
          var p = u;
          return J0(p._context) + ".Provider";
        case me:
          return "DehydratedFragment";
        case W:
          return _h(u, u.render, "ForwardRef");
        case Z:
          return "Fragment";
        case j:
          return u;
        case A:
          return "Portal";
        case T:
          return "Root";
        case I:
          return "Text";
        case pe:
          return _n(u);
        case N:
          return u === ku ? "StrictMode" : "Mode";
        case ce:
          return "Offscreen";
        case z:
          return "Profiler";
        case ge:
          return "Scope";
        case Y:
          return "Suspense";
        case oe:
          return "SuspenseList";
        case _e:
          return "TracingMarker";
        case R:
        case b:
        case J:
        case D:
        case ie:
        case G:
          if (typeof u == "function")
            return u.displayName || u.name || null;
          if (typeof u == "string")
            return u;
          break;
      }
      return null;
    }
    var Of = a.ReactDebugCurrentFrame, vo = null, Pu = !1;
    function Kl() {
      {
        if (vo === null)
          return null;
        var t = vo._debugOwner;
        if (t !== null && typeof t < "u")
          return tn(t);
      }
      return null;
    }
    function Nu() {
      return vo === null ? "" : bh(vo);
    }
    function Vr() {
      Of.getCurrentStack = null, vo = null, Pu = !1;
    }
    function or(t) {
      Of.getCurrentStack = t === null ? null : Nu, vo = t, Pu = !1;
    }
    function L1() {
      return vo;
    }
    function Ho(t) {
      Pu = t;
    }
    function wa(t) {
      return "" + t;
    }
    function Vu(t) {
      switch (typeof t) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return t;
        case "object":
          return Sn(t), t;
        default:
          return "";
      }
    }
    var U2 = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Ql(t, r) {
      U2[r.type] || r.onChange || r.onInput || r.readOnly || r.disabled || r.value == null || m("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), r.onChange || r.readOnly || r.disabled || r.checked == null || m("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function Y2(t) {
      var r = t.type, u = t.nodeName;
      return u && u.toLowerCase() === "input" && (r === "checkbox" || r === "radio");
    }
    function Rh(t) {
      return t._valueTracker;
    }
    function Df(t) {
      t._valueTracker = null;
    }
    function $2(t) {
      var r = "";
      return t && (Y2(t) ? r = t.checked ? "true" : "false" : r = t.value), r;
    }
    function em(t) {
      var r = Y2(t) ? "checked" : "value", u = Object.getOwnPropertyDescriptor(t.constructor.prototype, r);
      Sn(t[r]);
      var c = "" + t[r];
      if (!(t.hasOwnProperty(r) || typeof u > "u" || typeof u.get != "function" || typeof u.set != "function")) {
        var p = u.get, x = u.set;
        Object.defineProperty(t, r, {
          configurable: !0,
          get: function() {
            return p.call(this);
          },
          set: function(O) {
            Sn(O), c = "" + O, x.call(this, O);
          }
        }), Object.defineProperty(t, r, {
          enumerable: u.enumerable
        });
        var _ = {
          getValue: function() {
            return c;
          },
          setValue: function(O) {
            Sn(O), c = "" + O;
          },
          stopTracking: function() {
            Df(t), delete t[r];
          }
        };
        return _;
      }
    }
    function Pn(t) {
      Rh(t) || (t._valueTracker = em(t));
    }
    function Yn(t) {
      if (!t)
        return !1;
      var r = Rh(t);
      if (!r)
        return !0;
      var u = r.getValue(), c = $2(t);
      return c !== u ? (r.setValue(c), !0) : !1;
    }
    function Xl(t) {
      if (t = t || (typeof document < "u" ? document : void 0), typeof t > "u")
        return null;
      try {
        return t.activeElement || t.body;
      } catch {
        return t.body;
      }
    }
    var ec = !1, W2 = !1, z2 = !1, Af = !1;
    function tc(t) {
      var r = t.type === "checkbox" || t.type === "radio";
      return r ? t.checked != null : t.value != null;
    }
    function I1(t, r) {
      var u = t, c = r.checked, p = mt({}, r, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: c ?? u._wrapperState.initialChecked
      });
      return p;
    }
    function Eh(t, r) {
      Ql("input", r), r.checked !== void 0 && r.defaultChecked !== void 0 && !W2 && (m("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Kl() || "A component", r.type), W2 = !0), r.value !== void 0 && r.defaultValue !== void 0 && !ec && (m("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Kl() || "A component", r.type), ec = !0);
      var u = t, c = r.defaultValue == null ? "" : r.defaultValue;
      u._wrapperState = {
        initialChecked: r.checked != null ? r.checked : r.defaultChecked,
        initialValue: Vu(r.value != null ? r.value : c),
        controlled: tc(r)
      };
    }
    function yr(t, r) {
      var u = t, c = r.checked;
      c != null && js(u, "checked", c, !1);
    }
    function Is(t, r) {
      var u = t;
      {
        var c = tc(r);
        !u._wrapperState.controlled && c && !Af && (m("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Af = !0), u._wrapperState.controlled && !c && !z2 && (m("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), z2 = !0);
      }
      yr(t, r);
      var p = Vu(r.value), x = r.type;
      if (p != null)
        x === "number" ? (p === 0 && u.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        u.value != p) && (u.value = wa(p)) : u.value !== wa(p) && (u.value = wa(p));
      else if (x === "submit" || x === "reset") {
        u.removeAttribute("value");
        return;
      }
      r.hasOwnProperty("value") ? Ba(u, r.type, p) : r.hasOwnProperty("defaultValue") && Ba(u, r.type, Vu(r.defaultValue)), r.checked == null && r.defaultChecked != null && (u.defaultChecked = !!r.defaultChecked);
    }
    function Qi(t, r, u) {
      var c = t;
      if (r.hasOwnProperty("value") || r.hasOwnProperty("defaultValue")) {
        var p = r.type, x = p === "submit" || p === "reset";
        if (x && (r.value === void 0 || r.value === null))
          return;
        var _ = wa(c._wrapperState.initialValue);
        u || _ !== c.value && (c.value = _), c.defaultValue = _;
      }
      var O = c.name;
      O !== "" && (c.name = ""), c.defaultChecked = !c.defaultChecked, c.defaultChecked = !!c._wrapperState.initialChecked, O !== "" && (c.name = O);
    }
    function Mh(t, r) {
      var u = t;
      Is(u, r), H1(u, r);
    }
    function H1(t, r) {
      var u = r.name;
      if (r.type === "radio" && u != null) {
        for (var c = t; c.parentNode; )
          c = c.parentNode;
        wr(u, "name");
        for (var p = c.querySelectorAll("input[name=" + JSON.stringify("" + u) + '][type="radio"]'), x = 0; x < p.length; x++) {
          var _ = p[x];
          if (!(_ === t || _.form !== t.form)) {
            var O = Ve(_);
            if (!O)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            Yn(_), Is(_, O);
          }
        }
      }
    }
    function Ba(t, r, u) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (r !== "number" || Xl(t.ownerDocument) !== t) && (u == null ? t.defaultValue = wa(t._wrapperState.initialValue) : t.defaultValue !== wa(u) && (t.defaultValue = wa(u)));
    }
    var jf = !1, po = !1, Fu = !1;
    function nc(t, r) {
      r.value == null && (typeof r.children == "object" && r.children !== null ? e.Children.forEach(r.children, function(u) {
        u != null && (typeof u == "string" || typeof u == "number" || po || (po = !0, m("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : r.dangerouslySetInnerHTML != null && (Fu || (Fu = !0, m("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), r.selected != null && !jf && (m("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), jf = !0);
    }
    function Z1(t, r) {
      r.value != null && t.setAttribute("value", wa(Vu(r.value)));
    }
    var q2 = Array.isArray;
    function er(t) {
      return q2(t);
    }
    var rc;
    rc = !1;
    function Ua() {
      var t = Kl();
      return t ? `

Check the render method of \`` + t + "`." : "";
    }
    var ac = ["value", "defaultValue"];
    function Th(t) {
      {
        Ql("select", t);
        for (var r = 0; r < ac.length; r++) {
          var u = ac[r];
          if (t[u] != null) {
            var c = er(t[u]);
            t.multiple && !c ? m("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", u, Ua()) : !t.multiple && c && m("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", u, Ua());
          }
        }
      }
    }
    function ri(t, r, u, c) {
      var p = t.options;
      if (r) {
        for (var x = u, _ = {}, O = 0; O < x.length; O++)
          _["$" + x[O]] = !0;
        for (var k = 0; k < p.length; k++) {
          var V = _.hasOwnProperty("$" + p[k].value);
          p[k].selected !== V && (p[k].selected = V), V && c && (p[k].defaultSelected = !0);
        }
      } else {
        for (var U = wa(Vu(u)), ae = null, re = 0; re < p.length; re++) {
          if (p[re].value === U) {
            p[re].selected = !0, c && (p[re].defaultSelected = !0);
            return;
          }
          ae === null && !p[re].disabled && (ae = p[re]);
        }
        ae !== null && (ae.selected = !0);
      }
    }
    function P1(t, r) {
      return mt({}, r, {
        value: void 0
      });
    }
    function kf(t, r) {
      var u = t;
      Th(r), u._wrapperState = {
        wasMultiple: !!r.multiple
      }, r.value !== void 0 && r.defaultValue !== void 0 && !rc && (m("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), rc = !0);
    }
    function hr(t, r) {
      var u = t;
      u.multiple = !!r.multiple;
      var c = r.value;
      c != null ? ri(u, !!r.multiple, c, !1) : r.defaultValue != null && ri(u, !!r.multiple, r.defaultValue, !0);
    }
    function Bu(t, r) {
      var u = t, c = u._wrapperState.wasMultiple;
      u._wrapperState.wasMultiple = !!r.multiple;
      var p = r.value;
      p != null ? ri(u, !!r.multiple, p, !1) : c !== !!r.multiple && (r.defaultValue != null ? ri(u, !!r.multiple, r.defaultValue, !0) : ri(u, !!r.multiple, r.multiple ? [] : "", !1));
    }
    function Oh(t, r) {
      var u = t, c = r.value;
      c != null && ri(u, !!r.multiple, c, !1);
    }
    var G2 = !1;
    function oc(t, r) {
      var u = t;
      if (r.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var c = mt({}, r, {
        value: void 0,
        defaultValue: void 0,
        children: wa(u._wrapperState.initialValue)
      });
      return c;
    }
    function K2(t, r) {
      var u = t;
      Ql("textarea", r), r.value !== void 0 && r.defaultValue !== void 0 && !G2 && (m("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", Kl() || "A component"), G2 = !0);
      var c = r.value;
      if (c == null) {
        var p = r.children, x = r.defaultValue;
        if (p != null) {
          m("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (x != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (er(p)) {
              if (p.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              p = p[0];
            }
            x = p;
          }
        }
        x == null && (x = ""), c = x;
      }
      u._wrapperState = {
        initialValue: Vu(c)
      };
    }
    function Dh(t, r) {
      var u = t, c = Vu(r.value), p = Vu(r.defaultValue);
      if (c != null) {
        var x = wa(c);
        x !== u.value && (u.value = x), r.defaultValue == null && u.defaultValue !== x && (u.defaultValue = x);
      }
      p != null && (u.defaultValue = wa(p));
    }
    function Q2(t, r) {
      var u = t, c = u.textContent;
      c === u._wrapperState.initialValue && c !== "" && c !== null && (u.value = c);
    }
    function X2(t, r) {
      Dh(t, r);
    }
    var Ri = "http://www.w3.org/1999/xhtml", N1 = "http://www.w3.org/1998/Math/MathML", ic = "http://www.w3.org/2000/svg";
    function Lf(t) {
      switch (t) {
        case "svg":
          return ic;
        case "math":
          return N1;
        default:
          return Ri;
      }
    }
    function If(t, r) {
      return t == null || t === Ri ? Lf(r) : t === ic && r === "foreignObject" ? Ri : t;
    }
    var Ah = function(t) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(r, u, c, p) {
        MSApp.execUnsafeLocalFunction(function() {
          return t(r, u, c, p);
        });
      } : t;
    }, Hs, jh = Ah(function(t, r) {
      if (t.namespaceURI === ic && !("innerHTML" in t)) {
        Hs = Hs || document.createElement("div"), Hs.innerHTML = "<svg>" + r.valueOf().toString() + "</svg>";
        for (var u = Hs.firstChild; t.firstChild; )
          t.removeChild(t.firstChild);
        for (; u.firstChild; )
          t.appendChild(u.firstChild);
        return;
      }
      t.innerHTML = r;
    }), Zo = 1, Xi = 3, Fr = 8, Jl = 9, Hf = 11, no = function(t, r) {
      if (r) {
        var u = t.firstChild;
        if (u && u === t.lastChild && u.nodeType === Xi) {
          u.nodeValue = r;
          return;
        }
      }
      t.textContent = r;
    }, lc = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, ai = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function J2(t, r) {
      return t + r.charAt(0).toUpperCase() + r.substring(1);
    }
    var kh = ["Webkit", "ms", "Moz", "O"];
    Object.keys(ai).forEach(function(t) {
      kh.forEach(function(r) {
        ai[J2(r, t)] = ai[t];
      });
    });
    function Zf(t, r, u) {
      var c = r == null || typeof r == "boolean" || r === "";
      return c ? "" : !u && typeof r == "number" && r !== 0 && !(ai.hasOwnProperty(t) && ai[t]) ? r + "px" : (Mt(r, t), ("" + r).trim());
    }
    var ev = /([A-Z])/g, tv = /^ms-/;
    function nv(t) {
      return t.replace(ev, "-$1").toLowerCase().replace(tv, "-ms-");
    }
    var Zs = function() {
    };
    {
      var V1 = /^(?:webkit|moz|o)[A-Z]/, tm = /^-ms-/, nm = /-(.)/g, uc = /;\s*$/, Uu = {}, Po = {}, eu = !1, rv = !1, Pf = function(t) {
        return t.replace(nm, function(r, u) {
          return u.toUpperCase();
        });
      }, rm = function(t) {
        Uu.hasOwnProperty(t) && Uu[t] || (Uu[t] = !0, m(
          "Unsupported style property %s. Did you mean %s?",
          t,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Pf(t.replace(tm, "ms-"))
        ));
      }, Ps = function(t) {
        Uu.hasOwnProperty(t) && Uu[t] || (Uu[t] = !0, m("Unsupported vendor-prefixed style property %s. Did you mean %s?", t, t.charAt(0).toUpperCase() + t.slice(1)));
      }, oi = function(t, r) {
        Po.hasOwnProperty(r) && Po[r] || (Po[r] = !0, m(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, t, r.replace(uc, "")));
      }, Nf = function(t, r) {
        eu || (eu = !0, m("`NaN` is an invalid value for the `%s` css style property.", t));
      }, av = function(t, r) {
        rv || (rv = !0, m("`Infinity` is an invalid value for the `%s` css style property.", t));
      };
      Zs = function(t, r) {
        t.indexOf("-") > -1 ? rm(t) : V1.test(t) ? Ps(t) : uc.test(r) && oi(t, r), typeof r == "number" && (isNaN(r) ? Nf(t, r) : isFinite(r) || av(t, r));
      };
    }
    var ov = Zs;
    function iv(t) {
      {
        var r = "", u = "";
        for (var c in t)
          if (t.hasOwnProperty(c)) {
            var p = t[c];
            if (p != null) {
              var x = c.indexOf("--") === 0;
              r += u + (x ? c : nv(c)) + ":", r += Zf(c, p, x), u = ";";
            }
          }
        return r || null;
      }
    }
    function lv(t, r) {
      var u = t.style;
      for (var c in r)
        if (r.hasOwnProperty(c)) {
          var p = c.indexOf("--") === 0;
          p || ov(c, r[c]);
          var x = Zf(c, r[c], p);
          c === "float" && (c = "cssFloat"), p ? u.setProperty(c, x) : u[c] = x;
        }
    }
    function am(t) {
      return t == null || typeof t == "boolean" || t === "";
    }
    function Ns(t) {
      var r = {};
      for (var u in t)
        for (var c = lc[u] || [u], p = 0; p < c.length; p++)
          r[c[p]] = u;
      return r;
    }
    function le(t, r) {
      {
        if (!r)
          return;
        var u = Ns(t), c = Ns(r), p = {};
        for (var x in u) {
          var _ = u[x], O = c[x];
          if (O && _ !== O) {
            var k = _ + "," + O;
            if (p[k])
              continue;
            p[k] = !0, m("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", am(t[_]) ? "Removing" : "Updating", _, O);
          }
        }
      }
    }
    var Ee = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, we = mt({
      menuitem: !0
    }, Ee), ut = "__html";
    function Gt(t, r) {
      if (r) {
        if (we[t] && (r.children != null || r.dangerouslySetInnerHTML != null))
          throw new Error(t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (r.dangerouslySetInnerHTML != null) {
          if (r.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof r.dangerouslySetInnerHTML != "object" || !(ut in r.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!r.suppressContentEditableWarning && r.contentEditable && r.children != null && m("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), r.style != null && typeof r.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function cn(t, r) {
      if (t.indexOf("-") === -1)
        return typeof r.is == "string";
      switch (t) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Lr = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, tr = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, bl = {}, om = new RegExp("^(aria)-[" + Qe + "]*$"), Ei = new RegExp("^(aria)[A-Z][" + Qe + "]*$");
    function tu(t, r) {
      {
        if (Wn.call(bl, r) && bl[r])
          return !0;
        if (Ei.test(r)) {
          var u = "aria-" + r.slice(4).toLowerCase(), c = tr.hasOwnProperty(u) ? u : null;
          if (c == null)
            return m("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", r), bl[r] = !0, !0;
          if (r !== c)
            return m("Invalid ARIA attribute `%s`. Did you mean `%s`?", r, c), bl[r] = !0, !0;
        }
        if (om.test(r)) {
          var p = r.toLowerCase(), x = tr.hasOwnProperty(p) ? p : null;
          if (x == null)
            return bl[r] = !0, !1;
          if (r !== x)
            return m("Unknown ARIA attribute `%s`. Did you mean `%s`?", r, x), bl[r] = !0, !0;
        }
      }
      return !0;
    }
    function Lh(t, r) {
      {
        var u = [];
        for (var c in r) {
          var p = tu(t, c);
          p || u.push(c);
        }
        var x = u.map(function(_) {
          return "`" + _ + "`";
        }).join(", ");
        u.length === 1 ? m("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", x, t) : u.length > 1 && m("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", x, t);
      }
    }
    function _l(t, r) {
      cn(t, r) || Lh(t, r);
    }
    var Vs = !1;
    function sc(t, r) {
      {
        if (t !== "input" && t !== "textarea" && t !== "select")
          return;
        r != null && r.value === null && !Vs && (Vs = !0, t === "select" && r.multiple ? m("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", t) : m("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", t));
      }
    }
    var Dn = function() {
    };
    {
      var ua = {}, cc = /^on./, fc = /^on[^A-Z]/, Vf = new RegExp("^(aria)-[" + Qe + "]*$"), uv = new RegExp("^(aria)[A-Z][" + Qe + "]*$");
      Dn = function(t, r, u, c) {
        if (Wn.call(ua, r) && ua[r])
          return !0;
        var p = r.toLowerCase();
        if (p === "onfocusin" || p === "onfocusout")
          return m("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), ua[r] = !0, !0;
        if (c != null) {
          var x = c.registrationNameDependencies, _ = c.possibleRegistrationNames;
          if (x.hasOwnProperty(r))
            return !0;
          var O = _.hasOwnProperty(p) ? _[p] : null;
          if (O != null)
            return m("Invalid event handler property `%s`. Did you mean `%s`?", r, O), ua[r] = !0, !0;
          if (cc.test(r))
            return m("Unknown event handler property `%s`. It will be ignored.", r), ua[r] = !0, !0;
        } else if (cc.test(r))
          return fc.test(r) && m("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", r), ua[r] = !0, !0;
        if (Vf.test(r) || uv.test(r))
          return !0;
        if (p === "innerhtml")
          return m("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), ua[r] = !0, !0;
        if (p === "aria")
          return m("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), ua[r] = !0, !0;
        if (p === "is" && u !== null && u !== void 0 && typeof u != "string")
          return m("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof u), ua[r] = !0, !0;
        if (typeof u == "number" && isNaN(u))
          return m("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", r), ua[r] = !0, !0;
        var k = br(r), V = k !== null && k.type === jt;
        if (Lr.hasOwnProperty(p)) {
          var U = Lr[p];
          if (U !== r)
            return m("Invalid DOM property `%s`. Did you mean `%s`?", r, U), ua[r] = !0, !0;
        } else if (!V && r !== p)
          return m("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", r, p), ua[r] = !0, !0;
        return typeof u == "boolean" && Nr(r, u, k, !1) ? (u ? m('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', u, r, r, u, r) : m('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', u, r, r, u, r, r, r), ua[r] = !0, !0) : V ? !0 : Nr(r, u, k, !1) ? (ua[r] = !0, !1) : ((u === "false" || u === "true") && k !== null && k.type === Ge && (m("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", u, r, u === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', r, u), ua[r] = !0), !0);
      };
    }
    var sv = function(t, r, u) {
      {
        var c = [];
        for (var p in r) {
          var x = Dn(t, p, r[p], u);
          x || c.push(p);
        }
        var _ = c.map(function(O) {
          return "`" + O + "`";
        }).join(", ");
        c.length === 1 ? m("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", _, t) : c.length > 1 && m("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", _, t);
      }
    };
    function dc(t, r, u) {
      cn(t, r) || sv(t, r, u);
    }
    var Rl = 1, Fs = 2, Bs = 4, Ji = Rl | Fs | Bs, Yu = null;
    function Ff(t) {
      Yu !== null && m("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Yu = t;
    }
    function Bf() {
      Yu === null && m("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Yu = null;
    }
    function cv(t) {
      return t === Yu;
    }
    function el(t) {
      var r = t.target || t.srcElement || window;
      return r.correspondingUseElement && (r = r.correspondingUseElement), r.nodeType === Xi ? r.parentNode : r;
    }
    var nu = null, El = null, Us = null;
    function vr(t) {
      var r = Oe(t);
      if (r) {
        if (typeof nu != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var u = r.stateNode;
        if (u) {
          var c = Ve(u);
          nu(r.stateNode, r.type, c);
        }
      }
    }
    function Ih(t) {
      nu = t;
    }
    function $u(t) {
      El ? Us ? Us.push(t) : Us = [t] : El = t;
    }
    function Wu() {
      return El !== null || Us !== null;
    }
    function hc() {
      if (El) {
        var t = El, r = Us;
        if (El = null, Us = null, vr(t), r)
          for (var u = 0; u < r.length; u++)
            vr(r[u]);
      }
    }
    var Uf = function(t, r) {
      return t(r);
    }, Ys = function() {
    }, F1 = !1;
    function B1() {
      var t = Wu();
      t && (Ys(), hc());
    }
    function Kr(t, r, u) {
      if (F1)
        return t(r, u);
      F1 = !0;
      try {
        return Uf(t, r, u);
      } finally {
        F1 = !1, B1();
      }
    }
    function ro(t, r, u) {
      Uf = t, Ys = u;
    }
    function im(t) {
      return t === "button" || t === "input" || t === "select" || t === "textarea";
    }
    function fv(t, r, u) {
      switch (t) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(u.disabled && im(r));
        default:
          return !1;
      }
    }
    function ru(t, r) {
      var u = t.stateNode;
      if (u === null)
        return null;
      var c = Ve(u);
      if (c === null)
        return null;
      var p = c[r];
      if (fv(r, t.type, c))
        return null;
      if (p && typeof p != "function")
        throw new Error("Expected `" + r + "` listener to be a function, instead got a value of `" + typeof p + "` type.");
      return p;
    }
    var U1 = !1;
    if (ar)
      try {
        var au = {};
        Object.defineProperty(au, "passive", {
          get: function() {
            U1 = !0;
          }
        }), window.addEventListener("test", au, au), window.removeEventListener("test", au, au);
      } catch {
        U1 = !1;
      }
    function zu(t, r, u, c, p, x, _, O, k) {
      var V = Array.prototype.slice.call(arguments, 3);
      try {
        r.apply(u, V);
      } catch (U) {
        this.onError(U);
      }
    }
    var Y1 = zu;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var Ml = document.createElement("react");
      Y1 = function(r, u, c, p, x, _, O, k, V) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var U = document.createEvent("Event"), ae = !1, re = !0, xe = window.event, Ce = Object.getOwnPropertyDescriptor(window, "event");
        function Me() {
          Ml.removeEventListener(Te, Ft, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = xe);
        }
        var it = Array.prototype.slice.call(arguments, 3);
        function Ft() {
          ae = !0, Me(), u.apply(c, it), re = !1;
        }
        var At, kn = !1, xn = !1;
        function he(ve) {
          if (At = ve.error, kn = !0, At === null && ve.colno === 0 && ve.lineno === 0 && (xn = !0), ve.defaultPrevented && At != null && typeof At == "object")
            try {
              At._suppressLogging = !0;
            } catch {
            }
        }
        var Te = "react-" + (r || "invokeguardedcallback");
        if (window.addEventListener("error", he), Ml.addEventListener(Te, Ft, !1), U.initEvent(Te, !1, !1), Ml.dispatchEvent(U), Ce && Object.defineProperty(window, "event", Ce), ae && re && (kn ? xn && (At = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : At = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(At)), window.removeEventListener("error", he), !ae)
          return Me(), zu.apply(this, arguments);
      };
    }
    var vc = Y1, tl = !1, $s = null, ou = !1, pc = null, qu = {
      onError: function(t) {
        tl = !0, $s = t;
      }
    };
    function Yf(t, r, u, c, p, x, _, O, k) {
      tl = !1, $s = null, vc.apply(qu, arguments);
    }
    function $1(t, r, u, c, p, x, _, O, k) {
      if (Yf.apply(this, arguments), tl) {
        var V = mo();
        ou || (ou = !0, pc = V);
      }
    }
    function Tl() {
      if (ou) {
        var t = pc;
        throw ou = !1, pc = null, t;
      }
    }
    function Gu() {
      return tl;
    }
    function mo() {
      if (tl) {
        var t = $s;
        return tl = !1, $s = null, t;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function iu(t) {
      return t._reactInternals;
    }
    function P(t) {
      return t._reactInternals !== void 0;
    }
    function W1(t, r) {
      t._reactInternals = r;
    }
    var Et = (
      /*                      */
      0
    ), Qr = (
      /*                */
      1
    ), Tt = (
      /*                    */
      2
    ), un = (
      /*                       */
      4
    ), lu = (
      /*                */
      16
    ), Ol = (
      /*                 */
      32
    ), ao = (
      /*                     */
      64
    ), Dt = (
      /*                   */
      128
    ), Rn = (
      /*            */
      256
    ), go = (
      /*                          */
      512
    ), Br = (
      /*                     */
      1024
    ), Mr = (
      /*                      */
      2048
    ), Ir = (
      /*                    */
      4096
    ), Mi = (
      /*                   */
      8192
    ), Ya = (
      /*             */
      16384
    ), $f = Mr | un | ao | go | Br | Ya, dv = (
      /*               */
      32767
    ), z1 = (
      /*                   */
      32768
    ), pr = (
      /*                */
      65536
    ), Wf = (
      /* */
      131072
    ), Dl = (
      /*                       */
      1048576
    ), q1 = (
      /*                    */
      2097152
    ), uu = (
      /*                 */
      4194304
    ), zf = (
      /*                */
      8388608
    ), wo = (
      /*               */
      16777216
    ), nl = (
      /*              */
      33554432
    ), Ku = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      un | Br | 0
    ), Aa = Tt | un | lu | Ol | go | Ir | Mi, Qu = un | ao | go | Mi, su = Mr | lu, sa = uu | zf | q1, Ti = a.ReactCurrentOwner;
    function ii(t) {
      var r = t, u = t;
      if (t.alternate)
        for (; r.return; )
          r = r.return;
      else {
        var c = r;
        do
          r = c, (r.flags & (Tt | Ir)) !== Et && (u = r.return), c = r.return;
        while (c);
      }
      return r.tag === T ? u : null;
    }
    function rl(t) {
      if (t.tag === Y) {
        var r = t.memoizedState;
        if (r === null) {
          var u = t.alternate;
          u !== null && (r = u.memoizedState);
        }
        if (r !== null)
          return r.dehydrated;
      }
      return null;
    }
    function al(t) {
      return t.tag === T ? t.stateNode.containerInfo : null;
    }
    function Ws(t) {
      return ii(t) === t;
    }
    function hv(t) {
      {
        var r = Ti.current;
        if (r !== null && r.tag === R) {
          var u = r, c = u.stateNode;
          c._warnedAboutRefsInRender || m("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", tn(u) || "A component"), c._warnedAboutRefsInRender = !0;
        }
      }
      var p = iu(t);
      return p ? ii(p) === p : !1;
    }
    function G1(t) {
      if (ii(t) !== t)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function Xu(t) {
      var r = t.alternate;
      if (!r) {
        var u = ii(t);
        if (u === null)
          throw new Error("Unable to find node on an unmounted component.");
        return u !== t ? null : t;
      }
      for (var c = t, p = r; ; ) {
        var x = c.return;
        if (x === null)
          break;
        var _ = x.alternate;
        if (_ === null) {
          var O = x.return;
          if (O !== null) {
            c = p = O;
            continue;
          }
          break;
        }
        if (x.child === _.child) {
          for (var k = x.child; k; ) {
            if (k === c)
              return G1(x), t;
            if (k === p)
              return G1(x), r;
            k = k.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (c.return !== p.return)
          c = x, p = _;
        else {
          for (var V = !1, U = x.child; U; ) {
            if (U === c) {
              V = !0, c = x, p = _;
              break;
            }
            if (U === p) {
              V = !0, p = x, c = _;
              break;
            }
            U = U.sibling;
          }
          if (!V) {
            for (U = _.child; U; ) {
              if (U === c) {
                V = !0, c = _, p = x;
                break;
              }
              if (U === p) {
                V = !0, p = _, c = x;
                break;
              }
              U = U.sibling;
            }
            if (!V)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (c.alternate !== p)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (c.tag !== T)
        throw new Error("Unable to find node on an unmounted component.");
      return c.stateNode.current === c ? t : r;
    }
    function $a(t) {
      var r = Xu(t);
      return r !== null ? No(r) : null;
    }
    function No(t) {
      if (t.tag === j || t.tag === I)
        return t;
      for (var r = t.child; r !== null; ) {
        var u = No(r);
        if (u !== null)
          return u;
        r = r.sibling;
      }
      return null;
    }
    function xr(t) {
      var r = Xu(t);
      return r !== null ? Oi(r) : null;
    }
    function Oi(t) {
      if (t.tag === j || t.tag === I)
        return t;
      for (var r = t.child; r !== null; ) {
        if (r.tag !== A) {
          var u = Oi(r);
          if (u !== null)
            return u;
        }
        r = r.sibling;
      }
      return null;
    }
    var ol = n.unstable_scheduleCallback, qf = n.unstable_cancelCallback, cu = n.unstable_shouldYield, Vo = n.unstable_requestPaint, ya = n.unstable_now, mc = n.unstable_getCurrentPriorityLevel, K1 = n.unstable_ImmediatePriority, Di = n.unstable_UserBlockingPriority, oo = n.unstable_NormalPriority, vv = n.unstable_LowPriority, zs = n.unstable_IdlePriority, qs = n.unstable_yieldValue, pv = n.unstable_setDisableYieldValue, Ju = null, hn = null, et = null, Fo = !1, Hr = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function es(t) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var r = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (r.isDisabled)
        return !0;
      if (!r.supportsFiber)
        return m("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        t = mt({}, t, {
          getLaneLabelMap: Gs,
          injectProfilingHooks: Ai
        }), Ju = r.inject(t), hn = r;
      } catch (u) {
        m("React instrumentation encountered an error: %s.", u);
      }
      return !!r.checkDCE;
    }
    function Q1(t, r) {
      if (hn && typeof hn.onScheduleFiberRoot == "function")
        try {
          hn.onScheduleFiberRoot(Ju, t, r);
        } catch (u) {
          Fo || (Fo = !0, m("React instrumentation encountered an error: %s", u));
        }
    }
    function fu(t, r) {
      if (hn && typeof hn.onCommitFiberRoot == "function")
        try {
          var u = (t.current.flags & Dt) === Dt;
          {
            var c;
            switch (r) {
              case qa:
                c = K1;
                break;
              case uo:
                c = Di;
                break;
              case Pi:
                c = oo;
                break;
              case Uo:
                c = zs;
                break;
              default:
                c = oo;
                break;
            }
            hn.onCommitFiberRoot(Ju, t, c, u);
          }
        } catch (p) {
          Fo || (Fo = !0, m("React instrumentation encountered an error: %s", p));
        }
    }
    function Gf(t) {
      if (hn && typeof hn.onPostCommitFiberRoot == "function")
        try {
          hn.onPostCommitFiberRoot(Ju, t);
        } catch (r) {
          Fo || (Fo = !0, m("React instrumentation encountered an error: %s", r));
        }
    }
    function Wa(t) {
      if (hn && typeof hn.onCommitFiberUnmount == "function")
        try {
          hn.onCommitFiberUnmount(Ju, t);
        } catch (r) {
          Fo || (Fo = !0, m("React instrumentation encountered an error: %s", r));
        }
    }
    function Sr(t) {
      if (typeof qs == "function" && (pv(t), h(t)), hn && typeof hn.setStrictMode == "function")
        try {
          hn.setStrictMode(Ju, t);
        } catch (r) {
          Fo || (Fo = !0, m("React instrumentation encountered an error: %s", r));
        }
    }
    function Ai(t) {
      et = t;
    }
    function Gs() {
      {
        for (var t = /* @__PURE__ */ new Map(), r = 1, u = 0; u < pu; u++) {
          var c = xo(r);
          t.set(r, c), r *= 2;
        }
        return t;
      }
    }
    function Hh(t) {
      et !== null && typeof et.markCommitStarted == "function" && et.markCommitStarted(t);
    }
    function gc() {
      et !== null && typeof et.markCommitStopped == "function" && et.markCommitStopped();
    }
    function li(t) {
      et !== null && typeof et.markComponentRenderStarted == "function" && et.markComponentRenderStarted(t);
    }
    function za() {
      et !== null && typeof et.markComponentRenderStopped == "function" && et.markComponentRenderStopped();
    }
    function Kf(t) {
      et !== null && typeof et.markComponentPassiveEffectMountStarted == "function" && et.markComponentPassiveEffectMountStarted(t);
    }
    function mv() {
      et !== null && typeof et.markComponentPassiveEffectMountStopped == "function" && et.markComponentPassiveEffectMountStopped();
    }
    function du(t) {
      et !== null && typeof et.markComponentPassiveEffectUnmountStarted == "function" && et.markComponentPassiveEffectUnmountStarted(t);
    }
    function ji() {
      et !== null && typeof et.markComponentPassiveEffectUnmountStopped == "function" && et.markComponentPassiveEffectUnmountStopped();
    }
    function Qf(t) {
      et !== null && typeof et.markComponentLayoutEffectMountStarted == "function" && et.markComponentLayoutEffectMountStarted(t);
    }
    function gv() {
      et !== null && typeof et.markComponentLayoutEffectMountStopped == "function" && et.markComponentLayoutEffectMountStopped();
    }
    function Ks(t) {
      et !== null && typeof et.markComponentLayoutEffectUnmountStarted == "function" && et.markComponentLayoutEffectUnmountStarted(t);
    }
    function Xf() {
      et !== null && typeof et.markComponentLayoutEffectUnmountStopped == "function" && et.markComponentLayoutEffectUnmountStopped();
    }
    function wc(t, r, u) {
      et !== null && typeof et.markComponentErrored == "function" && et.markComponentErrored(t, r, u);
    }
    function Al(t, r, u) {
      et !== null && typeof et.markComponentSuspended == "function" && et.markComponentSuspended(t, r, u);
    }
    function yc(t) {
      et !== null && typeof et.markLayoutEffectsStarted == "function" && et.markLayoutEffectsStarted(t);
    }
    function X1() {
      et !== null && typeof et.markLayoutEffectsStopped == "function" && et.markLayoutEffectsStopped();
    }
    function hu(t) {
      et !== null && typeof et.markPassiveEffectsStarted == "function" && et.markPassiveEffectsStarted(t);
    }
    function Zh() {
      et !== null && typeof et.markPassiveEffectsStopped == "function" && et.markPassiveEffectsStopped();
    }
    function vu(t) {
      et !== null && typeof et.markRenderStarted == "function" && et.markRenderStarted(t);
    }
    function Ph() {
      et !== null && typeof et.markRenderYielded == "function" && et.markRenderYielded();
    }
    function xc() {
      et !== null && typeof et.markRenderStopped == "function" && et.markRenderStopped();
    }
    function Tr(t) {
      et !== null && typeof et.markRenderScheduled == "function" && et.markRenderScheduled(t);
    }
    function Qs(t, r) {
      et !== null && typeof et.markForceUpdateScheduled == "function" && et.markForceUpdateScheduled(t, r);
    }
    function Sc(t, r) {
      et !== null && typeof et.markStateUpdateScheduled == "function" && et.markStateUpdateScheduled(t, r);
    }
    var kt = (
      /*                         */
      0
    ), an = (
      /*                 */
      1
    ), Nn = (
      /*                    */
      2
    ), nr = (
      /*               */
      8
    ), Vn = (
      /*              */
      16
    ), Ur = Math.clz32 ? Math.clz32 : Cc, xa = Math.log, J1 = Math.LN2;
    function Cc(t) {
      var r = t >>> 0;
      return r === 0 ? 32 : 31 - (xa(r) / J1 | 0) | 0;
    }
    var pu = 31, be = (
      /*                        */
      0
    ), An = (
      /*                          */
      0
    ), Wt = (
      /*                        */
      1
    ), ki = (
      /*    */
      2
    ), Li = (
      /*             */
      4
    ), io = (
      /*            */
      8
    ), Xr = (
      /*                     */
      16
    ), ca = (
      /*                */
      32
    ), ts = (
      /*                       */
      4194240
    ), jl = (
      /*                        */
      64
    ), e0 = (
      /*                        */
      128
    ), bc = (
      /*                        */
      256
    ), _c = (
      /*                        */
      512
    ), lo = (
      /*                        */
      1024
    ), il = (
      /*                        */
      2048
    ), t0 = (
      /*                        */
      4096
    ), Rc = (
      /*                        */
      8192
    ), Xs = (
      /*                        */
      16384
    ), ns = (
      /*                       */
      32768
    ), n0 = (
      /*                       */
      65536
    ), Js = (
      /*                       */
      131072
    ), rs = (
      /*                       */
      262144
    ), r0 = (
      /*                       */
      524288
    ), Ii = (
      /*                       */
      1048576
    ), Jf = (
      /*                       */
      2097152
    ), Hi = (
      /*                            */
      130023424
    ), as = (
      /*                             */
      4194304
    ), Ec = (
      /*                             */
      8388608
    ), e1 = (
      /*                             */
      16777216
    ), ed = (
      /*                             */
      33554432
    ), td = (
      /*                             */
      67108864
    ), Nh = as, a0 = (
      /*          */
      134217728
    ), nd = (
      /*                          */
      268435455
    ), Mc = (
      /*               */
      268435456
    ), os = (
      /*                        */
      536870912
    ), yo = (
      /*                   */
      1073741824
    );
    function xo(t) {
      {
        if (t & Wt)
          return "Sync";
        if (t & ki)
          return "InputContinuousHydration";
        if (t & Li)
          return "InputContinuous";
        if (t & io)
          return "DefaultHydration";
        if (t & Xr)
          return "Default";
        if (t & ca)
          return "TransitionHydration";
        if (t & ts)
          return "Transition";
        if (t & Hi)
          return "Retry";
        if (t & a0)
          return "SelectiveHydration";
        if (t & Mc)
          return "IdleHydration";
        if (t & os)
          return "Idle";
        if (t & yo)
          return "Offscreen";
      }
    }
    var mn = -1, t1 = jl, rd = as;
    function is(t) {
      switch (wu(t)) {
        case Wt:
          return Wt;
        case ki:
          return ki;
        case Li:
          return Li;
        case io:
          return io;
        case Xr:
          return Xr;
        case ca:
          return ca;
        case jl:
        case e0:
        case bc:
        case _c:
        case lo:
        case il:
        case t0:
        case Rc:
        case Xs:
        case ns:
        case n0:
        case Js:
        case rs:
        case r0:
        case Ii:
        case Jf:
          return t & ts;
        case as:
        case Ec:
        case e1:
        case ed:
        case td:
          return t & Hi;
        case a0:
          return a0;
        case Mc:
          return Mc;
        case os:
          return os;
        case yo:
          return yo;
        default:
          return m("Should have found matching lanes. This is a bug in React."), t;
      }
    }
    function mu(t, r) {
      var u = t.pendingLanes;
      if (u === be)
        return be;
      var c = be, p = t.suspendedLanes, x = t.pingedLanes, _ = u & nd;
      if (_ !== be) {
        var O = _ & ~p;
        if (O !== be)
          c = is(O);
        else {
          var k = _ & x;
          k !== be && (c = is(k));
        }
      } else {
        var V = u & ~p;
        V !== be ? c = is(V) : x !== be && (c = is(x));
      }
      if (c === be)
        return be;
      if (r !== be && r !== c && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (r & p) === be) {
        var U = wu(c), ae = wu(r);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          U >= ae || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          U === Xr && (ae & ts) !== be
        )
          return r;
      }
      (c & Li) !== be && (c |= u & Xr);
      var re = t.entangledLanes;
      if (re !== be)
        for (var xe = t.entanglements, Ce = c & re; Ce > 0; ) {
          var Me = Jr(Ce), it = 1 << Me;
          c |= xe[Me], Ce &= ~it;
        }
      return c;
    }
    function Zi(t, r) {
      for (var u = t.eventTimes, c = mn; r > 0; ) {
        var p = Jr(r), x = 1 << p, _ = u[p];
        _ > c && (c = _), r &= ~x;
      }
      return c;
    }
    function ad(t, r) {
      switch (t) {
        case Wt:
        case ki:
        case Li:
          return r + 250;
        case io:
        case Xr:
        case ca:
        case jl:
        case e0:
        case bc:
        case _c:
        case lo:
        case il:
        case t0:
        case Rc:
        case Xs:
        case ns:
        case n0:
        case Js:
        case rs:
        case r0:
        case Ii:
        case Jf:
          return r + 5e3;
        case as:
        case Ec:
        case e1:
        case ed:
        case td:
          return mn;
        case a0:
        case Mc:
        case os:
        case yo:
          return mn;
        default:
          return m("Should have found matching lanes. This is a bug in React."), mn;
      }
    }
    function od(t, r) {
      for (var u = t.pendingLanes, c = t.suspendedLanes, p = t.pingedLanes, x = t.expirationTimes, _ = u; _ > 0; ) {
        var O = Jr(_), k = 1 << O, V = x[O];
        V === mn ? ((k & c) === be || (k & p) !== be) && (x[O] = ad(k, r)) : V <= r && (t.expiredLanes |= k), _ &= ~k;
      }
    }
    function Vh(t) {
      return is(t.pendingLanes);
    }
    function gu(t) {
      var r = t.pendingLanes & ~yo;
      return r !== be ? r : r & yo ? yo : be;
    }
    function o0(t) {
      return (t & Wt) !== be;
    }
    function Tc(t) {
      return (t & nd) !== be;
    }
    function ls(t) {
      return (t & Hi) === t;
    }
    function id(t) {
      var r = Wt | Li | Xr;
      return (t & r) === be;
    }
    function i0(t) {
      return (t & ts) === t;
    }
    function Oc(t, r) {
      var u = ki | Li | io | Xr;
      return (r & u) !== be;
    }
    function Dc(t, r) {
      return (r & t.expiredLanes) !== be;
    }
    function Ac(t) {
      return (t & ts) !== be;
    }
    function l0() {
      var t = t1;
      return t1 <<= 1, (t1 & ts) === be && (t1 = jl), t;
    }
    function wv() {
      var t = rd;
      return rd <<= 1, (rd & Hi) === be && (rd = as), t;
    }
    function wu(t) {
      return t & -t;
    }
    function us(t) {
      return wu(t);
    }
    function Jr(t) {
      return 31 - Ur(t);
    }
    function Sa(t) {
      return Jr(t);
    }
    function Bo(t, r) {
      return (t & r) !== be;
    }
    function ss(t, r) {
      return (t & r) === r;
    }
    function Bt(t, r) {
      return t | r;
    }
    function u0(t, r) {
      return t & ~r;
    }
    function ld(t, r) {
      return t & r;
    }
    function yv(t) {
      return t;
    }
    function Fh(t, r) {
      return t !== An && t < r ? t : r;
    }
    function jc(t) {
      for (var r = [], u = 0; u < pu; u++)
        r.push(t);
      return r;
    }
    function s0(t, r, u) {
      t.pendingLanes |= r, r !== os && (t.suspendedLanes = be, t.pingedLanes = be);
      var c = t.eventTimes, p = Sa(r);
      c[p] = u;
    }
    function kl(t, r) {
      t.suspendedLanes |= r, t.pingedLanes &= ~r;
      for (var u = t.expirationTimes, c = r; c > 0; ) {
        var p = Jr(c), x = 1 << p;
        u[p] = mn, c &= ~x;
      }
    }
    function c0(t, r, u) {
      t.pingedLanes |= t.suspendedLanes & r;
    }
    function kc(t, r) {
      var u = t.pendingLanes & ~r;
      t.pendingLanes = r, t.suspendedLanes = be, t.pingedLanes = be, t.expiredLanes &= r, t.mutableReadLanes &= r, t.entangledLanes &= r;
      for (var c = t.entanglements, p = t.eventTimes, x = t.expirationTimes, _ = u; _ > 0; ) {
        var O = Jr(_), k = 1 << O;
        c[O] = be, p[O] = mn, x[O] = mn, _ &= ~k;
      }
    }
    function f0(t, r) {
      for (var u = t.entangledLanes |= r, c = t.entanglements, p = u; p; ) {
        var x = Jr(p), _ = 1 << x;
        // Is this one of the newly entangled lanes?
        _ & r | // Is this lane transitively entangled with the newly entangled lanes?
        c[x] & r && (c[x] |= r), p &= ~_;
      }
    }
    function d0(t, r) {
      var u = wu(r), c;
      switch (u) {
        case Li:
          c = ki;
          break;
        case Xr:
          c = io;
          break;
        case jl:
        case e0:
        case bc:
        case _c:
        case lo:
        case il:
        case t0:
        case Rc:
        case Xs:
        case ns:
        case n0:
        case Js:
        case rs:
        case r0:
        case Ii:
        case Jf:
        case as:
        case Ec:
        case e1:
        case ed:
        case td:
          c = ca;
          break;
        case os:
          c = Mc;
          break;
        default:
          c = An;
          break;
      }
      return (c & (t.suspendedLanes | r)) !== An ? An : c;
    }
    function Ll(t, r, u) {
      if (Hr)
        for (var c = t.pendingUpdatersLaneMap; u > 0; ) {
          var p = Sa(u), x = 1 << p, _ = c[p];
          _.add(r), u &= ~x;
        }
    }
    function Vt(t, r) {
      if (Hr)
        for (var u = t.pendingUpdatersLaneMap, c = t.memoizedUpdaters; r > 0; ) {
          var p = Sa(r), x = 1 << p, _ = u[p];
          _.size > 0 && (_.forEach(function(O) {
            var k = O.alternate;
            (k === null || !c.has(k)) && c.add(O);
          }), _.clear()), r &= ~x;
        }
    }
    function h0(t, r) {
      return null;
    }
    var qa = Wt, uo = Li, Pi = Xr, Uo = os, v0 = An;
    function fr() {
      return v0;
    }
    function fa(t) {
      v0 = t;
    }
    function xv(t, r) {
      var u = v0;
      try {
        return v0 = t, r();
      } finally {
        v0 = u;
      }
    }
    function Bh(t, r) {
      return t !== 0 && t < r ? t : r;
    }
    function Lc(t, r) {
      return t > r ? t : r;
    }
    function Ca(t, r) {
      return t !== 0 && t < r;
    }
    function Sv(t) {
      var r = wu(t);
      return Ca(qa, r) ? Ca(uo, r) ? Tc(r) ? Pi : Uo : uo : qa;
    }
    function ud(t) {
      var r = t.current.memoizedState;
      return r.isDehydrated;
    }
    var Ic;
    function Or(t) {
      Ic = t;
    }
    function So(t) {
      Ic(t);
    }
    var ct;
    function p0(t) {
      ct = t;
    }
    var m0;
    function Cv(t) {
      m0 = t;
    }
    var bv;
    function yu(t) {
      bv = t;
    }
    var g0;
    function sd(t) {
      g0 = t;
    }
    var cd = !1, Hc = [], xu = null, Il = null, ll = null, Yr = /* @__PURE__ */ new Map(), Co = /* @__PURE__ */ new Map(), Ga = [], Uh = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function w0(t) {
      return Uh.indexOf(t) > -1;
    }
    function ui(t, r, u, c, p) {
      return {
        blockedOn: t,
        domEventName: r,
        eventSystemFlags: u,
        nativeEvent: p,
        targetContainers: [c]
      };
    }
    function fd(t, r) {
      switch (t) {
        case "focusin":
        case "focusout":
          xu = null;
          break;
        case "dragenter":
        case "dragleave":
          Il = null;
          break;
        case "mouseover":
        case "mouseout":
          ll = null;
          break;
        case "pointerover":
        case "pointerout": {
          var u = r.pointerId;
          Yr.delete(u);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var c = r.pointerId;
          Co.delete(c);
          break;
        }
      }
    }
    function bo(t, r, u, c, p, x) {
      if (t === null || t.nativeEvent !== x) {
        var _ = ui(r, u, c, p, x);
        if (r !== null) {
          var O = Oe(r);
          O !== null && ct(O);
        }
        return _;
      }
      t.eventSystemFlags |= c;
      var k = t.targetContainers;
      return p !== null && k.indexOf(p) === -1 && k.push(p), t;
    }
    function dd(t, r, u, c, p) {
      switch (r) {
        case "focusin": {
          var x = p;
          return xu = bo(xu, t, r, u, c, x), !0;
        }
        case "dragenter": {
          var _ = p;
          return Il = bo(Il, t, r, u, c, _), !0;
        }
        case "mouseover": {
          var O = p;
          return ll = bo(ll, t, r, u, c, O), !0;
        }
        case "pointerover": {
          var k = p, V = k.pointerId;
          return Yr.set(V, bo(Yr.get(V) || null, t, r, u, c, k)), !0;
        }
        case "gotpointercapture": {
          var U = p, ae = U.pointerId;
          return Co.set(ae, bo(Co.get(ae) || null, t, r, u, c, U)), !0;
        }
      }
      return !1;
    }
    function hd(t) {
      var r = se(t.target);
      if (r !== null) {
        var u = ii(r);
        if (u !== null) {
          var c = u.tag;
          if (c === Y) {
            var p = rl(u);
            if (p !== null) {
              t.blockedOn = p, g0(t.priority, function() {
                m0(u);
              });
              return;
            }
          } else if (c === T) {
            var x = u.stateNode;
            if (ud(x)) {
              t.blockedOn = al(u);
              return;
            }
          }
        }
      }
      t.blockedOn = null;
    }
    function ul(t) {
      for (var r = bv(), u = {
        blockedOn: null,
        target: t,
        priority: r
      }, c = 0; c < Ga.length && Ca(r, Ga[c].priority); c++)
        ;
      Ga.splice(c, 0, u), c === 0 && hd(u);
    }
    function sl(t) {
      if (t.blockedOn !== null)
        return !1;
      for (var r = t.targetContainers; r.length > 0; ) {
        var u = r[0], c = r1(t.domEventName, t.eventSystemFlags, u, t.nativeEvent);
        if (c === null) {
          var p = t.nativeEvent, x = new p.constructor(p.type, p);
          Ff(x), p.target.dispatchEvent(x), Bf();
        } else {
          var _ = Oe(c);
          return _ !== null && ct(_), t.blockedOn = c, !1;
        }
        r.shift();
      }
      return !0;
    }
    function Yh(t, r, u) {
      sl(t) && u.delete(r);
    }
    function _v() {
      cd = !1, xu !== null && sl(xu) && (xu = null), Il !== null && sl(Il) && (Il = null), ll !== null && sl(ll) && (ll = null), Yr.forEach(Yh), Co.forEach(Yh);
    }
    function cs(t, r) {
      t.blockedOn === r && (t.blockedOn = null, cd || (cd = !0, n.unstable_scheduleCallback(n.unstable_NormalPriority, _v)));
    }
    function n1(t) {
      if (Hc.length > 0) {
        cs(Hc[0], t);
        for (var r = 1; r < Hc.length; r++) {
          var u = Hc[r];
          u.blockedOn === t && (u.blockedOn = null);
        }
      }
      xu !== null && cs(xu, t), Il !== null && cs(Il, t), ll !== null && cs(ll, t);
      var c = function(O) {
        return cs(O, t);
      };
      Yr.forEach(c), Co.forEach(c);
      for (var p = 0; p < Ga.length; p++) {
        var x = Ga[p];
        x.blockedOn === t && (x.blockedOn = null);
      }
      for (; Ga.length > 0; ) {
        var _ = Ga[0];
        if (_.blockedOn !== null)
          break;
        hd(_), _.blockedOn === null && Ga.shift();
      }
    }
    var Ka = a.ReactCurrentBatchConfig, wn = !0;
    function ba(t) {
      wn = !!t;
    }
    function da() {
      return wn;
    }
    function Qa(t, r, u) {
      var c = Pc(r), p;
      switch (c) {
        case qa:
          p = si;
          break;
        case uo:
          p = y0;
          break;
        case Pi:
        default:
          p = ea;
          break;
      }
      return p.bind(null, r, u, t);
    }
    function si(t, r, u, c) {
      var p = fr(), x = Ka.transition;
      Ka.transition = null;
      try {
        fa(qa), ea(t, r, u, c);
      } finally {
        fa(p), Ka.transition = x;
      }
    }
    function y0(t, r, u, c) {
      var p = fr(), x = Ka.transition;
      Ka.transition = null;
      try {
        fa(uo), ea(t, r, u, c);
      } finally {
        fa(p), Ka.transition = x;
      }
    }
    function ea(t, r, u, c) {
      wn && Zc(t, r, u, c);
    }
    function Zc(t, r, u, c) {
      var p = r1(t, r, u, c);
      if (p === null) {
        Cm(t, r, c, cl, u), fd(t, c);
        return;
      }
      if (dd(p, t, r, u, c)) {
        c.stopPropagation();
        return;
      }
      if (fd(t, c), r & Bs && w0(t)) {
        for (; p !== null; ) {
          var x = Oe(p);
          x !== null && So(x);
          var _ = r1(t, r, u, c);
          if (_ === null && Cm(t, r, c, cl, u), _ === p)
            break;
          p = _;
        }
        p !== null && c.stopPropagation();
        return;
      }
      Cm(t, r, c, null, u);
    }
    var cl = null;
    function r1(t, r, u, c) {
      cl = null;
      var p = el(c), x = se(p);
      if (x !== null) {
        var _ = ii(x);
        if (_ === null)
          x = null;
        else {
          var O = _.tag;
          if (O === Y) {
            var k = rl(_);
            if (k !== null)
              return k;
            x = null;
          } else if (O === T) {
            var V = _.stateNode;
            if (ud(V))
              return al(_);
            x = null;
          } else _ !== x && (x = null);
        }
      }
      return cl = x, null;
    }
    function Pc(t) {
      switch (t) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return qa;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return uo;
        case "message": {
          var r = mc();
          switch (r) {
            case K1:
              return qa;
            case Di:
              return uo;
            case oo:
            case vv:
              return Pi;
            case zs:
              return Uo;
            default:
              return Pi;
          }
        }
        default:
          return Pi;
      }
    }
    function Nc(t, r, u) {
      return t.addEventListener(r, u, !1), u;
    }
    function Yo(t, r, u) {
      return t.addEventListener(r, u, !0), u;
    }
    function $h(t, r, u, c) {
      return t.addEventListener(r, u, {
        capture: !0,
        passive: c
      }), u;
    }
    function a1(t, r, u, c) {
      return t.addEventListener(r, u, {
        passive: c
      }), u;
    }
    var ci = null, x0 = null, o1 = null;
    function fs(t) {
      return ci = t, x0 = so(), !0;
    }
    function vd() {
      ci = null, x0 = null, o1 = null;
    }
    function Su() {
      if (o1)
        return o1;
      var t, r = x0, u = r.length, c, p = so(), x = p.length;
      for (t = 0; t < u && r[t] === p[t]; t++)
        ;
      var _ = u - t;
      for (c = 1; c <= _ && r[u - c] === p[x - c]; c++)
        ;
      var O = c > 1 ? 1 - c : void 0;
      return o1 = p.slice(t, O), o1;
    }
    function so() {
      return "value" in ci ? ci.value : ci.textContent;
    }
    function ds(t) {
      var r, u = t.keyCode;
      return "charCode" in t ? (r = t.charCode, r === 0 && u === 13 && (r = 13)) : r = u, r === 10 && (r = 13), r >= 32 || r === 13 ? r : 0;
    }
    function S0() {
      return !0;
    }
    function Vc() {
      return !1;
    }
    function Xa(t) {
      function r(u, c, p, x, _) {
        this._reactName = u, this._targetInst = p, this.type = c, this.nativeEvent = x, this.target = _, this.currentTarget = null;
        for (var O in t)
          if (t.hasOwnProperty(O)) {
            var k = t[O];
            k ? this[O] = k(x) : this[O] = x[O];
          }
        var V = x.defaultPrevented != null ? x.defaultPrevented : x.returnValue === !1;
        return V ? this.isDefaultPrevented = S0 : this.isDefaultPrevented = Vc, this.isPropagationStopped = Vc, this;
      }
      return mt(r.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var u = this.nativeEvent;
          u && (u.preventDefault ? u.preventDefault() : typeof u.returnValue != "unknown" && (u.returnValue = !1), this.isDefaultPrevented = S0);
        },
        stopPropagation: function() {
          var u = this.nativeEvent;
          u && (u.stopPropagation ? u.stopPropagation() : typeof u.cancelBubble != "unknown" && (u.cancelBubble = !0), this.isPropagationStopped = S0);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: S0
      }), r;
    }
    var ha = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(t) {
        return t.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, Hl = Xa(ha), _o = mt({}, ha, {
      view: 0,
      detail: 0
    }), $o = Xa(_o), C0, Fc, i1;
    function lm(t) {
      t !== i1 && (i1 && t.type === "mousemove" ? (C0 = t.screenX - i1.screenX, Fc = t.screenY - i1.screenY) : (C0 = 0, Fc = 0), i1 = t);
    }
    var fl = mt({}, _o, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Cr,
      button: 0,
      buttons: 0,
      relatedTarget: function(t) {
        return t.relatedTarget === void 0 ? t.fromElement === t.srcElement ? t.toElement : t.fromElement : t.relatedTarget;
      },
      movementX: function(t) {
        return "movementX" in t ? t.movementX : (lm(t), C0);
      },
      movementY: function(t) {
        return "movementY" in t ? t.movementY : Fc;
      }
    }), Wh = Xa(fl), zh = mt({}, fl, {
      dataTransfer: 0
    }), l1 = Xa(zh), qh = mt({}, _o, {
      relatedTarget: 0
    }), Cu = Xa(qh), Rv = mt({}, ha, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Ev = Xa(Rv), Gh = mt({}, ha, {
      clipboardData: function(t) {
        return "clipboardData" in t ? t.clipboardData : window.clipboardData;
      }
    }), pd = Xa(Gh), um = mt({}, ha, {
      data: 0
    }), Mv = Xa(um), Tv = Mv, Ov = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, u1 = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function sm(t) {
      if (t.key) {
        var r = Ov[t.key] || t.key;
        if (r !== "Unidentified")
          return r;
      }
      if (t.type === "keypress") {
        var u = ds(t);
        return u === 13 ? "Enter" : String.fromCharCode(u);
      }
      return t.type === "keydown" || t.type === "keyup" ? u1[t.keyCode] || "Unidentified" : "";
    }
    var b0 = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function md(t) {
      var r = this, u = r.nativeEvent;
      if (u.getModifierState)
        return u.getModifierState(t);
      var c = b0[t];
      return c ? !!u[c] : !1;
    }
    function Cr(t) {
      return md;
    }
    var cm = mt({}, _o, {
      key: sm,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Cr,
      // Legacy Interface
      charCode: function(t) {
        return t.type === "keypress" ? ds(t) : 0;
      },
      keyCode: function(t) {
        return t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
      },
      which: function(t) {
        return t.type === "keypress" ? ds(t) : t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
      }
    }), Dv = Xa(cm), fm = mt({}, fl, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), Av = Xa(fm), jv = mt({}, _o, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Cr
    }), kv = Xa(jv), dm = mt({}, ha, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Ni = Xa(dm), gd = mt({}, fl, {
      deltaX: function(t) {
        return "deltaX" in t ? t.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in t ? -t.wheelDeltaX : 0
        );
      },
      deltaY: function(t) {
        return "deltaY" in t ? t.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in t ? -t.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in t ? -t.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), hm = Xa(gd), dl = [9, 13, 27, 32], Bc = 229, bu = ar && "CompositionEvent" in window, hs = null;
    ar && "documentMode" in document && (hs = document.documentMode);
    var Kh = ar && "TextEvent" in window && !hs, wd = ar && (!bu || hs && hs > 8 && hs <= 11), Lv = 32, yd = String.fromCharCode(Lv);
    function vm() {
      Qt("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), Qt("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Qt("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Qt("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Qh = !1;
    function Iv(t) {
      return (t.ctrlKey || t.altKey || t.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(t.ctrlKey && t.altKey);
    }
    function xd(t) {
      switch (t) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function Sd(t, r) {
      return t === "keydown" && r.keyCode === Bc;
    }
    function Xh(t, r) {
      switch (t) {
        case "keyup":
          return dl.indexOf(r.keyCode) !== -1;
        case "keydown":
          return r.keyCode !== Bc;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Cd(t) {
      var r = t.detail;
      return typeof r == "object" && "data" in r ? r.data : null;
    }
    function Hv(t) {
      return t.locale === "ko";
    }
    var s1 = !1;
    function bd(t, r, u, c, p) {
      var x, _;
      if (bu ? x = xd(r) : s1 ? Xh(r, c) && (x = "onCompositionEnd") : Sd(r, c) && (x = "onCompositionStart"), !x)
        return null;
      wd && !Hv(c) && (!s1 && x === "onCompositionStart" ? s1 = fs(p) : x === "onCompositionEnd" && s1 && (_ = Su()));
      var O = Bv(u, x);
      if (O.length > 0) {
        var k = new Mv(x, r, null, c, p);
        if (t.push({
          event: k,
          listeners: O
        }), _)
          k.data = _;
        else {
          var V = Cd(c);
          V !== null && (k.data = V);
        }
      }
    }
    function Uc(t, r) {
      switch (t) {
        case "compositionend":
          return Cd(r);
        case "keypress":
          var u = r.which;
          return u !== Lv ? null : (Qh = !0, yd);
        case "textInput":
          var c = r.data;
          return c === yd && Qh ? null : c;
        default:
          return null;
      }
    }
    function Jh(t, r) {
      if (s1) {
        if (t === "compositionend" || !bu && Xh(t, r)) {
          var u = Su();
          return vd(), s1 = !1, u;
        }
        return null;
      }
      switch (t) {
        case "paste":
          return null;
        case "keypress":
          if (!Iv(r)) {
            if (r.char && r.char.length > 1)
              return r.char;
            if (r.which)
              return String.fromCharCode(r.which);
          }
          return null;
        case "compositionend":
          return wd && !Hv(r) ? null : r.data;
        default:
          return null;
      }
    }
    function _d(t, r, u, c, p) {
      var x;
      if (Kh ? x = Uc(r, c) : x = Jh(r, c), !x)
        return null;
      var _ = Bv(u, "onBeforeInput");
      if (_.length > 0) {
        var O = new Tv("onBeforeInput", "beforeinput", null, c, p);
        t.push({
          event: O,
          listeners: _
        }), O.data = x;
      }
    }
    function Zv(t, r, u, c, p, x, _) {
      bd(t, r, u, c, p), _d(t, r, u, c, p);
    }
    var pm = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function vs(t) {
      var r = t && t.nodeName && t.nodeName.toLowerCase();
      return r === "input" ? !!pm[t.type] : r === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function mm(t) {
      if (!ar)
        return !1;
      var r = "on" + t, u = r in document;
      if (!u) {
        var c = document.createElement("div");
        c.setAttribute(r, "return;"), u = typeof c[r] == "function";
      }
      return u;
    }
    function Yc() {
      Qt("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function Pv(t, r, u, c) {
      $u(c);
      var p = Bv(r, "onChange");
      if (p.length > 0) {
        var x = new Hl("onChange", "change", null, u, c);
        t.push({
          event: x,
          listeners: p
        });
      }
    }
    var ps = null, o = null;
    function l(t) {
      var r = t.nodeName && t.nodeName.toLowerCase();
      return r === "select" || r === "input" && t.type === "file";
    }
    function v(t) {
      var r = [];
      Pv(r, o, t, el(t)), Kr(w, r);
    }
    function w(t) {
      Md(t, 0);
    }
    function C(t) {
      var r = je(t);
      if (Yn(r))
        return t;
    }
    function E(t, r) {
      if (t === "change")
        return r;
    }
    var H = !1;
    ar && (H = mm("input") && (!document.documentMode || document.documentMode > 9));
    function q(t, r) {
      ps = t, o = r, ps.attachEvent("onpropertychange", ye);
    }
    function ee() {
      ps && (ps.detachEvent("onpropertychange", ye), ps = null, o = null);
    }
    function ye(t) {
      t.propertyName === "value" && C(o) && v(t);
    }
    function Be(t, r, u) {
      t === "focusin" ? (ee(), q(r, u)) : t === "focusout" && ee();
    }
    function $e(t, r) {
      if (t === "selectionchange" || t === "keyup" || t === "keydown")
        return C(o);
    }
    function Ne(t) {
      var r = t.nodeName;
      return r && r.toLowerCase() === "input" && (t.type === "checkbox" || t.type === "radio");
    }
    function st(t, r) {
      if (t === "click")
        return C(r);
    }
    function yt(t, r) {
      if (t === "input" || t === "change")
        return C(r);
    }
    function St(t) {
      var r = t._wrapperState;
      !r || !r.controlled || t.type !== "number" || Ba(t, "number", t.value);
    }
    function ta(t, r, u, c, p, x, _) {
      var O = u ? je(u) : window, k, V;
      if (l(O) ? k = E : vs(O) ? H ? k = yt : (k = $e, V = Be) : Ne(O) && (k = st), k) {
        var U = k(r, u);
        if (U) {
          Pv(t, U, c, p);
          return;
        }
      }
      V && V(r, O, u), r === "focusout" && St(O);
    }
    function fe() {
      Hn("onMouseEnter", ["mouseout", "mouseover"]), Hn("onMouseLeave", ["mouseout", "mouseover"]), Hn("onPointerEnter", ["pointerout", "pointerover"]), Hn("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function ne(t, r, u, c, p, x, _) {
      var O = r === "mouseover" || r === "pointerover", k = r === "mouseout" || r === "pointerout";
      if (O && !cv(c)) {
        var V = c.relatedTarget || c.fromElement;
        if (V && (se(V) || te(V)))
          return;
      }
      if (!(!k && !O)) {
        var U;
        if (p.window === p)
          U = p;
        else {
          var ae = p.ownerDocument;
          ae ? U = ae.defaultView || ae.parentWindow : U = window;
        }
        var re, xe;
        if (k) {
          var Ce = c.relatedTarget || c.toElement;
          if (re = u, xe = Ce ? se(Ce) : null, xe !== null) {
            var Me = ii(xe);
            (xe !== Me || xe.tag !== j && xe.tag !== I) && (xe = null);
          }
        } else
          re = null, xe = u;
        if (re !== xe) {
          var it = Wh, Ft = "onMouseLeave", At = "onMouseEnter", kn = "mouse";
          (r === "pointerout" || r === "pointerover") && (it = Av, Ft = "onPointerLeave", At = "onPointerEnter", kn = "pointer");
          var xn = re == null ? U : je(re), he = xe == null ? U : je(xe), Te = new it(Ft, kn + "leave", re, c, p);
          Te.target = xn, Te.relatedTarget = he;
          var ve = null, ze = se(p);
          if (ze === u) {
            var gt = new it(At, kn + "enter", xe, c, p);
            gt.target = he, gt.relatedTarget = xn, ve = gt;
          }
          E3(t, Te, ve, re, xe);
        }
      }
    }
    function de(t, r) {
      return t === r && (t !== 0 || 1 / t === 1 / r) || t !== t && r !== r;
    }
    var Fe = typeof Object.is == "function" ? Object.is : de;
    function xt(t, r) {
      if (Fe(t, r))
        return !0;
      if (typeof t != "object" || t === null || typeof r != "object" || r === null)
        return !1;
      var u = Object.keys(t), c = Object.keys(r);
      if (u.length !== c.length)
        return !1;
      for (var p = 0; p < u.length; p++) {
        var x = u[p];
        if (!Wn.call(r, x) || !Fe(t[x], r[x]))
          return !1;
      }
      return !0;
    }
    function Zt(t) {
      for (; t && t.firstChild; )
        t = t.firstChild;
      return t;
    }
    function It(t) {
      for (; t; ) {
        if (t.nextSibling)
          return t.nextSibling;
        t = t.parentNode;
      }
    }
    function zt(t, r) {
      for (var u = Zt(t), c = 0, p = 0; u; ) {
        if (u.nodeType === Xi) {
          if (p = c + u.textContent.length, c <= r && p >= r)
            return {
              node: u,
              offset: r - c
            };
          c = p;
        }
        u = Zt(It(u));
      }
    }
    function ja(t) {
      var r = t.ownerDocument, u = r && r.defaultView || window, c = u.getSelection && u.getSelection();
      if (!c || c.rangeCount === 0)
        return null;
      var p = c.anchorNode, x = c.anchorOffset, _ = c.focusNode, O = c.focusOffset;
      return Fn(t, p, x, _, O);
    }
    function Fn(t, r, u, c, p) {
      var x = 0, _ = -1, O = -1, k = 0, V = 0, U = t, ae = null;
      e: for (; ; ) {
        for (var re = null; U === r && (u === 0 || U.nodeType === Xi) && (_ = x + u), U === c && (p === 0 || U.nodeType === Xi) && (O = x + p), U.nodeType === Xi && (x += U.nodeValue.length), (re = U.firstChild) !== null; )
          ae = U, U = re;
        for (; ; ) {
          if (U === t)
            break e;
          if (ae === r && ++k === u && (_ = x), ae === c && ++V === p && (O = x), (re = U.nextSibling) !== null)
            break;
          U = ae, ae = U.parentNode;
        }
        U = re;
      }
      return _ === -1 || O === -1 ? null : {
        start: _,
        end: O
      };
    }
    function ms(t, r) {
      var u = t.ownerDocument || document, c = u && u.defaultView || window;
      if (c.getSelection) {
        var p = c.getSelection(), x = t.textContent.length, _ = Math.min(r.start, x), O = r.end === void 0 ? _ : Math.min(r.end, x);
        if (!p.extend && _ > O) {
          var k = O;
          O = _, _ = k;
        }
        var V = zt(t, _), U = zt(t, O);
        if (V && U) {
          if (p.rangeCount === 1 && p.anchorNode === V.node && p.anchorOffset === V.offset && p.focusNode === U.node && p.focusOffset === U.offset)
            return;
          var ae = u.createRange();
          ae.setStart(V.node, V.offset), p.removeAllRanges(), _ > O ? (p.addRange(ae), p.extend(U.node, U.offset)) : (ae.setEnd(U.node, U.offset), p.addRange(ae));
        }
      }
    }
    function Nv(t) {
      return t && t.nodeType === Xi;
    }
    function y3(t, r) {
      return !t || !r ? !1 : t === r ? !0 : Nv(t) ? !1 : Nv(r) ? y3(t, r.parentNode) : "contains" in t ? t.contains(r) : t.compareDocumentPosition ? !!(t.compareDocumentPosition(r) & 16) : !1;
    }
    function Lw(t) {
      return t && t.ownerDocument && y3(t.ownerDocument.documentElement, t);
    }
    function Iw(t) {
      try {
        return typeof t.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function x3() {
      for (var t = window, r = Xl(); r instanceof t.HTMLIFrameElement; ) {
        if (Iw(r))
          t = r.contentWindow;
        else
          return r;
        r = Xl(t.document);
      }
      return r;
    }
    function gm(t) {
      var r = t && t.nodeName && t.nodeName.toLowerCase();
      return r && (r === "input" && (t.type === "text" || t.type === "search" || t.type === "tel" || t.type === "url" || t.type === "password") || r === "textarea" || t.contentEditable === "true");
    }
    function Hw() {
      var t = x3();
      return {
        focusedElem: t,
        selectionRange: gm(t) ? Pw(t) : null
      };
    }
    function Zw(t) {
      var r = x3(), u = t.focusedElem, c = t.selectionRange;
      if (r !== u && Lw(u)) {
        c !== null && gm(u) && _u(u, c);
        for (var p = [], x = u; x = x.parentNode; )
          x.nodeType === Zo && p.push({
            element: x,
            left: x.scrollLeft,
            top: x.scrollTop
          });
        typeof u.focus == "function" && u.focus();
        for (var _ = 0; _ < p.length; _++) {
          var O = p[_];
          O.element.scrollLeft = O.left, O.element.scrollTop = O.top;
        }
      }
    }
    function Pw(t) {
      var r;
      return "selectionStart" in t ? r = {
        start: t.selectionStart,
        end: t.selectionEnd
      } : r = ja(t), r || {
        start: 0,
        end: 0
      };
    }
    function _u(t, r) {
      var u = r.start, c = r.end;
      c === void 0 && (c = u), "selectionStart" in t ? (t.selectionStart = u, t.selectionEnd = Math.min(c, t.value.length)) : ms(t, r);
    }
    var Nw = ar && "documentMode" in document && document.documentMode <= 11;
    function Vw() {
      Qt("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var Zl = null, nn = null, e2 = null, Wo = !1;
    function _a(t) {
      if ("selectionStart" in t && gm(t))
        return {
          start: t.selectionStart,
          end: t.selectionEnd
        };
      var r = t.ownerDocument && t.ownerDocument.defaultView || window, u = r.getSelection();
      return {
        anchorNode: u.anchorNode,
        anchorOffset: u.anchorOffset,
        focusNode: u.focusNode,
        focusOffset: u.focusOffset
      };
    }
    function Fw(t) {
      return t.window === t ? t.document : t.nodeType === Jl ? t : t.ownerDocument;
    }
    function c1(t, r, u) {
      var c = Fw(u);
      if (!(Wo || Zl == null || Zl !== Xl(c))) {
        var p = _a(Zl);
        if (!e2 || !xt(e2, p)) {
          e2 = p;
          var x = Bv(nn, "onSelect");
          if (x.length > 0) {
            var _ = new Hl("onSelect", "select", null, r, u);
            t.push({
              event: _,
              listeners: x
            }), _.target = Zl;
          }
        }
      }
    }
    function Bw(t, r, u, c, p, x, _) {
      var O = u ? je(u) : window;
      switch (r) {
        case "focusin":
          (vs(O) || O.contentEditable === "true") && (Zl = O, nn = u, e2 = null);
          break;
        case "focusout":
          Zl = null, nn = null, e2 = null;
          break;
        case "mousedown":
          Wo = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          Wo = !1, c1(t, c, p);
          break;
        case "selectionchange":
          if (Nw)
            break;
        case "keydown":
        case "keyup":
          c1(t, c, p);
      }
    }
    function Vv(t, r) {
      var u = {};
      return u[t.toLowerCase()] = r.toLowerCase(), u["Webkit" + t] = "webkit" + r, u["Moz" + t] = "moz" + r, u;
    }
    var Rd = {
      animationend: Vv("Animation", "AnimationEnd"),
      animationiteration: Vv("Animation", "AnimationIteration"),
      animationstart: Vv("Animation", "AnimationStart"),
      transitionend: Vv("Transition", "TransitionEnd")
    }, wm = {}, S3 = {};
    ar && (S3 = document.createElement("div").style, "AnimationEvent" in window || (delete Rd.animationend.animation, delete Rd.animationiteration.animation, delete Rd.animationstart.animation), "TransitionEvent" in window || delete Rd.transitionend.transition);
    function Ed(t) {
      if (wm[t])
        return wm[t];
      if (!Rd[t])
        return t;
      var r = Rd[t];
      for (var u in r)
        if (r.hasOwnProperty(u) && u in S3)
          return wm[t] = r[u];
      return t;
    }
    var C3 = Ed("animationend"), gs = Ed("animationiteration"), ym = Ed("animationstart"), t2 = Ed("transitionend"), $r = /* @__PURE__ */ new Map(), na = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function f1(t, r) {
      $r.set(t, r), Qt(r, [t]);
    }
    function Uw() {
      for (var t = 0; t < na.length; t++) {
        var r = na[t], u = r.toLowerCase(), c = r[0].toUpperCase() + r.slice(1);
        f1(u, "on" + c);
      }
      f1(C3, "onAnimationEnd"), f1(gs, "onAnimationIteration"), f1(ym, "onAnimationStart"), f1("dblclick", "onDoubleClick"), f1("focusin", "onFocus"), f1("focusout", "onBlur"), f1(t2, "onTransitionEnd");
    }
    function Yw(t, r, u, c, p, x, _) {
      var O = $r.get(r);
      if (O !== void 0) {
        var k = Hl, V = r;
        switch (r) {
          case "keypress":
            if (ds(c) === 0)
              return;
          case "keydown":
          case "keyup":
            k = Dv;
            break;
          case "focusin":
            V = "focus", k = Cu;
            break;
          case "focusout":
            V = "blur", k = Cu;
            break;
          case "beforeblur":
          case "afterblur":
            k = Cu;
            break;
          case "click":
            if (c.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            k = Wh;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            k = l1;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            k = kv;
            break;
          case C3:
          case gs:
          case ym:
            k = Ev;
            break;
          case t2:
            k = Ni;
            break;
          case "scroll":
            k = $o;
            break;
          case "wheel":
            k = hm;
            break;
          case "copy":
          case "cut":
          case "paste":
            k = pd;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            k = Av;
            break;
        }
        var U = (x & Bs) !== 0;
        {
          var ae = !U && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          r === "scroll", re = Ww(u, O, c.type, U, ae);
          if (re.length > 0) {
            var xe = new k(O, V, null, c, p);
            t.push({
              event: xe,
              listeners: re
            });
          }
        }
      }
    }
    Uw(), fe(), Yc(), Vw(), vm();
    function $w(t, r, u, c, p, x, _) {
      Yw(t, r, u, c, p, x);
      var O = (x & Ji) === 0;
      O && (ne(t, r, u, c, p), ta(t, r, u, c, p), Bw(t, r, u, c, p), Zv(t, r, u, c, p));
    }
    var n2 = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], xm = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(n2));
    function b3(t, r, u) {
      var c = t.type || "unknown-event";
      t.currentTarget = u, $1(c, r, void 0, t), t.currentTarget = null;
    }
    function _3(t, r, u) {
      var c;
      if (u)
        for (var p = r.length - 1; p >= 0; p--) {
          var x = r[p], _ = x.instance, O = x.currentTarget, k = x.listener;
          if (_ !== c && t.isPropagationStopped())
            return;
          b3(t, k, O), c = _;
        }
      else
        for (var V = 0; V < r.length; V++) {
          var U = r[V], ae = U.instance, re = U.currentTarget, xe = U.listener;
          if (ae !== c && t.isPropagationStopped())
            return;
          b3(t, xe, re), c = ae;
        }
    }
    function Md(t, r) {
      for (var u = (r & Bs) !== 0, c = 0; c < t.length; c++) {
        var p = t[c], x = p.event, _ = p.listeners;
        _3(x, _, u);
      }
      Tl();
    }
    function Sm(t, r, u, c, p) {
      var x = el(u), _ = [];
      $w(_, t, c, u, x, r), Md(_, r);
    }
    function Zr(t, r) {
      xm.has(t) || m('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', t);
      var u = !1, c = Ot(r), p = Pl(t);
      c.has(p) || (Wc(r, t, Fs, u), c.add(p));
    }
    function Fv(t, r, u) {
      xm.has(t) && !r && m('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', t);
      var c = 0;
      r && (c |= Bs), Wc(u, t, c, r);
    }
    var $c = "_reactListening" + Math.random().toString(36).slice(2);
    function Ro(t) {
      if (!t[$c]) {
        t[$c] = !0, ot.forEach(function(u) {
          u !== "selectionchange" && (xm.has(u) || Fv(u, !1, t), Fv(u, !0, t));
        });
        var r = t.nodeType === Jl ? t : t.ownerDocument;
        r !== null && (r[$c] || (r[$c] = !0, Fv("selectionchange", !1, r)));
      }
    }
    function Wc(t, r, u, c, p) {
      var x = Qa(t, r, u), _ = void 0;
      U1 && (r === "touchstart" || r === "touchmove" || r === "wheel") && (_ = !0), t = t, c ? _ !== void 0 ? $h(t, r, x, _) : Yo(t, r, x) : _ !== void 0 ? a1(t, r, x, _) : Nc(t, r, x);
    }
    function R3(t, r) {
      return t === r || t.nodeType === Fr && t.parentNode === r;
    }
    function Cm(t, r, u, c, p) {
      var x = c;
      if (!(r & Rl) && !(r & Fs)) {
        var _ = p;
        if (c !== null) {
          var O = c;
          e: for (; ; ) {
            if (O === null)
              return;
            var k = O.tag;
            if (k === T || k === A) {
              var V = O.stateNode.containerInfo;
              if (R3(V, _))
                break;
              if (k === A)
                for (var U = O.return; U !== null; ) {
                  var ae = U.tag;
                  if (ae === T || ae === A) {
                    var re = U.stateNode.containerInfo;
                    if (R3(re, _))
                      return;
                  }
                  U = U.return;
                }
              for (; V !== null; ) {
                var xe = se(V);
                if (xe === null)
                  return;
                var Ce = xe.tag;
                if (Ce === j || Ce === I) {
                  O = x = xe;
                  continue e;
                }
                V = V.parentNode;
              }
            }
            O = O.return;
          }
        }
      }
      Kr(function() {
        return Sm(t, r, u, x);
      });
    }
    function r2(t, r, u) {
      return {
        instance: t,
        listener: r,
        currentTarget: u
      };
    }
    function Ww(t, r, u, c, p, x) {
      for (var _ = r !== null ? r + "Capture" : null, O = c ? _ : r, k = [], V = t, U = null; V !== null; ) {
        var ae = V, re = ae.stateNode, xe = ae.tag;
        if (xe === j && re !== null && (U = re, O !== null)) {
          var Ce = ru(V, O);
          Ce != null && k.push(r2(V, Ce, U));
        }
        if (p)
          break;
        V = V.return;
      }
      return k;
    }
    function Bv(t, r) {
      for (var u = r + "Capture", c = [], p = t; p !== null; ) {
        var x = p, _ = x.stateNode, O = x.tag;
        if (O === j && _ !== null) {
          var k = _, V = ru(p, u);
          V != null && c.unshift(r2(p, V, k));
          var U = ru(p, r);
          U != null && c.push(r2(p, U, k));
        }
        p = p.return;
      }
      return c;
    }
    function zc(t) {
      if (t === null)
        return null;
      do
        t = t.return;
      while (t && t.tag !== j);
      return t || null;
    }
    function d1(t, r) {
      for (var u = t, c = r, p = 0, x = u; x; x = zc(x))
        p++;
      for (var _ = 0, O = c; O; O = zc(O))
        _++;
      for (; p - _ > 0; )
        u = zc(u), p--;
      for (; _ - p > 0; )
        c = zc(c), _--;
      for (var k = p; k--; ) {
        if (u === c || c !== null && u === c.alternate)
          return u;
        u = zc(u), c = zc(c);
      }
      return null;
    }
    function on(t, r, u, c, p) {
      for (var x = r._reactName, _ = [], O = u; O !== null && O !== c; ) {
        var k = O, V = k.alternate, U = k.stateNode, ae = k.tag;
        if (V !== null && V === c)
          break;
        if (ae === j && U !== null) {
          var re = U;
          if (p) {
            var xe = ru(O, x);
            xe != null && _.unshift(r2(O, xe, re));
          } else if (!p) {
            var Ce = ru(O, x);
            Ce != null && _.push(r2(O, Ce, re));
          }
        }
        O = O.return;
      }
      _.length !== 0 && t.push({
        event: r,
        listeners: _
      });
    }
    function E3(t, r, u, c, p) {
      var x = c && p ? d1(c, p) : null;
      c !== null && on(t, r, c, x, !1), p !== null && u !== null && on(t, u, p, x, !0);
    }
    function Pl(t, r) {
      return t + "__bubble";
    }
    var fi = !1, a2 = "dangerouslySetInnerHTML", $n = "suppressContentEditableWarning", _0 = "suppressHydrationWarning", bm = "autoFocus", ws = "children", qc = "style", Uv = "__html", _m, Yv, o2, M3, $v, T3, O3;
    _m = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, Yv = function(t, r) {
      _l(t, r), sc(t, r), dc(t, r, {
        registrationNameDependencies: Nt,
        possibleRegistrationNames: Tn
      });
    }, T3 = ar && !document.documentMode, o2 = function(t, r, u) {
      if (!fi) {
        var c = Wv(u), p = Wv(r);
        p !== c && (fi = !0, m("Prop `%s` did not match. Server: %s Client: %s", t, JSON.stringify(p), JSON.stringify(c)));
      }
    }, M3 = function(t) {
      if (!fi) {
        fi = !0;
        var r = [];
        t.forEach(function(u) {
          r.push(u);
        }), m("Extra attributes from the server: %s", r);
      }
    }, $v = function(t, r) {
      r === !1 ? m("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", t, t, t) : m("Expected `%s` listener to be a function, instead got a value of `%s` type.", t, typeof r);
    }, O3 = function(t, r) {
      var u = t.namespaceURI === Ri ? t.ownerDocument.createElement(t.tagName) : t.ownerDocument.createElementNS(t.namespaceURI, t.tagName);
      return u.innerHTML = r, u.innerHTML;
    };
    var zw = /\r\n?/g, qw = /\u0000|\uFFFD/g;
    function Wv(t) {
      fn(t);
      var r = typeof t == "string" ? t : "" + t;
      return r.replace(zw, `
`).replace(qw, "");
    }
    function zv(t, r, u, c) {
      var p = Wv(r), x = Wv(t);
      if (x !== p && (c && (fi || (fi = !0, m('Text content did not match. Server: "%s" Client: "%s"', x, p))), u && Ye))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function qv(t) {
      return t.nodeType === Jl ? t : t.ownerDocument;
    }
    function Gw() {
    }
    function Td(t) {
      t.onclick = Gw;
    }
    function Kw(t, r, u, c, p) {
      for (var x in c)
        if (c.hasOwnProperty(x)) {
          var _ = c[x];
          if (x === qc)
            _ && Object.freeze(_), lv(r, _);
          else if (x === a2) {
            var O = _ ? _[Uv] : void 0;
            O != null && jh(r, O);
          } else if (x === ws)
            if (typeof _ == "string") {
              var k = t !== "textarea" || _ !== "";
              k && no(r, _);
            } else typeof _ == "number" && no(r, "" + _);
          else x === $n || x === _0 || x === bm || (Nt.hasOwnProperty(x) ? _ != null && (typeof _ != "function" && $v(x, _), x === "onScroll" && Zr("scroll", r)) : _ != null && js(r, x, _, p));
        }
    }
    function Qw(t, r, u, c) {
      for (var p = 0; p < r.length; p += 2) {
        var x = r[p], _ = r[p + 1];
        x === qc ? lv(t, _) : x === a2 ? jh(t, _) : x === ws ? no(t, _) : js(t, x, _, c);
      }
    }
    function Xw(t, r, u, c) {
      var p, x = qv(u), _, O = c;
      if (O === Ri && (O = Lf(t)), O === Ri) {
        if (p = cn(t, r), !p && t !== t.toLowerCase() && m("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", t), t === "script") {
          var k = x.createElement("div");
          k.innerHTML = "<script><\/script>";
          var V = k.firstChild;
          _ = k.removeChild(V);
        } else if (typeof r.is == "string")
          _ = x.createElement(t, {
            is: r.is
          });
        else if (_ = x.createElement(t), t === "select") {
          var U = _;
          r.multiple ? U.multiple = !0 : r.size && (U.size = r.size);
        }
      } else
        _ = x.createElementNS(O, t);
      return O === Ri && !p && Object.prototype.toString.call(_) === "[object HTMLUnknownElement]" && !Wn.call(_m, t) && (_m[t] = !0, m("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", t)), _;
    }
    function co(t, r) {
      return qv(r).createTextNode(t);
    }
    function Vi(t, r, u, c) {
      var p = cn(r, u);
      Yv(r, u);
      var x;
      switch (r) {
        case "dialog":
          Zr("cancel", t), Zr("close", t), x = u;
          break;
        case "iframe":
        case "object":
        case "embed":
          Zr("load", t), x = u;
          break;
        case "video":
        case "audio":
          for (var _ = 0; _ < n2.length; _++)
            Zr(n2[_], t);
          x = u;
          break;
        case "source":
          Zr("error", t), x = u;
          break;
        case "img":
        case "image":
        case "link":
          Zr("error", t), Zr("load", t), x = u;
          break;
        case "details":
          Zr("toggle", t), x = u;
          break;
        case "input":
          Eh(t, u), x = I1(t, u), Zr("invalid", t);
          break;
        case "option":
          nc(t, u), x = u;
          break;
        case "select":
          kf(t, u), x = P1(t, u), Zr("invalid", t);
          break;
        case "textarea":
          K2(t, u), x = oc(t, u), Zr("invalid", t);
          break;
        default:
          x = u;
      }
      switch (Gt(r, x), Kw(r, t, c, x, p), r) {
        case "input":
          Pn(t), Qi(t, u, !1);
          break;
        case "textarea":
          Pn(t), Q2(t);
          break;
        case "option":
          Z1(t, u);
          break;
        case "select":
          hr(t, u);
          break;
        default:
          typeof x.onClick == "function" && Td(t);
          break;
      }
    }
    function Jw(t, r, u, c, p) {
      Yv(r, c);
      var x = null, _, O;
      switch (r) {
        case "input":
          _ = I1(t, u), O = I1(t, c), x = [];
          break;
        case "select":
          _ = P1(t, u), O = P1(t, c), x = [];
          break;
        case "textarea":
          _ = oc(t, u), O = oc(t, c), x = [];
          break;
        default:
          _ = u, O = c, typeof _.onClick != "function" && typeof O.onClick == "function" && Td(t);
          break;
      }
      Gt(r, O);
      var k, V, U = null;
      for (k in _)
        if (!(O.hasOwnProperty(k) || !_.hasOwnProperty(k) || _[k] == null))
          if (k === qc) {
            var ae = _[k];
            for (V in ae)
              ae.hasOwnProperty(V) && (U || (U = {}), U[V] = "");
          } else k === a2 || k === ws || k === $n || k === _0 || k === bm || (Nt.hasOwnProperty(k) ? x || (x = []) : (x = x || []).push(k, null));
      for (k in O) {
        var re = O[k], xe = _ != null ? _[k] : void 0;
        if (!(!O.hasOwnProperty(k) || re === xe || re == null && xe == null))
          if (k === qc)
            if (re && Object.freeze(re), xe) {
              for (V in xe)
                xe.hasOwnProperty(V) && (!re || !re.hasOwnProperty(V)) && (U || (U = {}), U[V] = "");
              for (V in re)
                re.hasOwnProperty(V) && xe[V] !== re[V] && (U || (U = {}), U[V] = re[V]);
            } else
              U || (x || (x = []), x.push(k, U)), U = re;
          else if (k === a2) {
            var Ce = re ? re[Uv] : void 0, Me = xe ? xe[Uv] : void 0;
            Ce != null && Me !== Ce && (x = x || []).push(k, Ce);
          } else k === ws ? (typeof re == "string" || typeof re == "number") && (x = x || []).push(k, "" + re) : k === $n || k === _0 || (Nt.hasOwnProperty(k) ? (re != null && (typeof re != "function" && $v(k, re), k === "onScroll" && Zr("scroll", t)), !x && xe !== re && (x = [])) : (x = x || []).push(k, re));
      }
      return U && (le(U, O[qc]), (x = x || []).push(qc, U)), x;
    }
    function e6(t, r, u, c, p) {
      u === "input" && p.type === "radio" && p.name != null && yr(t, p);
      var x = cn(u, c), _ = cn(u, p);
      switch (Qw(t, r, x, _), u) {
        case "input":
          Is(t, p);
          break;
        case "textarea":
          Dh(t, p);
          break;
        case "select":
          Bu(t, p);
          break;
      }
    }
    function t6(t) {
      {
        var r = t.toLowerCase();
        return Lr.hasOwnProperty(r) && Lr[r] || null;
      }
    }
    function D3(t, r, u, c, p, x, _) {
      var O, k;
      switch (O = cn(r, u), Yv(r, u), r) {
        case "dialog":
          Zr("cancel", t), Zr("close", t);
          break;
        case "iframe":
        case "object":
        case "embed":
          Zr("load", t);
          break;
        case "video":
        case "audio":
          for (var V = 0; V < n2.length; V++)
            Zr(n2[V], t);
          break;
        case "source":
          Zr("error", t);
          break;
        case "img":
        case "image":
        case "link":
          Zr("error", t), Zr("load", t);
          break;
        case "details":
          Zr("toggle", t);
          break;
        case "input":
          Eh(t, u), Zr("invalid", t);
          break;
        case "option":
          nc(t, u);
          break;
        case "select":
          kf(t, u), Zr("invalid", t);
          break;
        case "textarea":
          K2(t, u), Zr("invalid", t);
          break;
      }
      Gt(r, u);
      {
        k = /* @__PURE__ */ new Set();
        for (var U = t.attributes, ae = 0; ae < U.length; ae++) {
          var re = U[ae].name.toLowerCase();
          switch (re) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              k.add(U[ae].name);
          }
        }
      }
      var xe = null;
      for (var Ce in u)
        if (u.hasOwnProperty(Ce)) {
          var Me = u[Ce];
          if (Ce === ws)
            typeof Me == "string" ? t.textContent !== Me && (u[_0] !== !0 && zv(t.textContent, Me, x, _), xe = [ws, Me]) : typeof Me == "number" && t.textContent !== "" + Me && (u[_0] !== !0 && zv(t.textContent, Me, x, _), xe = [ws, "" + Me]);
          else if (Nt.hasOwnProperty(Ce))
            Me != null && (typeof Me != "function" && $v(Ce, Me), Ce === "onScroll" && Zr("scroll", t));
          else if (_ && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof O == "boolean") {
            var it = void 0, Ft = O && qe ? null : br(Ce);
            if (u[_0] !== !0) {
              if (!(Ce === $n || Ce === _0 || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              Ce === "value" || Ce === "checked" || Ce === "selected")) {
                if (Ce === a2) {
                  var At = t.innerHTML, kn = Me ? Me[Uv] : void 0;
                  if (kn != null) {
                    var xn = O3(t, kn);
                    xn !== At && o2(Ce, At, xn);
                  }
                } else if (Ce === qc) {
                  if (k.delete(Ce), T3) {
                    var he = iv(Me);
                    it = t.getAttribute("style"), he !== it && o2(Ce, it, he);
                  }
                } else if (O && !qe)
                  k.delete(Ce.toLowerCase()), it = As(t, Ce, Me), Me !== it && o2(Ce, it, Me);
                else if (!ga(Ce, Ft, O) && !Oa(Ce, Me, Ft, O)) {
                  var Te = !1;
                  if (Ft !== null)
                    k.delete(Ft.attributeName), it = q0(t, Ce, Me, Ft);
                  else {
                    var ve = c;
                    if (ve === Ri && (ve = Lf(r)), ve === Ri)
                      k.delete(Ce.toLowerCase());
                    else {
                      var ze = t6(Ce);
                      ze !== null && ze !== Ce && (Te = !0, k.delete(ze)), k.delete(Ce);
                    }
                    it = As(t, Ce, Me);
                  }
                  var gt = qe;
                  !gt && Me !== it && !Te && o2(Ce, it, Me);
                }
              }
            }
          }
        }
      switch (_ && // $FlowFixMe - Should be inferred as not undefined.
      k.size > 0 && u[_0] !== !0 && M3(k), r) {
        case "input":
          Pn(t), Qi(t, u, !0);
          break;
        case "textarea":
          Pn(t), Q2(t);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof u.onClick == "function" && Td(t);
          break;
      }
      return xe;
    }
    function n6(t, r, u) {
      var c = t.nodeValue !== r;
      return c;
    }
    function Rm(t, r) {
      {
        if (fi)
          return;
        fi = !0, m("Did not expect server HTML to contain a <%s> in <%s>.", r.nodeName.toLowerCase(), t.nodeName.toLowerCase());
      }
    }
    function Em(t, r) {
      {
        if (fi)
          return;
        fi = !0, m('Did not expect server HTML to contain the text node "%s" in <%s>.', r.nodeValue, t.nodeName.toLowerCase());
      }
    }
    function Gv(t, r, u) {
      {
        if (fi)
          return;
        fi = !0, m("Expected server HTML to contain a matching <%s> in <%s>.", r, t.nodeName.toLowerCase());
      }
    }
    function Mm(t, r) {
      {
        if (r === "" || fi)
          return;
        fi = !0, m('Expected server HTML to contain a matching text node for "%s" in <%s>.', r, t.nodeName.toLowerCase());
      }
    }
    function r6(t, r, u) {
      switch (r) {
        case "input":
          Mh(t, u);
          return;
        case "textarea":
          X2(t, u);
          return;
        case "select":
          Oh(t, u);
          return;
      }
    }
    var i2 = function() {
    }, Od = function() {
    };
    {
      var A3 = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], j3 = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], a6 = j3.concat(["button"]), o6 = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], k3 = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      Od = function(t, r) {
        var u = mt({}, t || k3), c = {
          tag: r
        };
        return j3.indexOf(r) !== -1 && (u.aTagInScope = null, u.buttonTagInScope = null, u.nobrTagInScope = null), a6.indexOf(r) !== -1 && (u.pTagInButtonScope = null), A3.indexOf(r) !== -1 && r !== "address" && r !== "div" && r !== "p" && (u.listItemTagAutoclosing = null, u.dlItemTagAutoclosing = null), u.current = c, r === "form" && (u.formTag = c), r === "a" && (u.aTagInScope = c), r === "button" && (u.buttonTagInScope = c), r === "nobr" && (u.nobrTagInScope = c), r === "p" && (u.pTagInButtonScope = c), r === "li" && (u.listItemTagAutoclosing = c), (r === "dd" || r === "dt") && (u.dlItemTagAutoclosing = c), u;
      };
      var Dd = function(t, r) {
        switch (r) {
          case "select":
            return t === "option" || t === "optgroup" || t === "#text";
          case "optgroup":
            return t === "option" || t === "#text";
          case "option":
            return t === "#text";
          case "tr":
            return t === "th" || t === "td" || t === "style" || t === "script" || t === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return t === "tr" || t === "style" || t === "script" || t === "template";
          case "colgroup":
            return t === "col" || t === "template";
          case "table":
            return t === "caption" || t === "colgroup" || t === "tbody" || t === "tfoot" || t === "thead" || t === "style" || t === "script" || t === "template";
          case "head":
            return t === "base" || t === "basefont" || t === "bgsound" || t === "link" || t === "meta" || t === "title" || t === "noscript" || t === "noframes" || t === "style" || t === "script" || t === "template";
          case "html":
            return t === "head" || t === "body" || t === "frameset";
          case "frameset":
            return t === "frame";
          case "#document":
            return t === "html";
        }
        switch (t) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return r !== "h1" && r !== "h2" && r !== "h3" && r !== "h4" && r !== "h5" && r !== "h6";
          case "rp":
          case "rt":
            return o6.indexOf(r) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return r == null;
        }
        return !0;
      }, i6 = function(t, r) {
        switch (t) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return r.pTagInButtonScope;
          case "form":
            return r.formTag || r.pTagInButtonScope;
          case "li":
            return r.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return r.dlItemTagAutoclosing;
          case "button":
            return r.buttonTagInScope;
          case "a":
            return r.aTagInScope;
          case "nobr":
            return r.nobrTagInScope;
        }
        return null;
      }, L3 = {};
      i2 = function(t, r, u) {
        u = u || k3;
        var c = u.current, p = c && c.tag;
        r != null && (t != null && m("validateDOMNesting: when childText is passed, childTag should be null"), t = "#text");
        var x = Dd(t, p) ? null : c, _ = x ? null : i6(t, u), O = x || _;
        if (O) {
          var k = O.tag, V = !!x + "|" + t + "|" + k;
          if (!L3[V]) {
            L3[V] = !0;
            var U = t, ae = "";
            if (t === "#text" ? /\S/.test(r) ? U = "Text nodes" : (U = "Whitespace text nodes", ae = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : U = "<" + t + ">", x) {
              var re = "";
              k === "table" && t === "tr" && (re += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), m("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", U, k, ae, re);
            } else
              m("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", U, k);
          }
        }
      };
    }
    var Kv = "suppressHydrationWarning", Qv = "$", Xv = "/$", Ad = "$?", jd = "$!", l6 = "style", Tm = null, Om = null;
    function u6(t) {
      var r, u, c = t.nodeType;
      switch (c) {
        case Jl:
        case Hf: {
          r = c === Jl ? "#document" : "#fragment";
          var p = t.documentElement;
          u = p ? p.namespaceURI : If(null, "");
          break;
        }
        default: {
          var x = c === Fr ? t.parentNode : t, _ = x.namespaceURI || null;
          r = x.tagName, u = If(_, r);
          break;
        }
      }
      {
        var O = r.toLowerCase(), k = Od(null, O);
        return {
          namespace: u,
          ancestorInfo: k
        };
      }
    }
    function s6(t, r, u) {
      {
        var c = t, p = If(c.namespace, r), x = Od(c.ancestorInfo, r);
        return {
          namespace: p,
          ancestorInfo: x
        };
      }
    }
    function uS(t) {
      return t;
    }
    function c6(t) {
      Tm = da(), Om = Hw();
      var r = null;
      return ba(!1), r;
    }
    function f6(t) {
      Zw(Om), ba(Tm), Tm = null, Om = null;
    }
    function d6(t, r, u, c, p) {
      var x;
      {
        var _ = c;
        if (i2(t, null, _.ancestorInfo), typeof r.children == "string" || typeof r.children == "number") {
          var O = "" + r.children, k = Od(_.ancestorInfo, t);
          i2(null, O, k);
        }
        x = _.namespace;
      }
      var V = Xw(t, r, u, x);
      return L(p, V), rt(V, r), V;
    }
    function h6(t, r) {
      t.appendChild(r);
    }
    function v6(t, r, u, c, p) {
      switch (Vi(t, r, u, c), r) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!u.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function p6(t, r, u, c, p, x) {
      {
        var _ = x;
        if (typeof c.children != typeof u.children && (typeof c.children == "string" || typeof c.children == "number")) {
          var O = "" + c.children, k = Od(_.ancestorInfo, r);
          i2(null, O, k);
        }
      }
      return Jw(t, r, u, c);
    }
    function Dm(t, r) {
      return t === "textarea" || t === "noscript" || typeof r.children == "string" || typeof r.children == "number" || typeof r.dangerouslySetInnerHTML == "object" && r.dangerouslySetInnerHTML !== null && r.dangerouslySetInnerHTML.__html != null;
    }
    function m6(t, r, u, c) {
      {
        var p = u;
        i2(null, t, p.ancestorInfo);
      }
      var x = co(t, r);
      return L(c, x), x;
    }
    function g6() {
      var t = window.event;
      return t === void 0 ? Pi : Pc(t.type);
    }
    var Am = typeof setTimeout == "function" ? setTimeout : void 0, w6 = typeof clearTimeout == "function" ? clearTimeout : void 0, jm = -1, I3 = typeof Promise == "function" ? Promise : void 0, y6 = typeof queueMicrotask == "function" ? queueMicrotask : typeof I3 < "u" ? function(t) {
      return I3.resolve(null).then(t).catch(x6);
    } : Am;
    function x6(t) {
      setTimeout(function() {
        throw t;
      });
    }
    function S6(t, r, u, c) {
      switch (r) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          u.autoFocus && t.focus();
          return;
        case "img": {
          u.src && (t.src = u.src);
          return;
        }
      }
    }
    function C6(t, r, u, c, p, x) {
      e6(t, r, u, c, p), rt(t, p);
    }
    function H3(t) {
      no(t, "");
    }
    function b6(t, r, u) {
      t.nodeValue = u;
    }
    function km(t, r) {
      t.appendChild(r);
    }
    function Z3(t, r) {
      var u;
      t.nodeType === Fr ? (u = t.parentNode, u.insertBefore(r, t)) : (u = t, u.appendChild(r));
      var c = t._reactRootContainer;
      c == null && u.onclick === null && Td(u);
    }
    function P3(t, r, u) {
      t.insertBefore(r, u);
    }
    function _6(t, r, u) {
      t.nodeType === Fr ? t.parentNode.insertBefore(r, u) : t.insertBefore(r, u);
    }
    function R6(t, r) {
      t.removeChild(r);
    }
    function E6(t, r) {
      t.nodeType === Fr ? t.parentNode.removeChild(r) : t.removeChild(r);
    }
    function l2(t, r) {
      var u = r, c = 0;
      do {
        var p = u.nextSibling;
        if (t.removeChild(u), p && p.nodeType === Fr) {
          var x = p.data;
          if (x === Xv)
            if (c === 0) {
              t.removeChild(p), n1(r);
              return;
            } else
              c--;
          else (x === Qv || x === Ad || x === jd) && c++;
        }
        u = p;
      } while (u);
      n1(r);
    }
    function M6(t, r) {
      t.nodeType === Fr ? l2(t.parentNode, r) : t.nodeType === Zo && l2(t, r), n1(t);
    }
    function T6(t) {
      t = t;
      var r = t.style;
      typeof r.setProperty == "function" ? r.setProperty("display", "none", "important") : r.display = "none";
    }
    function O6(t) {
      t.nodeValue = "";
    }
    function Fi(t, r) {
      t = t;
      var u = r[l6], c = u != null && u.hasOwnProperty("display") ? u.display : null;
      t.style.display = Zf("display", c);
    }
    function Lm(t, r) {
      t.nodeValue = r;
    }
    function D6(t) {
      t.nodeType === Zo ? t.textContent = "" : t.nodeType === Jl && t.documentElement && t.removeChild(t.documentElement);
    }
    function A6(t, r, u) {
      return t.nodeType !== Zo || r.toLowerCase() !== t.nodeName.toLowerCase() ? null : t;
    }
    function j6(t, r) {
      return r === "" || t.nodeType !== Xi ? null : t;
    }
    function k6(t) {
      return t.nodeType !== Fr ? null : t;
    }
    function Jv(t) {
      return t.data === Ad;
    }
    function Im(t) {
      return t.data === jd;
    }
    function Hm(t) {
      var r = t.nextSibling && t.nextSibling.dataset, u, c, p;
      return r && (u = r.dgst, c = r.msg, p = r.stck), {
        message: c,
        digest: u,
        stack: p
      };
    }
    function L6(t, r) {
      t._reactRetry = r;
    }
    function ep(t) {
      for (; t != null; t = t.nextSibling) {
        var r = t.nodeType;
        if (r === Zo || r === Xi)
          break;
        if (r === Fr) {
          var u = t.data;
          if (u === Qv || u === jd || u === Ad)
            break;
          if (u === Xv)
            return null;
        }
      }
      return t;
    }
    function u2(t) {
      return ep(t.nextSibling);
    }
    function I6(t) {
      return ep(t.firstChild);
    }
    function N3(t) {
      return ep(t.firstChild);
    }
    function H6(t) {
      return ep(t.nextSibling);
    }
    function Z6(t, r, u, c, p, x, _) {
      L(x, t), rt(t, u);
      var O;
      {
        var k = p;
        O = k.namespace;
      }
      var V = (x.mode & an) !== kt;
      return D3(t, r, u, O, c, V, _);
    }
    function P6(t, r, u, c) {
      return L(u, t), n6(t, r);
    }
    function Zm(t, r) {
      L(r, t);
    }
    function Pm(t) {
      for (var r = t.nextSibling, u = 0; r; ) {
        if (r.nodeType === Fr) {
          var c = r.data;
          if (c === Xv) {
            if (u === 0)
              return u2(r);
            u--;
          } else (c === Qv || c === jd || c === Ad) && u++;
        }
        r = r.nextSibling;
      }
      return null;
    }
    function V3(t) {
      for (var r = t.previousSibling, u = 0; r; ) {
        if (r.nodeType === Fr) {
          var c = r.data;
          if (c === Qv || c === jd || c === Ad) {
            if (u === 0)
              return r;
            u--;
          } else c === Xv && u++;
        }
        r = r.previousSibling;
      }
      return null;
    }
    function N6(t) {
      n1(t);
    }
    function V6(t) {
      n1(t);
    }
    function F6(t) {
      return t !== "head" && t !== "body";
    }
    function B6(t, r, u, c) {
      var p = !0;
      zv(r.nodeValue, u, c, p);
    }
    function U6(t, r, u, c, p, x) {
      if (r[Kv] !== !0) {
        var _ = !0;
        zv(c.nodeValue, p, x, _);
      }
    }
    function Y6(t, r) {
      r.nodeType === Zo ? Rm(t, r) : r.nodeType === Fr || Em(t, r);
    }
    function $6(t, r) {
      {
        var u = t.parentNode;
        u !== null && (r.nodeType === Zo ? Rm(u, r) : r.nodeType === Fr || Em(u, r));
      }
    }
    function W6(t, r, u, c, p) {
      (p || r[Kv] !== !0) && (c.nodeType === Zo ? Rm(u, c) : c.nodeType === Fr || Em(u, c));
    }
    function z6(t, r, u) {
      Gv(t, r);
    }
    function q6(t, r) {
      Mm(t, r);
    }
    function G6(t, r, u) {
      {
        var c = t.parentNode;
        c !== null && Gv(c, r);
      }
    }
    function K6(t, r) {
      {
        var u = t.parentNode;
        u !== null && Mm(u, r);
      }
    }
    function Q6(t, r, u, c, p, x) {
      (x || r[Kv] !== !0) && Gv(u, c);
    }
    function X6(t, r, u, c, p) {
      (p || r[Kv] !== !0) && Mm(u, c);
    }
    function J6(t) {
      m("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", t.nodeName.toLowerCase());
    }
    function e7(t) {
      Ro(t);
    }
    var kd = Math.random().toString(36).slice(2), Ld = "__reactFiber$" + kd, Nm = "__reactProps$" + kd, s2 = "__reactContainer$" + kd, s = "__reactEvents$" + kd, f = "__reactListeners$" + kd, y = "__reactHandles$" + kd;
    function M(t) {
      delete t[Ld], delete t[Nm], delete t[s], delete t[f], delete t[y];
    }
    function L(t, r) {
      r[Ld] = t;
    }
    function F(t, r) {
      r[s2] = t;
    }
    function K(t) {
      t[s2] = null;
    }
    function te(t) {
      return !!t[s2];
    }
    function se(t) {
      var r = t[Ld];
      if (r)
        return r;
      for (var u = t.parentNode; u; ) {
        if (r = u[s2] || u[Ld], r) {
          var c = r.alternate;
          if (r.child !== null || c !== null && c.child !== null)
            for (var p = V3(t); p !== null; ) {
              var x = p[Ld];
              if (x)
                return x;
              p = V3(p);
            }
          return r;
        }
        t = u, u = t.parentNode;
      }
      return null;
    }
    function Oe(t) {
      var r = t[Ld] || t[s2];
      return r && (r.tag === j || r.tag === I || r.tag === Y || r.tag === T) ? r : null;
    }
    function je(t) {
      if (t.tag === j || t.tag === I)
        return t.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function Ve(t) {
      return t[Nm] || null;
    }
    function rt(t, r) {
      t[Nm] = r;
    }
    function Ot(t) {
      var r = t[s];
      return r === void 0 && (r = t[s] = /* @__PURE__ */ new Set()), r;
    }
    var qt = {}, sn = a.ReactDebugCurrentFrame;
    function Ut(t) {
      if (t) {
        var r = Ls(t.type);
        sn.setExtraStackFrame(r);
      } else
        sn.setExtraStackFrame(null);
    }
    function Xt(t, r, u, c, p) {
      {
        var x = Function.call.bind(Wn);
        for (var _ in t)
          if (x(t, _)) {
            var O = void 0;
            try {
              if (typeof t[_] != "function") {
                var k = Error((c || "React class") + ": " + u + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw k.name = "Invariant Violation", k;
              }
              O = t[_](r, _, c, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              O = V;
            }
            O && !(O instanceof Error) && (Ut(p), m("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", c || "React class", u, _, typeof O), Ut(null)), O instanceof Error && !(O.message in qt) && (qt[O.message] = !0, Ut(p), m("Failed %s type: %s", u, O.message), Ut(null));
          }
      }
    }
    var yn = [], zo;
    zo = [];
    var ra = -1;
    function ka(t) {
      return {
        current: t
      };
    }
    function En(t, r) {
      if (ra < 0) {
        m("Unexpected pop.");
        return;
      }
      r !== zo[ra] && m("Unexpected Fiber popped."), t.current = yn[ra], yn[ra] = null, zo[ra] = null, ra--;
    }
    function Dr(t, r, u) {
      ra++, yn[ra] = t.current, zo[ra] = u, t.current = r;
    }
    var Ru;
    Ru = {};
    var Bi = {};
    Object.freeze(Bi);
    var Gc = ka(Bi), R0 = ka(!1), t7 = Bi;
    function tp(t, r, u) {
      return u && E0(r) ? t7 : Gc.current;
    }
    function sS(t, r, u) {
      {
        var c = t.stateNode;
        c.__reactInternalMemoizedUnmaskedChildContext = r, c.__reactInternalMemoizedMaskedChildContext = u;
      }
    }
    function np(t, r) {
      {
        var u = t.type, c = u.contextTypes;
        if (!c)
          return Bi;
        var p = t.stateNode;
        if (p && p.__reactInternalMemoizedUnmaskedChildContext === r)
          return p.__reactInternalMemoizedMaskedChildContext;
        var x = {};
        for (var _ in c)
          x[_] = r[_];
        {
          var O = tn(t) || "Unknown";
          Xt(c, x, "context", O);
        }
        return p && sS(t, r, x), x;
      }
    }
    function F3() {
      return R0.current;
    }
    function E0(t) {
      {
        var r = t.childContextTypes;
        return r != null;
      }
    }
    function B3(t) {
      En(R0, t), En(Gc, t);
    }
    function n7(t) {
      En(R0, t), En(Gc, t);
    }
    function cS(t, r, u) {
      {
        if (Gc.current !== Bi)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        Dr(Gc, r, t), Dr(R0, u, t);
      }
    }
    function fS(t, r, u) {
      {
        var c = t.stateNode, p = r.childContextTypes;
        if (typeof c.getChildContext != "function") {
          {
            var x = tn(t) || "Unknown";
            Ru[x] || (Ru[x] = !0, m("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", x, x));
          }
          return u;
        }
        var _ = c.getChildContext();
        for (var O in _)
          if (!(O in p))
            throw new Error((tn(t) || "Unknown") + '.getChildContext(): key "' + O + '" is not defined in childContextTypes.');
        {
          var k = tn(t) || "Unknown";
          Xt(p, _, "child context", k);
        }
        return mt({}, u, _);
      }
    }
    function U3(t) {
      {
        var r = t.stateNode, u = r && r.__reactInternalMemoizedMergedChildContext || Bi;
        return t7 = Gc.current, Dr(Gc, u, t), Dr(R0, R0.current, t), !0;
      }
    }
    function dS(t, r, u) {
      {
        var c = t.stateNode;
        if (!c)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (u) {
          var p = fS(t, r, t7);
          c.__reactInternalMemoizedMergedChildContext = p, En(R0, t), En(Gc, t), Dr(Gc, p, t), Dr(R0, u, t);
        } else
          En(R0, t), Dr(R0, u, t);
      }
    }
    function KO(t) {
      {
        if (!Ws(t) || t.tag !== R)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var r = t;
        do {
          switch (r.tag) {
            case T:
              return r.stateNode.context;
            case R: {
              var u = r.type;
              if (E0(u))
                return r.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          r = r.return;
        } while (r !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Id = 0, Y3 = 1, Kc = null, r7 = !1, a7 = !1;
    function hS(t) {
      Kc === null ? Kc = [t] : Kc.push(t);
    }
    function QO(t) {
      r7 = !0, hS(t);
    }
    function vS() {
      r7 && Hd();
    }
    function Hd() {
      if (!a7 && Kc !== null) {
        a7 = !0;
        var t = 0, r = fr();
        try {
          var u = !0, c = Kc;
          for (fa(qa); t < c.length; t++) {
            var p = c[t];
            do
              p = p(u);
            while (p !== null);
          }
          Kc = null, r7 = !1;
        } catch (x) {
          throw Kc !== null && (Kc = Kc.slice(t + 1)), ol(K1, Hd), x;
        } finally {
          fa(r), a7 = !1;
        }
      }
      return null;
    }
    var rp = [], ap = 0, $3 = null, W3 = 0, ys = [], xs = 0, c2 = null, Qc = 1, Xc = "";
    function XO(t) {
      return d2(), (t.flags & Dl) !== Et;
    }
    function JO(t) {
      return d2(), W3;
    }
    function eD() {
      var t = Xc, r = Qc, u = r & ~tD(r);
      return u.toString(32) + t;
    }
    function f2(t, r) {
      d2(), rp[ap++] = W3, rp[ap++] = $3, $3 = t, W3 = r;
    }
    function pS(t, r, u) {
      d2(), ys[xs++] = Qc, ys[xs++] = Xc, ys[xs++] = c2, c2 = t;
      var c = Qc, p = Xc, x = z3(c) - 1, _ = c & ~(1 << x), O = u + 1, k = z3(r) + x;
      if (k > 30) {
        var V = x - x % 5, U = (1 << V) - 1, ae = (_ & U).toString(32), re = _ >> V, xe = x - V, Ce = z3(r) + xe, Me = O << xe, it = Me | re, Ft = ae + p;
        Qc = 1 << Ce | it, Xc = Ft;
      } else {
        var At = O << x, kn = At | _, xn = p;
        Qc = 1 << k | kn, Xc = xn;
      }
    }
    function o7(t) {
      d2();
      var r = t.return;
      if (r !== null) {
        var u = 1, c = 0;
        f2(t, u), pS(t, u, c);
      }
    }
    function z3(t) {
      return 32 - Ur(t);
    }
    function tD(t) {
      return 1 << z3(t) - 1;
    }
    function i7(t) {
      for (; t === $3; )
        $3 = rp[--ap], rp[ap] = null, W3 = rp[--ap], rp[ap] = null;
      for (; t === c2; )
        c2 = ys[--xs], ys[xs] = null, Xc = ys[--xs], ys[xs] = null, Qc = ys[--xs], ys[xs] = null;
    }
    function nD() {
      return d2(), c2 !== null ? {
        id: Qc,
        overflow: Xc
      } : null;
    }
    function rD(t, r) {
      d2(), ys[xs++] = Qc, ys[xs++] = Xc, ys[xs++] = c2, Qc = r.id, Xc = r.overflow, c2 = t;
    }
    function d2() {
      hi() || m("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var di = null, Ss = null, h1 = !1, h2 = !1, Zd = null;
    function aD() {
      h1 && m("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function mS() {
      h2 = !0;
    }
    function oD() {
      return h2;
    }
    function iD(t) {
      var r = t.stateNode.containerInfo;
      return Ss = N3(r), di = t, h1 = !0, Zd = null, h2 = !1, !0;
    }
    function lD(t, r, u) {
      return Ss = H6(r), di = t, h1 = !0, Zd = null, h2 = !1, u !== null && rD(t, u), !0;
    }
    function gS(t, r) {
      switch (t.tag) {
        case T: {
          Y6(t.stateNode.containerInfo, r);
          break;
        }
        case j: {
          var u = (t.mode & an) !== kt;
          W6(
            t.type,
            t.memoizedProps,
            t.stateNode,
            r,
            // TODO: Delete this argument when we remove the legacy root API.
            u
          );
          break;
        }
        case Y: {
          var c = t.memoizedState;
          c.dehydrated !== null && $6(c.dehydrated, r);
          break;
        }
      }
    }
    function wS(t, r) {
      gS(t, r);
      var u = ck();
      u.stateNode = r, u.return = t;
      var c = t.deletions;
      c === null ? (t.deletions = [u], t.flags |= lu) : c.push(u);
    }
    function l7(t, r) {
      {
        if (h2)
          return;
        switch (t.tag) {
          case T: {
            var u = t.stateNode.containerInfo;
            switch (r.tag) {
              case j:
                var c = r.type;
                z6(u, c);
                break;
              case I:
                var p = r.pendingProps;
                q6(u, p);
                break;
            }
            break;
          }
          case j: {
            var x = t.type, _ = t.memoizedProps, O = t.stateNode;
            switch (r.tag) {
              case j: {
                var k = r.type, V = r.pendingProps, U = (t.mode & an) !== kt;
                Q6(
                  x,
                  _,
                  O,
                  k,
                  V,
                  // TODO: Delete this argument when we remove the legacy root API.
                  U
                );
                break;
              }
              case I: {
                var ae = r.pendingProps, re = (t.mode & an) !== kt;
                X6(
                  x,
                  _,
                  O,
                  ae,
                  // TODO: Delete this argument when we remove the legacy root API.
                  re
                );
                break;
              }
            }
            break;
          }
          case Y: {
            var xe = t.memoizedState, Ce = xe.dehydrated;
            if (Ce !== null) switch (r.tag) {
              case j:
                var Me = r.type;
                G6(Ce, Me);
                break;
              case I:
                var it = r.pendingProps;
                K6(Ce, it);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function yS(t, r) {
      r.flags = r.flags & ~Ir | Tt, l7(t, r);
    }
    function xS(t, r) {
      switch (t.tag) {
        case j: {
          var u = t.type, c = A6(r, u);
          return c !== null ? (t.stateNode = c, di = t, Ss = I6(c), !0) : !1;
        }
        case I: {
          var p = t.pendingProps, x = j6(r, p);
          return x !== null ? (t.stateNode = x, di = t, Ss = null, !0) : !1;
        }
        case Y: {
          var _ = k6(r);
          if (_ !== null) {
            var O = {
              dehydrated: _,
              treeContext: nD(),
              retryLane: yo
            };
            t.memoizedState = O;
            var k = fk(_);
            return k.return = t, t.child = k, di = t, Ss = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function u7(t) {
      return (t.mode & an) !== kt && (t.flags & Dt) === Et;
    }
    function s7(t) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function c7(t) {
      if (h1) {
        var r = Ss;
        if (!r) {
          u7(t) && (l7(di, t), s7()), yS(di, t), h1 = !1, di = t;
          return;
        }
        var u = r;
        if (!xS(t, r)) {
          u7(t) && (l7(di, t), s7()), r = u2(u);
          var c = di;
          if (!r || !xS(t, r)) {
            yS(di, t), h1 = !1, di = t;
            return;
          }
          wS(c, u);
        }
      }
    }
    function uD(t, r, u) {
      var c = t.stateNode, p = !h2, x = Z6(c, t.type, t.memoizedProps, r, u, t, p);
      return t.updateQueue = x, x !== null;
    }
    function sD(t) {
      var r = t.stateNode, u = t.memoizedProps, c = P6(r, u, t);
      if (c) {
        var p = di;
        if (p !== null)
          switch (p.tag) {
            case T: {
              var x = p.stateNode.containerInfo, _ = (p.mode & an) !== kt;
              B6(
                x,
                r,
                u,
                // TODO: Delete this argument when we remove the legacy root API.
                _
              );
              break;
            }
            case j: {
              var O = p.type, k = p.memoizedProps, V = p.stateNode, U = (p.mode & an) !== kt;
              U6(
                O,
                k,
                V,
                r,
                u,
                // TODO: Delete this argument when we remove the legacy root API.
                U
              );
              break;
            }
          }
      }
      return c;
    }
    function cD(t) {
      var r = t.memoizedState, u = r !== null ? r.dehydrated : null;
      if (!u)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      Zm(u, t);
    }
    function fD(t) {
      var r = t.memoizedState, u = r !== null ? r.dehydrated : null;
      if (!u)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return Pm(u);
    }
    function SS(t) {
      for (var r = t.return; r !== null && r.tag !== j && r.tag !== T && r.tag !== Y; )
        r = r.return;
      di = r;
    }
    function q3(t) {
      if (t !== di)
        return !1;
      if (!h1)
        return SS(t), h1 = !0, !1;
      if (t.tag !== T && (t.tag !== j || F6(t.type) && !Dm(t.type, t.memoizedProps))) {
        var r = Ss;
        if (r)
          if (u7(t))
            CS(t), s7();
          else
            for (; r; )
              wS(t, r), r = u2(r);
      }
      return SS(t), t.tag === Y ? Ss = fD(t) : Ss = di ? u2(t.stateNode) : null, !0;
    }
    function dD() {
      return h1 && Ss !== null;
    }
    function CS(t) {
      for (var r = Ss; r; )
        gS(t, r), r = u2(r);
    }
    function op() {
      di = null, Ss = null, h1 = !1, h2 = !1;
    }
    function bS() {
      Zd !== null && (mb(Zd), Zd = null);
    }
    function hi() {
      return h1;
    }
    function f7(t) {
      Zd === null ? Zd = [t] : Zd.push(t);
    }
    var hD = a.ReactCurrentBatchConfig, vD = null;
    function pD() {
      return hD.transition;
    }
    var v1 = {
      recordUnsafeLifecycleWarnings: function(t, r) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(t, r) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var mD = function(t) {
        for (var r = null, u = t; u !== null; )
          u.mode & nr && (r = u), u = u.return;
        return r;
      }, v2 = function(t) {
        var r = [];
        return t.forEach(function(u) {
          r.push(u);
        }), r.sort().join(", ");
      }, Vm = [], Fm = [], Bm = [], Um = [], Ym = [], $m = [], p2 = /* @__PURE__ */ new Set();
      v1.recordUnsafeLifecycleWarnings = function(t, r) {
        p2.has(t.type) || (typeof r.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        r.componentWillMount.__suppressDeprecationWarning !== !0 && Vm.push(t), t.mode & nr && typeof r.UNSAFE_componentWillMount == "function" && Fm.push(t), typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && Bm.push(t), t.mode & nr && typeof r.UNSAFE_componentWillReceiveProps == "function" && Um.push(t), typeof r.componentWillUpdate == "function" && r.componentWillUpdate.__suppressDeprecationWarning !== !0 && Ym.push(t), t.mode & nr && typeof r.UNSAFE_componentWillUpdate == "function" && $m.push(t));
      }, v1.flushPendingUnsafeLifecycleWarnings = function() {
        var t = /* @__PURE__ */ new Set();
        Vm.length > 0 && (Vm.forEach(function(re) {
          t.add(tn(re) || "Component"), p2.add(re.type);
        }), Vm = []);
        var r = /* @__PURE__ */ new Set();
        Fm.length > 0 && (Fm.forEach(function(re) {
          r.add(tn(re) || "Component"), p2.add(re.type);
        }), Fm = []);
        var u = /* @__PURE__ */ new Set();
        Bm.length > 0 && (Bm.forEach(function(re) {
          u.add(tn(re) || "Component"), p2.add(re.type);
        }), Bm = []);
        var c = /* @__PURE__ */ new Set();
        Um.length > 0 && (Um.forEach(function(re) {
          c.add(tn(re) || "Component"), p2.add(re.type);
        }), Um = []);
        var p = /* @__PURE__ */ new Set();
        Ym.length > 0 && (Ym.forEach(function(re) {
          p.add(tn(re) || "Component"), p2.add(re.type);
        }), Ym = []);
        var x = /* @__PURE__ */ new Set();
        if ($m.length > 0 && ($m.forEach(function(re) {
          x.add(tn(re) || "Component"), p2.add(re.type);
        }), $m = []), r.size > 0) {
          var _ = v2(r);
          m(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, _);
        }
        if (c.size > 0) {
          var O = v2(c);
          m(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, O);
        }
        if (x.size > 0) {
          var k = v2(x);
          m(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, k);
        }
        if (t.size > 0) {
          var V = v2(t);
          g(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, V);
        }
        if (u.size > 0) {
          var U = v2(u);
          g(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, U);
        }
        if (p.size > 0) {
          var ae = v2(p);
          g(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, ae);
        }
      };
      var G3 = /* @__PURE__ */ new Map(), _S = /* @__PURE__ */ new Set();
      v1.recordLegacyContextWarning = function(t, r) {
        var u = mD(t);
        if (u === null) {
          m("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!_S.has(t.type)) {
          var c = G3.get(u);
          (t.type.contextTypes != null || t.type.childContextTypes != null || r !== null && typeof r.getChildContext == "function") && (c === void 0 && (c = [], G3.set(u, c)), c.push(t));
        }
      }, v1.flushLegacyContextWarning = function() {
        G3.forEach(function(t, r) {
          if (t.length !== 0) {
            var u = t[0], c = /* @__PURE__ */ new Set();
            t.forEach(function(x) {
              c.add(tn(x) || "Component"), _S.add(x.type);
            });
            var p = v2(c);
            try {
              or(u), m(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, p);
            } finally {
              Vr();
            }
          }
        });
      }, v1.discardPendingWarnings = function() {
        Vm = [], Fm = [], Bm = [], Um = [], Ym = [], $m = [], G3 = /* @__PURE__ */ new Map();
      };
    }
    var d7, h7, v7, p7, m7, RS = function(t, r) {
    };
    d7 = !1, h7 = !1, v7 = {}, p7 = {}, m7 = {}, RS = function(t, r) {
      if (!(t === null || typeof t != "object") && !(!t._store || t._store.validated || t.key != null)) {
        if (typeof t._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        t._store.validated = !0;
        var u = tn(r) || "Component";
        p7[u] || (p7[u] = !0, m('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function gD(t) {
      return t.prototype && t.prototype.isReactComponent;
    }
    function Wm(t, r, u) {
      var c = u.ref;
      if (c !== null && typeof c != "function" && typeof c != "object") {
        if ((t.mode & nr || Je) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(u._owner && u._self && u._owner.stateNode !== u._self) && // Will already throw with "Function components cannot have string refs"
        !(u._owner && u._owner.tag !== R) && // Will already warn with "Function components cannot be given refs"
        !(typeof u.type == "function" && !gD(u.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        u._owner) {
          var p = tn(t) || "Component";
          v7[p] || (m('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', p, c), v7[p] = !0);
        }
        if (u._owner) {
          var x = u._owner, _;
          if (x) {
            var O = x;
            if (O.tag !== R)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            _ = O.stateNode;
          }
          if (!_)
            throw new Error("Missing owner for string ref " + c + ". This error is likely caused by a bug in React. Please file an issue.");
          var k = _;
          jr(c, "ref");
          var V = "" + c;
          if (r !== null && r.ref !== null && typeof r.ref == "function" && r.ref._stringRef === V)
            return r.ref;
          var U = function(ae) {
            var re = k.refs;
            ae === null ? delete re[V] : re[V] = ae;
          };
          return U._stringRef = V, U;
        } else {
          if (typeof c != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!u._owner)
            throw new Error("Element ref was specified as a string (" + c + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return c;
    }
    function K3(t, r) {
      var u = Object.prototype.toString.call(r);
      throw new Error("Objects are not valid as a React child (found: " + (u === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : u) + "). If you meant to render a collection of children, use an array instead.");
    }
    function Q3(t) {
      {
        var r = tn(t) || "Component";
        if (m7[r])
          return;
        m7[r] = !0, m("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function ES(t) {
      var r = t._payload, u = t._init;
      return u(r);
    }
    function MS(t) {
      function r(he, Te) {
        if (t) {
          var ve = he.deletions;
          ve === null ? (he.deletions = [Te], he.flags |= lu) : ve.push(Te);
        }
      }
      function u(he, Te) {
        if (!t)
          return null;
        for (var ve = Te; ve !== null; )
          r(he, ve), ve = ve.sibling;
        return null;
      }
      function c(he, Te) {
        for (var ve = /* @__PURE__ */ new Map(), ze = Te; ze !== null; )
          ze.key !== null ? ve.set(ze.key, ze) : ve.set(ze.index, ze), ze = ze.sibling;
        return ve;
      }
      function p(he, Te) {
        var ve = _2(he, Te);
        return ve.index = 0, ve.sibling = null, ve;
      }
      function x(he, Te, ve) {
        if (he.index = ve, !t)
          return he.flags |= Dl, Te;
        var ze = he.alternate;
        if (ze !== null) {
          var gt = ze.index;
          return gt < Te ? (he.flags |= Tt, Te) : gt;
        } else
          return he.flags |= Tt, Te;
      }
      function _(he) {
        return t && he.alternate === null && (he.flags |= Tt), he;
      }
      function O(he, Te, ve, ze) {
        if (Te === null || Te.tag !== I) {
          var gt = c9(ve, he.mode, ze);
          return gt.return = he, gt;
        } else {
          var ft = p(Te, ve);
          return ft.return = he, ft;
        }
      }
      function k(he, Te, ve, ze) {
        var gt = ve.type;
        if (gt === ti)
          return U(he, Te, ve.props.children, ze, ve.key);
        if (Te !== null && (Te.elementType === gt || // Keep this check inline so it only runs on the false path:
        jb(Te, ve) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof gt == "object" && gt !== null && gt.$$typeof === vt && ES(gt) === Te.type)) {
          var ft = p(Te, ve.props);
          return ft.ref = Wm(he, Te, ve), ft.return = he, ft._debugSource = ve._source, ft._debugOwner = ve._owner, ft;
        }
        var Jt = s9(ve, he.mode, ze);
        return Jt.ref = Wm(he, Te, ve), Jt.return = he, Jt;
      }
      function V(he, Te, ve, ze) {
        if (Te === null || Te.tag !== A || Te.stateNode.containerInfo !== ve.containerInfo || Te.stateNode.implementation !== ve.implementation) {
          var gt = f9(ve, he.mode, ze);
          return gt.return = he, gt;
        } else {
          var ft = p(Te, ve.children || []);
          return ft.return = he, ft;
        }
      }
      function U(he, Te, ve, ze, gt) {
        if (Te === null || Te.tag !== Z) {
          var ft = qd(ve, he.mode, ze, gt);
          return ft.return = he, ft;
        } else {
          var Jt = p(Te, ve);
          return Jt.return = he, Jt;
        }
      }
      function ae(he, Te, ve) {
        if (typeof Te == "string" && Te !== "" || typeof Te == "number") {
          var ze = c9("" + Te, he.mode, ve);
          return ze.return = he, ze;
        }
        if (typeof Te == "object" && Te !== null) {
          switch (Te.$$typeof) {
            case _i: {
              var gt = s9(Te, he.mode, ve);
              return gt.ref = Wm(he, null, Te), gt.return = he, gt;
            }
            case ei: {
              var ft = f9(Te, he.mode, ve);
              return ft.return = he, ft;
            }
            case vt: {
              var Jt = Te._payload, rn = Te._init;
              return ae(he, rn(Jt), ve);
            }
          }
          if (er(Te) || Io(Te)) {
            var gr = qd(Te, he.mode, ve, null);
            return gr.return = he, gr;
          }
          K3(he, Te);
        }
        return typeof Te == "function" && Q3(he), null;
      }
      function re(he, Te, ve, ze) {
        var gt = Te !== null ? Te.key : null;
        if (typeof ve == "string" && ve !== "" || typeof ve == "number")
          return gt !== null ? null : O(he, Te, "" + ve, ze);
        if (typeof ve == "object" && ve !== null) {
          switch (ve.$$typeof) {
            case _i:
              return ve.key === gt ? k(he, Te, ve, ze) : null;
            case ei:
              return ve.key === gt ? V(he, Te, ve, ze) : null;
            case vt: {
              var ft = ve._payload, Jt = ve._init;
              return re(he, Te, Jt(ft), ze);
            }
          }
          if (er(ve) || Io(ve))
            return gt !== null ? null : U(he, Te, ve, ze, null);
          K3(he, ve);
        }
        return typeof ve == "function" && Q3(he), null;
      }
      function xe(he, Te, ve, ze, gt) {
        if (typeof ze == "string" && ze !== "" || typeof ze == "number") {
          var ft = he.get(ve) || null;
          return O(Te, ft, "" + ze, gt);
        }
        if (typeof ze == "object" && ze !== null) {
          switch (ze.$$typeof) {
            case _i: {
              var Jt = he.get(ze.key === null ? ve : ze.key) || null;
              return k(Te, Jt, ze, gt);
            }
            case ei: {
              var rn = he.get(ze.key === null ? ve : ze.key) || null;
              return V(Te, rn, ze, gt);
            }
            case vt:
              var gr = ze._payload, Qn = ze._init;
              return xe(he, Te, ve, Qn(gr), gt);
          }
          if (er(ze) || Io(ze)) {
            var Ja = he.get(ve) || null;
            return U(Te, Ja, ze, gt, null);
          }
          K3(Te, ze);
        }
        return typeof ze == "function" && Q3(Te), null;
      }
      function Ce(he, Te, ve) {
        {
          if (typeof he != "object" || he === null)
            return Te;
          switch (he.$$typeof) {
            case _i:
            case ei:
              RS(he, ve);
              var ze = he.key;
              if (typeof ze != "string")
                break;
              if (Te === null) {
                Te = /* @__PURE__ */ new Set(), Te.add(ze);
                break;
              }
              if (!Te.has(ze)) {
                Te.add(ze);
                break;
              }
              m("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", ze);
              break;
            case vt:
              var gt = he._payload, ft = he._init;
              Ce(ft(gt), Te, ve);
              break;
          }
        }
        return Te;
      }
      function Me(he, Te, ve, ze) {
        for (var gt = null, ft = 0; ft < ve.length; ft++) {
          var Jt = ve[ft];
          gt = Ce(Jt, gt, he);
        }
        for (var rn = null, gr = null, Qn = Te, Ja = 0, Xn = 0, La = null; Qn !== null && Xn < ve.length; Xn++) {
          Qn.index > Xn ? (La = Qn, Qn = null) : La = Qn.sibling;
          var Yi = re(he, Qn, ve[Xn], ze);
          if (Yi === null) {
            Qn === null && (Qn = La);
            break;
          }
          t && Qn && Yi.alternate === null && r(he, Qn), Ja = x(Yi, Ja, Xn), gr === null ? rn = Yi : gr.sibling = Yi, gr = Yi, Qn = La;
        }
        if (Xn === ve.length) {
          if (u(he, Qn), hi()) {
            var xi = Xn;
            f2(he, xi);
          }
          return rn;
        }
        if (Qn === null) {
          for (; Xn < ve.length; Xn++) {
            var Mu = ae(he, ve[Xn], ze);
            Mu !== null && (Ja = x(Mu, Ja, Xn), gr === null ? rn = Mu : gr.sibling = Mu, gr = Mu);
          }
          if (hi()) {
            var ml = Xn;
            f2(he, ml);
          }
          return rn;
        }
        for (var gl = c(he, Qn); Xn < ve.length; Xn++) {
          var $i = xe(gl, he, Xn, ve[Xn], ze);
          $i !== null && (t && $i.alternate !== null && gl.delete($i.key === null ? Xn : $i.key), Ja = x($i, Ja, Xn), gr === null ? rn = $i : gr.sibling = $i, gr = $i);
        }
        if (t && gl.forEach(function(_p) {
          return r(he, _p);
        }), hi()) {
          var of = Xn;
          f2(he, of);
        }
        return rn;
      }
      function it(he, Te, ve, ze) {
        var gt = Io(ve);
        if (typeof gt != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          ve[Symbol.toStringTag] === "Generator" && (h7 || m("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), h7 = !0), ve.entries === gt && (d7 || m("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), d7 = !0);
          var ft = gt.call(ve);
          if (ft)
            for (var Jt = null, rn = ft.next(); !rn.done; rn = ft.next()) {
              var gr = rn.value;
              Jt = Ce(gr, Jt, he);
            }
        }
        var Qn = gt.call(ve);
        if (Qn == null)
          throw new Error("An iterable object provided no iterator.");
        for (var Ja = null, Xn = null, La = Te, Yi = 0, xi = 0, Mu = null, ml = Qn.next(); La !== null && !ml.done; xi++, ml = Qn.next()) {
          La.index > xi ? (Mu = La, La = null) : Mu = La.sibling;
          var gl = re(he, La, ml.value, ze);
          if (gl === null) {
            La === null && (La = Mu);
            break;
          }
          t && La && gl.alternate === null && r(he, La), Yi = x(gl, Yi, xi), Xn === null ? Ja = gl : Xn.sibling = gl, Xn = gl, La = Mu;
        }
        if (ml.done) {
          if (u(he, La), hi()) {
            var $i = xi;
            f2(he, $i);
          }
          return Ja;
        }
        if (La === null) {
          for (; !ml.done; xi++, ml = Qn.next()) {
            var of = ae(he, ml.value, ze);
            of !== null && (Yi = x(of, Yi, xi), Xn === null ? Ja = of : Xn.sibling = of, Xn = of);
          }
          if (hi()) {
            var _p = xi;
            f2(he, _p);
          }
          return Ja;
        }
        for (var _4 = c(he, La); !ml.done; xi++, ml = Qn.next()) {
          var L0 = xe(_4, he, xi, ml.value, ze);
          L0 !== null && (t && L0.alternate !== null && _4.delete(L0.key === null ? xi : L0.key), Yi = x(L0, Yi, xi), Xn === null ? Ja = L0 : Xn.sibling = L0, Xn = L0);
        }
        if (t && _4.forEach(function(Bk) {
          return r(he, Bk);
        }), hi()) {
          var Fk = xi;
          f2(he, Fk);
        }
        return Ja;
      }
      function Ft(he, Te, ve, ze) {
        if (Te !== null && Te.tag === I) {
          u(he, Te.sibling);
          var gt = p(Te, ve);
          return gt.return = he, gt;
        }
        u(he, Te);
        var ft = c9(ve, he.mode, ze);
        return ft.return = he, ft;
      }
      function At(he, Te, ve, ze) {
        for (var gt = ve.key, ft = Te; ft !== null; ) {
          if (ft.key === gt) {
            var Jt = ve.type;
            if (Jt === ti) {
              if (ft.tag === Z) {
                u(he, ft.sibling);
                var rn = p(ft, ve.props.children);
                return rn.return = he, rn._debugSource = ve._source, rn._debugOwner = ve._owner, rn;
              }
            } else if (ft.elementType === Jt || // Keep this check inline so it only runs on the false path:
            jb(ft, ve) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof Jt == "object" && Jt !== null && Jt.$$typeof === vt && ES(Jt) === ft.type) {
              u(he, ft.sibling);
              var gr = p(ft, ve.props);
              return gr.ref = Wm(he, ft, ve), gr.return = he, gr._debugSource = ve._source, gr._debugOwner = ve._owner, gr;
            }
            u(he, ft);
            break;
          } else
            r(he, ft);
          ft = ft.sibling;
        }
        if (ve.type === ti) {
          var Qn = qd(ve.props.children, he.mode, ze, ve.key);
          return Qn.return = he, Qn;
        } else {
          var Ja = s9(ve, he.mode, ze);
          return Ja.ref = Wm(he, Te, ve), Ja.return = he, Ja;
        }
      }
      function kn(he, Te, ve, ze) {
        for (var gt = ve.key, ft = Te; ft !== null; ) {
          if (ft.key === gt)
            if (ft.tag === A && ft.stateNode.containerInfo === ve.containerInfo && ft.stateNode.implementation === ve.implementation) {
              u(he, ft.sibling);
              var Jt = p(ft, ve.children || []);
              return Jt.return = he, Jt;
            } else {
              u(he, ft);
              break;
            }
          else
            r(he, ft);
          ft = ft.sibling;
        }
        var rn = f9(ve, he.mode, ze);
        return rn.return = he, rn;
      }
      function xn(he, Te, ve, ze) {
        var gt = typeof ve == "object" && ve !== null && ve.type === ti && ve.key === null;
        if (gt && (ve = ve.props.children), typeof ve == "object" && ve !== null) {
          switch (ve.$$typeof) {
            case _i:
              return _(At(he, Te, ve, ze));
            case ei:
              return _(kn(he, Te, ve, ze));
            case vt:
              var ft = ve._payload, Jt = ve._init;
              return xn(he, Te, Jt(ft), ze);
          }
          if (er(ve))
            return Me(he, Te, ve, ze);
          if (Io(ve))
            return it(he, Te, ve, ze);
          K3(he, ve);
        }
        return typeof ve == "string" && ve !== "" || typeof ve == "number" ? _(Ft(he, Te, "" + ve, ze)) : (typeof ve == "function" && Q3(he), u(he, Te));
      }
      return xn;
    }
    var ip = MS(!0), TS = MS(!1);
    function wD(t, r) {
      if (t !== null && r.child !== t.child)
        throw new Error("Resuming work not yet implemented.");
      if (r.child !== null) {
        var u = r.child, c = _2(u, u.pendingProps);
        for (r.child = c, c.return = r; u.sibling !== null; )
          u = u.sibling, c = c.sibling = _2(u, u.pendingProps), c.return = r;
        c.sibling = null;
      }
    }
    function yD(t, r) {
      for (var u = t.child; u !== null; )
        ok(u, r), u = u.sibling;
    }
    var g7 = ka(null), w7;
    w7 = {};
    var X3 = null, lp = null, y7 = null, J3 = !1;
    function eg() {
      X3 = null, lp = null, y7 = null, J3 = !1;
    }
    function OS() {
      J3 = !0;
    }
    function DS() {
      J3 = !1;
    }
    function AS(t, r, u) {
      Dr(g7, r._currentValue, t), r._currentValue = u, r._currentRenderer !== void 0 && r._currentRenderer !== null && r._currentRenderer !== w7 && m("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), r._currentRenderer = w7;
    }
    function x7(t, r) {
      var u = g7.current;
      En(g7, r), t._currentValue = u;
    }
    function S7(t, r, u) {
      for (var c = t; c !== null; ) {
        var p = c.alternate;
        if (ss(c.childLanes, r) ? p !== null && !ss(p.childLanes, r) && (p.childLanes = Bt(p.childLanes, r)) : (c.childLanes = Bt(c.childLanes, r), p !== null && (p.childLanes = Bt(p.childLanes, r))), c === u)
          break;
        c = c.return;
      }
      c !== u && m("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function xD(t, r, u) {
      SD(t, r, u);
    }
    function SD(t, r, u) {
      var c = t.child;
      for (c !== null && (c.return = t); c !== null; ) {
        var p = void 0, x = c.dependencies;
        if (x !== null) {
          p = c.child;
          for (var _ = x.firstContext; _ !== null; ) {
            if (_.context === r) {
              if (c.tag === R) {
                var O = us(u), k = Jc(mn, O);
                k.tag = ng;
                var V = c.updateQueue;
                if (V !== null) {
                  var U = V.shared, ae = U.pending;
                  ae === null ? k.next = k : (k.next = ae.next, ae.next = k), U.pending = k;
                }
              }
              c.lanes = Bt(c.lanes, u);
              var re = c.alternate;
              re !== null && (re.lanes = Bt(re.lanes, u)), S7(c.return, u, t), x.lanes = Bt(x.lanes, u);
              break;
            }
            _ = _.next;
          }
        } else if (c.tag === $)
          p = c.type === t.type ? null : c.child;
        else if (c.tag === me) {
          var xe = c.return;
          if (xe === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          xe.lanes = Bt(xe.lanes, u);
          var Ce = xe.alternate;
          Ce !== null && (Ce.lanes = Bt(Ce.lanes, u)), S7(xe, u, t), p = c.sibling;
        } else
          p = c.child;
        if (p !== null)
          p.return = c;
        else
          for (p = c; p !== null; ) {
            if (p === t) {
              p = null;
              break;
            }
            var Me = p.sibling;
            if (Me !== null) {
              Me.return = p.return, p = Me;
              break;
            }
            p = p.return;
          }
        c = p;
      }
    }
    function up(t, r) {
      X3 = t, lp = null, y7 = null;
      var u = t.dependencies;
      if (u !== null) {
        var c = u.firstContext;
        c !== null && (Bo(u.lanes, r) && l4(), u.firstContext = null);
      }
    }
    function fo(t) {
      J3 && m("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var r = t._currentValue;
      if (y7 !== t) {
        var u = {
          context: t,
          memoizedValue: r,
          next: null
        };
        if (lp === null) {
          if (X3 === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          lp = u, X3.dependencies = {
            lanes: be,
            firstContext: u
          };
        } else
          lp = lp.next = u;
      }
      return r;
    }
    var m2 = null;
    function C7(t) {
      m2 === null ? m2 = [t] : m2.push(t);
    }
    function CD() {
      if (m2 !== null) {
        for (var t = 0; t < m2.length; t++) {
          var r = m2[t], u = r.interleaved;
          if (u !== null) {
            r.interleaved = null;
            var c = u.next, p = r.pending;
            if (p !== null) {
              var x = p.next;
              p.next = c, u.next = x;
            }
            r.pending = u;
          }
        }
        m2 = null;
      }
    }
    function jS(t, r, u, c) {
      var p = r.interleaved;
      return p === null ? (u.next = u, C7(r)) : (u.next = p.next, p.next = u), r.interleaved = u, tg(t, c);
    }
    function bD(t, r, u, c) {
      var p = r.interleaved;
      p === null ? (u.next = u, C7(r)) : (u.next = p.next, p.next = u), r.interleaved = u;
    }
    function _D(t, r, u, c) {
      var p = r.interleaved;
      return p === null ? (u.next = u, C7(r)) : (u.next = p.next, p.next = u), r.interleaved = u, tg(t, c);
    }
    function Nl(t, r) {
      return tg(t, r);
    }
    var RD = tg;
    function tg(t, r) {
      t.lanes = Bt(t.lanes, r);
      var u = t.alternate;
      u !== null && (u.lanes = Bt(u.lanes, r)), u === null && (t.flags & (Tt | Ir)) !== Et && Tb(t);
      for (var c = t, p = t.return; p !== null; )
        p.childLanes = Bt(p.childLanes, r), u = p.alternate, u !== null ? u.childLanes = Bt(u.childLanes, r) : (p.flags & (Tt | Ir)) !== Et && Tb(t), c = p, p = p.return;
      if (c.tag === T) {
        var x = c.stateNode;
        return x;
      } else
        return null;
    }
    var kS = 0, LS = 1, ng = 2, b7 = 3, rg = !1, _7, ag;
    _7 = !1, ag = null;
    function R7(t) {
      var r = {
        baseState: t.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: be
        },
        effects: null
      };
      t.updateQueue = r;
    }
    function IS(t, r) {
      var u = r.updateQueue, c = t.updateQueue;
      if (u === c) {
        var p = {
          baseState: c.baseState,
          firstBaseUpdate: c.firstBaseUpdate,
          lastBaseUpdate: c.lastBaseUpdate,
          shared: c.shared,
          effects: c.effects
        };
        r.updateQueue = p;
      }
    }
    function Jc(t, r) {
      var u = {
        eventTime: t,
        lane: r,
        tag: kS,
        payload: null,
        callback: null,
        next: null
      };
      return u;
    }
    function Pd(t, r, u) {
      var c = t.updateQueue;
      if (c === null)
        return null;
      var p = c.shared;
      if (ag === p && !_7 && (m("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), _7 = !0), Cj()) {
        var x = p.pending;
        return x === null ? r.next = r : (r.next = x.next, x.next = r), p.pending = r, RD(t, u);
      } else
        return _D(t, p, r, u);
    }
    function og(t, r, u) {
      var c = r.updateQueue;
      if (c !== null) {
        var p = c.shared;
        if (Ac(u)) {
          var x = p.lanes;
          x = ld(x, t.pendingLanes);
          var _ = Bt(x, u);
          p.lanes = _, f0(t, _);
        }
      }
    }
    function E7(t, r) {
      var u = t.updateQueue, c = t.alternate;
      if (c !== null) {
        var p = c.updateQueue;
        if (u === p) {
          var x = null, _ = null, O = u.firstBaseUpdate;
          if (O !== null) {
            var k = O;
            do {
              var V = {
                eventTime: k.eventTime,
                lane: k.lane,
                tag: k.tag,
                payload: k.payload,
                callback: k.callback,
                next: null
              };
              _ === null ? x = _ = V : (_.next = V, _ = V), k = k.next;
            } while (k !== null);
            _ === null ? x = _ = r : (_.next = r, _ = r);
          } else
            x = _ = r;
          u = {
            baseState: p.baseState,
            firstBaseUpdate: x,
            lastBaseUpdate: _,
            shared: p.shared,
            effects: p.effects
          }, t.updateQueue = u;
          return;
        }
      }
      var U = u.lastBaseUpdate;
      U === null ? u.firstBaseUpdate = r : U.next = r, u.lastBaseUpdate = r;
    }
    function ED(t, r, u, c, p, x) {
      switch (u.tag) {
        case LS: {
          var _ = u.payload;
          if (typeof _ == "function") {
            OS();
            var O = _.call(x, c, p);
            {
              if (t.mode & nr) {
                Sr(!0);
                try {
                  _.call(x, c, p);
                } finally {
                  Sr(!1);
                }
              }
              DS();
            }
            return O;
          }
          return _;
        }
        case b7:
          t.flags = t.flags & ~pr | Dt;
        case kS: {
          var k = u.payload, V;
          if (typeof k == "function") {
            OS(), V = k.call(x, c, p);
            {
              if (t.mode & nr) {
                Sr(!0);
                try {
                  k.call(x, c, p);
                } finally {
                  Sr(!1);
                }
              }
              DS();
            }
          } else
            V = k;
          return V == null ? c : mt({}, c, V);
        }
        case ng:
          return rg = !0, c;
      }
      return c;
    }
    function ig(t, r, u, c) {
      var p = t.updateQueue;
      rg = !1, ag = p.shared;
      var x = p.firstBaseUpdate, _ = p.lastBaseUpdate, O = p.shared.pending;
      if (O !== null) {
        p.shared.pending = null;
        var k = O, V = k.next;
        k.next = null, _ === null ? x = V : _.next = V, _ = k;
        var U = t.alternate;
        if (U !== null) {
          var ae = U.updateQueue, re = ae.lastBaseUpdate;
          re !== _ && (re === null ? ae.firstBaseUpdate = V : re.next = V, ae.lastBaseUpdate = k);
        }
      }
      if (x !== null) {
        var xe = p.baseState, Ce = be, Me = null, it = null, Ft = null, At = x;
        do {
          var kn = At.lane, xn = At.eventTime;
          if (ss(c, kn)) {
            if (Ft !== null) {
              var Te = {
                eventTime: xn,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: An,
                tag: At.tag,
                payload: At.payload,
                callback: At.callback,
                next: null
              };
              Ft = Ft.next = Te;
            }
            xe = ED(t, p, At, xe, r, u);
            var ve = At.callback;
            if (ve !== null && // If the update was already committed, we should not queue its
            // callback again.
            At.lane !== An) {
              t.flags |= ao;
              var ze = p.effects;
              ze === null ? p.effects = [At] : ze.push(At);
            }
          } else {
            var he = {
              eventTime: xn,
              lane: kn,
              tag: At.tag,
              payload: At.payload,
              callback: At.callback,
              next: null
            };
            Ft === null ? (it = Ft = he, Me = xe) : Ft = Ft.next = he, Ce = Bt(Ce, kn);
          }
          if (At = At.next, At === null) {
            if (O = p.shared.pending, O === null)
              break;
            var gt = O, ft = gt.next;
            gt.next = null, At = ft, p.lastBaseUpdate = gt, p.shared.pending = null;
          }
        } while (!0);
        Ft === null && (Me = xe), p.baseState = Me, p.firstBaseUpdate = it, p.lastBaseUpdate = Ft;
        var Jt = p.shared.interleaved;
        if (Jt !== null) {
          var rn = Jt;
          do
            Ce = Bt(Ce, rn.lane), rn = rn.next;
          while (rn !== Jt);
        } else x === null && (p.shared.lanes = be);
        y4(Ce), t.lanes = Ce, t.memoizedState = xe;
      }
      ag = null;
    }
    function MD(t, r) {
      if (typeof t != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + t));
      t.call(r);
    }
    function HS() {
      rg = !1;
    }
    function lg() {
      return rg;
    }
    function ZS(t, r, u) {
      var c = r.effects;
      if (r.effects = null, c !== null)
        for (var p = 0; p < c.length; p++) {
          var x = c[p], _ = x.callback;
          _ !== null && (x.callback = null, MD(_, u));
        }
    }
    var zm = {}, Nd = ka(zm), qm = ka(zm), ug = ka(zm);
    function sg(t) {
      if (t === zm)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return t;
    }
    function PS() {
      var t = sg(ug.current);
      return t;
    }
    function M7(t, r) {
      Dr(ug, r, t), Dr(qm, t, t), Dr(Nd, zm, t);
      var u = u6(r);
      En(Nd, t), Dr(Nd, u, t);
    }
    function sp(t) {
      En(Nd, t), En(qm, t), En(ug, t);
    }
    function T7() {
      var t = sg(Nd.current);
      return t;
    }
    function NS(t) {
      sg(ug.current);
      var r = sg(Nd.current), u = s6(r, t.type);
      r !== u && (Dr(qm, t, t), Dr(Nd, u, t));
    }
    function O7(t) {
      qm.current === t && (En(Nd, t), En(qm, t));
    }
    var TD = 0, VS = 1, FS = 1, Gm = 2, p1 = ka(TD);
    function D7(t, r) {
      return (t & r) !== 0;
    }
    function cp(t) {
      return t & VS;
    }
    function A7(t, r) {
      return t & VS | r;
    }
    function OD(t, r) {
      return t | r;
    }
    function Vd(t, r) {
      Dr(p1, r, t);
    }
    function fp(t) {
      En(p1, t);
    }
    function DD(t, r) {
      var u = t.memoizedState;
      return u !== null ? u.dehydrated !== null : !0;
    }
    function cg(t) {
      for (var r = t; r !== null; ) {
        if (r.tag === Y) {
          var u = r.memoizedState;
          if (u !== null) {
            var c = u.dehydrated;
            if (c === null || Jv(c) || Im(c))
              return r;
          }
        } else if (r.tag === oe && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        r.memoizedProps.revealOrder !== void 0) {
          var p = (r.flags & Dt) !== Et;
          if (p)
            return r;
        } else if (r.child !== null) {
          r.child.return = r, r = r.child;
          continue;
        }
        if (r === t)
          return null;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === t)
            return null;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
      return null;
    }
    var Vl = (
      /*   */
      0
    ), Eo = (
      /* */
      1
    ), M0 = (
      /*  */
      2
    ), Mo = (
      /*    */
      4
    ), vi = (
      /*   */
      8
    ), j7 = [];
    function k7() {
      for (var t = 0; t < j7.length; t++) {
        var r = j7[t];
        r._workInProgressVersionPrimary = null;
      }
      j7.length = 0;
    }
    function AD(t, r) {
      var u = r._getVersion, c = u(r._source);
      t.mutableSourceEagerHydrationData == null ? t.mutableSourceEagerHydrationData = [r, c] : t.mutableSourceEagerHydrationData.push(r, c);
    }
    var pt = a.ReactCurrentDispatcher, Km = a.ReactCurrentBatchConfig, L7, dp;
    L7 = /* @__PURE__ */ new Set();
    var g2 = be, mr = null, To = null, Oo = null, fg = !1, Qm = !1, Xm = 0, jD = 0, kD = 25, Le = null, Cs = null, Fd = -1, I7 = !1;
    function ir() {
      {
        var t = Le;
        Cs === null ? Cs = [t] : Cs.push(t);
      }
    }
    function tt() {
      {
        var t = Le;
        Cs !== null && (Fd++, Cs[Fd] !== t && LD(t));
      }
    }
    function hp(t) {
      t != null && !er(t) && m("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", Le, typeof t);
    }
    function LD(t) {
      {
        var r = tn(mr);
        if (!L7.has(r) && (L7.add(r), Cs !== null)) {
          for (var u = "", c = 30, p = 0; p <= Fd; p++) {
            for (var x = Cs[p], _ = p === Fd ? t : x, O = p + 1 + ". " + x; O.length < c; )
              O += " ";
            O += _ + `
`, u += O;
          }
          m(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, r, u);
        }
      }
    }
    function Ui() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function H7(t, r) {
      if (I7)
        return !1;
      if (r === null)
        return m("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", Le), !1;
      t.length !== r.length && m(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, Le, "[" + r.join(", ") + "]", "[" + t.join(", ") + "]");
      for (var u = 0; u < r.length && u < t.length; u++)
        if (!Fe(t[u], r[u]))
          return !1;
      return !0;
    }
    function vp(t, r, u, c, p, x) {
      g2 = x, mr = r, Cs = t !== null ? t._debugHookTypes : null, Fd = -1, I7 = t !== null && t.type !== r.type, r.memoizedState = null, r.updateQueue = null, r.lanes = be, t !== null && t.memoizedState !== null ? pt.current = sC : Cs !== null ? pt.current = uC : pt.current = lC;
      var _ = u(c, p);
      if (Qm) {
        var O = 0;
        do {
          if (Qm = !1, Xm = 0, O >= kD)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          O += 1, I7 = !1, To = null, Oo = null, r.updateQueue = null, Fd = -1, pt.current = cC, _ = u(c, p);
        } while (Qm);
      }
      pt.current = _g, r._debugHookTypes = Cs;
      var k = To !== null && To.next !== null;
      if (g2 = be, mr = null, To = null, Oo = null, Le = null, Cs = null, Fd = -1, t !== null && (t.flags & sa) !== (r.flags & sa) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (t.mode & an) !== kt && m("Internal React error: Expected static flag was missing. Please notify the React team."), fg = !1, k)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return _;
    }
    function pp() {
      var t = Xm !== 0;
      return Xm = 0, t;
    }
    function BS(t, r, u) {
      r.updateQueue = t.updateQueue, (r.mode & Vn) !== kt ? r.flags &= ~(nl | wo | Mr | un) : r.flags &= ~(Mr | un), t.lanes = u0(t.lanes, u);
    }
    function US() {
      if (pt.current = _g, fg) {
        for (var t = mr.memoizedState; t !== null; ) {
          var r = t.queue;
          r !== null && (r.pending = null), t = t.next;
        }
        fg = !1;
      }
      g2 = be, mr = null, To = null, Oo = null, Cs = null, Fd = -1, Le = null, nC = !1, Qm = !1, Xm = 0;
    }
    function T0() {
      var t = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Oo === null ? mr.memoizedState = Oo = t : Oo = Oo.next = t, Oo;
    }
    function bs() {
      var t;
      if (To === null) {
        var r = mr.alternate;
        r !== null ? t = r.memoizedState : t = null;
      } else
        t = To.next;
      var u;
      if (Oo === null ? u = mr.memoizedState : u = Oo.next, u !== null)
        Oo = u, u = Oo.next, To = t;
      else {
        if (t === null)
          throw new Error("Rendered more hooks than during the previous render.");
        To = t;
        var c = {
          memoizedState: To.memoizedState,
          baseState: To.baseState,
          baseQueue: To.baseQueue,
          queue: To.queue,
          next: null
        };
        Oo === null ? mr.memoizedState = Oo = c : Oo = Oo.next = c;
      }
      return Oo;
    }
    function YS() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function Z7(t, r) {
      return typeof r == "function" ? r(t) : r;
    }
    function P7(t, r, u) {
      var c = T0(), p;
      u !== void 0 ? p = u(r) : p = r, c.memoizedState = c.baseState = p;
      var x = {
        pending: null,
        interleaved: null,
        lanes: be,
        dispatch: null,
        lastRenderedReducer: t,
        lastRenderedState: p
      };
      c.queue = x;
      var _ = x.dispatch = PD.bind(null, mr, x);
      return [c.memoizedState, _];
    }
    function N7(t, r, u) {
      var c = bs(), p = c.queue;
      if (p === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      p.lastRenderedReducer = t;
      var x = To, _ = x.baseQueue, O = p.pending;
      if (O !== null) {
        if (_ !== null) {
          var k = _.next, V = O.next;
          _.next = V, O.next = k;
        }
        x.baseQueue !== _ && m("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), x.baseQueue = _ = O, p.pending = null;
      }
      if (_ !== null) {
        var U = _.next, ae = x.baseState, re = null, xe = null, Ce = null, Me = U;
        do {
          var it = Me.lane;
          if (ss(g2, it)) {
            if (Ce !== null) {
              var At = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: An,
                action: Me.action,
                hasEagerState: Me.hasEagerState,
                eagerState: Me.eagerState,
                next: null
              };
              Ce = Ce.next = At;
            }
            if (Me.hasEagerState)
              ae = Me.eagerState;
            else {
              var kn = Me.action;
              ae = t(ae, kn);
            }
          } else {
            var Ft = {
              lane: it,
              action: Me.action,
              hasEagerState: Me.hasEagerState,
              eagerState: Me.eagerState,
              next: null
            };
            Ce === null ? (xe = Ce = Ft, re = ae) : Ce = Ce.next = Ft, mr.lanes = Bt(mr.lanes, it), y4(it);
          }
          Me = Me.next;
        } while (Me !== null && Me !== U);
        Ce === null ? re = ae : Ce.next = xe, Fe(ae, c.memoizedState) || l4(), c.memoizedState = ae, c.baseState = re, c.baseQueue = Ce, p.lastRenderedState = ae;
      }
      var xn = p.interleaved;
      if (xn !== null) {
        var he = xn;
        do {
          var Te = he.lane;
          mr.lanes = Bt(mr.lanes, Te), y4(Te), he = he.next;
        } while (he !== xn);
      } else _ === null && (p.lanes = be);
      var ve = p.dispatch;
      return [c.memoizedState, ve];
    }
    function V7(t, r, u) {
      var c = bs(), p = c.queue;
      if (p === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      p.lastRenderedReducer = t;
      var x = p.dispatch, _ = p.pending, O = c.memoizedState;
      if (_ !== null) {
        p.pending = null;
        var k = _.next, V = k;
        do {
          var U = V.action;
          O = t(O, U), V = V.next;
        } while (V !== k);
        Fe(O, c.memoizedState) || l4(), c.memoizedState = O, c.baseQueue === null && (c.baseState = O), p.lastRenderedState = O;
      }
      return [O, x];
    }
    function _Q(t, r, u) {
    }
    function RQ(t, r, u) {
    }
    function F7(t, r, u) {
      var c = mr, p = T0(), x, _ = hi();
      if (_) {
        if (u === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        x = u(), dp || x !== u() && (m("The result of getServerSnapshot should be cached to avoid an infinite loop"), dp = !0);
      } else {
        if (x = r(), !dp) {
          var O = r();
          Fe(x, O) || (m("The result of getSnapshot should be cached to avoid an infinite loop"), dp = !0);
        }
        var k = Ug();
        if (k === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Oc(k, g2) || $S(c, r, x);
      }
      p.memoizedState = x;
      var V = {
        value: x,
        getSnapshot: r
      };
      return p.queue = V, mg(zS.bind(null, c, V, t), [t]), c.flags |= Mr, Jm(Eo | vi, WS.bind(null, c, V, x, r), void 0, null), x;
    }
    function dg(t, r, u) {
      var c = mr, p = bs(), x = r();
      if (!dp) {
        var _ = r();
        Fe(x, _) || (m("The result of getSnapshot should be cached to avoid an infinite loop"), dp = !0);
      }
      var O = p.memoizedState, k = !Fe(O, x);
      k && (p.memoizedState = x, l4());
      var V = p.queue;
      if (t4(zS.bind(null, c, V, t), [t]), V.getSnapshot !== r || k || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      Oo !== null && Oo.memoizedState.tag & Eo) {
        c.flags |= Mr, Jm(Eo | vi, WS.bind(null, c, V, x, r), void 0, null);
        var U = Ug();
        if (U === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Oc(U, g2) || $S(c, r, x);
      }
      return x;
    }
    function $S(t, r, u) {
      t.flags |= Ya;
      var c = {
        getSnapshot: r,
        value: u
      }, p = mr.updateQueue;
      if (p === null)
        p = YS(), mr.updateQueue = p, p.stores = [c];
      else {
        var x = p.stores;
        x === null ? p.stores = [c] : x.push(c);
      }
    }
    function WS(t, r, u, c) {
      r.value = u, r.getSnapshot = c, qS(r) && GS(t);
    }
    function zS(t, r, u) {
      var c = function() {
        qS(r) && GS(t);
      };
      return u(c);
    }
    function qS(t) {
      var r = t.getSnapshot, u = t.value;
      try {
        var c = r();
        return !Fe(u, c);
      } catch {
        return !0;
      }
    }
    function GS(t) {
      var r = Nl(t, Wt);
      r !== null && ko(r, t, Wt, mn);
    }
    function hg(t) {
      var r = T0();
      typeof t == "function" && (t = t()), r.memoizedState = r.baseState = t;
      var u = {
        pending: null,
        interleaved: null,
        lanes: be,
        dispatch: null,
        lastRenderedReducer: Z7,
        lastRenderedState: t
      };
      r.queue = u;
      var c = u.dispatch = ND.bind(null, mr, u);
      return [r.memoizedState, c];
    }
    function B7(t) {
      return N7(Z7);
    }
    function U7(t) {
      return V7(Z7);
    }
    function Jm(t, r, u, c) {
      var p = {
        tag: t,
        create: r,
        destroy: u,
        deps: c,
        // Circular
        next: null
      }, x = mr.updateQueue;
      if (x === null)
        x = YS(), mr.updateQueue = x, x.lastEffect = p.next = p;
      else {
        var _ = x.lastEffect;
        if (_ === null)
          x.lastEffect = p.next = p;
        else {
          var O = _.next;
          _.next = p, p.next = O, x.lastEffect = p;
        }
      }
      return p;
    }
    function Y7(t) {
      var r = T0();
      {
        var u = {
          current: t
        };
        return r.memoizedState = u, u;
      }
    }
    function vg(t) {
      var r = bs();
      return r.memoizedState;
    }
    function e4(t, r, u, c) {
      var p = T0(), x = c === void 0 ? null : c;
      mr.flags |= t, p.memoizedState = Jm(Eo | r, u, void 0, x);
    }
    function pg(t, r, u, c) {
      var p = bs(), x = c === void 0 ? null : c, _ = void 0;
      if (To !== null) {
        var O = To.memoizedState;
        if (_ = O.destroy, x !== null) {
          var k = O.deps;
          if (H7(x, k)) {
            p.memoizedState = Jm(r, u, _, x);
            return;
          }
        }
      }
      mr.flags |= t, p.memoizedState = Jm(Eo | r, u, _, x);
    }
    function mg(t, r) {
      return (mr.mode & Vn) !== kt ? e4(nl | Mr | zf, vi, t, r) : e4(Mr | zf, vi, t, r);
    }
    function t4(t, r) {
      return pg(Mr, vi, t, r);
    }
    function $7(t, r) {
      return e4(un, M0, t, r);
    }
    function gg(t, r) {
      return pg(un, M0, t, r);
    }
    function W7(t, r) {
      var u = un;
      return u |= uu, (mr.mode & Vn) !== kt && (u |= wo), e4(u, Mo, t, r);
    }
    function wg(t, r) {
      return pg(un, Mo, t, r);
    }
    function KS(t, r) {
      if (typeof r == "function") {
        var u = r, c = t();
        return u(c), function() {
          u(null);
        };
      } else if (r != null) {
        var p = r;
        p.hasOwnProperty("current") || m("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(p).join(", ") + "}");
        var x = t();
        return p.current = x, function() {
          p.current = null;
        };
      }
    }
    function z7(t, r, u) {
      typeof r != "function" && m("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", r !== null ? typeof r : "null");
      var c = u != null ? u.concat([t]) : null, p = un;
      return p |= uu, (mr.mode & Vn) !== kt && (p |= wo), e4(p, Mo, KS.bind(null, r, t), c);
    }
    function yg(t, r, u) {
      typeof r != "function" && m("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", r !== null ? typeof r : "null");
      var c = u != null ? u.concat([t]) : null;
      return pg(un, Mo, KS.bind(null, r, t), c);
    }
    function ID(t, r) {
    }
    var xg = ID;
    function q7(t, r) {
      var u = T0(), c = r === void 0 ? null : r;
      return u.memoizedState = [t, c], t;
    }
    function Sg(t, r) {
      var u = bs(), c = r === void 0 ? null : r, p = u.memoizedState;
      if (p !== null && c !== null) {
        var x = p[1];
        if (H7(c, x))
          return p[0];
      }
      return u.memoizedState = [t, c], t;
    }
    function G7(t, r) {
      var u = T0(), c = r === void 0 ? null : r, p = t();
      return u.memoizedState = [p, c], p;
    }
    function Cg(t, r) {
      var u = bs(), c = r === void 0 ? null : r, p = u.memoizedState;
      if (p !== null && c !== null) {
        var x = p[1];
        if (H7(c, x))
          return p[0];
      }
      var _ = t();
      return u.memoizedState = [_, c], _;
    }
    function K7(t) {
      var r = T0();
      return r.memoizedState = t, t;
    }
    function QS(t) {
      var r = bs(), u = To, c = u.memoizedState;
      return JS(r, c, t);
    }
    function XS(t) {
      var r = bs();
      if (To === null)
        return r.memoizedState = t, t;
      var u = To.memoizedState;
      return JS(r, u, t);
    }
    function JS(t, r, u) {
      var c = !id(g2);
      if (c) {
        if (!Fe(u, r)) {
          var p = l0();
          mr.lanes = Bt(mr.lanes, p), y4(p), t.baseState = !0;
        }
        return r;
      } else
        return t.baseState && (t.baseState = !1, l4()), t.memoizedState = u, u;
    }
    function HD(t, r, u) {
      var c = fr();
      fa(Bh(c, uo)), t(!0);
      var p = Km.transition;
      Km.transition = {};
      var x = Km.transition;
      Km.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        t(!1), r();
      } finally {
        if (fa(c), Km.transition = p, p === null && x._updatedFibers) {
          var _ = x._updatedFibers.size;
          _ > 10 && g("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), x._updatedFibers.clear();
        }
      }
    }
    function Q7() {
      var t = hg(!1), r = t[0], u = t[1], c = HD.bind(null, u), p = T0();
      return p.memoizedState = c, [r, c];
    }
    function eC() {
      var t = B7(), r = t[0], u = bs(), c = u.memoizedState;
      return [r, c];
    }
    function tC() {
      var t = U7(), r = t[0], u = bs(), c = u.memoizedState;
      return [r, c];
    }
    var nC = !1;
    function ZD() {
      return nC;
    }
    function X7() {
      var t = T0(), r = Ug(), u = r.identifierPrefix, c;
      if (hi()) {
        var p = eD();
        c = ":" + u + "R" + p;
        var x = Xm++;
        x > 0 && (c += "H" + x.toString(32)), c += ":";
      } else {
        var _ = jD++;
        c = ":" + u + "r" + _.toString(32) + ":";
      }
      return t.memoizedState = c, c;
    }
    function bg() {
      var t = bs(), r = t.memoizedState;
      return r;
    }
    function PD(t, r, u) {
      typeof arguments[3] == "function" && m("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var c = Wd(t), p = {
        lane: c,
        action: u,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (rC(t))
        aC(r, p);
      else {
        var x = jS(t, r, p, c);
        if (x !== null) {
          var _ = pl();
          ko(x, t, c, _), oC(x, r, c);
        }
      }
      iC(t, c);
    }
    function ND(t, r, u) {
      typeof arguments[3] == "function" && m("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var c = Wd(t), p = {
        lane: c,
        action: u,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (rC(t))
        aC(r, p);
      else {
        var x = t.alternate;
        if (t.lanes === be && (x === null || x.lanes === be)) {
          var _ = r.lastRenderedReducer;
          if (_ !== null) {
            var O;
            O = pt.current, pt.current = m1;
            try {
              var k = r.lastRenderedState, V = _(k, u);
              if (p.hasEagerState = !0, p.eagerState = V, Fe(V, k)) {
                bD(t, r, p);
                return;
              }
            } catch {
            } finally {
              pt.current = O;
            }
          }
        }
        var U = jS(t, r, p, c);
        if (U !== null) {
          var ae = pl();
          ko(U, t, c, ae), oC(U, r, c);
        }
      }
      iC(t, c);
    }
    function rC(t) {
      var r = t.alternate;
      return t === mr || r !== null && r === mr;
    }
    function aC(t, r) {
      Qm = fg = !0;
      var u = t.pending;
      u === null ? r.next = r : (r.next = u.next, u.next = r), t.pending = r;
    }
    function oC(t, r, u) {
      if (Ac(u)) {
        var c = r.lanes;
        c = ld(c, t.pendingLanes);
        var p = Bt(c, u);
        r.lanes = p, f0(t, p);
      }
    }
    function iC(t, r, u) {
      Sc(t, r);
    }
    var _g = {
      readContext: fo,
      useCallback: Ui,
      useContext: Ui,
      useEffect: Ui,
      useImperativeHandle: Ui,
      useInsertionEffect: Ui,
      useLayoutEffect: Ui,
      useMemo: Ui,
      useReducer: Ui,
      useRef: Ui,
      useState: Ui,
      useDebugValue: Ui,
      useDeferredValue: Ui,
      useTransition: Ui,
      useMutableSource: Ui,
      useSyncExternalStore: Ui,
      useId: Ui,
      unstable_isNewReconciler: ue
    }, lC = null, uC = null, sC = null, cC = null, O0 = null, m1 = null, Rg = null;
    {
      var J7 = function() {
        m("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, en = function() {
        m("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      lC = {
        readContext: function(t) {
          return fo(t);
        },
        useCallback: function(t, r) {
          return Le = "useCallback", ir(), hp(r), q7(t, r);
        },
        useContext: function(t) {
          return Le = "useContext", ir(), fo(t);
        },
        useEffect: function(t, r) {
          return Le = "useEffect", ir(), hp(r), mg(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return Le = "useImperativeHandle", ir(), hp(u), z7(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return Le = "useInsertionEffect", ir(), hp(r), $7(t, r);
        },
        useLayoutEffect: function(t, r) {
          return Le = "useLayoutEffect", ir(), hp(r), W7(t, r);
        },
        useMemo: function(t, r) {
          Le = "useMemo", ir(), hp(r);
          var u = pt.current;
          pt.current = O0;
          try {
            return G7(t, r);
          } finally {
            pt.current = u;
          }
        },
        useReducer: function(t, r, u) {
          Le = "useReducer", ir();
          var c = pt.current;
          pt.current = O0;
          try {
            return P7(t, r, u);
          } finally {
            pt.current = c;
          }
        },
        useRef: function(t) {
          return Le = "useRef", ir(), Y7(t);
        },
        useState: function(t) {
          Le = "useState", ir();
          var r = pt.current;
          pt.current = O0;
          try {
            return hg(t);
          } finally {
            pt.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return Le = "useDebugValue", ir(), void 0;
        },
        useDeferredValue: function(t) {
          return Le = "useDeferredValue", ir(), K7(t);
        },
        useTransition: function() {
          return Le = "useTransition", ir(), Q7();
        },
        useMutableSource: function(t, r, u) {
          return Le = "useMutableSource", ir(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return Le = "useSyncExternalStore", ir(), F7(t, r, u);
        },
        useId: function() {
          return Le = "useId", ir(), X7();
        },
        unstable_isNewReconciler: ue
      }, uC = {
        readContext: function(t) {
          return fo(t);
        },
        useCallback: function(t, r) {
          return Le = "useCallback", tt(), q7(t, r);
        },
        useContext: function(t) {
          return Le = "useContext", tt(), fo(t);
        },
        useEffect: function(t, r) {
          return Le = "useEffect", tt(), mg(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return Le = "useImperativeHandle", tt(), z7(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return Le = "useInsertionEffect", tt(), $7(t, r);
        },
        useLayoutEffect: function(t, r) {
          return Le = "useLayoutEffect", tt(), W7(t, r);
        },
        useMemo: function(t, r) {
          Le = "useMemo", tt();
          var u = pt.current;
          pt.current = O0;
          try {
            return G7(t, r);
          } finally {
            pt.current = u;
          }
        },
        useReducer: function(t, r, u) {
          Le = "useReducer", tt();
          var c = pt.current;
          pt.current = O0;
          try {
            return P7(t, r, u);
          } finally {
            pt.current = c;
          }
        },
        useRef: function(t) {
          return Le = "useRef", tt(), Y7(t);
        },
        useState: function(t) {
          Le = "useState", tt();
          var r = pt.current;
          pt.current = O0;
          try {
            return hg(t);
          } finally {
            pt.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return Le = "useDebugValue", tt(), void 0;
        },
        useDeferredValue: function(t) {
          return Le = "useDeferredValue", tt(), K7(t);
        },
        useTransition: function() {
          return Le = "useTransition", tt(), Q7();
        },
        useMutableSource: function(t, r, u) {
          return Le = "useMutableSource", tt(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return Le = "useSyncExternalStore", tt(), F7(t, r, u);
        },
        useId: function() {
          return Le = "useId", tt(), X7();
        },
        unstable_isNewReconciler: ue
      }, sC = {
        readContext: function(t) {
          return fo(t);
        },
        useCallback: function(t, r) {
          return Le = "useCallback", tt(), Sg(t, r);
        },
        useContext: function(t) {
          return Le = "useContext", tt(), fo(t);
        },
        useEffect: function(t, r) {
          return Le = "useEffect", tt(), t4(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return Le = "useImperativeHandle", tt(), yg(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return Le = "useInsertionEffect", tt(), gg(t, r);
        },
        useLayoutEffect: function(t, r) {
          return Le = "useLayoutEffect", tt(), wg(t, r);
        },
        useMemo: function(t, r) {
          Le = "useMemo", tt();
          var u = pt.current;
          pt.current = m1;
          try {
            return Cg(t, r);
          } finally {
            pt.current = u;
          }
        },
        useReducer: function(t, r, u) {
          Le = "useReducer", tt();
          var c = pt.current;
          pt.current = m1;
          try {
            return N7(t);
          } finally {
            pt.current = c;
          }
        },
        useRef: function(t) {
          return Le = "useRef", tt(), vg();
        },
        useState: function(t) {
          Le = "useState", tt();
          var r = pt.current;
          pt.current = m1;
          try {
            return B7();
          } finally {
            pt.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return Le = "useDebugValue", tt(), xg();
        },
        useDeferredValue: function(t) {
          return Le = "useDeferredValue", tt(), QS(t);
        },
        useTransition: function() {
          return Le = "useTransition", tt(), eC();
        },
        useMutableSource: function(t, r, u) {
          return Le = "useMutableSource", tt(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return Le = "useSyncExternalStore", tt(), dg(t, r);
        },
        useId: function() {
          return Le = "useId", tt(), bg();
        },
        unstable_isNewReconciler: ue
      }, cC = {
        readContext: function(t) {
          return fo(t);
        },
        useCallback: function(t, r) {
          return Le = "useCallback", tt(), Sg(t, r);
        },
        useContext: function(t) {
          return Le = "useContext", tt(), fo(t);
        },
        useEffect: function(t, r) {
          return Le = "useEffect", tt(), t4(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return Le = "useImperativeHandle", tt(), yg(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return Le = "useInsertionEffect", tt(), gg(t, r);
        },
        useLayoutEffect: function(t, r) {
          return Le = "useLayoutEffect", tt(), wg(t, r);
        },
        useMemo: function(t, r) {
          Le = "useMemo", tt();
          var u = pt.current;
          pt.current = Rg;
          try {
            return Cg(t, r);
          } finally {
            pt.current = u;
          }
        },
        useReducer: function(t, r, u) {
          Le = "useReducer", tt();
          var c = pt.current;
          pt.current = Rg;
          try {
            return V7(t);
          } finally {
            pt.current = c;
          }
        },
        useRef: function(t) {
          return Le = "useRef", tt(), vg();
        },
        useState: function(t) {
          Le = "useState", tt();
          var r = pt.current;
          pt.current = Rg;
          try {
            return U7();
          } finally {
            pt.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return Le = "useDebugValue", tt(), xg();
        },
        useDeferredValue: function(t) {
          return Le = "useDeferredValue", tt(), XS(t);
        },
        useTransition: function() {
          return Le = "useTransition", tt(), tC();
        },
        useMutableSource: function(t, r, u) {
          return Le = "useMutableSource", tt(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return Le = "useSyncExternalStore", tt(), dg(t, r);
        },
        useId: function() {
          return Le = "useId", tt(), bg();
        },
        unstable_isNewReconciler: ue
      }, O0 = {
        readContext: function(t) {
          return J7(), fo(t);
        },
        useCallback: function(t, r) {
          return Le = "useCallback", en(), ir(), q7(t, r);
        },
        useContext: function(t) {
          return Le = "useContext", en(), ir(), fo(t);
        },
        useEffect: function(t, r) {
          return Le = "useEffect", en(), ir(), mg(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return Le = "useImperativeHandle", en(), ir(), z7(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return Le = "useInsertionEffect", en(), ir(), $7(t, r);
        },
        useLayoutEffect: function(t, r) {
          return Le = "useLayoutEffect", en(), ir(), W7(t, r);
        },
        useMemo: function(t, r) {
          Le = "useMemo", en(), ir();
          var u = pt.current;
          pt.current = O0;
          try {
            return G7(t, r);
          } finally {
            pt.current = u;
          }
        },
        useReducer: function(t, r, u) {
          Le = "useReducer", en(), ir();
          var c = pt.current;
          pt.current = O0;
          try {
            return P7(t, r, u);
          } finally {
            pt.current = c;
          }
        },
        useRef: function(t) {
          return Le = "useRef", en(), ir(), Y7(t);
        },
        useState: function(t) {
          Le = "useState", en(), ir();
          var r = pt.current;
          pt.current = O0;
          try {
            return hg(t);
          } finally {
            pt.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return Le = "useDebugValue", en(), ir(), void 0;
        },
        useDeferredValue: function(t) {
          return Le = "useDeferredValue", en(), ir(), K7(t);
        },
        useTransition: function() {
          return Le = "useTransition", en(), ir(), Q7();
        },
        useMutableSource: function(t, r, u) {
          return Le = "useMutableSource", en(), ir(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return Le = "useSyncExternalStore", en(), ir(), F7(t, r, u);
        },
        useId: function() {
          return Le = "useId", en(), ir(), X7();
        },
        unstable_isNewReconciler: ue
      }, m1 = {
        readContext: function(t) {
          return J7(), fo(t);
        },
        useCallback: function(t, r) {
          return Le = "useCallback", en(), tt(), Sg(t, r);
        },
        useContext: function(t) {
          return Le = "useContext", en(), tt(), fo(t);
        },
        useEffect: function(t, r) {
          return Le = "useEffect", en(), tt(), t4(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return Le = "useImperativeHandle", en(), tt(), yg(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return Le = "useInsertionEffect", en(), tt(), gg(t, r);
        },
        useLayoutEffect: function(t, r) {
          return Le = "useLayoutEffect", en(), tt(), wg(t, r);
        },
        useMemo: function(t, r) {
          Le = "useMemo", en(), tt();
          var u = pt.current;
          pt.current = m1;
          try {
            return Cg(t, r);
          } finally {
            pt.current = u;
          }
        },
        useReducer: function(t, r, u) {
          Le = "useReducer", en(), tt();
          var c = pt.current;
          pt.current = m1;
          try {
            return N7(t);
          } finally {
            pt.current = c;
          }
        },
        useRef: function(t) {
          return Le = "useRef", en(), tt(), vg();
        },
        useState: function(t) {
          Le = "useState", en(), tt();
          var r = pt.current;
          pt.current = m1;
          try {
            return B7();
          } finally {
            pt.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return Le = "useDebugValue", en(), tt(), xg();
        },
        useDeferredValue: function(t) {
          return Le = "useDeferredValue", en(), tt(), QS(t);
        },
        useTransition: function() {
          return Le = "useTransition", en(), tt(), eC();
        },
        useMutableSource: function(t, r, u) {
          return Le = "useMutableSource", en(), tt(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return Le = "useSyncExternalStore", en(), tt(), dg(t, r);
        },
        useId: function() {
          return Le = "useId", en(), tt(), bg();
        },
        unstable_isNewReconciler: ue
      }, Rg = {
        readContext: function(t) {
          return J7(), fo(t);
        },
        useCallback: function(t, r) {
          return Le = "useCallback", en(), tt(), Sg(t, r);
        },
        useContext: function(t) {
          return Le = "useContext", en(), tt(), fo(t);
        },
        useEffect: function(t, r) {
          return Le = "useEffect", en(), tt(), t4(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return Le = "useImperativeHandle", en(), tt(), yg(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return Le = "useInsertionEffect", en(), tt(), gg(t, r);
        },
        useLayoutEffect: function(t, r) {
          return Le = "useLayoutEffect", en(), tt(), wg(t, r);
        },
        useMemo: function(t, r) {
          Le = "useMemo", en(), tt();
          var u = pt.current;
          pt.current = m1;
          try {
            return Cg(t, r);
          } finally {
            pt.current = u;
          }
        },
        useReducer: function(t, r, u) {
          Le = "useReducer", en(), tt();
          var c = pt.current;
          pt.current = m1;
          try {
            return V7(t);
          } finally {
            pt.current = c;
          }
        },
        useRef: function(t) {
          return Le = "useRef", en(), tt(), vg();
        },
        useState: function(t) {
          Le = "useState", en(), tt();
          var r = pt.current;
          pt.current = m1;
          try {
            return U7();
          } finally {
            pt.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return Le = "useDebugValue", en(), tt(), xg();
        },
        useDeferredValue: function(t) {
          return Le = "useDeferredValue", en(), tt(), XS(t);
        },
        useTransition: function() {
          return Le = "useTransition", en(), tt(), tC();
        },
        useMutableSource: function(t, r, u) {
          return Le = "useMutableSource", en(), tt(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return Le = "useSyncExternalStore", en(), tt(), dg(t, r);
        },
        useId: function() {
          return Le = "useId", en(), tt(), bg();
        },
        unstable_isNewReconciler: ue
      };
    }
    var Bd = n.unstable_now, fC = 0, Eg = -1, n4 = -1, Mg = -1, ey = !1, Tg = !1;
    function dC() {
      return ey;
    }
    function VD() {
      Tg = !0;
    }
    function FD() {
      ey = !1, Tg = !1;
    }
    function BD() {
      ey = Tg, Tg = !1;
    }
    function hC() {
      return fC;
    }
    function vC() {
      fC = Bd();
    }
    function ty(t) {
      n4 = Bd(), t.actualStartTime < 0 && (t.actualStartTime = Bd());
    }
    function pC(t) {
      n4 = -1;
    }
    function Og(t, r) {
      if (n4 >= 0) {
        var u = Bd() - n4;
        t.actualDuration += u, r && (t.selfBaseDuration = u), n4 = -1;
      }
    }
    function D0(t) {
      if (Eg >= 0) {
        var r = Bd() - Eg;
        Eg = -1;
        for (var u = t.return; u !== null; ) {
          switch (u.tag) {
            case T:
              var c = u.stateNode;
              c.effectDuration += r;
              return;
            case z:
              var p = u.stateNode;
              p.effectDuration += r;
              return;
          }
          u = u.return;
        }
      }
    }
    function ny(t) {
      if (Mg >= 0) {
        var r = Bd() - Mg;
        Mg = -1;
        for (var u = t.return; u !== null; ) {
          switch (u.tag) {
            case T:
              var c = u.stateNode;
              c !== null && (c.passiveEffectDuration += r);
              return;
            case z:
              var p = u.stateNode;
              p !== null && (p.passiveEffectDuration += r);
              return;
          }
          u = u.return;
        }
      }
    }
    function A0() {
      Eg = Bd();
    }
    function ry() {
      Mg = Bd();
    }
    function ay(t) {
      for (var r = t.child; r; )
        t.actualDuration += r.actualDuration, r = r.sibling;
    }
    function g1(t, r) {
      if (t && t.defaultProps) {
        var u = mt({}, r), c = t.defaultProps;
        for (var p in c)
          u[p] === void 0 && (u[p] = c[p]);
        return u;
      }
      return r;
    }
    var oy = {}, iy, ly, uy, sy, cy, mC, Dg, fy, dy, hy, r4;
    {
      iy = /* @__PURE__ */ new Set(), ly = /* @__PURE__ */ new Set(), uy = /* @__PURE__ */ new Set(), sy = /* @__PURE__ */ new Set(), fy = /* @__PURE__ */ new Set(), cy = /* @__PURE__ */ new Set(), dy = /* @__PURE__ */ new Set(), hy = /* @__PURE__ */ new Set(), r4 = /* @__PURE__ */ new Set();
      var gC = /* @__PURE__ */ new Set();
      Dg = function(t, r) {
        if (!(t === null || typeof t == "function")) {
          var u = r + "_" + t;
          gC.has(u) || (gC.add(u), m("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", r, t));
        }
      }, mC = function(t, r) {
        if (r === void 0) {
          var u = _n(t) || "Component";
          cy.has(u) || (cy.add(u), m("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", u));
        }
      }, Object.defineProperty(oy, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(oy);
    }
    function vy(t, r, u, c) {
      var p = t.memoizedState, x = u(c, p);
      {
        if (t.mode & nr) {
          Sr(!0);
          try {
            x = u(c, p);
          } finally {
            Sr(!1);
          }
        }
        mC(r, x);
      }
      var _ = x == null ? p : mt({}, p, x);
      if (t.memoizedState = _, t.lanes === be) {
        var O = t.updateQueue;
        O.baseState = _;
      }
    }
    var py = {
      isMounted: hv,
      enqueueSetState: function(t, r, u) {
        var c = iu(t), p = pl(), x = Wd(c), _ = Jc(p, x);
        _.payload = r, u != null && (Dg(u, "setState"), _.callback = u);
        var O = Pd(c, _, x);
        O !== null && (ko(O, c, x, p), og(O, c, x)), Sc(c, x);
      },
      enqueueReplaceState: function(t, r, u) {
        var c = iu(t), p = pl(), x = Wd(c), _ = Jc(p, x);
        _.tag = LS, _.payload = r, u != null && (Dg(u, "replaceState"), _.callback = u);
        var O = Pd(c, _, x);
        O !== null && (ko(O, c, x, p), og(O, c, x)), Sc(c, x);
      },
      enqueueForceUpdate: function(t, r) {
        var u = iu(t), c = pl(), p = Wd(u), x = Jc(c, p);
        x.tag = ng, r != null && (Dg(r, "forceUpdate"), x.callback = r);
        var _ = Pd(u, x, p);
        _ !== null && (ko(_, u, p, c), og(_, u, p)), Qs(u, p);
      }
    };
    function wC(t, r, u, c, p, x, _) {
      var O = t.stateNode;
      if (typeof O.shouldComponentUpdate == "function") {
        var k = O.shouldComponentUpdate(c, x, _);
        {
          if (t.mode & nr) {
            Sr(!0);
            try {
              k = O.shouldComponentUpdate(c, x, _);
            } finally {
              Sr(!1);
            }
          }
          k === void 0 && m("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", _n(r) || "Component");
        }
        return k;
      }
      return r.prototype && r.prototype.isPureReactComponent ? !xt(u, c) || !xt(p, x) : !0;
    }
    function UD(t, r, u) {
      var c = t.stateNode;
      {
        var p = _n(r) || "Component", x = c.render;
        x || (r.prototype && typeof r.prototype.render == "function" ? m("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", p) : m("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", p)), c.getInitialState && !c.getInitialState.isReactClassApproved && !c.state && m("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", p), c.getDefaultProps && !c.getDefaultProps.isReactClassApproved && m("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", p), c.propTypes && m("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", p), c.contextType && m("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", p), r.childContextTypes && !r4.has(r) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (t.mode & nr) === kt && (r4.add(r), m(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, p)), r.contextTypes && !r4.has(r) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (t.mode & nr) === kt && (r4.add(r), m(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, p)), c.contextTypes && m("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", p), r.contextType && r.contextTypes && !dy.has(r) && (dy.add(r), m("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", p)), typeof c.componentShouldUpdate == "function" && m("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", p), r.prototype && r.prototype.isPureReactComponent && typeof c.shouldComponentUpdate < "u" && m("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", _n(r) || "A pure component"), typeof c.componentDidUnmount == "function" && m("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", p), typeof c.componentDidReceiveProps == "function" && m("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", p), typeof c.componentWillRecieveProps == "function" && m("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", p), typeof c.UNSAFE_componentWillRecieveProps == "function" && m("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", p);
        var _ = c.props !== u;
        c.props !== void 0 && _ && m("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", p, p), c.defaultProps && m("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", p, p), typeof c.getSnapshotBeforeUpdate == "function" && typeof c.componentDidUpdate != "function" && !uy.has(r) && (uy.add(r), m("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", _n(r))), typeof c.getDerivedStateFromProps == "function" && m("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", p), typeof c.getDerivedStateFromError == "function" && m("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", p), typeof r.getSnapshotBeforeUpdate == "function" && m("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", p);
        var O = c.state;
        O && (typeof O != "object" || er(O)) && m("%s.state: must be set to an object or null", p), typeof c.getChildContext == "function" && typeof r.childContextTypes != "object" && m("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", p);
      }
    }
    function yC(t, r) {
      r.updater = py, t.stateNode = r, W1(r, t), r._reactInternalInstance = oy;
    }
    function xC(t, r, u) {
      var c = !1, p = Bi, x = Bi, _ = r.contextType;
      if ("contextType" in r) {
        var O = (
          // Allow null for conditional declaration
          _ === null || _ !== void 0 && _.$$typeof === Iu && _._context === void 0
        );
        if (!O && !hy.has(r)) {
          hy.add(r);
          var k = "";
          _ === void 0 ? k = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof _ != "object" ? k = " However, it is set to a " + typeof _ + "." : _.$$typeof === Lu ? k = " Did you accidentally pass the Context.Provider instead?" : _._context !== void 0 ? k = " Did you accidentally pass the Context.Consumer instead?" : k = " However, it is set to an object with keys {" + Object.keys(_).join(", ") + "}.", m("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", _n(r) || "Component", k);
        }
      }
      if (typeof _ == "object" && _ !== null)
        x = fo(_);
      else {
        p = tp(t, r, !0);
        var V = r.contextTypes;
        c = V != null, x = c ? np(t, p) : Bi;
      }
      var U = new r(u, x);
      if (t.mode & nr) {
        Sr(!0);
        try {
          U = new r(u, x);
        } finally {
          Sr(!1);
        }
      }
      var ae = t.memoizedState = U.state !== null && U.state !== void 0 ? U.state : null;
      yC(t, U);
      {
        if (typeof r.getDerivedStateFromProps == "function" && ae === null) {
          var re = _n(r) || "Component";
          ly.has(re) || (ly.add(re), m("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", re, U.state === null ? "null" : "undefined", re));
        }
        if (typeof r.getDerivedStateFromProps == "function" || typeof U.getSnapshotBeforeUpdate == "function") {
          var xe = null, Ce = null, Me = null;
          if (typeof U.componentWillMount == "function" && U.componentWillMount.__suppressDeprecationWarning !== !0 ? xe = "componentWillMount" : typeof U.UNSAFE_componentWillMount == "function" && (xe = "UNSAFE_componentWillMount"), typeof U.componentWillReceiveProps == "function" && U.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Ce = "componentWillReceiveProps" : typeof U.UNSAFE_componentWillReceiveProps == "function" && (Ce = "UNSAFE_componentWillReceiveProps"), typeof U.componentWillUpdate == "function" && U.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Me = "componentWillUpdate" : typeof U.UNSAFE_componentWillUpdate == "function" && (Me = "UNSAFE_componentWillUpdate"), xe !== null || Ce !== null || Me !== null) {
            var it = _n(r) || "Component", Ft = typeof r.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            sy.has(it) || (sy.add(it), m(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, it, Ft, xe !== null ? `
  ` + xe : "", Ce !== null ? `
  ` + Ce : "", Me !== null ? `
  ` + Me : ""));
          }
        }
      }
      return c && sS(t, p, x), U;
    }
    function YD(t, r) {
      var u = r.state;
      typeof r.componentWillMount == "function" && r.componentWillMount(), typeof r.UNSAFE_componentWillMount == "function" && r.UNSAFE_componentWillMount(), u !== r.state && (m("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", tn(t) || "Component"), py.enqueueReplaceState(r, r.state, null));
    }
    function SC(t, r, u, c) {
      var p = r.state;
      if (typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps(u, c), typeof r.UNSAFE_componentWillReceiveProps == "function" && r.UNSAFE_componentWillReceiveProps(u, c), r.state !== p) {
        {
          var x = tn(t) || "Component";
          iy.has(x) || (iy.add(x), m("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", x));
        }
        py.enqueueReplaceState(r, r.state, null);
      }
    }
    function my(t, r, u, c) {
      UD(t, r, u);
      var p = t.stateNode;
      p.props = u, p.state = t.memoizedState, p.refs = {}, R7(t);
      var x = r.contextType;
      if (typeof x == "object" && x !== null)
        p.context = fo(x);
      else {
        var _ = tp(t, r, !0);
        p.context = np(t, _);
      }
      {
        if (p.state === u) {
          var O = _n(r) || "Component";
          fy.has(O) || (fy.add(O), m("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", O));
        }
        t.mode & nr && v1.recordLegacyContextWarning(t, p), v1.recordUnsafeLifecycleWarnings(t, p);
      }
      p.state = t.memoizedState;
      var k = r.getDerivedStateFromProps;
      if (typeof k == "function" && (vy(t, r, k, u), p.state = t.memoizedState), typeof r.getDerivedStateFromProps != "function" && typeof p.getSnapshotBeforeUpdate != "function" && (typeof p.UNSAFE_componentWillMount == "function" || typeof p.componentWillMount == "function") && (YD(t, p), ig(t, u, p, c), p.state = t.memoizedState), typeof p.componentDidMount == "function") {
        var V = un;
        V |= uu, (t.mode & Vn) !== kt && (V |= wo), t.flags |= V;
      }
    }
    function $D(t, r, u, c) {
      var p = t.stateNode, x = t.memoizedProps;
      p.props = x;
      var _ = p.context, O = r.contextType, k = Bi;
      if (typeof O == "object" && O !== null)
        k = fo(O);
      else {
        var V = tp(t, r, !0);
        k = np(t, V);
      }
      var U = r.getDerivedStateFromProps, ae = typeof U == "function" || typeof p.getSnapshotBeforeUpdate == "function";
      !ae && (typeof p.UNSAFE_componentWillReceiveProps == "function" || typeof p.componentWillReceiveProps == "function") && (x !== u || _ !== k) && SC(t, p, u, k), HS();
      var re = t.memoizedState, xe = p.state = re;
      if (ig(t, u, p, c), xe = t.memoizedState, x === u && re === xe && !F3() && !lg()) {
        if (typeof p.componentDidMount == "function") {
          var Ce = un;
          Ce |= uu, (t.mode & Vn) !== kt && (Ce |= wo), t.flags |= Ce;
        }
        return !1;
      }
      typeof U == "function" && (vy(t, r, U, u), xe = t.memoizedState);
      var Me = lg() || wC(t, r, x, u, re, xe, k);
      if (Me) {
        if (!ae && (typeof p.UNSAFE_componentWillMount == "function" || typeof p.componentWillMount == "function") && (typeof p.componentWillMount == "function" && p.componentWillMount(), typeof p.UNSAFE_componentWillMount == "function" && p.UNSAFE_componentWillMount()), typeof p.componentDidMount == "function") {
          var it = un;
          it |= uu, (t.mode & Vn) !== kt && (it |= wo), t.flags |= it;
        }
      } else {
        if (typeof p.componentDidMount == "function") {
          var Ft = un;
          Ft |= uu, (t.mode & Vn) !== kt && (Ft |= wo), t.flags |= Ft;
        }
        t.memoizedProps = u, t.memoizedState = xe;
      }
      return p.props = u, p.state = xe, p.context = k, Me;
    }
    function WD(t, r, u, c, p) {
      var x = r.stateNode;
      IS(t, r);
      var _ = r.memoizedProps, O = r.type === r.elementType ? _ : g1(r.type, _);
      x.props = O;
      var k = r.pendingProps, V = x.context, U = u.contextType, ae = Bi;
      if (typeof U == "object" && U !== null)
        ae = fo(U);
      else {
        var re = tp(r, u, !0);
        ae = np(r, re);
      }
      var xe = u.getDerivedStateFromProps, Ce = typeof xe == "function" || typeof x.getSnapshotBeforeUpdate == "function";
      !Ce && (typeof x.UNSAFE_componentWillReceiveProps == "function" || typeof x.componentWillReceiveProps == "function") && (_ !== k || V !== ae) && SC(r, x, c, ae), HS();
      var Me = r.memoizedState, it = x.state = Me;
      if (ig(r, c, x, p), it = r.memoizedState, _ === k && Me === it && !F3() && !lg() && !Ae)
        return typeof x.componentDidUpdate == "function" && (_ !== t.memoizedProps || Me !== t.memoizedState) && (r.flags |= un), typeof x.getSnapshotBeforeUpdate == "function" && (_ !== t.memoizedProps || Me !== t.memoizedState) && (r.flags |= Br), !1;
      typeof xe == "function" && (vy(r, u, xe, c), it = r.memoizedState);
      var Ft = lg() || wC(r, u, O, c, Me, it, ae) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      Ae;
      return Ft ? (!Ce && (typeof x.UNSAFE_componentWillUpdate == "function" || typeof x.componentWillUpdate == "function") && (typeof x.componentWillUpdate == "function" && x.componentWillUpdate(c, it, ae), typeof x.UNSAFE_componentWillUpdate == "function" && x.UNSAFE_componentWillUpdate(c, it, ae)), typeof x.componentDidUpdate == "function" && (r.flags |= un), typeof x.getSnapshotBeforeUpdate == "function" && (r.flags |= Br)) : (typeof x.componentDidUpdate == "function" && (_ !== t.memoizedProps || Me !== t.memoizedState) && (r.flags |= un), typeof x.getSnapshotBeforeUpdate == "function" && (_ !== t.memoizedProps || Me !== t.memoizedState) && (r.flags |= Br), r.memoizedProps = c, r.memoizedState = it), x.props = c, x.state = it, x.context = ae, Ft;
    }
    function w2(t, r) {
      return {
        value: t,
        source: r,
        stack: bh(r),
        digest: null
      };
    }
    function gy(t, r, u) {
      return {
        value: t,
        source: null,
        stack: u ?? null,
        digest: r ?? null
      };
    }
    function zD(t, r) {
      return !0;
    }
    function wy(t, r) {
      try {
        var u = zD();
        if (u === !1)
          return;
        var c = r.value;
        {
          var p = r.source, x = r.stack, _ = x !== null ? x : "";
          if (c != null && c._suppressLogging) {
            if (t.tag === R)
              return;
            console.error(c);
          }
          var O = p ? tn(p) : null, k = O ? "The above error occurred in the <" + O + "> component:" : "The above error occurred in one of your React components:", V;
          if (t.tag === T)
            V = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
          else {
            var U = tn(t) || "Anonymous";
            V = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + U + ".");
          }
          var ae = k + `
` + _ + `

` + ("" + V);
          console.error(ae);
        }
      } catch (re) {
        setTimeout(function() {
          throw re;
        });
      }
    }
    var qD = typeof WeakMap == "function" ? WeakMap : Map;
    function CC(t, r, u) {
      var c = Jc(mn, u);
      c.tag = b7, c.payload = {
        element: null
      };
      var p = r.value;
      return c.callback = function() {
        Nj(p), wy(t, r);
      }, c;
    }
    function yy(t, r, u) {
      var c = Jc(mn, u);
      c.tag = b7;
      var p = t.type.getDerivedStateFromError;
      if (typeof p == "function") {
        var x = r.value;
        c.payload = function() {
          return p(x);
        }, c.callback = function() {
          kb(t), wy(t, r);
        };
      }
      var _ = t.stateNode;
      return _ !== null && typeof _.componentDidCatch == "function" && (c.callback = function() {
        kb(t), wy(t, r), typeof p != "function" && Zj(this);
        var k = r.value, V = r.stack;
        this.componentDidCatch(k, {
          componentStack: V !== null ? V : ""
        }), typeof p != "function" && (Bo(t.lanes, Wt) || m("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", tn(t) || "Unknown"));
      }), c;
    }
    function bC(t, r, u) {
      var c = t.pingCache, p;
      if (c === null ? (c = t.pingCache = new qD(), p = /* @__PURE__ */ new Set(), c.set(r, p)) : (p = c.get(r), p === void 0 && (p = /* @__PURE__ */ new Set(), c.set(r, p))), !p.has(u)) {
        p.add(u);
        var x = Vj.bind(null, t, r, u);
        Hr && x4(t, u), r.then(x, x);
      }
    }
    function GD(t, r, u, c) {
      var p = t.updateQueue;
      if (p === null) {
        var x = /* @__PURE__ */ new Set();
        x.add(u), t.updateQueue = x;
      } else
        p.add(u);
    }
    function KD(t, r) {
      var u = t.tag;
      if ((t.mode & an) === kt && (u === b || u === W || u === G)) {
        var c = t.alternate;
        c ? (t.updateQueue = c.updateQueue, t.memoizedState = c.memoizedState, t.lanes = c.lanes) : (t.updateQueue = null, t.memoizedState = null);
      }
    }
    function _C(t) {
      var r = t;
      do {
        if (r.tag === Y && DD(r))
          return r;
        r = r.return;
      } while (r !== null);
      return null;
    }
    function RC(t, r, u, c, p) {
      if ((t.mode & an) === kt) {
        if (t === r)
          t.flags |= pr;
        else {
          if (t.flags |= Dt, u.flags |= Wf, u.flags &= ~($f | z1), u.tag === R) {
            var x = u.alternate;
            if (x === null)
              u.tag = J;
            else {
              var _ = Jc(mn, Wt);
              _.tag = ng, Pd(u, _, Wt);
            }
          }
          u.lanes = Bt(u.lanes, Wt);
        }
        return t;
      }
      return t.flags |= pr, t.lanes = p, t;
    }
    function QD(t, r, u, c, p) {
      if (u.flags |= z1, Hr && x4(t, p), c !== null && typeof c == "object" && typeof c.then == "function") {
        var x = c;
        KD(u), hi() && u.mode & an && mS();
        var _ = _C(r);
        if (_ !== null) {
          _.flags &= ~Rn, RC(_, r, u, t, p), _.mode & an && bC(t, x, p), GD(_, t, x);
          return;
        } else {
          if (!o0(p)) {
            bC(t, x, p), Qy();
            return;
          }
          var O = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          c = O;
        }
      } else if (hi() && u.mode & an) {
        mS();
        var k = _C(r);
        if (k !== null) {
          (k.flags & pr) === Et && (k.flags |= Rn), RC(k, r, u, t, p), f7(w2(c, u));
          return;
        }
      }
      c = w2(c, u), Oj(c);
      var V = r;
      do {
        switch (V.tag) {
          case T: {
            var U = c;
            V.flags |= pr;
            var ae = us(p);
            V.lanes = Bt(V.lanes, ae);
            var re = CC(V, U, ae);
            E7(V, re);
            return;
          }
          case R:
            var xe = c, Ce = V.type, Me = V.stateNode;
            if ((V.flags & Dt) === Et && (typeof Ce.getDerivedStateFromError == "function" || Me !== null && typeof Me.componentDidCatch == "function" && !_b(Me))) {
              V.flags |= pr;
              var it = us(p);
              V.lanes = Bt(V.lanes, it);
              var Ft = yy(V, xe, it);
              E7(V, Ft);
              return;
            }
            break;
        }
        V = V.return;
      } while (V !== null);
    }
    function XD() {
      return null;
    }
    var a4 = a.ReactCurrentOwner, w1 = !1, xy, o4, Sy, Cy, by, y2, _y, Ag, i4;
    xy = {}, o4 = {}, Sy = {}, Cy = {}, by = {}, y2 = !1, _y = {}, Ag = {}, i4 = {};
    function hl(t, r, u, c) {
      t === null ? r.child = TS(r, null, u, c) : r.child = ip(r, t.child, u, c);
    }
    function JD(t, r, u, c) {
      r.child = ip(r, t.child, null, c), r.child = ip(r, null, u, c);
    }
    function EC(t, r, u, c, p) {
      if (r.type !== r.elementType) {
        var x = u.propTypes;
        x && Xt(
          x,
          c,
          // Resolved props
          "prop",
          _n(u)
        );
      }
      var _ = u.render, O = r.ref, k, V;
      up(r, p), li(r);
      {
        if (a4.current = r, Ho(!0), k = vp(t, r, _, c, O, p), V = pp(), r.mode & nr) {
          Sr(!0);
          try {
            k = vp(t, r, _, c, O, p), V = pp();
          } finally {
            Sr(!1);
          }
        }
        Ho(!1);
      }
      return za(), t !== null && !w1 ? (BS(t, r, p), ef(t, r, p)) : (hi() && V && o7(r), r.flags |= Qr, hl(t, r, k, p), r.child);
    }
    function MC(t, r, u, c, p) {
      if (t === null) {
        var x = u.type;
        if (rk(x) && u.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        u.defaultProps === void 0) {
          var _ = x;
          return _ = bp(x), r.tag = G, r.type = _, My(r, x), TC(t, r, _, c, p);
        }
        {
          var O = x.propTypes;
          if (O && Xt(
            O,
            c,
            // Resolved props
            "prop",
            _n(x)
          ), u.defaultProps !== void 0) {
            var k = _n(x) || "Unknown";
            i4[k] || (m("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", k), i4[k] = !0);
          }
        }
        var V = u9(u.type, null, c, r, r.mode, p);
        return V.ref = r.ref, V.return = r, r.child = V, V;
      }
      {
        var U = u.type, ae = U.propTypes;
        ae && Xt(
          ae,
          c,
          // Resolved props
          "prop",
          _n(U)
        );
      }
      var re = t.child, xe = ky(t, p);
      if (!xe) {
        var Ce = re.memoizedProps, Me = u.compare;
        if (Me = Me !== null ? Me : xt, Me(Ce, c) && t.ref === r.ref)
          return ef(t, r, p);
      }
      r.flags |= Qr;
      var it = _2(re, c);
      return it.ref = r.ref, it.return = r, r.child = it, it;
    }
    function TC(t, r, u, c, p) {
      if (r.type !== r.elementType) {
        var x = r.elementType;
        if (x.$$typeof === vt) {
          var _ = x, O = _._payload, k = _._init;
          try {
            x = k(O);
          } catch {
            x = null;
          }
          var V = x && x.propTypes;
          V && Xt(
            V,
            c,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            _n(x)
          );
        }
      }
      if (t !== null) {
        var U = t.memoizedProps;
        if (xt(U, c) && t.ref === r.ref && // Prevent bailout if the implementation changed due to hot reload.
        r.type === t.type)
          if (w1 = !1, r.pendingProps = c = U, ky(t, p))
            (t.flags & Wf) !== Et && (w1 = !0);
          else return r.lanes = t.lanes, ef(t, r, p);
      }
      return Ry(t, r, u, c, p);
    }
    function OC(t, r, u) {
      var c = r.pendingProps, p = c.children, x = t !== null ? t.memoizedState : null;
      if (c.mode === "hidden" || Pe)
        if ((r.mode & an) === kt) {
          var _ = {
            baseLanes: be,
            cachePool: null,
            transitions: null
          };
          r.memoizedState = _, Yg(r, u);
        } else if (Bo(u, yo)) {
          var ae = {
            baseLanes: be,
            cachePool: null,
            transitions: null
          };
          r.memoizedState = ae;
          var re = x !== null ? x.baseLanes : u;
          Yg(r, re);
        } else {
          var O = null, k;
          if (x !== null) {
            var V = x.baseLanes;
            k = Bt(V, u);
          } else
            k = u;
          r.lanes = r.childLanes = yo;
          var U = {
            baseLanes: k,
            cachePool: O,
            transitions: null
          };
          return r.memoizedState = U, r.updateQueue = null, Yg(r, k), null;
        }
      else {
        var xe;
        x !== null ? (xe = Bt(x.baseLanes, u), r.memoizedState = null) : xe = u, Yg(r, xe);
      }
      return hl(t, r, p, u), r.child;
    }
    function eA(t, r, u) {
      var c = r.pendingProps;
      return hl(t, r, c, u), r.child;
    }
    function tA(t, r, u) {
      var c = r.pendingProps.children;
      return hl(t, r, c, u), r.child;
    }
    function nA(t, r, u) {
      {
        r.flags |= un;
        {
          var c = r.stateNode;
          c.effectDuration = 0, c.passiveEffectDuration = 0;
        }
      }
      var p = r.pendingProps, x = p.children;
      return hl(t, r, x, u), r.child;
    }
    function DC(t, r) {
      var u = r.ref;
      (t === null && u !== null || t !== null && t.ref !== u) && (r.flags |= go, r.flags |= q1);
    }
    function Ry(t, r, u, c, p) {
      if (r.type !== r.elementType) {
        var x = u.propTypes;
        x && Xt(
          x,
          c,
          // Resolved props
          "prop",
          _n(u)
        );
      }
      var _;
      {
        var O = tp(r, u, !0);
        _ = np(r, O);
      }
      var k, V;
      up(r, p), li(r);
      {
        if (a4.current = r, Ho(!0), k = vp(t, r, u, c, _, p), V = pp(), r.mode & nr) {
          Sr(!0);
          try {
            k = vp(t, r, u, c, _, p), V = pp();
          } finally {
            Sr(!1);
          }
        }
        Ho(!1);
      }
      return za(), t !== null && !w1 ? (BS(t, r, p), ef(t, r, p)) : (hi() && V && o7(r), r.flags |= Qr, hl(t, r, k, p), r.child);
    }
    function AC(t, r, u, c, p) {
      {
        switch (wk(r)) {
          case !1: {
            var x = r.stateNode, _ = r.type, O = new _(r.memoizedProps, x.context), k = O.state;
            x.updater.enqueueSetState(x, k, null);
            break;
          }
          case !0: {
            r.flags |= Dt, r.flags |= pr;
            var V = new Error("Simulated error coming from DevTools"), U = us(p);
            r.lanes = Bt(r.lanes, U);
            var ae = yy(r, w2(V, r), U);
            E7(r, ae);
            break;
          }
        }
        if (r.type !== r.elementType) {
          var re = u.propTypes;
          re && Xt(
            re,
            c,
            // Resolved props
            "prop",
            _n(u)
          );
        }
      }
      var xe;
      E0(u) ? (xe = !0, U3(r)) : xe = !1, up(r, p);
      var Ce = r.stateNode, Me;
      Ce === null ? (kg(t, r), xC(r, u, c), my(r, u, c, p), Me = !0) : t === null ? Me = $D(r, u, c, p) : Me = WD(t, r, u, c, p);
      var it = Ey(t, r, u, Me, xe, p);
      {
        var Ft = r.stateNode;
        Me && Ft.props !== c && (y2 || m("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", tn(r) || "a component"), y2 = !0);
      }
      return it;
    }
    function Ey(t, r, u, c, p, x) {
      DC(t, r);
      var _ = (r.flags & Dt) !== Et;
      if (!c && !_)
        return p && dS(r, u, !1), ef(t, r, x);
      var O = r.stateNode;
      a4.current = r;
      var k;
      if (_ && typeof u.getDerivedStateFromError != "function")
        k = null, pC();
      else {
        li(r);
        {
          if (Ho(!0), k = O.render(), r.mode & nr) {
            Sr(!0);
            try {
              O.render();
            } finally {
              Sr(!1);
            }
          }
          Ho(!1);
        }
        za();
      }
      return r.flags |= Qr, t !== null && _ ? JD(t, r, k, x) : hl(t, r, k, x), r.memoizedState = O.state, p && dS(r, u, !0), r.child;
    }
    function jC(t) {
      var r = t.stateNode;
      r.pendingContext ? cS(t, r.pendingContext, r.pendingContext !== r.context) : r.context && cS(t, r.context, !1), M7(t, r.containerInfo);
    }
    function rA(t, r, u) {
      if (jC(r), t === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var c = r.pendingProps, p = r.memoizedState, x = p.element;
      IS(t, r), ig(r, c, null, u);
      var _ = r.memoizedState, O = _.element;
      if (p.isDehydrated) {
        var k = {
          element: O,
          isDehydrated: !1,
          cache: _.cache,
          pendingSuspenseBoundaries: _.pendingSuspenseBoundaries,
          transitions: _.transitions
        }, V = r.updateQueue;
        if (V.baseState = k, r.memoizedState = k, r.flags & Rn) {
          var U = w2(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), r);
          return kC(t, r, O, u, U);
        } else if (O !== x) {
          var ae = w2(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), r);
          return kC(t, r, O, u, ae);
        } else {
          iD(r);
          var re = TS(r, null, O, u);
          r.child = re;
          for (var xe = re; xe; )
            xe.flags = xe.flags & ~Tt | Ir, xe = xe.sibling;
        }
      } else {
        if (op(), O === x)
          return ef(t, r, u);
        hl(t, r, O, u);
      }
      return r.child;
    }
    function kC(t, r, u, c, p) {
      return op(), f7(p), r.flags |= Rn, hl(t, r, u, c), r.child;
    }
    function aA(t, r, u) {
      NS(r), t === null && c7(r);
      var c = r.type, p = r.pendingProps, x = t !== null ? t.memoizedProps : null, _ = p.children, O = Dm(c, p);
      return O ? _ = null : x !== null && Dm(c, x) && (r.flags |= Ol), DC(t, r), hl(t, r, _, u), r.child;
    }
    function oA(t, r) {
      return t === null && c7(r), null;
    }
    function iA(t, r, u, c) {
      kg(t, r);
      var p = r.pendingProps, x = u, _ = x._payload, O = x._init, k = O(_);
      r.type = k;
      var V = r.tag = ak(k), U = g1(k, p), ae;
      switch (V) {
        case b:
          return My(r, k), r.type = k = bp(k), ae = Ry(null, r, k, U, c), ae;
        case R:
          return r.type = k = n9(k), ae = AC(null, r, k, U, c), ae;
        case W:
          return r.type = k = r9(k), ae = EC(null, r, k, U, c), ae;
        case ie: {
          if (r.type !== r.elementType) {
            var re = k.propTypes;
            re && Xt(
              re,
              U,
              // Resolved for outer only
              "prop",
              _n(k)
            );
          }
          return ae = MC(
            null,
            r,
            k,
            g1(k.type, U),
            // The inner type can have defaults too
            c
          ), ae;
        }
      }
      var xe = "";
      throw k !== null && typeof k == "object" && k.$$typeof === vt && (xe = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + k + ". " + ("Lazy element type must resolve to a class or function." + xe));
    }
    function lA(t, r, u, c, p) {
      kg(t, r), r.tag = R;
      var x;
      return E0(u) ? (x = !0, U3(r)) : x = !1, up(r, p), xC(r, u, c), my(r, u, c, p), Ey(null, r, u, !0, x, p);
    }
    function uA(t, r, u, c) {
      kg(t, r);
      var p = r.pendingProps, x;
      {
        var _ = tp(r, u, !1);
        x = np(r, _);
      }
      up(r, c);
      var O, k;
      li(r);
      {
        if (u.prototype && typeof u.prototype.render == "function") {
          var V = _n(u) || "Unknown";
          xy[V] || (m("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", V, V), xy[V] = !0);
        }
        r.mode & nr && v1.recordLegacyContextWarning(r, null), Ho(!0), a4.current = r, O = vp(null, r, u, p, x, c), k = pp(), Ho(!1);
      }
      if (za(), r.flags |= Qr, typeof O == "object" && O !== null && typeof O.render == "function" && O.$$typeof === void 0) {
        var U = _n(u) || "Unknown";
        o4[U] || (m("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", U, U, U), o4[U] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof O == "object" && O !== null && typeof O.render == "function" && O.$$typeof === void 0
      ) {
        {
          var ae = _n(u) || "Unknown";
          o4[ae] || (m("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", ae, ae, ae), o4[ae] = !0);
        }
        r.tag = R, r.memoizedState = null, r.updateQueue = null;
        var re = !1;
        return E0(u) ? (re = !0, U3(r)) : re = !1, r.memoizedState = O.state !== null && O.state !== void 0 ? O.state : null, R7(r), yC(r, O), my(r, u, p, c), Ey(null, r, u, !0, re, c);
      } else {
        if (r.tag = b, r.mode & nr) {
          Sr(!0);
          try {
            O = vp(null, r, u, p, x, c), k = pp();
          } finally {
            Sr(!1);
          }
        }
        return hi() && k && o7(r), hl(null, r, O, c), My(r, u), r.child;
      }
    }
    function My(t, r) {
      {
        if (r && r.childContextTypes && m("%s(...): childContextTypes cannot be defined on a function component.", r.displayName || r.name || "Component"), t.ref !== null) {
          var u = "", c = Kl();
          c && (u += `

Check the render method of \`` + c + "`.");
          var p = c || "", x = t._debugSource;
          x && (p = x.fileName + ":" + x.lineNumber), by[p] || (by[p] = !0, m("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", u));
        }
        if (r.defaultProps !== void 0) {
          var _ = _n(r) || "Unknown";
          i4[_] || (m("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", _), i4[_] = !0);
        }
        if (typeof r.getDerivedStateFromProps == "function") {
          var O = _n(r) || "Unknown";
          Cy[O] || (m("%s: Function components do not support getDerivedStateFromProps.", O), Cy[O] = !0);
        }
        if (typeof r.contextType == "object" && r.contextType !== null) {
          var k = _n(r) || "Unknown";
          Sy[k] || (m("%s: Function components do not support contextType.", k), Sy[k] = !0);
        }
      }
    }
    var Ty = {
      dehydrated: null,
      treeContext: null,
      retryLane: An
    };
    function Oy(t) {
      return {
        baseLanes: t,
        cachePool: XD(),
        transitions: null
      };
    }
    function sA(t, r) {
      var u = null;
      return {
        baseLanes: Bt(t.baseLanes, r),
        cachePool: u,
        transitions: t.transitions
      };
    }
    function cA(t, r, u, c) {
      if (r !== null) {
        var p = r.memoizedState;
        if (p === null)
          return !1;
      }
      return D7(t, Gm);
    }
    function fA(t, r) {
      return u0(t.childLanes, r);
    }
    function LC(t, r, u) {
      var c = r.pendingProps;
      yk(r) && (r.flags |= Dt);
      var p = p1.current, x = !1, _ = (r.flags & Dt) !== Et;
      if (_ || cA(p, t) ? (x = !0, r.flags &= ~Dt) : (t === null || t.memoizedState !== null) && (p = OD(p, FS)), p = cp(p), Vd(r, p), t === null) {
        c7(r);
        var O = r.memoizedState;
        if (O !== null) {
          var k = O.dehydrated;
          if (k !== null)
            return mA(r, k);
        }
        var V = c.children, U = c.fallback;
        if (x) {
          var ae = dA(r, V, U, u), re = r.child;
          return re.memoizedState = Oy(u), r.memoizedState = Ty, ae;
        } else
          return Dy(r, V);
      } else {
        var xe = t.memoizedState;
        if (xe !== null) {
          var Ce = xe.dehydrated;
          if (Ce !== null)
            return gA(t, r, _, c, Ce, xe, u);
        }
        if (x) {
          var Me = c.fallback, it = c.children, Ft = vA(t, r, it, Me, u), At = r.child, kn = t.child.memoizedState;
          return At.memoizedState = kn === null ? Oy(u) : sA(kn, u), At.childLanes = fA(t, u), r.memoizedState = Ty, Ft;
        } else {
          var xn = c.children, he = hA(t, r, xn, u);
          return r.memoizedState = null, he;
        }
      }
    }
    function Dy(t, r, u) {
      var c = t.mode, p = {
        mode: "visible",
        children: r
      }, x = Ay(p, c);
      return x.return = t, t.child = x, x;
    }
    function dA(t, r, u, c) {
      var p = t.mode, x = t.child, _ = {
        mode: "hidden",
        children: r
      }, O, k;
      return (p & an) === kt && x !== null ? (O = x, O.childLanes = be, O.pendingProps = _, t.mode & Nn && (O.actualDuration = 0, O.actualStartTime = -1, O.selfBaseDuration = 0, O.treeBaseDuration = 0), k = qd(u, p, c, null)) : (O = Ay(_, p), k = qd(u, p, c, null)), O.return = t, k.return = t, O.sibling = k, t.child = O, k;
    }
    function Ay(t, r, u) {
      return Lb(t, r, be, null);
    }
    function IC(t, r) {
      return _2(t, r);
    }
    function hA(t, r, u, c) {
      var p = t.child, x = p.sibling, _ = IC(p, {
        mode: "visible",
        children: u
      });
      if ((r.mode & an) === kt && (_.lanes = c), _.return = r, _.sibling = null, x !== null) {
        var O = r.deletions;
        O === null ? (r.deletions = [x], r.flags |= lu) : O.push(x);
      }
      return r.child = _, _;
    }
    function vA(t, r, u, c, p) {
      var x = r.mode, _ = t.child, O = _.sibling, k = {
        mode: "hidden",
        children: u
      }, V;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (x & an) === kt && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        r.child !== _
      ) {
        var U = r.child;
        V = U, V.childLanes = be, V.pendingProps = k, r.mode & Nn && (V.actualDuration = 0, V.actualStartTime = -1, V.selfBaseDuration = _.selfBaseDuration, V.treeBaseDuration = _.treeBaseDuration), r.deletions = null;
      } else
        V = IC(_, k), V.subtreeFlags = _.subtreeFlags & sa;
      var ae;
      return O !== null ? ae = _2(O, c) : (ae = qd(c, x, p, null), ae.flags |= Tt), ae.return = r, V.return = r, V.sibling = ae, r.child = V, ae;
    }
    function jg(t, r, u, c) {
      c !== null && f7(c), ip(r, t.child, null, u);
      var p = r.pendingProps, x = p.children, _ = Dy(r, x);
      return _.flags |= Tt, r.memoizedState = null, _;
    }
    function pA(t, r, u, c, p) {
      var x = r.mode, _ = {
        mode: "visible",
        children: u
      }, O = Ay(_, x), k = qd(c, x, p, null);
      return k.flags |= Tt, O.return = r, k.return = r, O.sibling = k, r.child = O, (r.mode & an) !== kt && ip(r, t.child, null, p), k;
    }
    function mA(t, r, u) {
      return (t.mode & an) === kt ? (m("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), t.lanes = Wt) : Im(r) ? t.lanes = io : t.lanes = yo, null;
    }
    function gA(t, r, u, c, p, x, _) {
      if (u)
        if (r.flags & Rn) {
          r.flags &= ~Rn;
          var he = gy(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return jg(t, r, _, he);
        } else {
          if (r.memoizedState !== null)
            return r.child = t.child, r.flags |= Dt, null;
          var Te = c.children, ve = c.fallback, ze = pA(t, r, Te, ve, _), gt = r.child;
          return gt.memoizedState = Oy(_), r.memoizedState = Ty, ze;
        }
      else {
        if (aD(), (r.mode & an) === kt)
          return jg(
            t,
            r,
            _,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (Im(p)) {
          var O, k, V;
          {
            var U = Hm(p);
            O = U.digest, k = U.message, V = U.stack;
          }
          var ae;
          k ? ae = new Error(k) : ae = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var re = gy(ae, O, V);
          return jg(t, r, _, re);
        }
        var xe = Bo(_, t.childLanes);
        if (w1 || xe) {
          var Ce = Ug();
          if (Ce !== null) {
            var Me = d0(Ce, _);
            if (Me !== An && Me !== x.retryLane) {
              x.retryLane = Me;
              var it = mn;
              Nl(t, Me), ko(Ce, t, Me, it);
            }
          }
          Qy();
          var Ft = gy(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return jg(t, r, _, Ft);
        } else if (Jv(p)) {
          r.flags |= Dt, r.child = t.child;
          var At = Fj.bind(null, t);
          return L6(p, At), null;
        } else {
          lD(r, p, x.treeContext);
          var kn = c.children, xn = Dy(r, kn);
          return xn.flags |= Ir, xn;
        }
      }
    }
    function HC(t, r, u) {
      t.lanes = Bt(t.lanes, r);
      var c = t.alternate;
      c !== null && (c.lanes = Bt(c.lanes, r)), S7(t.return, r, u);
    }
    function wA(t, r, u) {
      for (var c = r; c !== null; ) {
        if (c.tag === Y) {
          var p = c.memoizedState;
          p !== null && HC(c, u, t);
        } else if (c.tag === oe)
          HC(c, u, t);
        else if (c.child !== null) {
          c.child.return = c, c = c.child;
          continue;
        }
        if (c === t)
          return;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === t)
            return;
          c = c.return;
        }
        c.sibling.return = c.return, c = c.sibling;
      }
    }
    function yA(t) {
      for (var r = t, u = null; r !== null; ) {
        var c = r.alternate;
        c !== null && cg(c) === null && (u = r), r = r.sibling;
      }
      return u;
    }
    function xA(t) {
      if (t !== void 0 && t !== "forwards" && t !== "backwards" && t !== "together" && !_y[t])
        if (_y[t] = !0, typeof t == "string")
          switch (t.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              m('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', t, t.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              m('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', t, t.toLowerCase());
              break;
            }
            default:
              m('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', t);
              break;
          }
        else
          m('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', t);
    }
    function SA(t, r) {
      t !== void 0 && !Ag[t] && (t !== "collapsed" && t !== "hidden" ? (Ag[t] = !0, m('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', t)) : r !== "forwards" && r !== "backwards" && (Ag[t] = !0, m('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', t)));
    }
    function ZC(t, r) {
      {
        var u = er(t), c = !u && typeof Io(t) == "function";
        if (u || c) {
          var p = u ? "array" : "iterable";
          return m("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", p, r, p), !1;
        }
      }
      return !0;
    }
    function CA(t, r) {
      if ((r === "forwards" || r === "backwards") && t !== void 0 && t !== null && t !== !1)
        if (er(t)) {
          for (var u = 0; u < t.length; u++)
            if (!ZC(t[u], u))
              return;
        } else {
          var c = Io(t);
          if (typeof c == "function") {
            var p = c.call(t);
            if (p)
              for (var x = p.next(), _ = 0; !x.done; x = p.next()) {
                if (!ZC(x.value, _))
                  return;
                _++;
              }
          } else
            m('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', r);
        }
    }
    function jy(t, r, u, c, p) {
      var x = t.memoizedState;
      x === null ? t.memoizedState = {
        isBackwards: r,
        rendering: null,
        renderingStartTime: 0,
        last: c,
        tail: u,
        tailMode: p
      } : (x.isBackwards = r, x.rendering = null, x.renderingStartTime = 0, x.last = c, x.tail = u, x.tailMode = p);
    }
    function PC(t, r, u) {
      var c = r.pendingProps, p = c.revealOrder, x = c.tail, _ = c.children;
      xA(p), SA(x, p), CA(_, p), hl(t, r, _, u);
      var O = p1.current, k = D7(O, Gm);
      if (k)
        O = A7(O, Gm), r.flags |= Dt;
      else {
        var V = t !== null && (t.flags & Dt) !== Et;
        V && wA(r, r.child, u), O = cp(O);
      }
      if (Vd(r, O), (r.mode & an) === kt)
        r.memoizedState = null;
      else
        switch (p) {
          case "forwards": {
            var U = yA(r.child), ae;
            U === null ? (ae = r.child, r.child = null) : (ae = U.sibling, U.sibling = null), jy(
              r,
              !1,
              // isBackwards
              ae,
              U,
              x
            );
            break;
          }
          case "backwards": {
            var re = null, xe = r.child;
            for (r.child = null; xe !== null; ) {
              var Ce = xe.alternate;
              if (Ce !== null && cg(Ce) === null) {
                r.child = xe;
                break;
              }
              var Me = xe.sibling;
              xe.sibling = re, re = xe, xe = Me;
            }
            jy(
              r,
              !0,
              // isBackwards
              re,
              null,
              // last
              x
            );
            break;
          }
          case "together": {
            jy(
              r,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            r.memoizedState = null;
        }
      return r.child;
    }
    function bA(t, r, u) {
      M7(r, r.stateNode.containerInfo);
      var c = r.pendingProps;
      return t === null ? r.child = ip(r, null, c, u) : hl(t, r, c, u), r.child;
    }
    var NC = !1;
    function _A(t, r, u) {
      var c = r.type, p = c._context, x = r.pendingProps, _ = r.memoizedProps, O = x.value;
      {
        "value" in x || NC || (NC = !0, m("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var k = r.type.propTypes;
        k && Xt(k, x, "prop", "Context.Provider");
      }
      if (AS(r, p, O), _ !== null) {
        var V = _.value;
        if (Fe(V, O)) {
          if (_.children === x.children && !F3())
            return ef(t, r, u);
        } else
          xD(r, p, u);
      }
      var U = x.children;
      return hl(t, r, U, u), r.child;
    }
    var VC = !1;
    function RA(t, r, u) {
      var c = r.type;
      c._context === void 0 ? c !== c.Consumer && (VC || (VC = !0, m("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : c = c._context;
      var p = r.pendingProps, x = p.children;
      typeof x != "function" && m("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), up(r, u);
      var _ = fo(c);
      li(r);
      var O;
      return a4.current = r, Ho(!0), O = x(_), Ho(!1), za(), r.flags |= Qr, hl(t, r, O, u), r.child;
    }
    function l4() {
      w1 = !0;
    }
    function kg(t, r) {
      (r.mode & an) === kt && t !== null && (t.alternate = null, r.alternate = null, r.flags |= Tt);
    }
    function ef(t, r, u) {
      return t !== null && (r.dependencies = t.dependencies), pC(), y4(r.lanes), Bo(u, r.childLanes) ? (wD(t, r), r.child) : null;
    }
    function EA(t, r, u) {
      {
        var c = r.return;
        if (c === null)
          throw new Error("Cannot swap the root fiber.");
        if (t.alternate = null, r.alternate = null, u.index = r.index, u.sibling = r.sibling, u.return = r.return, u.ref = r.ref, r === c.child)
          c.child = u;
        else {
          var p = c.child;
          if (p === null)
            throw new Error("Expected parent to have a child.");
          for (; p.sibling !== r; )
            if (p = p.sibling, p === null)
              throw new Error("Expected to find the previous sibling.");
          p.sibling = u;
        }
        var x = c.deletions;
        return x === null ? (c.deletions = [t], c.flags |= lu) : x.push(t), u.flags |= Tt, u;
      }
    }
    function ky(t, r) {
      var u = t.lanes;
      return !!Bo(u, r);
    }
    function MA(t, r, u) {
      switch (r.tag) {
        case T:
          jC(r), op();
          break;
        case j:
          NS(r);
          break;
        case R: {
          var c = r.type;
          E0(c) && U3(r);
          break;
        }
        case A:
          M7(r, r.stateNode.containerInfo);
          break;
        case $: {
          var p = r.memoizedProps.value, x = r.type._context;
          AS(r, x, p);
          break;
        }
        case z:
          {
            var _ = Bo(u, r.childLanes);
            _ && (r.flags |= un);
            {
              var O = r.stateNode;
              O.effectDuration = 0, O.passiveEffectDuration = 0;
            }
          }
          break;
        case Y: {
          var k = r.memoizedState;
          if (k !== null) {
            if (k.dehydrated !== null)
              return Vd(r, cp(p1.current)), r.flags |= Dt, null;
            var V = r.child, U = V.childLanes;
            if (Bo(u, U))
              return LC(t, r, u);
            Vd(r, cp(p1.current));
            var ae = ef(t, r, u);
            return ae !== null ? ae.sibling : null;
          } else
            Vd(r, cp(p1.current));
          break;
        }
        case oe: {
          var re = (t.flags & Dt) !== Et, xe = Bo(u, r.childLanes);
          if (re) {
            if (xe)
              return PC(t, r, u);
            r.flags |= Dt;
          }
          var Ce = r.memoizedState;
          if (Ce !== null && (Ce.rendering = null, Ce.tail = null, Ce.lastEffect = null), Vd(r, p1.current), xe)
            break;
          return null;
        }
        case ce:
        case Se:
          return r.lanes = be, OC(t, r, u);
      }
      return ef(t, r, u);
    }
    function FC(t, r, u) {
      if (r._debugNeedsRemount && t !== null)
        return EA(t, r, u9(r.type, r.key, r.pendingProps, r._debugOwner || null, r.mode, r.lanes));
      if (t !== null) {
        var c = t.memoizedProps, p = r.pendingProps;
        if (c !== p || F3() || // Force a re-render if the implementation changed due to hot reload:
        r.type !== t.type)
          w1 = !0;
        else {
          var x = ky(t, u);
          if (!x && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (r.flags & Dt) === Et)
            return w1 = !1, MA(t, r, u);
          (t.flags & Wf) !== Et ? w1 = !0 : w1 = !1;
        }
      } else if (w1 = !1, hi() && XO(r)) {
        var _ = r.index, O = JO();
        pS(r, O, _);
      }
      switch (r.lanes = be, r.tag) {
        case D:
          return uA(t, r, r.type, u);
        case pe: {
          var k = r.elementType;
          return iA(t, r, k, u);
        }
        case b: {
          var V = r.type, U = r.pendingProps, ae = r.elementType === V ? U : g1(V, U);
          return Ry(t, r, V, ae, u);
        }
        case R: {
          var re = r.type, xe = r.pendingProps, Ce = r.elementType === re ? xe : g1(re, xe);
          return AC(t, r, re, Ce, u);
        }
        case T:
          return rA(t, r, u);
        case j:
          return aA(t, r, u);
        case I:
          return oA(t, r);
        case Y:
          return LC(t, r, u);
        case A:
          return bA(t, r, u);
        case W: {
          var Me = r.type, it = r.pendingProps, Ft = r.elementType === Me ? it : g1(Me, it);
          return EC(t, r, Me, Ft, u);
        }
        case Z:
          return eA(t, r, u);
        case N:
          return tA(t, r, u);
        case z:
          return nA(t, r, u);
        case $:
          return _A(t, r, u);
        case B:
          return RA(t, r, u);
        case ie: {
          var At = r.type, kn = r.pendingProps, xn = g1(At, kn);
          if (r.type !== r.elementType) {
            var he = At.propTypes;
            he && Xt(
              he,
              xn,
              // Resolved for outer only
              "prop",
              _n(At)
            );
          }
          return xn = g1(At.type, xn), MC(t, r, At, xn, u);
        }
        case G:
          return TC(t, r, r.type, r.pendingProps, u);
        case J: {
          var Te = r.type, ve = r.pendingProps, ze = r.elementType === Te ? ve : g1(Te, ve);
          return lA(t, r, Te, ze, u);
        }
        case oe:
          return PC(t, r, u);
        case ge:
          break;
        case ce:
          return OC(t, r, u);
      }
      throw new Error("Unknown unit of work tag (" + r.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function mp(t) {
      t.flags |= un;
    }
    function BC(t) {
      t.flags |= go, t.flags |= q1;
    }
    var UC, Ly, YC, $C;
    UC = function(t, r, u, c) {
      for (var p = r.child; p !== null; ) {
        if (p.tag === j || p.tag === I)
          h6(t, p.stateNode);
        else if (p.tag !== A) {
          if (p.child !== null) {
            p.child.return = p, p = p.child;
            continue;
          }
        }
        if (p === r)
          return;
        for (; p.sibling === null; ) {
          if (p.return === null || p.return === r)
            return;
          p = p.return;
        }
        p.sibling.return = p.return, p = p.sibling;
      }
    }, Ly = function(t, r) {
    }, YC = function(t, r, u, c, p) {
      var x = t.memoizedProps;
      if (x !== c) {
        var _ = r.stateNode, O = T7(), k = p6(_, u, x, c, p, O);
        r.updateQueue = k, k && mp(r);
      }
    }, $C = function(t, r, u, c) {
      u !== c && mp(r);
    };
    function u4(t, r) {
      if (!hi())
        switch (t.tailMode) {
          case "hidden": {
            for (var u = t.tail, c = null; u !== null; )
              u.alternate !== null && (c = u), u = u.sibling;
            c === null ? t.tail = null : c.sibling = null;
            break;
          }
          case "collapsed": {
            for (var p = t.tail, x = null; p !== null; )
              p.alternate !== null && (x = p), p = p.sibling;
            x === null ? !r && t.tail !== null ? t.tail.sibling = null : t.tail = null : x.sibling = null;
            break;
          }
        }
    }
    function pi(t) {
      var r = t.alternate !== null && t.alternate.child === t.child, u = be, c = Et;
      if (r) {
        if ((t.mode & Nn) !== kt) {
          for (var k = t.selfBaseDuration, V = t.child; V !== null; )
            u = Bt(u, Bt(V.lanes, V.childLanes)), c |= V.subtreeFlags & sa, c |= V.flags & sa, k += V.treeBaseDuration, V = V.sibling;
          t.treeBaseDuration = k;
        } else
          for (var U = t.child; U !== null; )
            u = Bt(u, Bt(U.lanes, U.childLanes)), c |= U.subtreeFlags & sa, c |= U.flags & sa, U.return = t, U = U.sibling;
        t.subtreeFlags |= c;
      } else {
        if ((t.mode & Nn) !== kt) {
          for (var p = t.actualDuration, x = t.selfBaseDuration, _ = t.child; _ !== null; )
            u = Bt(u, Bt(_.lanes, _.childLanes)), c |= _.subtreeFlags, c |= _.flags, p += _.actualDuration, x += _.treeBaseDuration, _ = _.sibling;
          t.actualDuration = p, t.treeBaseDuration = x;
        } else
          for (var O = t.child; O !== null; )
            u = Bt(u, Bt(O.lanes, O.childLanes)), c |= O.subtreeFlags, c |= O.flags, O.return = t, O = O.sibling;
        t.subtreeFlags |= c;
      }
      return t.childLanes = u, r;
    }
    function TA(t, r, u) {
      if (dD() && (r.mode & an) !== kt && (r.flags & Dt) === Et)
        return CS(r), op(), r.flags |= Rn | z1 | pr, !1;
      var c = q3(r);
      if (u !== null && u.dehydrated !== null)
        if (t === null) {
          if (!c)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (cD(r), pi(r), (r.mode & Nn) !== kt) {
            var p = u !== null;
            if (p) {
              var x = r.child;
              x !== null && (r.treeBaseDuration -= x.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (op(), (r.flags & Dt) === Et && (r.memoizedState = null), r.flags |= un, pi(r), (r.mode & Nn) !== kt) {
            var _ = u !== null;
            if (_) {
              var O = r.child;
              O !== null && (r.treeBaseDuration -= O.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return bS(), !0;
    }
    function WC(t, r, u) {
      var c = r.pendingProps;
      switch (i7(r), r.tag) {
        case D:
        case pe:
        case G:
        case b:
        case W:
        case Z:
        case N:
        case z:
        case B:
        case ie:
          return pi(r), null;
        case R: {
          var p = r.type;
          return E0(p) && B3(r), pi(r), null;
        }
        case T: {
          var x = r.stateNode;
          if (sp(r), n7(r), k7(), x.pendingContext && (x.context = x.pendingContext, x.pendingContext = null), t === null || t.child === null) {
            var _ = q3(r);
            if (_)
              mp(r);
            else if (t !== null) {
              var O = t.memoizedState;
              // Check if this is a client root
              (!O.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (r.flags & Rn) !== Et) && (r.flags |= Br, bS());
            }
          }
          return Ly(t, r), pi(r), null;
        }
        case j: {
          O7(r);
          var k = PS(), V = r.type;
          if (t !== null && r.stateNode != null)
            YC(t, r, V, c, k), t.ref !== r.ref && BC(r);
          else {
            if (!c) {
              if (r.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return pi(r), null;
            }
            var U = T7(), ae = q3(r);
            if (ae)
              uD(r, k, U) && mp(r);
            else {
              var re = d6(V, c, k, U, r);
              UC(re, r, !1, !1), r.stateNode = re, v6(re, V, c, k) && mp(r);
            }
            r.ref !== null && BC(r);
          }
          return pi(r), null;
        }
        case I: {
          var xe = c;
          if (t && r.stateNode != null) {
            var Ce = t.memoizedProps;
            $C(t, r, Ce, xe);
          } else {
            if (typeof xe != "string" && r.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var Me = PS(), it = T7(), Ft = q3(r);
            Ft ? sD(r) && mp(r) : r.stateNode = m6(xe, Me, it, r);
          }
          return pi(r), null;
        }
        case Y: {
          fp(r);
          var At = r.memoizedState;
          if (t === null || t.memoizedState !== null && t.memoizedState.dehydrated !== null) {
            var kn = TA(t, r, At);
            if (!kn)
              return r.flags & pr ? r : null;
          }
          if ((r.flags & Dt) !== Et)
            return r.lanes = u, (r.mode & Nn) !== kt && ay(r), r;
          var xn = At !== null, he = t !== null && t.memoizedState !== null;
          if (xn !== he && xn) {
            var Te = r.child;
            if (Te.flags |= Mi, (r.mode & an) !== kt) {
              var ve = t === null && (r.memoizedProps.unstable_avoidThisFallback !== !0 || !dt);
              ve || D7(p1.current, FS) ? Tj() : Qy();
            }
          }
          var ze = r.updateQueue;
          if (ze !== null && (r.flags |= un), pi(r), (r.mode & Nn) !== kt && xn) {
            var gt = r.child;
            gt !== null && (r.treeBaseDuration -= gt.treeBaseDuration);
          }
          return null;
        }
        case A:
          return sp(r), Ly(t, r), t === null && e7(r.stateNode.containerInfo), pi(r), null;
        case $:
          var ft = r.type._context;
          return x7(ft, r), pi(r), null;
        case J: {
          var Jt = r.type;
          return E0(Jt) && B3(r), pi(r), null;
        }
        case oe: {
          fp(r);
          var rn = r.memoizedState;
          if (rn === null)
            return pi(r), null;
          var gr = (r.flags & Dt) !== Et, Qn = rn.rendering;
          if (Qn === null)
            if (gr)
              u4(rn, !1);
            else {
              var Ja = Dj() && (t === null || (t.flags & Dt) === Et);
              if (!Ja)
                for (var Xn = r.child; Xn !== null; ) {
                  var La = cg(Xn);
                  if (La !== null) {
                    gr = !0, r.flags |= Dt, u4(rn, !1);
                    var Yi = La.updateQueue;
                    return Yi !== null && (r.updateQueue = Yi, r.flags |= un), r.subtreeFlags = Et, yD(r, u), Vd(r, A7(p1.current, Gm)), r.child;
                  }
                  Xn = Xn.sibling;
                }
              rn.tail !== null && ya() > hb() && (r.flags |= Dt, gr = !0, u4(rn, !1), r.lanes = Nh);
            }
          else {
            if (!gr) {
              var xi = cg(Qn);
              if (xi !== null) {
                r.flags |= Dt, gr = !0;
                var Mu = xi.updateQueue;
                if (Mu !== null && (r.updateQueue = Mu, r.flags |= un), u4(rn, !0), rn.tail === null && rn.tailMode === "hidden" && !Qn.alternate && !hi())
                  return pi(r), null;
              } else // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              ya() * 2 - rn.renderingStartTime > hb() && u !== yo && (r.flags |= Dt, gr = !0, u4(rn, !1), r.lanes = Nh);
            }
            if (rn.isBackwards)
              Qn.sibling = r.child, r.child = Qn;
            else {
              var ml = rn.last;
              ml !== null ? ml.sibling = Qn : r.child = Qn, rn.last = Qn;
            }
          }
          if (rn.tail !== null) {
            var gl = rn.tail;
            rn.rendering = gl, rn.tail = gl.sibling, rn.renderingStartTime = ya(), gl.sibling = null;
            var $i = p1.current;
            return gr ? $i = A7($i, Gm) : $i = cp($i), Vd(r, $i), gl;
          }
          return pi(r), null;
        }
        case ge:
          break;
        case ce:
        case Se: {
          Ky(r);
          var of = r.memoizedState, _p = of !== null;
          if (t !== null) {
            var _4 = t.memoizedState, L0 = _4 !== null;
            L0 !== _p && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !Pe && (r.flags |= Mi);
          }
          return !_p || (r.mode & an) === kt ? pi(r) : Bo(k0, yo) && (pi(r), r.subtreeFlags & (Tt | un) && (r.flags |= Mi)), null;
        }
        case Re:
          return null;
        case _e:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + r.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function OA(t, r, u) {
      switch (i7(r), r.tag) {
        case R: {
          var c = r.type;
          E0(c) && B3(r);
          var p = r.flags;
          return p & pr ? (r.flags = p & ~pr | Dt, (r.mode & Nn) !== kt && ay(r), r) : null;
        }
        case T: {
          sp(r), n7(r), k7();
          var x = r.flags;
          return (x & pr) !== Et && (x & Dt) === Et ? (r.flags = x & ~pr | Dt, r) : null;
        }
        case j:
          return O7(r), null;
        case Y: {
          fp(r);
          var _ = r.memoizedState;
          if (_ !== null && _.dehydrated !== null) {
            if (r.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            op();
          }
          var O = r.flags;
          return O & pr ? (r.flags = O & ~pr | Dt, (r.mode & Nn) !== kt && ay(r), r) : null;
        }
        case oe:
          return fp(r), null;
        case A:
          return sp(r), null;
        case $:
          var k = r.type._context;
          return x7(k, r), null;
        case ce:
        case Se:
          return Ky(r), null;
        case Re:
          return null;
        default:
          return null;
      }
    }
    function zC(t, r, u) {
      switch (i7(r), r.tag) {
        case R: {
          var c = r.type.childContextTypes;
          c != null && B3(r);
          break;
        }
        case T: {
          sp(r), n7(r), k7();
          break;
        }
        case j: {
          O7(r);
          break;
        }
        case A:
          sp(r);
          break;
        case Y:
          fp(r);
          break;
        case oe:
          fp(r);
          break;
        case $:
          var p = r.type._context;
          x7(p, r);
          break;
        case ce:
        case Se:
          Ky(r);
          break;
      }
    }
    var qC = null;
    qC = /* @__PURE__ */ new Set();
    var Lg = !1, mi = !1, DA = typeof WeakSet == "function" ? WeakSet : Set, _t = null, gp = null, wp = null;
    function AA(t) {
      Yf(null, function() {
        throw t;
      }), mo();
    }
    var jA = function(t, r) {
      if (r.props = t.memoizedProps, r.state = t.memoizedState, t.mode & Nn)
        try {
          A0(), r.componentWillUnmount();
        } finally {
          D0(t);
        }
      else
        r.componentWillUnmount();
    };
    function GC(t, r) {
      try {
        Ud(Mo, t);
      } catch (u) {
        Wr(t, r, u);
      }
    }
    function Iy(t, r, u) {
      try {
        jA(t, u);
      } catch (c) {
        Wr(t, r, c);
      }
    }
    function kA(t, r, u) {
      try {
        u.componentDidMount();
      } catch (c) {
        Wr(t, r, c);
      }
    }
    function KC(t, r) {
      try {
        XC(t);
      } catch (u) {
        Wr(t, r, u);
      }
    }
    function yp(t, r) {
      var u = t.ref;
      if (u !== null)
        if (typeof u == "function") {
          var c;
          try {
            if (t.mode & Nn)
              try {
                A0(), c = u(null);
              } finally {
                D0(t);
              }
            else
              c = u(null);
          } catch (p) {
            Wr(t, r, p);
          }
          typeof c == "function" && m("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", tn(t));
        } else
          u.current = null;
    }
    function Ig(t, r, u) {
      try {
        u();
      } catch (c) {
        Wr(t, r, c);
      }
    }
    var QC = !1;
    function LA(t, r) {
      c6(), _t = r, IA();
      var u = QC;
      return QC = !1, u;
    }
    function IA() {
      for (; _t !== null; ) {
        var t = _t, r = t.child;
        (t.subtreeFlags & Ku) !== Et && r !== null ? (r.return = t, _t = r) : HA();
      }
    }
    function HA() {
      for (; _t !== null; ) {
        var t = _t;
        or(t);
        try {
          ZA(t);
        } catch (u) {
          Wr(t, t.return, u);
        }
        Vr();
        var r = t.sibling;
        if (r !== null) {
          r.return = t.return, _t = r;
          return;
        }
        _t = t.return;
      }
    }
    function ZA(t) {
      var r = t.alternate, u = t.flags;
      if ((u & Br) !== Et) {
        switch (or(t), t.tag) {
          case b:
          case W:
          case G:
            break;
          case R: {
            if (r !== null) {
              var c = r.memoizedProps, p = r.memoizedState, x = t.stateNode;
              t.type === t.elementType && !y2 && (x.props !== t.memoizedProps && m("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", tn(t) || "instance"), x.state !== t.memoizedState && m("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", tn(t) || "instance"));
              var _ = x.getSnapshotBeforeUpdate(t.elementType === t.type ? c : g1(t.type, c), p);
              {
                var O = qC;
                _ === void 0 && !O.has(t.type) && (O.add(t.type), m("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", tn(t)));
              }
              x.__reactInternalSnapshotBeforeUpdate = _;
            }
            break;
          }
          case T: {
            {
              var k = t.stateNode;
              D6(k.containerInfo);
            }
            break;
          }
          case j:
          case I:
          case A:
          case J:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        Vr();
      }
    }
    function y1(t, r, u) {
      var c = r.updateQueue, p = c !== null ? c.lastEffect : null;
      if (p !== null) {
        var x = p.next, _ = x;
        do {
          if ((_.tag & t) === t) {
            var O = _.destroy;
            _.destroy = void 0, O !== void 0 && ((t & vi) !== Vl ? du(r) : (t & Mo) !== Vl && Ks(r), (t & M0) !== Vl && S4(!0), Ig(r, u, O), (t & M0) !== Vl && S4(!1), (t & vi) !== Vl ? ji() : (t & Mo) !== Vl && Xf());
          }
          _ = _.next;
        } while (_ !== x);
      }
    }
    function Ud(t, r) {
      var u = r.updateQueue, c = u !== null ? u.lastEffect : null;
      if (c !== null) {
        var p = c.next, x = p;
        do {
          if ((x.tag & t) === t) {
            (t & vi) !== Vl ? Kf(r) : (t & Mo) !== Vl && Qf(r);
            var _ = x.create;
            (t & M0) !== Vl && S4(!0), x.destroy = _(), (t & M0) !== Vl && S4(!1), (t & vi) !== Vl ? mv() : (t & Mo) !== Vl && gv();
            {
              var O = x.destroy;
              if (O !== void 0 && typeof O != "function") {
                var k = void 0;
                (x.tag & Mo) !== Et ? k = "useLayoutEffect" : (x.tag & M0) !== Et ? k = "useInsertionEffect" : k = "useEffect";
                var V = void 0;
                O === null ? V = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof O.then == "function" ? V = `

It looks like you wrote ` + k + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + k + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : V = " You returned: " + O, m("%s must not return anything besides a function, which is used for clean-up.%s", k, V);
              }
            }
          }
          x = x.next;
        } while (x !== p);
      }
    }
    function PA(t, r) {
      if ((r.flags & un) !== Et)
        switch (r.tag) {
          case z: {
            var u = r.stateNode.passiveEffectDuration, c = r.memoizedProps, p = c.id, x = c.onPostCommit, _ = hC(), O = r.alternate === null ? "mount" : "update";
            dC() && (O = "nested-update"), typeof x == "function" && x(p, O, u, _);
            var k = r.return;
            e: for (; k !== null; ) {
              switch (k.tag) {
                case T:
                  var V = k.stateNode;
                  V.passiveEffectDuration += u;
                  break e;
                case z:
                  var U = k.stateNode;
                  U.passiveEffectDuration += u;
                  break e;
              }
              k = k.return;
            }
            break;
          }
        }
    }
    function NA(t, r, u, c) {
      if ((u.flags & Qu) !== Et)
        switch (u.tag) {
          case b:
          case W:
          case G: {
            if (!mi)
              if (u.mode & Nn)
                try {
                  A0(), Ud(Mo | Eo, u);
                } finally {
                  D0(u);
                }
              else
                Ud(Mo | Eo, u);
            break;
          }
          case R: {
            var p = u.stateNode;
            if (u.flags & un && !mi)
              if (r === null)
                if (u.type === u.elementType && !y2 && (p.props !== u.memoizedProps && m("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", tn(u) || "instance"), p.state !== u.memoizedState && m("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", tn(u) || "instance")), u.mode & Nn)
                  try {
                    A0(), p.componentDidMount();
                  } finally {
                    D0(u);
                  }
                else
                  p.componentDidMount();
              else {
                var x = u.elementType === u.type ? r.memoizedProps : g1(u.type, r.memoizedProps), _ = r.memoizedState;
                if (u.type === u.elementType && !y2 && (p.props !== u.memoizedProps && m("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", tn(u) || "instance"), p.state !== u.memoizedState && m("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", tn(u) || "instance")), u.mode & Nn)
                  try {
                    A0(), p.componentDidUpdate(x, _, p.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    D0(u);
                  }
                else
                  p.componentDidUpdate(x, _, p.__reactInternalSnapshotBeforeUpdate);
              }
            var O = u.updateQueue;
            O !== null && (u.type === u.elementType && !y2 && (p.props !== u.memoizedProps && m("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", tn(u) || "instance"), p.state !== u.memoizedState && m("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", tn(u) || "instance")), ZS(u, O, p));
            break;
          }
          case T: {
            var k = u.updateQueue;
            if (k !== null) {
              var V = null;
              if (u.child !== null)
                switch (u.child.tag) {
                  case j:
                    V = u.child.stateNode;
                    break;
                  case R:
                    V = u.child.stateNode;
                    break;
                }
              ZS(u, k, V);
            }
            break;
          }
          case j: {
            var U = u.stateNode;
            if (r === null && u.flags & un) {
              var ae = u.type, re = u.memoizedProps;
              S6(U, ae, re);
            }
            break;
          }
          case I:
            break;
          case A:
            break;
          case z: {
            {
              var xe = u.memoizedProps, Ce = xe.onCommit, Me = xe.onRender, it = u.stateNode.effectDuration, Ft = hC(), At = r === null ? "mount" : "update";
              dC() && (At = "nested-update"), typeof Me == "function" && Me(u.memoizedProps.id, At, u.actualDuration, u.treeBaseDuration, u.actualStartTime, Ft);
              {
                typeof Ce == "function" && Ce(u.memoizedProps.id, At, it, Ft), Ij(u);
                var kn = u.return;
                e: for (; kn !== null; ) {
                  switch (kn.tag) {
                    case T:
                      var xn = kn.stateNode;
                      xn.effectDuration += it;
                      break e;
                    case z:
                      var he = kn.stateNode;
                      he.effectDuration += it;
                      break e;
                  }
                  kn = kn.return;
                }
              }
            }
            break;
          }
          case Y: {
            WA(t, u);
            break;
          }
          case oe:
          case J:
          case ge:
          case ce:
          case Se:
          case _e:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      mi || u.flags & go && XC(u);
    }
    function VA(t) {
      switch (t.tag) {
        case b:
        case W:
        case G: {
          if (t.mode & Nn)
            try {
              A0(), GC(t, t.return);
            } finally {
              D0(t);
            }
          else
            GC(t, t.return);
          break;
        }
        case R: {
          var r = t.stateNode;
          typeof r.componentDidMount == "function" && kA(t, t.return, r), KC(t, t.return);
          break;
        }
        case j: {
          KC(t, t.return);
          break;
        }
      }
    }
    function FA(t, r) {
      for (var u = null, c = t; ; ) {
        if (c.tag === j) {
          if (u === null) {
            u = c;
            try {
              var p = c.stateNode;
              r ? T6(p) : Fi(c.stateNode, c.memoizedProps);
            } catch (_) {
              Wr(t, t.return, _);
            }
          }
        } else if (c.tag === I) {
          if (u === null)
            try {
              var x = c.stateNode;
              r ? O6(x) : Lm(x, c.memoizedProps);
            } catch (_) {
              Wr(t, t.return, _);
            }
        } else if (!((c.tag === ce || c.tag === Se) && c.memoizedState !== null && c !== t)) {
          if (c.child !== null) {
            c.child.return = c, c = c.child;
            continue;
          }
        }
        if (c === t)
          return;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === t)
            return;
          u === c && (u = null), c = c.return;
        }
        u === c && (u = null), c.sibling.return = c.return, c = c.sibling;
      }
    }
    function XC(t) {
      var r = t.ref;
      if (r !== null) {
        var u = t.stateNode, c;
        switch (t.tag) {
          case j:
            c = u;
            break;
          default:
            c = u;
        }
        if (typeof r == "function") {
          var p;
          if (t.mode & Nn)
            try {
              A0(), p = r(c);
            } finally {
              D0(t);
            }
          else
            p = r(c);
          typeof p == "function" && m("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", tn(t));
        } else
          r.hasOwnProperty("current") || m("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", tn(t)), r.current = c;
      }
    }
    function BA(t) {
      var r = t.alternate;
      r !== null && (r.return = null), t.return = null;
    }
    function JC(t) {
      var r = t.alternate;
      r !== null && (t.alternate = null, JC(r));
      {
        if (t.child = null, t.deletions = null, t.sibling = null, t.tag === j) {
          var u = t.stateNode;
          u !== null && M(u);
        }
        t.stateNode = null, t._debugOwner = null, t.return = null, t.dependencies = null, t.memoizedProps = null, t.memoizedState = null, t.pendingProps = null, t.stateNode = null, t.updateQueue = null;
      }
    }
    function UA(t) {
      for (var r = t.return; r !== null; ) {
        if (eb(r))
          return r;
        r = r.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function eb(t) {
      return t.tag === j || t.tag === T || t.tag === A;
    }
    function tb(t) {
      var r = t;
      e: for (; ; ) {
        for (; r.sibling === null; ) {
          if (r.return === null || eb(r.return))
            return null;
          r = r.return;
        }
        for (r.sibling.return = r.return, r = r.sibling; r.tag !== j && r.tag !== I && r.tag !== me; ) {
          if (r.flags & Tt || r.child === null || r.tag === A)
            continue e;
          r.child.return = r, r = r.child;
        }
        if (!(r.flags & Tt))
          return r.stateNode;
      }
    }
    function YA(t) {
      var r = UA(t);
      switch (r.tag) {
        case j: {
          var u = r.stateNode;
          r.flags & Ol && (H3(u), r.flags &= ~Ol);
          var c = tb(t);
          Zy(t, c, u);
          break;
        }
        case T:
        case A: {
          var p = r.stateNode.containerInfo, x = tb(t);
          Hy(t, x, p);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function Hy(t, r, u) {
      var c = t.tag, p = c === j || c === I;
      if (p) {
        var x = t.stateNode;
        r ? _6(u, x, r) : Z3(u, x);
      } else if (c !== A) {
        var _ = t.child;
        if (_ !== null) {
          Hy(_, r, u);
          for (var O = _.sibling; O !== null; )
            Hy(O, r, u), O = O.sibling;
        }
      }
    }
    function Zy(t, r, u) {
      var c = t.tag, p = c === j || c === I;
      if (p) {
        var x = t.stateNode;
        r ? P3(u, x, r) : km(u, x);
      } else if (c !== A) {
        var _ = t.child;
        if (_ !== null) {
          Zy(_, r, u);
          for (var O = _.sibling; O !== null; )
            Zy(O, r, u), O = O.sibling;
        }
      }
    }
    var gi = null, x1 = !1;
    function $A(t, r, u) {
      {
        var c = r;
        e: for (; c !== null; ) {
          switch (c.tag) {
            case j: {
              gi = c.stateNode, x1 = !1;
              break e;
            }
            case T: {
              gi = c.stateNode.containerInfo, x1 = !0;
              break e;
            }
            case A: {
              gi = c.stateNode.containerInfo, x1 = !0;
              break e;
            }
          }
          c = c.return;
        }
        if (gi === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        nb(t, r, u), gi = null, x1 = !1;
      }
      BA(u);
    }
    function Yd(t, r, u) {
      for (var c = u.child; c !== null; )
        nb(t, r, c), c = c.sibling;
    }
    function nb(t, r, u) {
      switch (Wa(u), u.tag) {
        case j:
          mi || yp(u, r);
        case I: {
          {
            var c = gi, p = x1;
            gi = null, Yd(t, r, u), gi = c, x1 = p, gi !== null && (x1 ? E6(gi, u.stateNode) : R6(gi, u.stateNode));
          }
          return;
        }
        case me: {
          gi !== null && (x1 ? M6(gi, u.stateNode) : l2(gi, u.stateNode));
          return;
        }
        case A: {
          {
            var x = gi, _ = x1;
            gi = u.stateNode.containerInfo, x1 = !0, Yd(t, r, u), gi = x, x1 = _;
          }
          return;
        }
        case b:
        case W:
        case ie:
        case G: {
          if (!mi) {
            var O = u.updateQueue;
            if (O !== null) {
              var k = O.lastEffect;
              if (k !== null) {
                var V = k.next, U = V;
                do {
                  var ae = U, re = ae.destroy, xe = ae.tag;
                  re !== void 0 && ((xe & M0) !== Vl ? Ig(u, r, re) : (xe & Mo) !== Vl && (Ks(u), u.mode & Nn ? (A0(), Ig(u, r, re), D0(u)) : Ig(u, r, re), Xf())), U = U.next;
                } while (U !== V);
              }
            }
          }
          Yd(t, r, u);
          return;
        }
        case R: {
          if (!mi) {
            yp(u, r);
            var Ce = u.stateNode;
            typeof Ce.componentWillUnmount == "function" && Iy(u, r, Ce);
          }
          Yd(t, r, u);
          return;
        }
        case ge: {
          Yd(t, r, u);
          return;
        }
        case ce: {
          if (
            // TODO: Remove this dead flag
            u.mode & an
          ) {
            var Me = mi;
            mi = Me || u.memoizedState !== null, Yd(t, r, u), mi = Me;
          } else
            Yd(t, r, u);
          break;
        }
        default: {
          Yd(t, r, u);
          return;
        }
      }
    }
    function WA(t, r) {
      var u = r.memoizedState;
      if (u === null) {
        var c = r.alternate;
        if (c !== null) {
          var p = c.memoizedState;
          if (p !== null) {
            var x = p.dehydrated;
            x !== null && V6(x);
          }
        }
      }
    }
    function rb(t) {
      var r = t.updateQueue;
      if (r !== null) {
        t.updateQueue = null;
        var u = t.stateNode;
        u === null && (u = t.stateNode = new DA()), r.forEach(function(c) {
          var p = Bj.bind(null, t, c);
          if (!u.has(c)) {
            if (u.add(c), Hr)
              if (gp !== null && wp !== null)
                x4(wp, gp);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            c.then(p, p);
          }
        });
      }
    }
    function zA(t, r, u) {
      gp = u, wp = t, or(r), ab(r, t), or(r), gp = null, wp = null;
    }
    function S1(t, r, u) {
      var c = r.deletions;
      if (c !== null)
        for (var p = 0; p < c.length; p++) {
          var x = c[p];
          try {
            $A(t, r, x);
          } catch (k) {
            Wr(x, r, k);
          }
        }
      var _ = L1();
      if (r.subtreeFlags & Aa)
        for (var O = r.child; O !== null; )
          or(O), ab(O, t), O = O.sibling;
      or(_);
    }
    function ab(t, r, u) {
      var c = t.alternate, p = t.flags;
      switch (t.tag) {
        case b:
        case W:
        case ie:
        case G: {
          if (S1(r, t), j0(t), p & un) {
            try {
              y1(M0 | Eo, t, t.return), Ud(M0 | Eo, t);
            } catch (Jt) {
              Wr(t, t.return, Jt);
            }
            if (t.mode & Nn) {
              try {
                A0(), y1(Mo | Eo, t, t.return);
              } catch (Jt) {
                Wr(t, t.return, Jt);
              }
              D0(t);
            } else
              try {
                y1(Mo | Eo, t, t.return);
              } catch (Jt) {
                Wr(t, t.return, Jt);
              }
          }
          return;
        }
        case R: {
          S1(r, t), j0(t), p & go && c !== null && yp(c, c.return);
          return;
        }
        case j: {
          S1(r, t), j0(t), p & go && c !== null && yp(c, c.return);
          {
            if (t.flags & Ol) {
              var x = t.stateNode;
              try {
                H3(x);
              } catch (Jt) {
                Wr(t, t.return, Jt);
              }
            }
            if (p & un) {
              var _ = t.stateNode;
              if (_ != null) {
                var O = t.memoizedProps, k = c !== null ? c.memoizedProps : O, V = t.type, U = t.updateQueue;
                if (t.updateQueue = null, U !== null)
                  try {
                    C6(_, U, V, k, O);
                  } catch (Jt) {
                    Wr(t, t.return, Jt);
                  }
              }
            }
          }
          return;
        }
        case I: {
          if (S1(r, t), j0(t), p & un) {
            if (t.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var ae = t.stateNode, re = t.memoizedProps, xe = c !== null ? c.memoizedProps : re;
            try {
              b6(ae, xe, re);
            } catch (Jt) {
              Wr(t, t.return, Jt);
            }
          }
          return;
        }
        case T: {
          if (S1(r, t), j0(t), p & un && c !== null) {
            var Ce = c.memoizedState;
            if (Ce.isDehydrated)
              try {
                N6(r.containerInfo);
              } catch (Jt) {
                Wr(t, t.return, Jt);
              }
          }
          return;
        }
        case A: {
          S1(r, t), j0(t);
          return;
        }
        case Y: {
          S1(r, t), j0(t);
          var Me = t.child;
          if (Me.flags & Mi) {
            var it = Me.stateNode, Ft = Me.memoizedState, At = Ft !== null;
            if (it.isHidden = At, At) {
              var kn = Me.alternate !== null && Me.alternate.memoizedState !== null;
              kn || Mj();
            }
          }
          p & un && rb(t);
          return;
        }
        case ce: {
          var xn = c !== null && c.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            t.mode & an
          ) {
            var he = mi;
            mi = he || xn, S1(r, t), mi = he;
          } else
            S1(r, t);
          if (j0(t), p & Mi) {
            var Te = t.stateNode, ve = t.memoizedState, ze = ve !== null, gt = t;
            if (Te.isHidden = ze, ze && !xn && (gt.mode & an) !== kt) {
              _t = gt;
              for (var ft = gt.child; ft !== null; )
                _t = ft, GA(ft), ft = ft.sibling;
            }
            FA(gt, ze);
          }
          return;
        }
        case oe: {
          S1(r, t), j0(t), p & un && rb(t);
          return;
        }
        case ge:
          return;
        default: {
          S1(r, t), j0(t);
          return;
        }
      }
    }
    function j0(t) {
      var r = t.flags;
      if (r & Tt) {
        try {
          YA(t);
        } catch (u) {
          Wr(t, t.return, u);
        }
        t.flags &= ~Tt;
      }
      r & Ir && (t.flags &= ~Ir);
    }
    function qA(t, r, u) {
      gp = u, wp = r, _t = t, ob(t, r), gp = null, wp = null;
    }
    function ob(t, r, u) {
      for (var c = (t.mode & an) !== kt; _t !== null; ) {
        var p = _t, x = p.child;
        if (p.tag === ce && c) {
          var _ = p.memoizedState !== null, O = _ || Lg;
          if (O) {
            Py(t, r);
            continue;
          } else {
            var k = p.alternate, V = k !== null && k.memoizedState !== null, U = V || mi, ae = Lg, re = mi;
            Lg = O, mi = U, mi && !re && (_t = p, KA(p));
            for (var xe = x; xe !== null; )
              _t = xe, ob(
                xe,
                // New root; bubble back up to here and stop.
                r
              ), xe = xe.sibling;
            _t = p, Lg = ae, mi = re, Py(t, r);
            continue;
          }
        }
        (p.subtreeFlags & Qu) !== Et && x !== null ? (x.return = p, _t = x) : Py(t, r);
      }
    }
    function Py(t, r, u) {
      for (; _t !== null; ) {
        var c = _t;
        if ((c.flags & Qu) !== Et) {
          var p = c.alternate;
          or(c);
          try {
            NA(r, p, c);
          } catch (_) {
            Wr(c, c.return, _);
          }
          Vr();
        }
        if (c === t) {
          _t = null;
          return;
        }
        var x = c.sibling;
        if (x !== null) {
          x.return = c.return, _t = x;
          return;
        }
        _t = c.return;
      }
    }
    function GA(t) {
      for (; _t !== null; ) {
        var r = _t, u = r.child;
        switch (r.tag) {
          case b:
          case W:
          case ie:
          case G: {
            if (r.mode & Nn)
              try {
                A0(), y1(Mo, r, r.return);
              } finally {
                D0(r);
              }
            else
              y1(Mo, r, r.return);
            break;
          }
          case R: {
            yp(r, r.return);
            var c = r.stateNode;
            typeof c.componentWillUnmount == "function" && Iy(r, r.return, c);
            break;
          }
          case j: {
            yp(r, r.return);
            break;
          }
          case ce: {
            var p = r.memoizedState !== null;
            if (p) {
              ib(t);
              continue;
            }
            break;
          }
        }
        u !== null ? (u.return = r, _t = u) : ib(t);
      }
    }
    function ib(t) {
      for (; _t !== null; ) {
        var r = _t;
        if (r === t) {
          _t = null;
          return;
        }
        var u = r.sibling;
        if (u !== null) {
          u.return = r.return, _t = u;
          return;
        }
        _t = r.return;
      }
    }
    function KA(t) {
      for (; _t !== null; ) {
        var r = _t, u = r.child;
        if (r.tag === ce) {
          var c = r.memoizedState !== null;
          if (c) {
            lb(t);
            continue;
          }
        }
        u !== null ? (u.return = r, _t = u) : lb(t);
      }
    }
    function lb(t) {
      for (; _t !== null; ) {
        var r = _t;
        or(r);
        try {
          VA(r);
        } catch (c) {
          Wr(r, r.return, c);
        }
        if (Vr(), r === t) {
          _t = null;
          return;
        }
        var u = r.sibling;
        if (u !== null) {
          u.return = r.return, _t = u;
          return;
        }
        _t = r.return;
      }
    }
    function QA(t, r, u, c) {
      _t = r, XA(r, t);
    }
    function XA(t, r, u, c) {
      for (; _t !== null; ) {
        var p = _t, x = p.child;
        (p.subtreeFlags & su) !== Et && x !== null ? (x.return = p, _t = x) : JA(t, r);
      }
    }
    function JA(t, r, u, c) {
      for (; _t !== null; ) {
        var p = _t;
        if ((p.flags & Mr) !== Et) {
          or(p);
          try {
            ej(r, p);
          } catch (_) {
            Wr(p, p.return, _);
          }
          Vr();
        }
        if (p === t) {
          _t = null;
          return;
        }
        var x = p.sibling;
        if (x !== null) {
          x.return = p.return, _t = x;
          return;
        }
        _t = p.return;
      }
    }
    function ej(t, r, u, c) {
      switch (r.tag) {
        case b:
        case W:
        case G: {
          if (r.mode & Nn) {
            ry();
            try {
              Ud(vi | Eo, r);
            } finally {
              ny(r);
            }
          } else
            Ud(vi | Eo, r);
          break;
        }
      }
    }
    function tj(t) {
      _t = t, nj();
    }
    function nj() {
      for (; _t !== null; ) {
        var t = _t, r = t.child;
        if ((_t.flags & lu) !== Et) {
          var u = t.deletions;
          if (u !== null) {
            for (var c = 0; c < u.length; c++) {
              var p = u[c];
              _t = p, oj(p, t);
            }
            {
              var x = t.alternate;
              if (x !== null) {
                var _ = x.child;
                if (_ !== null) {
                  x.child = null;
                  do {
                    var O = _.sibling;
                    _.sibling = null, _ = O;
                  } while (_ !== null);
                }
              }
            }
            _t = t;
          }
        }
        (t.subtreeFlags & su) !== Et && r !== null ? (r.return = t, _t = r) : rj();
      }
    }
    function rj() {
      for (; _t !== null; ) {
        var t = _t;
        (t.flags & Mr) !== Et && (or(t), aj(t), Vr());
        var r = t.sibling;
        if (r !== null) {
          r.return = t.return, _t = r;
          return;
        }
        _t = t.return;
      }
    }
    function aj(t) {
      switch (t.tag) {
        case b:
        case W:
        case G: {
          t.mode & Nn ? (ry(), y1(vi | Eo, t, t.return), ny(t)) : y1(vi | Eo, t, t.return);
          break;
        }
      }
    }
    function oj(t, r) {
      for (; _t !== null; ) {
        var u = _t;
        or(u), lj(u, r), Vr();
        var c = u.child;
        c !== null ? (c.return = u, _t = c) : ij(t);
      }
    }
    function ij(t) {
      for (; _t !== null; ) {
        var r = _t, u = r.sibling, c = r.return;
        if (JC(r), r === t) {
          _t = null;
          return;
        }
        if (u !== null) {
          u.return = c, _t = u;
          return;
        }
        _t = c;
      }
    }
    function lj(t, r) {
      switch (t.tag) {
        case b:
        case W:
        case G: {
          t.mode & Nn ? (ry(), y1(vi, t, r), ny(t)) : y1(vi, t, r);
          break;
        }
      }
    }
    function uj(t) {
      switch (t.tag) {
        case b:
        case W:
        case G: {
          try {
            Ud(Mo | Eo, t);
          } catch (u) {
            Wr(t, t.return, u);
          }
          break;
        }
        case R: {
          var r = t.stateNode;
          try {
            r.componentDidMount();
          } catch (u) {
            Wr(t, t.return, u);
          }
          break;
        }
      }
    }
    function sj(t) {
      switch (t.tag) {
        case b:
        case W:
        case G: {
          try {
            Ud(vi | Eo, t);
          } catch (r) {
            Wr(t, t.return, r);
          }
          break;
        }
      }
    }
    function cj(t) {
      switch (t.tag) {
        case b:
        case W:
        case G: {
          try {
            y1(Mo | Eo, t, t.return);
          } catch (u) {
            Wr(t, t.return, u);
          }
          break;
        }
        case R: {
          var r = t.stateNode;
          typeof r.componentWillUnmount == "function" && Iy(t, t.return, r);
          break;
        }
      }
    }
    function fj(t) {
      switch (t.tag) {
        case b:
        case W:
        case G:
          try {
            y1(vi | Eo, t, t.return);
          } catch (r) {
            Wr(t, t.return, r);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var s4 = Symbol.for;
      s4("selector.component"), s4("selector.has_pseudo_class"), s4("selector.role"), s4("selector.test_id"), s4("selector.text");
    }
    var dj = [];
    function hj() {
      dj.forEach(function(t) {
        return t();
      });
    }
    var vj = a.ReactCurrentActQueue;
    function pj(t) {
      {
        var r = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), u = typeof jest < "u";
        return u && r !== !1;
      }
    }
    function ub() {
      {
        var t = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !t && vj.current !== null && m("The current testing environment is not configured to support act(...)"), t;
      }
    }
    var mj = Math.ceil, Ny = a.ReactCurrentDispatcher, Vy = a.ReactCurrentOwner, wi = a.ReactCurrentBatchConfig, C1 = a.ReactCurrentActQueue, Do = (
      /*             */
      0
    ), sb = (
      /*               */
      1
    ), yi = (
      /*                */
      2
    ), _s = (
      /*                */
      4
    ), tf = 0, c4 = 1, x2 = 2, Hg = 3, f4 = 4, cb = 5, Fy = 6, jn = Do, vl = null, Ra = null, Ao = be, k0 = be, By = ka(be), jo = tf, d4 = null, Zg = be, h4 = be, Pg = be, v4 = null, Fl = null, Uy = 0, fb = 500, db = 1 / 0, gj = 500, nf = null;
    function p4() {
      db = ya() + gj;
    }
    function hb() {
      return db;
    }
    var Ng = !1, Yy = null, xp = null, S2 = !1, $d = null, m4 = be, $y = [], wj = 50, g4 = 0, Wy = null, zy = !1, Vg = !1, yj = 50, Sp = 0, Fg = null, w4 = mn, Bg = be, vb = !1;
    function Ug() {
      return vl;
    }
    function pl() {
      return (jn & (yi | _s)) !== Do ? ya() : (w4 !== mn || (w4 = ya()), w4);
    }
    function Wd(t) {
      var r = t.mode;
      if ((r & an) === kt)
        return Wt;
      if ((jn & yi) !== Do && Ao !== be)
        return us(Ao);
      var u = pD() !== vD;
      if (u) {
        if (wi.transition !== null) {
          var c = wi.transition;
          c._updatedFibers || (c._updatedFibers = /* @__PURE__ */ new Set()), c._updatedFibers.add(t);
        }
        return Bg === An && (Bg = l0()), Bg;
      }
      var p = fr();
      if (p !== An)
        return p;
      var x = g6();
      return x;
    }
    function xj(t) {
      var r = t.mode;
      return (r & an) === kt ? Wt : wv();
    }
    function ko(t, r, u, c) {
      Yj(), vb && m("useInsertionEffect must not schedule updates."), zy && (Vg = !0), s0(t, u, c), (jn & yi) !== be && t === vl ? zj(r) : (Hr && Ll(t, r, u), qj(r), t === vl && ((jn & yi) === Do && (h4 = Bt(h4, u)), jo === f4 && zd(t, Ao)), Bl(t, c), u === Wt && jn === Do && (r.mode & an) === kt && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !C1.isBatchingLegacy && (p4(), vS()));
    }
    function Sj(t, r, u) {
      var c = t.current;
      c.lanes = r, s0(t, r, u), Bl(t, u);
    }
    function Cj(t) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (jn & yi) !== Do
      );
    }
    function Bl(t, r) {
      var u = t.callbackNode;
      od(t, r);
      var c = mu(t, t === vl ? Ao : be);
      if (c === be) {
        u !== null && Db(u), t.callbackNode = null, t.callbackPriority = An;
        return;
      }
      var p = wu(c), x = t.callbackPriority;
      if (x === p && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(C1.current !== null && u !== e9)) {
        u == null && x !== Wt && m("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      u != null && Db(u);
      var _;
      if (p === Wt)
        t.tag === Id ? (C1.isBatchingLegacy !== null && (C1.didScheduleLegacyUpdate = !0), QO(gb.bind(null, t))) : hS(gb.bind(null, t)), C1.current !== null ? C1.current.push(Hd) : y6(function() {
          (jn & (yi | _s)) === Do && Hd();
        }), _ = null;
      else {
        var O;
        switch (Sv(c)) {
          case qa:
            O = K1;
            break;
          case uo:
            O = Di;
            break;
          case Pi:
            O = oo;
            break;
          case Uo:
            O = zs;
            break;
          default:
            O = oo;
            break;
        }
        _ = t9(O, pb.bind(null, t));
      }
      t.callbackPriority = p, t.callbackNode = _;
    }
    function pb(t, r) {
      if (FD(), w4 = mn, Bg = be, (jn & (yi | _s)) !== Do)
        throw new Error("Should not already be working.");
      var u = t.callbackNode, c = af();
      if (c && t.callbackNode !== u)
        return null;
      var p = mu(t, t === vl ? Ao : be);
      if (p === be)
        return null;
      var x = !Oc(t, p) && !Dc(t, p) && !r, _ = x ? jj(t, p) : $g(t, p);
      if (_ !== tf) {
        if (_ === x2) {
          var O = gu(t);
          O !== be && (p = O, _ = qy(t, O));
        }
        if (_ === c4) {
          var k = d4;
          throw C2(t, be), zd(t, p), Bl(t, ya()), k;
        }
        if (_ === Fy)
          zd(t, p);
        else {
          var V = !Oc(t, p), U = t.current.alternate;
          if (V && !_j(U)) {
            if (_ = $g(t, p), _ === x2) {
              var ae = gu(t);
              ae !== be && (p = ae, _ = qy(t, ae));
            }
            if (_ === c4) {
              var re = d4;
              throw C2(t, be), zd(t, p), Bl(t, ya()), re;
            }
          }
          t.finishedWork = U, t.finishedLanes = p, bj(t, _, p);
        }
      }
      return Bl(t, ya()), t.callbackNode === u ? pb.bind(null, t) : null;
    }
    function qy(t, r) {
      var u = v4;
      if (ud(t)) {
        var c = C2(t, r);
        c.flags |= Rn, J6(t.containerInfo);
      }
      var p = $g(t, r);
      if (p !== x2) {
        var x = Fl;
        Fl = u, x !== null && mb(x);
      }
      return p;
    }
    function mb(t) {
      Fl === null ? Fl = t : Fl.push.apply(Fl, t);
    }
    function bj(t, r, u) {
      switch (r) {
        case tf:
        case c4:
          throw new Error("Root did not complete. This is a bug in React.");
        case x2: {
          b2(t, Fl, nf);
          break;
        }
        case Hg: {
          if (zd(t, u), ls(u) && // do not delay if we're inside an act() scope
          !Ab()) {
            var c = Uy + fb - ya();
            if (c > 10) {
              var p = mu(t, be);
              if (p !== be)
                break;
              var x = t.suspendedLanes;
              if (!ss(x, u)) {
                pl(), c0(t, x);
                break;
              }
              t.timeoutHandle = Am(b2.bind(null, t, Fl, nf), c);
              break;
            }
          }
          b2(t, Fl, nf);
          break;
        }
        case f4: {
          if (zd(t, u), i0(u))
            break;
          if (!Ab()) {
            var _ = Zi(t, u), O = _, k = ya() - O, V = Uj(k) - k;
            if (V > 10) {
              t.timeoutHandle = Am(b2.bind(null, t, Fl, nf), V);
              break;
            }
          }
          b2(t, Fl, nf);
          break;
        }
        case cb: {
          b2(t, Fl, nf);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function _j(t) {
      for (var r = t; ; ) {
        if (r.flags & Ya) {
          var u = r.updateQueue;
          if (u !== null) {
            var c = u.stores;
            if (c !== null)
              for (var p = 0; p < c.length; p++) {
                var x = c[p], _ = x.getSnapshot, O = x.value;
                try {
                  if (!Fe(_(), O))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var k = r.child;
        if (r.subtreeFlags & Ya && k !== null) {
          k.return = r, r = k;
          continue;
        }
        if (r === t)
          return !0;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === t)
            return !0;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
      return !0;
    }
    function zd(t, r) {
      r = u0(r, Pg), r = u0(r, h4), kl(t, r);
    }
    function gb(t) {
      if (BD(), (jn & (yi | _s)) !== Do)
        throw new Error("Should not already be working.");
      af();
      var r = mu(t, be);
      if (!Bo(r, Wt))
        return Bl(t, ya()), null;
      var u = $g(t, r);
      if (t.tag !== Id && u === x2) {
        var c = gu(t);
        c !== be && (r = c, u = qy(t, c));
      }
      if (u === c4) {
        var p = d4;
        throw C2(t, be), zd(t, r), Bl(t, ya()), p;
      }
      if (u === Fy)
        throw new Error("Root did not complete. This is a bug in React.");
      var x = t.current.alternate;
      return t.finishedWork = x, t.finishedLanes = r, b2(t, Fl, nf), Bl(t, ya()), null;
    }
    function Rj(t, r) {
      r !== be && (f0(t, Bt(r, Wt)), Bl(t, ya()), (jn & (yi | _s)) === Do && (p4(), Hd()));
    }
    function Gy(t, r) {
      var u = jn;
      jn |= sb;
      try {
        return t(r);
      } finally {
        jn = u, jn === Do && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !C1.isBatchingLegacy && (p4(), vS());
      }
    }
    function Ej(t, r, u, c, p) {
      var x = fr(), _ = wi.transition;
      try {
        return wi.transition = null, fa(qa), t(r, u, c, p);
      } finally {
        fa(x), wi.transition = _, jn === Do && p4();
      }
    }
    function rf(t) {
      $d !== null && $d.tag === Id && (jn & (yi | _s)) === Do && af();
      var r = jn;
      jn |= sb;
      var u = wi.transition, c = fr();
      try {
        return wi.transition = null, fa(qa), t ? t() : void 0;
      } finally {
        fa(c), wi.transition = u, jn = r, (jn & (yi | _s)) === Do && Hd();
      }
    }
    function wb() {
      return (jn & (yi | _s)) !== Do;
    }
    function Yg(t, r) {
      Dr(By, k0, t), k0 = Bt(k0, r);
    }
    function Ky(t) {
      k0 = By.current, En(By, t);
    }
    function C2(t, r) {
      t.finishedWork = null, t.finishedLanes = be;
      var u = t.timeoutHandle;
      if (u !== jm && (t.timeoutHandle = jm, w6(u)), Ra !== null)
        for (var c = Ra.return; c !== null; ) {
          var p = c.alternate;
          zC(p, c), c = c.return;
        }
      vl = t;
      var x = _2(t.current, null);
      return Ra = x, Ao = k0 = r, jo = tf, d4 = null, Zg = be, h4 = be, Pg = be, v4 = null, Fl = null, CD(), v1.discardPendingWarnings(), x;
    }
    function yb(t, r) {
      do {
        var u = Ra;
        try {
          if (eg(), US(), Vr(), Vy.current = null, u === null || u.return === null) {
            jo = c4, d4 = r, Ra = null;
            return;
          }
          if (u.mode & Nn && Og(u, !0), za(), r !== null && typeof r == "object" && typeof r.then == "function") {
            var c = r;
            Al(u, c, Ao);
          } else
            wc(u, r, Ao);
          QD(t, u.return, u, r, Ao), bb(u);
        } catch (p) {
          r = p, Ra === u && u !== null ? (u = u.return, Ra = u) : u = Ra;
          continue;
        }
        return;
      } while (!0);
    }
    function xb() {
      var t = Ny.current;
      return Ny.current = _g, t === null ? _g : t;
    }
    function Sb(t) {
      Ny.current = t;
    }
    function Mj() {
      Uy = ya();
    }
    function y4(t) {
      Zg = Bt(t, Zg);
    }
    function Tj() {
      jo === tf && (jo = Hg);
    }
    function Qy() {
      (jo === tf || jo === Hg || jo === x2) && (jo = f4), vl !== null && (Tc(Zg) || Tc(h4)) && zd(vl, Ao);
    }
    function Oj(t) {
      jo !== f4 && (jo = x2), v4 === null ? v4 = [t] : v4.push(t);
    }
    function Dj() {
      return jo === tf;
    }
    function $g(t, r) {
      var u = jn;
      jn |= yi;
      var c = xb();
      if (vl !== t || Ao !== r) {
        if (Hr) {
          var p = t.memoizedUpdaters;
          p.size > 0 && (x4(t, Ao), p.clear()), Vt(t, r);
        }
        nf = h0(), C2(t, r);
      }
      vu(r);
      do
        try {
          Aj();
          break;
        } catch (x) {
          yb(t, x);
        }
      while (!0);
      if (eg(), jn = u, Sb(c), Ra !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return xc(), vl = null, Ao = be, jo;
    }
    function Aj() {
      for (; Ra !== null; )
        Cb(Ra);
    }
    function jj(t, r) {
      var u = jn;
      jn |= yi;
      var c = xb();
      if (vl !== t || Ao !== r) {
        if (Hr) {
          var p = t.memoizedUpdaters;
          p.size > 0 && (x4(t, Ao), p.clear()), Vt(t, r);
        }
        nf = h0(), p4(), C2(t, r);
      }
      vu(r);
      do
        try {
          kj();
          break;
        } catch (x) {
          yb(t, x);
        }
      while (!0);
      return eg(), Sb(c), jn = u, Ra !== null ? (Ph(), tf) : (xc(), vl = null, Ao = be, jo);
    }
    function kj() {
      for (; Ra !== null && !cu(); )
        Cb(Ra);
    }
    function Cb(t) {
      var r = t.alternate;
      or(t);
      var u;
      (t.mode & Nn) !== kt ? (ty(t), u = Xy(r, t, k0), Og(t, !0)) : u = Xy(r, t, k0), Vr(), t.memoizedProps = t.pendingProps, u === null ? bb(t) : Ra = u, Vy.current = null;
    }
    function bb(t) {
      var r = t;
      do {
        var u = r.alternate, c = r.return;
        if ((r.flags & z1) === Et) {
          or(r);
          var p = void 0;
          if ((r.mode & Nn) === kt ? p = WC(u, r, k0) : (ty(r), p = WC(u, r, k0), Og(r, !1)), Vr(), p !== null) {
            Ra = p;
            return;
          }
        } else {
          var x = OA(u, r);
          if (x !== null) {
            x.flags &= dv, Ra = x;
            return;
          }
          if ((r.mode & Nn) !== kt) {
            Og(r, !1);
            for (var _ = r.actualDuration, O = r.child; O !== null; )
              _ += O.actualDuration, O = O.sibling;
            r.actualDuration = _;
          }
          if (c !== null)
            c.flags |= z1, c.subtreeFlags = Et, c.deletions = null;
          else {
            jo = Fy, Ra = null;
            return;
          }
        }
        var k = r.sibling;
        if (k !== null) {
          Ra = k;
          return;
        }
        r = c, Ra = r;
      } while (r !== null);
      jo === tf && (jo = cb);
    }
    function b2(t, r, u) {
      var c = fr(), p = wi.transition;
      try {
        wi.transition = null, fa(qa), Lj(t, r, u, c);
      } finally {
        wi.transition = p, fa(c);
      }
      return null;
    }
    function Lj(t, r, u, c) {
      do
        af();
      while ($d !== null);
      if ($j(), (jn & (yi | _s)) !== Do)
        throw new Error("Should not already be working.");
      var p = t.finishedWork, x = t.finishedLanes;
      if (Hh(x), p === null)
        return gc(), null;
      if (x === be && m("root.finishedLanes should not be empty during a commit. This is a bug in React."), t.finishedWork = null, t.finishedLanes = be, p === t.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      t.callbackNode = null, t.callbackPriority = An;
      var _ = Bt(p.lanes, p.childLanes);
      kc(t, _), t === vl && (vl = null, Ra = null, Ao = be), ((p.subtreeFlags & su) !== Et || (p.flags & su) !== Et) && (S2 || (S2 = !0, t9(oo, function() {
        return af(), null;
      })));
      var O = (p.subtreeFlags & (Ku | Aa | Qu | su)) !== Et, k = (p.flags & (Ku | Aa | Qu | su)) !== Et;
      if (O || k) {
        var V = wi.transition;
        wi.transition = null;
        var U = fr();
        fa(qa);
        var ae = jn;
        jn |= _s, Vy.current = null, LA(t, p), vC(), zA(t, p, x), f6(), t.current = p, yc(x), qA(p, t, x), X1(), Vo(), jn = ae, fa(U), wi.transition = V;
      } else
        t.current = p, vC();
      var re = S2;
      if (S2 ? (S2 = !1, $d = t, m4 = x) : (Sp = 0, Fg = null), _ = t.pendingLanes, _ === be && (xp = null), re || Mb(t.current, !1), fu(p.stateNode, c), Hr && t.memoizedUpdaters.clear(), hj(), Bl(t, ya()), r !== null)
        for (var xe = t.onRecoverableError, Ce = 0; Ce < r.length; Ce++) {
          var Me = r[Ce], it = Me.stack, Ft = Me.digest;
          xe(Me.value, {
            componentStack: it,
            digest: Ft
          });
        }
      if (Ng) {
        Ng = !1;
        var At = Yy;
        throw Yy = null, At;
      }
      return Bo(m4, Wt) && t.tag !== Id && af(), _ = t.pendingLanes, Bo(_, Wt) ? (VD(), t === Wy ? g4++ : (g4 = 0, Wy = t)) : g4 = 0, Hd(), gc(), null;
    }
    function af() {
      if ($d !== null) {
        var t = Sv(m4), r = Lc(Pi, t), u = wi.transition, c = fr();
        try {
          return wi.transition = null, fa(r), Hj();
        } finally {
          fa(c), wi.transition = u;
        }
      }
      return !1;
    }
    function Ij(t) {
      $y.push(t), S2 || (S2 = !0, t9(oo, function() {
        return af(), null;
      }));
    }
    function Hj() {
      if ($d === null)
        return !1;
      var t = $d, r = m4;
      if ($d = null, m4 = be, (jn & (yi | _s)) !== Do)
        throw new Error("Cannot flush passive effects while already rendering.");
      zy = !0, Vg = !1, hu(r);
      var u = jn;
      jn |= _s, tj(t.current), QA(t, t.current);
      {
        var c = $y;
        $y = [];
        for (var p = 0; p < c.length; p++) {
          var x = c[p];
          PA(t, x);
        }
      }
      Zh(), Mb(t.current, !0), jn = u, Hd(), Vg ? t === Fg ? Sp++ : (Sp = 0, Fg = t) : Sp = 0, zy = !1, Vg = !1, Gf(t);
      {
        var _ = t.current.stateNode;
        _.effectDuration = 0, _.passiveEffectDuration = 0;
      }
      return !0;
    }
    function _b(t) {
      return xp !== null && xp.has(t);
    }
    function Zj(t) {
      xp === null ? xp = /* @__PURE__ */ new Set([t]) : xp.add(t);
    }
    function Pj(t) {
      Ng || (Ng = !0, Yy = t);
    }
    var Nj = Pj;
    function Rb(t, r, u) {
      var c = w2(u, r), p = CC(t, c, Wt), x = Pd(t, p, Wt), _ = pl();
      x !== null && (s0(x, Wt, _), Bl(x, _));
    }
    function Wr(t, r, u) {
      if (AA(u), S4(!1), t.tag === T) {
        Rb(t, t, u);
        return;
      }
      var c = null;
      for (c = r; c !== null; ) {
        if (c.tag === T) {
          Rb(c, t, u);
          return;
        } else if (c.tag === R) {
          var p = c.type, x = c.stateNode;
          if (typeof p.getDerivedStateFromError == "function" || typeof x.componentDidCatch == "function" && !_b(x)) {
            var _ = w2(u, t), O = yy(c, _, Wt), k = Pd(c, O, Wt), V = pl();
            k !== null && (s0(k, Wt, V), Bl(k, V));
            return;
          }
        }
        c = c.return;
      }
      m(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, u);
    }
    function Vj(t, r, u) {
      var c = t.pingCache;
      c !== null && c.delete(r);
      var p = pl();
      c0(t, u), Gj(t), vl === t && ss(Ao, u) && (jo === f4 || jo === Hg && ls(Ao) && ya() - Uy < fb ? C2(t, be) : Pg = Bt(Pg, u)), Bl(t, p);
    }
    function Eb(t, r) {
      r === An && (r = xj(t));
      var u = pl(), c = Nl(t, r);
      c !== null && (s0(c, r, u), Bl(c, u));
    }
    function Fj(t) {
      var r = t.memoizedState, u = An;
      r !== null && (u = r.retryLane), Eb(t, u);
    }
    function Bj(t, r) {
      var u = An, c;
      switch (t.tag) {
        case Y:
          c = t.stateNode;
          var p = t.memoizedState;
          p !== null && (u = p.retryLane);
          break;
        case oe:
          c = t.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      c !== null && c.delete(r), Eb(t, u);
    }
    function Uj(t) {
      return t < 120 ? 120 : t < 480 ? 480 : t < 1080 ? 1080 : t < 1920 ? 1920 : t < 3e3 ? 3e3 : t < 4320 ? 4320 : mj(t / 1960) * 1960;
    }
    function Yj() {
      if (g4 > wj)
        throw g4 = 0, Wy = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      Sp > yj && (Sp = 0, Fg = null, m("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function $j() {
      v1.flushLegacyContextWarning(), v1.flushPendingUnsafeLifecycleWarnings();
    }
    function Mb(t, r) {
      or(t), Wg(t, wo, cj), r && Wg(t, nl, fj), Wg(t, wo, uj), r && Wg(t, nl, sj), Vr();
    }
    function Wg(t, r, u) {
      for (var c = t, p = null; c !== null; ) {
        var x = c.subtreeFlags & r;
        c !== p && c.child !== null && x !== Et ? c = c.child : ((c.flags & r) !== Et && u(c), c.sibling !== null ? c = c.sibling : c = p = c.return);
      }
    }
    var zg = null;
    function Tb(t) {
      {
        if ((jn & yi) !== Do || !(t.mode & an))
          return;
        var r = t.tag;
        if (r !== D && r !== T && r !== R && r !== b && r !== W && r !== ie && r !== G)
          return;
        var u = tn(t) || "ReactComponent";
        if (zg !== null) {
          if (zg.has(u))
            return;
          zg.add(u);
        } else
          zg = /* @__PURE__ */ new Set([u]);
        var c = vo;
        try {
          or(t), m("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          c ? or(t) : Vr();
        }
      }
    }
    var Xy;
    {
      var Wj = null;
      Xy = function(t, r, u) {
        var c = Ib(Wj, r);
        try {
          return FC(t, r, u);
        } catch (x) {
          if (oD() || x !== null && typeof x == "object" && typeof x.then == "function")
            throw x;
          if (eg(), US(), zC(t, r), Ib(r, c), r.mode & Nn && ty(r), Yf(null, FC, null, t, r, u), Gu()) {
            var p = mo();
            typeof p == "object" && p !== null && p._suppressLogging && typeof x == "object" && x !== null && !x._suppressLogging && (x._suppressLogging = !0);
          }
          throw x;
        }
      };
    }
    var Ob = !1, Jy;
    Jy = /* @__PURE__ */ new Set();
    function zj(t) {
      if (Pu && !ZD())
        switch (t.tag) {
          case b:
          case W:
          case G: {
            var r = Ra && tn(Ra) || "Unknown", u = r;
            if (!Jy.has(u)) {
              Jy.add(u);
              var c = tn(t) || "Unknown";
              m("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", c, r, r);
            }
            break;
          }
          case R: {
            Ob || (m("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), Ob = !0);
            break;
          }
        }
    }
    function x4(t, r) {
      if (Hr) {
        var u = t.memoizedUpdaters;
        u.forEach(function(c) {
          Ll(t, c, r);
        });
      }
    }
    var e9 = {};
    function t9(t, r) {
      {
        var u = C1.current;
        return u !== null ? (u.push(r), e9) : ol(t, r);
      }
    }
    function Db(t) {
      if (t !== e9)
        return qf(t);
    }
    function Ab() {
      return C1.current !== null;
    }
    function qj(t) {
      {
        if (t.mode & an) {
          if (!ub())
            return;
        } else if (!pj() || jn !== Do || t.tag !== b && t.tag !== W && t.tag !== G)
          return;
        if (C1.current === null) {
          var r = vo;
          try {
            or(t), m(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, tn(t));
          } finally {
            r ? or(t) : Vr();
          }
        }
      }
    }
    function Gj(t) {
      t.tag !== Id && ub() && C1.current === null && m(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function S4(t) {
      vb = t;
    }
    var Rs = null, Cp = null, Kj = function(t) {
      Rs = t;
    };
    function bp(t) {
      {
        if (Rs === null)
          return t;
        var r = Rs(t);
        return r === void 0 ? t : r.current;
      }
    }
    function n9(t) {
      return bp(t);
    }
    function r9(t) {
      {
        if (Rs === null)
          return t;
        var r = Rs(t);
        if (r === void 0) {
          if (t != null && typeof t.render == "function") {
            var u = bp(t.render);
            if (t.render !== u) {
              var c = {
                $$typeof: Cl,
                render: u
              };
              return t.displayName !== void 0 && (c.displayName = t.displayName), c;
            }
          }
          return t;
        }
        return r.current;
      }
    }
    function jb(t, r) {
      {
        if (Rs === null)
          return !1;
        var u = t.elementType, c = r.type, p = !1, x = typeof c == "object" && c !== null ? c.$$typeof : null;
        switch (t.tag) {
          case R: {
            typeof c == "function" && (p = !0);
            break;
          }
          case b: {
            (typeof c == "function" || x === vt) && (p = !0);
            break;
          }
          case W: {
            (x === Cl || x === vt) && (p = !0);
            break;
          }
          case ie:
          case G: {
            (x === lt || x === vt) && (p = !0);
            break;
          }
          default:
            return !1;
        }
        if (p) {
          var _ = Rs(u);
          if (_ !== void 0 && _ === Rs(c))
            return !0;
        }
        return !1;
      }
    }
    function kb(t) {
      {
        if (Rs === null || typeof WeakSet != "function")
          return;
        Cp === null && (Cp = /* @__PURE__ */ new WeakSet()), Cp.add(t);
      }
    }
    var Qj = function(t, r) {
      {
        if (Rs === null)
          return;
        var u = r.staleFamilies, c = r.updatedFamilies;
        af(), rf(function() {
          a9(t.current, c, u);
        });
      }
    }, Xj = function(t, r) {
      {
        if (t.context !== Bi)
          return;
        af(), rf(function() {
          C4(r, t, null, null);
        });
      }
    };
    function a9(t, r, u) {
      {
        var c = t.alternate, p = t.child, x = t.sibling, _ = t.tag, O = t.type, k = null;
        switch (_) {
          case b:
          case G:
          case R:
            k = O;
            break;
          case W:
            k = O.render;
            break;
        }
        if (Rs === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var V = !1, U = !1;
        if (k !== null) {
          var ae = Rs(k);
          ae !== void 0 && (u.has(ae) ? U = !0 : r.has(ae) && (_ === R ? U = !0 : V = !0));
        }
        if (Cp !== null && (Cp.has(t) || c !== null && Cp.has(c)) && (U = !0), U && (t._debugNeedsRemount = !0), U || V) {
          var re = Nl(t, Wt);
          re !== null && ko(re, t, Wt, mn);
        }
        p !== null && !U && a9(p, r, u), x !== null && a9(x, r, u);
      }
    }
    var Jj = function(t, r) {
      {
        var u = /* @__PURE__ */ new Set(), c = new Set(r.map(function(p) {
          return p.current;
        }));
        return o9(t.current, c, u), u;
      }
    };
    function o9(t, r, u) {
      {
        var c = t.child, p = t.sibling, x = t.tag, _ = t.type, O = null;
        switch (x) {
          case b:
          case G:
          case R:
            O = _;
            break;
          case W:
            O = _.render;
            break;
        }
        var k = !1;
        O !== null && r.has(O) && (k = !0), k ? ek(t, u) : c !== null && o9(c, r, u), p !== null && o9(p, r, u);
      }
    }
    function ek(t, r) {
      {
        var u = tk(t, r);
        if (u)
          return;
        for (var c = t; ; ) {
          switch (c.tag) {
            case j:
              r.add(c.stateNode);
              return;
            case A:
              r.add(c.stateNode.containerInfo);
              return;
            case T:
              r.add(c.stateNode.containerInfo);
              return;
          }
          if (c.return === null)
            throw new Error("Expected to reach root first.");
          c = c.return;
        }
      }
    }
    function tk(t, r) {
      for (var u = t, c = !1; ; ) {
        if (u.tag === j)
          c = !0, r.add(u.stateNode);
        else if (u.child !== null) {
          u.child.return = u, u = u.child;
          continue;
        }
        if (u === t)
          return c;
        for (; u.sibling === null; ) {
          if (u.return === null || u.return === t)
            return c;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
      return !1;
    }
    var i9;
    {
      i9 = !1;
      try {
        Object.preventExtensions({});
      } catch {
        i9 = !0;
      }
    }
    function nk(t, r, u, c) {
      this.tag = t, this.key = u, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = r, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = c, this.flags = Et, this.subtreeFlags = Et, this.deletions = null, this.lanes = be, this.childLanes = be, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !i9 && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var Eu = function(t, r, u, c) {
      return new nk(t, r, u, c);
    };
    function l9(t) {
      var r = t.prototype;
      return !!(r && r.isReactComponent);
    }
    function rk(t) {
      return typeof t == "function" && !l9(t) && t.defaultProps === void 0;
    }
    function ak(t) {
      if (typeof t == "function")
        return l9(t) ? R : b;
      if (t != null) {
        var r = t.$$typeof;
        if (r === Cl)
          return W;
        if (r === lt)
          return ie;
      }
      return D;
    }
    function _2(t, r) {
      var u = t.alternate;
      u === null ? (u = Eu(t.tag, r, t.key, t.mode), u.elementType = t.elementType, u.type = t.type, u.stateNode = t.stateNode, u._debugSource = t._debugSource, u._debugOwner = t._debugOwner, u._debugHookTypes = t._debugHookTypes, u.alternate = t, t.alternate = u) : (u.pendingProps = r, u.type = t.type, u.flags = Et, u.subtreeFlags = Et, u.deletions = null, u.actualDuration = 0, u.actualStartTime = -1), u.flags = t.flags & sa, u.childLanes = t.childLanes, u.lanes = t.lanes, u.child = t.child, u.memoizedProps = t.memoizedProps, u.memoizedState = t.memoizedState, u.updateQueue = t.updateQueue;
      var c = t.dependencies;
      switch (u.dependencies = c === null ? null : {
        lanes: c.lanes,
        firstContext: c.firstContext
      }, u.sibling = t.sibling, u.index = t.index, u.ref = t.ref, u.selfBaseDuration = t.selfBaseDuration, u.treeBaseDuration = t.treeBaseDuration, u._debugNeedsRemount = t._debugNeedsRemount, u.tag) {
        case D:
        case b:
        case G:
          u.type = bp(t.type);
          break;
        case R:
          u.type = n9(t.type);
          break;
        case W:
          u.type = r9(t.type);
          break;
      }
      return u;
    }
    function ok(t, r) {
      t.flags &= sa | Tt;
      var u = t.alternate;
      if (u === null)
        t.childLanes = be, t.lanes = r, t.child = null, t.subtreeFlags = Et, t.memoizedProps = null, t.memoizedState = null, t.updateQueue = null, t.dependencies = null, t.stateNode = null, t.selfBaseDuration = 0, t.treeBaseDuration = 0;
      else {
        t.childLanes = u.childLanes, t.lanes = u.lanes, t.child = u.child, t.subtreeFlags = Et, t.deletions = null, t.memoizedProps = u.memoizedProps, t.memoizedState = u.memoizedState, t.updateQueue = u.updateQueue, t.type = u.type;
        var c = u.dependencies;
        t.dependencies = c === null ? null : {
          lanes: c.lanes,
          firstContext: c.firstContext
        }, t.selfBaseDuration = u.selfBaseDuration, t.treeBaseDuration = u.treeBaseDuration;
      }
      return t;
    }
    function ik(t, r, u) {
      var c;
      return t === Y3 ? (c = an, r === !0 && (c |= nr, c |= Vn)) : c = kt, Hr && (c |= Nn), Eu(T, null, null, c);
    }
    function u9(t, r, u, c, p, x) {
      var _ = D, O = t;
      if (typeof t == "function")
        l9(t) ? (_ = R, O = n9(O)) : O = bp(O);
      else if (typeof t == "string")
        _ = j;
      else
        e: switch (t) {
          case ti:
            return qd(u.children, p, x, r);
          case ku:
            _ = N, p |= nr, (p & an) !== kt && (p |= Vn);
            break;
          case ql:
            return lk(u, p, x, r);
          case X:
            return uk(u, p, x, r);
          case We:
            return sk(u, p, x, r);
          case dn:
            return Lb(u, p, x, r);
          case ln:
          case bn:
          case Da:
          case Rr:
          case Kn:
          default: {
            if (typeof t == "object" && t !== null)
              switch (t.$$typeof) {
                case Lu:
                  _ = $;
                  break e;
                case Iu:
                  _ = B;
                  break e;
                case Cl:
                  _ = W, O = r9(O);
                  break e;
                case lt:
                  _ = ie;
                  break e;
                case vt:
                  _ = pe, O = null;
                  break e;
              }
            var k = "";
            {
              (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (k += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var V = c ? tn(c) : null;
              V && (k += `

Check the render method of \`` + V + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (t == null ? t : typeof t) + "." + k));
          }
        }
      var U = Eu(_, u, r, p);
      return U.elementType = t, U.type = O, U.lanes = x, U._debugOwner = c, U;
    }
    function s9(t, r, u) {
      var c = null;
      c = t._owner;
      var p = t.type, x = t.key, _ = t.props, O = u9(p, x, _, c, r, u);
      return O._debugSource = t._source, O._debugOwner = t._owner, O;
    }
    function qd(t, r, u, c) {
      var p = Eu(Z, t, c, r);
      return p.lanes = u, p;
    }
    function lk(t, r, u, c) {
      typeof t.id != "string" && m('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof t.id);
      var p = Eu(z, t, c, r | Nn);
      return p.elementType = ql, p.lanes = u, p.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, p;
    }
    function uk(t, r, u, c) {
      var p = Eu(Y, t, c, r);
      return p.elementType = X, p.lanes = u, p;
    }
    function sk(t, r, u, c) {
      var p = Eu(oe, t, c, r);
      return p.elementType = We, p.lanes = u, p;
    }
    function Lb(t, r, u, c) {
      var p = Eu(ce, t, c, r);
      p.elementType = dn, p.lanes = u;
      var x = {
        isHidden: !1
      };
      return p.stateNode = x, p;
    }
    function c9(t, r, u) {
      var c = Eu(I, t, null, r);
      return c.lanes = u, c;
    }
    function ck() {
      var t = Eu(j, null, null, kt);
      return t.elementType = "DELETED", t;
    }
    function fk(t) {
      var r = Eu(me, null, null, kt);
      return r.stateNode = t, r;
    }
    function f9(t, r, u) {
      var c = t.children !== null ? t.children : [], p = Eu(A, c, t.key, r);
      return p.lanes = u, p.stateNode = {
        containerInfo: t.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: t.implementation
      }, p;
    }
    function Ib(t, r) {
      return t === null && (t = Eu(D, null, null, kt)), t.tag = r.tag, t.key = r.key, t.elementType = r.elementType, t.type = r.type, t.stateNode = r.stateNode, t.return = r.return, t.child = r.child, t.sibling = r.sibling, t.index = r.index, t.ref = r.ref, t.pendingProps = r.pendingProps, t.memoizedProps = r.memoizedProps, t.updateQueue = r.updateQueue, t.memoizedState = r.memoizedState, t.dependencies = r.dependencies, t.mode = r.mode, t.flags = r.flags, t.subtreeFlags = r.subtreeFlags, t.deletions = r.deletions, t.lanes = r.lanes, t.childLanes = r.childLanes, t.alternate = r.alternate, t.actualDuration = r.actualDuration, t.actualStartTime = r.actualStartTime, t.selfBaseDuration = r.selfBaseDuration, t.treeBaseDuration = r.treeBaseDuration, t._debugSource = r._debugSource, t._debugOwner = r._debugOwner, t._debugNeedsRemount = r._debugNeedsRemount, t._debugHookTypes = r._debugHookTypes, t;
    }
    function dk(t, r, u, c, p) {
      this.tag = r, this.containerInfo = t, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = jm, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = An, this.eventTimes = jc(be), this.expirationTimes = jc(mn), this.pendingLanes = be, this.suspendedLanes = be, this.pingedLanes = be, this.expiredLanes = be, this.mutableReadLanes = be, this.finishedLanes = be, this.entangledLanes = be, this.entanglements = jc(be), this.identifierPrefix = c, this.onRecoverableError = p, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var x = this.pendingUpdatersLaneMap = [], _ = 0; _ < pu; _++)
          x.push(/* @__PURE__ */ new Set());
      }
      switch (r) {
        case Y3:
          this._debugRootType = u ? "hydrateRoot()" : "createRoot()";
          break;
        case Id:
          this._debugRootType = u ? "hydrate()" : "render()";
          break;
      }
    }
    function Hb(t, r, u, c, p, x, _, O, k, V) {
      var U = new dk(t, r, u, O, k), ae = ik(r, x);
      U.current = ae, ae.stateNode = U;
      {
        var re = {
          element: c,
          isDehydrated: u,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        ae.memoizedState = re;
      }
      return R7(ae), U;
    }
    var d9 = "18.3.1";
    function hk(t, r, u) {
      var c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return Ta(c), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: ei,
        key: c == null ? null : "" + c,
        children: t,
        containerInfo: r,
        implementation: u
      };
    }
    var h9, v9;
    h9 = !1, v9 = {};
    function Zb(t) {
      if (!t)
        return Bi;
      var r = iu(t), u = KO(r);
      if (r.tag === R) {
        var c = r.type;
        if (E0(c))
          return fS(r, c, u);
      }
      return u;
    }
    function vk(t, r) {
      {
        var u = iu(t);
        if (u === void 0) {
          if (typeof t.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var c = Object.keys(t).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + c);
        }
        var p = $a(u);
        if (p === null)
          return null;
        if (p.mode & nr) {
          var x = tn(u) || "Component";
          if (!v9[x]) {
            v9[x] = !0;
            var _ = vo;
            try {
              or(p), u.mode & nr ? m("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", r, r, x) : m("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", r, r, x);
            } finally {
              _ ? or(_) : Vr();
            }
          }
        }
        return p.stateNode;
      }
    }
    function Pb(t, r, u, c, p, x, _, O) {
      var k = !1, V = null;
      return Hb(t, r, k, V, u, c, p, x, _);
    }
    function Nb(t, r, u, c, p, x, _, O, k, V) {
      var U = !0, ae = Hb(u, c, U, t, p, x, _, O, k);
      ae.context = Zb(null);
      var re = ae.current, xe = pl(), Ce = Wd(re), Me = Jc(xe, Ce);
      return Me.callback = r ?? null, Pd(re, Me, Ce), Sj(ae, Ce, xe), ae;
    }
    function C4(t, r, u, c) {
      Q1(r, t);
      var p = r.current, x = pl(), _ = Wd(p);
      Tr(_);
      var O = Zb(u);
      r.context === null ? r.context = O : r.pendingContext = O, Pu && vo !== null && !h9 && (h9 = !0, m(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, tn(vo) || "Unknown"));
      var k = Jc(x, _);
      k.payload = {
        element: t
      }, c = c === void 0 ? null : c, c !== null && (typeof c != "function" && m("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", c), k.callback = c);
      var V = Pd(p, k, _);
      return V !== null && (ko(V, p, _, x), og(V, p, _)), _;
    }
    function qg(t) {
      var r = t.current;
      if (!r.child)
        return null;
      switch (r.child.tag) {
        case j:
          return r.child.stateNode;
        default:
          return r.child.stateNode;
      }
    }
    function pk(t) {
      switch (t.tag) {
        case T: {
          var r = t.stateNode;
          if (ud(r)) {
            var u = Vh(r);
            Rj(r, u);
          }
          break;
        }
        case Y: {
          rf(function() {
            var p = Nl(t, Wt);
            if (p !== null) {
              var x = pl();
              ko(p, t, Wt, x);
            }
          });
          var c = Wt;
          p9(t, c);
          break;
        }
      }
    }
    function Vb(t, r) {
      var u = t.memoizedState;
      u !== null && u.dehydrated !== null && (u.retryLane = Fh(u.retryLane, r));
    }
    function p9(t, r) {
      Vb(t, r);
      var u = t.alternate;
      u && Vb(u, r);
    }
    function mk(t) {
      if (t.tag === Y) {
        var r = a0, u = Nl(t, r);
        if (u !== null) {
          var c = pl();
          ko(u, t, r, c);
        }
        p9(t, r);
      }
    }
    function gk(t) {
      if (t.tag === Y) {
        var r = Wd(t), u = Nl(t, r);
        if (u !== null) {
          var c = pl();
          ko(u, t, r, c);
        }
        p9(t, r);
      }
    }
    function Fb(t) {
      var r = xr(t);
      return r === null ? null : r.stateNode;
    }
    var Bb = function(t) {
      return null;
    };
    function wk(t) {
      return Bb(t);
    }
    var Ub = function(t) {
      return !1;
    };
    function yk(t) {
      return Ub(t);
    }
    var Yb = null, $b = null, Wb = null, zb = null, qb = null, Gb = null, Kb = null, Qb = null, Xb = null;
    {
      var Jb = function(t, r, u) {
        var c = r[u], p = er(t) ? t.slice() : mt({}, t);
        return u + 1 === r.length ? (er(p) ? p.splice(c, 1) : delete p[c], p) : (p[c] = Jb(t[c], r, u + 1), p);
      }, e_ = function(t, r) {
        return Jb(t, r, 0);
      }, t_ = function(t, r, u, c) {
        var p = r[c], x = er(t) ? t.slice() : mt({}, t);
        if (c + 1 === r.length) {
          var _ = u[c];
          x[_] = x[p], er(x) ? x.splice(p, 1) : delete x[p];
        } else
          x[p] = t_(
            // $FlowFixMe number or string is fine here
            t[p],
            r,
            u,
            c + 1
          );
        return x;
      }, n_ = function(t, r, u) {
        if (r.length !== u.length) {
          g("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var c = 0; c < u.length - 1; c++)
            if (r[c] !== u[c]) {
              g("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return t_(t, r, u, 0);
      }, r_ = function(t, r, u, c) {
        if (u >= r.length)
          return c;
        var p = r[u], x = er(t) ? t.slice() : mt({}, t);
        return x[p] = r_(t[p], r, u + 1, c), x;
      }, a_ = function(t, r, u) {
        return r_(t, r, 0, u);
      }, m9 = function(t, r) {
        for (var u = t.memoizedState; u !== null && r > 0; )
          u = u.next, r--;
        return u;
      };
      Yb = function(t, r, u, c) {
        var p = m9(t, r);
        if (p !== null) {
          var x = a_(p.memoizedState, u, c);
          p.memoizedState = x, p.baseState = x, t.memoizedProps = mt({}, t.memoizedProps);
          var _ = Nl(t, Wt);
          _ !== null && ko(_, t, Wt, mn);
        }
      }, $b = function(t, r, u) {
        var c = m9(t, r);
        if (c !== null) {
          var p = e_(c.memoizedState, u);
          c.memoizedState = p, c.baseState = p, t.memoizedProps = mt({}, t.memoizedProps);
          var x = Nl(t, Wt);
          x !== null && ko(x, t, Wt, mn);
        }
      }, Wb = function(t, r, u, c) {
        var p = m9(t, r);
        if (p !== null) {
          var x = n_(p.memoizedState, u, c);
          p.memoizedState = x, p.baseState = x, t.memoizedProps = mt({}, t.memoizedProps);
          var _ = Nl(t, Wt);
          _ !== null && ko(_, t, Wt, mn);
        }
      }, zb = function(t, r, u) {
        t.pendingProps = a_(t.memoizedProps, r, u), t.alternate && (t.alternate.pendingProps = t.pendingProps);
        var c = Nl(t, Wt);
        c !== null && ko(c, t, Wt, mn);
      }, qb = function(t, r) {
        t.pendingProps = e_(t.memoizedProps, r), t.alternate && (t.alternate.pendingProps = t.pendingProps);
        var u = Nl(t, Wt);
        u !== null && ko(u, t, Wt, mn);
      }, Gb = function(t, r, u) {
        t.pendingProps = n_(t.memoizedProps, r, u), t.alternate && (t.alternate.pendingProps = t.pendingProps);
        var c = Nl(t, Wt);
        c !== null && ko(c, t, Wt, mn);
      }, Kb = function(t) {
        var r = Nl(t, Wt);
        r !== null && ko(r, t, Wt, mn);
      }, Qb = function(t) {
        Bb = t;
      }, Xb = function(t) {
        Ub = t;
      };
    }
    function xk(t) {
      var r = $a(t);
      return r === null ? null : r.stateNode;
    }
    function Sk(t) {
      return null;
    }
    function Ck() {
      return vo;
    }
    function bk(t) {
      var r = t.findFiberByHostInstance, u = a.ReactCurrentDispatcher;
      return es({
        bundleType: t.bundleType,
        version: t.version,
        rendererPackageName: t.rendererPackageName,
        rendererConfig: t.rendererConfig,
        overrideHookState: Yb,
        overrideHookStateDeletePath: $b,
        overrideHookStateRenamePath: Wb,
        overrideProps: zb,
        overridePropsDeletePath: qb,
        overridePropsRenamePath: Gb,
        setErrorHandler: Qb,
        setSuspenseHandler: Xb,
        scheduleUpdate: Kb,
        currentDispatcherRef: u,
        findHostInstanceByFiber: xk,
        findFiberByHostInstance: r || Sk,
        // React Refresh
        findHostInstancesForRefresh: Jj,
        scheduleRefresh: Qj,
        scheduleRoot: Xj,
        setRefreshHandler: Kj,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: Ck,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: d9
      });
    }
    var o_ = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(t) {
      console.error(t);
    };
    function g9(t) {
      this._internalRoot = t;
    }
    Gg.prototype.render = g9.prototype.render = function(t) {
      var r = this._internalRoot;
      if (r === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? m("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : Kg(arguments[1]) ? m("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && m("You passed a second argument to root.render(...) but it only accepts one argument.");
        var u = r.containerInfo;
        if (u.nodeType !== Fr) {
          var c = Fb(r.current);
          c && c.parentNode !== u && m("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      C4(t, r, null, null);
    }, Gg.prototype.unmount = g9.prototype.unmount = function() {
      typeof arguments[0] == "function" && m("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var t = this._internalRoot;
      if (t !== null) {
        this._internalRoot = null;
        var r = t.containerInfo;
        wb() && m("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), rf(function() {
          C4(null, t, null, null);
        }), K(r);
      }
    };
    function _k(t, r) {
      if (!Kg(t))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      i_(t);
      var u = !1, c = !1, p = "", x = o_;
      r != null && (r.hydrate ? g("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof r == "object" && r !== null && r.$$typeof === _i && m(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), r.unstable_strictMode === !0 && (u = !0), r.identifierPrefix !== void 0 && (p = r.identifierPrefix), r.onRecoverableError !== void 0 && (x = r.onRecoverableError));
      var _ = Pb(t, Y3, null, u, c, p, x);
      F(_.current, t);
      var O = t.nodeType === Fr ? t.parentNode : t;
      return Ro(O), new g9(_);
    }
    function Gg(t) {
      this._internalRoot = t;
    }
    function Rk(t) {
      t && ul(t);
    }
    Gg.prototype.unstable_scheduleHydration = Rk;
    function Ek(t, r, u) {
      if (!Kg(t))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      i_(t), r === void 0 && m("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var c = u ?? null, p = u != null && u.hydratedSources || null, x = !1, _ = !1, O = "", k = o_;
      u != null && (u.unstable_strictMode === !0 && (x = !0), u.identifierPrefix !== void 0 && (O = u.identifierPrefix), u.onRecoverableError !== void 0 && (k = u.onRecoverableError));
      var V = Nb(r, null, t, Y3, c, x, _, O, k);
      if (F(V.current, t), Ro(t), p)
        for (var U = 0; U < p.length; U++) {
          var ae = p[U];
          AD(V, ae);
        }
      return new Gg(V);
    }
    function Kg(t) {
      return !!(t && (t.nodeType === Zo || t.nodeType === Jl || t.nodeType === Hf || !Ze));
    }
    function b4(t) {
      return !!(t && (t.nodeType === Zo || t.nodeType === Jl || t.nodeType === Hf || t.nodeType === Fr && t.nodeValue === " react-mount-point-unstable "));
    }
    function i_(t) {
      t.nodeType === Zo && t.tagName && t.tagName.toUpperCase() === "BODY" && m("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), te(t) && (t._reactRootContainer ? m("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : m("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var Mk = a.ReactCurrentOwner, l_;
    l_ = function(t) {
      if (t._reactRootContainer && t.nodeType !== Fr) {
        var r = Fb(t._reactRootContainer.current);
        r && r.parentNode !== t && m("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var u = !!t._reactRootContainer, c = w9(t), p = !!(c && Oe(c));
      p && !u && m("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), t.nodeType === Zo && t.tagName && t.tagName.toUpperCase() === "BODY" && m("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function w9(t) {
      return t ? t.nodeType === Jl ? t.documentElement : t.firstChild : null;
    }
    function u_() {
    }
    function Tk(t, r, u, c, p) {
      if (p) {
        if (typeof c == "function") {
          var x = c;
          c = function() {
            var re = qg(_);
            x.call(re);
          };
        }
        var _ = Nb(
          r,
          c,
          t,
          Id,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          u_
        );
        t._reactRootContainer = _, F(_.current, t);
        var O = t.nodeType === Fr ? t.parentNode : t;
        return Ro(O), rf(), _;
      } else {
        for (var k; k = t.lastChild; )
          t.removeChild(k);
        if (typeof c == "function") {
          var V = c;
          c = function() {
            var re = qg(U);
            V.call(re);
          };
        }
        var U = Pb(
          t,
          Id,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          u_
        );
        t._reactRootContainer = U, F(U.current, t);
        var ae = t.nodeType === Fr ? t.parentNode : t;
        return Ro(ae), rf(function() {
          C4(r, U, u, c);
        }), U;
      }
    }
    function Ok(t, r) {
      t !== null && typeof t != "function" && m("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", r, t);
    }
    function Qg(t, r, u, c, p) {
      l_(u), Ok(p === void 0 ? null : p, "render");
      var x = u._reactRootContainer, _;
      if (!x)
        _ = Tk(u, r, t, p, c);
      else {
        if (_ = x, typeof p == "function") {
          var O = p;
          p = function() {
            var k = qg(_);
            O.call(k);
          };
        }
        C4(r, _, t, p);
      }
      return qg(_);
    }
    var s_ = !1;
    function Dk(t) {
      {
        s_ || (s_ = !0, m("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
        var r = Mk.current;
        if (r !== null && r.stateNode !== null) {
          var u = r.stateNode._warnedAboutRefsInRender;
          u || m("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", _n(r.type) || "A component"), r.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return t == null ? null : t.nodeType === Zo ? t : vk(t, "findDOMNode");
    }
    function Ak(t, r, u) {
      if (m("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !b4(r))
        throw new Error("Target container is not a DOM element.");
      {
        var c = te(r) && r._reactRootContainer === void 0;
        c && m("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return Qg(null, t, r, !0, u);
    }
    function jk(t, r, u) {
      if (m("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !b4(r))
        throw new Error("Target container is not a DOM element.");
      {
        var c = te(r) && r._reactRootContainer === void 0;
        c && m("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return Qg(null, t, r, !1, u);
    }
    function kk(t, r, u, c) {
      if (m("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !b4(u))
        throw new Error("Target container is not a DOM element.");
      if (t == null || !P(t))
        throw new Error("parentComponent must be a valid React Component");
      return Qg(t, r, u, !1, c);
    }
    var c_ = !1;
    function Lk(t) {
      if (c_ || (c_ = !0, m("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !b4(t))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var r = te(t) && t._reactRootContainer === void 0;
        r && m("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (t._reactRootContainer) {
        {
          var u = w9(t), c = u && !Oe(u);
          c && m("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return rf(function() {
          Qg(null, null, t, !1, function() {
            t._reactRootContainer = null, K(t);
          });
        }), !0;
      } else {
        {
          var p = w9(t), x = !!(p && Oe(p)), _ = t.nodeType === Zo && b4(t.parentNode) && !!t.parentNode._reactRootContainer;
          x && m("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", _ ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    Or(pk), p0(mk), Cv(gk), yu(fr), sd(xv), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && m("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), Ih(r6), ro(Gy, Ej, rf);
    function Ik(t, r) {
      var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!Kg(r))
        throw new Error("Target container is not a DOM element.");
      return hk(t, r, null, u);
    }
    function Hk(t, r, u, c) {
      return kk(t, r, u, c);
    }
    var y9 = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [Oe, je, Ve, $u, hc, Gy]
    };
    function Zk(t, r) {
      return y9.usingClientEntryPoint || m('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), _k(t, r);
    }
    function Pk(t, r, u) {
      return y9.usingClientEntryPoint || m('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), Ek(t, r, u);
    }
    function Nk(t) {
      return wb() && m("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), rf(t);
    }
    var Vk = bk({
      findFiberByHostInstance: se,
      bundleType: 1,
      version: d9,
      rendererPackageName: "react-dom"
    });
    if (!Vk && ar && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var f_ = window.location.protocol;
      /^(https?|file):$/.test(f_) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (f_ === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    Yl.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = y9, Yl.createPortal = Ik, Yl.createRoot = Zk, Yl.findDOMNode = Dk, Yl.flushSync = Nk, Yl.hydrate = Ak, Yl.hydrateRoot = Pk, Yl.render = jk, Yl.unmountComponentAtNode = Lk, Yl.unstable_batchedUpdates = Gy, Yl.unstable_renderSubtreeIntoContainer = Hk, Yl.version = d9, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Yl;
}
function JE() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(JE);
    } catch (e) {
      console.error(e);
    }
  }
}
process.env.NODE_ENV === "production" ? (JE(), J9.exports = eZ()) : J9.exports = tZ();
var x5 = J9.exports, nZ = "div";
function H_(e, n) {
  const a = setTimeout(n, e);
  return () => clearTimeout(a);
}
function rZ(e) {
  let n = requestAnimationFrame(() => {
    n = requestAnimationFrame(e);
  });
  return () => cancelAnimationFrame(n);
}
function Z_(...e) {
  return e.join(", ").split(", ").reduce((n, a) => {
    const i = a.endsWith("ms") ? 1 : 1e3, h = parseFloat(a || "0s") * i;
    return h > n ? h : n;
  }, 0);
}
function G4(e, n, a) {
  return !a && n !== !1 && (!e || !!n);
}
var $5 = He(function(n) {
  var a = n, { store: i, alwaysVisible: h } = a, g = Ue(a, ["store", "alwaysVisible"]);
  const m = Jx();
  i = i || m, Ht(
    i,
    process.env.NODE_ENV !== "production" && "DisclosureContent must receive a `store` prop or be wrapped in a DisclosureProvider component."
  );
  const S = Pt(null), b = Na(g.id), [R, D] = Kt(null), T = i.useState("open"), A = i.useState("mounted"), j = i.useState("animated"), I = i.useState("contentElement"), Z = Ia(i.disclosure, "contentElement");
  Ln(() => {
    S.current && (i == null || i.setContentElement(S.current));
  }, [i]), Ln(() => {
    let W;
    return i == null || i.setState("animated", (z) => (W = z, !0)), () => {
      W !== void 0 && (i == null || i.setState("animated", W));
    };
  }, [i]), Ln(() => {
    if (j) {
      if (!(I != null && I.isConnected)) {
        D(null);
        return;
      }
      return rZ(() => {
        D(T ? "enter" : A ? "leave" : null);
      });
    }
  }, [j, I, T, A]), Ln(() => {
    if (!i || !j)
      return;
    const W = () => i == null ? void 0 : i.setState("animating", !1), z = () => x5.flushSync(W);
    if (!R || !I) {
      W();
      return;
    }
    if (R === "leave" && T || R === "enter" && !T)
      return;
    if (typeof j == "number")
      return H_(j, z);
    const {
      transitionDuration: Y,
      animationDuration: ie,
      transitionDelay: G,
      animationDelay: pe
    } = getComputedStyle(I), {
      transitionDuration: J = "0",
      animationDuration: me = "0",
      transitionDelay: oe = "0",
      animationDelay: ge = "0"
    } = Z ? getComputedStyle(Z) : {}, ce = Z_(
      G,
      pe,
      oe,
      ge
    ), Se = Z_(
      Y,
      ie,
      J,
      me
    ), Re = ce + Se;
    if (!Re) {
      R === "enter" && i.setState("animated", !1), W();
      return;
    }
    const _e = 1e3 / 60, Ye = Math.max(Re - _e, 0);
    return H_(Ye, z);
  }, [i, j, I, Z, T, R]), g = Bn(
    g,
    (W) => /* @__PURE__ */ d.jsx(e8, { value: i, children: W }),
    [i]
  );
  const N = G4(A, g.hidden, h), B = g.style, $ = qr(() => N ? De(Q({}, B), { display: "none" }) : B, [N, B]);
  return g = De(Q({
    id: b,
    "data-open": T || void 0,
    "data-enter": R === "enter" || void 0,
    "data-leave": R === "leave" || void 0,
    hidden: N
  }, g), {
    ref: In(b ? i.setContentElement : null, S, g.ref),
    style: $
  }), Pa(g);
}), aZ = ke(function(n) {
  const a = $5(n);
  return Ie(nZ, a);
}), oZ = ke(function(n) {
  var a = n, {
    unmountOnHide: i
  } = a, h = Ue(a, [
    "unmountOnHide"
  ]);
  const g = Jx(), m = h.store || g;
  return Ia(
    m,
    (b) => !i || (b == null ? void 0 : b.mounted)
  ) === !1 ? null : /* @__PURE__ */ d.jsx(aZ, Q({}, h));
});
function eM(e = {}) {
  return YE(e);
}
function tM(e, n, a) {
  return $E(e, n, a);
}
function W5(e = {}) {
  const [n, a] = Ci(eM, e);
  return tM(n, a, e);
}
function nM(e, ...n) {
  if (!e)
    return !1;
  const a = e.getAttribute("data-backdrop");
  return a == null ? !1 : a === "" || a === "true" || !n.length ? !0 : n.some((i) => a === i);
}
var T9 = /* @__PURE__ */ new WeakMap();
function K4(e, n, a) {
  T9.has(e) || T9.set(e, /* @__PURE__ */ new Map());
  const i = T9.get(e), h = i.get(n);
  if (!h)
    return i.set(n, a()), () => {
      var S;
      (S = i.get(n)) == null || S(), i.delete(n);
    };
  const g = a(), m = () => {
    g(), h(), i.delete(n);
  };
  return i.set(n, m), () => {
    i.get(n) === m && (g(), i.set(n, h));
  };
}
function t8(e, n, a) {
  return K4(e, n, () => {
    const h = e.getAttribute(n);
    return e.setAttribute(n, a), () => {
      h == null ? e.removeAttribute(n) : e.setAttribute(n, h);
    };
  });
}
function k2(e, n, a) {
  return K4(e, n, () => {
    const h = n in e, g = e[n];
    return e[n] = a, () => {
      h ? e[n] = g : delete e[n];
    };
  });
}
function ex(e, n) {
  return e ? K4(e, "style", () => {
    const i = e.style.cssText;
    return Object.assign(e.style, n), () => {
      e.style.cssText = i;
    };
  }) : () => {
  };
}
function iZ(e, n, a) {
  return e ? K4(e, n, () => {
    const h = e.style.getPropertyValue(n);
    return e.style.setProperty(n, a), () => {
      h ? e.style.setProperty(n, h) : e.style.removeProperty(n);
    };
  }) : () => {
  };
}
var lZ = ["SCRIPT", "STYLE"];
function tx(e) {
  return `__ariakit-dialog-snapshot-${e}`;
}
function uZ(e, n) {
  const a = aa(n), i = tx(e);
  if (!a.body[i])
    return !0;
  do {
    if (n === a.body)
      return !1;
    if (n[i])
      return !0;
    if (!n.parentElement)
      return !1;
    n = n.parentElement;
  } while (!0);
}
function sZ(e, n, a) {
  return lZ.includes(n.tagName) || !uZ(e, n) ? !1 : !a.some(
    (i) => i && pa(n, i)
  );
}
function n8(e, n, a, i) {
  for (let h of n) {
    if (!(h != null && h.isConnected))
      continue;
    const g = n.some((b) => !b || b === h ? !1 : b.contains(h)), m = aa(h), S = h;
    for (; h.parentElement && h !== m.body; ) {
      if (i == null || i(h.parentElement, S), !g)
        for (const b of h.parentElement.children)
          sZ(e, b, n) && a(b, S);
      h = h.parentElement;
    }
  }
}
function cZ(e, n) {
  const { body: a } = aa(n[0]), i = [];
  return n8(e, n, (g) => {
    i.push(k2(g, tx(e), !0));
  }), xl(
    k2(a, tx(e), !0),
    () => i.forEach((g) => g())
  );
}
function Np(e = "", n = !1) {
  return `__ariakit-dialog-${n ? "ancestor" : "outside"}${e ? `-${e}` : ""}`;
}
function fZ(e, n = "") {
  return xl(
    k2(e, Np(), !0),
    k2(e, Np(n), !0)
  );
}
function rM(e, n = "") {
  return xl(
    k2(e, Np("", !0), !0),
    k2(e, Np(n, !0), !0)
  );
}
function r8(e, n) {
  const a = Np(n, !0);
  if (e[a])
    return !0;
  const i = Np(n);
  do {
    if (e[i])
      return !0;
    if (!e.parentElement)
      return !1;
    e = e.parentElement;
  } while (!0);
}
function P_(e, n) {
  const a = [], i = n.map((g) => g == null ? void 0 : g.id);
  return n8(
    e,
    n,
    (g) => {
      nM(g, ...i) || a.unshift(fZ(g, e));
    },
    (g, m) => {
      m.hasAttribute("data-dialog") && m.id !== e || a.unshift(rM(g, e));
    }
  ), () => {
    a.forEach((g) => g());
  };
}
var dZ = "div", hZ = [
  "a",
  "button",
  "details",
  "dialog",
  "div",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "section",
  "select",
  "span",
  "summary",
  "textarea",
  "ul",
  "svg"
];
He(
  function(n) {
    return n;
  }
);
var P4 = ke(
  // @ts-expect-error
  function(n) {
    return Ie(dZ, n);
  }
);
Object.assign(
  P4,
  hZ.reduce((e, n) => (e[n] = ke(function(i) {
    return Ie(n, i);
  }), e), {})
);
function vZ({
  store: e,
  backdrop: n,
  alwaysVisible: a,
  hidden: i
}) {
  const h = Pt(null), g = B5({ disclosure: e }), m = e.useState("contentElement");
  Ln(() => {
    const R = h.current, D = m;
    R && D && (R.style.zIndex = getComputedStyle(D).zIndex);
  }, [m]), Ln(() => {
    const R = m == null ? void 0 : m.id;
    if (!R)
      return;
    const D = h.current;
    if (D)
      return rM(D, R);
  }, [m]);
  const S = $5({
    ref: h,
    store: g,
    role: "presentation",
    "data-backdrop": (m == null ? void 0 : m.id) || "",
    alwaysVisible: a,
    hidden: i ?? void 0,
    style: {
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
  if (!n)
    return null;
  if (eE(n))
    return /* @__PURE__ */ d.jsx(P4, De(Q({}, S), { render: n }));
  const b = typeof n != "boolean" ? n : "div";
  return /* @__PURE__ */ d.jsx(P4, De(Q({}, S), { render: /* @__PURE__ */ d.jsx(b, {}) }));
}
var N_ = Za({});
function pZ(e) {
  const n = Qo(N_), [a, i] = Kt([]), h = Pr(
    (S) => {
      var b;
      return i((R) => [...R, S]), xl((b = n.add) == null ? void 0 : b.call(n, S), () => {
        i((R) => R.filter((D) => D !== S));
      });
    },
    [n]
  );
  Ln(() => Ea(e, ["open", "contentElement"], (S) => {
    var b;
    if (S.open && S.contentElement)
      return (b = n.add) == null ? void 0 : b.call(n, e);
  }), [e, n]);
  const g = qr(() => ({ store: e, add: h }), [e, h]);
  return { wrapElement: Pr(
    (S) => /* @__PURE__ */ d.jsx(N_.Provider, { value: g, children: S }),
    [g]
  ), nestedDialogs: a };
}
function mZ(e) {
  const n = Pt();
  return wt(() => {
    if (!e) {
      n.current = null;
      return;
    }
    return Go("mousedown", (i) => {
      n.current = i.target;
    }, !0);
  }, [e]), n;
}
function gZ(e) {
  return e.tagName === "HTML" ? !0 : pa(aa(e).body, e);
}
function wZ(e, n) {
  if (!e)
    return !1;
  if (pa(e, n))
    return !0;
  const a = n.getAttribute("aria-activedescendant");
  if (a) {
    const i = aa(e).getElementById(a);
    if (i)
      return pa(e, i);
  }
  return !1;
}
function yZ(e, n) {
  if (!("clientY" in e))
    return !1;
  const a = n.getBoundingClientRect();
  return a.width === 0 || a.height === 0 ? !1 : a.top <= e.clientY && e.clientY <= a.top + a.height && a.left <= e.clientX && e.clientX <= a.left + a.width;
}
function O9({
  store: e,
  type: n,
  listener: a,
  capture: i,
  domReady: h
}) {
  const g = nt(a), m = e.useState("open"), S = Pt(!1);
  Ln(() => {
    if (!m || !h)
      return;
    const { contentElement: b } = e.getState();
    if (!b)
      return;
    const R = () => {
      S.current = !0;
    };
    return b.addEventListener("focusin", R, !0), () => b.removeEventListener("focusin", R, !0);
  }, [e, m, h]), wt(() => m ? Go(n, (R) => {
    const { contentElement: D, disclosureElement: T } = e.getState(), A = R.target;
    !D || !A || !gZ(A) || pa(D, A) || wZ(T, A) || A.hasAttribute("data-focus-trap") || yZ(R, D) || S.current && !r8(A, D.id) || g(R);
  }, i) : void 0, [m, i]);
}
function D9(e, n) {
  return typeof e == "function" ? e(n) : !!e;
}
function xZ(e, n, a) {
  const i = e.useState("open"), h = mZ(i), g = { store: e, domReady: a, capture: !0 };
  O9(De(Q({}, g), {
    type: "click",
    listener: (m) => {
      const { contentElement: S } = e.getState(), b = h.current;
      b && sE(b) && r8(b, S == null ? void 0 : S.id) && D9(n, m) && e.hide();
    }
  })), O9(De(Q({}, g), {
    type: "focusin",
    listener: (m) => {
      const { contentElement: S } = e.getState();
      S && m.target !== aa(S) && D9(n, m) && e.hide();
    }
  })), O9(De(Q({}, g), {
    type: "contextmenu",
    listener: (m) => {
      D9(n, m) && e.hide();
    }
  }));
}
function SZ(e, n) {
  const i = aa(e).createElement("button");
  return i.type = "button", i.tabIndex = -1, i.textContent = "Dismiss popup", Object.assign(i.style, {
    border: "0px",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0px",
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
  }), i.addEventListener("click", n), e.prepend(i), () => {
    i.removeEventListener("click", n), i.remove();
  };
}
function CZ(e) {
  return t8(e, "aria-hidden", "true");
}
function aM() {
  return "inert" in HTMLElement.prototype;
}
function oM(e, n) {
  if (!("style" in e))
    return A4;
  if (aM())
    return k2(e, "inert", !0);
  const i = Yp(e, !0).map((h) => {
    if (n != null && n.some((m) => m && pa(m, h)))
      return A4;
    const g = K4(h, "focus", () => (h.focus = A4, () => {
      delete h.focus;
    }));
    return xl(t8(h, "tabindex", "-1"), g);
  });
  return xl(
    ...i,
    CZ(e),
    ex(e, {
      pointerEvents: "none",
      userSelect: "none",
      cursor: "default"
    })
  );
}
function bZ(e, n) {
  const a = [], i = n.map((g) => g == null ? void 0 : g.id);
  return n8(
    e,
    n,
    (g) => {
      nM(g, ...i) || a.unshift(oM(g, n));
    },
    (g) => {
      g.hasAttribute("role") && (n.some((m) => m && pa(m, g)) || a.unshift(t8(g, "role", "none")));
    }
  ), () => {
    a.forEach((g) => g());
  };
}
function _Z({
  attribute: e,
  contentId: n,
  contentElement: a,
  enabled: i
}) {
  const [h, g] = j5(), m = Pr(() => {
    if (!i || !a)
      return !1;
    const { body: S } = aa(a), b = S.getAttribute(e);
    return !b || b === n;
  }, [h, i, a, e, n]);
  return wt(() => {
    if (!i || !n || !a)
      return;
    const { body: S } = aa(a);
    if (m())
      return S.setAttribute(e, n), () => S.removeAttribute(e);
    const b = new MutationObserver(() => x5.flushSync(g));
    return b.observe(S, { attributeFilter: [e] }), () => b.disconnect();
  }, [h, i, n, a, m, e]), m;
}
function RZ(e) {
  const n = e.getBoundingClientRect().left;
  return Math.round(n) + e.scrollLeft ? "paddingLeft" : "paddingRight";
}
function EZ(e, n, a) {
  const i = _Z({
    attribute: "data-dialog-prevent-body-scroll",
    contentElement: e,
    contentId: n,
    enabled: a
  });
  wt(() => {
    if (!i() || !e)
      return;
    const h = aa(e), g = uE(e), { documentElement: m, body: S } = h, b = m.style.getPropertyValue("--scrollbar-width"), R = b ? parseInt(b) : g.innerWidth - m.clientWidth, D = () => iZ(
      m,
      "--scrollbar-width",
      `${R}px`
    ), T = RZ(m), A = () => ex(S, {
      overflow: "hidden",
      [T]: `${R}px`
    }), j = () => {
      var Z, N;
      const { scrollX: B, scrollY: $, visualViewport: W } = g, z = (Z = W == null ? void 0 : W.offsetLeft) != null ? Z : 0, Y = (N = W == null ? void 0 : W.offsetTop) != null ? N : 0, ie = ex(S, {
        position: "fixed",
        overflow: "hidden",
        top: `${-($ - Math.floor(Y))}px`,
        left: `${-(B - Math.floor(z))}px`,
        right: "0",
        [T]: `${R}px`
      });
      return () => {
        ie(), process.env.NODE_ENV !== "test" && g.scrollTo(B, $);
      };
    }, I = jx() && !pL();
    return xl(
      D(),
      I ? j() : A()
    );
  }, [i, e]);
}
var MZ = "div", iM = He(function(n) {
  var a = n, { autoFocusOnShow: i = !0 } = a, h = Ue(a, ["autoFocusOnShow"]);
  return h = Bn(
    h,
    (g) => /* @__PURE__ */ d.jsx(RE.Provider, { value: i, children: g }),
    [i]
  ), h;
});
ke(function(n) {
  const a = iM(n);
  return Ie(MZ, a);
});
var nx = Za(0);
function lM({ level: e, children: n }) {
  const a = Qo(nx), i = Math.max(
    Math.min(e || a + 1, 6),
    1
  );
  return /* @__PURE__ */ d.jsx(nx.Provider, { value: i, children: n });
}
var rx = Za(null), TZ = "div";
function OZ(e) {
  return aa(e).body;
}
function DZ(e, n) {
  return n ? typeof n == "function" ? n(e) : n : aa(e).createElement("div");
}
function AZ(e = "id") {
  return `${e ? `${e}-` : ""}${Math.random().toString(36).substr(2, 6)}`;
}
function Gd(e) {
  queueMicrotask(() => {
    e == null || e.focus();
  });
}
var uM = He(function(n) {
  var a = n, {
    preserveTabOrder: i,
    preserveTabOrderAnchor: h,
    portalElement: g,
    portalRef: m,
    portal: S = !0
  } = a, b = Ue(a, [
    "preserveTabOrder",
    "preserveTabOrderAnchor",
    "portalElement",
    "portalRef",
    "portal"
  ]);
  const R = Pt(null), D = In(R, b.ref), T = Qo(rx), [A, j] = Kt(null), [I, Z] = Kt(
    null
  ), N = Pt(null), B = Pt(null), $ = Pt(null), W = Pt(null);
  return Ln(() => {
    const z = R.current;
    if (!z || !S) {
      j(null);
      return;
    }
    const Y = DZ(z, g);
    if (!Y) {
      j(null);
      return;
    }
    const ie = Y.isConnected;
    if (ie || (T || OZ(z)).appendChild(Y), Y.id || (Y.id = z.id ? `portal/${z.id}` : AZ()), j(Y), $9(m, Y), !ie)
      return () => {
        Y.remove(), $9(m, null);
      };
  }, [S, g, T, m]), Ln(() => {
    if (!S || !i || !h)
      return;
    const Y = aa(h).createElement("span");
    return Y.style.position = "fixed", h.insertAdjacentElement("afterend", Y), Z(Y), () => {
      Y.remove(), Z(null);
    };
  }, [S, i, h]), wt(() => {
    if (!A || !i)
      return;
    let z = 0;
    const Y = (ie) => {
      if (!Qd(ie))
        return;
      const G = ie.type === "focusin";
      if (cancelAnimationFrame(z), G)
        return y5(A);
      z = requestAnimationFrame(() => {
        Op(A, !0);
      });
    };
    return A.addEventListener("focusin", Y, !0), A.addEventListener("focusout", Y, !0), () => {
      cancelAnimationFrame(z), A.removeEventListener("focusin", Y, !0), A.removeEventListener("focusout", Y, !0);
    };
  }, [A, i]), b = Bn(
    b,
    (z) => {
      if (z = // While the portal node is not in the DOM, we need to pass the
      // current context to the portal context, otherwise it's going to
      // reset to the body element on nested portals.
      /* @__PURE__ */ d.jsx(rx.Provider, { value: A || T, children: z }), !S)
        return z;
      if (!A)
        return /* @__PURE__ */ d.jsx(
          "span",
          {
            ref: D,
            id: b.id,
            style: { position: "fixed" },
            hidden: !0
          }
        );
      z = /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
        i && A && /* @__PURE__ */ d.jsx(
          Dp,
          {
            ref: B,
            className: "__focus-trap-inner-before",
            onFocus: (ie) => {
              Qd(ie, A) ? Gd(b9()) : Gd(N.current);
            }
          }
        ),
        z,
        i && A && /* @__PURE__ */ d.jsx(
          Dp,
          {
            ref: $,
            className: "__focus-trap-inner-after",
            onFocus: (ie) => {
              Qd(ie, A) ? Gd(b_()) : Gd(W.current);
            }
          }
        )
      ] }), A && (z = x5.createPortal(z, A));
      let Y = /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
        i && A && /* @__PURE__ */ d.jsx(
          Dp,
          {
            ref: N,
            className: "__focus-trap-outer-before",
            onFocus: (ie) => {
              !(ie.relatedTarget === W.current) && Qd(ie, A) ? Gd(B.current) : Gd(b_());
            }
          }
        ),
        i && // We're using position: fixed here so that the browser doesn't
        // add margin to the element when setting gap on a parent element.
        /* @__PURE__ */ d.jsx("span", { "aria-owns": A == null ? void 0 : A.id, style: { position: "fixed" } }),
        i && A && /* @__PURE__ */ d.jsx(
          Dp,
          {
            ref: W,
            className: "__focus-trap-outer-after",
            onFocus: (ie) => {
              if (Qd(ie, A))
                Gd($.current);
              else {
                const G = b9();
                if (G === B.current) {
                  requestAnimationFrame(() => {
                    var pe;
                    return (pe = b9()) == null ? void 0 : pe.focus();
                  });
                  return;
                }
                Gd(G);
              }
            }
          }
        )
      ] });
      return I && i && (Y = x5.createPortal(
        Y,
        I
      )), /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
        Y,
        z
      ] });
    },
    [A, T, S, b.id, i, I]
  ), b = De(Q({}, b), {
    ref: D
  }), b;
}), jZ = ke(function(n) {
  const a = uM(n);
  return Ie(TZ, a);
}), kZ = "div", V_ = kx();
function LZ(e) {
  const n = yf();
  return !n || e && pa(e, n) ? !1 : !!Z0(n);
}
function F_(e, n = !1) {
  if (!e)
    return null;
  const a = "current" in e ? e.current : e;
  return a ? n ? Z0(a) ? a : null : a : null;
}
var sM = He(function(n) {
  var a = n, {
    store: i,
    open: h,
    onClose: g,
    focusable: m = !0,
    modal: S = !0,
    portal: b = !!S,
    backdrop: R = !!S,
    hideOnEscape: D = !0,
    hideOnInteractOutside: T = !0,
    getPersistentElements: A,
    preventBodyScroll: j = !!S,
    autoFocusOnShow: I = !0,
    autoFocusOnHide: Z = !0,
    initialFocus: N,
    finalFocus: B,
    unmountOnHide: $,
    unstable_treeSnapshotKey: W
  } = a, z = Ue(a, [
    "store",
    "open",
    "onClose",
    "focusable",
    "modal",
    "portal",
    "backdrop",
    "hideOnEscape",
    "hideOnInteractOutside",
    "getPersistentElements",
    "preventBodyScroll",
    "autoFocusOnShow",
    "autoFocusOnHide",
    "initialFocus",
    "finalFocus",
    "unmountOnHide",
    "unstable_treeSnapshotKey"
  ]);
  const Y = Y5(), ie = Pt(null), G = W5({
    store: i || Y,
    open: h,
    setOpen(Mt) {
      if (Mt)
        return;
      const fn = ie.current;
      if (!fn)
        return;
      const Sn = new Event("close", { bubbles: !1, cancelable: !0 });
      g && fn.addEventListener("close", g, { once: !0 }), fn.dispatchEvent(Sn), Sn.defaultPrevented && G.setOpen(!0);
    }
  }), { portalRef: pe, domReady: J } = Zx(b, z.portalRef), me = z.preserveTabOrder, oe = G.useState(
    (Mt) => me && !S && Mt.mounted
  ), ge = Na(z.id), ce = G.useState("open"), Se = G.useState("mounted"), Re = G.useState("contentElement"), _e = G4(Se, z.hidden, z.alwaysVisible);
  EZ(Re, ge, j && !_e), xZ(G, T, J);
  const { wrapElement: Ye, nestedDialogs: ue } = pZ(G);
  z = Bn(z, Ye, [Ye]), Ln(() => {
    if (!ce)
      return;
    const Mt = ie.current, fn = yf(Mt, !0);
    fn && fn.tagName !== "BODY" && (Mt && pa(Mt, fn) || G.setDisclosureElement(fn));
  }, [G, ce]), V_ && wt(() => {
    if (!Se)
      return;
    const { disclosureElement: Mt } = G.getState();
    if (!Mt || !N0(Mt))
      return;
    const fn = () => {
      let Sn = !1;
      const jt = () => {
        Sn = !0;
      }, On = { capture: !0, once: !0 };
      Mt.addEventListener("focusin", jt, On), D2(Mt, "mouseup", () => {
        Mt.removeEventListener("focusin", jt, !0), !Sn && EE(Mt);
      });
    };
    return Mt.addEventListener("mousedown", fn), () => {
      Mt.removeEventListener("mousedown", fn);
    };
  }, [G, Se]), wt(() => {
    if (!S || !Se || !J)
      return;
    const Mt = ie.current;
    if (!(!Mt || Mt.querySelector("[data-dialog-dismiss]")))
      return SZ(Mt, G.hide);
  }, [G, S, Se, J]), Ln(() => {
    if (!aM() || ce || !Se || !J)
      return;
    const Mt = ie.current;
    if (Mt)
      return oM(Mt);
  }, [ce, Se, J]);
  const Ae = ce && J;
  Ln(() => {
    if (!ge || !Ae)
      return;
    const Mt = ie.current;
    return cZ(ge, [Mt]);
  }, [ge, Ae, W]);
  const Pe = nt(A);
  Ln(() => {
    if (!ge || !Ae)
      return;
    const { disclosureElement: Mt } = G.getState(), fn = ie.current, Sn = Pe() || [], jt = [
      fn,
      ...Sn,
      ...ue.map((On) => On.getState().contentElement)
    ];
    return S ? xl(
      P_(ge, jt),
      bZ(ge, jt)
    ) : P_(ge, [Mt, ...jt]);
  }, [
    ge,
    G,
    Ae,
    Pe,
    ue,
    S,
    W
  ]);
  const dt = !!I, Ze = rr(I), [qe, Je] = Kt(!1);
  wt(() => {
    if (!ce || !dt || !J || !(Re != null && Re.isConnected))
      return;
    const Mt = F_(N, !0) || // If no initial focus is specified, we try to focus the first element
    // with the autofocus attribute. If it's an Ariakit component, the
    // Focusable component will consume the autoFocus prop and add the
    // data-autofocus attribute to the element instead.
    Re.querySelector(
      "[data-autofocus=true],[autofocus]"
    ) || // We have to fallback to the first focusable element otherwise portaled
    // dialogs with preserveTabOrder set to true will not receive focus
    // properly because the elements aren't tabbable until the dialog receives
    // focus.
    H5(Re, !0, b && oe) || // Finally, we fallback to the dialog element itself.
    Re, fn = Z0(Mt);
    Ze(fn ? Mt : null) && (Je(!0), queueMicrotask(() => {
      Mt.focus(), V_ && Mt.scrollIntoView({ block: "nearest", inline: "nearest" });
    }));
  }, [
    ce,
    dt,
    J,
    Re,
    N,
    b,
    oe,
    Ze
  ]);
  const ot = !!Z, Nt = rr(Z), [Tn, Qt] = Kt(!1);
  wt(() => {
    if (ce)
      return Qt(!0), () => Qt(!1);
  }, [ce]);
  const Hn = Pr(
    (Mt, fn = !0) => {
      const { disclosureElement: Sn } = G.getState();
      if (LZ(Mt))
        return;
      let jt = F_(B) || Sn;
      if (jt != null && jt.id) {
        const Gr = aa(jt), Ge = `[aria-activedescendant="${jt.id}"]`, $t = Gr.querySelector(Ge);
        $t && (jt = $t);
      }
      if (jt && !Z0(jt)) {
        const Gr = cE(jt, "[data-dialog]");
        if (Gr && Gr.id) {
          const Ge = aa(Gr), $t = `[aria-controls~="${Gr.id}"]`, Cn = Ge.querySelector($t);
          Cn && (jt = Cn);
        }
      }
      const On = jt && Z0(jt);
      if (!On && fn) {
        requestAnimationFrame(() => Hn(Mt, !1));
        return;
      }
      Nt(On ? jt : null) && On && (jt == null || jt.focus());
    },
    [G, B, Nt]
  ), ar = Pt(!1);
  Ln(() => {
    if (ce || !Tn || !ot)
      return;
    const Mt = ie.current;
    ar.current = !0, Hn(Mt);
  }, [ce, Tn, J, ot, Hn]), wt(() => {
    if (!Tn || !ot)
      return;
    const Mt = ie.current;
    return () => {
      if (ar.current) {
        ar.current = !1;
        return;
      }
      Hn(Mt);
    };
  }, [Tn, ot, Hn]);
  const Wn = rr(D);
  wt(() => !J || !Se ? void 0 : Go("keydown", (fn) => {
    if (fn.key !== "Escape" || fn.defaultPrevented)
      return;
    const Sn = ie.current;
    if (!Sn || r8(Sn))
      return;
    const jt = fn.target;
    if (!jt)
      return;
    const { disclosureElement: On } = G.getState();
    !!(jt.tagName === "BODY" || pa(Sn, jt) || !On || pa(On, jt)) && Wn(fn) && G.hide();
  }, !0), [G, J, Se, Wn]), z = Bn(
    z,
    (Mt) => /* @__PURE__ */ d.jsx(lM, { level: S ? 1 : void 0, children: Mt }),
    [S]
  );
  const zn = z.hidden, qn = z.alwaysVisible;
  z = Bn(
    z,
    (Mt) => R ? /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
      /* @__PURE__ */ d.jsx(
        vZ,
        {
          store: G,
          backdrop: R,
          hidden: zn,
          alwaysVisible: qn
        }
      ),
      Mt
    ] }) : Mt,
    [G, R, zn, qn]
  );
  const [Gn, wr] = Kt(), [Ta, jr] = Kt();
  return z = Bn(
    z,
    (Mt) => /* @__PURE__ */ d.jsx(e8, { value: G, children: /* @__PURE__ */ d.jsx(KE.Provider, { value: wr, children: /* @__PURE__ */ d.jsx(QE.Provider, { value: jr, children: Mt }) }) }),
    [G]
  ), z = De(Q({
    id: ge,
    "data-dialog": "",
    role: "dialog",
    tabIndex: m ? -1 : void 0,
    "aria-labelledby": Gn,
    "aria-describedby": Ta
  }, z), {
    ref: In(ie, z.ref)
  }), z = iM(De(Q({}, z), {
    autoFocusOnShow: qe
  })), z = $5(Q({ store: G }, z)), z = H2(De(Q({}, z), { focusable: m })), z = uM(De(Q({ portal: b }, z), { portalRef: pe, preserveTabOrder: oe })), z;
});
function N2(e, n = Y5) {
  return ke(function(i) {
    const h = n(), g = i.store || h;
    return Ia(
      g,
      (S) => !i.unmountOnHide || (S == null ? void 0 : S.mounted) || !!i.open
    ) ? /* @__PURE__ */ d.jsx(e, Q({}, i)) : null;
  });
}
var cM = N2(
  ke(function(n) {
    const a = sM(n);
    return Ie(kZ, a);
  }),
  Y5
);
function fM(e = {}) {
  const n = W5(e);
  return /* @__PURE__ */ d.jsx(GE, { value: n, children: e.children });
}
var IZ = "p", dM = He(function(n) {
  var a = n, i = Ue(a, ["store"]);
  const h = Qo(QE), g = Na(i.id);
  return Ln(() => (h == null || h(g), () => h == null ? void 0 : h(void 0)), [h, g]), i = Q({
    id: g
  }, i), Pa(i);
}), HZ = ke(function(n) {
  const a = dM(n);
  return Ie(IZ, a);
}), ZZ = "button", z5 = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = Y5();
    i = i || g, Ht(
      i,
      process.env.NODE_ENV !== "production" && "DialogDisclosure must receive a `store` prop or be wrapped in a DialogProvider component."
    );
    const m = i.useState("contentElement");
    return h = Q({
      "aria-haspopup": sh(m, "dialog")
    }, h), h = zE(Q({ store: i }, h)), h;
  }
), PZ = ke(function(n) {
  const a = z5(n);
  return Ie(ZZ, a);
}), NZ = "button", hM = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = QH();
    i = i || g;
    const m = h.onClick, S = nt((R) => {
      m == null || m(R), !R.defaultPrevented && (i == null || i.hide());
    }), b = qr(
      () => /* @__PURE__ */ d.jsxs(
        "svg",
        {
          "aria-label": "Dismiss popup",
          display: "block",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          viewBox: "0 0 16 16",
          height: "1em",
          width: "1em",
          children: [
            /* @__PURE__ */ d.jsx("line", { x1: "4", y1: "4", x2: "12", y2: "12" }),
            /* @__PURE__ */ d.jsx("line", { x1: "4", y1: "12", x2: "12", y2: "4" })
          ]
        }
      ),
      []
    );
    return h = De(Q({
      "data-dialog-dismiss": "",
      children: b
    }, h), {
      onClick: S
    }), h = hh(h), h;
  }
), VZ = ke(function(n) {
  const a = hM(n);
  return Ie(NZ, a);
}), FZ = "h1", vM = He(
  function(n) {
    const a = Pt(null), i = Qo(nx) || 1, h = `h${i}`, g = ch(a, h), m = qr(
      () => !!g && /^h\d$/.test(g),
      [g]
    );
    return n = De(Q({
      render: /* @__PURE__ */ d.jsx(h, {}),
      role: m ? void 0 : "heading",
      "aria-level": m ? void 0 : i
    }, n), {
      ref: In(a, n.ref)
    }), n;
  }
), BZ = ke(function(n) {
  const a = vM(n);
  return Ie(FZ, a);
}), UZ = "h1", pM = He(
  function(n) {
    var a = n, i = Ue(a, ["store"]);
    const h = Qo(KE), g = Na(i.id);
    return Ln(() => (h == null || h(g), () => h == null ? void 0 : h(void 0)), [h, g]), i = Q({
      id: g
    }, i), i = vM(i), i;
  }
), YZ = ke(function(n) {
  const a = pM(n);
  return Ie(UZ, a);
});
function mM(e) {
  return Array.isArray(e) ? e : typeof e < "u" ? [e] : [];
}
function ax(e) {
  const n = [];
  for (const a of e)
    n.push(...a);
  return n;
}
function D4(e) {
  return e.slice().reverse();
}
var $Z = { id: null };
function I0(e, n) {
  return e.find((a) => n ? !a.disabled && a.id !== n : !a.disabled);
}
function WZ(e, n) {
  return e.filter((a) => n ? !a.disabled && a.id !== n : !a.disabled);
}
function zZ(e) {
  if (e === "vertical")
    return "horizontal";
  if (e === "horizontal")
    return "vertical";
}
function B_(e, n) {
  return e.filter((a) => a.rowId === n);
}
function qZ(e, n, a = !1) {
  const i = e.findIndex((h) => h.id === n);
  return [
    ...e.slice(i + 1),
    ...a ? [$Z] : [],
    ...e.slice(0, i)
  ];
}
function ox(e) {
  const n = [];
  for (const a of e) {
    const i = n.find((h) => {
      var g;
      return ((g = h[0]) == null ? void 0 : g.rowId) === a.rowId;
    });
    i ? i.push(a) : n.push([a]);
  }
  return n;
}
function gM(e) {
  let n = 0;
  for (const { length: a } of e)
    a > n && (n = a);
  return n;
}
function GZ(e) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: !0,
    rowId: e
  };
}
function U_(e, n, a) {
  const i = gM(e);
  for (const h of e)
    for (let g = 0; g < i; g += 1) {
      const m = h[g];
      if (!m || a && m.disabled) {
        const b = g === 0 && a ? I0(h) : h[g - 1];
        h[g] = b && n !== b.id && a ? b : GZ(b == null ? void 0 : b.rowId);
      }
    }
  return e;
}
function Y_(e) {
  const n = ox(e), a = gM(n), i = [];
  for (let h = 0; h < a; h += 1)
    for (const g of n) {
      const m = g[h];
      m && i.push(pn(Ct({}, m), {
        // If there's no rowId, it means that it's not a grid composite, but
        // a single row instead. So, instead of verticalizing it, that is,
        // assigning a different rowId based on the column index, we keep it
        // undefined so they will be part of the same row. This is useful
        // when using up/down on one-dimensional composites.
        rowId: m.rowId ? `${h}` : void 0
      }));
    }
  return i;
}
function ph(e = {}) {
  var n;
  const a = (n = e.store) == null ? void 0 : n.getState(), i = L5(e), h = ht(
    e.activeId,
    a == null ? void 0 : a.activeId,
    e.defaultActiveId
  ), g = pn(Ct({}, i.getState()), {
    activeId: h,
    baseElement: ht(a == null ? void 0 : a.baseElement, null),
    includesBaseElement: ht(
      e.includesBaseElement,
      a == null ? void 0 : a.includesBaseElement,
      h === null
    ),
    moves: ht(a == null ? void 0 : a.moves, 0),
    orientation: ht(
      e.orientation,
      a == null ? void 0 : a.orientation,
      "both"
    ),
    rtl: ht(e.rtl, a == null ? void 0 : a.rtl, !1),
    virtualFocus: ht(
      e.virtualFocus,
      a == null ? void 0 : a.virtualFocus,
      !1
    ),
    focusLoop: ht(e.focusLoop, a == null ? void 0 : a.focusLoop, !1),
    focusWrap: ht(e.focusWrap, a == null ? void 0 : a.focusWrap, !1),
    focusShift: ht(e.focusShift, a == null ? void 0 : a.focusShift, !1)
  }), m = ho(g, i, e.store);
  Ha(
    m,
    () => Ea(m, ["renderedItems", "activeId"], (b) => {
      m.setState("activeId", (R) => {
        var D;
        return R !== void 0 ? R : (D = I0(b.renderedItems)) == null ? void 0 : D.id;
      });
    })
  );
  const S = (b, R, D, T) => {
    var A, j;
    const { activeId: I, rtl: Z, focusLoop: N, focusWrap: B, includesBaseElement: $ } = m.getState(), Y = Z && R !== "vertical" ? D4(b) : b;
    if (I == null)
      return (A = I0(Y)) == null ? void 0 : A.id;
    const ie = Y.find((Re) => Re.id === I);
    if (!ie)
      return (j = I0(Y)) == null ? void 0 : j.id;
    const G = !!ie.rowId, pe = Y.indexOf(ie), J = Y.slice(pe + 1), me = B_(J, ie.rowId);
    if (T !== void 0) {
      const Re = WZ(me, I), _e = Re.slice(T)[0] || // If we can't find an item, just return the last one.
      Re[Re.length - 1];
      return _e == null ? void 0 : _e.id;
    }
    const oe = zZ(
      // If it's a grid and orientation is not set, it's a next/previous call,
      // which is inherently horizontal. up/down will call next with orientation
      // set to vertical by default (see below on up/down methods).
      G ? R || "horizontal" : R
    ), ge = N && N !== oe, ce = G && B && B !== oe;
    if (D = D || !G && ge && $, ge) {
      const Re = ce && !D ? Y : B_(Y, ie.rowId), _e = qZ(Re, I, D), Ye = I0(_e, I);
      return Ye == null ? void 0 : Ye.id;
    }
    if (ce) {
      const Re = I0(
        // We can use nextItems, which contains all the next items, including
        // items from other rows, to wrap between rows. However, if there is a
        // null item (the composite container), we'll only use the next items in
        // the row. So moving next from the last item will focus on the
        // composite container. On grid composites, horizontal navigation never
        // focuses on the composite container, only vertical.
        D ? me : J,
        I
      );
      return D ? (Re == null ? void 0 : Re.id) || null : Re == null ? void 0 : Re.id;
    }
    const Se = I0(me, I);
    return !Se && D ? null : Se == null ? void 0 : Se.id;
  };
  return pn(Ct(Ct({}, i), m), {
    setBaseElement: (b) => m.setState("baseElement", b),
    setActiveId: (b) => m.setState("activeId", b),
    move: (b) => {
      b !== void 0 && (m.setState("activeId", b), m.setState("moves", (R) => R + 1));
    },
    first: () => {
      var b;
      return (b = I0(m.getState().renderedItems)) == null ? void 0 : b.id;
    },
    last: () => {
      var b;
      return (b = I0(D4(m.getState().renderedItems))) == null ? void 0 : b.id;
    },
    next: (b) => {
      const { renderedItems: R, orientation: D } = m.getState();
      return S(R, D, !1, b);
    },
    previous: (b) => {
      var R;
      const { renderedItems: D, orientation: T, includesBaseElement: A } = m.getState(), I = !!!((R = I0(D)) != null && R.rowId) && A;
      return S(
        D4(D),
        T,
        I,
        b
      );
    },
    down: (b) => {
      const {
        activeId: R,
        renderedItems: D,
        focusShift: T,
        focusLoop: A,
        includesBaseElement: j
      } = m.getState(), I = T && !b, Z = Y_(
        ax(
          U_(ox(D), R, I)
        )
      );
      return S(Z, "vertical", A && A !== "horizontal" && j, b);
    },
    up: (b) => {
      const { activeId: R, renderedItems: D, focusShift: T, includesBaseElement: A } = m.getState(), j = T && !b, I = Y_(
        D4(
          ax(
            U_(
              ox(D),
              R,
              j
            )
          )
        )
      );
      return S(I, "vertical", A, b);
    }
  });
}
function mh(e, n, a) {
  return e = Nx(e, n, a), lr(e, a, "activeId", "setActiveId"), lr(e, a, "includesBaseElement"), lr(e, a, "virtualFocus"), lr(e, a, "orientation"), lr(e, a, "rtl"), lr(e, a, "focusLoop"), lr(e, a, "focusWrap"), lr(e, a, "focusShift"), e;
}
function wM(e = {}) {
  const [n, a] = Ci(ph, e);
  return mh(n, a, e);
}
var KZ = "div";
function QZ(e) {
  return e.some((n) => !!n.rowId);
}
function XZ(e) {
  const n = e.target;
  return n && !yl(n) ? !1 : e.key.length === 1 && !e.ctrlKey && !e.metaKey;
}
function JZ(e) {
  return e.key === "Shift" || e.key === "Control" || e.key === "Alt" || e.key === "Meta";
}
function $_(e, n, a) {
  return nt((i) => {
    var h;
    if (n == null || n(i), i.defaultPrevented || i.isPropagationStopped() || !Si(i) || JZ(i) || XZ(i))
      return;
    const g = e.getState(), m = (h = Xd(e, g.activeId)) == null ? void 0 : h.element;
    if (!m)
      return;
    const S = i, b = Ue(S, ["view"]), R = a == null ? void 0 : a.current;
    m !== R && m.focus(), gL(m, i.type, b) || i.preventDefault(), i.currentTarget.contains(m) && i.stopPropagation();
  });
}
function eP(e) {
  return fH(
    ax(D4(dH(e)))
  );
}
function tP(e) {
  const [n, a] = Kt(!1), i = Pr(() => a(!0), []), h = e.useState(
    (g) => Xd(e, g.activeId)
  );
  return wt(() => {
    const g = h == null ? void 0 : h.element;
    n && g && (a(!1), g.focus({ preventScroll: !0 }));
  }, [h, n]), i;
}
var gh = He(
  function(n) {
    var a = n, {
      store: i,
      composite: h = !0,
      focusOnMove: g = h,
      moveOnKeyPress: m = !0
    } = a, S = Ue(a, [
      "store",
      "composite",
      "focusOnMove",
      "moveOnKeyPress"
    ]);
    const b = aH();
    i = i || b, Ht(
      i,
      process.env.NODE_ENV !== "production" && "Composite must receive a `store` prop or be wrapped in a CompositeProvider component."
    );
    const R = Pt(null), D = tP(i), T = i.useState("moves");
    wt(() => {
      var oe;
      if (!i || !T || !h || !g)
        return;
      const { activeId: ge } = i.getState(), ce = (oe = Xd(i, ge)) == null ? void 0 : oe.element;
      ce && zL(ce);
    }, [i, T, h, g]), Ln(() => {
      if (!i || !T || !h)
        return;
      const { baseElement: oe, activeId: ge } = i.getState();
      if (!(ge === null) || !oe)
        return;
      const Se = R.current;
      R.current = null, Se && Rp(Se, { relatedTarget: oe }), j2(oe) || oe.focus();
    }, [i, T, h]);
    const A = i.useState("activeId"), j = i.useState("virtualFocus");
    Ln(() => {
      var oe;
      if (!i || !h || !j)
        return;
      const ge = R.current;
      if (R.current = null, !ge)
        return;
      const Se = ((oe = Xd(i, A)) == null ? void 0 : oe.element) || yf(ge);
      Se !== ge && Rp(ge, { relatedTarget: Se });
    }, [i, A, j, h]);
    const I = $_(
      i,
      S.onKeyDownCapture,
      R
    ), Z = $_(
      i,
      S.onKeyUpCapture,
      R
    ), N = S.onFocusCapture, B = nt((oe) => {
      if (N == null || N(oe), oe.defaultPrevented || !i)
        return;
      const { virtualFocus: ge } = i.getState();
      if (!ge)
        return;
      const ce = oe.relatedTarget, Se = vH(oe.currentTarget);
      Si(oe) && Se && (oe.stopPropagation(), R.current = ce);
    }), $ = S.onFocus, W = nt((oe) => {
      if ($ == null || $(oe), oe.defaultPrevented || !h || !i)
        return;
      const { relatedTarget: ge } = oe, { virtualFocus: ce } = i.getState();
      ce ? Si(oe) && !k4(i, ge) && queueMicrotask(D) : Si(oe) && i.setActiveId(null);
    }), z = S.onBlurCapture, Y = nt((oe) => {
      var ge;
      if (z == null || z(oe), oe.defaultPrevented || !i)
        return;
      const { virtualFocus: ce, activeId: Se } = i.getState();
      if (!ce)
        return;
      const Re = (ge = Xd(i, Se)) == null ? void 0 : ge.element, _e = oe.relatedTarget, Ye = k4(i, _e), ue = R.current;
      R.current = null, Si(oe) && Ye ? (_e === Re ? ue && ue !== _e && Rp(ue, oe) : Re ? Rp(Re, oe) : ue && Rp(ue, oe), oe.stopPropagation()) : !k4(i, oe.target) && Re && Rp(Re, oe);
    }), ie = S.onKeyDown, G = rr(m), pe = nt((oe) => {
      var ge;
      if (ie == null || ie(oe), oe.defaultPrevented || !i || !Si(oe))
        return;
      const { orientation: ce, items: Se, renderedItems: Re, activeId: _e } = i.getState(), Ye = Xd(i, _e);
      if ((ge = Ye == null ? void 0 : Ye.element) != null && ge.isConnected)
        return;
      const ue = ce !== "horizontal", Ae = ce !== "vertical", Pe = QZ(Re);
      if ((oe.key === "ArrowLeft" || oe.key === "ArrowRight" || oe.key === "Home" || oe.key === "End") && yl(oe.currentTarget))
        return;
      const Je = {
        ArrowUp: (Pe || ue) && (() => {
          if (Pe) {
            const ot = Se && eP(Se);
            return ot == null ? void 0 : ot.id;
          }
          return i == null ? void 0 : i.last();
        }),
        ArrowRight: (Pe || Ae) && i.first,
        ArrowDown: (Pe || ue) && i.first,
        ArrowLeft: (Pe || Ae) && i.last,
        Home: i.first,
        End: i.last,
        PageUp: i.first,
        PageDown: i.last
      }[oe.key];
      if (Je) {
        const ot = Je();
        if (ot !== void 0) {
          if (!G(oe))
            return;
          oe.preventDefault(), i.move(ot);
        }
      }
    });
    S = Bn(
      S,
      (oe) => /* @__PURE__ */ d.jsx(B0, { value: i, children: oe }),
      [i]
    );
    const J = i.useState((oe) => {
      var ge;
      if (i && h && oe.virtualFocus)
        return (ge = Xd(i, oe.activeId)) == null ? void 0 : ge.id;
    });
    S = De(Q({
      "aria-activedescendant": J
    }, S), {
      ref: In(h ? i.setBaseElement : null, S.ref),
      onKeyDownCapture: I,
      onKeyUpCapture: Z,
      onFocusCapture: B,
      onFocus: W,
      onBlurCapture: Y,
      onKeyDown: pe
    });
    const me = i.useState(
      (oe) => h && (oe.virtualFocus || oe.activeId === null)
    );
    return S = H2(Q({ focusable: me }, S)), S;
  }
), nP = ke(function(n) {
  const a = gh(n);
  return Ie(KZ, a);
});
function rP(e = {}) {
  const n = wM(e);
  return /* @__PURE__ */ d.jsx(B0, { value: n, children: e.children });
}
var aP = "div", q5 = He(function(n) {
  var a = n, i = Ue(a, ["store"]);
  return i = qx(i), i;
}), oP = ke(function(n) {
  const a = q5(n);
  return Ie(aP, a);
}), iP = "div", G5 = He(
  function(n) {
    var a = n, i = Ue(a, ["store"]);
    return i = Gx(i), i;
  }
), lP = ke(function(n) {
  const a = G5(n);
  return Ie(iP, a);
}), uP = "div";
function yM(e) {
  const n = e.relatedTarget;
  return (n == null ? void 0 : n.nodeType) === Node.ELEMENT_NODE ? n : null;
}
function sP(e) {
  const n = yM(e);
  return n ? pa(e.currentTarget, n) : !1;
}
var ix = Symbol("composite-hover");
function cP(e) {
  let n = yM(e);
  if (!n)
    return !1;
  do {
    if (vf(n, ix) && n[ix])
      return !0;
    n = n.parentElement;
  } while (n);
  return !1;
}
var K5 = He(
  function(n) {
    var a = n, {
      store: i,
      focusOnHover: h = !0,
      blurOnHoverEnd: g = !!h
    } = a, m = Ue(a, [
      "store",
      "focusOnHover",
      "blurOnHoverEnd"
    ]);
    const S = Z2();
    i = i || S, Ht(
      i,
      process.env.NODE_ENV !== "production" && "CompositeHover must be wrapped in a Composite component."
    );
    const b = mE(), R = m.onMouseMove, D = rr(h), T = nt((N) => {
      if (R == null || R(N), !N.defaultPrevented && b() && D(N)) {
        if (!rh(N.currentTarget)) {
          const B = i == null ? void 0 : i.getState().baseElement;
          B && !j2(B) && B.focus();
        }
        i == null || i.setActiveId(N.currentTarget.id);
      }
    }), A = m.onMouseLeave, j = rr(g), I = nt((N) => {
      var B;
      A == null || A(N), !N.defaultPrevented && b() && (sP(N) || cP(N) || D(N) && j(N) && (i == null || i.setActiveId(null), (B = i == null ? void 0 : i.getState().baseElement) == null || B.focus()));
    }), Z = Pr((N) => {
      N && (N[ix] = !0);
    }, []);
    return m = De(Q({}, m), {
      ref: In(Z, m.ref),
      onMouseMove: T,
      onMouseLeave: I
    }), Pa(m);
  }
), fP = Va(
  ke(function(n) {
    const a = K5(n);
    return Ie(uP, a);
  })
), dP = "div", a8 = He(
  function(n) {
    var a = n, {
      store: i,
      "aria-setsize": h,
      "aria-posinset": g
    } = a, m = Ue(a, [
      "store",
      "aria-setsize",
      "aria-posinset"
    ]);
    const S = Z2();
    i = i || S, Ht(
      i,
      process.env.NODE_ENV !== "production" && "CompositeRow must be wrapped in a Composite component."
    );
    const b = Na(m.id), R = i.useState(
      (T) => T.baseElement || void 0
    ), D = qr(
      () => ({ id: b, baseElement: R, ariaSetSize: h, ariaPosInSet: g }),
      [b, R, h, g]
    );
    return m = Bn(
      m,
      (T) => /* @__PURE__ */ d.jsx(PE.Provider, { value: D, children: T }),
      [D]
    ), m = Q({ id: b }, m), Pa(m);
  }
), hP = ke(function(n) {
  const a = a8(n);
  return Ie(dP, a);
}), vP = "hr", xM = He(
  function(n) {
    var a = n, { orientation: i = "horizontal" } = a, h = Ue(a, ["orientation"]);
    return h = Q({
      role: "separator",
      "aria-orientation": i
    }, h), h;
  }
), pP = ke(function(n) {
  const a = xM(n);
  return Ie(vP, a);
}), mP = "hr", Q4 = He(function(n) {
  var a = n, { store: i } = a, h = Ue(a, ["store"]);
  const g = Z2();
  i = i || g, Ht(
    i,
    process.env.NODE_ENV !== "production" && "CompositeSeparator must be wrapped in a Composite component."
  );
  const m = i.useState(
    (S) => S.orientation === "horizontal" ? "vertical" : "horizontal"
  );
  return h = xM(De(Q({}, h), { orientation: m })), h;
}), gP = ke(function(n) {
  const a = Q4(n);
  return Ie(mP, a);
}), wP = "div", cf = "";
function A9() {
  cf = "";
}
function yP(e) {
  const n = e.target;
  return n && yl(n) ? !1 : e.key === " " && cf.length ? !0 : e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey && /^[\p{Letter}\p{Number}]$/u.test(e.key);
}
function xP(e, n) {
  if (Si(e))
    return !0;
  const a = e.target;
  return a ? n.some((h) => h.element === a) : !1;
}
function SP(e) {
  return e.filter((n) => !n.disabled);
}
function l5(e, n) {
  var a;
  const i = ((a = e.element) == null ? void 0 : a.textContent) || e.children || // The composite item object itself doesn't include a value property, but
  // other components like Select do. Since CompositeTypeahead is a generic
  // component that can be used with those as well, we also consider the value
  // property as a fallback for the typeahead text content.
  "value" in e && e.value;
  return i ? Mx(i).trim().toLowerCase().startsWith(n.toLowerCase()) : !1;
}
function CP(e, n, a) {
  if (!a)
    return e;
  const i = e.find((h) => h.id === a);
  return !i || !l5(i, n) || cf !== n && l5(i, cf) ? e : (cf = n, cH(
    e.filter((h) => l5(h, cf)),
    a
  ).filter((h) => h.id !== a));
}
var X4 = He(function(n) {
  var a = n, { store: i, typeahead: h = !0 } = a, g = Ue(a, ["store", "typeahead"]);
  const m = Z2();
  i = i || m, Ht(
    i,
    process.env.NODE_ENV !== "production" && "CompositeTypeahead must be a Composite component"
  );
  const S = g.onKeyDownCapture, b = Pt(0), R = nt((D) => {
    if (S == null || S(D), D.defaultPrevented || !h || !i)
      return;
    const { renderedItems: T, items: A, activeId: j } = i.getState();
    if (!yP(D))
      return A9();
    let I = SP(
      T.length ? T : A
    );
    if (!xP(D, I))
      return A9();
    D.preventDefault(), window.clearTimeout(b.current), b.current = window.setTimeout(() => {
      cf = "";
    }, 500);
    const Z = D.key.toLowerCase();
    cf += Z, I = CP(I, Z, j);
    const N = I.find((B) => l5(B, cf));
    N ? i.move(N.id) : A9();
  });
  return g = De(Q({}, g), {
    onKeyDownCapture: R
  }), Pa(g);
}), bP = ke(function(n) {
  const a = X4(n);
  return Ie(wP, a);
});
Za(null);
Za(
  null
);
var _P = bi(
  [B0],
  [vh]
), RP = _P.useContext;
function Q5(e = {}) {
  var n = e, {
    popover: a
  } = n, i = Fp(n, [
    "popover"
  ]);
  const h = Up(
    i.store,
    Pp(a, [
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    ])
  );
  fh(i, h);
  const g = h == null ? void 0 : h.getState(), m = eM(pn(Ct({}, i), { store: h })), S = ht(
    i.placement,
    g == null ? void 0 : g.placement,
    "bottom"
  ), b = pn(Ct({}, m.getState()), {
    placement: S,
    currentPlacement: S,
    anchorElement: ht(g == null ? void 0 : g.anchorElement, null),
    popoverElement: ht(g == null ? void 0 : g.popoverElement, null),
    arrowElement: ht(g == null ? void 0 : g.arrowElement, null),
    rendered: Symbol("rendered")
  }), R = ho(b, m, h);
  return pn(Ct(Ct({}, m), R), {
    setAnchorElement: (D) => R.setState("anchorElement", D),
    setPopoverElement: (D) => R.setState("popoverElement", D),
    setArrowElement: (D) => R.setState("arrowElement", D),
    render: () => R.setState("rendered", Symbol("rendered"))
  });
}
function X5(e, n, a) {
  return R1(n, [a.popover]), lr(e, a, "placement"), tM(e, n, a);
}
function o8(e = {}) {
  const [n, a] = Ci(Q5, e);
  return X5(n, a, e);
}
var EP = kx() && matchMedia("(hover:none)").matches;
function MP(e = {}) {
  var n = e, {
    tag: a
  } = n, i = Fp(n, [
    "tag"
  ]);
  const h = Up(i.store, wE(a, ["value", "rtl"]));
  fh(i, h);
  const g = a == null ? void 0 : a.getState(), m = h == null ? void 0 : h.getState(), S = ht(
    i.activeId,
    m == null ? void 0 : m.activeId,
    i.defaultActiveId,
    null
  ), b = ph(pn(Ct({}, i), {
    activeId: S,
    includesBaseElement: ht(
      i.includesBaseElement,
      m == null ? void 0 : m.includesBaseElement,
      !0
    ),
    orientation: ht(
      i.orientation,
      m == null ? void 0 : m.orientation,
      "vertical"
    ),
    focusLoop: ht(i.focusLoop, m == null ? void 0 : m.focusLoop, !0),
    focusWrap: ht(i.focusWrap, m == null ? void 0 : m.focusWrap, !0),
    virtualFocus: ht(
      i.virtualFocus,
      m == null ? void 0 : m.virtualFocus,
      !EP
    )
  })), R = Q5(pn(Ct({}, i), {
    placement: ht(
      i.placement,
      m == null ? void 0 : m.placement,
      "bottom-start"
    )
  })), D = ht(
    i.value,
    m == null ? void 0 : m.value,
    i.defaultValue,
    ""
  ), T = ht(
    i.selectedValue,
    m == null ? void 0 : m.selectedValue,
    g == null ? void 0 : g.values,
    i.defaultSelectedValue,
    ""
  ), A = Array.isArray(T), j = pn(Ct(Ct({}, b.getState()), R.getState()), {
    value: D,
    selectedValue: T,
    resetValueOnSelect: ht(
      i.resetValueOnSelect,
      m == null ? void 0 : m.resetValueOnSelect,
      A
    ),
    resetValueOnHide: ht(
      i.resetValueOnHide,
      m == null ? void 0 : m.resetValueOnHide,
      A && !a
    ),
    activeValue: m == null ? void 0 : m.activeValue
  }), I = ho(j, b, R, h);
  return Ha(I, () => {
    if (a)
      return xl(
        Ea(I, ["selectedValue"], (Z) => {
          Array.isArray(Z.selectedValue) && a.setValues(Z.selectedValue);
        }),
        Ea(a, ["values"], (Z) => {
          I.setState("selectedValue", Z.values);
        })
      );
  }), Ha(
    I,
    () => Ea(I, ["resetValueOnHide", "mounted"], (Z) => {
      Z.resetValueOnHide && (Z.mounted || I.setState("value", D));
    })
  ), Ha(
    I,
    () => A2(I, ["mounted"], (Z) => {
      Z.mounted || (I.setState("activeId", S), I.setState("moves", 0));
    })
  ), Ha(
    I,
    () => Ea(I, ["moves", "activeId"], (Z, N) => {
      Z.moves === N.moves && I.setState("activeValue", void 0);
    })
  ), Ha(
    I,
    () => A2(I, ["moves", "renderedItems"], (Z, N) => {
      if (Z.moves === N.moves)
        return;
      const { activeId: B } = I.getState(), $ = b.item(B);
      I.setState("activeValue", $ == null ? void 0 : $.value);
    })
  ), pn(Ct(Ct(Ct({}, R), b), I), {
    tag: a,
    setValue: (Z) => I.setState("value", Z),
    resetValue: () => I.setState("value", j.value),
    setSelectedValue: (Z) => I.setState("selectedValue", Z)
  });
}
function TP(e, n, a) {
  return R1(n, [a.tag]), lr(e, a, "value", "setValue"), lr(e, a, "selectedValue", "setSelectedValue"), lr(e, a, "resetValueOnHide"), lr(e, a, "resetValueOnSelect"), Object.assign(
    mh(
      X5(e, n, a),
      n,
      a
    ),
    { tag: a.tag }
  );
}
function J4(e = {}) {
  const n = RP();
  e = De(Q({}, e), {
    tag: e.tag !== void 0 ? e.tag : n
  });
  const [a, i] = Ci(MP, e);
  return TP(a, i, e);
}
var e3 = bi(
  [GE],
  [e8]
), wh = e3.useContext, OP = e3.useScopedContext, J5 = e3.useProviderContext, ew = e3.ContextProvider, t3 = e3.ScopedContextProvider, SM = Za(
  void 0
), n3 = bi(
  [ew, B0],
  [t3, vh]
), i8 = n3.useContext, $p = n3.useScopedContext, yh = n3.useProviderContext, DP = n3.ContextProvider, AP = n3.ScopedContextProvider, CM = Za(
  void 0
), bM = Za(!1), jP = "div", l8 = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = J5();
    return i = i || g, h = De(Q({}, h), {
      ref: In(i == null ? void 0 : i.setAnchorElement, h.ref)
    }), h;
  }
), kP = ke(function(n) {
  const a = l8(n);
  return Ie(jP, a);
}), LP = "input";
function W_(e, n, a) {
  if (!a)
    return !1;
  const i = e.find((h) => !h.disabled && h.value);
  return (i == null ? void 0 : i.value) === n;
}
function z_(e, n) {
  return !n || e == null ? !1 : (e = Mx(e), n.length > e.length && n.toLowerCase().indexOf(e.toLowerCase()) === 0);
}
function IP(e) {
  return e.type === "input";
}
function HP(e) {
  return e === "inline" || e === "list" || e === "both" || e === "none";
}
function ZP(e) {
  const n = e.find((a) => {
    var i;
    return a.disabled ? !1 : ((i = a.element) == null ? void 0 : i.getAttribute("role")) !== "tab";
  });
  return n == null ? void 0 : n.id;
}
var PP = He(
  function(n) {
    var a = n, {
      store: i,
      focusable: h = !0,
      autoSelect: g = !1,
      getAutoSelectId: m,
      setValueOnChange: S,
      showMinLength: b = 0,
      showOnChange: R,
      showOnMouseDown: D,
      showOnClick: T = D,
      showOnKeyDown: A,
      showOnKeyPress: j = A,
      blurActiveItemOnClick: I,
      setValueOnClick: Z = !0,
      moveOnKeyPress: N = !0,
      autoComplete: B = "list"
    } = a, $ = Ue(a, [
      "store",
      "focusable",
      "autoSelect",
      "getAutoSelectId",
      "setValueOnChange",
      "showMinLength",
      "showOnChange",
      "showOnMouseDown",
      "showOnClick",
      "showOnKeyDown",
      "showOnKeyPress",
      "blurActiveItemOnClick",
      "setValueOnClick",
      "moveOnKeyPress",
      "autoComplete"
    ]);
    const W = yh();
    i = i || W, Ht(
      i,
      process.env.NODE_ENV !== "production" && "Combobox must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const z = Pt(null), [Y, ie] = j5(), G = Pt(!1), pe = Pt(!1), J = i.useState(
      (Ge) => Ge.virtualFocus && g
    ), me = B === "inline" || B === "both", [oe, ge] = Kt(me);
    wL(() => {
      me && ge(!0);
    }, [me]);
    const ce = i.useState("value"), Se = Pt();
    wt(() => Ea(i, ["selectedValue", "activeId"], (Ge, $t) => {
      Se.current = $t.selectedValue;
    }), []);
    const Re = i.useState((Ge) => {
      var $t;
      if (me && oe && !(Ge.activeValue && Array.isArray(Ge.selectedValue) && (Ge.selectedValue.includes(Ge.activeValue) || ($t = Se.current) != null && $t.includes(Ge.activeValue))))
        return Ge.activeValue;
    }), _e = i.useState("renderedItems"), Ye = i.useState("open"), ue = i.useState("contentElement"), Ae = qr(() => {
      if (!me || !oe)
        return ce;
      if (W_(
        _e,
        Re,
        J
      )) {
        if (z_(ce, Re)) {
          const $t = (Re == null ? void 0 : Re.slice(ce.length)) || "";
          return ce + $t;
        }
        return ce;
      }
      return Re || ce;
    }, [me, oe, _e, Re, J, ce]);
    wt(() => {
      const Ge = z.current;
      if (!Ge)
        return;
      const $t = () => ge(!0);
      return Ge.addEventListener("combobox-item-move", $t), () => {
        Ge.removeEventListener("combobox-item-move", $t);
      };
    }, []), wt(() => {
      if (!me || !oe || !Re || !W_(
        _e,
        Re,
        J
      ) || !z_(ce, Re))
        return;
      let $t = A4;
      return queueMicrotask(() => {
        const Cn = z.current;
        if (!Cn)
          return;
        const { start: gn, end: cr } = z9(Cn), Qe = ce.length, at = Re.length;
        x9(Cn, Qe, at), $t = () => {
          if (!j2(Cn))
            return;
          const { start: Lt, end: Un } = z9(Cn);
          Lt === Qe && Un === at && x9(Cn, gn, cr);
        };
      }), () => $t();
    }, [
      Y,
      me,
      oe,
      Re,
      _e,
      J,
      ce
    ]);
    const Pe = Pt(null), dt = nt(m), Ze = Pt(null);
    wt(() => {
      if (!Ye || !ue)
        return;
      const Ge = Ax(ue);
      if (!Ge)
        return;
      Pe.current = Ge;
      const $t = () => {
        G.current = !1;
      }, Cn = () => {
        if (!i || !G.current)
          return;
        const { activeId: cr } = i.getState();
        cr !== null && cr !== Ze.current && (G.current = !1);
      }, gn = { passive: !0, capture: !0 };
      return Ge.addEventListener("wheel", $t, gn), Ge.addEventListener("scroll", Cn, gn), () => {
        Ge.removeEventListener("wheel", $t, !0), Ge.removeEventListener("scroll", Cn, !0);
      };
    }, [Ye, ue, i]), Ln(() => {
      ce && (pe.current || (G.current = !0));
    }, [ce]), Ln(() => {
      J !== "always" && Ye || (G.current = Ye);
    }, [J, Ye]);
    const qe = i.useState("resetValueOnSelect");
    R1(() => {
      var Ge, $t;
      const Cn = G.current;
      if (!i || !Ye || (!J || !Cn) && !qe)
        return;
      const { baseElement: gn, contentElement: cr, activeId: Qe } = i.getState();
      if (!(gn && !j2(gn))) {
        if (cr != null && cr.hasAttribute("data-placing")) {
          const at = new MutationObserver(ie);
          return at.observe(cr, { attributeFilter: ["data-placing"] }), () => at.disconnect();
        }
        if (J && Cn) {
          const at = dt(_e), Lt = at !== void 0 ? at : (Ge = ZP(_e)) != null ? Ge : i.first();
          Ze.current = Lt, i.move(Lt ?? null);
        } else {
          const at = ($t = i.item(Qe)) == null ? void 0 : $t.element;
          at && "scrollIntoView" in at && at.scrollIntoView({ block: "nearest", inline: "nearest" });
        }
      }
    }, [
      i,
      Ye,
      Y,
      ce,
      J,
      qe,
      dt,
      _e
    ]), wt(() => {
      if (!me)
        return;
      const Ge = z.current;
      if (!Ge)
        return;
      const $t = [Ge, ue].filter(
        (gn) => !!gn
      ), Cn = (gn) => {
        $t.every((cr) => Qd(gn, cr)) && (i == null || i.setValue(Ae));
      };
      return $t.forEach((gn) => gn.addEventListener("focusout", Cn)), () => {
        $t.forEach((gn) => gn.removeEventListener("focusout", Cn));
      };
    }, [me, ue, i, Ae]);
    const Je = (Ge) => Ge.currentTarget.value.length >= b, ot = $.onChange, Nt = rr(R ?? Je), Tn = rr(
      // If the combobox is combined with tags, the value will be set by the tag
      // input component.
      S ?? !i.tag
    ), Qt = nt((Ge) => {
      if (ot == null || ot(Ge), Ge.defaultPrevented || !i)
        return;
      const $t = Ge.currentTarget, { value: Cn, selectionStart: gn, selectionEnd: cr } = $t, Qe = Ge.nativeEvent;
      if (G.current = !0, IP(Qe) && (Qe.isComposing && (G.current = !1, pe.current = !0), me)) {
        const at = Qe.inputType === "insertText" || Qe.inputType === "insertCompositionText", Lt = gn === Cn.length;
        ge(at && Lt);
      }
      if (Tn(Ge)) {
        const at = Cn === i.getState().value;
        i.setValue(Cn), queueMicrotask(() => {
          x9($t, gn, cr);
        }), me && J && at && ie();
      }
      Nt(Ge) && i.show(), (!J || !G.current) && i.setActiveId(null);
    }), Hn = $.onCompositionEnd, ar = nt((Ge) => {
      G.current = !0, pe.current = !1, Hn == null || Hn(Ge), !Ge.defaultPrevented && J && ie();
    }), Wn = $.onMouseDown, zn = rr(
      I ?? (() => !!(i != null && i.getState().includesBaseElement))
    ), qn = rr(Z), Gn = rr(T ?? Je), wr = nt((Ge) => {
      Wn == null || Wn(Ge), !Ge.defaultPrevented && (Ge.button || Ge.ctrlKey || i && (zn(Ge) && i.setActiveId(null), qn(Ge) && i.setValue(Ae), Gn(Ge) && D2(Ge.currentTarget, "mouseup", i.show)));
    }), Ta = $.onKeyDown, jr = rr(j ?? Je), Mt = nt((Ge) => {
      if (Ta == null || Ta(Ge), Ge.repeat || (G.current = !1), Ge.defaultPrevented || Ge.ctrlKey || Ge.altKey || Ge.shiftKey || Ge.metaKey || !i)
        return;
      const { open: $t, activeId: Cn } = i.getState();
      $t || Cn === null && (Ge.key === "ArrowUp" || Ge.key === "ArrowDown") && jr(Ge) && (Ge.preventDefault(), i.show());
    }), fn = $.onBlur, Sn = nt((Ge) => {
      G.current = !1, fn == null || fn(Ge), Ge.defaultPrevented;
    }), jt = Na($.id), On = HP(B) ? B : void 0, Gr = i.useState((Ge) => Ge.activeId === null);
    return $ = De(Q({
      id: jt,
      role: "combobox",
      "aria-autocomplete": On,
      "aria-haspopup": sh(ue, "listbox"),
      "aria-expanded": Ye,
      "aria-controls": ue == null ? void 0 : ue.id,
      "data-active-item": Gr || void 0,
      value: Ae
    }, $), {
      ref: In(z, $.ref),
      onChange: Qt,
      onCompositionEnd: ar,
      onMouseDown: wr,
      onKeyDown: Mt,
      onBlur: Sn
    }), $ = gh(De(Q({
      store: i,
      focusable: h
    }, $), {
      // Enable inline autocomplete when the user moves from the combobox input
      // to an item.
      moveOnKeyPress: (Ge) => O2(N, Ge) ? !1 : (me && ge(!0), !0)
    })), $ = l8(Q({ store: i }, $)), Q({ autoComplete: "off" }, $);
  }
), tw = ke(function(n) {
  const a = PP(n);
  return Ie(LP, a);
});
function _M(e = {}) {
  const n = J4(e);
  return /* @__PURE__ */ d.jsx(DP, { value: n, children: e.children });
}
var NP = "button", VP = /* @__PURE__ */ d.jsxs(
  "svg",
  {
    "aria-hidden": "true",
    display: "block",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    width: "1em",
    height: "1em",
    pointerEvents: "none",
    children: [
      /* @__PURE__ */ d.jsx("line", { x1: "5", y1: "5", x2: "11", y2: "11" }),
      /* @__PURE__ */ d.jsx("line", { x1: "5", y1: "11", x2: "11", y2: "5" })
    ]
  }
), FP = He(
  function(n) {
    var a = n, { store: i, hideWhenEmpty: h } = a, g = Ue(a, ["store", "hideWhenEmpty"]);
    const m = yh();
    i = i || m, Ht(
      i,
      process.env.NODE_ENV !== "production" && "ComboboxCancel must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const S = g.onClick, b = nt((T) => {
      S == null || S(T), !T.defaultPrevented && (i == null || i.setValue(""), i == null || i.move(null));
    }), R = i.useState((T) => {
      var A;
      return (A = T.baseElement) == null ? void 0 : A.id;
    }), D = i.useState((T) => T.value === "");
    return g = Bn(
      g,
      (T) => h && D ? /* @__PURE__ */ d.jsx(nE, {}) : T,
      [h, D]
    ), g = De(Q({
      children: VP,
      "aria-label": "Clear input",
      // This aria-controls will ensure the combobox popup remains visible when
      // this element gets focused. This logic is done in the ComboboxPopover
      // component.
      "aria-controls": R
    }, g), {
      onClick: b
    }), g = hh(g), g;
  }
), BP = ke(function(n) {
  const a = FP(n);
  return Ie(NP, a);
}), UP = "button", YP = /* @__PURE__ */ d.jsx(
  "svg",
  {
    "aria-hidden": "true",
    display: "block",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    viewBox: "0 0 16 16",
    height: "1em",
    width: "1em",
    pointerEvents: "none",
    children: /* @__PURE__ */ d.jsx("polyline", { points: "4,6 8,10 12,6" })
  }
), $P = He(function(n) {
  var a = n, { store: i } = a, h = Ue(a, ["store"]);
  const g = yh();
  i = i || g, Ht(
    i,
    process.env.NODE_ENV !== "production" && "ComboboxDisclosure must receive a `store` prop or be wrapped in a ComboboxProvider component."
  );
  const m = h.onMouseDown, S = nt((T) => {
    m == null || m(T), T.preventDefault(), i == null || i.move(null);
  }), b = h.onClick, R = nt((T) => {
    if (b == null || b(T), T.defaultPrevented || !i)
      return;
    const { baseElement: A } = i.getState();
    i.setDisclosureElement(A);
  }), D = i.useState("open");
  return h = De(Q({
    children: YP,
    tabIndex: -1,
    "aria-label": D ? "Hide popup" : "Show popup",
    "aria-expanded": D
  }, h), {
    onMouseDown: S,
    onClick: R
  }), h = z5(Q({ store: i }, h)), h;
}), WP = ke(function(n) {
  const a = $P(n);
  return Ie(UP, a);
}), zP = "div", qP = He(function(n) {
  return n = q5(n), n;
}), RM = ke(function(n) {
  const a = qP(n);
  return Ie(zP, a);
}), GP = "div", KP = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = $p();
    i = i || g, Ht(
      i,
      process.env.NODE_ENV !== "production" && "ComboboxRow must be wrapped in a ComboboxList or ComboboxPopover component"
    );
    const m = i.useState("contentElement");
    return sh(m) === "grid" && (h = Q({ role: "rowgroup" }, h)), h = G5(Q({ store: i }, h)), h;
  }
), EM = ke(function(n) {
  const a = KP(n);
  return Ie(GP, a);
}), QP = "span", XP = He(function(n) {
  var a = n, { store: i, checked: h } = a, g = Ue(a, ["store", "checked"]);
  const m = Qo(bM);
  return h = h ?? m, g = P5(De(Q({}, g), { checked: h })), g;
}), JP = ke(function(n) {
  const a = XP(n);
  return Ie(QP, a);
}), eN = "span";
function j9(e) {
  return Mx(e).toLowerCase();
}
function tN(e, n) {
  n = j9(n);
  let a = j9(e).indexOf(n);
  const i = [];
  for (; a !== -1; )
    a !== 0 && i.push(
      /* @__PURE__ */ d.jsx("span", { "data-autocomplete-value": "", children: e.substr(0, a) }, i.length)
    ), i.push(
      /* @__PURE__ */ d.jsx("span", { "data-user-value": "", children: e.substr(a, n.length) }, i.length)
    ), e = e.substr(a + n.length), a = j9(e).indexOf(n);
  return e && i.push(
    /* @__PURE__ */ d.jsx("span", { "data-autocomplete-value": "", children: e }, i.length)
  ), i;
}
var nN = He(function(n) {
  var a = n, { store: i, value: h } = a, g = Ue(a, ["store", "value"]);
  const m = $p();
  i = i || m;
  const S = Qo(CM), b = h ?? S;
  Ht(
    i,
    process.env.NODE_ENV !== "production" && "ComboboxItemValue must be wrapped in a ComboboxItem component."
  );
  const R = i.useState(
    (T) => b && T.value ? T.value : void 0
  ), D = qr(
    () => b && R ? tN(b, R) : b,
    [b, R]
  );
  return g = Q({
    children: D
  }, g), Pa(g);
}), rN = ke(function(n) {
  const a = nN(n);
  return Ie(eN, a);
}), aN = "div";
function oN(e, n) {
  if (n != null)
    return e == null ? !1 : Array.isArray(e) ? e.includes(n) : e === n;
}
function iN(e) {
  var n;
  return (n = {
    menu: "menuitem",
    listbox: "option",
    tree: "treeitem"
  }[e]) != null ? n : "option";
}
var lN = He(
  function(n) {
    var a = n, {
      store: i,
      value: h,
      hideOnClick: g,
      setValueOnClick: m,
      selectValueOnClick: S = !0,
      resetValueOnSelect: b,
      focusOnHover: R = !1,
      moveOnKeyPress: D = !0,
      getItem: T
    } = a, A = Ue(a, [
      "store",
      "value",
      "hideOnClick",
      "setValueOnClick",
      "selectValueOnClick",
      "resetValueOnSelect",
      "focusOnHover",
      "moveOnKeyPress",
      "getItem"
    ]), j;
    const I = $p();
    i = i || I, Ht(
      i,
      process.env.NODE_ENV !== "production" && "ComboboxItem must be wrapped in a ComboboxList or ComboboxPopover component."
    );
    const Z = Pr(
      (ce) => {
        const Se = De(Q({}, ce), { value: h });
        return T ? T(Se) : Se;
      },
      [h, T]
    ), N = i.useState(
      (ce) => Array.isArray(ce.selectedValue)
    ), B = i.useState(
      (ce) => oN(ce.selectedValue, h)
    ), $ = i.useState("resetValueOnSelect");
    m = m ?? !N, g = g ?? (h != null && !N);
    const W = A.onClick, z = rr(m), Y = rr(S), ie = rr(
      (j = b ?? $) != null ? j : N
    ), G = rr(g), pe = nt((ce) => {
      W == null || W(ce), !ce.defaultPrevented && (Ix(ce) || Lx(ce) || (h != null && (Y(ce) && (ie(ce) && (i == null || i.resetValue()), i == null || i.setSelectedValue((Se) => Array.isArray(Se) ? Se.includes(h) ? Se.filter((Re) => Re !== h) : [...Se, h] : h)), z(ce) && (i == null || i.setValue(h))), G(ce) && (i == null || i.hide())));
    }), J = A.onKeyDown, me = nt((ce) => {
      if (J == null || J(ce), ce.defaultPrevented)
        return;
      const Se = i == null ? void 0 : i.getState().baseElement;
      if (!Se || j2(Se))
        return;
      (ce.key.length === 1 || ce.key === "Backspace" || ce.key === "Delete") && (queueMicrotask(() => Se.focus()), yl(Se) && (i == null || i.setValue(Se.value)));
    });
    N && B != null && (A = Q({
      "aria-selected": B
    }, A)), A = Bn(
      A,
      (ce) => /* @__PURE__ */ d.jsx(CM.Provider, { value: h, children: /* @__PURE__ */ d.jsx(bM.Provider, { value: B ?? !1, children: ce }) }),
      [h, B]
    );
    const oe = Qo(SM);
    A = De(Q({
      role: iN(oe),
      children: h
    }, A), {
      onClick: pe,
      onKeyDown: me
    });
    const ge = rr(D);
    return A = P2(De(Q({
      store: i
    }, A), {
      getItem: Z,
      // Dispatch a custom event on the combobox input when moving to an item
      // with the keyboard so the Combobox component can enable inline
      // autocompletion.
      moveOnKeyPress: (ce) => {
        if (!ge(ce))
          return !1;
        const Se = new Event("combobox-item-move"), Re = i == null ? void 0 : i.getState().baseElement;
        return Re == null || Re.dispatchEvent(Se), !0;
      }
    })), A = K5(Q({ store: i, focusOnHover: R }, A)), A;
  }
), N4 = Va(
  ke(function(n) {
    const a = lN(n);
    return Ie(aN, a);
  })
), uN = "label", sN = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = yh();
    i = i || g, Ht(
      i,
      process.env.NODE_ENV !== "production" && "ComboboxLabel must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const m = i.useState((S) => {
      var b;
      return (b = S.baseElement) == null ? void 0 : b.id;
    });
    return h = Q({
      htmlFor: m
    }, h), Pa(h);
  }
), cN = Va(
  ke(function(n) {
    const a = sN(n);
    return Ie(uN, a);
  })
), fN = "div", MM = He(
  function(n) {
    var a = n, { store: i, alwaysVisible: h } = a, g = Ue(a, ["store", "alwaysVisible"]);
    const m = $p(!0), S = i8();
    i = i || S;
    const b = !!i && i === m;
    Ht(
      i,
      process.env.NODE_ENV !== "production" && "ComboboxList must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const R = Pt(null), D = Na(g.id), T = i.useState("mounted"), A = G4(T, g.hidden, h), j = A ? De(Q({}, g.style), { display: "none" }) : g.style, I = i.useState(
      (ie) => Array.isArray(ie.selectedValue)
    ), Z = vE(R, "role", g.role), B = (Z === "listbox" || Z === "tree" || Z === "grid") && I || void 0, [$, W] = Kt(!1), z = i.useState("contentElement");
    Ln(() => {
      if (!T)
        return;
      const ie = R.current;
      if (!ie || z !== ie)
        return;
      const G = () => {
        W(!!ie.querySelector("[role='listbox']"));
      }, pe = new MutationObserver(G);
      return pe.observe(ie, {
        subtree: !0,
        childList: !0,
        attributeFilter: ["role"]
      }), G(), () => pe.disconnect();
    }, [T, z]), $ || (g = Q({
      role: "listbox",
      "aria-multiselectable": B
    }, g)), g = Bn(
      g,
      (ie) => /* @__PURE__ */ d.jsx(AP, { value: i, children: /* @__PURE__ */ d.jsx(SM.Provider, { value: Z, children: ie }) }),
      [i, Z]
    );
    const Y = D && (!m || !b) ? i.setContentElement : null;
    return g = De(Q({
      id: D,
      hidden: A
    }, g), {
      ref: In(Y, R, g.ref),
      style: j
    }), Pa(g);
  }
), u8 = ke(function(n) {
  const a = MM(n);
  return Ie(fN, a);
});
const oh = Math.min, Ou = Math.max, S5 = Math.round, e5 = Math.floor, ih = (e) => ({
  x: e,
  y: e
}), dN = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, hN = {
  start: "end",
  end: "start"
};
function lx(e, n, a) {
  return Ou(e, oh(n, a));
}
function lh(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function pf(e) {
  return e.split("-")[0];
}
function Wp(e) {
  return e.split("-")[1];
}
function s8(e) {
  return e === "x" ? "y" : "x";
}
function c8(e) {
  return e === "y" ? "height" : "width";
}
function zp(e) {
  return ["top", "bottom"].includes(pf(e)) ? "y" : "x";
}
function f8(e) {
  return s8(zp(e));
}
function vN(e, n, a) {
  a === void 0 && (a = !1);
  const i = Wp(e), h = f8(e), g = c8(h);
  let m = h === "x" ? i === (a ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return n.reference[g] > n.floating[g] && (m = C5(m)), [m, C5(m)];
}
function pN(e) {
  const n = C5(e);
  return [ux(e), n, ux(n)];
}
function ux(e) {
  return e.replace(/start|end/g, (n) => hN[n]);
}
function mN(e, n, a) {
  const i = ["left", "right"], h = ["right", "left"], g = ["top", "bottom"], m = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return a ? n ? h : i : n ? i : h;
    case "left":
    case "right":
      return n ? g : m;
    default:
      return [];
  }
}
function gN(e, n, a, i) {
  const h = Wp(e);
  let g = mN(pf(e), a === "start", i);
  return h && (g = g.map((m) => m + "-" + h), n && (g = g.concat(g.map(ux)))), g;
}
function C5(e) {
  return e.replace(/left|right|bottom|top/g, (n) => dN[n]);
}
function wN(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function TM(e) {
  return typeof e != "number" ? wN(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function b5(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function q_(e, n, a) {
  let {
    reference: i,
    floating: h
  } = e;
  const g = zp(n), m = f8(n), S = c8(m), b = pf(n), R = g === "y", D = i.x + i.width / 2 - h.width / 2, T = i.y + i.height / 2 - h.height / 2, A = i[S] / 2 - h[S] / 2;
  let j;
  switch (b) {
    case "top":
      j = {
        x: D,
        y: i.y - h.height
      };
      break;
    case "bottom":
      j = {
        x: D,
        y: i.y + i.height
      };
      break;
    case "right":
      j = {
        x: i.x + i.width,
        y: T
      };
      break;
    case "left":
      j = {
        x: i.x - h.width,
        y: T
      };
      break;
    default:
      j = {
        x: i.x,
        y: i.y
      };
  }
  switch (Wp(n)) {
    case "start":
      j[m] -= A * (a && R ? -1 : 1);
      break;
    case "end":
      j[m] += A * (a && R ? -1 : 1);
      break;
  }
  return j;
}
const yN = async (e, n, a) => {
  const {
    placement: i = "bottom",
    strategy: h = "absolute",
    middleware: g = [],
    platform: m
  } = a, S = g.filter(Boolean), b = await (m.isRTL == null ? void 0 : m.isRTL(n));
  let R = await m.getElementRects({
    reference: e,
    floating: n,
    strategy: h
  }), {
    x: D,
    y: T
  } = q_(R, i, b), A = i, j = {}, I = 0;
  for (let Z = 0; Z < S.length; Z++) {
    const {
      name: N,
      fn: B
    } = S[Z], {
      x: $,
      y: W,
      data: z,
      reset: Y
    } = await B({
      x: D,
      y: T,
      initialPlacement: i,
      placement: A,
      strategy: h,
      middlewareData: j,
      rects: R,
      platform: m,
      elements: {
        reference: e,
        floating: n
      }
    });
    D = $ ?? D, T = W ?? T, j = {
      ...j,
      [N]: {
        ...j[N],
        ...z
      }
    }, Y && I <= 50 && (I++, typeof Y == "object" && (Y.placement && (A = Y.placement), Y.rects && (R = Y.rects === !0 ? await m.getElementRects({
      reference: e,
      floating: n,
      strategy: h
    }) : Y.rects), {
      x: D,
      y: T
    } = q_(R, A, b)), Z = -1);
  }
  return {
    x: D,
    y: T,
    placement: A,
    strategy: h,
    middlewareData: j
  };
};
async function d8(e, n) {
  var a;
  n === void 0 && (n = {});
  const {
    x: i,
    y: h,
    platform: g,
    rects: m,
    elements: S,
    strategy: b
  } = e, {
    boundary: R = "clippingAncestors",
    rootBoundary: D = "viewport",
    elementContext: T = "floating",
    altBoundary: A = !1,
    padding: j = 0
  } = lh(n, e), I = TM(j), N = S[A ? T === "floating" ? "reference" : "floating" : T], B = b5(await g.getClippingRect({
    element: (a = await (g.isElement == null ? void 0 : g.isElement(N))) == null || a ? N : N.contextElement || await (g.getDocumentElement == null ? void 0 : g.getDocumentElement(S.floating)),
    boundary: R,
    rootBoundary: D,
    strategy: b
  })), $ = T === "floating" ? {
    ...m.floating,
    x: i,
    y: h
  } : m.reference, W = await (g.getOffsetParent == null ? void 0 : g.getOffsetParent(S.floating)), z = await (g.isElement == null ? void 0 : g.isElement(W)) ? await (g.getScale == null ? void 0 : g.getScale(W)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, Y = b5(g.convertOffsetParentRelativeRectToViewportRelativeRect ? await g.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: S,
    rect: $,
    offsetParent: W,
    strategy: b
  }) : $);
  return {
    top: (B.top - Y.top + I.top) / z.y,
    bottom: (Y.bottom - B.bottom + I.bottom) / z.y,
    left: (B.left - Y.left + I.left) / z.x,
    right: (Y.right - B.right + I.right) / z.x
  };
}
const xN = (e) => ({
  name: "arrow",
  options: e,
  async fn(n) {
    const {
      x: a,
      y: i,
      placement: h,
      rects: g,
      platform: m,
      elements: S,
      middlewareData: b
    } = n, {
      element: R,
      padding: D = 0
    } = lh(e, n) || {};
    if (R == null)
      return {};
    const T = TM(D), A = {
      x: a,
      y: i
    }, j = f8(h), I = c8(j), Z = await m.getDimensions(R), N = j === "y", B = N ? "top" : "left", $ = N ? "bottom" : "right", W = N ? "clientHeight" : "clientWidth", z = g.reference[I] + g.reference[j] - A[j] - g.floating[I], Y = A[j] - g.reference[j], ie = await (m.getOffsetParent == null ? void 0 : m.getOffsetParent(R));
    let G = ie ? ie[W] : 0;
    (!G || !await (m.isElement == null ? void 0 : m.isElement(ie))) && (G = S.floating[W] || g.floating[I]);
    const pe = z / 2 - Y / 2, J = G / 2 - Z[I] / 2 - 1, me = oh(T[B], J), oe = oh(T[$], J), ge = me, ce = G - Z[I] - oe, Se = G / 2 - Z[I] / 2 + pe, Re = lx(ge, Se, ce), _e = !b.arrow && Wp(h) != null && Se !== Re && g.reference[I] / 2 - (Se < ge ? me : oe) - Z[I] / 2 < 0, Ye = _e ? Se < ge ? Se - ge : Se - ce : 0;
    return {
      [j]: A[j] + Ye,
      data: {
        [j]: Re,
        centerOffset: Se - Re - Ye,
        ..._e && {
          alignmentOffset: Ye
        }
      },
      reset: _e
    };
  }
}), SN = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(n) {
      var a, i;
      const {
        placement: h,
        middlewareData: g,
        rects: m,
        initialPlacement: S,
        platform: b,
        elements: R
      } = n, {
        mainAxis: D = !0,
        crossAxis: T = !0,
        fallbackPlacements: A,
        fallbackStrategy: j = "bestFit",
        fallbackAxisSideDirection: I = "none",
        flipAlignment: Z = !0,
        ...N
      } = lh(e, n);
      if ((a = g.arrow) != null && a.alignmentOffset)
        return {};
      const B = pf(h), $ = pf(S) === S, W = await (b.isRTL == null ? void 0 : b.isRTL(R.floating)), z = A || ($ || !Z ? [C5(S)] : pN(S));
      !A && I !== "none" && z.push(...gN(S, Z, I, W));
      const Y = [S, ...z], ie = await d8(n, N), G = [];
      let pe = ((i = g.flip) == null ? void 0 : i.overflows) || [];
      if (D && G.push(ie[B]), T) {
        const ge = vN(h, m, W);
        G.push(ie[ge[0]], ie[ge[1]]);
      }
      if (pe = [...pe, {
        placement: h,
        overflows: G
      }], !G.every((ge) => ge <= 0)) {
        var J, me;
        const ge = (((J = g.flip) == null ? void 0 : J.index) || 0) + 1, ce = Y[ge];
        if (ce)
          return {
            data: {
              index: ge,
              overflows: pe
            },
            reset: {
              placement: ce
            }
          };
        let Se = (me = pe.filter((Re) => Re.overflows[0] <= 0).sort((Re, _e) => Re.overflows[1] - _e.overflows[1])[0]) == null ? void 0 : me.placement;
        if (!Se)
          switch (j) {
            case "bestFit": {
              var oe;
              const Re = (oe = pe.map((_e) => [_e.placement, _e.overflows.filter((Ye) => Ye > 0).reduce((Ye, ue) => Ye + ue, 0)]).sort((_e, Ye) => _e[1] - Ye[1])[0]) == null ? void 0 : oe[0];
              Re && (Se = Re);
              break;
            }
            case "initialPlacement":
              Se = S;
              break;
          }
        if (h !== Se)
          return {
            reset: {
              placement: Se
            }
          };
      }
      return {};
    }
  };
};
async function CN(e, n) {
  const {
    placement: a,
    platform: i,
    elements: h
  } = e, g = await (i.isRTL == null ? void 0 : i.isRTL(h.floating)), m = pf(a), S = Wp(a), b = zp(a) === "y", R = ["left", "top"].includes(m) ? -1 : 1, D = g && b ? -1 : 1, T = lh(n, e);
  let {
    mainAxis: A,
    crossAxis: j,
    alignmentAxis: I
  } = typeof T == "number" ? {
    mainAxis: T,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...T
  };
  return S && typeof I == "number" && (j = S === "end" ? I * -1 : I), b ? {
    x: j * D,
    y: A * R
  } : {
    x: A * R,
    y: j * D
  };
}
const bN = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(n) {
      var a, i;
      const {
        x: h,
        y: g,
        placement: m,
        middlewareData: S
      } = n, b = await CN(n, e);
      return m === ((a = S.offset) == null ? void 0 : a.placement) && (i = S.arrow) != null && i.alignmentOffset ? {} : {
        x: h + b.x,
        y: g + b.y,
        data: {
          ...b,
          placement: m
        }
      };
    }
  };
}, _N = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(n) {
      const {
        x: a,
        y: i,
        placement: h
      } = n, {
        mainAxis: g = !0,
        crossAxis: m = !1,
        limiter: S = {
          fn: (N) => {
            let {
              x: B,
              y: $
            } = N;
            return {
              x: B,
              y: $
            };
          }
        },
        ...b
      } = lh(e, n), R = {
        x: a,
        y: i
      }, D = await d8(n, b), T = zp(pf(h)), A = s8(T);
      let j = R[A], I = R[T];
      if (g) {
        const N = A === "y" ? "top" : "left", B = A === "y" ? "bottom" : "right", $ = j + D[N], W = j - D[B];
        j = lx($, j, W);
      }
      if (m) {
        const N = T === "y" ? "top" : "left", B = T === "y" ? "bottom" : "right", $ = I + D[N], W = I - D[B];
        I = lx($, I, W);
      }
      const Z = S.fn({
        ...n,
        [A]: j,
        [T]: I
      });
      return {
        ...Z,
        data: {
          x: Z.x - a,
          y: Z.y - i
        }
      };
    }
  };
}, RN = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(n) {
      const {
        x: a,
        y: i,
        placement: h,
        rects: g,
        middlewareData: m
      } = n, {
        offset: S = 0,
        mainAxis: b = !0,
        crossAxis: R = !0
      } = lh(e, n), D = {
        x: a,
        y: i
      }, T = zp(h), A = s8(T);
      let j = D[A], I = D[T];
      const Z = lh(S, n), N = typeof Z == "number" ? {
        mainAxis: Z,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...Z
      };
      if (b) {
        const W = A === "y" ? "height" : "width", z = g.reference[A] - g.floating[W] + N.mainAxis, Y = g.reference[A] + g.reference[W] - N.mainAxis;
        j < z ? j = z : j > Y && (j = Y);
      }
      if (R) {
        var B, $;
        const W = A === "y" ? "width" : "height", z = ["top", "left"].includes(pf(h)), Y = g.reference[T] - g.floating[W] + (z && ((B = m.offset) == null ? void 0 : B[T]) || 0) + (z ? 0 : N.crossAxis), ie = g.reference[T] + g.reference[W] + (z ? 0 : (($ = m.offset) == null ? void 0 : $[T]) || 0) - (z ? N.crossAxis : 0);
        I < Y ? I = Y : I > ie && (I = ie);
      }
      return {
        [A]: j,
        [T]: I
      };
    }
  };
}, EN = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(n) {
      const {
        placement: a,
        rects: i,
        platform: h,
        elements: g
      } = n, {
        apply: m = () => {
        },
        ...S
      } = lh(e, n), b = await d8(n, S), R = pf(a), D = Wp(a), T = zp(a) === "y", {
        width: A,
        height: j
      } = i.floating;
      let I, Z;
      R === "top" || R === "bottom" ? (I = R, Z = D === (await (h.isRTL == null ? void 0 : h.isRTL(g.floating)) ? "start" : "end") ? "left" : "right") : (Z = R, I = D === "end" ? "top" : "bottom");
      const N = j - b[I], B = A - b[Z], $ = !n.middlewareData.shift;
      let W = N, z = B;
      if (T) {
        const ie = A - b.left - b.right;
        z = D || $ ? oh(B, ie) : ie;
      } else {
        const ie = j - b.top - b.bottom;
        W = D || $ ? oh(N, ie) : ie;
      }
      if ($ && !D) {
        const ie = Ou(b.left, 0), G = Ou(b.right, 0), pe = Ou(b.top, 0), J = Ou(b.bottom, 0);
        T ? z = A - 2 * (ie !== 0 || G !== 0 ? ie + G : Ou(b.left, b.right)) : W = j - 2 * (pe !== 0 || J !== 0 ? pe + J : Ou(b.top, b.bottom));
      }
      await m({
        ...n,
        availableWidth: z,
        availableHeight: W
      });
      const Y = await h.getDimensions(g.floating);
      return A !== Y.width || j !== Y.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function uh(e) {
  return OM(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Au(e) {
  var n;
  return (e == null || (n = e.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function xf(e) {
  var n;
  return (n = (OM(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : n.documentElement;
}
function OM(e) {
  return e instanceof Node || e instanceof Au(e).Node;
}
function mf(e) {
  return e instanceof Element || e instanceof Au(e).Element;
}
function V0(e) {
  return e instanceof HTMLElement || e instanceof Au(e).HTMLElement;
}
function G_(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Au(e).ShadowRoot;
}
function r3(e) {
  const {
    overflow: n,
    overflowX: a,
    overflowY: i,
    display: h
  } = Ms(e);
  return /auto|scroll|overlay|hidden|clip/.test(n + i + a) && !["inline", "contents"].includes(h);
}
function MN(e) {
  return ["table", "td", "th"].includes(uh(e));
}
function h8(e) {
  const n = v8(), a = Ms(e);
  return a.transform !== "none" || a.perspective !== "none" || (a.containerType ? a.containerType !== "normal" : !1) || !n && (a.backdropFilter ? a.backdropFilter !== "none" : !1) || !n && (a.filter ? a.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((i) => (a.willChange || "").includes(i)) || ["paint", "layout", "strict", "content"].some((i) => (a.contain || "").includes(i));
}
function TN(e) {
  let n = Vp(e);
  for (; V0(n) && !nw(n); ) {
    if (h8(n))
      return n;
    n = Vp(n);
  }
  return null;
}
function v8() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function nw(e) {
  return ["html", "body", "#document"].includes(uh(e));
}
function Ms(e) {
  return Au(e).getComputedStyle(e);
}
function rw(e) {
  return mf(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function Vp(e) {
  if (uh(e) === "html")
    return e;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    G_(e) && e.host || // Fallback.
    xf(e)
  );
  return G_(n) ? n.host : n;
}
function DM(e) {
  const n = Vp(e);
  return nw(n) ? e.ownerDocument ? e.ownerDocument.body : e.body : V0(n) && r3(n) ? n : DM(n);
}
function V4(e, n, a) {
  var i;
  n === void 0 && (n = []), a === void 0 && (a = !0);
  const h = DM(e), g = h === ((i = e.ownerDocument) == null ? void 0 : i.body), m = Au(h);
  return g ? n.concat(m, m.visualViewport || [], r3(h) ? h : [], m.frameElement && a ? V4(m.frameElement) : []) : n.concat(h, V4(h, [], a));
}
function AM(e) {
  const n = Ms(e);
  let a = parseFloat(n.width) || 0, i = parseFloat(n.height) || 0;
  const h = V0(e), g = h ? e.offsetWidth : a, m = h ? e.offsetHeight : i, S = S5(a) !== g || S5(i) !== m;
  return S && (a = g, i = m), {
    width: a,
    height: i,
    $: S
  };
}
function p8(e) {
  return mf(e) ? e : e.contextElement;
}
function kp(e) {
  const n = p8(e);
  if (!V0(n))
    return ih(1);
  const a = n.getBoundingClientRect(), {
    width: i,
    height: h,
    $: g
  } = AM(n);
  let m = (g ? S5(a.width) : a.width) / i, S = (g ? S5(a.height) : a.height) / h;
  return (!m || !Number.isFinite(m)) && (m = 1), (!S || !Number.isFinite(S)) && (S = 1), {
    x: m,
    y: S
  };
}
const ON = /* @__PURE__ */ ih(0);
function jM(e) {
  const n = Au(e);
  return !v8() || !n.visualViewport ? ON : {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  };
}
function DN(e, n, a) {
  return n === void 0 && (n = !1), !a || n && a !== Au(e) ? !1 : n;
}
function L2(e, n, a, i) {
  n === void 0 && (n = !1), a === void 0 && (a = !1);
  const h = e.getBoundingClientRect(), g = p8(e);
  let m = ih(1);
  n && (i ? mf(i) && (m = kp(i)) : m = kp(e));
  const S = DN(g, a, i) ? jM(g) : ih(0);
  let b = (h.left + S.x) / m.x, R = (h.top + S.y) / m.y, D = h.width / m.x, T = h.height / m.y;
  if (g) {
    const A = Au(g), j = i && mf(i) ? Au(i) : i;
    let I = A, Z = I.frameElement;
    for (; Z && i && j !== I; ) {
      const N = kp(Z), B = Z.getBoundingClientRect(), $ = Ms(Z), W = B.left + (Z.clientLeft + parseFloat($.paddingLeft)) * N.x, z = B.top + (Z.clientTop + parseFloat($.paddingTop)) * N.y;
      b *= N.x, R *= N.y, D *= N.x, T *= N.y, b += W, R += z, I = Au(Z), Z = I.frameElement;
    }
  }
  return b5({
    width: D,
    height: T,
    x: b,
    y: R
  });
}
const AN = [":popover-open", ":modal"];
function kM(e) {
  return AN.some((n) => {
    try {
      return e.matches(n);
    } catch {
      return !1;
    }
  });
}
function jN(e) {
  let {
    elements: n,
    rect: a,
    offsetParent: i,
    strategy: h
  } = e;
  const g = h === "fixed", m = xf(i), S = n ? kM(n.floating) : !1;
  if (i === m || S && g)
    return a;
  let b = {
    scrollLeft: 0,
    scrollTop: 0
  }, R = ih(1);
  const D = ih(0), T = V0(i);
  if ((T || !T && !g) && ((uh(i) !== "body" || r3(m)) && (b = rw(i)), V0(i))) {
    const A = L2(i);
    R = kp(i), D.x = A.x + i.clientLeft, D.y = A.y + i.clientTop;
  }
  return {
    width: a.width * R.x,
    height: a.height * R.y,
    x: a.x * R.x - b.scrollLeft * R.x + D.x,
    y: a.y * R.y - b.scrollTop * R.y + D.y
  };
}
function kN(e) {
  return Array.from(e.getClientRects());
}
function LM(e) {
  return L2(xf(e)).left + rw(e).scrollLeft;
}
function LN(e) {
  const n = xf(e), a = rw(e), i = e.ownerDocument.body, h = Ou(n.scrollWidth, n.clientWidth, i.scrollWidth, i.clientWidth), g = Ou(n.scrollHeight, n.clientHeight, i.scrollHeight, i.clientHeight);
  let m = -a.scrollLeft + LM(e);
  const S = -a.scrollTop;
  return Ms(i).direction === "rtl" && (m += Ou(n.clientWidth, i.clientWidth) - h), {
    width: h,
    height: g,
    x: m,
    y: S
  };
}
function IN(e, n) {
  const a = Au(e), i = xf(e), h = a.visualViewport;
  let g = i.clientWidth, m = i.clientHeight, S = 0, b = 0;
  if (h) {
    g = h.width, m = h.height;
    const R = v8();
    (!R || R && n === "fixed") && (S = h.offsetLeft, b = h.offsetTop);
  }
  return {
    width: g,
    height: m,
    x: S,
    y: b
  };
}
function HN(e, n) {
  const a = L2(e, !0, n === "fixed"), i = a.top + e.clientTop, h = a.left + e.clientLeft, g = V0(e) ? kp(e) : ih(1), m = e.clientWidth * g.x, S = e.clientHeight * g.y, b = h * g.x, R = i * g.y;
  return {
    width: m,
    height: S,
    x: b,
    y: R
  };
}
function K_(e, n, a) {
  let i;
  if (n === "viewport")
    i = IN(e, a);
  else if (n === "document")
    i = LN(xf(e));
  else if (mf(n))
    i = HN(n, a);
  else {
    const h = jM(e);
    i = {
      ...n,
      x: n.x - h.x,
      y: n.y - h.y
    };
  }
  return b5(i);
}
function IM(e, n) {
  const a = Vp(e);
  return a === n || !mf(a) || nw(a) ? !1 : Ms(a).position === "fixed" || IM(a, n);
}
function ZN(e, n) {
  const a = n.get(e);
  if (a)
    return a;
  let i = V4(e, [], !1).filter((S) => mf(S) && uh(S) !== "body"), h = null;
  const g = Ms(e).position === "fixed";
  let m = g ? Vp(e) : e;
  for (; mf(m) && !nw(m); ) {
    const S = Ms(m), b = h8(m);
    !b && S.position === "fixed" && (h = null), (g ? !b && !h : !b && S.position === "static" && !!h && ["absolute", "fixed"].includes(h.position) || r3(m) && !b && IM(e, m)) ? i = i.filter((D) => D !== m) : h = S, m = Vp(m);
  }
  return n.set(e, i), i;
}
function PN(e) {
  let {
    element: n,
    boundary: a,
    rootBoundary: i,
    strategy: h
  } = e;
  const m = [...a === "clippingAncestors" ? ZN(n, this._c) : [].concat(a), i], S = m[0], b = m.reduce((R, D) => {
    const T = K_(n, D, h);
    return R.top = Ou(T.top, R.top), R.right = oh(T.right, R.right), R.bottom = oh(T.bottom, R.bottom), R.left = Ou(T.left, R.left), R;
  }, K_(n, S, h));
  return {
    width: b.right - b.left,
    height: b.bottom - b.top,
    x: b.left,
    y: b.top
  };
}
function NN(e) {
  const {
    width: n,
    height: a
  } = AM(e);
  return {
    width: n,
    height: a
  };
}
function VN(e, n, a) {
  const i = V0(n), h = xf(n), g = a === "fixed", m = L2(e, !0, g, n);
  let S = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const b = ih(0);
  if (i || !i && !g)
    if ((uh(n) !== "body" || r3(h)) && (S = rw(n)), i) {
      const T = L2(n, !0, g, n);
      b.x = T.x + n.clientLeft, b.y = T.y + n.clientTop;
    } else h && (b.x = LM(h));
  const R = m.left + S.scrollLeft - b.x, D = m.top + S.scrollTop - b.y;
  return {
    x: R,
    y: D,
    width: m.width,
    height: m.height
  };
}
function Q_(e, n) {
  return !V0(e) || Ms(e).position === "fixed" ? null : n ? n(e) : e.offsetParent;
}
function HM(e, n) {
  const a = Au(e);
  if (!V0(e) || kM(e))
    return a;
  let i = Q_(e, n);
  for (; i && MN(i) && Ms(i).position === "static"; )
    i = Q_(i, n);
  return i && (uh(i) === "html" || uh(i) === "body" && Ms(i).position === "static" && !h8(i)) ? a : i || TN(e) || a;
}
const FN = async function(e) {
  const n = this.getOffsetParent || HM, a = this.getDimensions;
  return {
    reference: VN(e.reference, await n(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      ...await a(e.floating)
    }
  };
};
function BN(e) {
  return Ms(e).direction === "rtl";
}
const UN = {
  convertOffsetParentRelativeRectToViewportRelativeRect: jN,
  getDocumentElement: xf,
  getClippingRect: PN,
  getOffsetParent: HM,
  getElementRects: FN,
  getClientRects: kN,
  getDimensions: NN,
  getScale: kp,
  isElement: mf,
  isRTL: BN
};
function YN(e, n) {
  let a = null, i;
  const h = xf(e);
  function g() {
    var S;
    clearTimeout(i), (S = a) == null || S.disconnect(), a = null;
  }
  function m(S, b) {
    S === void 0 && (S = !1), b === void 0 && (b = 1), g();
    const {
      left: R,
      top: D,
      width: T,
      height: A
    } = e.getBoundingClientRect();
    if (S || n(), !T || !A)
      return;
    const j = e5(D), I = e5(h.clientWidth - (R + T)), Z = e5(h.clientHeight - (D + A)), N = e5(R), $ = {
      rootMargin: -j + "px " + -I + "px " + -Z + "px " + -N + "px",
      threshold: Ou(0, oh(1, b)) || 1
    };
    let W = !0;
    function z(Y) {
      const ie = Y[0].intersectionRatio;
      if (ie !== b) {
        if (!W)
          return m();
        ie ? m(!1, ie) : i = setTimeout(() => {
          m(!1, 1e-7);
        }, 100);
      }
      W = !1;
    }
    try {
      a = new IntersectionObserver(z, {
        ...$,
        // Handle <iframe>s
        root: h.ownerDocument
      });
    } catch {
      a = new IntersectionObserver(z, $);
    }
    a.observe(e);
  }
  return m(!0), g;
}
function $N(e, n, a, i) {
  i === void 0 && (i = {});
  const {
    ancestorScroll: h = !0,
    ancestorResize: g = !0,
    elementResize: m = typeof ResizeObserver == "function",
    layoutShift: S = typeof IntersectionObserver == "function",
    animationFrame: b = !1
  } = i, R = p8(e), D = h || g ? [...R ? V4(R) : [], ...V4(n)] : [];
  D.forEach((B) => {
    h && B.addEventListener("scroll", a, {
      passive: !0
    }), g && B.addEventListener("resize", a);
  });
  const T = R && S ? YN(R, a) : null;
  let A = -1, j = null;
  m && (j = new ResizeObserver((B) => {
    let [$] = B;
    $ && $.target === R && j && (j.unobserve(n), cancelAnimationFrame(A), A = requestAnimationFrame(() => {
      var W;
      (W = j) == null || W.observe(n);
    })), a();
  }), R && !b && j.observe(R), j.observe(n));
  let I, Z = b ? L2(e) : null;
  b && N();
  function N() {
    const B = L2(e);
    Z && (B.x !== Z.x || B.y !== Z.y || B.width !== Z.width || B.height !== Z.height) && a(), Z = B, I = requestAnimationFrame(N);
  }
  return a(), () => {
    var B;
    D.forEach(($) => {
      h && $.removeEventListener("scroll", a), g && $.removeEventListener("resize", a);
    }), T == null || T(), (B = j) == null || B.disconnect(), j = null, b && cancelAnimationFrame(I);
  };
}
const WN = _N, zN = SN, qN = EN, GN = xN, KN = RN, QN = (e, n, a) => {
  const i = /* @__PURE__ */ new Map(), h = {
    platform: UN,
    ...a
  }, g = {
    ...h.platform,
    _c: i
  };
  return yN(e, n, {
    ...h,
    platform: g
  });
};
var XN = "div";
function X_(e = 0, n = 0, a = 0, i = 0) {
  if (typeof DOMRect == "function")
    return new DOMRect(e, n, a, i);
  const h = {
    x: e,
    y: n,
    width: a,
    height: i,
    top: n,
    right: e + a,
    bottom: n + i,
    left: e
  };
  return De(Q({}, h), { toJSON: () => h });
}
function JN(e) {
  if (!e)
    return X_();
  const { x: n, y: a, width: i, height: h } = e;
  return X_(n, a, i, h);
}
function eV(e, n) {
  return {
    contextElement: e || void 0,
    getBoundingClientRect: () => {
      const i = e, h = n == null ? void 0 : n(i);
      return h || !i ? JN(h) : i.getBoundingClientRect();
    }
  };
}
function tV(e) {
  return /^(?:top|bottom|left|right)(?:-(?:start|end))?$/.test(e);
}
function J_(e) {
  const n = window.devicePixelRatio || 1;
  return Math.round(e * n) / n;
}
function nV(e, n) {
  return bN(({ placement: a }) => {
    var i;
    const h = ((e == null ? void 0 : e.clientHeight) || 0) / 2, g = typeof n.gutter == "number" ? n.gutter + h : (i = n.gutter) != null ? i : h;
    return {
      crossAxis: !!a.split("-")[1] ? void 0 : n.shift,
      mainAxis: g,
      alignmentAxis: n.shift
    };
  });
}
function rV(e) {
  if (e.flip === !1)
    return;
  const n = typeof e.flip == "string" ? e.flip.split(" ") : void 0;
  return Ht(
    !n || n.every(tV),
    process.env.NODE_ENV !== "production" && "`flip` expects a spaced-delimited list of placements"
  ), zN({
    padding: e.overflowPadding,
    fallbackPlacements: n
  });
}
function aV(e) {
  if (!(!e.slide && !e.overlap))
    return WN({
      mainAxis: e.slide,
      crossAxis: e.overlap,
      padding: e.overflowPadding,
      limiter: KN()
    });
}
function oV(e) {
  return qN({
    padding: e.overflowPadding,
    apply({ elements: n, availableWidth: a, availableHeight: i, rects: h }) {
      const g = n.floating, m = Math.round(h.reference.width);
      a = Math.floor(a), i = Math.floor(i), g.style.setProperty(
        "--popover-anchor-width",
        `${m}px`
      ), g.style.setProperty(
        "--popover-available-width",
        `${a}px`
      ), g.style.setProperty(
        "--popover-available-height",
        `${i}px`
      ), e.sameWidth && (g.style.width = `${m}px`), e.fitViewport && (g.style.maxWidth = `${a}px`, g.style.maxHeight = `${i}px`);
    }
  });
}
function iV(e, n) {
  if (e)
    return GN({
      element: e,
      padding: n.arrowPadding
    });
}
var aw = He(
  function(n) {
    var a = n, {
      store: i,
      modal: h = !1,
      portal: g = !!h,
      preserveTabOrder: m = !0,
      autoFocusOnShow: S = !0,
      wrapperProps: b,
      fixed: R = !1,
      flip: D = !0,
      shift: T = 0,
      slide: A = !0,
      overlap: j = !1,
      sameWidth: I = !1,
      fitViewport: Z = !1,
      gutter: N,
      arrowPadding: B = 4,
      overflowPadding: $ = 8,
      getAnchorRect: W,
      updatePosition: z
    } = a, Y = Ue(a, [
      "store",
      "modal",
      "portal",
      "preserveTabOrder",
      "autoFocusOnShow",
      "wrapperProps",
      "fixed",
      "flip",
      "shift",
      "slide",
      "overlap",
      "sameWidth",
      "fitViewport",
      "gutter",
      "arrowPadding",
      "overflowPadding",
      "getAnchorRect",
      "updatePosition"
    ]);
    const ie = J5();
    i = i || ie, Ht(
      i,
      process.env.NODE_ENV !== "production" && "Popover must receive a `store` prop or be wrapped in a PopoverProvider component."
    );
    const G = i.useState("arrowElement"), pe = i.useState("anchorElement"), J = i.useState("disclosureElement"), me = i.useState("popoverElement"), oe = i.useState("contentElement"), ge = i.useState("placement"), ce = i.useState("mounted"), Se = i.useState("rendered"), [Re, _e] = Kt(!1), { portalRef: Ye, domReady: ue } = Zx(g, Y.portalRef), Ae = nt(W), Pe = nt(z), dt = !!z;
    Ln(() => {
      if (!(me != null && me.isConnected))
        return;
      me.style.setProperty(
        "--popover-overflow-padding",
        `${$}px`
      );
      const qe = eV(pe, Ae), Je = async () => {
        if (!ce)
          return;
        const Tn = [
          nV(G, { gutter: N, shift: T }),
          rV({ flip: D, overflowPadding: $ }),
          aV({ slide: A, shift: T, overlap: j, overflowPadding: $ }),
          iV(G, { arrowPadding: B }),
          oV({
            sameWidth: I,
            fitViewport: Z,
            overflowPadding: $
          })
        ], Qt = await QN(qe, me, {
          placement: ge,
          strategy: R ? "fixed" : "absolute",
          middleware: Tn
        });
        i == null || i.setState("currentPlacement", Qt.placement), _e(!0);
        const Hn = J_(Qt.x), ar = J_(Qt.y);
        if (Object.assign(me.style, {
          top: "0",
          left: "0",
          transform: `translate3d(${Hn}px,${ar}px,0)`
        }), G && Qt.middlewareData.arrow) {
          const { x: Wn, y: zn } = Qt.middlewareData.arrow, qn = Qt.placement.split("-")[0];
          Object.assign(G.style, {
            left: Wn != null ? `${Wn}px` : "",
            top: zn != null ? `${zn}px` : "",
            [qn]: "100%"
          });
        }
      }, Nt = $N(qe, me, async () => {
        dt ? (await Pe({ updatePosition: Je }), _e(!0)) : await Je();
      }, {
        // JSDOM doesn't support ResizeObserver
        elementResize: typeof ResizeObserver == "function"
      });
      return () => {
        _e(!1), Nt();
      };
    }, [
      i,
      Se,
      me,
      G,
      pe,
      me,
      ge,
      ce,
      ue,
      R,
      D,
      T,
      A,
      j,
      I,
      Z,
      N,
      B,
      $,
      Ae,
      dt,
      Pe
    ]), Ln(() => {
      if (!ce || !ue || !(me != null && me.isConnected) || !(oe != null && oe.isConnected))
        return;
      const qe = () => {
        me.style.zIndex = getComputedStyle(oe).zIndex;
      };
      qe();
      let Je = requestAnimationFrame(() => {
        Je = requestAnimationFrame(qe);
      });
      return () => cancelAnimationFrame(Je);
    }, [ce, ue, me, oe]);
    const Ze = R ? "fixed" : "absolute";
    return Y = Bn(
      Y,
      (qe) => /* @__PURE__ */ d.jsx(
        "div",
        De(Q({}, b), {
          style: Q({
            // https://floating-ui.com/docs/computeposition#initial-layout
            position: Ze,
            top: 0,
            left: 0,
            width: "max-content"
          }, b == null ? void 0 : b.style),
          ref: i == null ? void 0 : i.setPopoverElement,
          children: qe
        })
      ),
      [i, Ze, b]
    ), Y = Bn(
      Y,
      (qe) => /* @__PURE__ */ d.jsx(t3, { value: i, children: qe }),
      [i]
    ), Y = De(Q({
      // data-placing is not part of the public API. We're setting this here so
      // we can wait for the popover to be positioned before other components
      // move focus into it. For example, this attribute is observed by the
      // Combobox component with the autoSelect behavior.
      "data-placing": !Re || void 0
    }, Y), {
      style: Q({
        position: "relative"
      }, Y.style)
    }), Y = sM(De(Q({
      store: i,
      modal: h,
      portal: g,
      preserveTabOrder: m,
      preserveTabOrderAnchor: J || pe,
      autoFocusOnShow: Re && S
    }, Y), {
      portalRef: Ye
    })), Y;
  }
), ZM = N2(
  ke(function(n) {
    const a = aw(n);
    return Ie(XN, a);
  }),
  J5
), lV = "div";
function uV(e, ...n) {
  if (!e)
    return !1;
  if ("id" in e) {
    const a = n.filter(Boolean).map((i) => `[aria-controls~="${i}"]`).join(", ");
    return a ? Ox(e, a) : !1;
  }
  return !1;
}
var sV = He(
  function(n) {
    var a = n, {
      store: i,
      modal: h,
      tabIndex: g,
      alwaysVisible: m,
      autoFocusOnHide: S = !0,
      hideOnInteractOutside: b = !0
    } = a, R = Ue(a, [
      "store",
      "modal",
      "tabIndex",
      "alwaysVisible",
      "autoFocusOnHide",
      "hideOnInteractOutside"
    ]);
    const D = yh();
    i = i || D, Ht(
      i,
      process.env.NODE_ENV !== "production" && "ComboboxPopover must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const T = i.useState("baseElement"), A = Pt(!1), j = Ia(
      i.tag,
      (I) => I == null ? void 0 : I.renderedItems.length
    );
    return R = MM(Q({ store: i, alwaysVisible: m }, R)), R = aw(De(Q({
      store: i,
      modal: h,
      alwaysVisible: m,
      backdrop: !1,
      autoFocusOnShow: !1,
      finalFocus: T,
      preserveTabOrderAnchor: null,
      unstable_treeSnapshotKey: j
    }, R), {
      // When the combobox popover is modal, we make sure to include the
      // combobox input and all the combobox controls (cancel, disclosure) in
      // the list of persistent elements so they make part of the modal context,
      // allowing users to tab through them.
      getPersistentElements() {
        var I;
        const Z = ((I = R.getPersistentElements) == null ? void 0 : I.call(R)) || [];
        if (!h || !i)
          return Z;
        const { contentElement: N, baseElement: B } = i.getState();
        if (!B)
          return Z;
        const $ = aa(B), W = [];
        if (N != null && N.id && W.push(`[aria-controls~="${N.id}"]`), B != null && B.id && W.push(`[aria-controls~="${B.id}"]`), !W.length)
          return [...Z, B];
        const z = W.join(","), Y = $.querySelectorAll(z);
        return [...Z, ...Y];
      },
      // The combobox popover should focus on the combobox input when it hides,
      // unless the event was triggered by a click outside the popover, in which
      // case the input shouldn't be re-focused.
      autoFocusOnHide(I) {
        return O2(S, I) ? !1 : A.current ? (A.current = !1, !1) : !0;
      },
      // Make sure we don't hide the popover when the user interacts with the
      // combobox cancel or the combobox disclosure buttons. They will have the
      // aria-controls attribute pointing to either the combobox input or the
      // combobox popover elements.
      hideOnInteractOutside(I) {
        var Z, N;
        const B = i == null ? void 0 : i.getState(), $ = (Z = B == null ? void 0 : B.contentElement) == null ? void 0 : Z.id, W = (N = B == null ? void 0 : B.baseElement) == null ? void 0 : N.id;
        if (uV(I.target, $, W))
          return !1;
        const z = typeof b == "function" ? b(I) : b;
        return z && (A.current = I.type === "click"), z;
      }
    })), R;
  }
), PM = N2(
  ke(function(n) {
    const a = sV(n);
    return Ie(lV, a);
  }),
  yh
), cV = "div", fV = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = $p();
    i = i || g, Ht(
      i,
      process.env.NODE_ENV !== "production" && "ComboboxRow must be wrapped in a ComboboxList or ComboboxPopover component"
    );
    const m = i.useState("contentElement"), b = sh(m) === "grid" ? "row" : "presentation";
    return h = Q({ role: b }, h), h = a8(Q({ store: i }, h)), h;
  }
), dV = ke(function(n) {
  const a = fV(n);
  return Ie(cV, a);
}), hV = "hr", vV = He(function(n) {
  var a = n, { store: i } = a, h = Ue(a, ["store"]);
  const g = $p();
  return i = i || g, Ht(
    i,
    process.env.NODE_ENV !== "production" && "ComboboxSeparator must be wrapped in a ComboboxList or ComboboxPopover component."
  ), h = Q4(Q({ store: i }, h)), h;
}), pV = ke(function(n) {
  const a = vV(n);
  return Ie(hV, a);
});
function NM(e = {}) {
  const n = o8(e);
  return /* @__PURE__ */ d.jsx(ew, { value: n, children: e.children });
}
var eR = "M23,27.8c1.1,1.2,3.4,2.2,5,2.2h2H0h2c1.7,0,3.9-1,5-2.2l6.6-7.2c0.7-0.8,2-0.8,2.7,0L23,27.8L23,27.8z", mV = "div", sx = 30, Kd = sx / 2, gV = {
  top: `rotate(180 ${Kd} ${Kd})`,
  right: `rotate(-90 ${Kd} ${Kd})`,
  bottom: `rotate(0 ${Kd} ${Kd})`,
  left: `rotate(90 ${Kd} ${Kd})`
};
function wV(e) {
  const [n, a] = Kt(), i = e.useState("contentElement");
  return Ln(() => {
    if (!i)
      return;
    const g = uE(i).getComputedStyle(i);
    a(g);
  }, [i]), n;
}
var ow = He(
  function(n) {
    var a = n, { store: i, size: h = sx } = a, g = Ue(a, ["store", "size"]);
    const m = wh();
    i = i || m, Ht(
      i,
      process.env.NODE_ENV !== "production" && "PopoverArrow must be wrapped in a Popover component."
    );
    const S = i.useState(
      (Z) => Z.currentPlacement.split("-")[0]
    ), b = wV(i), R = (b == null ? void 0 : b.getPropertyValue("background-color")) || "none", D = (b == null ? void 0 : b.getPropertyValue(`border-${S}-color`)) || "none", T = (b == null ? void 0 : b.getPropertyValue(`border-${S}-width`)) || "0px", A = parseInt(T) * 2 * (sx / h), j = gV[S], I = qr(
      () => /* @__PURE__ */ d.jsx("svg", { display: "block", viewBox: "0 0 30 30", children: /* @__PURE__ */ d.jsxs("g", { transform: j, children: [
        /* @__PURE__ */ d.jsx("path", { fill: "none", d: eR }),
        /* @__PURE__ */ d.jsx("path", { stroke: "none", d: eR })
      ] }) }),
      [j]
    );
    return g = De(Q({
      children: I,
      "aria-hidden": !0
    }, g), {
      ref: In(i.setArrowElement, g.ref),
      style: Q({
        // server side rendering
        position: "absolute",
        fontSize: h,
        width: "1em",
        height: "1em",
        pointerEvents: "none",
        fill: R,
        stroke: D,
        strokeWidth: A
      }, g.style)
    }), Pa(g);
  }
), qp = ke(function(n) {
  const a = ow(n);
  return Ie(mV, a);
}), yV = "p", VM = He(function(n) {
  return n = dM(n), n;
}), xV = ke(function(n) {
  const a = VM(n);
  return Ie(yV, a);
}), SV = "span", CV = {
  top: "4,10 8,6 12,10",
  right: "6,4 10,8 6,12",
  bottom: "4,6 8,10 12,6",
  left: "10,4 6,8 10,12"
}, m8 = He(function(n) {
  var a = n, { store: i, placement: h } = a, g = Ue(a, ["store", "placement"]);
  const m = wh();
  i = i || m, Ht(
    i,
    process.env.NODE_ENV !== "production" && "PopoverDisclosureArrow must be wrapped in a PopoverDisclosure component."
  );
  const b = i.useState((T) => h || T.placement).split("-")[0], R = CV[b], D = qr(
    () => /* @__PURE__ */ d.jsx(
      "svg",
      {
        display: "block",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        viewBox: "0 0 16 16",
        height: "1em",
        width: "1em",
        children: /* @__PURE__ */ d.jsx("polyline", { points: R })
      }
    ),
    [R]
  );
  return g = De(Q({
    children: D,
    "aria-hidden": !0
  }, g), {
    style: Q({
      width: "1em",
      height: "1em",
      pointerEvents: "none"
    }, g.style)
  }), Pa(g);
}), bV = ke(
  function(n) {
    const a = m8(n);
    return Ie(SV, a);
  }
), _V = "button", g8 = He(function(n) {
  var a = n, { store: i } = a, h = Ue(a, ["store"]);
  const g = J5();
  i = i || g, Ht(
    i,
    process.env.NODE_ENV !== "production" && "PopoverDisclosure must receive a `store` prop or be wrapped in a PopoverProvider component."
  );
  const m = h.onClick, S = nt((b) => {
    i == null || i.setAnchorElement(b.currentTarget), m == null || m(b);
  });
  return h = Bn(
    h,
    (b) => /* @__PURE__ */ d.jsx(t3, { value: i, children: b }),
    [i]
  ), h = De(Q({}, h), {
    onClick: S
  }), h = l8(Q({ store: i }, h)), h = z5(Q({ store: i }, h)), h;
}), iw = ke(function(n) {
  const a = g8(n);
  return Ie(_V, a);
}), RV = "button", FM = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = OP();
    return i = i || g, h = hM(Q({ store: i }, h)), h;
  }
), EV = ke(function(n) {
  const a = FM(n);
  return Ie(RV, a);
}), MV = "h1", BM = He(
  function(n) {
    return n = pM(n), n;
  }
), TV = ke(function(n) {
  const a = BM(n);
  return Ie(MV, a);
}), a3 = bi(
  [B0],
  [vh]
), w8 = a3.useContext, OV = a3.useScopedContext, DV = a3.useProviderContext, AV = a3.ContextProvider, jV = a3.ScopedContextProvider;
Za(
  void 0
);
function kV(e = {}) {
  var n;
  const a = (n = e.store) == null ? void 0 : n.getState(), i = ph(pn(Ct({}, e), {
    orientation: ht(
      e.orientation,
      a == null ? void 0 : a.orientation,
      "horizontal"
    ),
    focusLoop: ht(e.focusLoop, a == null ? void 0 : a.focusLoop, !0)
  })), h = Ct({}, i.getState()), g = ho(h, i, e.store);
  return Ct(Ct({}, i), g);
}
function LV(e, n, a) {
  return mh(e, n, a);
}
function lw(e = {}) {
  const [n, a] = Ci(kV, e);
  return LV(n, a, e);
}
var IV = "div", UM = He(
  function(n) {
    var a = n, {
      store: i,
      composite: h = !0,
      orientation: g,
      virtualFocus: m,
      focusLoop: S,
      rtl: b
    } = a, R = Ue(a, [
      "store",
      "composite",
      "orientation",
      "virtualFocus",
      "focusLoop",
      "rtl"
    ]);
    const D = DV();
    i = i || D;
    const T = lw({
      store: i,
      orientation: g,
      virtualFocus: m,
      focusLoop: S,
      rtl: b
    }), A = T.useState(
      (j) => !h || j.orientation === "both" ? void 0 : j.orientation
    );
    return R = Bn(
      R,
      (j) => /* @__PURE__ */ d.jsx(jV, { value: T, children: j }),
      [T]
    ), h && (R = Q({
      role: "menubar",
      "aria-orientation": A
    }, R)), R = gh(Q({ store: T, composite: h }, R)), R;
  }
), HV = ke(function(n) {
  const a = UM(n);
  return Ie(IV, a);
});
function YM(e = {}) {
  const n = lw(e);
  return /* @__PURE__ */ d.jsx(AV, { value: n, children: e.children });
}
var o3 = bi(
  [ew],
  [t3]
), $M = o3.useContext, ZV = o3.useScopedContext, uw = o3.useProviderContext, y8 = o3.ContextProvider, x8 = o3.ScopedContextProvider, i3 = bi(
  [B0, y8],
  [vh, x8]
), Sf = i3.useContext, sw = i3.useScopedContext, cw = i3.useProviderContext, WM = i3.ContextProvider, PV = i3.ScopedContextProvider, NV = w8, zM = Za(
  void 0
);
function S8(e = {}) {
  var n;
  const a = (n = e.store) == null ? void 0 : n.getState(), i = Q5(pn(Ct({}, e), {
    placement: ht(
      e.placement,
      a == null ? void 0 : a.placement,
      "bottom"
    )
  })), h = ht(e.timeout, a == null ? void 0 : a.timeout, 500), g = pn(Ct({}, i.getState()), {
    timeout: h,
    showTimeout: ht(e.showTimeout, a == null ? void 0 : a.showTimeout),
    hideTimeout: ht(e.hideTimeout, a == null ? void 0 : a.hideTimeout),
    autoFocusOnShow: ht(a == null ? void 0 : a.autoFocusOnShow, !1)
  }), m = ho(g, i, e.store);
  return pn(Ct(Ct({}, i), m), {
    setAutoFocusOnShow: (S) => m.setState("autoFocusOnShow", S)
  });
}
function C8(e, n, a) {
  return lr(e, a, "timeout"), lr(e, a, "showTimeout"), lr(e, a, "hideTimeout"), X5(e, n, a);
}
function qM(e = {}) {
  const [n, a] = Ci(S8, e);
  return C8(n, a, e);
}
function VV(e = {}) {
  var n = e, {
    combobox: a,
    parent: i,
    menubar: h
  } = n, g = Fp(n, [
    "combobox",
    "parent",
    "menubar"
  ]);
  const m = !!h && !i, S = Up(
    g.store,
    wE(i, ["values"]),
    Pp(a, [
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    ])
  );
  fh(g, S);
  const b = S.getState(), R = ph(pn(Ct({}, g), {
    store: S,
    orientation: ht(
      g.orientation,
      b.orientation,
      "vertical"
    )
  })), D = S8(pn(Ct({}, g), {
    store: S,
    placement: ht(
      g.placement,
      b.placement,
      "bottom-start"
    ),
    timeout: ht(
      g.timeout,
      b.timeout,
      m ? 0 : 150
    ),
    hideTimeout: ht(g.hideTimeout, b.hideTimeout, 0)
  })), T = pn(Ct(Ct({}, R.getState()), D.getState()), {
    initialFocus: ht(b.initialFocus, "container"),
    values: ht(
      g.values,
      b.values,
      g.defaultValues,
      {}
    )
  }), A = ho(T, R, D, S);
  return Ha(
    A,
    () => Ea(A, ["mounted"], (j) => {
      j.mounted || A.setState("activeId", null);
    })
  ), Ha(
    A,
    () => Ea(i, ["orientation"], (j) => {
      A.setState(
        "placement",
        j.orientation === "vertical" ? "right-start" : "bottom-start"
      );
    })
  ), pn(Ct(Ct(Ct({}, R), D), A), {
    combobox: a,
    parent: i,
    menubar: h,
    hideAll: () => {
      D.hide(), i == null || i.hideAll();
    },
    setInitialFocus: (j) => A.setState("initialFocus", j),
    setValues: (j) => A.setState("values", j),
    setValue: (j, I) => {
      j !== "__proto__" && j !== "constructor" && (Array.isArray(j) || A.setState("values", (Z) => {
        const N = Z[j], B = j4(I, N);
        return B === N ? Z : pn(Ct({}, Z), {
          [j]: B !== void 0 && B
        });
      }));
    }
  });
}
function FV(e, n, a) {
  return R1(n, [a.combobox, a.parent, a.menubar]), lr(e, a, "values", "setValues"), Object.assign(
    C8(
      mh(e, n, a),
      n,
      a
    ),
    {
      combobox: a.combobox,
      parent: a.parent,
      menubar: a.menubar
    }
  );
}
function b8(e = {}) {
  const n = Sf(), a = w8(), i = yh();
  e = De(Q({}, e), {
    parent: e.parent !== void 0 ? e.parent : n,
    menubar: e.menubar !== void 0 ? e.menubar : a,
    combobox: e.combobox !== void 0 ? e.combobox : i
  });
  const [h, g] = Ci(VV, e);
  return FV(h, g, e);
}
function BV(e = {}) {
  return wt(() => {
    process.env.NODE_ENV !== "production" && console.warn(
      "useMenuBarStore is deprecated. Use useMenubarStore instead.",
      "See https://ariakit.org/reference/use-menubar-store"
    );
  }, []), lw(e);
}
var UV = "div";
function YV(e) {
  var n = e, { store: a } = n, i = Ue(n, ["store"]);
  const [h, g] = Kt(void 0), m = i["aria-label"], S = Ia(a, "disclosureElement"), b = Ia(a, "contentElement");
  return wt(() => {
    const R = S;
    if (!R)
      return;
    const D = b;
    if (!D)
      return;
    m || D.hasAttribute("aria-label") ? g(void 0) : R.id && g(R.id);
  }, [m, S, b]), h;
}
var GM = He(
  function(n) {
    var a = n, { store: i, alwaysVisible: h, composite: g } = a, m = Ue(a, ["store", "alwaysVisible", "composite"]);
    const S = cw();
    i = i || S, Ht(
      i,
      process.env.NODE_ENV !== "production" && "MenuList must receive a `store` prop or be wrapped in a MenuProvider component."
    );
    const b = i.parent, R = i.menubar, D = !!b, T = Na(m.id), A = m.onKeyDown, j = i.useState(
      (G) => G.placement.split("-")[0]
    ), I = i.useState(
      (G) => G.orientation === "both" ? void 0 : G.orientation
    ), Z = I !== "vertical", N = Ia(
      R,
      (G) => !!G && G.orientation !== "vertical"
    ), B = nt((G) => {
      if (A == null || A(G), !G.defaultPrevented) {
        if (D || R && !Z) {
          const J = {
            ArrowRight: () => j === "left" && !Z,
            ArrowLeft: () => j === "right" && !Z,
            ArrowUp: () => j === "bottom" && Z,
            ArrowDown: () => j === "top" && Z
          }[G.key];
          if (J != null && J())
            return G.stopPropagation(), G.preventDefault(), i == null ? void 0 : i.hide();
        }
        if (R) {
          const J = {
            ArrowRight: () => {
              if (N)
                return R.next();
            },
            ArrowLeft: () => {
              if (N)
                return R.previous();
            },
            ArrowDown: () => {
              if (!N)
                return R.next();
            },
            ArrowUp: () => {
              if (!N)
                return R.previous();
            }
          }[G.key], me = J == null ? void 0 : J();
          me !== void 0 && (G.stopPropagation(), G.preventDefault(), R.move(me));
        }
      }
    });
    m = Bn(
      m,
      (G) => /* @__PURE__ */ d.jsx(PV, { value: i, children: G }),
      [i]
    );
    const $ = YV(Q({ store: i }, m)), W = i.useState("mounted"), z = G4(W, m.hidden, h), Y = z ? De(Q({}, m.style), { display: "none" }) : m.style;
    m = De(Q({
      id: T,
      "aria-labelledby": $,
      hidden: z
    }, m), {
      ref: In(T ? i.setContentElement : null, m.ref),
      style: Y,
      onKeyDown: B
    });
    const ie = !!i.combobox;
    return g = g ?? !ie, g && (m = Q({
      role: "menu",
      "aria-orientation": I
    }, m)), m = gh(Q({ store: i, composite: g }, m)), m = X4(Q({ store: i, typeahead: !ie }, m)), m;
  }
), $V = ke(function(n) {
  const a = GM(n);
  return Ie(UV, a);
});
function k9(e) {
  return [e.clientX, e.clientY];
}
function tR(e, n) {
  const [a, i] = e;
  let h = !1;
  const g = n.length;
  for (let m = g, S = 0, b = m - 1; S < m; b = S++) {
    const [R, D] = n[S], [T, A] = n[b], [, j] = n[b === 0 ? m - 1 : b - 1] || [0, 0], I = (D - A) * (a - R) - (R - T) * (i - D);
    if (A < D) {
      if (i >= A && i < D) {
        if (I === 0)
          return !0;
        I > 0 && (i === A ? i > j && (h = !h) : h = !h);
      }
    } else if (D < A) {
      if (i > D && i <= A) {
        if (I === 0)
          return !0;
        I < 0 && (i === A ? i < j && (h = !h) : h = !h);
      }
    } else if (i == D && (a >= T && a <= R || a >= R && a <= T))
      return !0;
  }
  return h;
}
function WV(e, n) {
  const { top: a, right: i, bottom: h, left: g } = n, [m, S] = e, b = m < g ? "left" : m > i ? "right" : null, R = S < a ? "top" : S > h ? "bottom" : null;
  return [b, R];
}
function nR(e, n) {
  const a = e.getBoundingClientRect(), { top: i, right: h, bottom: g, left: m } = a, [S, b] = WV(n, a), R = [n];
  return S ? (b !== "top" && R.push([S === "left" ? m : h, i]), R.push([S === "left" ? h : m, i]), R.push([S === "left" ? h : m, g]), b !== "bottom" && R.push([S === "left" ? m : h, g])) : b === "top" ? (R.push([m, i]), R.push([m, g]), R.push([h, g]), R.push([h, i])) : (R.push([m, g]), R.push([m, i]), R.push([h, i]), R.push([h, g])), R;
}
var zV = "div";
function KM(e, n, a, i) {
  return rh(n) ? !0 : e ? !!(pa(n, e) || a && pa(a, e) || i != null && i.some((h) => KM(e, h, a))) : !1;
}
function qV(e) {
  var n = e, {
    store: a
  } = n, i = Ue(n, [
    "store"
  ]);
  const [h, g] = Kt(!1), m = a.useState("mounted");
  wt(() => {
    m || g(!1);
  }, [m]);
  const S = i.onFocus, b = nt((D) => {
    S == null || S(D), !D.defaultPrevented && g(!0);
  }), R = Pt(null);
  return wt(() => Ea(a, ["anchorElement"], (D) => {
    R.current = D.anchorElement;
  }), []), i = De(Q({
    autoFocusOnHide: h,
    finalFocus: R
  }, i), {
    onFocus: b
  }), i;
}
var rR = Za(null), _8 = He(
  function(n) {
    var a = n, {
      store: i,
      modal: h = !1,
      portal: g = !!h,
      hideOnEscape: m = !0,
      hideOnHoverOutside: S = !0,
      disablePointerEventsOnApproach: b = !!S
    } = a, R = Ue(a, [
      "store",
      "modal",
      "portal",
      "hideOnEscape",
      "hideOnHoverOutside",
      "disablePointerEventsOnApproach"
    ]);
    const D = uw();
    i = i || D, Ht(
      i,
      process.env.NODE_ENV !== "production" && "Hovercard must receive a `store` prop or be wrapped in a HovercardProvider component."
    );
    const T = Pt(null), [A, j] = Kt([]), I = Pt(0), Z = Pt(null), { portalRef: N, domReady: B } = Zx(g, R.portalRef), $ = !!S, W = rr(S), z = !!b, Y = rr(
      b
    ), ie = i.useState("open"), G = i.useState("mounted");
    wt(() => {
      if (!B || !G || !$ && !z)
        return;
      const ge = T.current;
      return ge ? xl(
        Go("mousemove", (Se) => {
          if (!i)
            return;
          const { anchorElement: Re, hideTimeout: _e, timeout: Ye } = i.getState(), ue = Z.current, [Ae] = Se.composedPath(), Pe = Re;
          if (KM(Ae, ge, Pe, A)) {
            Z.current = Ae && Pe && pa(Pe, Ae) ? k9(Se) : null, window.clearTimeout(I.current), I.current = 0;
            return;
          }
          if (!I.current) {
            if (ue) {
              const dt = k9(Se), Ze = nR(ge, ue);
              if (tR(dt, Ze)) {
                if (Z.current = dt, !Y(Se))
                  return;
                Se.preventDefault(), Se.stopPropagation();
                return;
              }
            }
            W(Se) && (I.current = window.setTimeout(() => {
              I.current = 0, i == null || i.hide();
            }, _e ?? Ye));
          }
        }, !0),
        () => clearTimeout(I.current)
      ) : void 0;
    }, [
      i,
      B,
      G,
      $,
      z,
      A,
      Y,
      W
    ]), wt(() => {
      if (!B || !G || !z)
        return;
      const ge = (ce) => {
        const Se = T.current;
        if (!Se)
          return;
        const Re = Z.current;
        if (!Re)
          return;
        const _e = nR(Se, Re);
        if (tR(k9(ce), _e)) {
          if (!Y(ce))
            return;
          ce.preventDefault(), ce.stopPropagation();
        }
      };
      return xl(
        // Note: we may need to add pointer events here in the future.
        Go("mouseenter", ge, !0),
        Go("mouseover", ge, !0),
        Go("mouseout", ge, !0),
        Go("mouseleave", ge, !0)
      );
    }, [B, G, z, Y]), wt(() => {
      B && (ie || i == null || i.setAutoFocusOnShow(!1));
    }, [i, B, ie]);
    const pe = hE(ie);
    wt(() => {
      if (B)
        return () => {
          pe.current || i == null || i.setAutoFocusOnShow(!1);
        };
    }, [i, B]);
    const J = Qo(rR);
    Ln(() => {
      if (h || !g || !G || !B)
        return;
      const ge = T.current;
      if (ge)
        return J == null ? void 0 : J(ge);
    }, [h, g, G, B]);
    const me = Pr(
      (ge) => {
        j((Se) => [...Se, ge]);
        const ce = J == null ? void 0 : J(ge);
        return () => {
          j(
            (Se) => Se.filter((Re) => Re !== ge)
          ), ce == null || ce();
        };
      },
      [J]
    );
    R = Bn(
      R,
      (ge) => /* @__PURE__ */ d.jsx(x8, { value: i, children: /* @__PURE__ */ d.jsx(rR.Provider, { value: me, children: ge }) }),
      [i, me]
    ), R = De(Q({}, R), {
      ref: In(T, R.ref)
    }), R = qV(Q({ store: i }, R));
    const oe = i.useState(
      (ge) => h || ge.autoFocusOnShow
    );
    return R = aw(De(Q({
      store: i,
      modal: h,
      portal: g,
      autoFocusOnShow: oe
    }, R), {
      portalRef: N,
      hideOnEscape(ge) {
        return O2(m, ge) ? !1 : (requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            i == null || i.hide();
          });
        }), !0);
      }
    })), R;
  }
), GV = N2(
  ke(function(n) {
    const a = _8(n);
    return Ie(zV, a);
  }),
  uw
), KV = "div", QV = He(function(n) {
  var a = n, {
    store: i,
    modal: h = !1,
    portal: g = !!h,
    hideOnEscape: m = !0,
    autoFocusOnShow: S = !0,
    hideOnHoverOutside: b,
    alwaysVisible: R
  } = a, D = Ue(a, [
    "store",
    "modal",
    "portal",
    "hideOnEscape",
    "autoFocusOnShow",
    "hideOnHoverOutside",
    "alwaysVisible"
  ]);
  const T = cw();
  i = i || T, Ht(
    i,
    process.env.NODE_ENV !== "production" && "Menu must receive a `store` prop or be wrapped in a MenuProvider component."
  );
  const A = Pt(null), j = i.parent, I = i.menubar, Z = !!j, N = !!I && !Z;
  D = De(Q({}, D), {
    ref: In(A, D.ref)
  });
  const B = GM(Q({
    store: i,
    alwaysVisible: R
  }, D)), { "aria-labelledby": $ } = B;
  D = Ue(B, ["aria-labelledby"]);
  const [z, Y] = Kt(), ie = i.useState("autoFocusOnShow"), G = i.useState("initialFocus"), pe = i.useState("baseElement"), J = i.useState("renderedItems");
  wt(() => {
    let _e = !1;
    return Y((Ye) => {
      var ue, Ae, Pe;
      if (_e || !ie)
        return;
      if ((ue = Ye == null ? void 0 : Ye.current) != null && ue.isConnected)
        return Ye;
      const dt = Yk();
      switch (G) {
        case "first":
          dt.current = ((Ae = J.find((Ze) => !Ze.disabled && Ze.element)) == null ? void 0 : Ae.element) || null;
          break;
        case "last":
          dt.current = ((Pe = [...J].reverse().find((Ze) => !Ze.disabled && Ze.element)) == null ? void 0 : Pe.element) || null;
          break;
        default:
          dt.current = pe;
      }
      return dt;
    }), () => {
      _e = !0;
    };
  }, [i, ie, G, J, pe]);
  const me = Z ? !1 : h, oe = !!S, ge = !!z || !!D.initialFocus || !!me, ce = Ia(
    i.combobox || i,
    "contentElement"
  ), Se = Ia(
    (j == null ? void 0 : j.combobox) || j,
    "contentElement"
  ), Re = qr(() => {
    if (!Se || !ce)
      return;
    const _e = ce.getAttribute("role"), Ye = Se.getAttribute("role");
    if (!((Ye === "menu" || Ye === "menubar") && _e === "menu"))
      return Se;
  }, [ce, Se]);
  return Re !== void 0 && (D = Q({
    preserveTabOrderAnchor: Re
  }, D)), D = _8(De(Q({
    store: i,
    alwaysVisible: R,
    initialFocus: z,
    autoFocusOnShow: oe ? ge && S : ie || !!me
  }, D), {
    hideOnEscape(_e) {
      return O2(m, _e) ? !1 : (i == null || i.hideAll(), !0);
    },
    hideOnHoverOutside(_e) {
      const Ye = i == null ? void 0 : i.getState().disclosureElement;
      return (typeof b == "function" ? b(_e) : b ?? (Z ? !0 : N ? Ye ? !rh(Ye) : !0 : !1)) ? _e.defaultPrevented || !Z || !Ye || (mL(Ye, "mouseout", _e), !rh(Ye)) ? !0 : (requestAnimationFrame(() => {
        rh(Ye) || i == null || i.hide();
      }), !1) : !1;
    },
    modal: me,
    portal: g,
    backdrop: Z ? !1 : D.backdrop
  })), D = Q({
    "aria-labelledby": $
  }, D), D;
}), QM = N2(
  ke(function(n) {
    const a = QV(n);
    return Ie(KV, a);
  }),
  cw
);
function XM(e = {}) {
  const n = b8(e);
  return /* @__PURE__ */ d.jsx(WM, { value: n, children: e.children });
}
var XV = "div", JV = He(
  function(n) {
    return wt(() => {
      process.env.NODE_ENV !== "production" && console.warn(
        "MenuBar is deprecated. Use Menubar instead.",
        "See https://ariakit.org/reference/menubar"
      );
    }, []), UM(n);
  }
), eF = ke(function(n) {
  const a = JV(n);
  return Ie(XV, a);
});
function tF(e = {}) {
  return wt(() => {
    process.env.NODE_ENV !== "production" && console.warn(
      "MenuBarProvider is deprecated. Use MenubarProvider instead.",
      "See https://ariakit.org/reference/menubar-provider"
    );
  }, []), /* @__PURE__ */ d.jsx(YM, Q({}, e));
}
var nF = "div", rF = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = Sf();
    return i = i || g, ow(Q({ store: i }, h));
  }
), JM = ke(function(n) {
  const a = rF(n);
  return Ie(nF, a);
}), aF = "span", oF = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = Sf();
    return i = i || g, h = m8(Q({ store: i }, h)), h;
  }
), iF = ke(function(n) {
  const a = oF(n);
  return Ie(aF, a);
}), lF = "a", R8 = He(
  function(n) {
    var a = n, { store: i, showOnHover: h = !0 } = a, g = Ue(a, ["store", "showOnHover"]);
    const m = uw();
    i = i || m, Ht(
      i,
      process.env.NODE_ENV !== "production" && "HovercardAnchor must receive a `store` prop or be wrapped in a HovercardProvider component."
    );
    const S = wf(g), b = Pt(0);
    wt(() => () => window.clearTimeout(b.current), []), wt(() => Go("mouseleave", (B) => {
      if (!i)
        return;
      const { anchorElement: $ } = i.getState();
      $ && B.target === $ && (window.clearTimeout(b.current), b.current = 0);
    }, !0), [i]);
    const R = g.onMouseMove, D = rr(h), T = mE(), A = nt((N) => {
      if (R == null || R(N), S || !i || N.defaultPrevented || b.current || !T() || !D(N))
        return;
      const B = N.currentTarget;
      i.setAnchorElement(B), i.setDisclosureElement(B);
      const { showTimeout: $, timeout: W } = i.getState(), z = () => {
        b.current = 0, T() && (i == null || i.setAnchorElement(B), i == null || i.show(), queueMicrotask(() => {
          i == null || i.setDisclosureElement(B);
        }));
      }, Y = $ ?? W;
      Y === 0 ? z() : b.current = window.setTimeout(z, Y);
    }), j = g.onClick, I = nt((N) => {
      j == null || j(N), i && (window.clearTimeout(b.current), b.current = 0);
    }), Z = Pr(
      (N) => {
        if (!i)
          return;
        const { anchorElement: B } = i.getState();
        B != null && B.isConnected || i.setAnchorElement(N);
      },
      [i]
    );
    return g = De(Q({}, g), {
      ref: In(Z, g.ref),
      onMouseMove: A,
      onClick: I
    }), g = H2(g), g;
  }
), uF = ke(function(n) {
  const a = R8(n);
  return Ie(lF, a);
}), sF = "button";
function cF(e, n) {
  return {
    ArrowDown: n === "bottom" || n === "top" ? "first" : !1,
    ArrowUp: n === "bottom" || n === "top" ? "last" : !1,
    ArrowRight: n === "right" ? "first" : !1,
    ArrowLeft: n === "left" ? "first" : !1
  }[e.key];
}
function aR(e, n) {
  return !!(e != null && e.some((a) => !a.element || a.element === n ? !1 : a.element.getAttribute("aria-expanded") === "true"));
}
var fF = He(
  function(n) {
    var a = n, {
      store: i,
      focusable: h,
      accessibleWhenDisabled: g,
      showOnHover: m
    } = a, S = Ue(a, [
      "store",
      "focusable",
      "accessibleWhenDisabled",
      "showOnHover"
    ]);
    const b = cw();
    i = i || b, Ht(
      i,
      process.env.NODE_ENV !== "production" && "MenuButton must receive a `store` prop or be wrapped in a MenuProvider component."
    );
    const R = Pt(null), D = i.parent, T = i.menubar, A = !!D, j = !!T && !A, I = wf(S), Z = () => {
      const oe = R.current;
      oe && (i == null || i.setDisclosureElement(oe), i == null || i.setAnchorElement(oe), i == null || i.show());
    }, N = S.onFocus, B = nt((oe) => {
      if (N == null || N(oe), I || oe.defaultPrevented || (i == null || i.setAutoFocusOnShow(!1), i == null || i.setActiveId(null), !T) || !j)
        return;
      const { items: ge } = T.getState();
      aR(ge, oe.currentTarget) && Z();
    }), $ = i.useState(
      (oe) => oe.placement.split("-")[0]
    ), W = S.onKeyDown, z = nt((oe) => {
      if (W == null || W(oe), I || oe.defaultPrevented)
        return;
      const ge = cF(oe, $);
      ge && (oe.preventDefault(), Z(), i == null || i.setAutoFocusOnShow(!0), i == null || i.setInitialFocus(ge));
    }), Y = S.onClick, ie = nt((oe) => {
      if (Y == null || Y(oe), oe.defaultPrevented || !i)
        return;
      const ge = !oe.detail, { open: ce } = i.getState();
      (!ce || ge) && ((!A || ge) && i.setAutoFocusOnShow(!0), i.setInitialFocus(ge ? "first" : "container")), A && Z();
    });
    S = Bn(
      S,
      (oe) => /* @__PURE__ */ d.jsx(WM, { value: i, children: oe }),
      [i]
    ), A && (S = De(Q({}, S), {
      render: /* @__PURE__ */ d.jsx(P4.div, { render: S.render })
    }));
    const G = Na(S.id), pe = Ia(
      (D == null ? void 0 : D.combobox) || D,
      "contentElement"
    ), J = A || j ? Dx(pe, "menuitem") : void 0, me = i.useState("contentElement");
    return S = De(Q({
      id: G,
      role: J,
      "aria-haspopup": sh(me, "menu")
    }, S), {
      ref: In(R, S.ref),
      onFocus: B,
      onKeyDown: z,
      onClick: ie
    }), S = R8(De(Q({
      store: i,
      focusable: h,
      accessibleWhenDisabled: g
    }, S), {
      showOnHover: (oe) => {
        if (!(() => {
          if (typeof m == "function")
            return m(oe);
          if (m != null)
            return m;
          if (A)
            return !0;
          if (!T)
            return !1;
          const { items: Re } = T.getState();
          return j && aR(Re);
        })())
          return !1;
        const Se = j ? T : D;
        return Se && Se.setActiveId(oe.currentTarget.id), !0;
      }
    })), S = g8(Q({
      store: i,
      toggleOnClick: !A,
      focusable: h,
      accessibleWhenDisabled: g
    }, S)), S = X4(Q({
      store: i,
      typeahead: j
    }, S)), S;
  }
), eT = ke(function(n) {
  const a = fF(n);
  return Ie(sF, a);
}), dF = "p", tT = He(function(n) {
  return n = VM(n), n;
}), hF = ke(function(n) {
  const a = tT(n);
  return Ie(dF, a);
}), vF = "p", pF = He(
  function(n) {
    return n = tT(n), n;
  }
), mF = ke(function(n) {
  const a = pF(n);
  return Ie(vF, a);
}), gF = "button", nT = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = ZV();
    return i = i || g, h = FM(Q({ store: i }, h)), h;
  }
), wF = ke(function(n) {
  const a = nT(n);
  return Ie(gF, a);
}), yF = "button", xF = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = sw();
    return i = i || g, h = nT(Q({ store: i }, h)), h;
  }
), SF = ke(function(n) {
  const a = xF(n);
  return Ie(yF, a);
}), CF = "div", bF = He(
  function(n) {
    return n = q5(n), n;
  }
), _F = ke(function(n) {
  const a = bF(n);
  return Ie(CF, a);
}), RF = "div", EF = He(
  function(n) {
    return n = G5(n), n;
  }
), MF = ke(function(n) {
  const a = EF(n);
  return Ie(RF, a);
}), TF = "h1", rT = He(
  function(n) {
    return n = BM(n), n;
  }
), OF = ke(function(n) {
  const a = rT(n);
  return Ie(TF, a);
}), DF = "h1", AF = He(
  function(n) {
    return n = rT(n), n;
  }
), aT = ke(function(n) {
  const a = AF(n);
  return Ie(DF, a);
}), jF = "span", kF = He(
  function(n) {
    var a = n, { store: i, checked: h } = a, g = Ue(a, ["store", "checked"]);
    const m = Qo(zM);
    return h = h ?? m, g = P5(De(Q({}, g), { checked: h })), g;
  }
), LF = ke(function(n) {
  const a = kF(n);
  return Ie(jF, a);
}), IF = "div";
function HF(e, n, a) {
  var i;
  if (!e)
    return !1;
  if (rh(e))
    return !0;
  const h = n == null ? void 0 : n.find((b) => {
    var R;
    return b.element === a ? !1 : ((R = b.element) == null ? void 0 : R.getAttribute("aria-expanded")) === "true";
  }), g = (i = h == null ? void 0 : h.element) == null ? void 0 : i.getAttribute("aria-controls");
  if (!g)
    return !1;
  const S = aa(e).getElementById(g);
  return S ? rh(S) ? !0 : !!S.querySelector("[role=menuitem][aria-expanded=true]") : !1;
}
var E8 = He(
  function(n) {
    var a = n, {
      store: i,
      hideOnClick: h = !0,
      preventScrollOnKeyDown: g = !0,
      focusOnHover: m,
      blurOnHoverEnd: S
    } = a, b = Ue(a, [
      "store",
      "hideOnClick",
      "preventScrollOnKeyDown",
      "focusOnHover",
      "blurOnHoverEnd"
    ]);
    const R = sw(!0), D = OV();
    i = i || R || D, Ht(
      i,
      process.env.NODE_ENV !== "production" && "MenuItem must be wrapped in a MenuList, Menu or Menubar component"
    );
    const T = b.onClick, A = rr(h), j = "hideAll" in i ? i.hideAll : void 0, I = !!j, Z = nt(($) => {
      T == null || T($), !($.defaultPrevented || Ix($) || Lx($) || !j || $.currentTarget.getAttribute("aria-haspopup") === "menu") && A($) && j();
    }), N = Ia(
      i,
      ($) => "contentElement" in $ ? $.contentElement : null
    ), B = Dx(N, "menuitem");
    return b = De(Q({
      role: B
    }, b), {
      onClick: Z
    }), b = P2(Q({
      store: i,
      preventScrollOnKeyDown: g
    }, b)), b = K5(De(Q({
      store: i
    }, b), {
      focusOnHover($) {
        const W = () => typeof m == "function" ? m($) : m ?? !0;
        if (!i || !W())
          return !1;
        const { baseElement: z, items: Y } = i.getState();
        return I ? ($.currentTarget.hasAttribute("aria-expanded") && $.currentTarget.focus(), !0) : HF(z, Y, $.currentTarget) ? ($.currentTarget.focus(), !0) : !1;
      },
      blurOnHoverEnd($) {
        return typeof S == "function" ? S($) : S ?? I;
      }
    })), b;
  }
), oT = Va(
  ke(function(n) {
    const a = E8(n);
    return Ie(IF, a);
  })
), ZF = "div";
function PF(e) {
  return Array.isArray(e) ? e.toString() : e;
}
function L9(e, n, a) {
  if (n === void 0)
    return Array.isArray(e) ? e : !!a;
  const i = PF(n);
  return Array.isArray(e) ? a ? e.includes(i) ? e : [...e, i] : e.filter((h) => h !== i) : a ? i : e === i ? !1 : e;
}
var NF = He(
  function(n) {
    var a = n, {
      store: i,
      name: h,
      value: g,
      checked: m,
      defaultChecked: S,
      hideOnClick: b = !1
    } = a, R = Ue(a, [
      "store",
      "name",
      "value",
      "checked",
      "defaultChecked",
      "hideOnClick"
    ]);
    const D = sw();
    i = i || D, Ht(
      i,
      process.env.NODE_ENV !== "production" && "MenuItemCheckbox must be wrapped in a MenuList or Menu component"
    );
    const T = Hx(S);
    wt(() => {
      i == null || i.setValue(h, (j = []) => T ? L9(j, g, !0) : j);
    }, [i, h, g, T]), wt(() => {
      m !== void 0 && (i == null || i.setValue(h, (j) => L9(j, g, m)));
    }, [i, h, g, m]);
    const A = W4({
      value: i.useState((j) => j.values[h]),
      setValue(j) {
        i == null || i.setValue(h, () => {
          if (m === void 0)
            return j;
          const I = L9(j, g, m);
          return !Array.isArray(I) || !Array.isArray(j) ? I : Jk(j, I) ? j : I;
        });
      }
    });
    return R = Q({
      role: "menuitemcheckbox"
    }, R), R = $x(Q({
      store: A,
      name: h,
      value: g,
      checked: m
    }, R)), R = E8(Q({ store: i, hideOnClick: b }, R)), R;
  }
), VF = Va(
  ke(function(n) {
    const a = NF(n);
    return Ie(ZF, a);
  })
), FF = "div";
function I9(e, n, a) {
  return a === void 0 ? e : a ? n : e;
}
var BF = He(
  function(n) {
    var a = n, {
      store: i,
      name: h,
      value: g,
      checked: m,
      onChange: S,
      hideOnClick: b = !1
    } = a, R = Ue(a, [
      "store",
      "name",
      "value",
      "checked",
      "onChange",
      "hideOnClick"
    ]);
    const D = sw();
    i = i || D, Ht(
      i,
      process.env.NODE_ENV !== "production" && "MenuItemRadio must be wrapped in a MenuList or Menu component"
    );
    const T = Hx(R.defaultChecked);
    wt(() => {
      i == null || i.setValue(h, (j = !1) => I9(j, g, T));
    }, [i, h, g, T]), wt(() => {
      m !== void 0 && (i == null || i.setValue(h, (j) => I9(j, g, m)));
    }, [i, h, g, m]);
    const A = i.useState((j) => j.values[h] === g);
    return R = Bn(
      R,
      (j) => /* @__PURE__ */ d.jsx(zM.Provider, { value: !!A, children: j }),
      [A]
    ), R = Q({
      role: "menuitemradio"
    }, R), R = Qx(Q({
      name: h,
      value: g,
      checked: A,
      onChange(j) {
        if (S == null || S(j), j.defaultPrevented)
          return;
        const I = j.currentTarget;
        i == null || i.setValue(h, (Z) => I9(Z, g, m ?? I.checked));
      }
    }, R)), R = E8(Q({ store: i, hideOnClick: b }, R)), R;
  }
), UF = Va(
  ke(function(n) {
    const a = BF(n);
    return Ie(FF, a);
  })
), YF = "hr", $F = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = Sf();
    return i = i || g, h = Q4(Q({ store: i }, h)), h;
  }
), iT = ke(function(n) {
  const a = $F(n);
  return Ie(YF, a);
});
function WF(e = {}) {
  const n = qM(e);
  return /* @__PURE__ */ d.jsx(y8, { value: n, children: e.children });
}
var zF = "div", qF = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = $M();
    return i = i || g, h = ow(Q({ store: i }, h)), h;
  }
), GF = ke(function(n) {
  const a = qF(n);
  return Ie(zF, a);
}), KF = "button", QF = He(function(n) {
  var a = n, { store: i } = a, h = Ue(a, ["store"]);
  const g = uw();
  i = i || g, Ht(
    i,
    process.env.NODE_ENV !== "production" && "HovercardDisclosure must receive a `store` prop or be wrapped in a HovercardProvider component."
  );
  const [m, S] = Kt(!1);
  wt(() => m ? Go("focusout", (Z) => {
    if (!i)
      return;
    const N = Z.relatedTarget;
    if (N) {
      const {
        anchorElement: B,
        popoverElement: $,
        disclosureElement: W
      } = i.getState();
      if (B && pa(B, N) || $ && pa($, N) || W && pa(W, N) || N.hasAttribute("data-focus-trap"))
        return;
    }
    S(!1);
  }, !0) : void 0, [m, i]), wt(() => Ea(i, ["anchorElement"], (I) => {
    const Z = I.anchorElement;
    if (!Z)
      return;
    const N = new MutationObserver(() => {
      Z.hasAttribute("data-focus-visible") && S(!0);
    });
    return N.observe(Z, { attributeFilter: ["data-focus-visible"] }), () => N.disconnect();
  }), [i]);
  const b = h.onClick, R = nt((I) => {
    b == null || b(I), !I.defaultPrevented && (i == null || i.setAutoFocusOnShow(!0));
  }), D = h.onFocus, T = nt((I) => {
    D == null || D(I), !I.defaultPrevented && S(!0);
  }), { style: A } = Xx();
  return m || (h = De(Q({}, h), {
    style: Q(Q({}, A), h.style)
  })), h = De(Q({
    children: /* @__PURE__ */ d.jsx(
      "svg",
      {
        display: "block",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        viewBox: "0 0 16 16",
        height: "1em",
        width: "1em",
        children: /* @__PURE__ */ d.jsx("polyline", { points: "4,6 8,10 12,6" })
      }
    )
  }, h), {
    ref: In(i.setDisclosureElement, h.ref),
    onClick: R,
    onFocus: T
  }), h = z5(Q({ store: i }, h)), h;
}), XF = ke(function(n) {
  const a = QF(n);
  return Ie(KF, a);
});
function JF(e = {}) {
  var n;
  process.env.NODE_ENV !== "production" && e.type === "label" && console.warn(
    "The `type` option on the tooltip store is deprecated.",
    "Render a visually hidden label or use the `aria-label` or `aria-labelledby` attributes on the anchor element instead.",
    "See https://ariakit.org/components/tooltip#tooltip-anchors-must-have-accessible-names"
  );
  const a = (n = e.store) == null ? void 0 : n.getState(), i = S8(pn(Ct({}, e), {
    placement: ht(
      e.placement,
      a == null ? void 0 : a.placement,
      "top"
    ),
    hideTimeout: ht(e.hideTimeout, a == null ? void 0 : a.hideTimeout, 0)
  })), h = pn(Ct({}, i.getState()), {
    type: ht(e.type, a == null ? void 0 : a.type, "description"),
    skipTimeout: ht(e.skipTimeout, a == null ? void 0 : a.skipTimeout, 300)
  }), g = ho(h, i, e.store);
  return Ct(Ct({}, i), g);
}
function eB(e, n, a) {
  return lr(e, a, "type"), lr(e, a, "skipTimeout"), C8(e, n, a);
}
function M8(e = {}) {
  const [n, a] = Ci(JF, e);
  return eB(n, a, e);
}
var fw = bi(
  [y8],
  [x8]
), lT = fw.useContext, T8 = fw.useProviderContext, tB = fw.ContextProvider, nB = fw.ScopedContextProvider, rB = "div", aB = He(
  function(n) {
    var a = n, {
      store: i,
      portal: h = !0,
      gutter: g = 8,
      preserveTabOrder: m = !1,
      hideOnHoverOutside: S = !0,
      hideOnInteractOutside: b = !0
    } = a, R = Ue(a, [
      "store",
      "portal",
      "gutter",
      "preserveTabOrder",
      "hideOnHoverOutside",
      "hideOnInteractOutside"
    ]);
    const D = T8();
    i = i || D, Ht(
      i,
      process.env.NODE_ENV !== "production" && "Tooltip must receive a `store` prop or be wrapped in a TooltipProvider component."
    ), R = Bn(
      R,
      (A) => /* @__PURE__ */ d.jsx(nB, { value: i, children: A }),
      [i]
    );
    const T = i.useState(
      (A) => A.type === "description" ? "tooltip" : "none"
    );
    return R = Q({ role: T }, R), R = _8(De(Q({}, R), {
      store: i,
      portal: h,
      gutter: g,
      preserveTabOrder: m,
      hideOnHoverOutside(A) {
        if (O2(S, A))
          return !1;
        const j = i == null ? void 0 : i.getState().anchorElement;
        return j ? !("focusVisible" in j.dataset) : !0;
      },
      hideOnInteractOutside: (A) => {
        if (O2(b, A))
          return !1;
        const j = i == null ? void 0 : i.getState().anchorElement;
        return j ? !pa(j, A.target) : !0;
      }
    })), R;
  }
), uT = N2(
  ke(function(n) {
    const a = aB(n);
    return Ie(rB, a);
  }),
  T8
);
function oB(e = {}) {
  const n = M8(e);
  return /* @__PURE__ */ d.jsx(tB, { value: n, children: e.children });
}
var iB = "div", E2 = ho({
  activeStore: null
});
function oR(e) {
  return () => {
    const { activeStore: n } = E2.getState();
    n === e && E2.setState("activeStore", null);
  };
}
var lB = He(
  function(n) {
    var a = n, { store: i, showOnHover: h = !0 } = a, g = Ue(a, ["store", "showOnHover"]);
    const m = T8();
    i = i || m, Ht(
      i,
      process.env.NODE_ENV !== "production" && "TooltipAnchor must receive a `store` prop or be wrapped in a TooltipProvider component."
    );
    const S = Pt(!1);
    wt(() => Ea(i, ["mounted"], (N) => {
      N.mounted || (S.current = !1);
    }), [i]), wt(() => {
      if (i)
        return xl(
          // Immediately remove the current store from the global store when
          // the component unmounts. This is useful, for example, to avoid
          // showing tooltips immediately on serial tests.
          oR(i),
          Ea(i, ["mounted", "skipTimeout"], (N) => {
            if (!i)
              return;
            if (N.mounted) {
              const { activeStore: $ } = E2.getState();
              return $ !== i && ($ == null || $.hide()), E2.setState("activeStore", i);
            }
            const B = setTimeout(
              oR(i),
              N.skipTimeout
            );
            return () => clearTimeout(B);
          })
        );
    }, [i]);
    const b = g.onMouseEnter, R = nt((N) => {
      b == null || b(N), S.current = !0;
    }), D = g.onFocusVisible, T = nt((N) => {
      D == null || D(N), !N.defaultPrevented && (i == null || i.setAnchorElement(N.currentTarget), i == null || i.show());
    }), A = g.onBlur, j = nt((N) => {
      if (A == null || A(N), N.defaultPrevented)
        return;
      const { activeStore: B } = E2.getState();
      S.current = !1, B === i && E2.setState("activeStore", null);
    }), I = i.useState("type"), Z = i.useState((N) => {
      var B;
      return (B = N.contentElement) == null ? void 0 : B.id;
    });
    return g = De(Q({
      "aria-labelledby": I === "label" ? Z : void 0
    }, g), {
      onMouseEnter: R,
      onFocusVisible: T,
      onBlur: j
    }), g = R8(Q({
      store: i,
      showOnHover(N) {
        if (!S.current || O2(h, N))
          return !1;
        const { activeStore: B } = E2.getState();
        return B ? (i == null || i.show(), !1) : !0;
      }
    }, g)), g;
  }
), sT = ke(function(n) {
  const a = lB(n);
  return Ie(iB, a);
}), uB = "div", sB = He(
  function(n) {
    var a = n, { store: i, size: h = 16 } = a, g = Ue(a, ["store", "size"]);
    const m = lT();
    return i = i || m, Ht(
      i,
      process.env.NODE_ENV !== "production" && "TooltipArrow must be wrapped in a Tooltip component."
    ), g = ow(Q({ store: i, size: h }, g)), g;
  }
), cT = ke(function(n) {
  const a = sB(n);
  return Ie(uB, a);
});
function cB(e = {}) {
  var n;
  const a = (n = e.store) == null ? void 0 : n.getState();
  return ph(pn(Ct({}, e), {
    orientation: ht(
      e.orientation,
      a == null ? void 0 : a.orientation,
      "horizontal"
    ),
    focusLoop: ht(e.focusLoop, a == null ? void 0 : a.focusLoop, !0)
  }));
}
function fB(e, n, a) {
  return mh(e, n, a);
}
function O8(e = {}) {
  const [n, a] = Ci(cB, e);
  return fB(n, a, e);
}
var dw = bi(
  [B0],
  [vh]
), l3 = dw.useContext, dB = dw.useProviderContext, hB = dw.ContextProvider, vB = dw.ScopedContextProvider, pB = "div", mB = He(
  function(n) {
    var a = n, {
      store: i,
      orientation: h,
      virtualFocus: g,
      focusLoop: m,
      rtl: S
    } = a, b = Ue(a, [
      "store",
      "orientation",
      "virtualFocus",
      "focusLoop",
      "rtl"
    ]);
    const R = dB();
    i = i || R;
    const D = O8({
      store: i,
      orientation: h,
      virtualFocus: g,
      focusLoop: m,
      rtl: S
    }), T = D.useState(
      (A) => A.orientation === "both" ? void 0 : A.orientation
    );
    return b = Bn(
      b,
      (A) => /* @__PURE__ */ d.jsx(vB, { value: D, children: A }),
      [D]
    ), b = Q({
      role: "toolbar",
      "aria-orientation": T
    }, b), b = gh(Q({ store: D }, b)), b;
  }
), gB = ke(function(n) {
  const a = mB(n);
  return Ie(pB, a);
});
function wB(e = {}) {
  const n = O8(e);
  return /* @__PURE__ */ d.jsx(hB, { value: n, children: e.children });
}
var yB = "div";
function iR(e) {
  y5(e);
  const n = H5(e);
  return Op(e), n;
}
var fT = He(function(n) {
  var a = n, { store: i } = a, h = Ue(a, ["store"]);
  const g = Z2();
  i = i || g;
  const m = Pt(null), S = Pt(!1), b = (W = !1) => {
    const z = m.current;
    if (!z)
      return;
    y5(z);
    const Y = H5(z);
    if (!Y) {
      Op(z);
      return;
    }
    S.current = !0, queueMicrotask(() => {
      Y.focus(), (yl(Y) || Y.isContentEditable) && VE(Y, W);
    });
  }, R = () => {
    const W = m.current;
    W && (S.current = !1, Op(W));
  }, D = Ia(i, "renderedItems");
  wt(() => {
    const W = m.current;
    if (!W)
      return;
    !S.current && (D != null && D.length) && Op(W);
  }, [D]);
  const T = h.onFocus, A = nt((W) => {
    if (T == null || T(W), W.defaultPrevented || !i)
      return;
    const z = S.current;
    if (Si(W)) {
      S.current = !1;
      const { baseElement: Y } = i.getState(), ie = Y, pe = ie == null ? void 0 : ie.querySelectorAll("[data-composite-container]");
      pe == null || pe.forEach((J) => Op(J));
    } else z || (S.current = !0, y5(W.currentTarget), i == null || i.setState("moves", 0));
  }), j = h.onBlur, I = nt((W) => {
    j == null || j(W), !W.defaultPrevented && Qd(W) && R();
  }), Z = h.onKeyDown, N = nt((W) => {
    if (Z == null || Z(W), W.defaultPrevented || W.altKey || W.ctrlKey || W.metaKey || W.shiftKey)
      return;
    const z = W.currentTarget;
    if (Si(W)) {
      if (W.key.length === 1 && W.key !== " ") {
        const Y = iR(z);
        if (!Y)
          return;
        (yl(Y) || Y.isContentEditable) && (W.stopPropagation(), b());
      } else if (W.key === "Delete" || W.key === "Backspace") {
        const Y = iR(z);
        if (!Y)
          return;
        if (yl(Y) || Y.isContentEditable) {
          b();
          const ie = () => queueMicrotask(() => z.focus());
          z.addEventListener("input", ie, { once: !0 });
        }
      }
    } else if (W.key === "Escape")
      queueMicrotask(() => z.focus());
    else if (W.key === "Enter") {
      const Y = W.target;
      (Y.tagName === "INPUT" && !N0(Y) || Y.tagName === "TEXTAREA" || Y.isContentEditable) && (W.preventDefault(), queueMicrotask(() => z.focus()));
    }
  }), B = h.onClick, $ = nt((W) => {
    B == null || B(W), !W.defaultPrevented && Si(W) && !W.detail && b(!0);
  });
  return h = De(Q({
    "data-composite-container": ""
  }, h), {
    ref: In(m, h.ref),
    onFocus: A,
    onBlur: I,
    onKeyDown: N,
    onClick: $
  }), Pa(h);
});
ke(function(n) {
  const a = fT(n);
  return Ie(yB, a);
});
var xB = "button", D8 = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = l3();
    return i = i || g, h = P2(Q({ store: i }, h)), h;
  }
), SB = Va(
  ke(function(n) {
    const a = D8(n);
    return Ie(xB, a);
  })
), CB = "div", bB = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = l3();
    return i = i || g, h = fT(Q({ store: i }, h)), h = D8(Q({ store: i }, h)), h;
  }
), _B = Va(
  ke(function(n) {
    const a = bB(n);
    return Ie(CB, a);
  })
), RB = "input", EB = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = l3();
    return i = i || g, h = D8(Q({ store: i }, h)), h;
  }
), MB = Va(
  ke(function(n) {
    const a = EB(n);
    return Ie(RB, a);
  })
), TB = "hr", OB = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = l3();
    return i = i || g, h = Q4(Q({ store: i }, h)), h;
  }
), DB = ke(function(n) {
  const a = OB(n);
  return Ie(TB, a);
}), u3 = bi(
  [ew, B0],
  [t3, vh]
), Cf = u3.useContext, AB = u3.useScopedContext, s3 = u3.useProviderContext, jB = u3.ContextProvider, dT = u3.ScopedContextProvider, hT = Za(!1);
function vT(e = {}) {
  var n = e, {
    composite: a,
    combobox: i
  } = n, h = Fp(n, [
    "composite",
    "combobox"
  ]);
  const g = [
    "items",
    "renderedItems",
    "moves",
    "orientation",
    "baseElement",
    "focusLoop",
    "focusShift",
    "focusWrap"
  ], m = Up(
    h.store,
    Pp(a, g),
    Pp(i, g)
  ), S = m == null ? void 0 : m.getState(), b = ph(pn(Ct({}, h), {
    orientation: ht(
      h.orientation,
      S == null ? void 0 : S.orientation,
      "horizontal"
    ),
    focusLoop: ht(h.focusLoop, S == null ? void 0 : S.focusLoop, !0)
  })), R = L5(), D = pn(Ct({}, b.getState()), {
    selectedId: ht(
      h.selectedId,
      S == null ? void 0 : S.selectedId,
      h.defaultSelectedId,
      void 0
    ),
    selectOnMove: ht(
      h.selectOnMove,
      S == null ? void 0 : S.selectOnMove,
      !0
    )
  }), T = ho(D, b, m);
  return Ha(
    T,
    () => Ea(T, ["moves"], () => {
      const { activeId: A, selectOnMove: j } = T.getState();
      if (!j || !A)
        return;
      const I = b.item(A);
      I && (I.dimmed || I.disabled || T.setState("selectedId", I.id));
    })
  ), Ha(
    T,
    () => A2(
      T,
      ["selectedId"],
      (A) => T.setState("activeId", A.selectedId)
    )
  ), Ha(
    T,
    () => Ea(T, ["selectedId", "renderedItems"], (A) => {
      if (A.selectedId !== void 0)
        return;
      const { activeId: j, renderedItems: I } = T.getState(), Z = b.item(j);
      if (Z && !Z.disabled && !Z.dimmed)
        T.setState("selectedId", Z.id);
      else {
        const N = I.find(
          (B) => !B.disabled && !B.dimmed
        );
        T.setState("selectedId", N == null ? void 0 : N.id);
      }
    })
  ), Ha(
    T,
    () => Ea(T, ["renderedItems"], (A) => {
      const j = A.renderedItems;
      if (j.length)
        return Ea(R, ["renderedItems"], (I) => {
          const Z = I.renderedItems;
          Z.some((B) => !B.tabId) && Z.forEach((B, $) => {
            if (B.tabId)
              return;
            const W = j[$];
            W && R.renderItem(pn(Ct({}, B), { tabId: W.id }));
          });
        });
    })
  ), pn(Ct(Ct({}, b), T), {
    panels: R,
    setSelectedId: (A) => T.setState("selectedId", A),
    select: (A) => {
      T.setState("selectedId", A), b.move(A);
    }
  });
}
function kB(e, n, a) {
  R1(n, [a.composite, a.combobox]), e = mh(e, n, a), lr(e, a, "selectedId", "setSelectedId"), lr(e, a, "selectOnMove");
  const [i, h] = Ci(() => e.panels, {});
  return R1(h, [e, h]), Object.assign(
    qr(() => De(Q({}, e), { panels: i }), [e, i]),
    { composite: a.composite, combobox: a.combobox }
  );
}
function hw(e = {}) {
  const n = i8(), a = Cf() || n;
  e = De(Q({}, e), {
    composite: e.composite !== void 0 ? e.composite : a,
    combobox: e.combobox !== void 0 ? e.combobox : n
  });
  const [i, h] = Ci(vT, e);
  return kB(i, h, e);
}
var c3 = bi(
  [B0],
  [vh]
), A8 = c3.useContext, LB = c3.useScopedContext, pT = c3.useProviderContext, IB = c3.ContextProvider, mT = c3.ScopedContextProvider, HB = "button", ZB = He(function(n) {
  var a = n, {
    store: i,
    accessibleWhenDisabled: h = !0,
    getItem: g
  } = a, m = Ue(a, [
    "store",
    "accessibleWhenDisabled",
    "getItem"
  ]);
  const S = LB();
  i = i || S, Ht(
    i,
    process.env.NODE_ENV !== "production" && "Tab must be wrapped in a TabList component."
  );
  const b = Na(), R = m.id || b, D = wf(m), T = Pr(
    (B) => {
      const $ = De(Q({}, B), { dimmed: D });
      return g ? g($) : $;
    },
    [D, g]
  ), A = m.onClick, j = nt((B) => {
    A == null || A(B), !B.defaultPrevented && (i == null || i.setSelectedId(R));
  }), I = i.panels.useState(
    (B) => {
      var $;
      return ($ = B.items.find((W) => W.tabId === R)) == null ? void 0 : $.id;
    }
  ), Z = i.useState((B) => !!R && B.selectedId === R), N = b ? m.shouldRegisterItem : !1;
  return m = Bn(
    m,
    (B) => {
      if (!(i != null && i.composite))
        return B;
      const $ = {
        id: R,
        store: i.composite,
        shouldRegisterItem: Z && N,
        render: B
      };
      return /* @__PURE__ */ d.jsx(
        X9,
        De(Q({}, $), {
          render: i.combobox && i.composite !== i.combobox ? /* @__PURE__ */ d.jsx(X9, De(Q({}, $), { store: i.combobox })) : B
        })
      );
    },
    [i, R, Z, N]
  ), m = De(Q({
    id: R,
    role: "tab",
    "aria-selected": Z,
    "aria-controls": I || void 0
  }, m), {
    onClick: j
  }), m = P2(De(Q({
    store: i
  }, m), {
    accessibleWhenDisabled: h,
    getItem: T,
    shouldRegisterItem: N
  })), m;
}), gT = Va(
  ke(function(n) {
    const a = ZB(n);
    return Ie(HB, a);
  })
);
function wT(e = {}) {
  const n = hw(e);
  return /* @__PURE__ */ d.jsx(IB, { value: n, children: e.children });
}
var PB = "div", NB = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = pT();
    i = i || g, Ht(
      i,
      process.env.NODE_ENV !== "production" && "TabList must receive a `store` prop or be wrapped in a TabProvider component."
    );
    const m = i.useState(
      (S) => S.orientation === "both" ? void 0 : S.orientation
    );
    return h = Bn(
      h,
      (S) => /* @__PURE__ */ d.jsx(mT, { value: i, children: S }),
      [i]
    ), i.composite && (h = Q({
      focusable: !1
    }, h)), h = Q({
      role: "tablist",
      "aria-orientation": m
    }, h), h = gh(Q({ store: i }, h)), h;
  }
), yT = ke(function(n) {
  const a = NB(n);
  return Ie(PB, a);
}), VB = "div", FB = He(
  function(n) {
    var a = n, {
      store: i,
      unmountOnHide: h,
      tabId: g,
      getItem: m
    } = a, S = Ue(a, [
      "store",
      "unmountOnHide",
      "tabId",
      "getItem"
    ]);
    const b = pT();
    i = i || b, Ht(
      i,
      process.env.NODE_ENV !== "production" && "TabPanel must receive a `store` prop or be wrapped in a TabProvider component."
    );
    const R = Pt(null), D = Na(S.id), [T, A] = Kt(!1);
    wt(() => {
      const z = R.current;
      if (!z)
        return;
      const Y = Yp(z);
      A(!!Y.length);
    }, []);
    const j = Pr(
      (z) => {
        const Y = De(Q({}, z), { id: D || z.id, tabId: g });
        return m ? m(Y) : Y;
      },
      [D, g, m]
    ), I = S.onKeyDown, Z = nt((z) => {
      if (I == null || I(z), z.defaultPrevented || !(i != null && i.composite))
        return;
      const { items: Y, renderedItems: ie, selectedId: G } = i.getState(), pe = vT({ items: Y, activeId: G });
      pe.setState("renderedItems", ie);
      const me = {
        ArrowLeft: pe.previous,
        ArrowRight: pe.next,
        Home: pe.first,
        End: pe.last
      }[z.key];
      if (!me)
        return;
      const oe = me();
      oe && (z.preventDefault(), i.select(oe));
    });
    S = Bn(
      S,
      (z) => /* @__PURE__ */ d.jsx(mT, { value: i, children: z }),
      [i]
    );
    const N = i.panels.useState(
      () => {
        var z;
        return g || ((z = i == null ? void 0 : i.panels.item(D)) == null ? void 0 : z.tabId);
      }
    ), B = i.useState(
      (z) => !!N && z.selectedId === N
    ), $ = B5({ open: B }), W = $.useState("mounted");
    return S = De(Q({
      id: D,
      role: "tabpanel",
      "aria-labelledby": N || void 0
    }, S), {
      children: h && !W ? null : S.children,
      ref: In(R, S.ref),
      onKeyDown: Z
    }), S = H2(Q({
      // If the tab panel is rendered as part of another composite widget such
      // as combobox, it should not be focusable.
      focusable: !i.composite && !T
    }, S)), S = $5(Q({ store: $ }, S)), S = dh(De(Q({ store: i.panels }, S), { getItem: j })), S;
  }
), xT = ke(function(n) {
  const a = FB(n);
  return Ie(VB, a);
});
function BB(e = {}) {
  var n = e, {
    combobox: a
  } = n, i = Fp(n, [
    "combobox"
  ]);
  const h = Up(
    i.store,
    Pp(a, [
      "value",
      "items",
      "renderedItems",
      "baseElement",
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    ])
  );
  fh(i, h);
  const g = h.getState(), m = ph(pn(Ct({}, i), {
    store: h,
    virtualFocus: ht(
      i.virtualFocus,
      g.virtualFocus,
      !0
    ),
    includesBaseElement: ht(
      i.includesBaseElement,
      g.includesBaseElement,
      !1
    ),
    activeId: ht(
      i.activeId,
      g.activeId,
      i.defaultActiveId,
      null
    ),
    orientation: ht(
      i.orientation,
      g.orientation,
      "vertical"
    )
  })), S = Q5(pn(Ct({}, i), {
    store: h,
    placement: ht(
      i.placement,
      g.placement,
      "bottom-start"
    )
  })), b = new String(""), R = pn(Ct(Ct({}, m.getState()), S.getState()), {
    value: ht(
      i.value,
      g.value,
      i.defaultValue,
      b
    ),
    setValueOnMove: ht(
      i.setValueOnMove,
      g.setValueOnMove,
      !1
    ),
    selectElement: ht(g.selectElement, null),
    labelElement: ht(g.labelElement, null)
  }), D = ho(R, m, S, h);
  return Ha(
    D,
    () => Ea(D, ["value", "items"], (T) => {
      if (T.value !== b || !T.items.length)
        return;
      const A = T.items.find(
        (j) => !j.disabled && j.value != null
      );
      (A == null ? void 0 : A.value) != null && D.setState("value", A.value);
    })
  ), Ha(
    D,
    () => Ea(D, ["mounted", "items", "value"], (T) => {
      if (a || T.mounted)
        return;
      const A = mM(T.value), j = A[A.length - 1];
      if (j == null)
        return;
      const I = T.items.find(
        (Z) => !Z.disabled && Z.value === j
      );
      I && D.setState("activeId", I.id);
    })
  ), Ha(
    D,
    () => A2(D, ["setValueOnMove", "moves"], (T) => {
      const { mounted: A, value: j, activeId: I } = D.getState();
      if (!T.setValueOnMove && A || Array.isArray(j) || !T.moves || !I)
        return;
      const Z = m.item(I);
      !Z || Z.disabled || Z.value == null || D.setState("value", Z.value);
    })
  ), pn(Ct(Ct(Ct({}, m), S), D), {
    combobox: a,
    setValue: (T) => D.setState("value", T),
    setSelectElement: (T) => D.setState("selectElement", T),
    setLabelElement: (T) => D.setState("labelElement", T)
  });
}
function UB(e, n, a) {
  return R1(n, [a.combobox]), lr(e, a, "value", "setValue"), lr(e, a, "setValueOnMove"), Object.assign(
    X5(
      mh(e, n, a),
      n,
      a
    ),
    { combobox: a.combobox }
  );
}
function Gp(e = {}) {
  const n = yh();
  e = De(Q({}, e), {
    combobox: e.combobox !== void 0 ? e.combobox : n
  });
  const [a, i] = Ci(BB, e);
  return UB(a, i, e);
}
var YB = "span", $B = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = Cf();
    return i = i || g, h = m8(Q({ store: i }, h)), h;
  }
), vw = ke(function(n) {
  const a = $B(n);
  return Ie(YB, a);
}), WB = "button";
function zB(e) {
  return Array.from(e.selectedOptions).map((n) => n.value);
}
function t5(e, n) {
  return () => {
    const a = n();
    if (!a)
      return;
    let i = 0, h = e.item(a);
    const g = h;
    for (; h && h.value == null; ) {
      const m = n(++i);
      if (!m)
        return;
      if (h = e.item(m), h === g)
        break;
    }
    return h == null ? void 0 : h.id;
  };
}
var qB = He(function(n) {
  var a = n, {
    store: i,
    name: h,
    form: g,
    required: m,
    showOnKeyDown: S = !0,
    moveOnKeyDown: b = !0,
    toggleOnClick: R = !1,
    toggleOnPress: D = !R
  } = a, T = Ue(a, [
    "store",
    "name",
    "form",
    "required",
    "showOnKeyDown",
    "moveOnKeyDown",
    "toggleOnClick",
    "toggleOnPress"
  ]);
  const A = s3();
  i = i || A, Ht(
    i,
    process.env.NODE_ENV !== "production" && "Select must receive a `store` prop or be wrapped in a SelectProvider component."
  ), D = R ? !1 : D;
  const j = T.onKeyDown, I = rr(S), Z = rr(b), N = rr(D), $ = i.useState("placement").split("-")[0], W = i.useState("value"), z = Array.isArray(W), Y = nt((ue) => {
    var Ae;
    if (j == null || j(ue), ue.defaultPrevented || !i)
      return;
    const { orientation: Pe, items: dt, activeId: Ze } = i.getState();
    (ue.key === " " || ue.key === "Enter") && N(ue) && (ue.preventDefault(), i.toggle());
    const qe = Pe !== "horizontal", Je = Pe !== "vertical", ot = !!((Ae = dt.find((qn) => !qn.disabled && qn.value != null)) != null && Ae.rowId), Tn = {
      ArrowUp: (ot || qe) && t5(i, i.up),
      ArrowRight: (ot || Je) && t5(i, i.next),
      ArrowDown: (ot || qe) && t5(i, i.down),
      ArrowLeft: (ot || Je) && t5(i, i.previous)
    }[ue.key];
    Tn && Z(ue) && (ue.preventDefault(), i.move(Tn()));
    const Qt = $ === "top" || $ === "bottom";
    ({
      ArrowDown: Qt,
      ArrowUp: Qt,
      ArrowLeft: $ === "left",
      ArrowRight: $ === "right"
    })[ue.key] && I(ue) && (ue.preventDefault(), i.move(Ze), D2(ue.currentTarget, "keyup", i.show));
  }), ie = T.onMouseDown, G = nt((ue) => {
    if (ie == null || ie(ue), ue.defaultPrevented || ue.button || ue.ctrlKey || !N(ue))
      return;
    const Ae = ue.currentTarget;
    D2(Ae, "focusin", () => {
      i == null || i.setDisclosureElement(Ae), i == null || i.toggle();
    });
  });
  T = Bn(
    T,
    (ue) => /* @__PURE__ */ d.jsx(dT, { value: i, children: ue }),
    [i]
  );
  const [pe, J] = Kt(!1), me = Pt(!1);
  wt(() => {
    const ue = me.current;
    me.current = !1, !ue && J(!1);
  }, [W]);
  const oe = i.useState((ue) => {
    var Ae;
    return (Ae = ue.labelElement) == null ? void 0 : Ae.id;
  }), ge = T["aria-label"], ce = T["aria-labelledby"] || oe, Se = i.useState((ue) => {
    if (h)
      return ue.items;
  }), Re = qr(() => [...new Set(Se == null ? void 0 : Se.map((ue) => ue.value).filter((ue) => ue != null))], [Se]);
  T = Bn(
    T,
    (ue) => h ? /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
      /* @__PURE__ */ d.jsxs(
        "select",
        {
          style: {
            border: 0,
            clip: "rect(0 0 0 0)",
            height: "1px",
            margin: "-1px",
            overflow: "hidden",
            padding: 0,
            position: "absolute",
            whiteSpace: "nowrap",
            width: "1px"
          },
          tabIndex: -1,
          "aria-hidden": !0,
          "aria-label": ge,
          "aria-labelledby": ce,
          name: h,
          form: g,
          required: m,
          value: W,
          multiple: z,
          onFocus: () => {
            var Ae;
            return (Ae = i == null ? void 0 : i.getState().selectElement) == null ? void 0 : Ae.focus();
          },
          onChange: (Ae) => {
            me.current = !0, J(!0), i == null || i.setValue(
              z ? zB(Ae.target) : Ae.target.value
            );
          },
          children: [
            mM(W).map((Ae) => Ae == null || Re.includes(Ae) ? null : /* @__PURE__ */ d.jsx("option", { value: Ae, children: Ae }, Ae)),
            Re.map((Ae) => /* @__PURE__ */ d.jsx("option", { value: Ae, children: Ae }, Ae))
          ]
        }
      ),
      ue
    ] }) : ue,
    [
      i,
      ge,
      ce,
      h,
      g,
      m,
      W,
      z,
      Re
    ]
  );
  const _e = /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    W,
    /* @__PURE__ */ d.jsx(vw, {})
  ] }), Ye = i.useState("contentElement");
  return T = De(Q({
    role: "combobox",
    "aria-autocomplete": "none",
    "aria-labelledby": oe,
    "aria-haspopup": sh(Ye, "listbox"),
    "data-autofill": pe || void 0,
    "data-name": h,
    children: _e
  }, T), {
    ref: In(i.setSelectElement, T.ref),
    onKeyDown: Y,
    onMouseDown: G
  }), T = g8(Q({ store: i, toggleOnClick: R }, T)), T = X4(Q({ store: i }, T)), T;
}), f3 = ke(function(n) {
  const a = qB(n);
  return Ie(WB, a);
});
function ST(e = {}) {
  const n = Gp(e);
  return /* @__PURE__ */ d.jsx(jB, { value: n, children: e.children });
}
var GB = "div", KB = He(
  function(n) {
    return n = q5(n), n;
  }
), CT = ke(function(n) {
  const a = KB(n);
  return Ie(GB, a);
}), QB = "div", XB = He(
  function(n) {
    return n = G5(n), n;
  }
), bT = ke(function(n) {
  const a = XB(n);
  return Ie(QB, a);
}), JB = "span", eU = He(
  function(n) {
    var a = n, { store: i, checked: h } = a, g = Ue(a, ["store", "checked"]);
    const m = Qo(hT);
    return h = h ?? m, g = P5(De(Q({}, g), { checked: h })), g;
  }
), _T = ke(function(n) {
  const a = eU(n);
  return Ie(JB, a);
}), tU = "div";
function nU(e, n) {
  if (n != null)
    return e == null ? !1 : Array.isArray(e) ? e.includes(n) : e === n;
}
var rU = He(
  function(n) {
    var a = n, {
      store: i,
      value: h,
      getItem: g,
      hideOnClick: m,
      setValueOnClick: S = h != null,
      preventScrollOnKeyDown: b = !0,
      focusOnHover: R = !0
    } = a, D = Ue(a, [
      "store",
      "value",
      "getItem",
      "hideOnClick",
      "setValueOnClick",
      "preventScrollOnKeyDown",
      "focusOnHover"
    ]), T;
    const A = AB();
    i = i || A, Ht(
      i,
      process.env.NODE_ENV !== "production" && "SelectItem must be wrapped in a SelectList or SelectPopover component."
    );
    const j = Na(D.id), I = wf(D), Z = Pr(
      (J) => {
        const me = De(Q({}, J), {
          value: I ? void 0 : h,
          children: h
        });
        return g ? g(me) : me;
      },
      [I, h, g]
    ), N = i.useState(
      (J) => Array.isArray(J.value)
    );
    m = m ?? (h != null && !N);
    const B = D.onClick, $ = rr(S), W = rr(m), z = nt((J) => {
      B == null || B(J), !J.defaultPrevented && (Ix(J) || Lx(J) || ($(J) && h != null && (i == null || i.setValue((me) => Array.isArray(me) ? me.includes(h) ? me.filter((oe) => oe !== h) : [...me, h] : h)), W(J) && (i == null || i.hide())));
    }), Y = i.useState((J) => nU(J.value, h));
    D = Bn(
      D,
      (J) => /* @__PURE__ */ d.jsx(hT.Provider, { value: Y ?? !1, children: J }),
      [Y]
    );
    const ie = i.useState("contentElement"), G = i.useState((J) => J.activeId !== j && (i != null && i.item(J.activeId)) || J.value == null || h == null ? !1 : Array.isArray(J.value) ? J.value[J.value.length - 1] === h : J.value === h);
    D = De(Q({
      id: j,
      role: Dx(ie),
      "aria-selected": Y,
      children: h
    }, D), {
      autoFocus: (T = D.autoFocus) != null ? T : G,
      onClick: z
    }), D = P2(Q({
      store: i,
      getItem: Z,
      preventScrollOnKeyDown: b
    }, D));
    const pe = rr(R);
    return D = K5(De(Q({
      store: i
    }, D), {
      // We have to disable focusOnHover when the popup is closed, otherwise
      // the active item will change to null (the container) when the popup is
      // closed by clicking on an item.
      focusOnHover(J) {
        if (!pe(J))
          return !1;
        const me = i == null ? void 0 : i.getState();
        return !!(me != null && me.open);
      }
    })), D;
  }
), pw = Va(
  ke(function(n) {
    const a = rU(n);
    return Ie(tU, a);
  })
), aU = "div", oU = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = s3();
    i = i || g, Ht(
      i,
      process.env.NODE_ENV !== "production" && "SelectLabel must receive a `store` prop or be wrapped in a SelectProvider component."
    );
    const m = Na(h.id), S = h.onClick, b = nt((R) => {
      S == null || S(R), !R.defaultPrevented && queueMicrotask(() => {
        const D = i == null ? void 0 : i.getState().selectElement;
        D == null || D.focus(), D == null || D.click();
      });
    });
    return h = De(Q({
      id: m
    }, h), {
      ref: In(i.setLabelElement, h.ref),
      onClick: b,
      style: Q({
        cursor: "default"
      }, h.style)
    }), Pa(h);
  }
), mw = Va(
  ke(function(n) {
    const a = oU(n);
    return Ie(aU, a);
  })
), iU = "div", RT = He(
  function(n) {
    var a = n, {
      store: i,
      resetOnEscape: h = !0,
      hideOnEnter: g = !0,
      focusOnMove: m = !0,
      composite: S,
      alwaysVisible: b
    } = a, R = Ue(a, [
      "store",
      "resetOnEscape",
      "hideOnEnter",
      "focusOnMove",
      "composite",
      "alwaysVisible"
    ]);
    const D = s3();
    i = i || D, Ht(
      i,
      process.env.NODE_ENV !== "production" && "SelectList must receive a `store` prop or be wrapped in a SelectProvider component."
    );
    const T = Pt(null), A = Na(R.id), j = i.useState("value"), I = Array.isArray(j), [Z, N] = Kt(j), B = i.useState("mounted");
    wt(() => {
      B || N(j);
    }, [B, j]), h = h && !I;
    const $ = R.onKeyDown, W = rr(h), z = rr(g), Y = nt((ce) => {
      $ == null || $(ce), !ce.defaultPrevented && (ce.key === "Escape" && W(ce) && (i == null || i.setValue(Z)), (ce.key === " " || ce.key === "Enter") && Si(ce) && z(ce) && (ce.preventDefault(), i == null || i.hide()));
    });
    R = Bn(
      R,
      (ce) => /* @__PURE__ */ d.jsx(dT, { value: i, children: ce }),
      [i]
    );
    const ie = i.useState((ce) => {
      var Se;
      return (Se = ce.labelElement) == null ? void 0 : Se.id;
    }), G = !!i.combobox;
    S = S ?? !G, S && (R = Q({ role: "listbox" }, R));
    const pe = vE(T, "role", R.role), me = (S || (pe === "listbox" || pe === "menu" || pe === "tree" || pe === "grid")) && I || void 0, oe = G4(B, R.hidden, b), ge = oe ? De(Q({}, R.style), { display: "none" }) : R.style;
    return R = De(Q({
      id: A,
      "aria-labelledby": ie,
      "aria-multiselectable": me,
      hidden: oe
    }, R), {
      ref: In(A ? i.setContentElement : null, T, R.ref),
      style: ge,
      onKeyDown: Y
    }), R = gh(De(Q({ store: i }, R), { composite: S })), R = X4(Q({ store: i, typeahead: !G }, R)), R;
  }
), lU = ke(function(n) {
  const a = RT(n);
  return Ie(iU, a);
}), uU = "div", sU = He(
  function(n) {
    var a = n, { store: i, alwaysVisible: h } = a, g = Ue(a, ["store", "alwaysVisible"]);
    const m = s3();
    return i = i || m, g = RT(Q({ store: i, alwaysVisible: h }, g)), g = aw(Q({ store: i, alwaysVisible: h }, g)), g;
  }
), gw = N2(
  ke(function(n) {
    const a = sU(n);
    return Ie(uU, a);
  }),
  s3
), cU = "div", fU = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = Cf();
    i = i || g, Ht(
      i,
      process.env.NODE_ENV !== "production" && "SelectRow must be wrapped in a SelectList or SelectPopover component"
    );
    const m = i.useState("contentElement"), b = sh(m) === "grid" ? "row" : "presentation";
    return h = Q({ role: b }, h), h = a8(Q({ store: i }, h)), h;
  }
), dU = ke(function(n) {
  const a = fU(n);
  return Ie(cU, a);
}), hU = "hr", vU = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = Cf();
    return i = i || g, h = Q4(Q({ store: i }, h)), h;
  }
), pU = ke(function(n) {
  const a = vU(n);
  return Ie(hU, a);
});
function mU(e = {}) {
  var n = Fp(e, []), a;
  const i = (a = n.store) == null ? void 0 : a.getState(), h = ph(pn(Ct({}, n), {
    focusLoop: ht(n.focusLoop, i == null ? void 0 : i.focusLoop, !0)
  })), g = pn(Ct({}, h.getState()), {
    value: ht(
      n.value,
      i == null ? void 0 : i.value,
      n.defaultValue,
      null
    )
  }), m = ho(g, h, n.store);
  return pn(Ct(Ct({}, h), m), {
    setValue: (S) => m.setState("value", S)
  });
}
function gU(e, n, a) {
  return e = mh(e, n, a), lr(e, a, "value", "setValue"), e;
}
function ET(e = {}) {
  const [n, a] = Ci(mU, e);
  return gU(n, a, e);
}
function MT(e = {}) {
  const n = ET(e);
  return /* @__PURE__ */ d.jsx(lH, { value: n, children: e.children });
}
var wU = "div", yU = He(
  function(n) {
    var a = n, { store: i } = a, h = Ue(a, ["store"]);
    const g = iH();
    return i = i || g, Ht(
      i,
      process.env.NODE_ENV !== "production" && "RadioGroup must receive a `store` prop or be wrapped in a RadioProvider component."
    ), h = Bn(
      h,
      (m) => /* @__PURE__ */ d.jsx(uH, { value: i, children: m }),
      [i]
    ), h = Q({
      role: "radiogroup"
    }, h), h = gh(Q({ store: i }, h)), h;
  }
), TT = ke(function(n) {
  const a = yU(n);
  return Ie(wU, a);
});
const DQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: N5,
  Checkbox: TE,
  CheckboxCheck: hI,
  CheckboxProvider: sI,
  Collection: HL,
  CollectionItem: NL,
  CollectionProvider: ZL,
  Combobox: tw,
  ComboboxCancel: BP,
  ComboboxDisclosure: WP,
  ComboboxGroup: EM,
  ComboboxGroupLabel: RM,
  ComboboxItem: N4,
  ComboboxItemCheck: JP,
  ComboboxItemValue: rN,
  ComboboxLabel: cN,
  ComboboxList: u8,
  ComboboxPopover: PM,
  ComboboxProvider: _M,
  ComboboxRow: dV,
  ComboboxSeparator: pV,
  Command: lI,
  Composite: nP,
  CompositeGroup: lP,
  CompositeGroupLabel: oP,
  CompositeHover: fP,
  CompositeItem: X9,
  CompositeProvider: rP,
  CompositeRow: hP,
  CompositeSeparator: gP,
  CompositeTypeahead: bP,
  Dialog: cM,
  DialogDescription: HZ,
  DialogDisclosure: PZ,
  DialogDismiss: VZ,
  DialogHeading: YZ,
  DialogProvider: fM,
  Disclosure: GH,
  DisclosureContent: oZ,
  DisclosureProvider: KH,
  FocusTrap: Dp,
  FocusTrapRegion: YH,
  Focusable: aI,
  Form: jE,
  FormCheckbox: TI,
  FormControl: RI,
  FormDescription: AI,
  FormError: LE,
  FormField: HI,
  FormGroup: $I,
  FormGroupLabel: FI,
  FormInput: Kx,
  FormLabel: ZE,
  FormProvider: kE,
  FormPush: eH,
  FormRadio: MH,
  FormRadioGroup: rH,
  FormRemove: jH,
  FormReset: IH,
  FormSubmit: UE,
  Group: UI,
  GroupLabel: PI,
  Heading: BZ,
  HeadingLevel: lM,
  Hovercard: GV,
  HovercardAnchor: uF,
  HovercardArrow: GF,
  HovercardDescription: hF,
  HovercardDisclosure: XF,
  HovercardDismiss: wF,
  HovercardHeading: OF,
  HovercardProvider: WF,
  Menu: QM,
  MenuArrow: JM,
  MenuBar: eF,
  MenuBarProvider: tF,
  MenuButton: eT,
  MenuButtonArrow: iF,
  MenuDescription: mF,
  MenuDismiss: SF,
  MenuGroup: MF,
  MenuGroupLabel: _F,
  MenuHeading: aT,
  MenuItem: oT,
  MenuItemCheck: LF,
  MenuItemCheckbox: VF,
  MenuItemRadio: UF,
  MenuList: $V,
  MenuProvider: XM,
  MenuSeparator: iT,
  Menubar: HV,
  MenubarProvider: YM,
  Popover: ZM,
  PopoverAnchor: kP,
  PopoverArrow: qp,
  PopoverDescription: xV,
  PopoverDisclosure: iw,
  PopoverDisclosureArrow: bV,
  PopoverDismiss: EV,
  PopoverHeading: TV,
  PopoverProvider: NM,
  Portal: jZ,
  PortalContext: rx,
  Radio: BE,
  RadioGroup: TT,
  RadioProvider: MT,
  Role: P4,
  Select: f3,
  SelectArrow: vw,
  SelectGroup: bT,
  SelectGroupLabel: CT,
  SelectItem: pw,
  SelectItemCheck: _T,
  SelectLabel: mw,
  SelectList: lU,
  SelectPopover: gw,
  SelectProvider: ST,
  SelectRow: dU,
  SelectSeparator: pU,
  Separator: pP,
  Tab: gT,
  TabList: yT,
  TabPanel: xT,
  TabProvider: wT,
  Toolbar: gB,
  ToolbarContainer: _B,
  ToolbarInput: MB,
  ToolbarItem: SB,
  ToolbarProvider: wB,
  ToolbarSeparator: DB,
  Tooltip: uT,
  TooltipAnchor: sT,
  TooltipArrow: cT,
  TooltipProvider: oB,
  VisuallyHidden: NH,
  useCheckboxContext: bE,
  useCheckboxStore: W4,
  useCollectionContext: SE,
  useCollectionStore: xE,
  useComboboxContext: i8,
  useComboboxStore: J4,
  useCompositeContext: Z2,
  useCompositeStore: wM,
  useDialogContext: qE,
  useDialogStore: W5,
  useDisclosureContext: $H,
  useDisclosureStore: B5,
  useFormContext: Sl,
  useFormStore: Wx,
  useHovercardContext: $M,
  useHovercardStore: qM,
  useMenuBarContext: NV,
  useMenuBarStore: BV,
  useMenuContext: Sf,
  useMenuStore: b8,
  useMenubarContext: w8,
  useMenubarStore: lw,
  usePopoverContext: wh,
  usePopoverStore: o8,
  useRadioContext: NE,
  useRadioStore: ET,
  useSelectContext: Cf,
  useSelectStore: Gp,
  useTabContext: A8,
  useTabStore: hw,
  useToolbarContext: l3,
  useToolbarStore: O8,
  useTooltipContext: lT,
  useTooltipStore: M8
}, Symbol.toStringTag, { value: "Module" }));
function OT(e) {
  var n, a, i = "";
  if (typeof e == "string" || typeof e == "number") i += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (n = 0; n < e.length; n++) e[n] && (a = OT(e[n])) && (i && (i += " "), i += a);
  else for (n in e) e[n] && (i && (i += " "), i += n);
  return i;
}
function zr() {
  for (var e, n, a = 0, i = ""; a < arguments.length; ) (e = arguments[a++]) && (n = OT(e)) && (i && (i += " "), i += n);
  return i;
}
var xU = "f08kno0";
const Rt = Ma.forwardRef(
  ({ as: e = "div", cssClass: n, hiddenScroll: a, ...i }, h) => {
    const g = {}, m = {}, S = zr(n);
    for (const b in i)
      Y9.properties.has(b) ? g[b] = i[b] : m[b] = i[b];
    return Ma.createElement(e, {
      className: zr([
        Y9(g),
        S,
        { [xU]: a }
      ]),
      ref: h,
      ...m
    });
  }
);
Rt.displayName = "Box";
function SU(e, n) {
  if (typeof e != "object" || !e) return e;
  var a = e[Symbol.toPrimitive];
  if (a !== void 0) {
    var i = a.call(e, n || "default");
    if (typeof i != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function CU(e) {
  var n = SU(e, "string");
  return typeof n == "symbol" ? n : String(n);
}
function bU(e, n, a) {
  return n = CU(n), n in e ? Object.defineProperty(e, n, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = a, e;
}
function lR(e, n) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    n && (i = i.filter(function(h) {
      return Object.getOwnPropertyDescriptor(e, h).enumerable;
    })), a.push.apply(a, i);
  }
  return a;
}
function uR(e) {
  for (var n = 1; n < arguments.length; n++) {
    var a = arguments[n] != null ? arguments[n] : {};
    n % 2 ? lR(Object(a), !0).forEach(function(i) {
      bU(e, i, a[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : lR(Object(a)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(a, i));
    });
  }
  return e;
}
function sR(e, n) {
  var a = {};
  for (var i in e)
    a[i] = n(e[i], i);
  return a;
}
var _U = (e, n, a) => {
  for (var i of Object.keys(e)) {
    var h;
    if (e[i] !== ((h = n[i]) !== null && h !== void 0 ? h : a[i]))
      return !1;
  }
  return !0;
}, Xo = (e) => {
  var n = (a) => {
    var i = e.defaultClassName, h = uR(uR({}, e.defaultVariants), a);
    for (var g in h) {
      var m, S = (m = h[g]) !== null && m !== void 0 ? m : e.defaultVariants[g];
      if (S != null) {
        var b = S;
        typeof b == "boolean" && (b = b === !0 ? "true" : "false");
        var R = (
          // @ts-expect-error
          e.variantClassNames[g][b]
        );
        R && (i += " " + R);
      }
    }
    for (var [D, T] of e.compoundVariants)
      _U(D, h, e.defaultVariants) && (i += " " + T);
    return i;
  };
  return n.variants = () => Object.keys(e.variantClassNames), n.classNames = {
    get base() {
      return e.defaultClassName.split(" ")[0];
    },
    get variants() {
      return sR(e.variantClassNames, (a) => sR(a, (i) => i.split(" ")[0]));
    }
  }, n;
}, RU = Xo({ defaultClassName: "_1x3701w0", variantClassNames: { lines: { 1: "_1x3701w1", 2: "_1x3701w2", 3: "_1x3701w3", 4: "_1x3701w4" } }, defaultVariants: {}, compoundVariants: [] });
const j8 = Ma.forwardRef(
  ({ children: e, lines: n }, a) => /* @__PURE__ */ d.jsx(Rt, { as: "span", ref: a, cssClass: RU({ lines: n }), children: e })
);
j8.displayName = "Truncate";
var EU = { fontSize: "11px", lineHeight: "12px", "::before": { content: "''", marginBottom: "-0.1818em", display: "table" }, "::after": { content: "''", marginTop: "-0.1818em", display: "table" } }, MU = { fontSize: "12px", lineHeight: "16px", "::before": { content: "''", marginBottom: "-0.303em", display: "table" }, "::after": { content: "''", marginTop: "-0.303em", display: "table" } }, TU = { fontSize: "13px", lineHeight: "20px", "::before": { content: "''", marginBottom: "-0.4056em", display: "table" }, "::after": { content: "''", marginTop: "-0.4056em", display: "table" } }, OU = { fontSize: "14px", lineHeight: "20px", "::before": { content: "''", marginBottom: "-0.3506em", display: "table" }, "::after": { content: "''", marginTop: "-0.3506em", display: "table" } }, DU = { fontSize: "16px", lineHeight: "24px", "::before": { content: "''", marginBottom: "-0.3864em", display: "table" }, "::after": { content: "''", marginTop: "-0.3864em", display: "table" } }, AQ = { fontSize: "13px", lineHeight: "20px", "::before": { content: "''", marginBottom: "-0.4462em", display: "table" }, "::after": { content: "''", marginTop: "-0.3942em", display: "table" } }, AU = { body: { fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol" }, heading: { fontFamily: "Inter, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif" }, monospace: { fontFamily: "IBM Plex Mono, Menlo, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier, monospace" } }, jQ = { family: AU, size: { xxSmall: EU, xSmall: MU, small: TU, medium: OU, large: DU }, weight: { regular: { fontWeight: "400" }, medium: { fontWeight: "500" }, bold: { fontWeight: "600" } } }, jU = Xo({ defaultClassName: "_1j32j980", variantClassNames: { align: { center: "_1j32j981", left: "_1j32j982", right: "_1j32j983" }, family: { body: "_1j32j984", heading: "_1j32j985", monospace: "_1j32j986" }, size: { xxSmall: "_1j32j987", xSmall: "_1j32j988", small: "_1j32j989", medium: "_1j32j98a", large: "_1j32j98b" }, weight: { regular: "_1j32j98c", medium: "_1j32j98d", bold: "_1j32j98e" }, case: { capital: "_1j32j98f", upper: "_1j32j98g", lower: "_1j32j98h" }, break: { all: "_1j32j98i", word: "_1j32j98j", normal: "_1j32j98k", none: "_1j32j98l" } }, defaultVariants: { family: "body", size: "small", weight: "medium" }, compoundVariants: [[{ family: "monospace", size: "small" }, "_1j32j98m"], [{ family: "monospace", size: "xSmall" }, "_1j32j98n"], [{ family: "monospace", size: "xxSmall" }, "_1j32j98o"]] });
const ma = Ma.forwardRef(
  ({
    as: e,
    children: n,
    color: a,
    decoration: i,
    display: h,
    lines: g,
    transform: m,
    userSelect: S,
    cssClass: b,
    title: R,
    whiteSpace: D,
    wrap: T,
    ...A
  }, j) => {
    const I = g ? /* @__PURE__ */ d.jsx(j8, { ref: j, lines: g, children: n }) : n;
    return /* @__PURE__ */ d.jsx(
      Rt,
      {
        as: e,
        color: a,
        cssClass: zr(jU({ ...A }), b),
        display: h,
        overflowWrap: T,
        ref: g ? void 0 : j,
        textDecoration: i,
        textTransform: m,
        title: R,
        userSelect: S,
        whiteSpace: D,
        children: I
      }
    );
  }
);
ma.displayName = "Text";
var kU = Xo({ defaultClassName: "_989awr4", variantClassNames: { size: { small: "_989awr5 _989awr0 _1faqfmv4a _1faqfmv4u", medium: "_989awr6 _989awr1 _1faqfmv4b _1faqfmv4v", large: "_989awr7 _989awr2 _1faqfmv4c _1faqfmv4w" }, shape: { rounded: "_989awr8", basic: "_989awr9" }, variant: { white: "_989awra", gray: "_989awrb", outlineGray: "_989awrc", green: "_989awrd", blue: "_989awre _989awr3 _1faqfmvcz", red: "_989awrf", yellow: "_989awrg", purple: "_989awrh", outlinePurple: "_989awri" } }, defaultVariants: { size: "small", shape: "basic", variant: "white" }, compoundVariants: [[{ size: "small", shape: "basic" }, "_989awrj"], [{ size: "medium", shape: "basic" }, "_989awrk"], [{ size: "large", shape: "basic" }, "_989awrl"], [{ size: "small", shape: "rounded" }, "_989awrm"], [{ size: "medium", shape: "rounded" }, "_989awrn"], [{ size: "large", shape: "rounded" }, "_989awro"]] });
const d3 = ({
  iconStart: e,
  iconEnd: n,
  label: a,
  lines: i,
  cssClass: h,
  size: g,
  shape: m,
  variant: S,
  ...b
}) => {
  let R;
  switch (g) {
    case "large":
      R = "small";
      break;
    default:
      R = "xSmall";
  }
  let D;
  switch (S) {
    case "red":
      D = "r11";
      break;
    case "blue":
      D = "lb700";
      break;
    case "yellow":
      D = "y11";
      break;
    case "green":
      D = "good";
      break;
    case "gray":
      D = "default";
      break;
    case "outlineGray":
      D = "default";
      break;
    case "outlinePurple":
      D = "p6";
      break;
    case "white":
      D = "moderate";
      break;
    case "purple":
      D = "informative";
      break;
    default:
      D = "moderate";
  }
  return /* @__PURE__ */ d.jsxs(
    Rt,
    {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "2",
      cssClass: [kU({ size: g, shape: m, variant: S }), h],
      ...b,
      children: [
        e,
        a && /* @__PURE__ */ d.jsx(ma, { size: R, color: D, as: "span", lines: i, children: a }),
        n
      ]
    }
  );
};
var LU = { grey: "inset 0px -1px 0px rgba(0, 0, 0, 0.1)", primary: "inset 0px -1px 0px rgba(0, 0, 0, 0.32)", neutral: "0 0 0 1px #f9f8f9 inset", n5: "0 0 0 1px #e9e8ea inset" }, k8 = "small", cx = Xo({ defaultClassName: "_6syg4r0", variantClassNames: { size: { xSmall: "_6syg4r1", small: "_6syg4r2", medium: "_6syg4r3", large: "_6syg4r4", xLarge: "_6syg4r5" }, emphasis: { high: "_6syg4r6", medium: "_6syg4r7", low: "_6syg4r8" }, kind: { primary: "_6syg4r9", secondary: "_6syg4ra", danger: "_6syg4rb" } }, defaultVariants: { size: "small" }, compoundVariants: [[{ kind: "primary", emphasis: "high" }, "_6syg4rc"]] }), DT = Xo({ defaultClassName: "_6syg4rh _6syg4rd _1faqfmvsz _1faqfmvex _1faqfmv21 _1faqfmvwf", variantClassNames: { emphasis: { high: "_6syg4ri", medium: "_6syg4rj", low: "_6syg4rk" }, kind: { primary: "_6syg4rl", secondary: "_6syg4rm", danger: "_6syg4rn" }, size: { xSmall: "_6syg4ro _6syg4re _1faqfmv4c _1faqfmv4w _1faqfmv3 _1faqfmvuf", small: "_6syg4rp _6syg4rf _1faqfmv4c _1faqfmv4w _1faqfmv5 _1faqfmvuj", medium: "_6syg4rq _6syg4rg _1faqfmv4e _1faqfmv4y _1faqfmv5 _1faqfmvuj" } }, defaultVariants: { kind: "primary", emphasis: "high", size: "small" }, compoundVariants: [[{ kind: "primary", emphasis: "high" }, "_6syg4rr"], [{ kind: "primary", emphasis: "medium" }, "_6syg4rs"], [{ kind: "primary", emphasis: "low" }, "_6syg4rt"], [{ kind: "secondary", emphasis: "high" }, "_6syg4ru"], [{ kind: "secondary", emphasis: "medium" }, "_6syg4rv"], [{ kind: "secondary", emphasis: "low" }, "_6syg4rw"]] });
const kQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  defaultSize: k8,
  iconVariants: cx,
  shadows: LU,
  variants: DT
}, Symbol.toStringTag, { value: "Module" })), IU = {
  xSmall: "xSmall",
  small: "small",
  medium: "small",
  large: "small",
  xLarge: "large"
}, ww = Ma.forwardRef(
  ({
    children: e,
    iconLeft: n,
    iconRight: a,
    size: i = k8,
    kind: h,
    emphasis: g,
    className: m,
    cssClass: S,
    disabled: b,
    ...R
  }, D) => /* @__PURE__ */ d.jsx(
    N5,
    {
      disabled: b,
      className: zr(
        DT({
          kind: h,
          size: i,
          emphasis: g
        }),
        m,
        S
      ),
      ref: D,
      type: "button",
      ...R,
      children: /* @__PURE__ */ d.jsx(
        HU,
        {
          iconLeft: n,
          iconRight: a,
          size: i,
          kind: h,
          emphasis: g,
          disabled: b,
          children: e
        }
      )
    }
  )
), HU = ({
  children: e,
  disabled: n,
  emphasis: a,
  iconLeft: i,
  iconRight: h,
  kind: g,
  size: m = k8
}) => {
  const S = IU[m];
  return /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    i && /* @__PURE__ */ d.jsx(
      Rt,
      {
        as: "span",
        display: "inline-flex",
        disabled: n,
        cssClass: cx({
          size: m,
          emphasis: a,
          kind: g
        }),
        children: i
      }
    ),
    e && /* @__PURE__ */ d.jsx(
      ma,
      {
        userSelect: "none",
        size: S,
        align: "center",
        display: "inline-flex",
        children: e
      }
    ),
    h && /* @__PURE__ */ d.jsx(
      Rt,
      {
        as: "span",
        display: "inline-flex",
        disabled: n,
        cssClass: cx({
          size: m,
          emphasis: a,
          kind: g
        }),
        children: h
      }
    )
  ] });
};
var ZU = Xo({ defaultClassName: "oor2ha0", variantClassNames: { shape: { thin: "oor2ha1", square: "oor2ha2" }, emphasis: { low: "oor2ha3", medium: "oor2ha4", high: "oor2ha5", none: "oor2ha6" }, size: { xSmall: "oor2ha7", small: "oor2ha8", medium: "oor2ha9", minimal: "oor2haa" }, kind: { primary: "oor2hab", secondary: "oor2hac" } }, defaultVariants: { kind: "primary", emphasis: "medium", shape: "square", size: "small" }, compoundVariants: [[{ size: "xSmall", shape: "thin" }, "oor2had"], [{ size: "small", shape: "thin" }, "oor2hae"], [{ size: "medium", shape: "thin" }, "oor2haf"], [{ emphasis: "high", kind: "primary" }, "oor2hag"], [{ emphasis: "medium", kind: "primary" }, "oor2hah"], [{ emphasis: "low", kind: "primary" }, "oor2hai"], [{ emphasis: "high", kind: "secondary" }, "oor2haj"], [{ emphasis: "medium", kind: "secondary" }, "oor2hak"], [{ emphasis: "low", kind: "secondary" }, "oor2hal"]] });
const L8 = Ex(
  ({
    icon: e,
    kind: n,
    shape: a,
    emphasis: i,
    size: h,
    onClick: g,
    disabled: m,
    cssClass: S,
    className: b,
    type: R = "button"
  }, D) => /* @__PURE__ */ d.jsx(
    Rt,
    {
      as: "button",
      display: "inline-flex",
      cssClass: zr(
        ZU({ kind: n, shape: a, emphasis: i, size: h }),
        b,
        S
      ),
      onClick: g,
      disabled: m,
      type: R,
      ref: D,
      children: e
    }
  )
);
var PU = "_88y39m0", NU = Xo({ defaultClassName: "_88y39m1", variantClassNames: { kind: { primary: "_88y39m2", secondary: "_88y39m3", light: "_88y39m4" } }, defaultVariants: { kind: "primary" }, compoundVariants: [] });
const LQ = ({
  children: e,
  kind: n,
  ...a
}) => /* @__PURE__ */ d.jsx(
  N5,
  {
    render: /* @__PURE__ */ d.jsx("button", {}),
    className: zr(PU, NU({ kind: n })),
    type: "button",
    ...a,
    children: /* @__PURE__ */ d.jsx(ma, { children: e })
  }
), IQ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m12 14 9-5-9-5-9 5 9 5Zm0 0 6.16-3.422a12.083 12.083 0 0 1 .665 6.479A11.952 11.952 0 0 0 12 20.055a11.952 11.952 0 0 0-6.824-2.998 12.078 12.078 0 0 1 .665-6.479L12 14Zm-4 6v-7.5l4-2.222"
      }
    )
  }
), HQ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 3a1 1 0 0 1 1 1v9.17a3.001 3.001 0 0 1 0 5.66V20a1 1 0 1 1-2 0v-1.17a3.001 3.001 0 0 1 0-5.66V4a1 1 0 0 1 1-1Zm6 0a1 1 0 0 1 1 1v1.17a3.001 3.001 0 0 1 0 5.66V20a1 1 0 1 1-2 0v-9.17a3.001 3.001 0 0 1 0-5.66V4a1 1 0 0 1 1-1Zm6 0a1 1 0 0 1 1 1v9.17a3.001 3.001 0 0 1 0 5.66V20a1 1 0 1 1-2 0v-1.17a3.001 3.001 0 0 1 0-5.66V4a1 1 0 0 1 1-1Zm-6 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-6 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
        clipRule: "evenodd"
      }
    )
  }
), ZQ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-2.586l-3.707 3.707a1 1 0 0 1-1.414 0L7.586 17H5a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h3a1 1 0 0 1 .707.293L12 18.586l3.293-3.293A1 1 0 0 1 16 15h3a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5Zm1 3a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), PQ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h14a3 3 0 0 1 1 5.83V18a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V8.83A3.001 3.001 0 0 1 2 6Zm4 3v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9H6ZM5 5a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2H5Zm4 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), NQ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-5a1 1 0 0 1 1 1v5.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 13.586V8a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), VQ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9.707-3.707a1 1 0 0 1 0 1.414L10.414 11H16a1 1 0 1 1 0 2h-5.586l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), FQ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10.293-3.707a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L13.586 13H8a1 1 0 1 1 0-2h5.586l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), BQ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9-1.586-1.293 1.293a1 1 0 0 1-1.414-1.414l3-3a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L13 10.414V16a1 1 0 1 1-2 0v-5.586Z",
        clipRule: "evenodd"
      }
    )
  }
), UQ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v15.586l5.293-5.293a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 1 1 1.414-1.414L11 18.586V3a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), YQ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.707 4.293a1 1 0 0 1 0 1.414L5.414 11H21a1 1 0 1 1 0 2H5.414l5.293 5.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), $Q = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v15.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 18.586V3a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), WQ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.707 7.293a1 1 0 0 1 0 1.414L5.414 11H21a1 1 0 1 1 0 2H5.414l2.293 2.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), zQ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.293 7.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L18.586 13H3a1 1 0 1 1 0-2h15.586l-2.293-2.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), qQ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 2.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 5.414V21a1 1 0 1 1-2 0V5.414L8.707 7.707a1 1 0 0 1-1.414-1.414l4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), GQ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.293 4.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414L18.586 13H3a1 1 0 1 1 0-2h15.586l-5.293-5.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), KQ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2H6.414l3.293 3.293a1 1 0 0 1-1.414 1.414L5 6.414V8a1 1 0 0 1-2 0V4Zm13-1h4a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V6.414l-3.293 3.293a1 1 0 0 1-1.414-1.414L17.586 5H16a1 1 0 1 1 0-2ZM9.707 14.293a1 1 0 0 1 0 1.414L6.414 19H8a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1v-4a1 1 0 1 1 2 0v1.586l3.293-3.293a1 1 0 0 1 1.414 0Zm4.586 0a1 1 0 0 1 1.414 0L19 17.586V16a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h1.586l-3.293-3.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), QQ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 5a1 1 0 0 1 1 1v9.586l3.293-3.293a1 1 0 0 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L11 15.586V6a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), XQ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.707 6.293a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.293 3.293a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), JQ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.293 6.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L15.586 13H6a1 1 0 1 1 0-2h9.586l-3.293-3.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), eX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 5.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L13 8.414V18a1 1 0 1 1-2 0V8.414l-3.293 3.293a1 1 0 0 1-1.414-1.414l5-5Z",
        clipRule: "evenodd"
      }
    )
  }
), tX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 2.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1-1.414 1.414L13 5.414V21a1 1 0 1 1-2 0V5.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l7-7Z",
        clipRule: "evenodd"
      }
    )
  }
), nX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 4 14.928 1 1 0 1 1 1 1.732A9.96 9.96 0 0 1 11.942 22C6.446 21.968 2 17.503 2 12 2 6.477 6.477 2 12 2s10 4.477 10 10v1.5a3.5 3.5 0 0 1-6.396 1.966A5 5 0 1 1 17 12v1.5a1.5 1.5 0 0 0 3 0V12a8 8 0 0 0-8-8Zm3 8a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z",
        clipRule: "evenodd"
      }
    )
  }
), rX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.707 4.879A3 3 0 0 1 10.828 4H19a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-8.172a3 3 0 0 1-2.12-.879l-6.415-6.414a1 1 0 0 1 0-1.414l6.414-6.414ZM10.828 6a1 1 0 0 0-.707.293L4.414 12l5.707 5.707a1 1 0 0 0 .707.293H19a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-8.172Zm.465 3.293a1 1 0 0 1 1.414 0L14 10.586l1.293-1.293a1 1 0 1 1 1.414 1.414L15.414 12l1.293 1.293a1 1 0 0 1-1.414 1.414L14 13.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L12.586 12l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), aX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.133 3.13a4.42 4.42 0 0 1 5.734 0c.388.33.87.53 1.378.57A4.42 4.42 0 0 1 20.3 7.755c.04.508.24.99.57 1.378a4.42 4.42 0 0 1 0 5.734c-.33.388-.53.87-.57 1.378a4.42 4.42 0 0 1-4.055 4.055c-.508.04-.99.24-1.378.57a4.42 4.42 0 0 1-5.734 0 2.42 2.42 0 0 0-1.378-.57A4.42 4.42 0 0 1 3.7 16.245a2.42 2.42 0 0 0-.57-1.378 4.42 4.42 0 0 1 0-5.734c.33-.388.53-.87.57-1.378A4.42 4.42 0 0 1 7.755 3.7c.508-.04.99-.24 1.378-.57Zm4.437 1.522a2.42 2.42 0 0 0-3.14 0 4.42 4.42 0 0 1-2.516 1.042 2.42 2.42 0 0 0-2.22 2.22 4.42 4.42 0 0 1-1.042 2.516 2.42 2.42 0 0 0 0 3.14 4.42 4.42 0 0 1 1.042 2.516 2.42 2.42 0 0 0 2.22 2.22 4.42 4.42 0 0 1 2.516 1.042 2.42 2.42 0 0 0 3.14 0 4.42 4.42 0 0 1 2.516-1.042 2.42 2.42 0 0 0 2.22-2.22 4.42 4.42 0 0 1 1.042-2.516 2.42 2.42 0 0 0 0-3.14 4.42 4.42 0 0 1-1.042-2.516 2.42 2.42 0 0 0-2.22-2.22 4.42 4.42 0 0 1-2.516-1.042Zm2.137 4.64a1 1 0 0 1 0 1.415l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 12.586l3.293-3.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), oX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.094 5.68 18.32 16.906A8.001 8.001 0 0 0 7.094 5.68Zm9.812 12.64L5.68 7.094A8.002 8.002 0 0 0 16.906 18.32ZM4.929 4.93c3.905-3.905 10.237-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.905-10.237 0-14.142Z",
        clipRule: "evenodd"
      }
    )
  }
), iX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.076 3.617A1 1 0 0 1 8 3h8a1 1 0 0 1 .707 1.707L16 5.414v4.758a1 1 0 0 0 .293.707l3.84 3.84.002.002.001.001 1.157 1.157c1.89 1.89.551 5.121-2.122 5.121H4.828c-2.673 0-4.011-3.231-2.121-5.121l.828-.829h.001l4.17-4.171A1 1 0 0 0 8 10.172V5.414l-.707-.707a1 1 0 0 1-.217-1.09ZM10 5v5.172a3 3 0 0 1-.879 2.12l-2.093 2.094 1.15.23a5 5 0 0 0 3.216-.431l.317-.159a7 7 0 0 1 4.252-.648l-1.084-1.085a3 3 0 0 1-.88-2.121V5h-4Zm8.72 11.134a1 1 0 0 0-.51-.272l-2.388-.478a5 5 0 0 0-3.216.431l-.318.159a7 7 0 0 1-4.503.603l-1.932-.387a1 1 0 0 0-.903.274l-.829.829c-.63.63-.184 1.707.707 1.707h14.343c.891 0 1.337-1.077.707-1.707l-1.157-1.158h-.001Z",
        clipRule: "evenodd"
      }
    )
  }
), lX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.018 4.665a3 3 0 0 1 5.963 0A7 7 0 0 1 19 11v3.159c0 .273.109.535.302.729l1.405 1.405A1 1 0 0 1 20 18h-4a4 4 0 0 1-8 0H4a1 1 0 0 1-.707-1.707l1.405-1.405c.193-.194.302-.456.302-.73V11a7 7 0 0 1 4.018-6.335ZM10 18a2 2 0 1 0 4 0h-4Zm2-14a1 1 0 0 0-1 1v.341a1 1 0 0 1-.667.943A5.003 5.003 0 0 0 7 11v3.159c0 .669-.221 1.315-.623 1.841h11.246A3.032 3.032 0 0 1 17 14.159V11a5.002 5.002 0 0 0-3.333-4.716A1 1 0 0 1 13 5.341V5a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), uX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v16a1 1 0 0 1-1.447.894L12 18.618l-6.553 3.276A1 1 0 0 1 4 21V5Zm3-1a1 1 0 0 0-1 1v14.382l5.553-2.776a1 1 0 0 1 .894 0L18 19.382V5a1 1 0 0 0-1-1H7Z",
        clipRule: "evenodd"
      }
    )
  }
), sX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm12-1H9v9.382l2.553-1.276a1 1 0 0 1 .894 0L15 14.382V5ZM7 5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-1v11a1 1 0 0 1-1.447.894L12 15.118l-3.553 1.776A1 1 0 0 1 7 16V5Z",
        clipRule: "evenodd"
      }
    )
  }
), cX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 6.82v10.806A9.823 9.823 0 0 1 7.5 17c1.252 0 2.446.222 3.5.626V6.819C10.06 6.317 8.848 6 7.5 6c-1.348 0-2.56.317-3.5.82Zm9 0v10.806A9.823 9.823 0 0 1 16.5 17c1.252 0 2.446.222 3.5.626V6.819C19.06 6.317 17.848 6 16.5 6c-1.348 0-2.56.317-3.5.82Zm-1-1.734C10.733 4.395 9.168 4 7.5 4c-1.92 0-3.703.523-5.053 1.42A1 1 0 0 0 2 6.253v13a1 1 0 0 0 1.553.833C4.54 19.43 5.927 19 7.5 19s2.961.431 3.947 1.086a1 1 0 0 0 1.106 0C13.54 19.43 14.927 19 16.5 19s2.961.431 3.947 1.086A1 1 0 0 0 22 19.253v-13a1 1 0 0 0-.447-.833C20.203 4.523 18.42 4 16.5 4c-1.668 0-3.233.395-4.5 1.086Z",
        clipRule: "evenodd"
      }
    )
  }
), fX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h2V4ZM5 7a1 1 0 0 0-1 1v4.57A22.95 22.95 0 0 0 12 14c2.815 0 5.51-.505 8-1.43V8a1 1 0 0 0-1-1H5Zm10-2H9V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1Zm5 9.692A24.971 24.971 0 0 1 12 16a24.98 24.98 0 0 1-8-1.308V18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3.308ZM11 12a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), dX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1ZM9 5a1 1 0 0 1 1 1v1h1V6a1 1 0 1 1 2 0v1h1V6a1 1 0 1 1 2 0v1a3 3 0 0 1 3 3v1a3 3 0 0 1 3 3v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7a3 3 0 0 1 3-3v-1a3 3 0 0 1 3-3V6a1 1 0 0 1 1-1ZM8 9a1 1 0 0 0-1 1v1h10v-1a1 1 0 0 0-1-1H8Zm-3 4a1 1 0 0 0-1 1v.683c.369.104.725.265 1.055.485a1.704 1.704 0 0 0 1.89 0 3.704 3.704 0 0 1 4.11 0 1.704 1.704 0 0 0 1.89 0 3.704 3.704 0 0 1 4.11 0 1.704 1.704 0 0 0 1.89 0c.33-.22.686-.381 1.055-.485V14a1 1 0 0 0-1-1H5Zm15 3.868a3.704 3.704 0 0 1-4.055-.036 1.704 1.704 0 0 0-1.89 0 3.704 3.704 0 0 1-4.11 0 1.704 1.704 0 0 0-1.89 0A3.704 3.704 0 0 1 4 16.868V20h16v-3.132Z",
        clipRule: "evenodd"
      }
    )
  }
), hX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H7Zm1 3a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1Zm-6 3a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm4-1a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm-7 4a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), vX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a1 1 0 0 1 1 1v1h6V3a1 1 0 1 1 2 0v1h2a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h2V3a1 1 0 0 1 1-1ZM7 6H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-2v1a1 1 0 1 1-2 0V6H9v1a1 1 0 0 1-2 0V6Zm-1 5a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), pX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.07 5a1 1 0 0 0-.832.445l-.812 1.22A3 3 0 0 1 5.93 8H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-.93a3 3 0 0 1-2.496-1.336l-.812-1.219A1 1 0 0 0 13.93 5h-3.86Zm-2.496-.664A3 3 0 0 1 10.07 3h3.86a3 3 0 0 1 2.496 1.336l.812 1.219A1 1 0 0 0 18.07 6H19a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h.93a1 1 0 0 0 .832-.445l.812-1.22ZM12 11a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
        clipRule: "evenodd"
      }
    )
  }
), mX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v1h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3v-1H5a3 3 0 0 1-3-3V7Zm6 10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v6Zm8-9H9a3 3 0 0 0-3 3v3H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1Zm-2 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
        clipRule: "evenodd"
      }
    )
  }
), gX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3h-2c-.768 0-1.47-.289-2-.764A2.989 2.989 0 0 1 13 22h-2c-.768 0-1.47-.289-2-.764A2.989 2.989 0 0 1 7 22H5a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h2c.35 0 .687.06 1 .17V9a3 3 0 0 1 3-3h2c.35 0 .687.06 1 .17V5Zm2 14a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v14ZM14 9a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V9Zm-6 4a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6Z",
        clipRule: "evenodd"
      }
    )
  }
), wX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.667 2.31a1 1 0 0 1 .333.745V12h8.945a1 1 0 0 1 .994 1.11C21.386 18.11 17.148 22 12 22 6.477 22 2 17.523 2 12c0-5.148 3.89-9.386 8.89-9.939a1 1 0 0 1 .777.249ZM10 4.252A8 8 0 1 0 19.748 14H11a1 1 0 0 1-1-1V4.252Zm4.423-1.556a1 1 0 0 1 .91-.127 10.025 10.025 0 0 1 6.098 6.098A1 1 0 0 1 20.488 10H15a1 1 0 0 1-1-1V3.512a1 1 0 0 1 .423-.816ZM16 5.07V8h2.93A8.044 8.044 0 0 0 16 5.07Z",
        clipRule: "evenodd"
      }
    )
  }
), yX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Zm10 2a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm-4 3a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1Zm-4 3a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), xX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 5c-4.532 0-8 3.241-8 7 0 1.352.438 2.619 1.209 3.7a1 1 0 0 1 .122.931l-.763 2.036 2.98-.597a1 1 0 0 1 .628.079A8.862 8.862 0 0 0 12 19c4.532 0 8-3.242 8-7 0-3.759-3.468-7-8-7ZM2 12c0-5.078 4.591-9 10-9s10 3.922 10 9c0 5.078-4.591 9-10 9-1.565 0-3.051-.324-4.377-.905l-4.427.886a1 1 0 0 1-1.132-1.332l1.215-3.24A8.283 8.283 0 0 1 2 12Zm5 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H16a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), SX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-4.586l-4.707 4.707A1 1 0 0 1 8 21v-4H5a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4a1 1 0 0 1 1 1v2.586l3.293-3.293A1 1 0 0 1 14 15h5a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5Zm2 5a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H8a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H16a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), CX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v1h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-1v3a1 1 0 0 1-1.707.707L12.586 19H9a2.99 2.99 0 0 1-1.293-.293A1 1 0 0 1 6 18v-3H5a3 3 0 0 1-3-3V6Zm7.414 11H13a1 1 0 0 1 .707.293L16 19.586V18a1 1 0 0 1 1-1h2a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-1v3a3 3 0 0 1-3 3h-3.586l-2 2ZM16 6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v1.586l2.293-2.293A1 1 0 0 1 11 13h4a1 1 0 0 0 1-1V6Z",
        clipRule: "evenodd"
      }
    )
  }
), bX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.707 6.293a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L9 15.586l9.293-9.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), _X = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-2.707a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 12.586l3.293-3.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), RX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 8.293a1 1 0 0 1 1.414 0L12 14.586l6.293-6.293a1 1 0 1 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), EX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.707 4.293a1 1 0 0 1 0 1.414L9.414 12l6.293 6.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), MX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.293 19.707a1 1 0 0 1 0-1.414L14.586 12 8.293 5.707a1 1 0 0 1 1.414-1.414l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), TX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.707 15.707a1 1 0 0 1-1.414 0L12 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414l7-7a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), OX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 4.293a1 1 0 0 1 1.414 0L12 10.586l6.293-6.293a1 1 0 1 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414Zm0 8a1 1 0 0 1 1.414 0L12 18.586l6.293-6.293a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), DX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.707 4.293a1 1 0 0 1 0 1.414L5.414 12l6.293 6.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0Zm8 0a1 1 0 0 1 0 1.414L13.414 12l6.293 6.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), AX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 4.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414L10.586 12 4.293 5.707a1 1 0 0 1 0-1.414Zm8 0a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414L18.586 12l-6.293-6.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), jX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 3.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1-1.414 1.414L12 5.414l-6.293 6.293a1 1 0 0 1-1.414-1.414l7-7ZM12 13.414l6.293 6.293a1 1 0 0 0 1.414-1.414l-7-7a1 1 0 0 0-1.414 0l-7 7a1 1 0 1 0 1.414 1.414L12 13.414Z",
        clipRule: "evenodd"
      }
    )
  }
), kX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 2a1 1 0 0 1 1 1v1h4V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v1h1a1 1 0 1 1 0 2h-1v4h1a1 1 0 1 1 0 2h-1v1a3 3 0 0 1-3 3h-1v1a1 1 0 1 1-2 0v-1h-4v1a1 1 0 1 1-2 0v-1H7a3 3 0 0 1-3-3v-1H3a1 1 0 1 1 0-2h1v-4H3a1 1 0 0 1 0-2h1V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1ZM7 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7Zm1 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9Zm2 1v4h4v-4h-4Z",
        clipRule: "evenodd"
      }
    )
  }
), LX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.17 4A3.001 3.001 0 0 1 11 2h2c1.306 0 2.418.835 2.83 2H17a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1.17Zm0 2H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1.17A3.001 3.001 0 0 1 13 8h-2a3.001 3.001 0 0 1-2.83-2ZM11 4a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z",
        clipRule: "evenodd"
      }
    )
  }
), IX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.17 4A3.001 3.001 0 0 1 11 2h2c1.306 0 2.418.835 2.83 2H17a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1.17Zm0 2H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1.17A3.001 3.001 0 0 1 13 8h-2a3.001 3.001 0 0 1-2.83-2ZM11 4a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm4.707 7.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 14.586l3.293-3.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), HX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.17 4A3.001 3.001 0 0 1 10 2h2c1.306 0 2.418.835 2.83 2H16a3 3 0 0 1 3 3v3a1 1 0 1 1-2 0V7a1 1 0 0 0-1-1h-1.17A3.001 3.001 0 0 1 12 8h-2a3.001 3.001 0 0 1-2.83-2H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a1 1 0 1 1 2 0v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1.17ZM10 4a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2h-2Zm3.707 6.293a1 1 0 0 1 0 1.414L12.414 13H20a1 1 0 1 1 0 2h-7.586l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), ZX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.17 4A3.001 3.001 0 0 1 11 2h2c1.306 0 2.418.835 2.83 2H17a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1.17Zm0 2H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1.17A3.001 3.001 0 0 1 13 8h-2a3.001 3.001 0 0 1-2.83-2ZM11 4a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm-3 8a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Zm-3 4a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), PX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-5a1 1 0 0 1 1 1v3.586l2.707 2.707a1 1 0 0 1-1.414 1.414l-3-3A1 1 0 0 1 11 12V8a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), NX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 6a4 4 0 0 0-3.903 4.879 1 1 0 0 1-.757 1.194A3.002 3.002 0 0 0 7 18h9a4 4 0 1 0-.08-8 1 1 0 0 1-1-.8A4.002 4.002 0 0 0 11 6Zm-6 4a6 6 0 0 1 11.671-1.963A6 6 0 0 1 16 20H7a5 5 0 0 1-1.986-9.59A6.071 6.071 0 0 1 5 10Z",
        clipRule: "evenodd"
      }
    )
  }
), VX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 3a4 4 0 0 0-3.903 4.879 1 1 0 0 1-.757 1.194A3.002 3.002 0 0 0 7 15a1 1 0 1 1 0 2 5 5 0 0 1-1.986-9.59A6 6 0 0 1 16.67 5.037a6 6 0 0 1 .53 11.843 1 1 0 1 1-.398-1.96A4.002 4.002 0 0 0 15.92 7a1 1 0 0 1-1-.8A4.002 4.002 0 0 0 11 3Zm1 6a1 1 0 0 1 1 1v9.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 19.586V10a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), FX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 3a4 4 0 0 0-3.903 4.879 1 1 0 0 1-.757 1.194A3.002 3.002 0 0 0 7 15a1 1 0 1 1 0 2 5 5 0 0 1-1.986-9.59A6 6 0 0 1 16.67 5.037a6 6 0 0 1 .53 11.843 1 1 0 1 1-.398-1.96A4.002 4.002 0 0 0 15.92 7a1 1 0 0 1-1-.8A4.002 4.002 0 0 0 11 3Zm.293 6.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L13 12.414V22a1 1 0 1 1-2 0v-9.586l-1.293 1.293a1 1 0 0 1-1.414-1.414l3-3Z",
        clipRule: "evenodd"
      }
    )
  }
), BX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.242 3.03a1 1 0 0 1 .728 1.213l-4 16a1 1 0 1 1-1.94-.485l4-16a1 1 0 0 1 1.213-.728ZM6.707 7.293a1 1 0 0 1 0 1.414L3.414 12l3.293 3.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Zm10.586 0a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L20.586 12l-3.293-3.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), UX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.353 4.081c.674-2.775 4.62-2.775 5.294 0a.724.724 0 0 0 1.08.448c2.44-1.486 5.23 1.305 3.744 3.744a.724.724 0 0 0 .448 1.08c2.775.674 2.775 4.62 0 5.294a.724.724 0 0 0-.448 1.08c1.486 2.44-1.305 5.23-3.744 3.744a.724.724 0 0 0-1.08.448c-.674 2.775-4.62 2.775-5.294 0a.724.724 0 0 0-1.08-.448c-2.44 1.486-5.23-1.305-3.744-3.744a.724.724 0 0 0-.448-1.08c-2.775-.674-2.775-4.62 0-5.294a.724.724 0 0 0 .448-1.08c-1.486-2.44 1.305-5.23 3.744-3.744a.724.724 0 0 0 1.08-.448Zm3.35.472c-.178-.737-1.227-.737-1.407 0a2.724 2.724 0 0 1-4.064 1.684c-.648-.395-1.39.347-.995.995a2.723 2.723 0 0 1-1.684 4.064c-.737.18-.737 1.229 0 1.408a2.724 2.724 0 0 1 1.684 4.064c-.395.648.347 1.39.995.995a2.724 2.724 0 0 1 4.064 1.684c.18.737 1.229.737 1.408 0a2.724 2.724 0 0 1 4.064-1.684c.648.395 1.39-.347.995-.995a2.724 2.724 0 0 1 1.684-4.064c.737-.18.737-1.229 0-1.408a2.724 2.724 0 0 1-1.684-4.064c.395-.648-.347-1.39-.995-.995a2.723 2.723 0 0 1-4.064-1.684ZM12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
        clipRule: "evenodd"
      }
    )
  }
), YX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 5a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v1.17c1.165.413 2 1.524 2 2.83v1.17c1.165.412 2 1.524 2 2.83v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-6c0-1.306.835-2.418 2-2.83V9c0-1.306.835-2.417 2-2.83V5Zm2 1h8V5a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v1Zm-2 4h12V9a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1Zm-1 2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H5Z",
        clipRule: "evenodd"
      }
    )
  }
), $X = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h4a3 3 0 0 1 3 2.93 3 3 0 0 1 4.192.05l2.829 2.828A3 3 0 0 1 19.069 12 3 3 0 0 1 22 15v4a3 3 0 0 1-3 3H7a5 5 0 0 1-5-5V5Zm9.071 15H19a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1.929l-6 6Zm4.878-7.707h.001l1.657-1.657a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 0 0-1.414 0L12 7.757v8.486l3.95-3.95ZM9.123 19.12A2.99 2.99 0 0 0 10 17V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a3 3 0 0 0 5.123 2.12ZM6 17a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), WX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8Zm2 3v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5H4Zm16-2H4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1ZM6 15a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm5 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), zX = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.553 2.106a1 1 0 0 1 .894 0l8 4A1 1 0 0 1 21 7v10a1 1 0 0 1-.553.894l-8 4a1 1 0 0 1-.894 0l-8-4A1 1 0 0 1 3 17V7a1 1 0 0 1 .553-.894l8-4ZM5 8.618l6 3v7.764l-6-3V8.618Zm8 10.764 6-3V8.618l-6 3v7.764Zm-1-9.5L17.764 7 12 4.118 6.236 7 12 9.882Z",
        clipRule: "evenodd"
      }
    )
  }
), qX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.553 2.106a1 1 0 0 1 .894 0l2 1a1 1 0 1 1-.894 1.788L12 4.118l-1.553.776a1 1 0 1 1-.894-1.788l2-1ZM6.894 5.553a1 1 0 0 1-.447 1.341L6.237 7l.21.106a1 1 0 0 1-.894 1.788L5 8.618V9.5a1 1 0 1 1-2 0V7a1 1 0 0 1 .553-.894l2-1a1 1 0 0 1 1.341.447Zm10.212 0a1 1 0 0 1 1.341-.447l2 1A1 1 0 0 1 21 7v2.5a1 1 0 1 1-2 0v-.882l-.553.276a1 1 0 1 1-.894-1.788l.21-.106-.21-.106a1 1 0 0 1-.447-1.341Zm-8 4a1 1 0 0 1 1.341-.447L12 9.882l1.553-.776a1 1 0 1 1 .894 1.788L13 11.618V13.5a1 1 0 1 1-2 0v-1.882l-1.447-.724a1 1 0 0 1-.447-1.341ZM4 13.5a1 1 0 0 1 1 1v1.882l1.447.724a1 1 0 1 1-.894 1.788l-2-1A1 1 0 0 1 3 17v-2.5a1 1 0 0 1 1-1Zm16 0a1 1 0 0 1 1 1V17a1 1 0 0 1-.553.894l-2 1a1 1 0 1 1-.894-1.788L19 16.382V14.5a1 1 0 0 1 1-1Zm-8 4a1 1 0 0 1 1 1v.882l.553-.276a1 1 0 1 1 .894 1.788l-2 1a1 1 0 0 1-.894 0l-2-1a1 1 0 1 1 .894-1.788l.553.276V18.5a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), GX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6-5a1 1 0 0 1 1-1 3 3 0 0 1 3 3v1h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 0 2 0v-1a1 1 0 1 1 2 0v1a3 3 0 1 1-6 0v-3H9a1 1 0 1 1 0-2h1V9a1 1 0 0 0-1-1 1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), KX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-6a1 1 0 0 1 1 1v.092c.94.177 1.791.604 2.354 1.253a1 1 0 0 1-1.51 1.31c-.163-.187-.453-.377-.844-.504v1.941a4.535 4.535 0 0 1 1.676.662C15.398 12.234 16 13.009 16 14c0 .99-.602 1.765-1.324 2.246-.48.32-1.054.545-1.676.662V17a1 1 0 1 1-2 0v-.092c-.94-.177-1.791-.604-2.354-1.253a1 1 0 0 1 1.51-1.31c.163.187.453.377.844.504v-1.941a4.535 4.535 0 0 1-1.676-.662C8.602 11.766 8 10.991 8 10c0-.99.602-1.765 1.324-2.246A4.535 4.535 0 0 1 11 7.092V7a1 1 0 0 1 1-1Zm-1 3.151c-.22.071-.412.164-.567.267C10.07 9.66 10 9.886 10 10c0 .114.07.34.433.582.155.103.346.196.567.267V9.151Zm2 4v1.698c.22-.071.412-.164.567-.267.364-.243.433-.468.433-.582 0-.114-.07-.34-.433-.582A2.305 2.305 0 0 0 13 13.15Z",
        clipRule: "evenodd"
      }
    )
  }
), QX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-4c-.304 0-.792.193-1.264.979a4.259 4.259 0 0 0-.264.521H12a1 1 0 1 1 0 2h-1.983a7.321 7.321 0 0 0 0 1H12a1 1 0 1 1 0 2h-1.528c.08.185.167.36.264.521.472.786.96.979 1.264.979.304 0 .792-.193 1.264-.979a1 1 0 0 1 1.715 1.029C14.279 17.216 13.232 18 12 18s-2.279-.784-2.979-1.95c-.285-.475-.507-1-.67-1.55H8a1 1 0 1 1 0-2h.013a9.358 9.358 0 0 1 0-1H8a1 1 0 1 1 0-2h.351c.163-.55.385-1.075.67-1.55C9.721 6.784 10.768 6 12 6s2.279.784 2.979 1.95a1 1 0 1 1-1.715 1.029C12.792 8.193 12.304 8 12 8Z",
        clipRule: "evenodd"
      }
    )
  }
), XX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm8-3a3 3 0 1 1 6 0 1 1 0 1 1-2 0 1 1 0 1 0-2 0v2h1a1 1 0 1 1 0 2h-1v1c0 .35-.06.687-.17 1H15a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2 1 1 0 0 0 1-1v-1H9a1 1 0 1 1 0-2h1V9Z",
        clipRule: "evenodd"
      }
    )
  }
), JX = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6-4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-1.535c.179.31.318.645.409 1H15a1 1 0 1 1 0 2h-1.126a4.008 4.008 0 0 1-2.65 2.81l1.483 1.483a1 1 0 0 1-1.414 1.414l-3-3A1 1 0 0 1 9 13h1a2 2 0 0 0 1.732-1H9a1 1 0 1 1 0-2h2.732A2 2 0 0 0 10 9H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), eJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6.486-4.857a1 1 0 0 1 1.371.343L11.967 11h.067l2.108-3.514a1 1 0 0 1 1.716 1.029L14.366 11H15a1 1 0 1 1 0 2h-1.834l-.166.277V14h2a1 1 0 1 1 0 2h-2v1a1 1 0 1 1-2 0v-1H9a1 1 0 1 1 0-2h2v-.723L10.834 13H9a1 1 0 1 1 0-2h.634L8.143 8.514a1 1 0 0 1 .342-1.371Z",
        clipRule: "evenodd"
      }
    )
  }
), tJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.93 1.273a1 1 0 0 1 1.224.707l.777 2.897a1 1 0 0 1-1.932.518l-.777-2.898a1 1 0 0 1 .707-1.224Zm7.727 2.07a1 1 0 0 1 0 1.414L12.535 6.88a1 1 0 1 1-1.414-1.414l2.122-2.122a1 1 0 0 1 1.414 0ZM1.272 6.93a1 1 0 0 1 1.225-.707L5.395 7a1 1 0 0 1-.518 1.932L1.98 8.154a1 1 0 0 1-.708-1.225Zm7.02 1.364a1 1 0 0 1 1.05-.233l11 4a1 1 0 0 1 .03 1.868l-3.593 1.437 3.928 3.928a1 1 0 0 1-1.414 1.414l-3.928-3.928-1.437 3.592a1 1 0 0 1-1.868-.03l-4-11a1 1 0 0 1 .233-1.048Zm2.38 2.38 2.372 6.523 1.027-2.567a1 1 0 0 1 .558-.557l2.567-1.027-6.524-2.373Zm-3.793.448a1 1 0 0 1 0 1.415l-2.122 2.12a1 1 0 0 1-1.414-1.413l2.121-2.122a1 1 0 0 1 1.415 0Z",
        clipRule: "evenodd"
      }
    )
  }
), nJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.79 5.066C5.45 5.736 5 6.478 5 7s.449 1.263 1.79 1.934C8.072 9.574 9.912 10 12 10s3.928-.425 5.21-1.066C18.55 8.264 19 7.522 19 7s-.449-1.263-1.79-1.934C15.928 4.426 14.088 4 12 4s-3.928.425-5.21 1.066ZM19 10.201a7.846 7.846 0 0 1-.896.522C16.49 11.53 14.331 12 12 12c-2.33 0-4.49-.47-6.104-1.277A7.842 7.842 0 0 1 5 10.2V12c0 .522.449 1.263 1.79 1.934C8.072 14.574 9.912 15 12 15s3.928-.425 5.21-1.066C18.55 13.264 19 12.522 19 12v-1.8ZM21 7c0-1.687-1.342-2.946-2.896-3.723C16.49 2.47 14.331 2 12 2c-2.33 0-4.49.47-6.104 1.277C4.342 4.054 3 5.313 3 7v10c0 1.687 1.342 2.946 2.896 3.723C7.51 21.53 9.669 22 12 22c2.33 0 4.49-.47 6.104-1.277C19.658 19.946 21 18.687 21 17V7Zm-2 8.2a7.846 7.846 0 0 1-.896.523C16.49 16.53 14.331 17 12 17c-2.33 0-4.49-.47-6.104-1.277A7.842 7.842 0 0 1 5 15.2V17c0 .522.449 1.263 1.79 1.934C8.072 19.574 9.912 20 12 20s3.928-.425 5.21-1.066C18.55 18.264 19 17.522 19 17v-1.8Z",
        clipRule: "evenodd"
      }
    )
  }
), rJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-3.47l.373 1.489.804.804A1 1 0 0 1 16 22H8a1 1 0 0 1-.707-1.707l.804-.804L8.469 18H5a3 3 0 0 1-3-3V5Zm2 9v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1H4Zm16-2H4V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v7Zm-6.53 6h-2.94l-.5 2h3.94l-.5-2Z",
        clipRule: "evenodd"
      }
    )
  }
), aJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 5a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V5Zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8Zm3 14a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), oJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H7Zm4 14a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), iJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Z",
        clipRule: "evenodd"
      }
    )
  }
), lJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm8 4a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), uJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm8 4a1 1 0 0 1 1 1v3.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 13.586V10a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), sJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8.414L14.586 4H10ZM7 5a3 3 0 0 1 3-3h4.586A2 2 0 0 1 16 2.586L20.414 7A2 2 0 0 1 21 8.414V15a3 3 0 0 1-3 3h-1v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h1V5Zm0 3H6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h-5a3 3 0 0 1-3-3V8Z",
        clipRule: "evenodd"
      }
    )
  }
), cJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm4 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), fJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm11 5a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm-3 2a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Zm-3 2a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), dJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v11a1 1 0 1 1-2 0V5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3h-7a1 1 0 1 1 0-2h7a1 1 0 0 0 1-1V9.414L12.586 4H7Zm5 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 1.968 3.446l-4.26 4.261a1 1 0 0 1-1.415-1.414l4.261-4.261A3.984 3.984 0 0 1 8 14Z",
        clipRule: "evenodd"
      }
    )
  }
), hJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm4 7a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), vJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm5 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H16a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), pJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), mJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z",
        clipRule: "evenodd"
      }
    )
  }
), gJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 17a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 1 1 2 0v1a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-1a1 1 0 1 1 2 0v1Zm2.293-5.707a1 1 0 0 1 1.414 0L11 13.586V4a1 1 0 1 1 2 0v9.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), wJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v1h1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3v-1H6a3 3 0 0 1-3-3V6Zm6 12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v8Zm6-11h-5a3 3 0 0 0-3 3v5H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1Z",
        clipRule: "evenodd"
      }
    )
  }
), yJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6-2a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1Zm6 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1Zm-5.536 4.121a1 1 0 0 1 1.415 0 3 3 0 0 0 4.242 0 1 1 0 0 1 1.415 1.415 5 5 0 0 1-7.072 0 1 1 0 0 1 0-1.415Z",
        clipRule: "evenodd"
      }
    )
  }
), xJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6-2a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1Zm6 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1Zm.121 6.879a3 3 0 0 0-4.242 0 1 1 0 1 1-1.414-1.415 5 5 0 0 1 7.07 0 1 1 0 0 1-1.414 1.415Z",
        clipRule: "evenodd"
      }
    )
  }
), SJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.402 3.5c1.155-2 4.041-2 5.196 0l6.928 12c1.155 2-.288 4.5-2.598 4.5H5.072c-2.31 0-3.753-2.5-2.598-4.5l6.928-12Zm3.464 1a1 1 0 0 0-1.732 0l-6.928 12a1 1 0 0 0 .866 1.5h13.856a1 1 0 0 0 .866-1.5l-6.928-12ZM12 8a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Zm-1 7a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), CJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-5a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm-1 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), bJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-1a1 1 0 1 1 2 0v1a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v1a1 1 0 1 1-2 0V7a2 2 0 0 0-2-2H6Zm10.293 2.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L18.586 13H7a1 1 0 1 1 0-2h11.586l-2.293-2.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), _J = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 5a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V6.414l-8.293 8.293a1 1 0 0 1-1.414-1.414L17.586 5H14ZM6 7a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-4a1 1 0 1 1 2 0v4a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h4a1 1 0 1 1 0 2H6Z",
        clipRule: "evenodd"
      }
    )
  }
), RJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.512 12a9.004 9.004 0 0 0 16.977 0 9.004 9.004 0 0 0-16.977 0Zm-2.008-.3C2.906 7.238 7.074 4 12 4c4.927 0 9.095 3.238 10.497 7.7a1 1 0 0 1 0 .6C21.095 16.762 16.927 20 12 20s-9.095-3.238-10.497-7.7a1 1 0 0 1 0-.6ZM12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
        clipRule: "evenodd"
      }
    )
  }
), EJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.293 2.293a1 1 0 0 1 1.414 0l3.04 3.04A10.955 10.955 0 0 1 12 4c4.927 0 9.095 3.238 10.497 7.7a1 1 0 0 1 0 .6 11.014 11.014 0 0 1-3.552 5.231l2.762 2.762a1 1 0 0 1-1.414 1.414l-18-18a1 1 0 0 1 0-1.414Zm5.943 4.53 1.732 1.731a4 4 0 0 1 5.478 5.478l2.076 2.076A9.022 9.022 0 0 0 20.489 12 9.004 9.004 0 0 0 8.236 6.822Zm5.696 5.695a2 2 0 0 0-2.45-2.45l2.45 2.45ZM4.625 8.174a1 1 0 0 1 .194 1.4A8.975 8.975 0 0 0 3.512 12a9.004 9.004 0 0 0 10.177 5.842 1 1 0 0 1 .372 1.965c-.668.127-1.357.193-2.06.193-4.927 0-9.095-3.238-10.497-7.7a1 1 0 0 1 0-.6 10.97 10.97 0 0 1 1.72-3.332 1 1 0 0 1 1.4-.194Z",
        clipRule: "evenodd"
      }
    )
  }
), MJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 8c0-1.648 1.882-2.589 3.2-1.6L12 10V8c0-1.648 1.882-2.589 3.2-1.6l5.333 4a2 2 0 0 1 0 3.2l-5.333 4c-1.318.989-3.2.048-3.2-1.6v-2l-4.8 3.6c-1.318.989-3.2.048-3.2-1.6V8Zm7.333 4L6 8v8l5.333-4Zm8 0L14 8v8l5.333-4Z",
        clipRule: "evenodd"
      }
    )
  }
), TJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm4 0H4v2h2V5Zm2 0v6h8V5H8Zm10 0v2h2V5h-2Zm2 4h-2v2h2V9Zm0 4h-2v2h2v-2Zm0 4h-2v2h2v-2Zm-4 2v-6H8v6h8ZM6 19v-2H4v2h2Zm-2-4h2v-2H4v2Zm0-4h2V9H4v2Z",
        clipRule: "evenodd"
      }
    )
  }
), OJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2.586A2 2 0 0 1 21.414 8L15 14.414V17a1 1 0 0 1-.293.707l-4 4A1 1 0 0 1 9 21v-6.586L2.586 8A2 2 0 0 1 2 6.586V4Zm18 0H4v2.586L10.414 13A2 2 0 0 1 11 14.414v4.172l2-2v-2.172A2 2 0 0 1 13.586 13L20 6.586V4Z",
        clipRule: "evenodd"
      }
    )
  }
), DJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 3.205A9 9 0 0 1 21 11c0 2.567-.358 5.051-1.029 7.406a1 1 0 0 1-1.923-.548C18.668 15.68 19 13.38 19 11A7 7 0 0 0 8.5 4.936a1 1 0 1 1-1-1.731Zm-1.93 2.93A1 1 0 0 1 5.936 7.5 6.963 6.963 0 0 0 5 11c0 1.72-.395 3.35-1.1 4.801a1 1 0 0 1-1.8-.874A8.96 8.96 0 0 0 3 11c0-1.638.438-3.176 1.205-4.5a1 1 0 0 1 1.366-.366ZM7 11a5 5 0 0 1 10 0 23 23 0 0 1-.213 3.135 1 1 0 0 1-1.981-.27c.128-.937.194-1.893.194-2.865a3 3 0 1 0-6 0 14.916 14.916 0 0 1-2.333 8.041 1 1 0 1 1-1.72-1.021l.068-.111.846.532-.846-.532A12.916 12.916 0 0 0 7 11Zm5-1a1 1 0 0 1 1 1 18.92 18.92 0 0 1-2.906 10.104A1 1 0 1 1 8.4 20.039 16.915 16.915 0 0 0 11 11a1 1 0 0 1 1-1Zm3.443 6.038a1 1 0 0 1 .69 1.234 22.876 22.876 0 0 1-1.56 4.02 1 1 0 1 1-1.788-.896 20.882 20.882 0 0 0 1.424-3.668 1 1 0 0 1 1.234-.69Z",
        clipRule: "evenodd"
      }
    )
  }
), AJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.359 2.22a1 1 0 0 1 1.332.07c.93.925 1.884 1.573 2.85 2.21l.185.122c.89.586 1.825 1.201 2.638 2.014A8.975 8.975 0 0 1 21 13 9 9 0 1 1 5.636 6.636a1 1 0 0 1 1.634.331v.003l.002.002m-.002-.005v.001l.013.028a4.197 4.197 0 0 0 .432.691c.114.15.253.312.418.476A12.62 12.62 0 0 0 8 10h1l.447-.894a5.051 5.051 0 0 1-1.314-.943C8.42 6.222 9.25 3.917 11.36 2.221m.623 2.14C10.379 6.05 10 8.32 10 10a1 1 0 0 1-1.447.894 6.998 6.998 0 0 1-2.323-1.86A6.98 6.98 0 0 0 5 13a7 7 0 1 0 11.95-4.95c-.664-.663-1.438-1.173-2.371-1.789l-.14-.092c-.765-.504-1.607-1.07-2.457-1.809Zm-4.71 2.613Zm3.795 3.706a1 1 0 0 1 .952-.68 3.99 3.99 0 0 1 2.81 1.171A3.99 3.99 0 0 1 16 14a4 4 0 1 1-8 0 1 1 0 0 1 1-1h1.283l.784-2.32Zm1.624 1.442-.744 2.198A1 1 0 0 1 11 15h-.733a2 2 0 1 0 2.424-2.878Z",
        clipRule: "evenodd"
      }
    )
  }
), jJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 4a1 1 0 0 0-1 1v9.17c.313-.11.65-.17 1-.17h6.5a1 1 0 0 1 .707.293l.707.707h6.468l-2.276-4.553a1 1 0 0 1 0-.894L19.382 5H13v4a1 1 0 1 1-2 0V4H5Zm7.914-1H21a1 1 0 0 1 .894 1.447L19.118 10l2.776 5.553A1 1 0 0 1 21 17h-8.5a1 1 0 0 1-.707-.293L11.086 16H5a1 1 0 0 0-1 1v4a1 1 0 1 1-2 0V5a3 3 0 0 1 3-3h6.5a1 1 0 0 1 .707.293l.5.5.207.207Z",
        clipRule: "evenodd"
      }
    )
  }
), kJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-6a1 1 0 0 1-.707-.293L10.586 6H5ZM2 7a3 3 0 0 1 3-3h6a1 1 0 0 1 .707.293L13.414 6H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Z",
        clipRule: "evenodd"
      }
    )
  }
), LJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-6a1 1 0 0 1-.707-.293L10.586 6H5ZM2 7a3 3 0 0 1 3-3h6a1 1 0 0 1 .707.293L13.414 6H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm10 2a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), IJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-6a1 1 0 0 1-.707-.293L10.586 6H5ZM2 7a3 3 0 0 1 3-3h6a1 1 0 0 1 .707.293L13.414 6H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm10 2a1 1 0 0 1 1 1v3.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 13.586V10a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), HJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 6a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0v-5a3 3 0 0 1 3-3h7a1 1 0 0 0-1-1h-4.414l-2-2H5Zm4 5a1 1 0 0 0-1 1v5c0 .35-.06.687-.17 1H19a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H9Zm-4 9a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h4.414l2 2H15a3 3 0 0 1 3 3h1a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3H5Z",
        clipRule: "evenodd"
      }
    )
  }
), ZJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-6a1 1 0 0 1-.707-.293L10.586 6H5ZM2 7a3 3 0 0 1 3-3h6a1 1 0 0 1 .707.293L13.414 6H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm6 6a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), PJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.5 4a1.5 1.5 0 1 0 0 3H11V5.5A1.5 1.5 0 0 0 9.5 4Zm2.863-.514A3.5 3.5 0 0 0 6.337 7H5a3 3 0 0 0-1 5.83V19a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-6.17A3.001 3.001 0 0 0 19 7h-2.17a3 3 0 0 0-4.467-3.514ZM13 6v1h1a1 1 0 1 0-1-1Zm-2 3H5a1 1 0 0 0 0 2h6V9Zm0 4H6v6a1 1 0 0 0 1 1h4v-7Zm2 7v-7h5v6a1 1 0 0 1-1 1h-4Zm0-9V9h6a1 1 0 1 1 0 2h-6Z",
        clipRule: "evenodd"
      }
    )
  }
), NJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.252 10H5a3 3 0 0 1 3 3v1a1 1 0 0 0 1 1 3 3 0 0 1 3 3v2a8 8 0 0 0 2-.252V18a3 3 0 0 1 3-3h2.419c.375-.926.581-1.94.581-3s-.206-2.074-.581-3H19a1 1 0 0 0-1 1 3 3 0 1 1-6 0 1 1 0 0 0-1-1h-.5a3.5 3.5 0 0 1-3.491-3.252A8.004 8.004 0 0 0 4.252 10Zm3.304-6.96A10 10 0 0 0 2 12c0 5.523 4.477 10 10 10s10-4.477 10-10a9.958 9.958 0 0 0-1.039-4.444v-.001A10 10 0 0 0 12 2a9.959 9.959 0 0 0-4.444 1.04ZM9 4.581V5.5A1.5 1.5 0 0 0 10.5 7h.5a3 3 0 0 1 3 3 1 1 0 1 0 2 0 3 3 0 0 1 2.309-2.92A7.986 7.986 0 0 0 12 4a7.98 7.98 0 0 0-3 .582ZM18.245 17H17a1 1 0 0 0-1 1v.93A8.038 8.038 0 0 0 18.245 17ZM10 19.748C6.55 18.86 4 15.728 4 12h1a1 1 0 0 1 1 1v1a3 3 0 0 0 3 3 1 1 0 0 1 1 1v1.748Z",
        clipRule: "evenodd"
      }
    )
  }
), VJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 12a9 9 0 0 1-9 9m9-9a9 9 0 0 0-9-9m9 9H3m9 9a9 9 0 0 1-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 0 1 9-9"
      }
    )
  }
), FJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.5 4a.5.5 0 0 0-.5.5V11a1 1 0 1 1-2 0V5.5a.5.5 0 0 0-1 0V14a1 1 0 1 1-2 0v-2.5a.5.5 0 0 0-1 0v2a6.5 6.5 0 1 0 13 0v-5a.5.5 0 0 0-1 0V11a1 1 0 1 1-2 0V5.5a.5.5 0 0 0-1 0V11a1 1 0 1 1-2 0V4.5a.5.5 0 0 0-.5-.5Zm2.112-.838A2.5 2.5 0 0 1 17 5.5v.55a2.5 2.5 0 0 1 3 2.45v5a8.5 8.5 0 0 1-17 0v-2a2.5 2.5 0 0 1 3-2.45V5.5a2.5 2.5 0 0 1 3.388-2.338 2.498 2.498 0 0 1 4.224 0Z",
        clipRule: "evenodd"
      }
    )
  }
), BJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.242 3.03a1 1 0 0 1 .728 1.213L11.03 8h3.94l1.06-4.243a1 1 0 1 1 1.94.486L17.03 8H20a1 1 0 1 1 0 2h-3.47l-1 4H18a1 1 0 1 1 0 2h-2.97l-1.06 4.242a1 1 0 1 1-1.94-.485L12.97 16H9.03l-1.06 4.242a1 1 0 1 1-1.94-.485L6.97 16H4a1 1 0 1 1 0-2h3.47l1-4H6a1 1 0 0 1 0-2h2.97l1.06-4.243a1 1 0 0 1 1.213-.727ZM10.531 10l-1 4h3.938l1-4h-3.938Z",
        clipRule: "evenodd"
      }
    )
  }
), UJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m14.025 7.025-1.318 1.318a1 1 0 0 1-1.414 0L9.975 7.025a3.5 3.5 0 1 0-4.95 4.95L12 18.95l6.975-6.975.707.707-.707-.707a3.5 3.5 0 0 0-4.95-4.95Zm-1.414-1.414a5.5 5.5 0 0 1 7.778 7.778l-7.682 7.682a1 1 0 0 1-1.414 0L3.61 13.39a5.5 5.5 0 0 1 7.778-7.778l.611.61.61-.61Z",
        clipRule: "evenodd"
      }
    )
  }
), YJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 2.293a1 1 0 0 1 1.414 0l9 9a1 1 0 0 1-1.414 1.414L20 12.414V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7.586l-.293.293a1 1 0 0 1-1.414-1.414l9-9ZM6 10.414V20h3v-4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h3v-9.586l-6-6-6 6ZM13 20v-4h-2v4h2Z",
        clipRule: "evenodd"
      }
    )
  }
), $J = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM4 7a5 5 0 1 1 10 0A5 5 0 0 1 4 7Zm10 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Zm-5 3a5 5 0 0 0-5 5h10a5 5 0 0 0-5-5Zm-7 5a7 7 0 1 1 14 0v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1Z",
        clipRule: "evenodd"
      }
    )
  }
), WJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 5a3 3 0 1 1 6 0h4a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h4Zm.17 2H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-4.17a3.001 3.001 0 0 1-5.66 0ZM12 4a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1Zm-3 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm2.4 2.8a3 3 0 1 0-4.8 0 4.01 4.01 0 0 0-1.372 1.867 1 1 0 1 0 1.885.666 2.001 2.001 0 0 1 3.773 0 1 1 0 1 0 1.886-.666A4.01 4.01 0 0 0 11.4 13.8ZM14 11a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), zJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v6h1.586A2 2 0 0 1 8 12.586L10.414 15h3.172L16 12.586A2 2 0 0 1 17.414 12H19V6a1 1 0 0 0-1-1H6Zm13 9h-1.586L15 16.414a2 2 0 0 1-1.414.586h-3.172A2 2 0 0 1 9 16.414L6.586 14H5v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4Z",
        clipRule: "evenodd"
      }
    )
  }
), qJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v5.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 1.414-1.414L11 8.586V3a1 1 0 0 1 1-1ZM6 5a1 1 0 0 0-1 1v6h1.586A2 2 0 0 1 8 12.586L10.414 15h3.172L16 12.586A2 2 0 0 1 17.414 12H19V6a1 1 0 0 0-1-1h-2a1 1 0 1 1 0-2h2a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h2a1 1 0 0 1 0 2H6Zm-1 9v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4h-1.586L15 16.414a2 2 0 0 1-1.414.586h-3.172A2 2 0 0 1 9 16.414L6.586 14H5Z",
        clipRule: "evenodd"
      }
    )
  }
), GJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9-4a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm-1 4a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), KJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15 4a5 5 0 0 0-4.786 6.453 1 1 0 0 1-.25.997L4 17.414V20h2v-1a1 1 0 0 1 1-1h1v-1a1 1 0 0 1 1-1h1.586l1.964-1.964a1 1 0 0 1 .997-.25A5 5 0 1 0 15 4ZM8 20v1a1 1 0 0 1-1 1H4a2 2 0 0 1-2-2v-2.586A2 2 0 0 1 2.586 16l5.562-5.562a7 7 0 1 1 5.414 5.414l-1.855 1.855A1 1 0 0 1 11 18h-1v1a1 1 0 0 1-1 1H8Zm6-13a1 1 0 0 1 1-1 3 3 0 0 1 3 3 1 1 0 1 1-2 0 1 1 0 0 0-1-1 1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), QJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.594 2.086a1 1 0 0 1 .812 0l9 4a1 1 0 0 1-.812 1.828L12 4.094l-8.594 3.82a1 1 0 1 1-.812-1.828l9-4ZM2 10a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2v9a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2v-9a1 1 0 0 1-1-1Zm3 1v9h14v-9H5Zm3 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), XJ = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1ZM4.929 4.929a1 1 0 0 1 1.414 0l.707.707A1 1 0 1 1 5.636 7.05l-.707-.707a1 1 0 0 1 0-1.414Zm14.142 0a1 1 0 0 1 0 1.414l-.707.707a1 1 0 0 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 0Zm-9.9 4.243a4 4 0 0 0 0 5.656l.548.548c.193.193.366.402.518.624h3.526a4.38 4.38 0 0 1 .518-.624l.547-.547a4 4 0 0 0-5.656-5.657Zm6.074 8.247c.114-.231.265-.444.45-.63l.548-.546a6 6 0 1 0-8.486 0l.547.547A2.374 2.374 0 0 1 9 18.469V19a3 3 0 1 0 6 0v-.531a2.374 2.374 0 0 1 .245-1.05Zm-2.22.581h-2.05c.017.155.025.312.025.469V19a1 1 0 1 0 2 0v-.531c0-.157.008-.314.025-.469ZM2 12a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1Zm17 0a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2h-1a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), JJ = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.336 2.058A1 1 0 0 1 14 3v6h6a1 1 0 0 1 .774 1.633l-9 11A1 1 0 0 1 10 21v-6H4a1 1 0 0 1-.774-1.633l9-11a1 1 0 0 1 1.11-.309ZM6.11 13H11a1 1 0 0 1 1 1v4.199L17.89 11H13a1 1 0 0 1-1-1V5.801L6.11 13Z",
        clipRule: "evenodd"
      }
    )
  }
), eee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.121 4.879a3 3 0 0 0-4.242 0l-1.1 1.1a1 1 0 1 1-1.414-1.415l1.1-1.1a5 5 0 1 1 7.07 7.072l-4 4a5 5 0 0 1-7.07 0 1 1 0 1 1 1.414-1.415 3 3 0 0 0 4.242 0l4-4a3 3 0 0 0 0-4.242Zm-6 6a3 3 0 0 0-4.242 0l-4 4A3 3 0 1 0 9.12 19.12l1.102-1.101a1 1 0 1 1 1.414 1.414l-1.101 1.101a5 5 0 1 1-7.072-7.07l4-4a5 5 0 0 1 7.072 0 1 1 0 1 1-1.415 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), tee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.95 6.05a7 7 0 1 0-9.9 9.9l4.244 4.243a.998.998 0 0 0 1.413 0l4.243-4.243a7 7 0 0 0 0-9.9ZM5.636 4.636a9 9 0 0 1 12.728 12.728l-3.502 3.502-.018.018-.723.723a2.998 2.998 0 0 1-4.241 0l-4.244-4.243a9 9 0 0 1 0-12.728ZM12 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
        clipRule: "evenodd"
      }
    )
  }
), nee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 7a5 5 0 0 1 10 0v3h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h1V7Zm2 3h6V7a3 3 0 1 0-6 0v3Zm-3 2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H6Zm6 2a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), ree = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 7a5 5 0 0 1 10 0 1 1 0 1 1-2 0 3 3 0 1 0-6 0v3h9a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h1V7Zm-1 5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H6Zm6 2a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), aee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-1a1 1 0 1 1 2 0v1a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h7a4 4 0 0 1 4 4v1a1 1 0 1 1-2 0V7a2 2 0 0 0-2-2H6Zm5.707 2.293a1 1 0 0 1 0 1.414L9.414 11H21a1 1 0 1 1 0 2H9.414l2.293 2.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), oee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm2 2.869V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9.869l-6.336 4.223a3 3 0 0 1-3.328 0L4 9.87Zm16-2.404-7.445 4.963a1 1 0 0 1-1.11 0L4 7.465V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v.465Z",
        clipRule: "evenodd"
      }
    )
  }
), iee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.555 4.572a1 1 0 0 0-1.11 0l-7 4.666a1 1 0 0 0-.304.32l7.304 4.87a1 1 0 0 0 1.11 0l7.304-4.87a1 1 0 0 0-.304-.32l-7-4.666Zm9.44 5.328a3 3 0 0 0-1.33-2.326l-7-4.666a3 3 0 0 0-3.33 0l-7 4.666A3 3 0 0 0 2 10.07V19a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-8.93a3.028 3.028 0 0 0-.005-.17ZM20 11.868 16.053 14.5 20 17.131v-5.263Zm-.112 7.592-5.638-3.758-.586.39a3 3 0 0 1-3.328 0l-.586-.39-5.638 3.758A1 1 0 0 0 5 20h14a1 1 0 0 0 .888-.54ZM4 17.131 7.947 14.5 4 11.868v5.263Z",
        clipRule: "evenodd"
      }
    )
  }
), lee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.553 3.106a1 1 0 0 1 .894 0l5.447 2.723A2 2 0 0 1 22 7.618v10.764a2 2 0 0 1-2.894 1.789L15 18.118l-5.553 2.776a1 1 0 0 1-.894 0l-5.447-2.723A2 2 0 0 1 2 16.382V5.618a2 2 0 0 1 2.894-1.789L9 5.882l5.553-2.776ZM8 7.618l-4-2v10.764l4 2V7.618Zm2 10.764 4-2V5.618l-4 2v10.764Zm6-12.764v10.764l4 2V7.618l-4-2Z",
        clipRule: "evenodd"
      }
    )
  }
), uee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), see = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), cee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), fee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm9 6a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), dee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 8a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 8a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), hee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 5a4 4 0 1 1 8 0v6a4 4 0 0 1-8 0V5Zm4-2a2 2 0 0 0-2 2v6a2 2 0 1 0 4 0V5a2 2 0 0 0-2-2Zm-7 7a1 1 0 0 1 1 1 6 6 0 0 0 12 0 1 1 0 1 1 2 0 8.001 8.001 0 0 1-7 7.938V21h3a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h3v-2.062A8.001 8.001 0 0 1 4 11a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), vee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 12a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), pee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6 0a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), mee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 12a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), gee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.353 2.939a1 1 0 0 1 .22 1.08 8 8 0 0 0 10.408 10.408 1 1 0 0 1 1.301 1.3A10.003 10.003 0 0 1 12 22C6.477 22 2 17.523 2 12c0-4.207 2.598-7.805 6.273-9.282a1 1 0 0 1 1.08.22ZM7.086 5.687a8 8 0 1 0 11.228 11.228c-.43.056-.87.085-1.314.085-5.523 0-10-4.477-10-10 0-.445.03-.883.086-1.313Z",
        clipRule: "evenodd"
      }
    )
  }
), wee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.615 2.212A1 1 0 0 1 22 3v13c0 .99-.602 1.765-1.324 2.246-.729.486-1.678.754-2.676.754-.998 0-1.947-.268-2.676-.754C14.602 17.766 14 16.991 14 16c0-.99.602-1.765 1.324-2.246C16.053 13.268 17.002 13 18 13c.712 0 1.4.136 2 .391v-5.11l-10 2.5V19c0 .99-.602 1.765-1.324 2.246C7.947 21.732 6.998 22 6 22c-.998 0-1.947-.268-2.676-.754C2.602 20.766 2 19.991 2 19c0-.99.602-1.765 1.324-2.246C4.053 16.268 5.002 16 6 16c.713 0 1.4.137 2 .391V6a1 1 0 0 1 .757-.97l12-3a1 1 0 0 1 .858.182ZM10 8.719l10-2.5V4.281l-10 2.5v1.938ZM8 19c0-.114-.07-.34-.433-.582C7.21 18.18 6.659 18 6 18c-.659 0-1.21.18-1.567.418C4.07 18.66 4 18.886 4 19c0 .114.07.34.433.582C4.79 19.82 5.341 20 6 20c.659 0 1.21-.18 1.567-.418C7.93 19.34 8 19.114 8 19Zm12-3c0-.114-.07-.34-.433-.582C19.209 15.18 18.658 15 18 15c-.659 0-1.21.18-1.567.418-.364.243-.433.468-.433.582 0 .114.07.34.433.582.358.238.909.418 1.567.418.659 0 1.21-.18 1.567-.418.364-.243.433-.468.433-.582Z",
        clipRule: "evenodd"
      }
    )
  }
), yee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3h1a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6Zm14.17 13H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v12c0 .35.06.687.17 1ZM18 8v10a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1h-1ZM6 8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8Zm2 1v2h4V9H8Zm-2 7a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), xee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v15h1a1 1 0 1 1 0 2H3a1 1 0 0 1 0-2h1V5Zm2 15h3v-4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h3V5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v15Zm7 0v-4h-2v4h2ZM8 7a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm5 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Zm-5 4a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm5 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), See = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 .894.553l9 18a1 1 0 0 1-1.11 1.423L12 20.024l-8.783 1.952a1 1 0 0 1-1.111-1.423l9-18A1 1 0 0 1 12 2Zm1 16.198 6.166 1.37L12 5.236 4.834 19.568 11 18.198V11a1 1 0 1 1 2 0v7.198Z",
        clipRule: "evenodd"
      }
    )
  }
), Cee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m12.883 4.874-6.418 6.59a5 5 0 1 0 7.07 7.071h.001l6.258-6.243a1 1 0 1 1 1.412 1.416L14.95 19.95a7 7 0 0 1-9.905-9.895l6.42-6.59a5 5 0 0 1 7.075 7.066l-6.419 6.59A3 3 0 0 1 7.88 12.88l6.585-6.586a1 1 0 1 1 1.415 1.414l-6.586 6.586a1 1 0 0 0 1.41 1.418l6.418-6.59a3 3 0 0 0-4.238-4.247Z",
        clipRule: "evenodd"
      }
    )
  }
), bee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm8-4a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), _ee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.56 4.44a1.5 1.5 0 0 0-2.12 0l-.794.792 2.122 2.122.793-.793a1.5 1.5 0 0 0 0-2.122Zm1.415 3.535a3.5 3.5 0 0 0-4.95-4.95l-1.5 1.5L2.293 16.757a1 1 0 0 0-.293.707v3.572a1 1 0 0 0 1 1h3.5a1 1 0 0 0 .707-.293L20.975 7.975Zm-3.621.793-2.122-2.122L4 17.88v2.156h2.086L17.354 8.768Z",
        clipRule: "evenodd"
      }
    )
  }
), Ree = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.707 4.293a1 1 0 0 0-1.414 0L10 12.586V14h1.414l8.293-8.293a1 1 0 0 0 0-1.414ZM16.88 2.879a3 3 0 1 1 4.24 4.241l-8.585 8.586a1 1 0 0 1-.708.293H9a1 1 0 0 1-1-1v-2.828a1 1 0 0 1 .293-.708l8.586-8.585ZM6 6a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-5a1 1 0 1 1 2 0v5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h5a1 1 0 1 1 0 2H6Z",
        clipRule: "evenodd"
      }
    )
  }
), Eee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h3.28a2 2 0 0 1 1.897 1.368l1.497 4.493a2 2 0 0 1-1.002 2.421l-1.357.679a10.055 10.055 0 0 0 3.724 3.724l.679-1.357a2 2 0 0 1 2.421-1.002l4.494 1.497A2 2 0 0 1 22 15.721V19a3 3 0 0 1-3 3h-1C9.163 22 2 14.837 2 6V5Zm3-1a1 1 0 0 0-1 1v1c0 7.732 6.268 14 14 14h1a1 1 0 0 0 1-1v-3.28l-4.493-1.497-1.13 2.257a1 1 0 0 1-1.305.465 12.042 12.042 0 0 1-6.017-6.018 1 1 0 0 1 .465-1.305l2.257-1.129L8.28 4H5Z",
        clipRule: "evenodd"
      }
    )
  }
), Mee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h3.28a2 2 0 0 1 1.897 1.368l1.497 4.493a2 2 0 0 1-1.002 2.421l-1.357.679a10.055 10.055 0 0 0 3.724 3.724l.679-1.357a2 2 0 0 1 2.421-1.002l4.494 1.497A2 2 0 0 1 22 15.721V19a3 3 0 0 1-3 3h-1C9.163 22 2 14.837 2 6V5Zm3-1a1 1 0 0 0-1 1v1c0 7.732 6.268 14 14 14h1a1 1 0 0 0 1-1v-3.28l-4.493-1.497-1.13 2.257a1 1 0 0 1-1.305.465 12.042 12.042 0 0 1-6.017-6.018 1 1 0 0 1 .465-1.305l2.257-1.129L8.28 4H5Zm15.293-1.707a1 1 0 1 1 1.414 1.414L17.414 8H20a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v2.586l4.293-4.293Z",
        clipRule: "evenodd"
      }
    )
  }
), Tee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h3.28a2 2 0 0 1 1.897 1.368l1.497 4.493a2 2 0 0 1-1.002 2.421l-1.357.679a10.055 10.055 0 0 0 3.724 3.724l.679-1.357a2 2 0 0 1 2.421-1.002l4.494 1.497A2 2 0 0 1 22 15.721V19a3 3 0 0 1-3 3h-1C9.163 22 2 14.837 2 6V5Zm3-1a1 1 0 0 0-1 1v1c0 7.732 6.268 14 14 14h1a1 1 0 0 0 1-1v-3.28l-4.493-1.497-1.13 2.257a1 1 0 0 1-1.305.465 12.042 12.042 0 0 1-6.017-6.018 1 1 0 0 1 .465-1.305l2.257-1.129L8.28 4H5Zm10.293-.707a1 1 0 0 1 1.414 0L18 4.586l1.293-1.293a1 1 0 1 1 1.414 1.414L19.414 6l1.293 1.293a1 1 0 0 1-1.414 1.414L18 7.414l-1.293 1.293a1 1 0 1 1-1.414-1.414L16.586 6l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Oee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h3.28a2 2 0 0 1 1.897 1.368l1.497 4.493a2 2 0 0 1-1.002 2.421l-1.357.679a10.055 10.055 0 0 0 3.724 3.724l.679-1.357a2 2 0 0 1 2.421-1.002l4.494 1.497A2 2 0 0 1 22 15.721V19a3 3 0 0 1-3 3h-1C9.163 22 2 14.837 2 6V5Zm3-1a1 1 0 0 0-1 1v1c0 7.732 6.268 14 14 14h1a1 1 0 0 0 1-1v-3.28l-4.493-1.497-1.13 2.257a1 1 0 0 1-1.305.465 12.042 12.042 0 0 1-6.017-6.018 1 1 0 0 1 .465-1.305l2.257-1.129L8.28 4H5Zm11 0a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V5.414l-4.293 4.293a1 1 0 0 1-1.414-1.414L18.586 4H16Z",
        clipRule: "evenodd"
      }
    )
  }
), Dee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm2 10.414V18a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.586l-1.293-1.293a1 1 0 0 0-1.414 0l-.879.879 1.293 1.293a1 1 0 0 1-1.414 1.414l-2-2-2.586-2.586a1 1 0 0 0-1.414 0L5 16.414Zm9-3.828-1.879-1.879a3 3 0 0 0-4.242 0L5 13.586V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5.592a3 3 0 0 0-4.121.115l-.879.879ZM13 8a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H14a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Aee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7-2.131c0-1.598 1.78-2.55 3.11-1.665l3.197 2.132a2 2 0 0 1 0 3.328l-3.198 2.132C10.78 16.682 9 15.729 9 14.132V9.869ZM14.197 12 11 9.869v4.263L14.197 12Z",
        clipRule: "evenodd"
      }
    )
  }
), jee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3a1 1 0 0 1 1 1v7h7a1 1 0 1 1 0 2h-7v7a1 1 0 1 1-2 0v-7H4a1 1 0 1 1 0-2h7V4a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), kee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-4a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2V9a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Lee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 5a1 1 0 0 1 1 1v5h5a1 1 0 1 1 0 2h-5v5a1 1 0 1 1-2 0v-5H6a1 1 0 1 1 0-2h5V6a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Iee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2v11a2 2 0 0 1-2 2h-4.586l2.293 2.293a1 1 0 0 1-1.414 1.414L12 18.414l-3.293 3.293a1 1 0 0 1-1.414-1.414L9.586 18H5a2 2 0 0 1-2-2V5a1 1 0 0 1-1-1Zm3 1v11h14V5H5Zm11 2a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm-4 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm-4 2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Hee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2v11a2 2 0 0 1-2 2h-4.586l2.293 2.293a1 1 0 0 1-1.414 1.414L12 18.414l-3.293 3.293a1 1 0 0 1-1.414-1.414L9.586 18H5a2 2 0 0 1-2-2V5a1 1 0 0 1-1-1Zm3 1v11h14V5H5Zm12.707 2.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0L10 10.414l-2.293 2.293a1 1 0 0 1-1.414-1.414l3-3a1 1 0 0 1 1.414 0L13 10.586l3.293-3.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Zee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 5a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v3h1a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-1v1a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3v-1H5a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h1V5Zm2 3h8V5a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3Zm-3 2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1v-1a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v1h1a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H5Zm11 5a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Pee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4a3 3 0 1 1 6 0v1h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1a1 1 0 1 0 0 2h1a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-1a1 1 0 1 0-2 0v1a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H4a3 3 0 1 1 0-6h1V7a2 2 0 0 1 2-2h3V4Zm3-1a1 1 0 0 0-1 1v1a2 2 0 0 1-2 2H7v3a2 2 0 0 1-2 2H4a1 1 0 1 0 0 2h1a2 2 0 0 1 2 2v3h3v-1a3 3 0 1 1 6 0v1h3v-3h-1a3 3 0 1 1 0-6h1V7h-3a2 2 0 0 1-2-2V4a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Nee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm4 0H5v2h2V5Zm5-2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Zm3 2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V5Zm4 0h-2v2h2V5Zm-7 3a1 1 0 0 1 1 1v2h3.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Zm-9 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm16 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H20a1 1 0 0 1-1-1ZM3 17a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2Zm4 0H5v2h2v-2Zm4-1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-1v3a1 1 0 1 1-2 0v-4Zm6 0a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm-2 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Vee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-4c-1.472 0-2.528.706-2.868 1.426a1 1 0 0 1-1.809-.852C8.082 6.964 9.99 6 12 6c1.3 0 2.515.394 3.428 1.079C16.343 7.764 17 8.786 17 10c0 2.07-1.834 3.508-3.817 3.889a.31.31 0 0 0-.162.083A.107.107 0 0 0 13 14a1 1 0 0 1-2 0c0-1.142.909-1.904 1.805-2.075C14.279 11.642 15 10.729 15 10c0-.443-.237-.92-.771-1.321C13.694 8.278 12.909 8 12 8Zm-1 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Fee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v16a1 1 0 0 1-1.447.894L16 20.118l-3.553 1.776a1 1 0 0 1-.894 0L8 20.118l-3.553 1.776A1 1 0 0 1 3 21V5Zm3-1a1 1 0 0 0-1 1v14.382l2.553-1.276a1 1 0 0 1 .894 0L12 19.882l3.553-1.776a1 1 0 0 1 .894 0L19 19.382V5a1 1 0 0 0-1-1H6Zm5.707 2.293a1 1 0 0 1 0 1.414L10.414 9H12a5 5 0 0 1 5 5v1a1 1 0 1 1-2 0v-1a3 3 0 0 0-3-3h-1.586l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Bee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v16a1 1 0 0 1-1.496.868L15.5 20.152l-3.004 1.716a1 1 0 0 1-.992 0L8.5 20.152l-3.004 1.716A1 1 0 0 1 4 21V5Zm3-1a1 1 0 0 0-1 1v14.277l2.004-1.145a1 1 0 0 1 .992 0L12 19.848l3.004-1.716a1 1 0 0 1 .992 0L18 19.277V5a1 1 0 0 0-1-1H7Zm1 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6.293-1.207a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414-1.414l6-6ZM13 13.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Uee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 3a1 1 0 0 1 1 1v2.343A8.982 8.982 0 0 1 12 3a9.001 9.001 0 0 1 8.93 7.876 1 1 0 1 1-1.984.248A7.001 7.001 0 0 0 6.254 8H9a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm-.062 9.008a1 1 0 0 1 1.116.868A7.001 7.001 0 0 0 17.746 16H15a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-2.343A8.982 8.982 0 0 1 12 21a9.001 9.001 0 0 1-8.93-7.876 1 1 0 0 1 .868-1.116Z",
        clipRule: "evenodd"
      }
    )
  }
), Yee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.707 3.293a1 1 0 0 1 0 1.414L5.414 9H13a9 9 0 0 1 9 9v2a1 1 0 1 1-2 0v-2a7 7 0 0 0-7-7H5.414l4.293 4.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), $ee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.8 6.4C10.118 5.411 12 6.352 12 8v2l4.8-3.6C18.119 5.411 20 6.352 20 8v8c0 1.648-1.881 2.589-3.2 1.6L12 14v2c0 1.648-1.882 2.589-3.2 1.6l-5.333-4a2 2 0 0 1 0-3.2l5.333-4ZM10 8l-5.333 4L10 16V8Zm8 0-5.333 4L18 16V8Z",
        clipRule: "evenodd"
      }
    )
  }
), Wee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 5a1 1 0 0 1 1-1c7.732 0 14 6.268 14 14a1 1 0 1 1-2 0c0-6.627-5.373-12-12-12a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1 8 8 0 0 1 8 8 1 1 0 1 1-2 0 6 6 0 0 0-6-6 1 1 0 0 1-1-1Zm-1 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), zee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 2,
        d: "M4 12c11 0 5 6 16 6M4 18C15 18 9 6 20 6M4 6c11 0 5 6 16 6"
      }
    )
  }
), qee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3a1 1 0 0 1 1 1v7.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 11.586V4a1 1 0 0 1 1-1ZM2 9a3 3 0 0 1 3-3h3a1 1 0 0 1 0 2H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-3a1 1 0 1 1 0-2h3a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V9Z",
        clipRule: "evenodd"
      }
    )
  }
), Gee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 2a1 1 0 0 1 1 1v6.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L13 9.586V3a1 1 0 0 1 1-1ZM6 7a3 3 0 0 1 3-3h1a1 1 0 1 1 0 2H9a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1a1 1 0 1 1 0-2h1a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-1v1a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3h1V7Zm0 3H5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1H9a3 3 0 0 1-3-3v-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Kee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v1.28l5 1.666 2.684-.895a1 1 0 0 1 .632 1.898l-2.051.683 2.668 8.003a1 1 0 0 1-.33 1.164 6.002 6.002 0 0 1-7.204 0 1 1 0 0 1-.348-1.115l2.684-8.052L13 6.387V20h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2V6.387L7.265 7.632l2.668 8.003a1 1 0 0 1-.33 1.164 6.002 6.002 0 0 1-7.204 0 1 1 0 0 1-.348-1.115l2.684-8.052-2.051-.683a1 1 0 0 1 .632-1.898L6 5.946l5-1.667V3a1 1 0 0 1 1-1Zm-6 8.162-1.803 5.41a4.01 4.01 0 0 0 3.606 0L6 10.162Zm12 0-1.803 5.41a4.01 4.01 0 0 0 3.606 0L18 10.162Z",
        clipRule: "evenodd"
      }
    )
  }
), Qee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM3 7a4 4 0 1 1 7.446 2.032L12 10.586l6.293-6.293a1 1 0 1 1 1.414 1.414l-9.261 9.261a4 4 0 1 1-1.414-1.414L10.586 12l-1.554-1.554A4 4 0 0 1 3 7Zm4 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm6.414-1.586a1 1 0 0 1 1.414 0l4.88 4.879a1 1 0 0 1-1.415 1.414l-4.879-4.879a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Xee = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 14.32 4.906l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387A8 8 0 0 1 2 10Z",
        clipRule: "evenodd"
      }
    )
  }
), Jee = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-3a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 1.968 3.446l-2.26 2.261a1 1 0 0 1-1.415-1.414l2.261-2.261A3.984 3.984 0 0 1 9 11Z",
        clipRule: "evenodd"
      }
    )
  }
), ete = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a1 1 0 0 1 .707.293l4 4a1 1 0 0 1-1.414 1.414L12 6.414 8.707 9.707a1 1 0 0 1-1.414-1.414l4-4A1 1 0 0 1 12 4ZM7.293 14.293a1 1 0 0 1 1.414 0L12 17.586l3.293-3.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), tte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v4c0 .768-.289 1.47-.764 2 .475.53.764 1.232.764 2v4a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-4c0-.768.289-1.47.764-2A2.989 2.989 0 0 1 2 10V6Zm3 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H5Zm14-2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14Zm-3-3a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H17a1 1 0 0 1-1-1Zm0 8a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H17a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), nte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 .983 2.626l-5.071 2.536a4.012 4.012 0 0 1 0 1.676l5.071 2.536a4 4 0 1 1-.895 1.788l-5.071-2.536a4 4 0 1 1 0-5.253l5.071-2.535A4.015 4.015 0 0 1 14 6Zm-8 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm12 6a2 2 0 1 0-.001 4A2 2 0 0 0 18 16Z",
        clipRule: "evenodd"
      }
    )
  }
), rte = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.333 2.2a1 1 0 0 1 1.334 0 10.955 10.955 0 0 0 7.9 2.786 1 1 0 0 1 1.019.748C21.856 6.778 22 7.874 22 9c0 6.059-4.144 11.147-9.75 12.59a1 1 0 0 1-.5 0C6.145 20.147 2 15.06 2 9c0-1.127.144-2.222.414-3.266a1 1 0 0 1 1.019-.748 10.955 10.955 0 0 0 7.9-2.786ZM4.181 6.998A11.092 11.092 0 0 0 4 9c0 5.034 3.382 9.28 8 10.586 4.618-1.305 8-5.552 8-10.586 0-.684-.062-1.353-.181-2.001a12.946 12.946 0 0 1-7.82-2.751 12.946 12.946 0 0 1-7.818 2.75Zm11.526 2.294a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 12.586l3.293-3.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), ate = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.333 2.2a1 1 0 0 1 1.334 0 10.955 10.955 0 0 0 7.9 2.786 1 1 0 0 1 1.019.748C21.856 6.778 22 7.874 22 9c0 6.059-4.144 11.147-9.75 12.59a1 1 0 0 1-.5 0C6.145 20.147 2 15.06 2 9c0-1.127.144-2.222.414-3.266a1 1 0 0 1 1.019-.748 10.955 10.955 0 0 0 7.9-2.786ZM4.181 6.998A11.092 11.092 0 0 0 4 9c0 5.034 3.382 9.28 8 10.586 4.618-1.305 8-5.552 8-10.586 0-.684-.062-1.353-.181-2.001a12.946 12.946 0 0 1-7.82-2.751 12.946 12.946 0 0 1-7.818 2.75ZM12 8a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Zm-1 7a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), ote = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 7a5 5 0 0 1 10 0v1h2a1 1 0 0 1 .997.917l1 12A1 1 0 0 1 20 22H4a1 1 0 0 1-.997-1.083l1-12A1 1 0 0 1 5 8h2V7Zm0 3v1a1 1 0 1 0 2 0v-1h6v1a1 1 0 1 0 2 0v-1h1.08l.833 10H5.087l.833-10H7Zm8-2H9V7a3 3 0 1 1 6 0v1Z",
        clipRule: "evenodd"
      }
    )
  }
), ite = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3a1 1 0 0 1 1-1h2a1 1 0 0 1 .98.804L6.22 4H21a1 1 0 0 1 .894 1.447l-4 8A1 1 0 0 1 17 14H7.414l-2 2H17a3 3 0 1 1-2.83 2H9.83a3 3 0 1 1-5.521-.326c-.98-.65-1.268-2.129-.309-3.088l1.914-1.915L4.18 4H3a1 1 0 0 1-1-1Zm5.82 9h8.562l3-6H6.62l1.2 6ZM7 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm10 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
        clipRule: "evenodd"
      }
    )
  }
), lte = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 5a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm0 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm0 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM19 5a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm0 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm0 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), ute = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Zm7 1a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2ZM3 16a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H6Zm11-2a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), ste = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm14 2.414-2.293 2.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L18 10.414V20a1 1 0 1 1-2 0v-9.586ZM2 12a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), cte = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm15-1a1 1 0 0 1 1 1v9.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L16 17.586V8a1 1 0 0 1 1-1ZM2 12a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), fte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 2a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2H6v1a1 1 0 0 1-2 0V6H3a1 1 0 0 1 0-2h1V3a1 1 0 0 1 1-1Zm8 0a1 1 0 0 1 .949.684l2.135 6.404 5.267 1.976a1 1 0 0 1 0 1.872l-5.267 1.976-2.135 6.404a1 1 0 0 1-1.898 0l-2.135-6.404-5.267-1.976a1 1 0 0 1 0-1.872l5.267-1.976 2.135-6.404A1 1 0 0 1 13 2Zm0 4.162-1.337 4.011a1 1 0 0 1-.598.62L7.848 12l3.217 1.207a1 1 0 0 1 .598.62L13 17.837l1.337-4.01a1 1 0 0 1 .598-.62L18.152 12l-3.217-1.207a1 1 0 0 1-.598-.62L13 6.163ZM6 16a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2H7v1a1 1 0 1 1-2 0v-1H4a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), dte = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.351 2.064A1 1 0 0 1 19 3v3.126a4.002 4.002 0 0 1 0 7.748V17a1 1 0 0 1-1.753.658c-.613-.702-1.699-1.375-3.188-1.872A14.547 14.547 0 0 0 12 15.271v3.97a2.76 2.76 0 0 1-5.359.927l-.002-.006-2.01-5.76A5 5 0 0 1 7 5h1.832a18.768 18.768 0 0 0 2.07-.112 15.426 15.426 0 0 0 3.157-.673c1.49-.497 2.575-1.17 3.188-1.872a1 1 0 0 1 1.104-.278ZM10 6.968A21.14 21.14 0 0 1 8.832 7H7a3 3 0 0 0 0 6h1.832c.394 0 .784.01 1.168.032V6.968Zm2 6.275V6.757a16.89 16.89 0 0 0 2.692-.646c.84-.28 1.62-.626 2.308-1.035v9.848a11.903 11.903 0 0 0-2.308-1.035A16.807 16.807 0 0 0 12 13.243Zm7-1.51a2 2 0 0 0 0-3.465v3.464Zm-9 3.303A19.108 19.108 0 0 0 8.832 15H6.955l1.57 4.496v.002A.76.76 0 0 0 10 19.24v-4.204Z",
        clipRule: "evenodd"
      }
    )
  }
), hte = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17 2a3 3 0 0 0-3 3v1.17c-.313-.11-.65-.17-1-.17h-2a3 3 0 0 0-3 3v1.17c-.313-.11-.65-.17-1-.17H5a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h2c.768 0 1.47-.289 2-.764.53.475 1.232.764 2 .764h2c.768 0 1.47-.289 2-.764.53.475 1.232.764 2 .764h2a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3h-2Zm-7 17v-5h4v5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1Zm4-7h-4V9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3Zm-7 0a1 1 0 0 1 1 1v2H4v-2a1 1 0 0 1 1-1h2Zm-3 7v-2h4v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Zm12 0a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-9h-4v9Zm0-11V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h-4Z",
        clipRule: "evenodd"
      }
    )
  }
), vte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.098 2.618c.599-1.843 3.205-1.843 3.804 0l1.519 4.673h4.914c1.938 0 2.743 2.48 1.176 3.619l-3.976 2.889 1.519 4.674c.598 1.842-1.51 3.374-3.078 2.236L12 17.82l-3.976 2.889c-1.567 1.138-3.676-.394-3.078-2.236l1.519-4.674-3.976-2.89C.922 9.772 1.727 7.293 3.665 7.293h4.914l1.519-4.674ZM12 3.236 10.481 7.91A2 2 0 0 1 8.58 9.29H3.665l3.975 2.89a2 2 0 0 1 .727 2.235L6.848 19.09l3.977-2.888a2 2 0 0 1 2.35 0l3.976 2.888-1.518-4.674a2 2 0 0 1 .727-2.236l3.975-2.888h-4.914a2 2 0 0 1-1.902-1.382L12 3.236Z",
        clipRule: "evenodd"
      }
    )
  }
), pte = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.293 2.293a1 1 0 0 1 1.414 0l7.775 7.775a2.002 2.002 0 0 1 2.45 2.45l1.514 1.514a4.001 4.001 0 0 0-.618-4.86 1 1 0 0 1 1.415-1.415 6.002 6.002 0 0 1 .648 7.72l1.43 1.429a8.001 8.001 0 0 0-.664-10.563A1 1 0 1 1 19.07 4.93c3.667 3.667 3.89 9.472.672 13.4l1.964 1.964a1 1 0 0 1-1.414 1.414l-18-18a1 1 0 0 1 0-1.414Zm1.495 5.885a1 1 0 0 1 .629 1.267 8 8 0 0 0 1.926 8.212A1 1 0 1 1 4.93 19.07 10 10 0 0 1 2.52 8.807a1 1 0 0 1 1.267-.629Zm3.121 3.539a1 1 0 0 1 1.131.85 3.978 3.978 0 0 0 1.132 2.261 1 1 0 0 1-1.415 1.415 5.978 5.978 0 0 1-1.697-3.396 1 1 0 0 1 .85-1.13Z",
        clipRule: "evenodd"
      }
    )
  }
), mte = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.343 4.929a1 1 0 0 1 0 1.414 8 8 0 0 0 0 11.314A1 1 0 1 1 4.93 19.07c-3.905-3.905-3.905-10.237 0-14.142a1 1 0 0 1 1.414 0Zm11.314 0a1 1 0 0 1 1.414 0c3.905 3.905 3.905 10.237 0 14.142a1 1 0 0 1-1.414-1.414 8 8 0 0 0 0-11.314 1 1 0 0 1 0-1.414ZM9.172 7.757a1 1 0 0 1 0 1.415 4 4 0 0 0 0 5.656 1 1 0 1 1-1.415 1.415 6 6 0 0 1 0-8.486 1 1 0 0 1 1.415 0Zm5.656 0a1 1 0 0 1 1.415 0 6 6 0 0 1 0 8.486 1 1 0 1 1-1.415-1.415 4 4 0 0 0 0-5.656 1 1 0 0 1 0-1.415ZM10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), gte = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6-2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4Zm6 0h-4v4h4v-4Z",
        clipRule: "evenodd"
      }
    )
  }
), wte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1ZM4.929 4.929a1 1 0 0 1 1.414 0l.707.707A1 1 0 1 1 5.636 7.05l-.707-.707a1 1 0 0 1 0-1.414Zm14.142 0a1 1 0 0 1 0 1.414l-.707.707a1 1 0 1 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 0ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm-5 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm17 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Zm-2.05 4.95a1 1 0 0 1 1.414 0l.707.707a1 1 0 0 1-1.414 1.414l-.707-.707a1 1 0 0 1 0-1.414Zm-11.314 0a1 1 0 0 1 1.414 1.414l-.707.707a1 1 0 0 1-1.414-1.414l.707-.707ZM12 19a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), yte = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.01 4.061a8.001 8.001 0 0 0-6.79 9.813l2.992-1.141a4.874 4.874 0 0 1 3.803-5.463l-.004-3.209Zm-3.112 10.55-2.97 1.133A7.999 7.999 0 0 0 12 20a7.999 7.999 0 0 0 7.067-4.248l-2.907-1.123a4.869 4.869 0 0 1-4.125 2.28 4.87 4.87 0 0 1-4.137-2.297ZM20 12.002c0 .647-.077 1.278-.222 1.881l-2.922-1.128a4.874 4.874 0 0 0-3.84-5.491l-.004-3.2A8.001 8.001 0 0 1 19.999 12ZM2 12C2 6.476 6.477 2 12 2c5.522 0 10 4.476 10 10 0 5.522-4.479 10-10 10-5.523 0-10-4.477-10-10Zm10.035-2.837a2.872 2.872 0 1 0 0 5.744 2.872 2.872 0 0 0 0-5.744Z",
        clipRule: "evenodd"
      }
    )
  }
), xte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.68 7.094A7.965 7.965 0 0 0 4 12c0 1.849.627 3.551 1.68 4.906l2.148-2.149A4.977 4.977 0 0 1 7 12c0-1.02.305-1.967.828-2.757L5.68 7.094ZM7.094 5.68l2.149 2.148A4.977 4.977 0 0 1 12 7c1.02 0 1.967.305 2.757.828l2.149-2.148A7.965 7.965 0 0 0 12 4a7.965 7.965 0 0 0-4.906 1.68ZM18.32 7.094l-2.148 2.149c.523.79.828 1.738.828 2.757 0 1.02-.305 1.967-.828 2.757l2.148 2.149A7.965 7.965 0 0 0 20 12a7.966 7.966 0 0 0-1.68-4.906ZM16.906 18.32l-2.149-2.148A4.977 4.977 0 0 1 12 17a4.977 4.977 0 0 1-2.757-.828L7.094 18.32A7.966 7.966 0 0 0 12 20a7.965 7.965 0 0 0 4.906-1.68ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Ste = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M20.707 6.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L17.586 8H8a1 1 0 1 1 0-2h9.586l-2.293-2.293a1 1 0 0 1 1.414-1.414l4 4ZM6.414 16H16a1 1 0 1 1 0 2H6.414l2.293 2.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414L6.414 16Z",
        clipRule: "evenodd"
      }
    )
  }
), Cte = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.293 3.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L8 6.414V16a1 1 0 1 1-2 0V6.414L3.707 8.707a1 1 0 0 1-1.414-1.414l4-4ZM16 17.586V8a1 1 0 1 1 2 0v9.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L16 17.586Z",
        clipRule: "evenodd"
      }
    )
  }
), bte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8Zm3-1a1 1 0 0 0-1 1v1h16V8a1 1 0 0 0-1-1H5Zm15 4h-7v2h7v-2Zm0 4h-7v2h6a1 1 0 0 0 1-1v-1Zm-9 2v-2H4v1a1 1 0 0 0 1 1h6Zm-7-4h7v-2H4v2Z",
        clipRule: "evenodd"
      }
    )
  }
), _te = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a3 3 0 0 0-3 3v5c0 .299.13.566.339.75l.023.02 6.996 6.997A.992.992 0 0 0 12 20a.992.992 0 0 0 .642-.233l6.974-6.974a.96.96 0 0 1 .045-.043.996.996 0 0 0 .106-1.392l-6.974-6.974a.965.965 0 0 1-.043-.045A.995.995 0 0 0 12 4H7ZM2 7a5 5 0 0 1 5-5h5c.884 0 1.68.383 2.227.99l6.98 6.98.043.045c.466.529.75 1.225.75 1.985 0 .884-.383 1.68-.99 2.227l-6.98 6.98A2.992 2.992 0 0 1 12 22a2.992 2.992 0 0 1-2.03-.793l-6.98-6.98A2.995 2.995 0 0 1 2 12V7Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Rte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm16 0H5v2h14V5ZM3 13a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6Zm8 0H5v6h6v-6Zm4 0a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-6Zm4 0h-2v6h2v-6Z",
        clipRule: "evenodd"
      }
    )
  }
), Ete = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5Zm2.293 3.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L9.586 12 7.293 9.707a1 1 0 0 1 0-1.414ZM12 15a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Mte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.736 4a1 1 0 0 0-.894.553l-3.5 7A1 1 0 0 0 5.236 13H12a1 1 0 1 1 0 2h-1v4a1 1 0 0 0 1 1 4.62 4.62 0 0 1 .776-2.466L16 12.697V4.781l-3.004-.751a1 1 0 0 0-.242-.03H8.736ZM18 5v8h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-1Zm-1.131 10-2.43 3.643c-.286.43-.439.936-.439 1.453A1.905 1.905 0 0 1 12.095 22H12a3 3 0 0 1-3-3v-4H5.236c-2.23 0-3.68-2.347-2.683-4.342l3.5-7A3 3 0 0 1 8.736 2h4.018a3 3 0 0 1 .727.09l3.642.91H19a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-2.131Z",
        clipRule: "evenodd"
      }
    )
  }
), Tte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 3.905C10 2.853 10.853 2 11.905 2H12a3 3 0 0 1 3 3v4h3.764c2.23 0 3.68 2.347 2.683 4.342l-3.5 7A3 3 0 0 1 15.264 22h-4.018a3 3 0 0 1-.727-.09L6.877 21H5a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h2.131l2.43-3.643c.286-.43.439-.936.439-1.452ZM6 11H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1v-8Zm2 8.22v-7.917l3.224-4.837A4.617 4.617 0 0 0 12 4a1 1 0 0 1 1 1v4h-1a1 1 0 1 0 0 2h6.764a1 1 0 0 1 .894 1.447l-3.5 7a1 1 0 0 1-.894.553h-4.018a.996.996 0 0 1-.242-.03L8 19.22Z",
        clipRule: "evenodd"
      }
    )
  }
), Ote = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v3a1 1 0 0 1-1 1 1 1 0 1 0 0 2 1 1 0 0 1 1 1v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-3a1 1 0 0 1 1-1 1 1 0 1 0 0-2 1 1 0 0 1-1-1V7Zm14 11v-1a1 1 0 1 0-2 0v1H5a1 1 0 0 1-1-1v-2.17a3.001 3.001 0 0 0 0-5.66V7a1 1 0 0 1 1-1h9v1a1 1 0 1 0 2 0V6h3a1 1 0 0 1 1 1v2.17a3.001 3.001 0 0 0 0 5.66V17a1 1 0 0 1-1 1h-3Zm-1-8a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Dte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 2a1 1 0 0 1 1 1v1h5a1 1 0 1 1 0 2h-1.422a18.914 18.914 0 0 1-3.292 7.286c.157.176.318.35.482.52a1 1 0 0 1-1.44 1.389 19.02 19.02 0 0 1-.328-.35 19.06 19.06 0 0 1-5.555 4.18 1 1 0 1 1-.89-1.792 17.062 17.062 0 0 0 5.159-3.947A18.978 18.978 0 0 1 5.49 9.389a1 1 0 1 1 1.842-.778A16.963 16.963 0 0 0 9 11.646 16.915 16.915 0 0 0 11.527 6H3a1 1 0 1 1 0-2h5V3a1 1 0 0 1 1-1Zm7 8a1 1 0 0 1 .894.553l3.491 6.982.02.037 1.49 2.98a1 1 0 1 1-1.79.895L18.883 19h-5.764l-1.224 2.447a1 1 0 1 1-1.788-.894l1.49-2.98.019-.038 3.49-6.982A1 1 0 0 1 16 10Zm-1.882 7h3.764L16 13.236 14.118 17Z",
        clipRule: "evenodd"
      }
    )
  }
), Ate = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2h4a1 1 0 1 1 0 2h-.069l-.8 11.214A3 3 0 0 1 16.137 22H7.862a3 3 0 0 1-2.992-2.786L4.069 8H4a1 1 0 0 1 0-2h4V4ZM6.074 8l.79 11.071a1 1 0 0 0 .998.929h8.276a1 1 0 0 0 .997-.929L17.926 8H6.074ZM14 6h-4V4h4v2Zm-4 4a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), jte = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.293 6.293a1 1 0 0 1 1.414 0L9 11.586l3.293-3.293a1 1 0 0 1 1.414 0L20 14.586V9a1 1 0 1 1 2 0v8a1 1 0 0 1-1 1h-8a1 1 0 1 1 0-2h5.586L13 10.414l-3.293 3.293a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), kte = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 8a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V9.414l-6.293 6.293a1 1 0 0 1-1.414 0L9 12.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l6-6a1 1 0 0 1 1.414 0L13 13.586 18.586 8H13Z",
        clipRule: "evenodd"
      }
    )
  }
), Lte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2h2.586A2 2 0 0 1 18 6.586l-.707.707.707-.707L21.414 10A2 2 0 0 1 22 11.414V16a2 2 0 0 1-2 2h-.17a3.001 3.001 0 0 1-5.66 0H14a1.99 1.99 0 0 1-1-.268A1.99 1.99 0 0 1 12 18H9.83a3.001 3.001 0 0 1-5.66 0H4a2 2 0 0 1-2-2V6Zm2.17 10a3.001 3.001 0 0 1 5.66 0H12V7.997 8m0-.003V6H4v10h.17M14 16h.17a3.001 3.001 0 0 1 5.66 0H20v-4.586L16.586 8H14v8Zm-7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm10 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
        clipRule: "evenodd"
      }
    )
  }
), Ite = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 17a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 1 1 2 0v1a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-1a1 1 0 1 1 2 0v1Zm2.293-8.293a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 6.414V16a1 1 0 1 1-2 0V6.414L8.707 8.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Hte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM7 7a5 5 0 1 1 10 0A5 5 0 0 1 7 7Zm-.917 13h11.834a6.002 6.002 0 0 0-11.834 0ZM4 21a8 8 0 1 1 16 0 1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Zte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM4 7a5 5 0 1 1 10 0A5 5 0 0 1 4 7Zm14 1a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2V9a1 1 0 0 1 1-1Zm-9 7a5 5 0 0 0-5 5h10a5 5 0 0 0-5-5Zm-7 5a7 7 0 1 1 14 0v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Pte = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 0 0-6.598 12.526A14.943 14.943 0 0 1 12 15c2.366 0 4.606.548 6.598 1.526A8 8 0 0 0 12 4Zm7.654 14.436A9.96 9.96 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.96 9.96 0 0 0 2.37 6.464A9.978 9.978 0 0 0 12 22a9.978 9.978 0 0 0 7.654-3.564ZM17.2 18.08A12.954 12.954 0 0 0 12 17c-1.85 0-3.607.386-5.199 1.08A7.968 7.968 0 0 0 12 20c1.985 0 3.8-.723 5.199-1.92ZM12 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Nte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM8 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM5 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm17-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm-4 4a4.002 4.002 0 0 0-4 4v1h8v-1a4.002 4.002 0 0 0-4-4Zm6 5h3v-1a2 2 0 0 0-3.213-1.59c.139.507.213 1.04.213 1.59v1Zm-1.071-4.422A5.992 5.992 0 0 0 12 12a5.993 5.993 0 0 0-4.929 2.578A4 4 0 0 0 1 18v2a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-2a4 4 0 0 0-6.071-3.422ZM6.213 16.41A2 2 0 0 0 3 18v1h3v-1c0-.55.074-1.083.213-1.59Z",
        clipRule: "evenodd"
      }
    )
  }
), Vte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm3-1a5 5 0 1 0 0 8 5 5 0 1 0 0-8Zm1.334 1.505C13.758 5.239 14 6.09 14 7s-.242 1.76-.666 2.495a3 3 0 1 0 0-4.99ZM9 15a5 5 0 0 0-5 5h10a5 5 0 0 0-5-5Zm7 5h4a5 5 0 0 0-6.001-4.9A6.977 6.977 0 0 1 16 20Zm-4-6.326A7 7 0 0 0 2 20v1a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-1a7 7 0 0 0-10-6.326Z",
        clipRule: "evenodd"
      }
    )
  }
), Fte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.555 3.104a1 1 0 0 1 1.34.451A18.926 18.926 0 0 1 21.872 12c0 3.031-.71 5.9-1.975 8.445a1 1 0 0 1-1.791-.89A16.926 16.926 0 0 0 19.87 12c0-2.716-.636-5.28-1.766-7.555a1 1 0 0 1 .45-1.34Zm-13.239 0a1 1 0 0 1 .45 1.341A16.926 16.926 0 0 0 4 12c0 2.716.636 5.28 1.767 7.555a1 1 0 1 1-1.791.89A18.926 18.926 0 0 1 2 12c0-3.032.71-5.9 1.976-8.445a1 1 0 0 1 1.34-.45ZM8 9a1 1 0 0 1 1-1h1.246a2 2 0 0 1 1.923 1.45l.282.988 1.191-1.39A3 3 0 0 1 15.92 8H16a1 1 0 1 1 0 2h-.08a1 1 0 0 0-.76.35l-2.05 2.392.644 2.258H15a1 1 0 1 1 0 2h-1.246a2 2 0 0 1-1.923-1.45l-.282-.988-1.191 1.39A3 3 0 0 1 8.08 17H8a1 1 0 1 1 0-2h.08a1 1 0 0 0 .76-.35l2.05-2.392L10.247 10H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Bte = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v.382l3.106-1.553A2 2 0 0 1 22 8.618v6.764a2 2 0 0 1-2.894 1.789L16 15.618V16a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8Zm12 5.978a.97.97 0 0 0 0 .042V16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5.978Zm2-.596 4 2V8.618l-4 2v2.764Z",
        clipRule: "evenodd"
      }
    )
  }
), Ute = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 7a3 3 0 0 1 3-3h2c.768 0 1.47.289 2 .764A2.989 2.989 0 0 1 11 4h2c.768 0 1.47.289 2 .764A2.989 2.989 0 0 1 17 4h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-2c-.768 0-1.47-.289-2-.764A2.989 2.989 0 0 1 13 20h-2c-.768 0-1.47-.289-2-.764A2.989 2.989 0 0 1 7 20H5a3 3 0 0 1-3-3V7Zm8 10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v10ZM8 7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V7Zm8 0v10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1Z",
        clipRule: "evenodd"
      }
    )
  }
), Yte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Zm7 1a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2ZM3 16a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H6Zm7 1a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3v-2Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2Z",
        clipRule: "evenodd"
      }
    )
  }
), $te = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Wte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.586 3.586C10.846 2.326 13 3.218 13 5v14c0 1.782-2.154 2.674-3.414 1.414L5.172 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.172l4.414-4.414ZM11 5 6.293 9.707a1 1 0 0 1-.707.293H4v4h1.586a1 1 0 0 1 .707.293L11 19V5Zm5.293 4.293a1 1 0 0 1 1.414 0L19 10.586l1.293-1.293a1 1 0 1 1 1.414 1.414L20.414 12l1.293 1.293a1 1 0 0 1-1.414 1.414L19 13.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L17.586 12l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), zte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.586 3.586C10.846 2.326 13 3.218 13 5v14c0 1.782-2.154 2.674-3.414 1.414L5.172 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.172l4.414-4.414ZM11 5 6.293 9.707a1 1 0 0 1-.707.293H4v4h1.586a1 1 0 0 1 .707.293L11 19V5Zm6.657-.071a1 1 0 0 1 1.414 0c3.905 3.905 3.905 10.237 0 14.142a1 1 0 0 1-1.414-1.414 8 8 0 0 0 0-11.314 1 1 0 0 1 0-1.414Zm-2.829 2.828a1 1 0 0 1 1.415 0 6 6 0 0 1 0 8.486 1 1 0 1 1-1.415-1.415 4 4 0 0 0 0-5.656 1 1 0 0 1 0-1.415Z",
        clipRule: "evenodd"
      }
    )
  }
), qte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.9 10.1c-5.468-5.467-14.332-5.467-19.8 0A1 1 0 0 1 .687 8.687c6.249-6.248 16.38-6.248 22.628 0a1 1 0 0 1-1.414 1.415Zm-3.536 3.536a9 9 0 0 0-12.728 0 1 1 0 0 1-1.414-1.414c4.296-4.296 11.26-4.296 15.556 0a1 1 0 0 1-1.414 1.414Zm-3.182 3.475a4.5 4.5 0 0 0-6.364 0 1 1 0 0 1-1.414-1.414 6.5 6.5 0 0 1 9.192 0 1 1 0 1 1-1.414 1.414ZM11 20a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Gte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.293 5.293a1 1 0 0 1 1.414 0L12 10.586l5.293-5.293a1 1 0 1 1 1.414 1.414L13.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L10.586 12 5.293 6.707a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Kte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7.293-2.707a1 1 0 0 1 1.414 0L12 10.586l1.293-1.293a1 1 0 1 1 1.414 1.414L13.414 12l1.293 1.293a1 1 0 0 1-1.414 1.414L12 13.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L10.586 12l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Qte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 14.32 4.906l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387A8 8 0 0 1 2 10Zm8-4a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H7a1 1 0 1 1 0-2h2V7a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Xte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 14.32 4.906l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387A8 8 0 0 1 2 10Zm4 0a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Jte = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10.394 2.08a1 1 0 0 0-.788 0l-7 3a1 1 0 0 0 0 1.84L5.25 8.051a.999.999 0 0 1 .356-.257l4-1.714a1 1 0 1 1 .788 1.838l-2.727 1.17 1.94.831a1 1 0 0 0 .787 0l7-3a1 1 0 0 0 0-1.838l-7-3ZM3.31 9.397 5 10.12v4.102a8.969 8.969 0 0 0-1.05-.174 1 1 0 0 1-.89-.89 11.115 11.115 0 0 1 .25-3.762Zm5.99 7.176A9.026 9.026 0 0 0 7 14.935v-3.957l1.818.78a3 3 0 0 0 2.364 0l5.508-2.361a11.026 11.026 0 0 1 .25 3.762 1 1 0 0 1-.89.89 8.968 8.968 0 0 0-5.35 2.524 1 1 0 0 1-1.4 0ZM6 18a1 1 0 0 0 1-1v-2.065a8.935 8.935 0 0 0-2-.712V17a1 1 0 0 0 1 1Z"
      }
    )
  }
), ene = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 4a1 1 0 0 0-2 0v7.268a2 2 0 0 0 0 3.464V16a1 1 0 1 0 2 0v-1.268a2 2 0 0 0 0-3.464V4Zm6 0a1 1 0 1 0-2 0v1.268a2 2 0 0 0 0 3.464V16a1 1 0 1 0 2 0V8.732a2 2 0 0 0 0-3.464V4Zm5-1a1 1 0 0 1 1 1v7.268a2 2 0 0 1 0 3.464V16a1 1 0 1 1-2 0v-1.268a2 2 0 0 1 0-3.464V4a1 1 0 0 1 1-1Z"
      }
    )
  }
), tne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 13V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3l3 3 3-3h3a2 2 0 0 0 2-2ZM5 7a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2H6Z",
        clipRule: "evenodd"
      }
    )
  }
), nne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 3a2 2 0 1 0 0 4h12a2 2 0 1 0 0-4H4Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 8h14v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8Zm5 3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), rne = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-11a1 1 0 1 0-2 0v3.586L7.707 9.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 10.586V7Z",
        clipRule: "evenodd"
      }
    )
  }
), ane = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.707-10.293a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L9.414 11H13a1 1 0 1 0 0-2H9.414l1.293-1.293Z",
        clipRule: "evenodd"
      }
    )
  }
), one = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.707-8.707-3-3a1 1 0 0 0-1.414 1.414L10.586 9H7a1 1 0 1 0 0 2h3.586l-1.293 1.293a1 1 0 1 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), ine = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.707-8.707-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L9 9.414V13a1 1 0 1 0 2 0V9.414l1.293 1.293a1 1 0 0 0 1.414-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), lne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.707 10.293a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 1 1 1.414-1.414L9 14.586V3a1 1 0 0 1 2 0v11.586l4.293-4.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), une = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.707 16.707a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 1.414L5.414 9H17a1 1 0 1 1 0 2H5.414l4.293 4.293a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), sne = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.707 12.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L9 14.586V3a1 1 0 0 1 2 0v11.586l2.293-2.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), cne = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.707 14.707a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414L5.414 9H17a1 1 0 1 1 0 2H5.414l2.293 2.293a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), fne = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.293 5.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L14.586 11H3a1 1 0 1 1 0-2h11.586l-2.293-2.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), dne = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.293 7.707a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L11 5.414V17a1 1 0 1 1-2 0V5.414L6.707 7.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), hne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.293 3.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L14.586 11H3a1 1 0 1 1 0-2h11.586l-4.293-4.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), vne = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2H6.414l2.293 2.293a1 1 0 0 1-1.414 1.414L5 6.414V8a1 1 0 0 1-2 0V4Zm9 1a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V6.414l-2.293 2.293a1 1 0 1 1-1.414-1.414L13.586 5H12Zm-9 7a1 1 0 1 1 2 0v1.586l2.293-2.293a1 1 0 0 1 1.414 1.414L6.414 15H8a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1v-4Zm13-1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h1.586l-2.293-2.293a1 1 0 0 1 1.414-1.414L15 13.586V12a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), pne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.707 10.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L9 12.586V5a1 1 0 0 1 2 0v7.586l2.293-2.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), mne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.707 14.707a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414L7.414 9H15a1 1 0 1 1 0 2H7.414l2.293 2.293a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), gne = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.293 5.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L12.586 11H5a1 1 0 1 1 0-2h7.586l-2.293-2.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), wne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.293 9.707a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L11 7.414V15a1 1 0 1 1-2 0V7.414L6.707 9.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), yne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.293 9.707a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414L11 5.414V17a1 1 0 1 1-2 0V5.414L4.707 9.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), xne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.243 5.757a6 6 0 1 0-.986 9.284 1 1 0 1 1 1.087 1.678A8 8 0 1 1 18 10a3 3 0 0 1-4.8 2.401A4 4 0 1 1 14 10a1 1 0 1 0 2 0c0-1.537-.586-3.07-1.757-4.243ZM12 10a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Sne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.707 4.879A3 3 0 0 1 8.828 4H15a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H8.828a3 3 0 0 1-2.12-.879l-4.415-4.414a1 1 0 0 1 0-1.414l4.414-4.414Zm4 2.414a1 1 0 0 0-1.414 1.414L10.586 10l-1.293 1.293a1 1 0 1 0 1.414 1.414L12 11.414l1.293 1.293a1 1 0 0 0 1.414-1.414L13.414 10l1.293-1.293a1 1 0 0 0-1.414-1.414L12 8.586l-1.293-1.293Z",
        clipRule: "evenodd"
      }
    )
  }
), Cne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.267 3.455a3.066 3.066 0 0 0 1.745-.723 3.066 3.066 0 0 1 3.976 0 3.066 3.066 0 0 0 1.745.723 3.066 3.066 0 0 1 2.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 0 1 0 3.976 3.066 3.066 0 0 0-.723 1.745 3.066 3.066 0 0 1-2.812 2.812 3.066 3.066 0 0 0-1.745.723 3.066 3.066 0 0 1-3.976 0 3.066 3.066 0 0 0-1.745-.723 3.066 3.066 0 0 1-2.812-2.812 3.066 3.066 0 0 0-.723-1.745 3.066 3.066 0 0 1 0-3.976 3.066 3.066 0 0 0 .723-1.745 3.066 3.066 0 0 1 2.812-2.812Zm7.44 5.252a1 1 0 0 0-1.414-1.414L9 10.586 7.707 9.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), bne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-4.523 4.89A6 6 0 0 1 5.11 6.524l8.367 8.368Zm1.414-1.414L6.524 5.11a6 6 0 0 1 8.367 8.367Z",
        clipRule: "evenodd"
      }
    )
  }
), _ne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 2a1 1 0 0 0-.707 1.707L7 4.414v3.758a1 1 0 0 1-.293.707l-4 4C.817 14.769 2.156 18 4.828 18h10.343c2.673 0 4.012-3.231 2.122-5.121l-4-4A1 1 0 0 1 13 8.172V4.414l.707-.707A1 1 0 0 0 13 2H7Zm2 6.172V4h2v4.172a3 3 0 0 0 .879 2.12l1.027 1.028a4 4 0 0 0-2.171.102l-.47.156a4 4 0 0 1-2.53 0l-.563-.187a1.993 1.993 0 0 0-.114-.035l1.063-1.063A3 3 0 0 0 9 8.172Z",
        clipRule: "evenodd"
      }
    )
  }
), Rne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 2a6 6 0 0 0-6 6v3.586l-.707.707A1 1 0 0 0 4 14h12a1 1 0 0 0 .707-1.707L16 11.586V8a6 6 0 0 0-6-6Zm0 16a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3Z"
      }
    )
  }
), Ene = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v14l-5-2.5L5 18V4Z"
      }
    )
  }
), Mne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm11 1H6v8l4-2 4 2V6Z",
        clipRule: "evenodd"
      }
    )
  }
), Tne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9 4.804A7.968 7.968 0 0 0 5.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 0 1 5.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0 1 14.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0 0 14.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 1 1-2 0V4.804Z"
      }
    )
  }
), One = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 6V5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2a2 2 0 0 1 2 2v3.57A22.952 22.952 0 0 1 10 13a22.95 22.95 0 0 1-8-1.43V8a2 2 0 0 1 2-2h2Zm2-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1H8V5Zm1 5a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 13.692V16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2.308A24.974 24.974 0 0 1 10 15a24.98 24.98 0 0 1-8-1.308Z"
        }
      )
    ]
  }
), Dne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6 3a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Zm2 3a1 1 0 0 0-2 0v1a2 2 0 0 0-2 2v1a2 2 0 0 0-2 2v.683a3.7 3.7 0 0 1 1.055.485 1.704 1.704 0 0 0 1.89 0 3.704 3.704 0 0 1 4.11 0 1.704 1.704 0 0 0 1.89 0 3.704 3.704 0 0 1 4.11 0 1.704 1.704 0 0 0 1.89 0A3.7 3.7 0 0 1 18 12.683V12a2 2 0 0 0-2-2V9a2 2 0 0 0-2-2V6a1 1 0 1 0-2 0v1h-1V6a1 1 0 1 0-2 0v1H8V6Zm10 8.868a3.704 3.704 0 0 1-4.055-.036 1.704 1.704 0 0 0-1.89 0 3.704 3.704 0 0 1-4.11 0 1.704 1.704 0 0 0-1.89 0A3.704 3.704 0 0 1 2 14.868V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2.132ZM9 3a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1Z"
      }
    )
  }
), Ane = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6Zm1 2a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H7Zm6 7a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm-3 3a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H10Zm-4 1a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm1-4a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H7Zm2 1a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1Zm4-4a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H13ZM9 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1ZM7 8a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2H7Z",
        clipRule: "evenodd"
      }
    )
  }
), jne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a1 1 0 0 0-1 1v1H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1V3a1 1 0 1 0-2 0v1H7V3a1 1 0 0 0-1-1Zm0 5a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2H6Z",
        clipRule: "evenodd"
      }
    )
  }
), kne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1.586a1 1 0 0 1-.707-.293l-1.121-1.121A2 2 0 0 0 11.172 3H8.828a2 2 0 0 0-1.414.586L6.293 4.707A1 1 0 0 1 5.586 5H4Zm6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
        clipRule: "evenodd"
      }
    )
  }
), Lne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 1a1 1 0 0 0 0 2h1.22l.305 1.222a.997.997 0 0 0 .01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 0 0 0-2H6.414l1-1H14a1 1 0 0 0 .894-.553l3-6A1 1 0 0 0 17 3H6.28l-.31-1.243A1 1 0 0 0 5 1H3Zm13 15.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM6.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
      }
    )
  }
), Ine = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2V9a3 3 0 0 1 3-3h7a2 2 0 0 0-2-2H4Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 10a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-4Zm6 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Hne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-5Zm6-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V7Zm6-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4Z"
      }
    )
  }
), Zne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 10a8 8 0 0 1 8-8v8h8a8 8 0 1 1-16 0Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12 2.252A8.014 8.014 0 0 1 17.748 8H12V2.252Z"
        }
      )
    ]
  }
), Pne = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm9 4a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0V7Zm-3 2a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V9Zm-3 3a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0v-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Nne = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 16 16",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        id: "icon",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.40039 3.9999C2.40039 3.11625 3.11674 2.3999 4.00039 2.3999H12.0004C12.884 2.3999 13.6004 3.11625 13.6004 3.9999V11.9999C13.6004 12.8836 12.884 13.5999 12.0004 13.5999H4.00039C3.11674 13.5999 2.40039 12.8836 2.40039 11.9999V3.9999ZM11.7661 5.76559C12.0785 6.07801 12.0785 6.58454 11.7661 6.89696L8.56608 10.097C8.25366 10.4094 7.74712 10.4094 7.43471 10.097L6.40039 9.06264L5.36608 10.097C5.05366 10.4094 4.54712 10.4094 4.23471 10.097C3.92229 9.78454 3.92229 9.27801 4.23471 8.96559L5.83471 7.36559C6.14712 7.05317 6.65366 7.05317 6.96608 7.36559L8.00039 8.3999L10.6347 5.76559C10.9471 5.45317 11.4537 5.45317 11.7661 5.76559Z",
        fill: "currentColor"
      }
    )
  }
), Vne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 0 1-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7ZM7 9H5v2h2V9Zm8 0h-2v2h2V9ZM9 9h2v2H9V9Z",
        clipRule: "evenodd"
      }
    )
  }
), Fne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 5v8a2 2 0 0 1-2 2h-5l-5 4v-4H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2ZM7 8H5v2h2V8Zm2 0h2v2H9V8Zm6 0h-2v2h2V8Z",
        clipRule: "evenodd"
      }
    )
  }
), Bne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H9l-3 3v-3H4a2 2 0 0 1-2-2V5Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M15 7v2a4 4 0 0 1-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-1Z"
        }
      )
    ]
  }
), AT = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.707 5.293a1 1 0 0 1 0 1.414l-8 8a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L8 12.586l7.293-7.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), I8 = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.707-9.293a1 1 0 0 0-1.414-1.414L9 10.586 7.707 9.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), H8 = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.293 7.293a1 1 0 0 1 1.414 0L10 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), VU = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.707 5.293a1 1 0 0 1 0 1.414L9.414 10l3.293 3.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), jT = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.293 14.707a1 1 0 0 1 0-1.414L10.586 10 7.293 6.707a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), FU = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.707 12.707a1 1 0 0 1-1.414 0L10 9.414l-3.293 3.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Une = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.707 4.293a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 1.414-1.414L10 8.586l4.293-4.293a1 1 0 0 1 1.414 0Zm0 6a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L10 14.586l4.293-4.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Yne = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.707 15.707a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 1 1 1.414 1.414L11.414 10l4.293 4.293a1 1 0 0 1 0 1.414Zm-6 0a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 1.414L5.414 10l4.293 4.293a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), $ne = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.293 15.707a1 1 0 0 1 0-1.414L14.586 10l-4.293-4.293a1 1 0 1 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4.293 15.707a1 1 0 0 1 0-1.414L8.586 10 4.293 5.707a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Wne = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 15.707a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 0 1-1.414 0Zm0-6a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L10 5.414 5.707 9.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), zne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx("path", { fill: "currentColor", d: "M13 7H7v6h6V7Z" }),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 2a1 1 0 0 1 2 0v1h2V2a1 1 0 1 1 2 0v1h2a2 2 0 0 1 2 2v2h1a1 1 0 1 1 0 2h-1v2h1a1 1 0 1 1 0 2h-1v2a2 2 0 0 1-2 2h-2v1a1 1 0 1 1-2 0v-1H9v1a1 1 0 1 1-2 0v-1H5a2 2 0 0 1-2-2v-2H2a1 1 0 1 1 0-2h1V9H2a1 1 0 0 1 0-2h1V5a2 2 0 0 1 2-2h2V2ZM5 5h10v10H5V5Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), qne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "#fff",
          stroke: "#DCDBDD",
          strokeWidth: 0.6,
          d: "M5.32 1.3h9.36c2.22 0 4.02 1.8 4.02 4.02v9.36c0 2.22-1.8 4.02-4.02 4.02H5.32a4.02 4.02 0 0 1-4.02-4.02V5.32C1.3 3.1 3.1 1.3 5.32 1.3Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "url(#paint0_linear_590_7245)",
          fillRule: "evenodd",
          d: "m4.727 13.343 1.946-1.491c1.034 1.35 2.132 1.971 3.355 1.971 1.217 0 2.284-.614 3.272-1.953l1.973 1.455c-1.424 1.93-3.195 2.95-5.245 2.95-2.043 0-3.831-1.012-5.301-2.932Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "url(#paint1_linear_590_7245)",
          fillRule: "evenodd",
          d: "M10.021 6.862 6.557 9.847 4.956 7.99l5.072-4.37 5.033 4.373-1.608 1.851-3.431-2.982Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsxs("defs", { children: [
        /* @__PURE__ */ d.jsxs(
          "linearGradient",
          {
            id: "paint0_linear_590_7245",
            x1: 4.727,
            x2: 15.273,
            y1: 14.86,
            y2: 14.86,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ d.jsx("stop", { stopColor: "#8930FD" }),
              /* @__PURE__ */ d.jsx("stop", { offset: 1, stopColor: "#49CCF9" })
            ]
          }
        ),
        /* @__PURE__ */ d.jsxs(
          "linearGradient",
          {
            id: "paint1_linear_590_7245",
            x1: 4.956,
            x2: 15.061,
            y1: 7.855,
            y2: 7.855,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ d.jsx("stop", { stopColor: "#FF02F0" }),
              /* @__PURE__ */ d.jsx("stop", { offset: 1, stopColor: "#FFC800" })
            ]
          }
        )
      ] })
    ]
  }
), Gne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6 3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2 3 3 0 0 1-3 3H9a3 3 0 0 1-3-3Z"
        }
      )
    ]
  }
), Kne = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9 2a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2H9Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 5a2 2 0 0 1 2-2 3 3 0 0 0 3 3h2a3 3 0 0 0 3-3 2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5Zm9.707 5.707a1 1 0 0 0-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Qne = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2H8Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 5a2 2 0 0 1 2-2 3 3 0 0 0 3 3h2a3 3 0 0 0 3-3 2 2 0 0 1 2 2v6h-4.586l1.293-1.293a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L10.414 13H15v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm12 6h2a1 1 0 1 1 0 2h-2v-2Z"
        }
      )
    ]
  }
), Xne = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9 2a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2H9Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 5a2 2 0 0 1 2-2 3 3 0 0 0 3 3h2a3 3 0 0 0 3-3 2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5Zm3 4a1 1 0 0 0 0 2h.01a1 1 0 1 0 0-2H7Zm3 0a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2h-3Zm-3 4a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H7Zm3 0a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Jne = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-12a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l2.828 2.829a1 1 0 1 0 1.415-1.415L11 9.586V6Z",
        clipRule: "evenodd"
      }
    )
  }
), ere = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5.5 16a3.5 3.5 0 0 1-.369-6.98 4 4 0 1 1 7.753-1.977A4.5 4.5 0 1 1 13.5 16h-8Z"
      }
    )
  }
), tre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 9.5A3.5 3.5 0 0 0 5.5 13H9v2.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 15.586V13h2.5a4.5 4.5 0 1 0-.616-8.958 4.002 4.002 0 1 0-7.753 1.977A3.5 3.5 0 0 0 2 9.5Zm9 3.5H9V8a1 1 0 0 1 2 0v5Z",
        clipRule: "evenodd"
      }
    )
  }
), nre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5.5 13a3.5 3.5 0 0 1-.369-6.98 4 4 0 1 1 7.753-1.977A4.5 4.5 0 1 1 13.5 13H11V9.413l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L9 9.414V13H5.5Z"
        }
      ),
      /* @__PURE__ */ d.jsx("path", { fill: "currentColor", d: "M9 13h2v5a1 1 0 1 1-2 0v-5Z" })
    ]
  }
), rre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.316 3.051a1 1 0 0 1 .633 1.265l-4 12a1 1 0 1 1-1.898-.632l4-12a1 1 0 0 1 1.265-.633ZM5.707 6.293a1 1 0 0 1 0 1.414L3.414 10l2.293 2.293a1 1 0 1 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0Zm8.586 0a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), are = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 0 1-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 0 1 .947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 0 1 2.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 0 1 2.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 0 1 .947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 0 1-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 0 1-2.287-.947ZM10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
        clipRule: "evenodd"
      }
    )
  }
), ore = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7 3a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H7ZM4 7a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm-2 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4Z"
      }
    )
  }
), ire = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 2a2 2 0 0 0-2 2v11a3 3 0 1 0 6 0V4a2 2 0 0 0-2-2H4Zm1 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m10 14.243 4.9-4.9a2 2 0 0 0 0-2.828L13.485 5.1a2 2 0 0 0-2.828 0L10 5.757v8.486ZM16 18H9.071l6-6H16a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2Z"
        }
      )
    ]
  }
), lre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 4a2 2 0 0 0-2 2v1h16V6a2 2 0 0 0-2-2H4Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M18 9H2v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9ZM4 13a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm5-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2H9Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), ure = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11 17a1 1 0 0 0 1.447.894l4-2A1 1 0 0 0 17 15V9.236a1 1 0 0 0-1.447-.894l-4 2a1 1 0 0 0-.553.894V17Zm4.211-10.724a1 1 0 0 0 0-1.788l-4.764-2.382a1 1 0 0 0-.894 0L4.789 4.488a1 1 0 0 0 0 1.788l4.764 2.382a1 1 0 0 0 .894 0l4.764-2.382ZM4.447 8.342A1 1 0 0 0 3 9.236V15a1 1 0 0 0 .553.894l4 2A1 1 0 0 0 9 17v-5.764a1 1 0 0 0-.553-.894l-4-2Z"
      }
    )
  }
), sre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9.504 1.132a1 1 0 0 1 .992 0l1.75 1a1 1 0 1 1-.992 1.736L10 3.152l-1.254.716a1 1 0 1 1-.992-1.736l1.75-1ZM5.618 4.504a1 1 0 0 1-.372 1.364L5.016 6l.23.132a1 1 0 1 1-.992 1.736L4 7.723V8a1 1 0 0 1-2 0V6a.996.996 0 0 1 .52-.878l1.734-.99a1 1 0 0 1 1.364.372Zm8.764 0a1 1 0 0 1 1.364-.372l1.733.99A1.002 1.002 0 0 1 18 6v2a1 1 0 1 1-2 0v-.277l-.254.145a1 1 0 1 1-.992-1.736l.23-.132-.23-.132a1 1 0 0 1-.372-1.364Zm-7 4a1 1 0 0 1 1.364-.372L10 8.848l1.254-.716a1 1 0 1 1 .992 1.736L11 10.58V12a1 1 0 1 1-2 0v-1.42l-1.246-.712a1 1 0 0 1-.372-1.364ZM3 11a1 1 0 0 1 1 1v1.42l1.246.712a1 1 0 1 1-.992 1.736l-1.75-1A1 1 0 0 1 2 14v-2a1 1 0 0 1 1-1Zm14 0a1 1 0 0 1 1 1v2a1 1 0 0 1-.504.868l-1.75 1a1 1 0 1 1-.992-1.736L16 13.42V12a1 1 0 0 1 1-1Zm-9.618 5.504a1 1 0 0 1 1.364-.372l.254.145V16a1 1 0 1 1 2 0v.277l.254-.145a1 1 0 1 1 .992 1.736l-1.735.992a.995.995 0 0 1-1.022 0l-1.735-.992a1 1 0 0 1-.372-1.364Z"
      }
    )
  }
), cre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 4a1 1 0 0 0 0 2 1 1 0 0 1 1 1v1H7a1 1 0 0 0 0 2h1v3a3 3 0 1 0 6 0v-1a1 1 0 1 0-2 0v1a1 1 0 1 1-2 0v-3h3a1 1 0 1 0 0-2h-3V7a3 3 0 0 0-3-3Z",
        clipRule: "evenodd"
      }
    )
  }
), fre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 0 1-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582ZM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 0 1-.567.267Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-13a1 1 0 1 0-2 0v.092a4.535 4.535 0 0 0-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 1 0-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 1 0 2 0v-.092a4.535 4.535 0 0 0 1.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0 0 11 9.092V7.151c.391.127.68.317.843.504a1 1 0 1 0 1.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), dre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.736 6.979C9.208 6.193 9.696 6 10 6c.304 0 .792.193 1.264.979a1 1 0 0 0 1.715-1.029C12.279 4.784 11.232 4 10 4s-2.279.784-2.979 1.95c-.285.475-.507 1-.67 1.55H6a1 1 0 0 0 0 2h.013a9.358 9.358 0 0 0 0 1H6a1 1 0 1 0 0 2h.351c.163.55.385 1.075.67 1.55C7.721 15.216 8.768 16 10 16s2.279-.784 2.979-1.95a1 1 0 1 0-1.715-1.029c-.472.786-.96.979-1.264.979-.304 0-.792-.193-1.264-.979a4.265 4.265 0 0 1-.264-.521H10a1 1 0 1 0 0-2H8.017a7.36 7.36 0 0 1 0-1H10a1 1 0 1 0 0-2H8.472c.08-.185.167-.36.264-.521Z",
        clipRule: "evenodd"
      }
    )
  }
), hre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-14a3 3 0 0 0-3 3v2H7a1 1 0 0 0 0 2h1v1a1 1 0 0 1-1 1 1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9.83c.11-.313.17-.65.17-1v-1h1a1 1 0 1 0 0-2h-1V7a1 1 0 1 1 2 0 1 1 0 1 0 2 0 3 3 0 0 0-3-3Z",
        clipRule: "evenodd"
      }
    )
  }
), vre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 5a1 1 0 1 0 0 2h1a2 2 0 0 1 1.732 1H7a1 1 0 1 0 0 2h2.732A2 2 0 0 1 8 11H7a1 1 0 0 0-.707 1.707l3 3a1 1 0 0 0 1.414-1.414l-1.483-1.484A4.008 4.008 0 0 0 11.874 10H13a1 1 0 1 0 0-2h-1.126a3.976 3.976 0 0 0-.41-1H13a1 1 0 1 0 0-2H7Z",
        clipRule: "evenodd"
      }
    )
  }
), pre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7.858 5.485a1 1 0 0 0-1.715 1.03L7.633 9H7a1 1 0 1 0 0 2h1.834l.166.277V12H7a1 1 0 1 0 0 2h2v1a1 1 0 1 0 2 0v-1h2a1 1 0 1 0 0-2h-2v-.723l.166-.277H13a1 1 0 1 0 0-2h-.634l1.492-2.486a1 1 0 1 0-1.716-1.029L10.034 9h-.068L7.858 5.485Z",
        clipRule: "evenodd"
      }
    )
  }
), mre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6.672 1.912a1 1 0 0 0-1.932.517l.259.966a1 1 0 0 0 1.932-.518l-.26-.965ZM2.43 4.74a1 1 0 0 0-.519 1.932l.966.259a1 1 0 0 0 .518-1.932l-.966-.26Zm8.813-.568a1 1 0 0 0-1.415-1.415l-.707.707a1 1 0 1 0 1.415 1.415l.707-.707Zm-7.072 7.071.708-.707A1 1 0 0 0 3.464 9.12l-.707.707a1 1 0 0 0 1.414 1.415Zm3.2-5.171a1 1 0 0 0-1.3 1.3l4 10a1 1 0 0 0 1.824.075l1.379-2.759 3.019 3.02a1 1 0 1 0 1.414-1.415l-3.019-3.019 2.76-1.38a1 1 0 0 0-.077-1.822l-10-4Z"
      }
    )
  }
), gre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3Z"
        }
      )
    ]
  }
), wre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.22l.123.489.804.804A1 1 0 0 1 13 18H7a1 1 0 0 1-.707-1.707l.804-.804L7.22 15H5a2 2 0 0 1-2-2V5Zm5.771 7H5V5h10v7H8.771Z",
        clipRule: "evenodd"
      }
    )
  }
), yre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H7Zm3 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
      }
    )
  }
), xre = ({
  size: e = "1em",
  fill: n = "#5865F2",
  ...a
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 71 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a,
    children: [
      /* @__PURE__ */ d.jsx("g", { clipPath: "url(#clip0)", children: /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M60.1045 4.8978C55.5792 2.8214 50.7265 1.2916 45.6527 0.41542C45.5603 0.39851 45.468 0.440769 45.4204 0.525289C44.7963 1.6353 44.105 3.0834 43.6209 4.2216C38.1637 3.4046 32.7345 3.4046 27.3892 4.2216C26.905 3.0581 26.1886 1.6353 25.5617 0.525289C25.5141 0.443589 25.4218 0.40133 25.3294 0.41542C20.2584 1.2888 15.4057 2.8186 10.8776 4.8978C10.8384 4.9147 10.8048 4.9429 10.7825 4.9795C1.57795 18.7309 -0.943561 32.1443 0.293408 45.3914C0.299005 45.4562 0.335386 45.5182 0.385761 45.5576C6.45866 50.0174 12.3413 52.7249 18.1147 54.5195C18.2071 54.5477 18.305 54.5139 18.3638 54.4378C19.7295 52.5728 20.9469 50.6063 21.9907 48.5383C22.0523 48.4172 21.9935 48.2735 21.8676 48.2256C19.9366 47.4931 18.0979 46.6 16.3292 45.5858C16.1893 45.5041 16.1781 45.304 16.3068 45.2082C16.679 44.9293 17.0513 44.6391 17.4067 44.3461C17.471 44.2926 17.5606 44.2813 17.6362 44.3151C29.2558 49.6202 41.8354 49.6202 53.3179 44.3151C53.3935 44.2785 53.4831 44.2898 53.5502 44.3433C53.9057 44.6363 54.2779 44.9293 54.6529 45.2082C54.7816 45.304 54.7732 45.5041 54.6333 45.5858C52.8646 46.6197 51.0259 47.4931 49.0921 48.2228C48.9662 48.2707 48.9102 48.4172 48.9718 48.5383C50.038 50.6034 51.2554 52.5699 52.5959 54.435C52.6519 54.5139 52.7526 54.5477 52.845 54.5195C58.6464 52.7249 64.529 50.0174 70.6019 45.5576C70.6551 45.5182 70.6887 45.459 70.6943 45.3942C72.1747 30.0791 68.2147 16.7757 60.1968 4.9823C60.1772 4.9429 60.1437 4.9147 60.1045 4.8978ZM23.7259 37.3253C20.2276 37.3253 17.3451 34.1136 17.3451 30.1693C17.3451 26.225 20.1717 23.0133 23.7259 23.0133C27.308 23.0133 30.1626 26.2532 30.1066 30.1693C30.1066 34.1136 27.28 37.3253 23.7259 37.3253ZM47.3178 37.3253C43.8196 37.3253 40.9371 34.1136 40.9371 30.1693C40.9371 26.225 43.7636 23.0133 47.3178 23.0133C50.9 23.0133 53.7545 26.2532 53.6986 30.1693C53.6986 34.1136 50.9 37.3253 47.3178 37.3253Z",
          fill: n
        }
      ) }),
      /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: "clip0", children: /* @__PURE__ */ d.jsx("rect", { width: "71", height: "55", fill: "white" }) }) })
    ]
  }
), Sre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 1 2-2h4.586A2 2 0 0 1 12 2.586L15.414 6A2 2 0 0 1 16 7.414V16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Z",
        clipRule: "evenodd"
      }
    )
  }
), Cre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414A2 2 0 0 0 15.414 6L12 2.586A2 2 0 0 0 10.586 2H6Zm5 6a1 1 0 1 0-2 0v2H7a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2V8Z",
        clipRule: "evenodd"
      }
    )
  }
), bre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414A2 2 0 0 0 15.414 6L12 2.586A2 2 0 0 0 10.586 2H6Zm5 6a1 1 0 1 0-2 0v3.586l-1.293-1.293a1 1 0 1 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 11.586V8Z",
        clipRule: "evenodd"
      }
    )
  }
), _re = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6.414A2 2 0 0 0 16.414 5L14 2.586A2 2 0 0 0 12.586 2H9Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 8a2 2 0 0 1 2-2v7a3 3 0 0 0 3 3h5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8Z"
        }
      )
    ]
  }
), Rre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414A2 2 0 0 0 15.414 6L12 2.586A2 2 0 0 0 10.586 2H6Zm1 8a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H7Z",
        clipRule: "evenodd"
      }
    )
  }
), Ere = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414A2 2 0 0 0 15.414 6L12 2.586A2 2 0 0 0 10.586 2H6Zm2 10a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3Zm2-3a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1Zm4-1a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0V8Z",
        clipRule: "evenodd"
      }
    )
  }
), Mre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 4a2 2 0 0 1 2-2h4.586A2 2 0 0 1 12 2.586L15.414 6A2 2 0 0 1 16 7.414V16a2 2 0 0 1-2 2h-1.528A6 6 0 0 0 4 9.528V4Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 10a4 4 0 0 0-3.446 6.032l-1.261 1.26a1 1 0 1 0 1.414 1.415l1.261-1.261A4 4 0 1 0 8 10Zm-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Tre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 1 2-2h4.586A2 2 0 0 1 12 2.586L15.414 6A2 2 0 0 1 16 7.414V16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Zm2 6a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H7Z",
        clipRule: "evenodd"
      }
    )
  }
), Ore = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 9H5v2h2V9Zm8 0h-2v2h2V9ZM9 9h2v2H9V9Z",
        clipRule: "evenodd"
      }
    )
  }
), Dre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm6 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      }
    )
  }
), Are = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
      }
    )
  }
), jre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 17a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm3.293-7.707a1 1 0 0 1 1.414 0L9 10.586V3a1 1 0 1 1 2 0v7.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), kre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7 9a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V9Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2V8a3 3 0 0 1 3-3h5a2 2 0 0 0-2-2H5Z"
        }
      )
    ]
  }
), Lre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-.464 5.535a1 1 0 1 0-1.415-1.414 3 3 0 0 1-4.242 0 1 1 0 0 0-1.415 1.414 5 5 0 0 0 7.072 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Ire = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-7.536 5.879a1 1 0 0 0 1.415 0 3 3 0 0 1 4.242 0 1 1 0 0 0 1.415-1.415 5 5 0 0 0-7.072 0 1 1 0 0 0 0 1.415Z",
        clipRule: "evenodd"
      }
    )
  }
), BU = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.743 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92ZM11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1-8a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Hre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1-9a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Zre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 3a1 1 0 0 0-1 1v12a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1Zm10.293 9.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414L14.586 9H7a1 1 0 1 0 0 2h7.586l-1.293 1.293Z"
      }
    )
  }
), Pre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11 3a1 1 0 1 0 0 2h2.586l-6.293 6.293a1 1 0 1 0 1.414 1.414L15 6.414V9a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1h-5Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5 5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3a1 1 0 1 0-2 0v3H5V7h3a1 1 0 0 0 0-2H5Z"
        }
      )
    ]
  }
), Nre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx("path", { fill: "currentColor", d: "M10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Vre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l14 14a1 1 0 0 0 1.414-1.414l-1.473-1.473A10.014 10.014 0 0 0 19.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 0 0-4.512 1.074l-1.78-1.781Zm4.261 4.26 1.514 1.515a2.003 2.003 0 0 1 2.45 2.45l1.514 1.514a4 4 0 0 0-5.478-5.478Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12.454 16.697 9.75 13.992a4 4 0 0 1-3.742-3.741L2.335 6.578A9.98 9.98 0 0 0 .458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303Z"
        }
      )
    ]
  }
), Fre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.555 5.168A1 1 0 0 0 3 6v8a1 1 0 0 0 1.555.832L10 11.202V14a1 1 0 0 0 1.555.832l6-4a1 1 0 0 0 0-1.664l-6-4A1 1 0 0 0 10 6v2.798l-5.445-3.63Z"
      }
    )
  }
), Bre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4Zm3 2h6v4H7V5Zm8 8v2h1v-2h-1Zm-2-2H7v4h6v-4Zm2 0h1V9h-1v2Zm1-4V5h-1v2h1ZM5 5v2H4V5h1Zm0 4H4v2h1V9Zm-1 4h1v2H4v-2Z",
        clipRule: "evenodd"
      }
    )
  }
), Ure = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-.293.707L12 11.414V15a1 1 0 0 1-.293.707l-2 2A1 1 0 0 1 8 17v-5.586L3.293 6.707A1 1 0 0 1 3 6V3Z",
        clipRule: "evenodd"
      }
    )
  }
), Yre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.625 2.655A9 9 0 0 1 19 11a1 1 0 1 1-2 0 7 7 0 0 0-9.625-6.492 1 1 0 1 1-.75-1.853ZM4.662 4.959A1 1 0 0 1 4.75 6.37 6.97 6.97 0 0 0 3 11a1 1 0 1 1-2 0 8.97 8.97 0 0 1 2.25-5.953 1 1 0 0 1 1.412-.088Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 11a5 5 0 0 1 10 0 1 1 0 1 1-2 0 3 3 0 1 0-6 0c0 1.677-.345 3.276-.968 4.729a1 1 0 1 1-1.838-.789A9.964 9.964 0 0 0 5 11Zm8.921 2.012a1 1 0 0 1 .831 1.145 19.86 19.86 0 0 1-.545 2.436 1 1 0 1 1-1.92-.558c.207-.713.371-1.445.49-2.192a1 1 0 0 1 1.144-.83Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 10a1 1 0 0 1 1 1c0 2.236-.46 4.368-1.29 6.304a1 1 0 0 1-1.838-.789A13.952 13.952 0 0 0 9 11a1 1 0 0 1 1-1Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), $re = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.757 2.034a1 1 0 0 1 .638.519c.483.967.844 1.554 1.207 2.03.368.482.756.876 1.348 1.467A6.981 6.981 0 0 1 17 11 7 7 0 1 1 5.05 6.05a1 1 0 0 1 1.707.707c0 1.12.07 1.973.398 2.654.18.374.46.74.945 1.067.116-1.061.328-2.354.614-3.58.225-.966.505-1.93.839-2.734.167-.403.356-.785.57-1.116.208-.322.477-.65.822-.88a1 1 0 0 1 .812-.134Zm.364 13.087A3 3 0 0 1 7 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0 1 13 13a2.99 2.99 0 0 1-.879 2.121Z",
        clipRule: "evenodd"
      }
    )
  }
), Wre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h10a1 1 0 0 1 .8 1.6L14.25 8l2.55 3.4A1 1 0 0 1 16 13H6a1 1 0 0 0-1 1v3a1 1 0 1 1-2 0V6Z",
        clipRule: "evenodd"
      }
    )
  }
), zre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 6a2 2 0 0 1 2-2h5l2 2h5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Z"
      }
    )
  }
), qre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5L9 4H4Zm7 5a1 1 0 1 0-2 0v1H8a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1V9Z",
        clipRule: "evenodd"
      }
    )
  }
), Gre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5L9 4H4Zm7 5a1 1 0 1 0-2 0v1.586l-.293-.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l2-2a1 1 0 0 0-1.414-1.414l-.293.293V9Z",
        clipRule: "evenodd"
      }
    )
  }
), Kre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 6a2 2 0 0 1 2-2h4l2 2h4a2 2 0 0 1 2 2v1H8a3 3 0 0 0-3 3v1.5a1.5 1.5 0 0 1-3 0V6Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6 12a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H2h2a2 2 0 0 0 2-2v-2Z"
        }
      )
    ]
  }
), Qre = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5L9 4H4Zm4 6a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H8Z",
        clipRule: "evenodd"
      }
    )
  }
), Xre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 5a3 3 0 0 1 5-2.236A3 3 0 0 1 14.83 6H16a2 2 0 1 1 0 4h-5V9a1 1 0 1 0-2 0v1H4a2 2 0 1 1 0-4h1.17C5.06 5.687 5 5.35 5 5Zm4 1V5a1 1 0 1 0-1 1h1Zm3 0a1 1 0 1 0-1-1v1h1Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9 11H3v5a2 2 0 0 0 2 2h4v-7Zm2 7h4a2 2 0 0 0 2-2v-5h-6v7Z"
        }
      )
    ]
  }
), Jre = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 1.95c-4.42 0-8 3.58-8 8 0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 18 9.95c0-4.42-3.58-8-8-8Z",
        clipRule: "evenodd"
      }
    )
  }
), eae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    width: e,
    height: e,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    className: "feather feather-gitlab",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"
      }
    )
  }
), tae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM4.332 8.027a6.012 6.012 0 0 1 1.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 0 1 9 7.5V8a2 2 0 0 0 4 0 2 2 0 0 1 1.523-1.943A5.977 5.977 0 0 1 16 10c0 .34-.028.675-.083 1H15a2 2 0 0 0-2 2v2.197A5.973 5.973 0 0 1 10 16v-2a2 2 0 0 0-2-2 2 2 0 0 1-2-2 2 2 0 0 0-1.668-1.973Z",
        clipRule: "evenodd"
      }
    )
  }
), nae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 0 0 4.083 9ZM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4Zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0 1 15.917 9h-1.946Zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556Zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 0 1-2.783 4.118Zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 0 0 2.783 4.118Z",
        clipRule: "evenodd"
      }
    )
  }
), rae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_1603_12998)", children: [
        /* @__PURE__ */ d.jsx(
          "path",
          {
            fill: "#4285F4",
            d: "M18.215 10.368a7.05 7.05 0 0 0-.172-1.669h-7.665v3.03h4.5c-.092.753-.581 1.886-1.67 2.648l-.015.101 2.423 1.878.168.017c1.542-1.424 2.431-3.52 2.431-6.005Z"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            fill: "#34A853",
            d: "M10.378 18.35c2.204 0 4.055-.726 5.406-1.977l-2.576-1.996c-.69.48-1.614.816-2.83.816-2.158 0-3.99-1.424-4.644-3.392l-.096.008-2.52 1.95-.032.092a8.157 8.157 0 0 0 7.292 4.499Z"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            fill: "#FBBC05",
            d: "M5.734 11.801a5.025 5.025 0 0 1-.272-1.614c0-.563.1-1.107.263-1.615l-.004-.108-2.552-1.981-.083.04a8.17 8.17 0 0 0-.871 3.664 8.17 8.17 0 0 0 .87 3.664l2.65-2.05Z"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            fill: "#EB4335",
            d: "M10.378 5.18c1.533 0 2.567.662 3.157 1.215l2.303-2.25c-1.414-1.314-3.256-2.122-5.46-2.122a8.157 8.157 0 0 0-7.292 4.5l2.64 2.05c.661-1.97 2.494-3.393 4.652-3.393Z"
          }
        )
      ] }),
      /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: "clip0_1603_12998", children: /* @__PURE__ */ d.jsx("path", { fill: "#fff", d: "M2.215 2h16v16.373h-16z" }) }) })
    ]
  }
), aae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M17.1997 9.0611C17.1733 8.79223 17.1292 8.48369 17.041 8.13988C16.9529 7.80049 16.8207 7.42583 16.6267 7.03796C16.4328 6.65008 16.1815 6.24897 15.8554 5.85669C15.7275 5.70242 15.5865 5.55256 15.4366 5.4071C15.6614 4.51234 15.1634 3.73658 15.1634 3.73658C14.3039 3.68369 13.7573 4.00545 13.5545 4.1509C13.5193 4.13768 13.4884 4.12005 13.4532 4.10683C13.3077 4.04953 13.1579 3.99223 12.9992 3.94374C12.8449 3.89526 12.6862 3.85118 12.5231 3.81151C12.3601 3.77184 12.197 3.74099 12.0295 3.71454C11.9986 3.71013 11.9722 3.70572 11.9413 3.70132C11.5667 2.50242 10.4912 1.99994 10.4912 1.99994C9.28788 2.76247 9.06308 3.82914 9.06308 3.82914C9.06308 3.82914 9.05868 3.85118 9.04986 3.89085C8.98375 3.90848 8.91763 3.93052 8.85151 3.94815C8.75895 3.97459 8.66639 4.00986 8.57824 4.04512C8.48567 4.08038 8.39752 4.11564 8.30496 4.15531C8.12424 4.23465 7.94353 4.3228 7.76722 4.41977C7.59532 4.51674 7.42782 4.62253 7.26474 4.73272L7.22066 4.71509C5.55455 4.08038 4.07796 4.84291 4.07796 4.84291C3.94132 6.61481 4.74353 7.72997 4.9022 7.93272C4.86253 8.04291 4.82727 8.15311 4.79201 8.2633C4.66859 8.6644 4.57603 9.07432 4.51873 9.50187C4.50992 9.56358 4.5011 9.62528 4.49669 9.68699C2.95399 10.4495 2.5 12.0054 2.5 12.0054C3.78264 13.482 5.28127 13.5746 5.28127 13.5746L5.28567 13.5702C5.47521 13.9096 5.69559 14.2313 5.94242 14.5355C6.04821 14.6633 6.15399 14.7823 6.26859 14.9013C5.80138 16.2413 6.33471 17.352 6.33471 17.352C7.76281 17.4049 8.70165 16.7261 8.9 16.5718C9.04105 16.6203 9.1865 16.6644 9.33196 16.6997C9.77273 16.8143 10.2223 16.8804 10.6719 16.898C10.7821 16.9024 10.8967 16.9068 11.0069 16.9024H11.1656L11.2361 16.898V16.9024C11.9105 17.8633 13.0917 17.9999 13.0917 17.9999C13.9336 17.114 13.9821 16.2324 13.9821 16.0429V15.9636C14.1584 15.8402 14.3259 15.7079 14.4846 15.5625C14.8196 15.2583 15.1149 14.9101 15.3617 14.5355L15.4278 14.4297C16.3799 14.4826 17.0543 13.8391 17.0543 13.8391C16.8956 12.8473 16.3314 12.3625 16.2124 12.2699C16.0934 12.1774 16.208 12.2655 16.1992 12.2611C16.1904 12.2567 16.1904 12.2523 16.1904 12.2523C16.1859 12.2479 16.1771 12.2435 16.1683 12.2391C16.1727 12.1773 16.1771 12.12 16.1815 12.0583C16.1904 11.9526 16.1904 11.8424 16.1904 11.7366V11.5691L16.1859 11.503L16.1815 11.4148C16.1815 11.384 16.1771 11.3575 16.1727 11.3311C16.1683 11.3046 16.1683 11.2738 16.1639 11.2473L16.1551 11.1636L16.1419 11.0798C16.1242 10.9696 16.1066 10.8639 16.0802 10.7537C15.9788 10.3261 15.8113 9.9206 15.5953 9.55476C15.3749 9.18892 15.1017 8.86716 14.7887 8.59388C14.4802 8.3206 14.132 8.10021 13.7705 7.93713C13.4047 7.77404 13.0256 7.66826 12.6466 7.61977C12.457 7.59333 12.2675 7.58451 12.078 7.58892H11.9369L11.8664 7.59333C11.8399 7.59333 11.8135 7.59774 11.7915 7.59774C11.6945 7.60655 11.5975 7.61977 11.505 7.6374C11.1259 7.70793 10.7689 7.84457 10.4559 8.0341C10.143 8.22363 9.8697 8.45724 9.64931 8.7217C9.42893 8.98617 9.25702 9.28148 9.13802 9.58561C9.01901 9.88975 8.95289 10.2071 8.93526 10.5112C8.93085 10.5862 8.93085 10.6655 8.93085 10.7404V10.7977L8.93526 10.8594C8.93967 10.8947 8.93967 10.9344 8.94408 10.9696C8.9573 11.1239 8.98815 11.2738 9.02782 11.4148C9.11157 11.7013 9.2438 11.9614 9.40689 12.1818C9.56997 12.4021 9.76832 12.5829 9.97548 12.7283C10.1826 12.8694 10.4074 12.9707 10.6278 13.0369C10.8482 13.103 11.0686 13.1294 11.2758 13.1294H11.3904C11.4036 13.1294 11.4168 13.1294 11.43 13.125C11.4521 13.125 11.4741 13.1206 11.4961 13.1206C11.5006 13.1206 11.5094 13.1206 11.5138 13.1162L11.5358 13.1118C11.549 13.1118 11.5623 13.1074 11.5755 13.1074C11.6019 13.103 11.624 13.0986 11.6504 13.0942C11.6769 13.0897 11.6989 13.0853 11.7209 13.0765C11.7694 13.0677 11.8135 13.0501 11.8576 13.0369C11.9457 13.006 12.0339 12.9707 12.1088 12.9311C12.1882 12.8914 12.2587 12.8429 12.3292 12.7988C12.3468 12.7856 12.3689 12.7724 12.3865 12.7548C12.457 12.6975 12.4702 12.5917 12.4129 12.5212C12.3645 12.4594 12.2763 12.4418 12.2058 12.4815L12.1529 12.5079C12.0912 12.5388 12.0295 12.5652 11.9634 12.5873C11.8972 12.6093 11.8267 12.6269 11.7562 12.6402C11.7209 12.6446 11.6857 12.649 11.646 12.6534C11.6284 12.6534 11.6107 12.6578 11.5887 12.6578H11.4829C11.4609 12.6578 11.4388 12.6578 11.4168 12.6534H11.3904C11.3815 12.6534 11.3683 12.6534 11.3595 12.649C11.3375 12.6446 11.3198 12.6446 11.2978 12.6402C11.1347 12.6181 10.9716 12.5696 10.8174 12.4991C10.6587 12.4286 10.5088 12.3316 10.3722 12.2082C10.2355 12.0848 10.1165 11.9393 10.024 11.7718C9.9314 11.6043 9.86529 11.4192 9.83443 11.2253C9.82121 11.1283 9.8124 11.0269 9.8168 10.93C9.8168 10.9035 9.82121 10.8771 9.82121 10.8506V10.8154C9.82121 10.8021 9.82562 10.7889 9.82562 10.7757C9.83003 10.7228 9.83884 10.6699 9.84766 10.617C9.92259 10.1939 10.1342 9.77955 10.4603 9.46661C10.5441 9.38727 10.6322 9.31674 10.7248 9.25063C10.8174 9.18451 10.9187 9.12721 11.0245 9.07873C11.1303 9.03024 11.2361 8.99057 11.3507 8.95972C11.4609 8.92886 11.5755 8.91123 11.6945 8.89801C11.7518 8.8936 11.8091 8.8892 11.8708 8.8892H12.0074L12.0559 8.8936C12.1837 8.90242 12.3072 8.92005 12.4306 8.9509C12.6774 9.0038 12.9198 9.09636 13.1446 9.21977C13.5942 9.47101 13.9777 9.85889 14.2113 10.3261C14.3303 10.5597 14.4141 10.811 14.4537 11.071C14.4625 11.1371 14.4713 11.2032 14.4758 11.2694L14.4846 11.3663V11.5559C14.4846 11.5867 14.4802 11.6396 14.4802 11.6705C14.4758 11.741 14.4669 11.8159 14.4581 11.8864C14.4493 11.957 14.4361 12.0275 14.4229 12.098C14.4096 12.1685 14.392 12.2391 14.3744 12.3052C14.3391 12.4418 14.295 12.5785 14.2421 12.7151C14.1364 12.9796 13.9953 13.2352 13.8278 13.4688C13.4884 13.936 13.0256 14.3151 12.4967 14.5575C12.2322 14.6765 11.9545 14.7647 11.668 14.8088C11.527 14.8352 11.3815 14.8484 11.2361 14.8528H11.0157C10.9364 14.8528 10.8614 14.8484 10.7821 14.8396C10.4736 14.8176 10.1694 14.7603 9.8697 14.6765C9.57438 14.5928 9.28788 14.4738 9.0146 14.3327C8.47245 14.0418 7.9832 13.6451 7.60413 13.1647C7.4146 12.9267 7.24711 12.6666 7.11047 12.3977C6.97383 12.1289 6.86364 11.8424 6.7843 11.5559C6.70496 11.265 6.65647 10.9696 6.63444 10.6699L6.63003 10.6126V10.2203C6.63443 10.0749 6.64766 9.9206 6.66529 9.77074C6.68292 9.62088 6.70937 9.46661 6.74022 9.31674C6.77107 9.16688 6.80634 9.01702 6.85041 8.86716C6.93416 8.57184 7.03994 8.28534 7.16336 8.01647C7.4146 7.47873 7.74077 6.99829 8.13306 6.61481C8.23003 6.51785 8.3314 6.42969 8.43719 6.34154C8.54297 6.25779 8.65317 6.17845 8.76777 6.10352C8.87796 6.02859 8.99697 5.96247 9.11598 5.90077C9.17328 5.86991 9.23499 5.83906 9.29669 5.81261L9.48182 5.73327C9.60523 5.68038 9.73306 5.6363 9.86529 5.59663C9.89614 5.58782 9.9314 5.579 9.96226 5.56578C9.99311 5.55696 10.0284 5.54815 10.0592 5.53933C10.1253 5.5217 10.1915 5.50407 10.2576 5.49085C10.2884 5.48203 10.3237 5.47762 10.359 5.46881C10.3942 5.45999 10.4251 5.45559 10.4603 5.44677C10.4956 5.44236 10.5264 5.43355 10.5617 5.42914L10.6102 5.42032L10.6631 5.41151C10.6983 5.4071 10.7292 5.40269 10.7645 5.39829C10.8041 5.39388 10.8394 5.38947 10.8791 5.38506C10.9099 5.38066 10.9628 5.37625 10.9937 5.37184C11.0157 5.36743 11.0421 5.36743 11.0642 5.36302L11.1127 5.35862L11.1347 5.35421H11.1612C11.2008 5.3498 11.2361 5.3498 11.2758 5.34539L11.3331 5.34099H11.3771C11.408 5.34099 11.4432 5.33658 11.4741 5.33658C11.6019 5.33217 11.7342 5.33217 11.862 5.33658C12.1176 5.34539 12.3689 5.37625 12.6113 5.42032C13.1005 5.51289 13.559 5.66716 13.9777 5.87432C14.3964 6.07707 14.7667 6.32831 15.0928 6.60159C15.1149 6.61922 15.1325 6.63685 15.1545 6.65448C15.1722 6.67212 15.1942 6.68975 15.2118 6.70738C15.2515 6.74264 15.2868 6.7779 15.3264 6.81316C15.3661 6.84842 15.4014 6.88369 15.4366 6.91895C15.4719 6.95421 15.5072 6.98947 15.5424 7.02914C15.6791 7.17459 15.8069 7.32005 15.9215 7.46991C16.1507 7.76523 16.3358 8.06495 16.4813 8.34705L16.5342 8.45283C16.5518 8.48809 16.5694 8.52336 16.5826 8.55862C16.6003 8.59388 16.6135 8.62473 16.6311 8.65999C16.6444 8.69526 16.662 8.72611 16.6752 8.76137C16.7281 8.8936 16.781 9.02143 16.8207 9.14043C16.8868 9.33437 16.9353 9.50628 16.9749 9.65614C16.9882 9.71785 17.0455 9.75751 17.1072 9.7487C17.1733 9.74429 17.2218 9.6914 17.2218 9.62528C17.2262 9.46661 17.2218 9.27707 17.1997 9.0611Z",
        fill: "#322444"
      }
    )
  }
), oae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9 3a1 1 0 0 1 2 0v5.5a.5.5 0 0 0 1 0V4a1 1 0 1 1 2 0v4.5a.5.5 0 0 0 1 0V6a1 1 0 1 1 2 0v5a7 7 0 1 1-14 0V9a1 1 0 0 1 2 0v2.5a.5.5 0 0 0 1 0V4a1 1 0 0 1 2 0v4.5a.5.5 0 0 0 1 0V3Z"
      }
    )
  }
), iae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.243 3.03a1 1 0 0 1 .727 1.213L9.53 6h2.94l.56-2.243a1 1 0 1 1 1.94.486L14.53 6H17a1 1 0 1 1 0 2h-2.97l-1 4H15a1 1 0 1 1 0 2h-2.47l-.56 2.242a1 1 0 1 1-1.94-.485L10.47 14H7.53l-.56 2.242a1 1 0 1 1-1.94-.485L5.47 14H3a1 1 0 1 1 0-2h2.97l1-4H5a1 1 0 0 1 0-2h2.47l.56-2.243a1 1 0 0 1 1.213-.727ZM9.03 8l-1 4h2.938l1-4H9.031Z",
        clipRule: "evenodd"
      }
    )
  }
), lae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.172 5.172a4 4 0 0 1 5.656 0L10 6.343l1.172-1.171a4 4 0 1 1 5.656 5.656L10 17.657l-6.828-6.829a4 4 0 0 1 0-5.656Z",
        clipRule: "evenodd"
      }
    )
  }
), uae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_590_7243)", children: [
        /* @__PURE__ */ d.jsx(
          "path",
          {
            fill: "#7957FF",
            d: "m8.922 12.62.129-.107 6.473-.056.04.164a.409.409 0 0 1-.04.1c-.056.098-.177.168-.419.308l-6.25 3.616c-.622.36-.933.54-1.125.497a.505.505 0 0 1-.363-.315c-.07-.184.065-.518.335-1.185l1.22-3.021Z"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            fill: "#18B6AA",
            d: "M15.564 12.62H8.922l-.039-.274 2.01-4.915.165-.092 4.208 4.675.02.022c.173.193.26.294.282.4a.413.413 0 0 1-.004.185Z"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            fill: "#F845C6",
            d: "m11.108 3.35-6.22 3.582c-.242.139-.364.209-.42.307a.413.413 0 0 0-.045.285c.023.11.116.215.303.423l4.196 4.674 2.136-5.282 1.203-2.985c.268-.665.402-.997.333-1.181a.505.505 0 0 0-.363-.315c-.192-.043-.502.135-1.123.493Z"
          }
        )
      ] }),
      /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: "clip0_590_7243", children: /* @__PURE__ */ d.jsx("path", { fill: "#fff", d: "M0 0h20v20H0z" }) }) })
    ]
  }
), sae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 12 12",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsxs("g", { id: "Own color", children: [
      /* @__PURE__ */ d.jsx(
        "circle",
        {
          id: "Ellipse 132",
          cx: "5.99999",
          cy: "6",
          r: "5.6",
          fill: "#744ED4"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          id: "Subtract",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.54999 3.55C3.9977 3.55 3.54999 3.99772 3.54999 4.55V7.45C3.54999 8.00229 3.9977 8.45 4.54999 8.45H6.34999L4.59999 3.55H4.54999ZM5.64999 3.55L7.39999 8.45H7.44999C8.00227 8.45 8.44999 8.00229 8.44999 7.45V4.55C8.44999 3.99772 8.00227 3.55 7.44999 3.55H5.64999Z",
          fill: "white"
        }
      )
    ] })
  }
), cae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10.707 2.293a1 1 0 0 0-1.414 0l-7 7a1 1 0 0 0 1.414 1.414L4 10.414V17a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6.586l.293.293a1 1 0 0 0 1.414-1.414l-7-7Z"
      }
    )
  }
), fae = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10 2a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 4h3a3 3 0 0 0 6 0h3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm2.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm2.45 4a2.5 2.5 0 1 0-4.9 0h4.9ZM12 9a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3Zm-1 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), dae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm12 0H5v10h10V5Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx("path", { fill: "currentColor", d: "M4 12h3l1 2h4l1-2h3v4H4v-4Z" })
    ]
  }
), hae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 5a2 2 0 0 1 2-2h1a1 1 0 0 1 0 2H5v10h10V5h-1a1 1 0 1 1 0-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 12h3l1 2h4l1-2h3v4H4v-4Zm3.293-4.707a1 1 0 0 1 1.414 0L9 7.586V3a1 1 0 1 1 2 0v4.586l.293-.293a1 1 0 1 1 1.414 1.414l-2 2a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 0-1.414Z"
        }
      )
    ]
  }
), UU = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a1 1 0 0 0 0 2v3a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2v-3a1 1 0 0 0-1-1H9Z",
        clipRule: "evenodd"
      }
    )
  }
), vae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M15 4H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1.5a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v1.5a1 1 0 1 1-2 0V5a1 1 0 0 0-1-1Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7.269 7.269a.913.913 0 0 1 .988-.203l9.167 3.666a.917.917 0 0 1 .07 1.671L14 14l-1.597 3.493a.917.917 0 0 1-1.67-.07L7.065 8.258a.917.917 0 0 1 .203-.988Z"
        }
      )
    ]
  }
), pae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx("path", { d: "M32 0H0V32H32V0Z", fill: "#0052CC" }),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M23.7199 7.64001H15.6399C15.6399 9.64001 17.2799 11.28 19.2799 11.28H20.7599V12.72C20.7599 14.72 22.3999 16.36 24.3999 16.36V8.32001C24.4399 7.96001 24.1199 7.64001 23.7199 7.64001Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M19.7199 11.64H11.6399C11.6399 13.64 13.2799 15.28 15.2799 15.28H16.7599V16.72C16.7599 18.72 18.3999 20.36 20.3999 20.36V12.36C20.4399 11.96 20.1199 11.64 19.7199 11.64Z",
          fill: "url(#paint0_linear)"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M15.7199 15.6801H7.63989C7.63989 17.6801 9.27988 19.3201 11.2799 19.3201H12.7599V20.7601C12.7599 22.7601 14.3999 24.4001 16.3999 24.4001V16.4001C16.4399 16.0001 16.1199 15.6801 15.7199 15.6801Z",
          fill: "url(#paint1_linear)"
        }
      ),
      /* @__PURE__ */ d.jsxs("defs", { children: [
        /* @__PURE__ */ d.jsxs(
          "linearGradient",
          {
            id: "paint0_linear",
            x1: "20.2597",
            y1: "11.6708",
            x2: "16.8183",
            y2: "15.2196",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ d.jsx("stop", { offset: "0.176", stopColor: "white", stopOpacity: "0.4" }),
              /* @__PURE__ */ d.jsx("stop", { offset: "1", stopColor: "white" })
            ]
          }
        ),
        /* @__PURE__ */ d.jsxs(
          "linearGradient",
          {
            id: "paint1_linear",
            x1: "16.4844",
            y1: "15.7246",
            x2: "12.5054",
            y2: "19.596",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ d.jsx("stop", { offset: "0.176", stopColor: "white", stopOpacity: "0.4" }),
              /* @__PURE__ */ d.jsx("stop", { offset: "1", stopColor: "white" })
            ]
          }
        )
      ] })
    ]
  }
), mae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 8a6 6 0 0 1-7.743 5.743L8 16H6v2H2v-4l4.257-4.257A6 6 0 1 1 18 8Zm-6-4a1 1 0 1 0 0 2 2 2 0 0 1 2 2 1 1 0 1 0 2 0 4 4 0 0 0-4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), gae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11 3a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0V3Zm4.657 2.757a1 1 0 0 0-1.414-1.414l-.707.707a1 1 0 0 0 1.414 1.414l.707-.707ZM18 10a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1ZM5.05 6.464A1 1 0 1 0 6.464 5.05l-.707-.707a1 1 0 0 0-1.414 1.414l.707.707ZM5 10a1 1 0 0 1-1 1H3a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1Zm3 6v-1h4v1a2 2 0 1 1-4 0Zm4-2c.015-.34.208-.646.477-.859a4 4 0 1 0-4.954 0c.27.213.462.519.476.859h4.002Z"
      }
    )
  }
), wae = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.3 1.046A1 1 0 0 1 12 2v5h4a1 1 0 0 1 .82 1.573l-7 10A1 1 0 0 1 8 18v-5H4a1 1 0 0 1-.82-1.573l7-10a1 1 0 0 1 1.12-.38Z",
        clipRule: "evenodd"
      }
    )
  }
), yae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "#5E6AD2",
        d: "m2.1 11.35 6.55 6.55a8.013 8.013 0 0 1-6.55-6.55ZM2 9.572 10.428 18a8.01 8.01 0 0 0 1.463-.214L2.214 8.109A8 8 0 0 0 2 9.572Zm.634-2.72 10.515 10.514a7.988 7.988 0 0 0 1.1-.577L3.21 5.75c-.22.351-.413.719-.577 1.1Zm1.29-2.066a8.006 8.006 0 1 1 11.29 11.29L3.924 4.786Z"
      }
    )
  }
), xae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12.586 4.586a2 2 0 1 1 2.828 2.828l-3 3a2 2 0 0 1-2.828 0 1 1 0 0 0-1.414 1.414 4 4 0 0 0 5.656 0l3-3a4 4 0 0 0-5.656-5.656l-1.5 1.5a1 1 0 1 0 1.414 1.414l1.5-1.5Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7.586 9.586a2 2 0 0 1 2.828 0 1 1 0 1 0 1.414-1.414 4 4 0 0 0-5.656 0l-3 3a4 4 0 1 0 5.656 5.656l1.5-1.5a1 1 0 1 0-1.414-1.414l-1.5 1.5a2 2 0 1 1-2.828-2.828l3-3Z"
        }
      )
    ]
  }
), Sae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 3c0-.552.45-1.006.997-.938a8 8 0 0 1 .987 15.688c-.535.137-1.037-.257-1.107-.805-.069-.548.323-1.04.852-1.2a6 6 0 0 0-.734-11.662C10.451 3.991 10 3.553 10 3Z"
      }
    )
  }
), Cae = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 114 39",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M18 28a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-1.6a6.4 6.4 0 1 1 0-12.8 6.4 6.4 0 0 1 0 12.8Zm3.423-10.045A5 5 0 0 0 18 15v5l3.423-3.645ZM74 28a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-1.6a6.4 6.4 0 1 1 0-12.8 6.4 6.4 0 0 1 0 12.8Zm2.409-10.781A5 5 0 0 0 74 15v5l-3.853 3.187a5 5 0 1 0 6.262-7.569ZM97 28a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-1.6a6.4 6.4 0 1 1 0-12.8 6.4 6.4 0 0 1 0 12.8Zm0-1.4a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "rect",
        {
          width: 113,
          height: 38,
          x: 0.5,
          y: 0.5,
          stroke: "currentColor",
          strokeDasharray: "10 5",
          rx: 4.5
        }
      )
    ]
  }
), bae = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.05 4.05a7 7 0 1 1 9.9 9.9L10 18.9l-4.95-4.95a7 7 0 0 1 0-9.9ZM10 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
        clipRule: "evenodd"
      }
    )
  }
), _ae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 9V7a5 5 0 0 1 10 0v2a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2Zm8-2v2H7V7a3 3 0 0 1 6 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Rae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 2a5 5 0 0 0-5 5v2a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2H7V7a3 3 0 0 1 5.905-.75 1 1 0 0 0 1.937-.5A5.002 5.002 0 0 0 10 2Z"
      }
    )
  }
), Eae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Zm7.707 3.293a1 1 0 0 1 0 1.414L9.414 9H17a1 1 0 1 1 0 2H9.414l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Mae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 16 14",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M0 3a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3Zm3 1.752c0-.69.56-1.25 1.25-1.25h7.5a1.25 1.25 0 1 1 0 2.5h-7.5c-.69 0-1.25-.56-1.25-1.25Zm1.25 3.246a1.25 1.25 0 1 0 0 2.5h4.5a1.25 1.25 0 1 0 0-2.5h-4.5Z",
        clipRule: "evenodd"
      }
    )
  }
), Tae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2.003 5.884 10 9.882l7.997-3.998A2 2 0 0 0 16 4H4a2 2 0 0 0-1.997 1.884Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m18 8.118-8 4-8-4V14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.118Z"
        }
      )
    ]
  }
), Oae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.94 6.412A2 2 0 0 0 2 8.108V16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.108a2 2 0 0 0-.94-1.696l-6-3.75a2 2 0 0 0-2.12 0l-6 3.75Zm2.615 2.423a1 1 0 1 0-1.11 1.664l5 3.333a1 1 0 0 0 1.11 0l5-3.333a1 1 0 0 0-1.11-1.664L10 11.798 5.555 8.835Z",
        clipRule: "evenodd"
      }
    )
  }
), Dae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m12 1.586-4 4v12.828l4-4V1.586ZM3.707 3.293A1 1 0 0 0 2 4v10a1 1 0 0 0 .293.707L6 18.414V5.586L3.707 3.293Zm14 2L14 1.586v12.828l2.293 2.293A1 1 0 0 0 18 16V6a1 1 0 0 0-.293-.707Z",
        clipRule: "evenodd"
      }
    )
  }
), Aae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.496 2.132a1 1 0 0 0-.992 0l-7 4A1 1 0 0 0 3 8v7a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2V8a1 1 0 0 0 .496-1.868l-7-4ZM6 9a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1Zm3 1a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0v-3Zm5-1a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), jae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), kae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Lae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Iae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm6 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Hae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 7a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Zae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7 4a3 3 0 0 1 6 0v4a3 3 0 1 1-6 0V4Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11 14.93A7.001 7.001 0 0 0 17 8a1 1 0 1 0-2 0A5 5 0 0 1 5 8a1 1 0 0 0-2 0 7.001 7.001 0 0 0 6 6.93V17H6a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3v-2.07Z"
        }
      )
    ]
  }
), Pae = ({
  size: e = "1em",
  fill: n = "#5865F2"
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    fill: n,
    width: e,
    height: e,
    xmlns: "http://www.w3.org/2000/svg",
    className: "bi bi-microsoft-teams",
    viewBox: "0 0 16 16",
    children: [
      /* @__PURE__ */ d.jsx("path", { d: "M9.186 4.797a2.42 2.42 0 1 0-2.86-2.448h1.178c.929 0 1.682.753 1.682 1.682v.766Zm-4.295 7.738h2.613c.929 0 1.682-.753 1.682-1.682V5.58h2.783a.7.7 0 0 1 .682.716v4.294a4.197 4.197 0 0 1-4.093 4.293c-1.618-.04-3-.99-3.667-2.35Zm10.737-9.372a1.674 1.674 0 1 1-3.349 0 1.674 1.674 0 0 1 3.349 0Zm-2.238 9.488c-.04 0-.08 0-.12-.002a5.19 5.19 0 0 0 .381-2.07V6.306a1.692 1.692 0 0 0-.15-.725h1.792c.39 0 .707.317.707.707v3.765a2.598 2.598 0 0 1-2.598 2.598h-.013Z" }),
      /* @__PURE__ */ d.jsx("path", { d: "M.682 3.349h6.822c.377 0 .682.305.682.682v6.822a.682.682 0 0 1-.682.682H.682A.682.682 0 0 1 0 10.853V4.03c0-.377.305-.682.682-.682Zm5.206 2.596v-.72h-3.59v.72h1.357V9.66h.87V5.945h1.363Z" })
    ]
  }
), YU = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 10a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Nae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H7Z",
        clipRule: "evenodd"
      }
    )
  }
), Vae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 10a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Fae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M17.293 13.293A8 8 0 0 1 6.707 2.707a8.002 8.002 0 1 0 10.586 10.586Z"
      }
    )
  }
), Bae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M18 3a1 1 0 0 0-1.196-.98l-10 2A1 1 0 0 0 6 5v9.114A4.369 4.369 0 0 0 5 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0 0 15 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3Z"
      }
    )
  }
), Uae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v10a2 2 0 0 0 2 2H4a2 2 0 0 1-2-2V5Zm3 1h6v4H5V6Zm6 6H5v2h6v-2Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M15 7h1a2 2 0 0 1 2 2v5.5a1.5 1.5 0 0 1-3 0V7Z"
        }
      )
    ]
  }
), Yae = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1v-2a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2a1 1 0 0 1-1 1H4a1 1 0 1 1 0-2V4Zm3 1h2v2H7V5Zm2 4H7v2h2V9Zm2-4h2v2h-2V5Zm2 4h-2v2h2V9Z",
        clipRule: "evenodd"
      }
    )
  }
), $ae = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M17.447 10.894a1 1 0 0 0 0-1.788l-14-7a1 1 0 0 0-1.409 1.169l1.429 5A1 1 0 0 0 4.429 9H9a1 1 0 1 1 0 2H4.429a1 1 0 0 0-.962.725l-1.429 5a1 1 0 0 0 1.41 1.17l14-7Z"
      }
    )
  }
), Wae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4a3 3 0 0 0-3 3v4a5 5 0 0 0 10 0V7a1 1 0 1 1 2 0v4a7 7 0 1 1-14 0V7a5 5 0 0 1 10 0v4a3 3 0 1 1-6 0V7a1 1 0 0 1 2 0v4a1 1 0 1 0 2 0V7a3 3 0 0 0-3-3Z",
        clipRule: "evenodd"
      }
    )
  }
), zae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H5Zm8 0a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-2Z"
      }
    )
  }
), qae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM7 8a1 1 0 0 1 2 0v4a1 1 0 1 1-2 0V8Zm5-1a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Gae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M13.586 3.586a2 2 0 1 1 2.828 2.828l-.793.793-2.828-2.828.793-.793Zm-2.207 2.207L3 14.172V17h2.828l8.38-8.379-2.83-2.828Z"
      }
    )
  }
), Kae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M17.414 2.586a2 2 0 0 0-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 0 0 0-2.828Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 6a2 2 0 0 1 2-2h4a1 1 0 0 1 0 2H4v10h10v-4a1 1 0 1 1 2 0v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Qae = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.037 11.037 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.435.74a1 1 0 0 1 .836.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5V3Z"
      }
    )
  }
), Xae = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m14.414 7 3.293-3.293a1 1 0 0 0-1.414-1.414L13 5.586V4a1 1 0 1 0-2 0v4.003a.996.996 0 0 0 .617.921A.997.997 0 0 0 12 9h4a1 1 0 1 0 0-2h-1.586Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.037 11.037 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.435.74a1 1 0 0 1 .836.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5V3Z"
        }
      )
    ]
  }
), Jae = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.037 11.037 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.435.74a1 1 0 0 1 .836.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5V3Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M16.707 3.293a1 1 0 0 1 0 1.414L15.414 6l1.293 1.293a1 1 0 0 1-1.414 1.414L14 7.414l-1.293 1.293a1 1 0 1 1-1.414-1.414L12.586 6l-1.293-1.293a1 1 0 0 1 1.414-1.414L14 4.586l1.293-1.293a1 1 0 0 1 1.414 0Z"
        }
      )
    ]
  }
), eoe = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M17.924 2.617a.997.997 0 0 0-.215-.322l-.004-.004A.997.997 0 0 0 17 2h-4a1 1 0 1 0 0 2h1.586l-3.293 3.293a1 1 0 0 0 1.414 1.414L16 5.414V7a1 1 0 1 0 2 0V3a.997.997 0 0 0-.076-.383Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.037 11.037 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.435.74a1 1 0 0 1 .836.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5V3Z"
        }
      )
    ]
  }
), toe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4Zm12 12H4l4-8 3 6 2-4 3 6Z",
        clipRule: "evenodd"
      }
    )
  }
), noe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M16.14 11.572c1.311-.706 1.311-2.588 0-3.294L6.756 3.226C5.511 2.556 4 3.458 4 4.873v10.104c0 1.415 1.511 2.318 2.757 1.647l9.382-5.052Z"
      }
    )
  }
), roe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM9.555 7.168A1 1 0 0 0 8 8v4a1 1 0 0 0 1.555.832l3-2a1 1 0 0 0 0-1.664l-3-2Z",
        clipRule: "evenodd"
      }
    )
  }
), aoe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 3a1 1 0 0 1 1 1v5h5a1 1 0 1 1 0 2h-5v5a1 1 0 1 1-2 0v-5H4a1 1 0 1 1 0-2h5V4a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), ooe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-11a1 1 0 1 0-2 0v2H7a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2V7Z",
        clipRule: "evenodd"
      }
    )
  }
), ioe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 5a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H6a1 1 0 1 1 0-2h3V6a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), loe = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3a1 1 0 0 0 0 2v8a2 2 0 0 0 2 2h2.586l-1.293 1.293a1 1 0 1 0 1.414 1.414L10 15.414l2.293 2.293a1 1 0 0 0 1.414-1.414L12.414 15H15a2 2 0 0 0 2-2V5a1 1 0 1 0 0-2H3Zm11 4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V7Zm-3 1a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0V8ZM8 9a1 1 0 0 0-2 0v2a1 1 0 1 0 2 0V9Z",
        clipRule: "evenodd"
      }
    )
  }
), uoe = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3a1 1 0 0 0 0 2v8a2 2 0 0 0 2 2h2.586l-1.293 1.293a1 1 0 1 0 1.414 1.414L10 15.414l2.293 2.293a1 1 0 0 0 1.414-1.414L12.414 15H15a2 2 0 0 0 2-2V5a1 1 0 1 0 0-2H3Zm11.707 4.707a1 1 0 0 0-1.414-1.414L10 9.586 8.707 8.293a1 1 0 0 0-1.414 0l-2 2a1 1 0 1 0 1.414 1.414L8 10.414l1.293 1.293a1 1 0 0 0 1.414 0l4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), soe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 4v3H4a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2h1a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-1V4a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2Zm8 0H7v3h6V4Zm0 8H7v4h6v-4Z",
        clipRule: "evenodd"
      }
    )
  }
), coe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 3.5a1.5 1.5 0 0 1 3 0V4a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.5a1.5 1.5 0 0 0 0 3h.5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-.5a1.5 1.5 0 0 0-3 0v.5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-3a1 1 0 0 0-1-1h-.5a1.5 1.5 0 0 1 0-3H4a1 1 0 0 0 1-1V6a1 1 0 0 1 1-1h3a1 1 0 0 0 1-1v-.5Z"
      }
    )
  }
), foe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm2 2V5h1v1H5Zm-2 7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-3Zm2 2v-1h1v1H5Zm8-12a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-3Zm1 2v1h1V5h-1Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11 4a1 1 0 1 0-2 0v1a1 1 0 0 0 2 0V4Zm-1 3a1 1 0 0 1 1 1v1h2a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Zm6 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-7 4a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2v2a1 1 0 1 1-2 0v-3Zm-2-2a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2h3Zm10 2a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1Zm-1 4a1 1 0 1 0 0-2h-3a1 1 0 1 0 0 2h3Z"
        }
      )
    ]
  }
), doe = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8-3a1 1 0 0 0-.867.5 1 1 0 1 1-1.731-1A3 3 0 0 1 13 8a3.001 3.001 0 0 1-2 2.83V11a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1 1 1 0 1 0 0-2Zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
      }
    )
  }
), hoe = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 2a2 2 0 0 0-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 0 0-2-2H5Zm4.707 3.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L8.414 9H10a3 3 0 0 1 3 3v1a1 1 0 1 0 2 0v-1a5 5 0 0 0-5-5H8.414l1.293-1.293Z",
        clipRule: "evenodd"
      }
    )
  }
), voe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: n.color,
        fillRule: "evenodd",
        d: "M5 2a2 2 0 0 0-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 0 0-2-2H5Zm2.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm6.207.293a1 1 0 0 0-1.414 0l-6 6a1 1 0 1 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414ZM12.5 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
        clipRule: "evenodd"
      }
    )
  }
), poe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 2a1 1 0 0 1 1 1v2.101a7.002 7.002 0 0 1 11.601 2.566 1 1 0 1 1-1.885.666A5.002 5.002 0 0 0 5.999 7H9a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm.008 9.057a1 1 0 0 1 1.276.61A5.002 5.002 0 0 0 14.001 13H11a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-2.101a7.002 7.002 0 0 1-11.601-2.566 1 1 0 0 1 .61-1.276Z",
        clipRule: "evenodd"
      }
    )
  }
), moe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.707 3.293a1 1 0 0 1 0 1.414L5.414 7H11a7 7 0 0 1 7 7v2a1 1 0 1 1-2 0v-2a5 5 0 0 0-5-5H5.414l2.293 2.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), goe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8.445 14.832A1 1 0 0 0 10 14v-2.798l5.445 3.63A1 1 0 0 0 17 14V6a1 1 0 0 0-1.555-.832L10 8.798V6a1 1 0 0 0-1.555-.832l-6 4a1 1 0 0 0 0 1.664l6 4Z"
      }
    )
  }
), woe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5 3a1 1 0 0 0 0 2c5.523 0 10 4.477 10 10a1 1 0 1 0 2 0C17 8.373 11.627 3 5 3Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 9a1 1 0 0 1 1-1 7 7 0 0 1 7 7 1 1 0 1 1-2 0 5 5 0 0 0-5-5 1 1 0 0 1-1-1Zm-1 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
        }
      )
    ]
  }
), yoe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7.707 10.293a1 1 0 1 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 11.586V6h5a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5v5.586l-1.293-1.293ZM9 4a1 1 0 0 1 2 0v2H9V4Z"
      }
    )
  }
), xoe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9.707 7.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L13 8.586V5h3a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3v3.586L9.707 7.293ZM11 3a1 1 0 1 1 2 0v2h-2V3Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 9a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2H7a3 3 0 0 1-3-3V9Z"
        }
      )
    ]
  }
), Soe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 2a1 1 0 0 1 1 1v1.323l3.954 1.582 1.599-.8a1 1 0 1 1 .894 1.79l-1.233.616 1.738 5.42a1 1 0 0 1-.285 1.05A3.989 3.989 0 0 1 15 15a3.989 3.989 0 0 1-2.667-1.019 1 1 0 0 1-.285-1.05l1.715-5.349L11 6.477V16h2a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2h2V6.477L6.237 7.582l1.715 5.349a1 1 0 0 1-.285 1.05A3.989 3.989 0 0 1 5 15a3.989 3.989 0 0 1-2.667-1.019 1 1 0 0 1-.285-1.05l1.738-5.42-1.233-.617a1 1 0 0 1 .894-1.788l1.599.799L9 4.323V3a1 1 0 0 1 1-1Zm-5 8.274-.818 2.552c.25.112.526.174.818.174.292 0 .569-.062.818-.174L5 10.274Zm10 0-.818 2.552c.25.112.526.174.818.174.292 0 .569-.062.818-.174L15 10.274Z",
        clipRule: "evenodd"
      }
    )
  }
), Coe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.5 2a3.5 3.5 0 1 0 1.665 6.58L8.585 10l-1.42 1.42a3.5 3.5 0 1 0 1.414 1.414l8.128-8.127a1 1 0 0 0-1.414-1.414L10 8.586l-1.42-1.42A3.5 3.5 0 0 0 5.5 2ZM4 5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm0 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12.828 11.414a1 1 0 0 0-1.414 1.414l3.879 3.88a1 1 0 0 0 1.414-1.415l-3.879-3.879Z"
        }
      )
    ]
  }
), kT = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM2 8a6 6 0 1 1 10.89 3.476l4.817 4.817a1 1 0 0 1-1.414 1.414l-4.816-4.816A6 6 0 0 1 2 8Z",
        clipRule: "evenodd"
      }
    )
  }
), boe = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx("path", { fill: "currentColor", d: "M9 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" }),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-13a4 4 0 0 0-3.446 6.032l-2.261 2.26a1 1 0 1 0 1.414 1.415l2.261-2.261A4 4 0 1 0 11 5Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), _oe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9.27 2.164c.47-.219.99-.219 1.46 0l6.885 3.203c.513.239.513 1.108 0 1.347L10.73 9.917c-.47.218-.99.218-1.46 0L2.385 6.714c-.513-.24-.513-1.108 0-1.347L9.27 2.164Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m3.527 8.87-1.142.53c-.513.24-.513 1.108 0 1.348L9.27 13.95c.47.219.99.219 1.46 0l6.885-3.202c.513-.24.513-1.109 0-1.348l-1.142-.53-5.743 2.671c-.47.218-.99.218-1.46 0L3.527 8.87Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m2.385 13.286 1.142-.53 5.743 2.671c.47.219.99.219 1.46 0l5.743-2.672 1.142.531c.513.24.513 1.109 0 1.347l-6.885 3.203c-.47.219-.99.219-1.46 0l-6.885-3.203c-.513-.238-.513-1.108 0-1.347Z"
        }
      )
    ]
  }
), LT = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 3a1 1 0 0 1 .707.293l3 3a1 1 0 0 1-1.414 1.414L10 5.414 7.707 7.707a1 1 0 0 1-1.414-1.414l3-3A1 1 0 0 1 10 3Zm-3.707 9.293a1 1 0 0 1 1.414 0L10 14.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Roe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm14 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM2 13a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2Zm14 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Eoe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M15 8a3 3 0 1 0-2.977-2.63l-4.94 2.47a3 3 0 1 0 0 4.319l4.94 2.47a3 3 0 1 0 .895-1.789l-4.94-2.47a3.027 3.027 0 0 0 0-.74l4.94-2.47C13.456 7.68 14.19 8 15 8Z"
      }
    )
  }
), Moe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.166 4.999A11.954 11.954 0 0 0 10 1.944 11.954 11.954 0 0 0 17.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001Zm11.541 3.708a1 1 0 0 0-1.414-1.414L9 10.586 7.707 9.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Toe = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 1.944A11.954 11.954 0 0 1 2.166 5C2.056 5.649 2 6.319 2 7c0 5.225 3.34 9.67 8 11.317C14.66 16.67 18 12.225 18 7c0-.682-.057-1.35-.166-2.001A11.954 11.954 0 0 1 10 1.944ZM11 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0-7a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0V7Z",
        clipRule: "evenodd"
      }
    )
  }
), Ooe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 2a4 4 0 0 0-4 4v1H5a1 1 0 0 0-.994.89l-1 9A1 1 0 0 0 4 18h12a1 1 0 0 0 .994-1.11l-1-9A1 1 0 0 0 15 7h-1V6a4 4 0 0 0-4-4Zm2 5V6a2 2 0 1 0-4 0v1h4Zm-6 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm7-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
        clipRule: "evenodd"
      }
    )
  }
), Doe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M15.833 3c-.644 0-1.166.522-1.166 1.167v11.666a1.167 1.167 0 1 0 2.333 0V4.167C17 3.522 16.478 3 15.833 3Zm-3.351 5.47a1.867 1.867 0 0 1 0 3.06l-6.545 4.58C4.7 16.978 3 16.093 3 14.582V5.42c0-1.51 1.7-2.396 2.937-1.53l6.545 4.582Z"
      }
    )
  }
), Aoe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.167 17c.644 0 1.166-.522 1.166-1.167V4.167a1.167 1.167 0 1 0-2.333 0v11.666C3 16.478 3.522 17 4.167 17Zm3.351-5.47a1.867 1.867 0 0 1 0-3.06l6.545-4.58C15.3 3.022 17 3.907 17 5.418v9.162c0 1.51-1.7 2.396-2.937 1.53l-6.545-4.582Z"
      }
    )
  }
), joe = ({ size: e = "1em", fill: n, ...a }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    viewBox: "0 0 16 16",
    fill: "none",
    ...a,
    children: [
      /* @__PURE__ */ d.jsxs("g", { id: "Slack logo", clipPath: "url(#clip0_10939_406962)", children: [
        /* @__PURE__ */ d.jsx(
          "path",
          {
            id: "path2",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.44434 10.0775C4.44434 9.14544 5.14913 8.39508 6.02458 8.39508C6.90004 8.39508 7.60483 9.14544 7.60483 10.0775V14.2188C7.60483 15.1509 6.90004 15.9013 6.02458 15.9013C5.14913 15.9013 4.44434 15.1509 4.44434 14.2188V10.0775Z",
            fill: n ?? "#E01E5A",
            stroke: "#E01E5A",
            strokeWidth: "0.197531",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            id: "path4",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.0774 11.5556C9.14538 11.5556 8.39502 10.8508 8.39502 9.97533C8.39502 9.09987 9.14538 8.39508 10.0774 8.39508H14.2188C15.1508 8.39508 15.9012 9.09987 15.9012 9.97533C15.9012 10.8508 15.1508 11.5556 14.2188 11.5556H10.0774Z",
            fill: n ?? "#ECB22D",
            stroke: "#ECB22D",
            strokeWidth: "0.197531",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            id: "path6",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.39502 1.78116C8.39502 0.849115 9.09981 0.0987549 9.97527 0.0987549C10.8507 0.0987549 11.5555 0.849115 11.5555 1.78116V5.9225C11.5555 6.85457 10.8507 7.60493 9.97527 7.60493C9.09981 7.60493 8.39502 6.85457 8.39502 5.9225V1.78116Z",
            fill: n ?? "#2FB67C",
            stroke: "#2FB67C",
            strokeWidth: "0.197531",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            id: "path8",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.78104 7.60495C0.848993 7.60495 0.0986328 6.90016 0.0986328 6.0247C0.0986328 5.14925 0.848993 4.44446 1.78104 4.44446H5.92237C6.85444 4.44446 7.6048 5.14925 7.6048 6.0247C7.6048 6.90016 6.85444 7.60495 5.92237 7.60495H1.78104Z",
            fill: n ?? "#36C5F1",
            stroke: "#36C5F1",
            strokeWidth: "0.197531",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ d.jsxs("g", { id: "g18", children: [
          /* @__PURE__ */ d.jsx(
            "path",
            {
              id: "path10",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M8.39502 14.321C8.39458 14.5286 8.43515 14.7343 8.51441 14.9262C8.59367 15.1182 8.71005 15.2925 8.85688 15.4394C9.00371 15.5862 9.17809 15.7026 9.37001 15.7818C9.56194 15.8611 9.76762 15.9017 9.97527 15.9012C10.8507 15.9012 11.5555 15.1964 11.5555 14.321C11.556 14.1133 11.5154 13.9076 11.4361 13.7157C11.3569 13.5238 11.2405 13.3494 11.0937 13.2026C10.9468 13.0558 10.7725 12.9394 10.5805 12.8601C10.3886 12.7809 10.1829 12.7403 9.97527 12.7407H8.39502V14.321Z",
              fill: n ?? "#ECB22D",
              stroke: "#ECB22D",
              strokeWidth: "0.197531",
              strokeLinecap: "round"
            }
          ),
          /* @__PURE__ */ d.jsx(
            "path",
            {
              id: "path12",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M14.321 7.60495H12.7407V6.0247C12.7407 5.14925 13.4455 4.44446 14.321 4.44446C15.1964 4.44446 15.9012 5.14925 15.9012 6.0247C15.9012 6.90016 15.1964 7.60495 14.321 7.60495Z",
              fill: n ?? "#2FB67C",
              stroke: "#2FB67C",
              strokeWidth: "0.197531",
              strokeLinecap: "round"
            }
          ),
          /* @__PURE__ */ d.jsx(
            "path",
            {
              id: "path14",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M1.67888 8.39508H3.25913V9.97533C3.25913 10.8508 2.55434 11.5556 1.67888 11.5556C1.47124 11.556 1.26555 11.5154 1.07363 11.4362C0.881701 11.3569 0.70732 11.2405 0.560493 11.0937C0.413665 10.9469 0.297282 10.7725 0.218024 10.5806C0.138766 10.3887 0.0981937 10.183 0.0986364 9.97533C0.0986364 9.09987 0.803426 8.39508 1.67888 8.39508Z",
              fill: n ?? "#E01E5A",
              stroke: "#E01E5A",
              strokeWidth: "0.197531",
              strokeLinecap: "round"
            }
          ),
          /* @__PURE__ */ d.jsx(
            "path",
            {
              id: "path16",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.60483 1.67901V3.25925H6.02459C5.81694 3.25969 5.61125 3.21912 5.41933 3.13986C5.2274 3.06061 5.05302 2.94422 4.9062 2.7974C4.75937 2.65057 4.64298 2.47619 4.56373 2.28426C4.48447 2.09234 4.4439 1.88665 4.44434 1.67901C4.44434 0.803548 5.14913 0.0987585 6.02459 0.0987585C6.23223 0.0983158 6.43792 0.138888 6.62984 0.218146C6.82177 0.297404 6.99615 0.413787 7.14298 0.560615C7.2898 0.707442 7.40619 0.881823 7.48544 1.07375C7.5647 1.26567 7.60528 1.47136 7.60483 1.67901Z",
              fill: n ?? "#36C5F1",
              stroke: "#36C5F1",
              strokeWidth: "0.197531",
              strokeLinecap: "round"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: "clip0_10939_406962", children: /* @__PURE__ */ d.jsx("rect", { width: "16", height: "16", fill: "white" }) }) })
    ]
  }
), koe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6Zm4 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
      }
    )
  }
), Loe = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 3a1 1 0 0 0 0 2h11a1 1 0 1 0 0-2H3Zm0 4a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2H3Zm0 4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H3Zm10 5a1 1 0 1 0 2 0v-5.586l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 1 0 1.414 1.414L13 10.414V16Z"
      }
    )
  }
), Ioe = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 3a1 1 0 0 0 0 2h11a1 1 0 1 0 0-2H3Zm0 4a1 1 0 0 0 0 2h7a1 1 0 1 0 0-2H3Zm0 4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H3Zm12-3a1 1 0 1 0-2 0v5.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L15 13.586V8Z"
      }
    )
  }
), Hoe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 2a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2H6v1a1 1 0 0 1-2 0V6H3a1 1 0 0 1 0-2h1V3a1 1 0 0 1 1-1Zm0 10a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2H6v1a1 1 0 1 1-2 0v-1H3a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Zm7-10a1 1 0 0 1 .967.744L14.146 7.2 17.5 9.134a1 1 0 0 1 0 1.732l-3.354 1.935-1.18 4.455a1 1 0 0 1-1.933 0L9.854 12.8 6.5 10.866a1 1 0 0 1 0-1.732l3.354-1.935 1.18-4.455A1 1 0 0 1 12 2Z",
        clipRule: "evenodd"
      }
    )
  }
), Zoe = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M18 3a1 1 0 0 0-1.447-.894L8.763 6H5a3 3 0 0 0 0 6h.28l1.771 5.316A1 1 0 0 0 8 18h1a1 1 0 0 0 1-1v-4.382l6.553 3.276A1 1 0 0 0 18 15V3Z"
      }
    )
  }
), Poe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9.049 3.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 0 0 .95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 0 0-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.539 1.118l-2.8-2.034a1 1 0 0 0-1.176 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 0 0-.364-1.118L2.98 9.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 0 0 .951-.69l1.07-3.292Z"
      }
    )
  }
), Noe = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l6.921 6.922c.05.062.105.118.168.167l6.91 6.911a1 1 0 0 0 1.415-1.414l-.675-.675a9.001 9.001 0 0 0-.668-11.982A1 1 0 1 0 14.95 5.05a7.002 7.002 0 0 1 .657 9.143l-1.435-1.435a5.002 5.002 0 0 0-.636-6.294A1 1 0 0 0 12.12 7.88a3 3 0 0 1 .587 3.415l-1.992-1.992a.922.922 0 0 0-.018-.018l-6.99-6.991Zm-.469 5.894a1 1 0 0 0-1.933-.516 9 9 0 0 0 2.331 8.693 1 1 0 0 0 1.414-1.415 6.997 6.997 0 0 1-1.812-6.762ZM7.4 11.5a1 1 0 1 0-1.73 1c.214.371.48.72.795 1.035a1 1 0 0 0 1.414-1.414c-.191-.191-.35-.4-.478-.622Z"
      }
    )
  }
), Voe = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.05 3.636a1 1 0 0 1 0 1.414 7 7 0 0 0 0 9.9 1 1 0 1 1-1.414 1.414 9 9 0 0 1 0-12.728 1 1 0 0 1 1.414 0Zm9.9 0a1 1 0 0 1 1.414 0 9 9 0 0 1 0 12.728 1 1 0 1 1-1.414-1.414 7 7 0 0 0 0-9.9 1 1 0 0 1 0-1.414ZM7.879 6.464a1 1 0 0 1 0 1.414 3 3 0 0 0 0 4.243 1 1 0 1 1-1.414 1.414 5 5 0 0 1 0-7.07 1 1 0 0 1 1.414 0Zm4.242 0a1 1 0 0 1 1.415 0 5 5 0 0 1 0 7.072 1 1 0 0 1-1.415-1.415 3 3 0 0 0 0-4.242 1 1 0 0 1 0-1.415ZM10.001 9a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V10a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Foe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H8Z",
        clipRule: "evenodd"
      }
    )
  }
), Boe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Zm4 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-.464 4.95.707.707a1 1 0 0 0 1.414-1.414l-.707-.707a1 1 0 0 0-1.414 1.414Zm2.121-10.607a1 1 0 0 1 0 1.414l-.707.707a1 1 0 1 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 0ZM17 11a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2h1Zm-7 4a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1ZM5.05 6.464A1 1 0 1 0 6.465 5.05l-.708-.707a1 1 0 0 0-1.414 1.414l.707.707Zm1.414 8.486-.707.707a1 1 0 0 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 1.414ZM4 11a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2h1Z"
      }
    )
  }
), Uoe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-2 0c0 .993-.241 1.929-.668 2.754l-1.524-1.525a3.997 3.997 0 0 0 .078-2.183l1.562-1.562C15.802 8.249 16 9.1 16 10Zm-5.165 3.913 1.58 1.58A5.98 5.98 0 0 1 10 16a5.978 5.978 0 0 1-2.516-.552l1.562-1.562a4.007 4.007 0 0 0 1.789.027Zm-4.677-2.796a4.002 4.002 0 0 1-.041-2.08l-.08.079-1.53-1.532A5.98 5.98 0 0 0 4 10c0 .954.223 1.856.619 2.656l1.54-1.539Zm1.088-6.45A5.974 5.974 0 0 1 10 4c.954 0 1.856.223 2.656.619l-1.539 1.54a4.002 4.002 0 0 0-2.346.033L7.246 4.668ZM12 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Yoe = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 5a1 1 0 1 0 0 2h5.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414L13.586 5H8Zm4 10a1 1 0 1 0 0-2H6.414l1.293-1.293a1 1 0 1 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L6.414 15H12Z"
      }
    )
  }
), $oe = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 12a1 1 0 1 0 2 0V6.414l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L5 6.414V12Zm10-4a1 1 0 1 0-2 0v5.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L15 13.586V8Z"
      }
    )
  }
), Woe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5Zm-1 9v-1h5v2H5a1 1 0 0 1-1-1Zm7 1h4a1 1 0 0 0 1-1v-1h-5v2Zm0-4h5V8h-5v2ZM9 8H4v2h5V8Z",
        clipRule: "evenodd"
      }
    )
  }
), zoe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.707 9.293a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7A.997.997 0 0 1 2 10V5a3 3 0 0 1 3-3h5c.256 0 .512.098.707.293l7 7ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
      }
    )
  }
), qoe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm0 6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6Zm11-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-2Z"
      }
    )
  }
), Goe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm3.293 1.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L7.586 10 5.293 7.707a1 1 0 0 1 0-1.414ZM11 12a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3Z",
        clipRule: "evenodd"
      }
    )
  }
), Koe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M18 9.5a1.5 1.5 0 1 1-3 0v-6a1.5 1.5 0 0 1 3 0v6Zm-4 .167v-5.43a2 2 0 0 0-1.105-1.79l-.05-.025A4 4 0 0 0 11.055 2H5.64a2 2 0 0 0-1.962 1.608l-1.2 6A2 2 0 0 0 4.44 12H8v4a2 2 0 0 0 2 2 1 1 0 0 0 1-1v-.667a4 4 0 0 1 .8-2.4l1.4-1.866a4 4 0 0 0 .8-2.4Z"
      }
    )
  }
), Qoe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 10.5a1.5 1.5 0 1 1 3 0v6a1.5 1.5 0 0 1-3 0v-6Zm4-.167v5.43a2 2 0 0 0 1.106 1.79l.05.025A4 4 0 0 0 8.943 18h5.416a2 2 0 0 0 1.962-1.608l1.2-6A2 2 0 0 0 15.56 8H12V4a2 2 0 0 0-2-2 1 1 0 0 0-1 1v.667a4 4 0 0 1-.8 2.4L6.8 7.933a4 4 0 0 0-.8 2.4Z"
      }
    )
  }
), Xoe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 1 0 0 4v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2a2 2 0 1 0 0-4V6Z"
      }
    )
  }
), Joe = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 14 14",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.3999 3.49998C1.3999 2.72678 2.0267 2.09998 2.7999 2.09998H11.1999C11.9731 2.09998 12.5999 2.72678 12.5999 3.49998C12.5999 4.27317 11.9731 4.89998 11.1999 4.89998H2.7999C2.0267 4.89998 1.3999 4.27317 1.3999 3.49998Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.3999 6.99998C1.3999 6.22678 2.0267 5.59998 2.7999 5.59998H4.1999C4.9731 5.59998 5.5999 6.22678 5.5999 6.99998C5.5999 7.77317 4.9731 8.39997 4.1999 8.39997H2.7999C2.0267 8.39997 1.3999 7.77317 1.3999 6.99998Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.2999 6.99998C6.2999 6.22678 6.9267 5.59998 7.6999 5.59998C8.4731 5.59998 9.0999 6.22678 9.0999 6.99998C9.0999 7.77317 8.4731 8.39997 7.6999 8.39997C6.9267 8.39997 6.2999 7.77317 6.2999 6.99998Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.7999 6.29998C9.7999 5.91338 10.1133 5.59998 10.4999 5.59998C10.8865 5.59998 11.1999 5.91338 11.1999 6.29998V7.69998C11.1999 8.08657 10.8865 8.39997 10.4999 8.39997C10.1133 8.39997 9.7999 8.08657 9.7999 7.69998V6.29998Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.1499 10.5C3.1499 9.72678 3.7767 9.09997 4.5499 9.09997H9.4499C10.2231 9.09997 10.8499 9.72678 10.8499 10.5C10.8499 11.2732 10.2231 11.9 9.4499 11.9H4.5499C3.7767 11.9 3.1499 11.2732 3.1499 10.5Z"
        }
      )
    ]
  }
), eie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 2a1 1 0 0 1 1 1v1h3a1 1 0 1 1 0 2H9.578a18.87 18.87 0 0 1-1.724 4.78c.29.354.596.696.914 1.026a1 1 0 1 1-1.44 1.389 21.034 21.034 0 0 1-.554-.6 19.098 19.098 0 0 1-3.107 3.567 1 1 0 0 1-1.334-1.49 17.087 17.087 0 0 0 3.13-3.733 18.992 18.992 0 0 1-1.487-2.494 1 1 0 1 1 1.79-.89c.234.47.489.928.764 1.372.417-.934.752-1.913.997-2.927H3a1 1 0 1 1 0-2h3V3a1 1 0 0 1 1-1Zm6 6a1 1 0 0 1 .894.553l2.991 5.982a.869.869 0 0 1 .02.037l.99 1.98a1 1 0 1 1-1.79.895L15.383 16h-4.764l-.724 1.447a1 1 0 1 1-1.788-.894l.99-1.98.019-.038 2.99-5.982A1 1 0 0 1 13 8Zm-1.382 6h2.764L13 11.236 11.618 14Z",
        clipRule: "evenodd"
      }
    )
  }
), tie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 2a1 1 0 0 0-.894.553L7.382 4H4a1 1 0 0 0 0 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a1 1 0 1 0 0-2h-3.382l-.724-1.447A1 1 0 0 0 11 2H9ZM7 8a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0V8Zm5-1a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), nie = ({
  size: e = "1em",
  ...n
}) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 13a1 1 0 1 0 0 2h5a1 1 0 0 0 1-1V9a1 1 0 1 0-2 0v2.586l-4.293-4.293a1 1 0 0 0-1.414 0L8 9.586 3.707 5.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0L11 9.414 14.586 13H12Z",
        clipRule: "evenodd"
      }
    )
  }
), rie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 7a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V8.414l-4.293 4.293a1 1 0 0 1-1.414 0L8 10.414l-4.293 4.293a1 1 0 0 1-1.414-1.414l5-5a1 1 0 0 1 1.414 0L11 10.586 14.586 7H12Z",
        clipRule: "evenodd"
      }
    )
  }
), aie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm7 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1.05a2.5 2.5 0 0 1 4.9 0H10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3Zm11 3a1 1 0 0 0-1 1v6.05A2.5 2.5 0 0 1 15.95 16H17a1 1 0 0 0 1-1v-5a1 1 0 0 0-.293-.707l-2-2A1 1 0 0 0 15 7h-1Z"
        }
      )
    ]
  }
), oie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 17a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1ZM6.293 6.707a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L11 5.414V13a1 1 0 1 1-2 0V5.414L7.707 6.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), iie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-7 9a7 7 0 1 1 14 0H3Z"
      }
    )
  }
), lie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a6 6 0 0 1 6 6H2a6 6 0 0 1 6-6Zm8-4a1 1 0 1 0-2 0v1h-1a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1V7Z"
      }
    )
  }
), uie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-6-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-2 4a5 5 0 0 0-4.546 2.916A5.986 5.986 0 0 0 10 16a5.986 5.986 0 0 0 4.546-2.084A5 5 0 0 0 10 11Z",
        clipRule: "evenodd"
      }
    )
  }
), sie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M13 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm5 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-4 7a4 4 0 0 0-8 0v3h8v-3ZM6 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm10 10v-3a5.972 5.972 0 0 0-.75-2.906A3.005 3.005 0 0 1 19 15v3h-3ZM4.75 12.094A5.973 5.973 0 0 0 4 15v3H1v-3a3 3 0 0 1 3.75-2.906Z"
      }
    )
  }
), cie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 11a6 6 0 0 0-12 0h12Zm-1-9a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
      }
    )
  }
), fie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm8 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-4.07 11c.046-.327.07-.66.07-1a6.97 6.97 0 0 0-1.5-4.33A5 5 0 0 1 19 16v1h-6.07ZM6 11a5 5 0 0 1 5 5v1H1v-1a5 5 0 0 1 5-5Z"
      }
    )
  }
), die = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.649 3.084A1 1 0 0 1 5.163 4.4 13.95 13.95 0 0 0 4 10c0 1.993.416 3.886 1.164 5.6a1 1 0 0 1-1.832.8A15.95 15.95 0 0 1 2 10c0-2.274.475-4.44 1.332-6.4a1 1 0 0 1 1.317-.516ZM12.961 7a3 3 0 0 0-2.342 1.126l-.328.41-.111-.279A2 2 0 0 0 8.323 7H8a1 1 0 0 0 0 2h.323l.532 1.33-1.035 1.295a1 1 0 0 1-.781.375H7a1 1 0 1 0 0 2h.039a3 3 0 0 0 2.342-1.126l.328-.41.111.279A2 2 0 0 0 11.677 14H12a1 1 0 1 0 0-2h-.323l-.532-1.33 1.035-1.295A1 1 0 0 1 12.961 9H13a1 1 0 1 0 0-2h-.039Zm1.874-2.6a1 1 0 0 1 1.833-.8A15.95 15.95 0 0 1 18 10c0 2.274-.475 4.44-1.332 6.4a1 1 0 1 1-1.832-.8A13.949 13.949 0 0 0 16 10c0-1.993-.416-3.886-1.165-5.6Z"
      }
    )
  }
), hie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Zm12.553 1.106A1 1 0 0 0 14 8v4a1 1 0 0 0 .553.894l2 1A1 1 0 0 0 18 13V7a1 1 0 0 0-1.447-.894l-2 1Z"
      }
    )
  }
), vie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4Zm6 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V4Zm7-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-2Z"
      }
    )
  }
), pie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm0 8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H5Zm6-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V5Zm0 8a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2Z"
      }
    )
  }
), mie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm0 8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H5Zm6-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V5Zm3 6a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z"
      }
    )
  }
), gie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), wie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.383 3.076A1 1 0 0 1 10 4v12a1 1 0 0 1-1.707.707L4.586 13H2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h2.586l3.707-3.707a1 1 0 0 1 1.09-.217Zm2.91 4.217a1 1 0 0 1 1.414 0L15 8.586l1.293-1.293a1 1 0 1 1 1.414 1.414L16.414 10l1.293 1.293a1 1 0 0 1-1.414 1.414L15 11.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L13.586 10l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), yie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.383 3.076A1 1 0 0 1 10 4v12a1 1 0 0 1-1.707.707L4.586 13H2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h2.586l3.707-3.707a1 1 0 0 1 1.09-.217Zm5.274-.147a1 1 0 0 1 1.414 0A9.972 9.972 0 0 1 19 10a9.972 9.972 0 0 1-2.929 7.071 1 1 0 0 1-1.414-1.414A7.971 7.971 0 0 0 17 10a7.97 7.97 0 0 0-2.343-5.657 1 1 0 0 1 0-1.414Zm-2.829 2.828a1 1 0 0 1 1.415 0A5.983 5.983 0 0 1 15 10a5.984 5.984 0 0 1-1.757 4.243 1 1 0 0 1-1.415-1.415A3.984 3.984 0 0 0 13 10a3.983 3.983 0 0 0-1.172-2.828 1 1 0 0 1 0-1.415Z",
        clipRule: "evenodd"
      }
    )
  }
), xie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.778 8.222c-4.296-4.296-11.26-4.296-15.556 0A1 1 0 0 1 .808 6.808c5.076-5.077 13.308-5.077 18.384 0a1 1 0 0 1-1.414 1.414ZM14.95 11.05a7 7 0 0 0-9.9 0 1 1 0 0 1-1.414-1.414 9 9 0 0 1 12.728 0 1 1 0 0 1-1.414 1.414Zm-2.83 2.83a3 3 0 0 0-4.242 0 1 1 0 0 1-1.415-1.415 5 5 0 0 1 7.072 0 1 1 0 0 1-1.415 1.415ZM9 16a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), IT = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 4.293a1 1 0 0 1 1.414 0L10 8.586l4.293-4.293a1 1 0 1 1 1.414 1.414L11.414 10l4.293 4.293a1 1 0 0 1-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 0 1-1.414-1.414L8.586 10 4.293 5.707a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), HT = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.707 7.293a1 1 0 0 0-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 1 0 1.414 1.414L10 11.414l1.293 1.293a1 1 0 0 0 1.414-1.414L11.414 10l1.293-1.293a1 1 0 0 0-1.414-1.414L10 8.586 8.707 7.293Z",
        clipRule: "evenodd"
      }
    )
  }
), Sie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5 8a1 1 0 0 1 1-1h1V6a1 1 0 0 1 2 0v1h1a1 1 0 1 1 0 2H9v1a1 1 0 1 1-2 0V9H6a1 1 0 0 1-1-1Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 8a6 6 0 1 1 10.89 3.476l4.817 4.817a1 1 0 0 1-1.414 1.414l-4.816-4.816A6 6 0 0 1 2 8Zm6-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Cie = ({ size: e = "1em", ...n }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM2 8a6 6 0 1 1 10.89 3.476l4.817 4.817a1 1 0 0 1-1.414 1.414l-4.816-4.816A6 6 0 0 1 2 8Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 8a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
var $U = Xo({ defaultClassName: "_1gg22ys2", variantClassNames: { kind: { info: "_1gg22ys3", error: "_1gg22ys4", warning: "_1gg22ys5" }, border: { true: "_1gg22ys6 _1gg22ys0 _1faqfmvf9 _1faqfmv6", false: "_1gg22ys7 _1gg22ys1" } }, defaultVariants: { kind: "info", border: !0 }, compoundVariants: [] });
const WU = {
  error: nh.theme.static.surface.sentiment.bad,
  info: nh.theme.static.surface.sentiment.neutral,
  warning: nh.theme.static.surface.sentiment.caution
}, zU = {
  error: nh.theme.static.content.sentiment.bad,
  info: nh.theme.static.content.weak,
  warning: nh.theme.static.content.sentiment.caution
}, bie = ({
  children: e,
  kind: n = "info",
  title: a,
  icon: i,
  border: h,
  style: g = {},
  width: m,
  handleCloseClick: S
}) => {
  const b = i || qU[n];
  return /* @__PURE__ */ d.jsxs(
    Rt,
    {
      p: "8",
      gap: "8",
      display: "flex",
      alignItems: "flex-start",
      borderRadius: "8",
      border: "secondary",
      cssClass: $U({ kind: n, border: h }),
      justifyContent: "space-between",
      style: {
        ...g,
        width: m || "auto"
      },
      children: [
        i !== !1 && /* @__PURE__ */ d.jsx(
          Rt,
          {
            alignItems: "center",
            alignSelf: "flex-start",
            borderRadius: "5",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            style: {
              backgroundColor: WU[n],
              height: 22,
              width: 22
            },
            children: /* @__PURE__ */ d.jsx(b, { size: 14, color: zU[n] })
          }
        ),
        /* @__PURE__ */ d.jsxs(Rt, { gap: "16", display: "flex", flexDirection: "column", width: "full", children: [
          a && /* @__PURE__ */ d.jsxs(Rt, { display: "flex", position: "relative", children: [
            /* @__PURE__ */ d.jsx(Rt, { mt: "6", children: /* @__PURE__ */ d.jsx(ma, { color: "strong", weight: "bold", size: "small", children: a }) }),
            S && /* @__PURE__ */ d.jsx(
              Rt,
              {
                flexShrink: 0,
                style: { position: "absolute", right: "0" },
                children: /* @__PURE__ */ d.jsx(
                  L8,
                  {
                    kind: "secondary",
                    emphasis: "low",
                    shape: "square",
                    size: "minimal",
                    icon: /* @__PURE__ */ d.jsx(IT, { size: 16 }),
                    onClick: S
                  }
                )
              }
            )
          ] }),
          e
        ] })
      ]
    }
  );
}, qU = {
  error: HT,
  info: UU,
  warning: BU
};
var GU = Xo({ defaultClassName: "_1kudzuf6", variantClassNames: { size: { small: "_1kudzuf7 _1kudzuf0 _1faqfmv2o", medium: "_1kudzuf8 _1kudzuf1 _1faqfmv2t", large: "_1kudzuf9 _1kudzuf2 _1faqfmv2u" }, border: { none: "_1kudzufa", primary: "_1kudzufb _1kudzuf3 _1faqfmvez", secondary: "_1kudzufc _1kudzuf4 _1faqfmvf9" }, rounded: { true: "_1kudzufd _1kudzuf5 _1faqfmv5", false: "_1kudzufe" } }, defaultVariants: { border: "secondary", rounded: !0, size: "medium" }, compoundVariants: [] });
const _ie = ({ children: e, ...n }) => /* @__PURE__ */ d.jsx(Rt, { cssClass: GU({ ...n }), children: e });
var KU = "_45t5730", QU = "_45t5731", XU = $k({ conditions: { defaultCondition: "mobile", conditionNames: ["mobile", "tablet", "desktop", "wide"], responsiveArray: void 0 }, styles: { flex: { values: { 1: { conditions: { mobile: "_45t5732", tablet: "_45t5733", desktop: "_45t5734", wide: "_45t5735" }, defaultClass: "_45t5732" }, 2: { conditions: { mobile: "_45t5736", tablet: "_45t5737", desktop: "_45t5738", wide: "_45t5739" }, defaultClass: "_45t5736" }, 3: { conditions: { mobile: "_45t573a", tablet: "_45t573b", desktop: "_45t573c", wide: "_45t573d" }, defaultClass: "_45t573a" }, 4: { conditions: { mobile: "_45t573e", tablet: "_45t573f", desktop: "_45t573g", wide: "_45t573h" }, defaultClass: "_45t573e" }, 5: { conditions: { mobile: "_45t573i", tablet: "_45t573j", desktop: "_45t573k", wide: "_45t573l" }, defaultClass: "_45t573i" }, 6: { conditions: { mobile: "_45t573m", tablet: "_45t573n", desktop: "_45t573o", wide: "_45t573p" }, defaultClass: "_45t573m" }, 7: { conditions: { mobile: "_45t573q", tablet: "_45t573r", desktop: "_45t573s", wide: "_45t573t" }, defaultClass: "_45t573q" }, 8: { conditions: { mobile: "_45t573u", tablet: "_45t573v", desktop: "_45t573w", wide: "_45t573x" }, defaultClass: "_45t573u" }, 9: { conditions: { mobile: "_45t573y", tablet: "_45t573z", desktop: "_45t57310", wide: "_45t57311" }, defaultClass: "_45t573y" }, 10: { conditions: { mobile: "_45t57312", tablet: "_45t57313", desktop: "_45t57314", wide: "_45t57315" }, defaultClass: "_45t57312" }, 11: { conditions: { mobile: "_45t57316", tablet: "_45t57317", desktop: "_45t57318", wide: "_45t57319" }, defaultClass: "_45t57316" }, 12: { conditions: { mobile: "_45t5731a", tablet: "_45t5731b", desktop: "_45t5731c", wide: "_45t5731d" }, defaultClass: "_45t5731a" }, auto: { conditions: { mobile: "_45t5731e", tablet: "_45t5731f", desktop: "_45t5731g", wide: "_45t5731h" }, defaultClass: "_45t5731e" } } } } }), cR = { mobile: { 0: "_45t5731i", 1: "_45t5731j", 2: "_45t5731k", 3: "_45t5731l", 4: "_45t5731m", 6: "_45t5731n", 7: "_45t5731o", 8: "_45t5731p", 9: "_45t5731q", 10: "_45t5731r", 12: "_45t5731s", 16: "_45t5731t", 20: "_45t5731u", 24: "_45t5731v", 28: "_45t5731w", 32: "_45t5731x", 36: "_45t5731y", 40: "_45t5731z", 44: "_45t57320", 48: "_45t57321" }, tablet: { 0: "_45t57322", 1: "_45t57323", 2: "_45t57324", 3: "_45t57325", 4: "_45t57326", 6: "_45t57327", 7: "_45t57328", 8: "_45t57329", 9: "_45t5732a", 10: "_45t5732b", 12: "_45t5732c", 16: "_45t5732d", 20: "_45t5732e", 24: "_45t5732f", 28: "_45t5732g", 32: "_45t5732h", 36: "_45t5732i", 40: "_45t5732j", 44: "_45t5732k", 48: "_45t5732l" }, desktop: { 0: "_45t5732m", 1: "_45t5732n", 2: "_45t5732o", 3: "_45t5732p", 4: "_45t5732q", 6: "_45t5732r", 7: "_45t5732s", 8: "_45t5732t", 9: "_45t5732u", 10: "_45t5732v", 12: "_45t5732w", 16: "_45t5732x", 20: "_45t5732y", 24: "_45t5732z", 28: "_45t57330", 32: "_45t57331", 36: "_45t57332", 40: "_45t57333", 44: "_45t57334", 48: "_45t57335" }, wide: { 0: "_45t57336", 1: "_45t57337", 2: "_45t57338", 3: "_45t57339", 4: "_45t5733a", 6: "_45t5733b", 7: "_45t5733c", 8: "_45t5733d", 9: "_45t5733e", 10: "_45t5733f", 12: "_45t5733g", 16: "_45t5733h", 20: "_45t5733i", 24: "_45t5733j", 28: "_45t5733k", 32: "_45t5733l", 36: "_45t5733m", 40: "_45t5733n", 44: "_45t5733o", 48: "_45t5733p" } };
const JU = (e) => {
  switch (typeof e) {
    case "object":
      return Wk.map(
        (n) => cR[n][e[n]]
      ).join(" ");
    case "string":
      return cR.mobile[e];
    default:
      return "";
  }
}, ZT = Ma.createContext({
  gap: "0"
}), eY = ({ children: e, gap: n }) => /* @__PURE__ */ d.jsx(ZT.Provider, { value: { gap: n ?? "0" }, children: /* @__PURE__ */ d.jsx(Rt, { cssClass: zr(KU, JU(n)), children: e }) }), tY = ({
  children: e,
  span: n = "auto"
}) => {
  const { gap: a } = Ma.useContext(ZT);
  return /* @__PURE__ */ d.jsx(
    Rt,
    {
      cssClass: zr(
        QU,
        XU({ flex: n }),
        Y9({ pl: a, pt: a })
      ),
      children: e
    }
  );
};
tY.Container = eY;
const Rie = J4, h3 = Ma.forwardRef(({ children: e, ...n }, a) => /* @__PURE__ */ d.jsx(tw, { ref: a, ...n, children: e })), nY = ({ children: e, ...n }) => (n.gutter = n.gutter ?? 4, /* @__PURE__ */ d.jsxs(PM, { ...n, children: [
  /* @__PURE__ */ d.jsx(qp, { size: 0 }),
  e
] })), rY = ({ children: e, ...n }) => /* @__PURE__ */ d.jsx(N4, { ...n, children: e }), aY = ({ children: e, ...n }) => /* @__PURE__ */ d.jsx(EM, { ...n, children: e }), oY = ({ children: e, ...n }) => /* @__PURE__ */ d.jsx(RM, { ...n, children: e });
h3.Popover = nY;
h3.Item = rY;
h3.Group = aY;
h3.GroupLabel = oY;
var iY = "_1lamavh0", lY = "_1lamavh1", uY = "_1lamavh2", sY = "_1lamavh3", cY = "_1lamavh4", fY = "_1lamavh5", dY = "_1lamavh6", H9 = "_1lamavh7", fR = "_1lamavh8", hY = "_1lamavh9";
const Eie = ({
  label: e,
  icon: n,
  value: a,
  valueRender: i,
  options: h,
  onChange: g,
  onChangeQuery: m,
  onClose: S,
  queryPlaceholder: b,
  cssClass: R,
  wrapperCssClass: D,
  popoverCssClass: T,
  creatableRender: A,
  defaultOpen: j,
  disabled: I,
  loadingRender: Z,
  emptyStateRender: N
}) => {
  const B = typeof a == "object", $ = J4({
    setValue: (me) => {
      m == null || m(me);
    },
    resetValueOnHide: !0,
    defaultOpen: j
  }), W = Gp({
    combobox: $,
    setValue: (me) => {
      g(me), B && j && $.setOpen(!1);
    },
    value: a
  }), z = new Set(a), Y = $.useState("value"), ie = h === void 0, G = Y !== void 0 && Y !== "" && A !== void 0 ? [{ key: Y, render: A(Y) }] : [], pe = B && A ? a.filter((me) => me !== Y).map((me) => ({ key: me, render: A(me) })) : [], J = G.concat(pe).concat(h ?? []);
  return /* @__PURE__ */ d.jsxs("div", { className: zr(D), children: [
    /* @__PURE__ */ d.jsx(mw, { store: W, className: iY, children: e }),
    /* @__PURE__ */ d.jsxs(
      f3,
      {
        store: W,
        className: zr([lY, R]),
        disabled: I,
        children: [
          n,
          i && /* @__PURE__ */ d.jsx(ma, { size: "xSmall", color: "secondaryContentText", lines: "1", children: i })
        ]
      }
    ),
    /* @__PURE__ */ d.jsxs(
      gw,
      {
        store: W,
        className: zr([dY, T]),
        gutter: 4,
        autoFocusOnHide: !1,
        onClose: S,
        children: [
          /* @__PURE__ */ d.jsx(qp, { size: 0 }),
          m !== void 0 && /* @__PURE__ */ d.jsxs(
            "div",
            {
              className: zr(sY, {
                [cY]: J.length > 0 || ie || !!N
              }),
              children: [
                /* @__PURE__ */ d.jsx(kT, {}),
                /* @__PURE__ */ d.jsx(
                  tw,
                  {
                    store: $,
                    type: "text",
                    autoSelect: !0,
                    autoComplete: "none",
                    placeholder: b,
                    className: uY
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ d.jsxs(
            u8,
            {
              store: $,
              className: zr([fY, "hide-scrollbar"]),
              children: [
                ie && /* @__PURE__ */ d.jsx(
                  "div",
                  {
                    className: zr([
                      H9,
                      fR
                    ]),
                    children: Z
                  }
                ),
                N && !ie && J.length === 0 && /* @__PURE__ */ d.jsx(
                  "div",
                  {
                    className: zr([
                      H9,
                      fR
                    ]),
                    children: N
                  }
                ),
                W.useState("open") && J.map((me) => /* @__PURE__ */ d.jsx(
                  N4,
                  {
                    focusOnHover: !0,
                    className: H9,
                    render: /* @__PURE__ */ d.jsxs(pw, { value: me.key, children: [
                      B && /* @__PURE__ */ d.jsx(
                        "div",
                        {
                          className: hY,
                          style: {
                            backgroundColor: z.has(me.key) ? nh.theme.interactive.fill.primary.enabled : "white"
                          },
                          children: /* @__PURE__ */ d.jsx(I8, { color: "white" })
                        }
                      ),
                      me.render
                    ] })
                  },
                  me.key
                ))
              ]
            }
          )
        ]
      }
    )
  ] });
};
var vY = "_821rm91", pY = "_821rm92";
const Mie = ({
  children: e,
  centered: n = !0,
  padded: a = !0,
  ...i
}) => /* @__PURE__ */ d.jsx(Rt, { cssClass: vY, children: /* @__PURE__ */ d.jsx(
  Rt,
  {
    cssClass: pY,
    px: a ? "20" : void 0,
    mx: n ? "auto" : void 0,
    ...i,
    children: e
  }
) }), P0 = (e, n, ...a) => !e || n == null ? /* @__PURE__ */ new Date() : new Date(e, n, ...a), _1 = (e) => ({
  D: e.getDate(),
  M: e.getMonth(),
  Y: e.getFullYear()
}), mY = (e) => e.getDay(), qo = (e) => P0(_1(e).Y, _1(e).M, _1(e).D), fx = (e) => P0(_1(e).Y, _1(e).M + 1, 0).getDate(), Lp = (e, n, a) => {
  const { Y: i, M: h, D: g } = _1(e), m = a === "date" ? g + n : a === "month" && g > fx(P0(i, h + n, 1)) ? fx(P0(i, h + n, 1)) : g;
  return P0(i + (a === "year" ? n : 0), h + (a === "month" ? n : 0), m);
}, dR = (e, n, a) => Lp(e, 0 - n, a), PT = (e, n) => +e - +n, _5 = (e, n, a) => e.toLocaleDateString(n, a), gY = (e, { locale: n, monthName: a }) => _5(e, n, { month: a }), hR = (e, n) => e.concat(n).sort(PT), vR = (e, n, a) => {
  let [i, h] = [e, n];
  return e && n && ([i, h] = [e, n].sort(a)), [i, h];
}, wY = (e, n) => n ? n.includes(e) : !1, yY = (e, n = []) => {
  const { M: a, D: i } = _1(e);
  return n.some((h) => {
    const { M: g, D: m } = _1(h);
    return a === g && i === m;
  });
}, xY = (e, { day: n, date: a } = {}) => wY(e.getDay(), n) || yY(e, a);
var SY = 42;
function pR(e, n) {
  return (mY(e) + 7 - n) % 7;
}
function CY(e, n, { mode: a, startDay: i }) {
  const h = P0(n, e, 1), g = fx(h), m = pR(h, i), S = a === "static" ? SY : m + g + 6 - pR(P0(n, e, g), i);
  return {
    start: m,
    length: S
  };
}
const Tu = (e, n) => +e == +n, R5 = (e, n) => e < n, dx = (e, n) => e > n, mR = (e, n, a) => dx(n, e) && R5(n, a) || R5(n, e) && dx(n, a), F4 = (e, n) => !!e && dx(n, e), B4 = (e, n) => !!e && R5(n, e), yw = (e, n) => e.some((a) => Tu(qo(a), qo(n)));
var gR = {
  mode: "static",
  offsets: [0],
  startDay: 0
}, bY = {
  mode: "decade",
  /*
   * The default value for the numberOfYears is 12
   * it consists of 10 years + 1 year before + 1 year after
   */
  numberOfYears: 12,
  step: 10
}, _Y = {
  mode: "single",
  toggle: !1,
  selectSameDate: !1
}, RY = {
  interval: 30,
  useLocales: !1
}, EY = {
  locale: "en-GB",
  day: "2-digit",
  year: "numeric",
  weekday: "short",
  monthName: "long",
  hour: "2-digit",
  minute: "2-digit",
  hour12: void 0,
  second: void 0
};
function MY({ selectedDates: e = [], onDatesChange: n, focusDate: a, offsetDate: i, onOffsetChange: h, calendar: g = {}, dates: m = {}, locale: S, time: b = {}, exclude: R = {}, years: D }) {
  const { minDate: T, maxDate: A, ...j } = m, { offsets: I = [], ...Z } = g, { minTime: N, maxTime: B, ...$ } = b, [W, z] = vR(T, A, PT), [Y, ie] = vR(N, B, (pe, J) => pe.h - J.h), G = a && yw(e, a) ? a : void 0;
  return {
    selectedDates: e,
    onDatesChange: n,
    offsetDate: i,
    onOffsetChange: h,
    focusDate: G,
    calendar: {
      ...gR,
      ...Z,
      offsets: gR.offsets.concat(I)
    },
    years: { ...bY, ...D },
    dates: {
      ..._Y,
      ...j,
      minDate: W && qo(W),
      maxDate: z && qo(z)
    },
    locale: {
      ...EY,
      ...S
    },
    time: {
      ...RY,
      minTime: Y,
      maxTime: ie,
      ...$
    },
    exclude: R
  };
}
function L4(e) {
  return e === "range";
}
const wR = "range-start", yR = "range-end", xR = "will-be-range-start", SR = "will-be-range-end", TY = (e, n, a, i) => {
  if (!L4(i) || a.length === 0)
    return "";
  const [h, g] = a;
  return h && g ? Tu(e, qo(h)) ? Tu(qo(h), qo(g)) ? `${wR} ${yR}` : wR : Tu(e, qo(g)) ? yR : mR(qo(h), e, qo(g)) ? "in-range" : "" : !g && n ? mR(qo(h), e, n) ? "will-be-in-range" : R5(n, qo(h)) ? Tu(e, n) ? xR : Tu(e, qo(h)) ? SR : "" : Tu(e, qo(h)) ? xR : Tu(e, n) ? SR : "" : "";
}, OY = (e, n, a, { rangeEnd: i }, h) => {
  const { dates: { mode: g, minDate: m, maxDate: S }, locale: b, calendar: R, exclude: D } = h, { locale: T, day: A, year: j } = b, { M: I, Y: Z } = _1(n), { start: N, length: B } = CY(I, Z, R), $ = Array(B).fill(0).map((W, z) => {
    const Y = P0(Z, I, z + 1 - N);
    return {
      $date: Y,
      active: Tu(e, Y),
      day: _5(Y, T, { day: A }),
      now: Tu(qo(P0()), Y),
      range: TY(Y, i, a, g),
      disabled: B4(m, Y) || F4(S, Y) || xY(Y, D),
      selected: yw(a, Y),
      inCurrentMonth: _1(Y).M === I
    };
  });
  return {
    year: _5(n, T, { year: j }),
    month: gY(n, b),
    days: $
  };
}, DY = ({ selectedDates: e, state: n, config: a, offsetDate: i }) => a.calendar.offsets.map((h) => OY(i, Lp(i, h, "month"), e, n, a));
var AY = ({ days: e }, { locale: { locale: n, weekday: a } }) => [0, 1, 2, 3, 4, 5, 6].map((i) => _5(e[i].$date, n, { weekday: a }));
const jY = (e) => {
  const n = DY(e);
  return qr(() => ({
    calendars: n,
    weekDays: AY(n[0], e.config)
  }), [n, e.config]);
}, u5 = (...e) => (...n) => e.forEach((a) => a == null ? void 0 : a(...n)), s5 = (e) => (n, a) => e(a), c5 = (e, n, a = {}, i = !1) => ({
  role: "button",
  tabIndex: 0,
  ...e ? {
    disabled: !0,
    "aria-disabled": !0
  } : {
    onClick(h) {
      n(h);
    }
  },
  ...i ? { "aria-selected": !0 } : {},
  ...a
});
var NT = "SET_FOCUS_DATE", VT = "SET_OFFSET_DATE", FT = "SET_RANGE_END", kY = "SET_YEAR", LY = (e, n) => {
  switch (n.type) {
    case NT:
      return {
        ...e,
        focusDate: n.date
      };
    case VT:
      return {
        ...e,
        offsetDate: n.date
      };
    case FT:
      return {
        ...e,
        rangeEnd: n.date
      };
    case kY:
      return {
        ...e,
        offsetYear: n.year
      };
    default:
      return e;
  }
}, CR = (e, n) => {
  e({ type: NT, date: n });
}, IY = (e, n) => {
  e({ type: VT, date: n });
}, bR = (e, n) => {
  e({ type: FT, date: n });
};
const Z9 = ({ dispatch: e, config: { onOffsetChange: n, offsetDate: a } }) => (i) => {
  !n && !a && IY(e, i), n && n(i);
}, _R = (e, { days: n, months: a, years: i }) => {
  let h = e;
  return n && n !== 0 && (h = Lp(h, n, "date")), a && a !== 0 && (h = Lp(h, a, "month")), i && i !== 0 && (h = Lp(h, i, "year")), h;
}, RR = (e, { days: n = 0, months: a = 0, years: i = 0 }, h) => !h || Tu(e, h) ? e : n !== 0 ? P9(e, h, n, "date") : a !== 0 ? P9(e, h, a, "month") : i !== 0 ? P9(e, h, i, "year") : e, P9 = (e, n, a, i) => {
  const h = Lp(e, a, i);
  return a > 0 ? F4(n, h) ? dR(n, a, i) : e : B4(n, h) ? dR(n, a, i) : e;
}, HY = (e) => {
  const { config: { dates: n } } = e, { minDate: a, maxDate: i } = n, h = Pr((S, { disabled: b, onClick: R, ...D } = {}) => {
    const T = RR(e.offsetDate, S, i), A = _R(T, S), j = !!b || F4(i, A);
    return c5(j, (I) => u5(R, s5(Z9(e)))(I, A), D);
  }, [i, e]), g = Pr(({ days: S = 0, months: b = 0, years: R = 0 }, { disabled: D, onClick: T, ...A } = {}) => {
    const j = {
      days: -S,
      months: -b,
      years: -R
    }, I = RR(e.offsetDate, j, a), Z = _R(I, j), N = !!D || B4(a, Z);
    return c5(N, (B) => u5(T, s5(Z9(e)))(B, Z), A);
  }, [a, e]), m = Pr((S, { disabled: b, onClick: R, ...D } = {}) => {
    const T = !!b || B4(a, S) || F4(i, S);
    return c5(T, (A) => u5(R, s5(Z9(e)))(A, S), D);
  }, [e, i, a]);
  return {
    addOffset: h,
    setOffset: m,
    subtractOffset: g
  };
}, ZY = (e, n, a) => F4(n, a) ? n : B4(e, a) ? e : a, PY = (e) => e - e % 10 - 1, NY = (e, n) => e - (n / 2 - (n % 2 === 0 ? 1 : 0)), VY = (e, n) => e - n + 1, FY = (e) => e === "exact", BY = (e, { mode: n, numberOfYears: a }) => FY(n) ? VY(e, a) : n === "decade" ? PY(e) : NY(e, a), UY = (e) => {
  const { selectedDates: n, offsetDate: a, focusDate: i, dates: { minDate: h, maxDate: g }, years: m } = e, S = a || (n.length > 0 ? n[n.length - 1] : ZY(h, g, qo(P0())));
  return {
    focusDate: i,
    rangeEnd: null,
    offsetDate: S,
    offsetYear: BY(_1(S).Y, m)
  };
}, YY = (e) => {
  const n = MY(e), [a, i] = tE(LY, UY(n));
  return {
    dispatch: i,
    selectedDates: n.selectedDates,
    offsetDate: n.offsetDate || a.offsetDate,
    state: a,
    config: n
  };
}, $Y = (e, n, { mode: a, toggle: i, limit: h }) => i && yw(e, n) ? e.filter((g) => !Tu(qo(g), n)) : a === "multiple" ? !h || e.length < h ? hR(e, n) : e : L4(a) ? e.length === 2 ? [n] : hR(e, n) : [n], WY = ({ config: e, selectedDates: n, dispatch: a }) => {
  const { onDatesChange: i, dates: { mode: h, toggle: g, selectSameDate: m } } = e;
  return { dayButton: Pr(({ $date: b, selected: R, disabled: D, active: T }, { onClick: A, disabled: j, ...I } = {}) => c5(D || !!j, (Z) => {
    R && !g && (n.forEach((N) => {
      Tu(qo(N), b) && CR(a, N);
    }), !L4(h) || !m) || (L4(h) && n.length === 1 && bR(a, null), u5(A, s5((N) => {
      const B = $Y(n, N, e.dates);
      CR(a, yw(B, N) ? N : void 0), i(B);
    }))(Z, b));
  }, {
    ...I,
    ...L4(h) && n.length === 1 && {
      onMouseEnter() {
        bR(a, b);
      }
    },
    tabIndex: T ? 0 : -1
  }, R), [
    h,
    g,
    e.dates,
    i,
    n,
    a,
    m
  ]) };
};
Za({});
var BT = Za({}), Z8 = () => Qo(BT), zY = ({ children: e, config: n }) => Ma.createElement(BT.Provider, { value: YY(n) }, e);
const UT = () => jY(Z8()), qY = () => WY(Z8()), GY = () => HY(Z8());
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var YT;
function Xe() {
  return YT.apply(null, arguments);
}
function KY(e) {
  YT = e;
}
function E1(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function T2(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function ur(e, n) {
  return Object.prototype.hasOwnProperty.call(e, n);
}
function P8(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var n;
  for (n in e)
    if (ur(e, n))
      return !1;
  return !0;
}
function $l(e) {
  return e === void 0;
}
function gf(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function v3(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function $T(e, n) {
  var a = [], i, h = e.length;
  for (i = 0; i < h; ++i)
    a.push(n(e[i], i));
  return a;
}
function Jd(e, n) {
  for (var a in n)
    ur(n, a) && (e[a] = n[a]);
  return ur(n, "toString") && (e.toString = n.toString), ur(n, "valueOf") && (e.valueOf = n.valueOf), e;
}
function U0(e, n, a, i) {
  return pO(e, n, a, i, !0).utc();
}
function QY() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function vn(e) {
  return e._pf == null && (e._pf = QY()), e._pf;
}
var hx;
Array.prototype.some ? hx = Array.prototype.some : hx = function(e) {
  var n = Object(this), a = n.length >>> 0, i;
  for (i = 0; i < a; i++)
    if (i in n && e.call(this, n[i], i, n))
      return !0;
  return !1;
};
function N8(e) {
  if (e._isValid == null) {
    var n = vn(e), a = hx.call(n.parsedDateParts, function(h) {
      return h != null;
    }), i = !isNaN(e._d.getTime()) && n.overflow < 0 && !n.empty && !n.invalidEra && !n.invalidMonth && !n.invalidWeekday && !n.weekdayMismatch && !n.nullInput && !n.invalidFormat && !n.userInvalidated && (!n.meridiem || n.meridiem && a);
    if (e._strict && (i = i && n.charsLeftOver === 0 && n.unusedTokens.length === 0 && n.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = i;
    else
      return i;
  }
  return e._isValid;
}
function xw(e) {
  var n = U0(NaN);
  return e != null ? Jd(vn(n), e) : vn(n).userInvalidated = !0, n;
}
var ER = Xe.momentProperties = [], N9 = !1;
function V8(e, n) {
  var a, i, h, g = ER.length;
  if ($l(n._isAMomentObject) || (e._isAMomentObject = n._isAMomentObject), $l(n._i) || (e._i = n._i), $l(n._f) || (e._f = n._f), $l(n._l) || (e._l = n._l), $l(n._strict) || (e._strict = n._strict), $l(n._tzm) || (e._tzm = n._tzm), $l(n._isUTC) || (e._isUTC = n._isUTC), $l(n._offset) || (e._offset = n._offset), $l(n._pf) || (e._pf = vn(n)), $l(n._locale) || (e._locale = n._locale), g > 0)
    for (a = 0; a < g; a++)
      i = ER[a], h = n[i], $l(h) || (e[i] = h);
  return e;
}
function p3(e) {
  V8(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), N9 === !1 && (N9 = !0, Xe.updateOffset(this), N9 = !1);
}
function M1(e) {
  return e instanceof p3 || e != null && e._isAMomentObject != null;
}
function WT(e) {
  Xe.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function Ts(e, n) {
  var a = !0;
  return Jd(function() {
    if (Xe.deprecationHandler != null && Xe.deprecationHandler(null, e), a) {
      var i = [], h, g, m, S = arguments.length;
      for (g = 0; g < S; g++) {
        if (h = "", typeof arguments[g] == "object") {
          h += `
[` + g + "] ";
          for (m in arguments[0])
            ur(arguments[0], m) && (h += m + ": " + arguments[0][m] + ", ");
          h = h.slice(0, -2);
        } else
          h = arguments[g];
        i.push(h);
      }
      WT(
        e + `
Arguments: ` + Array.prototype.slice.call(i).join("") + `
` + new Error().stack
      ), a = !1;
    }
    return n.apply(this, arguments);
  }, n);
}
var MR = {};
function zT(e, n) {
  Xe.deprecationHandler != null && Xe.deprecationHandler(e, n), MR[e] || (WT(n), MR[e] = !0);
}
Xe.suppressDeprecationWarnings = !1;
Xe.deprecationHandler = null;
function Y0(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function XY(e) {
  var n, a;
  for (a in e)
    ur(e, a) && (n = e[a], Y0(n) ? this[a] = n : this["_" + a] = n);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function vx(e, n) {
  var a = Jd({}, e), i;
  for (i in n)
    ur(n, i) && (T2(e[i]) && T2(n[i]) ? (a[i] = {}, Jd(a[i], e[i]), Jd(a[i], n[i])) : n[i] != null ? a[i] = n[i] : delete a[i]);
  for (i in e)
    ur(e, i) && !ur(n, i) && T2(e[i]) && (a[i] = Jd({}, a[i]));
  return a;
}
function F8(e) {
  e != null && this.set(e);
}
var px;
Object.keys ? px = Object.keys : px = function(e) {
  var n, a = [];
  for (n in e)
    ur(e, n) && a.push(n);
  return a;
};
var JY = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function e$(e, n, a) {
  var i = this._calendar[e] || this._calendar.sameElse;
  return Y0(i) ? i.call(n, a) : i;
}
function F0(e, n, a) {
  var i = "" + Math.abs(e), h = n - i.length, g = e >= 0;
  return (g ? a ? "+" : "" : "-") + Math.pow(10, Math.max(0, h)).toString().substr(1) + i;
}
var B8 = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, n5 = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, V9 = {}, Ip = {};
function Yt(e, n, a, i) {
  var h = i;
  typeof i == "string" && (h = function() {
    return this[i]();
  }), e && (Ip[e] = h), n && (Ip[n[0]] = function() {
    return F0(h.apply(this, arguments), n[1], n[2]);
  }), a && (Ip[a] = function() {
    return this.localeData().ordinal(
      h.apply(this, arguments),
      e
    );
  });
}
function t$(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function n$(e) {
  var n = e.match(B8), a, i;
  for (a = 0, i = n.length; a < i; a++)
    Ip[n[a]] ? n[a] = Ip[n[a]] : n[a] = t$(n[a]);
  return function(h) {
    var g = "", m;
    for (m = 0; m < i; m++)
      g += Y0(n[m]) ? n[m].call(h, e) : n[m];
    return g;
  };
}
function f5(e, n) {
  return e.isValid() ? (n = qT(n, e.localeData()), V9[n] = V9[n] || n$(n), V9[n](e)) : e.localeData().invalidDate();
}
function qT(e, n) {
  var a = 5;
  function i(h) {
    return n.longDateFormat(h) || h;
  }
  for (n5.lastIndex = 0; a >= 0 && n5.test(e); )
    e = e.replace(
      n5,
      i
    ), n5.lastIndex = 0, a -= 1;
  return e;
}
var r$ = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function a$(e) {
  var n = this._longDateFormat[e], a = this._longDateFormat[e.toUpperCase()];
  return n || !a ? n : (this._longDateFormat[e] = a.match(B8).map(function(i) {
    return i === "MMMM" || i === "MM" || i === "DD" || i === "dddd" ? i.slice(1) : i;
  }).join(""), this._longDateFormat[e]);
}
var o$ = "Invalid date";
function i$() {
  return this._invalidDate;
}
var l$ = "%d", u$ = /\d{1,2}/;
function s$(e) {
  return this._ordinal.replace("%d", e);
}
var c$ = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function f$(e, n, a, i) {
  var h = this._relativeTime[a];
  return Y0(h) ? h(e, n, a, i) : h.replace(/%d/i, e);
}
function d$(e, n) {
  var a = this._relativeTime[e > 0 ? "future" : "past"];
  return Y0(a) ? a(n) : a.replace(/%s/i, n);
}
var I4 = {};
function zi(e, n) {
  var a = e.toLowerCase();
  I4[a] = I4[a + "s"] = I4[n] = e;
}
function Os(e) {
  return typeof e == "string" ? I4[e] || I4[e.toLowerCase()] : void 0;
}
function U8(e) {
  var n = {}, a, i;
  for (i in e)
    ur(e, i) && (a = Os(i), a && (n[a] = e[i]));
  return n;
}
var GT = {};
function qi(e, n) {
  GT[e] = n;
}
function h$(e) {
  var n = [], a;
  for (a in e)
    ur(e, a) && n.push({ unit: a, priority: GT[a] });
  return n.sort(function(i, h) {
    return i.priority - h.priority;
  }), n;
}
function Sw(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Es(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function Mn(e) {
  var n = +e, a = 0;
  return n !== 0 && isFinite(n) && (a = Es(n)), a;
}
function Kp(e, n) {
  return function(a) {
    return a != null ? (KT(this, e, a), Xe.updateOffset(this, n), this) : E5(this, e);
  };
}
function E5(e, n) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + n]() : NaN;
}
function KT(e, n, a) {
  e.isValid() && !isNaN(a) && (n === "FullYear" && Sw(e.year()) && e.month() === 1 && e.date() === 29 ? (a = Mn(a), e._d["set" + (e._isUTC ? "UTC" : "") + n](
    a,
    e.month(),
    Mw(a, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + n](a));
}
function v$(e) {
  return e = Os(e), Y0(this[e]) ? this[e]() : this;
}
function p$(e, n) {
  if (typeof e == "object") {
    e = U8(e);
    var a = h$(e), i, h = a.length;
    for (i = 0; i < h; i++)
      this[a[i].unit](e[a[i].unit]);
  } else if (e = Os(e), Y0(this[e]))
    return this[e](n);
  return this;
}
var QT = /\d/, ju = /\d\d/, XT = /\d{3}/, Y8 = /\d{4}/, Cw = /[+-]?\d{6}/, ia = /\d\d?/, JT = /\d\d\d\d?/, eO = /\d\d\d\d\d\d?/, bw = /\d{1,3}/, $8 = /\d{1,4}/, _w = /[+-]?\d{1,6}/, Qp = /\d+/, Rw = /[+-]?\d+/, m$ = /Z|[+-]\d\d:?\d\d/gi, Ew = /Z|[+-]\d\d(?::?\d\d)?/gi, g$ = /[+-]?\d+(\.\d{1,3})?/, m3 = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, M5;
M5 = {};
function bt(e, n, a) {
  M5[e] = Y0(n) ? n : function(i, h) {
    return i && a ? a : n;
  };
}
function w$(e, n) {
  return ur(M5, e) ? M5[e](n._strict, n._locale) : new RegExp(y$(e));
}
function y$(e) {
  return Du(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(n, a, i, h, g) {
        return a || i || h || g;
      }
    )
  );
}
function Du(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var mx = {};
function Ar(e, n) {
  var a, i = n, h;
  for (typeof e == "string" && (e = [e]), gf(n) && (i = function(g, m) {
    m[n] = Mn(g);
  }), h = e.length, a = 0; a < h; a++)
    mx[e[a]] = i;
}
function g3(e, n) {
  Ar(e, function(a, i, h, g) {
    h._w = h._w || {}, n(a, h._w, h, g);
  });
}
function x$(e, n, a) {
  n != null && ur(mx, e) && mx[e](n, a._a, a, e);
}
var Wi = 0, ff = 1, H0 = 2, Lo = 3, b1 = 4, df = 5, M2 = 6, S$ = 7, C$ = 8;
function b$(e, n) {
  return (e % n + n) % n;
}
var eo;
Array.prototype.indexOf ? eo = Array.prototype.indexOf : eo = function(e) {
  var n;
  for (n = 0; n < this.length; ++n)
    if (this[n] === e)
      return n;
  return -1;
};
function Mw(e, n) {
  if (isNaN(e) || isNaN(n))
    return NaN;
  var a = b$(n, 12);
  return e += (n - a) / 12, a === 1 ? Sw(e) ? 29 : 28 : 31 - a % 7 % 2;
}
Yt("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
Yt("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
Yt("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
zi("month", "M");
qi("month", 8);
bt("M", ia);
bt("MM", ia, ju);
bt("MMM", function(e, n) {
  return n.monthsShortRegex(e);
});
bt("MMMM", function(e, n) {
  return n.monthsRegex(e);
});
Ar(["M", "MM"], function(e, n) {
  n[ff] = Mn(e) - 1;
});
Ar(["MMM", "MMMM"], function(e, n, a, i) {
  var h = a._locale.monthsParse(e, i, a._strict);
  h != null ? n[ff] = h : vn(a).invalidMonth = e;
});
var _$ = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), tO = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), nO = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, R$ = m3, E$ = m3;
function M$(e, n) {
  return e ? E1(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || nO).test(n) ? "format" : "standalone"][e.month()] : E1(this._months) ? this._months : this._months.standalone;
}
function T$(e, n) {
  return e ? E1(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[nO.test(n) ? "format" : "standalone"][e.month()] : E1(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function O$(e, n, a) {
  var i, h, g, m = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], i = 0; i < 12; ++i)
      g = U0([2e3, i]), this._shortMonthsParse[i] = this.monthsShort(
        g,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[i] = this.months(g, "").toLocaleLowerCase();
  return a ? n === "MMM" ? (h = eo.call(this._shortMonthsParse, m), h !== -1 ? h : null) : (h = eo.call(this._longMonthsParse, m), h !== -1 ? h : null) : n === "MMM" ? (h = eo.call(this._shortMonthsParse, m), h !== -1 ? h : (h = eo.call(this._longMonthsParse, m), h !== -1 ? h : null)) : (h = eo.call(this._longMonthsParse, m), h !== -1 ? h : (h = eo.call(this._shortMonthsParse, m), h !== -1 ? h : null));
}
function D$(e, n, a) {
  var i, h, g;
  if (this._monthsParseExact)
    return O$.call(this, e, n, a);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), i = 0; i < 12; i++) {
    if (h = U0([2e3, i]), a && !this._longMonthsParse[i] && (this._longMonthsParse[i] = new RegExp(
      "^" + this.months(h, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[i] = new RegExp(
      "^" + this.monthsShort(h, "").replace(".", "") + "$",
      "i"
    )), !a && !this._monthsParse[i] && (g = "^" + this.months(h, "") + "|^" + this.monthsShort(h, ""), this._monthsParse[i] = new RegExp(g.replace(".", ""), "i")), a && n === "MMMM" && this._longMonthsParse[i].test(e))
      return i;
    if (a && n === "MMM" && this._shortMonthsParse[i].test(e))
      return i;
    if (!a && this._monthsParse[i].test(e))
      return i;
  }
}
function rO(e, n) {
  var a;
  if (!e.isValid())
    return e;
  if (typeof n == "string") {
    if (/^\d+$/.test(n))
      n = Mn(n);
    else if (n = e.localeData().monthsParse(n), !gf(n))
      return e;
  }
  return a = Math.min(e.date(), Mw(e.year(), n)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](n, a), e;
}
function aO(e) {
  return e != null ? (rO(this, e), Xe.updateOffset(this, !0), this) : E5(this, "Month");
}
function A$() {
  return Mw(this.year(), this.month());
}
function j$(e) {
  return this._monthsParseExact ? (ur(this, "_monthsRegex") || oO.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (ur(this, "_monthsShortRegex") || (this._monthsShortRegex = R$), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function k$(e) {
  return this._monthsParseExact ? (ur(this, "_monthsRegex") || oO.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (ur(this, "_monthsRegex") || (this._monthsRegex = E$), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function oO() {
  function e(m, S) {
    return S.length - m.length;
  }
  var n = [], a = [], i = [], h, g;
  for (h = 0; h < 12; h++)
    g = U0([2e3, h]), n.push(this.monthsShort(g, "")), a.push(this.months(g, "")), i.push(this.months(g, "")), i.push(this.monthsShort(g, ""));
  for (n.sort(e), a.sort(e), i.sort(e), h = 0; h < 12; h++)
    n[h] = Du(n[h]), a[h] = Du(a[h]);
  for (h = 0; h < 24; h++)
    i[h] = Du(i[h]);
  this._monthsRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + a.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
Yt("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? F0(e, 4) : "+" + e;
});
Yt(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
Yt(0, ["YYYY", 4], 0, "year");
Yt(0, ["YYYYY", 5], 0, "year");
Yt(0, ["YYYYYY", 6, !0], 0, "year");
zi("year", "y");
qi("year", 1);
bt("Y", Rw);
bt("YY", ia, ju);
bt("YYYY", $8, Y8);
bt("YYYYY", _w, Cw);
bt("YYYYYY", _w, Cw);
Ar(["YYYYY", "YYYYYY"], Wi);
Ar("YYYY", function(e, n) {
  n[Wi] = e.length === 2 ? Xe.parseTwoDigitYear(e) : Mn(e);
});
Ar("YY", function(e, n) {
  n[Wi] = Xe.parseTwoDigitYear(e);
});
Ar("Y", function(e, n) {
  n[Wi] = parseInt(e, 10);
});
function H4(e) {
  return Sw(e) ? 366 : 365;
}
Xe.parseTwoDigitYear = function(e) {
  return Mn(e) + (Mn(e) > 68 ? 1900 : 2e3);
};
var iO = Kp("FullYear", !0);
function L$() {
  return Sw(this.year());
}
function I$(e, n, a, i, h, g, m) {
  var S;
  return e < 100 && e >= 0 ? (S = new Date(e + 400, n, a, i, h, g, m), isFinite(S.getFullYear()) && S.setFullYear(e)) : S = new Date(e, n, a, i, h, g, m), S;
}
function U4(e) {
  var n, a;
  return e < 100 && e >= 0 ? (a = Array.prototype.slice.call(arguments), a[0] = e + 400, n = new Date(Date.UTC.apply(null, a)), isFinite(n.getUTCFullYear()) && n.setUTCFullYear(e)) : n = new Date(Date.UTC.apply(null, arguments)), n;
}
function T5(e, n, a) {
  var i = 7 + n - a, h = (7 + U4(e, 0, i).getUTCDay() - n) % 7;
  return -h + i - 1;
}
function lO(e, n, a, i, h) {
  var g = (7 + a - i) % 7, m = T5(e, i, h), S = 1 + 7 * (n - 1) + g + m, b, R;
  return S <= 0 ? (b = e - 1, R = H4(b) + S) : S > H4(e) ? (b = e + 1, R = S - H4(e)) : (b = e, R = S), {
    year: b,
    dayOfYear: R
  };
}
function Y4(e, n, a) {
  var i = T5(e.year(), n, a), h = Math.floor((e.dayOfYear() - i - 1) / 7) + 1, g, m;
  return h < 1 ? (m = e.year() - 1, g = h + hf(m, n, a)) : h > hf(e.year(), n, a) ? (g = h - hf(e.year(), n, a), m = e.year() + 1) : (m = e.year(), g = h), {
    week: g,
    year: m
  };
}
function hf(e, n, a) {
  var i = T5(e, n, a), h = T5(e + 1, n, a);
  return (H4(e) - i + h) / 7;
}
Yt("w", ["ww", 2], "wo", "week");
Yt("W", ["WW", 2], "Wo", "isoWeek");
zi("week", "w");
zi("isoWeek", "W");
qi("week", 5);
qi("isoWeek", 5);
bt("w", ia);
bt("ww", ia, ju);
bt("W", ia);
bt("WW", ia, ju);
g3(
  ["w", "ww", "W", "WW"],
  function(e, n, a, i) {
    n[i.substr(0, 1)] = Mn(e);
  }
);
function H$(e) {
  return Y4(e, this._week.dow, this._week.doy).week;
}
var Z$ = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function P$() {
  return this._week.dow;
}
function N$() {
  return this._week.doy;
}
function V$(e) {
  var n = this.localeData().week(this);
  return e == null ? n : this.add((e - n) * 7, "d");
}
function F$(e) {
  var n = Y4(this, 1, 4).week;
  return e == null ? n : this.add((e - n) * 7, "d");
}
Yt("d", 0, "do", "day");
Yt("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
Yt("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
Yt("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
Yt("e", 0, 0, "weekday");
Yt("E", 0, 0, "isoWeekday");
zi("day", "d");
zi("weekday", "e");
zi("isoWeekday", "E");
qi("day", 11);
qi("weekday", 11);
qi("isoWeekday", 11);
bt("d", ia);
bt("e", ia);
bt("E", ia);
bt("dd", function(e, n) {
  return n.weekdaysMinRegex(e);
});
bt("ddd", function(e, n) {
  return n.weekdaysShortRegex(e);
});
bt("dddd", function(e, n) {
  return n.weekdaysRegex(e);
});
g3(["dd", "ddd", "dddd"], function(e, n, a, i) {
  var h = a._locale.weekdaysParse(e, i, a._strict);
  h != null ? n.d = h : vn(a).invalidWeekday = e;
});
g3(["d", "e", "E"], function(e, n, a, i) {
  n[i] = Mn(e);
});
function B$(e, n) {
  return typeof e != "string" ? e : isNaN(e) ? (e = n.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function U$(e, n) {
  return typeof e == "string" ? n.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function W8(e, n) {
  return e.slice(n, 7).concat(e.slice(0, n));
}
var Y$ = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), uO = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), $$ = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), W$ = m3, z$ = m3, q$ = m3;
function G$(e, n) {
  var a = E1(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(n) ? "format" : "standalone"];
  return e === !0 ? W8(a, this._week.dow) : e ? a[e.day()] : a;
}
function K$(e) {
  return e === !0 ? W8(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function Q$(e) {
  return e === !0 ? W8(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function X$(e, n, a) {
  var i, h, g, m = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], i = 0; i < 7; ++i)
      g = U0([2e3, 1]).day(i), this._minWeekdaysParse[i] = this.weekdaysMin(
        g,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[i] = this.weekdaysShort(
        g,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[i] = this.weekdays(g, "").toLocaleLowerCase();
  return a ? n === "dddd" ? (h = eo.call(this._weekdaysParse, m), h !== -1 ? h : null) : n === "ddd" ? (h = eo.call(this._shortWeekdaysParse, m), h !== -1 ? h : null) : (h = eo.call(this._minWeekdaysParse, m), h !== -1 ? h : null) : n === "dddd" ? (h = eo.call(this._weekdaysParse, m), h !== -1 || (h = eo.call(this._shortWeekdaysParse, m), h !== -1) ? h : (h = eo.call(this._minWeekdaysParse, m), h !== -1 ? h : null)) : n === "ddd" ? (h = eo.call(this._shortWeekdaysParse, m), h !== -1 || (h = eo.call(this._weekdaysParse, m), h !== -1) ? h : (h = eo.call(this._minWeekdaysParse, m), h !== -1 ? h : null)) : (h = eo.call(this._minWeekdaysParse, m), h !== -1 || (h = eo.call(this._weekdaysParse, m), h !== -1) ? h : (h = eo.call(this._shortWeekdaysParse, m), h !== -1 ? h : null));
}
function J$(e, n, a) {
  var i, h, g;
  if (this._weekdaysParseExact)
    return X$.call(this, e, n, a);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), i = 0; i < 7; i++) {
    if (h = U0([2e3, 1]).day(i), a && !this._fullWeekdaysParse[i] && (this._fullWeekdaysParse[i] = new RegExp(
      "^" + this.weekdays(h, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysShort(h, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysMin(h, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[i] || (g = "^" + this.weekdays(h, "") + "|^" + this.weekdaysShort(h, "") + "|^" + this.weekdaysMin(h, ""), this._weekdaysParse[i] = new RegExp(g.replace(".", ""), "i")), a && n === "dddd" && this._fullWeekdaysParse[i].test(e))
      return i;
    if (a && n === "ddd" && this._shortWeekdaysParse[i].test(e))
      return i;
    if (a && n === "dd" && this._minWeekdaysParse[i].test(e))
      return i;
    if (!a && this._weekdaysParse[i].test(e))
      return i;
  }
}
function eW(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var n = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = B$(e, this.localeData()), this.add(e - n, "d")) : n;
}
function tW(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var n = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? n : this.add(e - n, "d");
}
function nW(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var n = U$(e, this.localeData());
    return this.day(this.day() % 7 ? n : n - 7);
  } else
    return this.day() || 7;
}
function rW(e) {
  return this._weekdaysParseExact ? (ur(this, "_weekdaysRegex") || z8.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (ur(this, "_weekdaysRegex") || (this._weekdaysRegex = W$), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function aW(e) {
  return this._weekdaysParseExact ? (ur(this, "_weekdaysRegex") || z8.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (ur(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = z$), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function oW(e) {
  return this._weekdaysParseExact ? (ur(this, "_weekdaysRegex") || z8.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (ur(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = q$), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function z8() {
  function e(D, T) {
    return T.length - D.length;
  }
  var n = [], a = [], i = [], h = [], g, m, S, b, R;
  for (g = 0; g < 7; g++)
    m = U0([2e3, 1]).day(g), S = Du(this.weekdaysMin(m, "")), b = Du(this.weekdaysShort(m, "")), R = Du(this.weekdays(m, "")), n.push(S), a.push(b), i.push(R), h.push(S), h.push(b), h.push(R);
  n.sort(e), a.sort(e), i.sort(e), h.sort(e), this._weekdaysRegex = new RegExp("^(" + h.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + a.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
function q8() {
  return this.hours() % 12 || 12;
}
function iW() {
  return this.hours() || 24;
}
Yt("H", ["HH", 2], 0, "hour");
Yt("h", ["hh", 2], 0, q8);
Yt("k", ["kk", 2], 0, iW);
Yt("hmm", 0, 0, function() {
  return "" + q8.apply(this) + F0(this.minutes(), 2);
});
Yt("hmmss", 0, 0, function() {
  return "" + q8.apply(this) + F0(this.minutes(), 2) + F0(this.seconds(), 2);
});
Yt("Hmm", 0, 0, function() {
  return "" + this.hours() + F0(this.minutes(), 2);
});
Yt("Hmmss", 0, 0, function() {
  return "" + this.hours() + F0(this.minutes(), 2) + F0(this.seconds(), 2);
});
function sO(e, n) {
  Yt(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      n
    );
  });
}
sO("a", !0);
sO("A", !1);
zi("hour", "h");
qi("hour", 13);
function cO(e, n) {
  return n._meridiemParse;
}
bt("a", cO);
bt("A", cO);
bt("H", ia);
bt("h", ia);
bt("k", ia);
bt("HH", ia, ju);
bt("hh", ia, ju);
bt("kk", ia, ju);
bt("hmm", JT);
bt("hmmss", eO);
bt("Hmm", JT);
bt("Hmmss", eO);
Ar(["H", "HH"], Lo);
Ar(["k", "kk"], function(e, n, a) {
  var i = Mn(e);
  n[Lo] = i === 24 ? 0 : i;
});
Ar(["a", "A"], function(e, n, a) {
  a._isPm = a._locale.isPM(e), a._meridiem = e;
});
Ar(["h", "hh"], function(e, n, a) {
  n[Lo] = Mn(e), vn(a).bigHour = !0;
});
Ar("hmm", function(e, n, a) {
  var i = e.length - 2;
  n[Lo] = Mn(e.substr(0, i)), n[b1] = Mn(e.substr(i)), vn(a).bigHour = !0;
});
Ar("hmmss", function(e, n, a) {
  var i = e.length - 4, h = e.length - 2;
  n[Lo] = Mn(e.substr(0, i)), n[b1] = Mn(e.substr(i, 2)), n[df] = Mn(e.substr(h)), vn(a).bigHour = !0;
});
Ar("Hmm", function(e, n, a) {
  var i = e.length - 2;
  n[Lo] = Mn(e.substr(0, i)), n[b1] = Mn(e.substr(i));
});
Ar("Hmmss", function(e, n, a) {
  var i = e.length - 4, h = e.length - 2;
  n[Lo] = Mn(e.substr(0, i)), n[b1] = Mn(e.substr(i, 2)), n[df] = Mn(e.substr(h));
});
function lW(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var uW = /[ap]\.?m?\.?/i, sW = Kp("Hours", !0);
function cW(e, n, a) {
  return e > 11 ? a ? "pm" : "PM" : a ? "am" : "AM";
}
var fO = {
  calendar: JY,
  longDateFormat: r$,
  invalidDate: o$,
  ordinal: l$,
  dayOfMonthOrdinalParse: u$,
  relativeTime: c$,
  months: _$,
  monthsShort: tO,
  week: Z$,
  weekdays: Y$,
  weekdaysMin: $$,
  weekdaysShort: uO,
  meridiemParse: uW
}, va = {}, T4 = {}, $4;
function fW(e, n) {
  var a, i = Math.min(e.length, n.length);
  for (a = 0; a < i; a += 1)
    if (e[a] !== n[a])
      return a;
  return i;
}
function TR(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function dW(e) {
  for (var n = 0, a, i, h, g; n < e.length; ) {
    for (g = TR(e[n]).split("-"), a = g.length, i = TR(e[n + 1]), i = i ? i.split("-") : null; a > 0; ) {
      if (h = Tw(g.slice(0, a).join("-")), h)
        return h;
      if (i && i.length >= a && fW(g, i) >= a - 1)
        break;
      a--;
    }
    n++;
  }
  return $4;
}
function hW(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function Tw(e) {
  var n = null, a;
  if (va[e] === void 0 && typeof module < "u" && module && module.exports && hW(e))
    try {
      n = $4._abbr, a = require, a("./locale/" + e), ah(n);
    } catch {
      va[e] = null;
    }
  return va[e];
}
function ah(e, n) {
  var a;
  return e && ($l(n) ? a = bf(e) : a = G8(e, n), a ? $4 = a : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), $4._abbr;
}
function G8(e, n) {
  if (n !== null) {
    var a, i = fO;
    if (n.abbr = e, va[e] != null)
      zT(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), i = va[e]._config;
    else if (n.parentLocale != null)
      if (va[n.parentLocale] != null)
        i = va[n.parentLocale]._config;
      else if (a = Tw(n.parentLocale), a != null)
        i = a._config;
      else
        return T4[n.parentLocale] || (T4[n.parentLocale] = []), T4[n.parentLocale].push({
          name: e,
          config: n
        }), null;
    return va[e] = new F8(vx(i, n)), T4[e] && T4[e].forEach(function(h) {
      G8(h.name, h.config);
    }), ah(e), va[e];
  } else
    return delete va[e], null;
}
function vW(e, n) {
  if (n != null) {
    var a, i, h = fO;
    va[e] != null && va[e].parentLocale != null ? va[e].set(vx(va[e]._config, n)) : (i = Tw(e), i != null && (h = i._config), n = vx(h, n), i == null && (n.abbr = e), a = new F8(n), a.parentLocale = va[e], va[e] = a), ah(e);
  } else
    va[e] != null && (va[e].parentLocale != null ? (va[e] = va[e].parentLocale, e === ah() && ah(e)) : va[e] != null && delete va[e]);
  return va[e];
}
function bf(e) {
  var n;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return $4;
  if (!E1(e)) {
    if (n = Tw(e), n)
      return n;
    e = [e];
  }
  return dW(e);
}
function pW() {
  return px(va);
}
function K8(e) {
  var n, a = e._a;
  return a && vn(e).overflow === -2 && (n = a[ff] < 0 || a[ff] > 11 ? ff : a[H0] < 1 || a[H0] > Mw(a[Wi], a[ff]) ? H0 : a[Lo] < 0 || a[Lo] > 24 || a[Lo] === 24 && (a[b1] !== 0 || a[df] !== 0 || a[M2] !== 0) ? Lo : a[b1] < 0 || a[b1] > 59 ? b1 : a[df] < 0 || a[df] > 59 ? df : a[M2] < 0 || a[M2] > 999 ? M2 : -1, vn(e)._overflowDayOfYear && (n < Wi || n > H0) && (n = H0), vn(e)._overflowWeeks && n === -1 && (n = S$), vn(e)._overflowWeekday && n === -1 && (n = C$), vn(e).overflow = n), e;
}
var mW = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, gW = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, wW = /Z|[+-]\d\d(?::?\d\d)?/, r5 = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], F9 = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], yW = /^\/?Date\((-?\d+)/i, xW = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, SW = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function dO(e) {
  var n, a, i = e._i, h = mW.exec(i) || gW.exec(i), g, m, S, b, R = r5.length, D = F9.length;
  if (h) {
    for (vn(e).iso = !0, n = 0, a = R; n < a; n++)
      if (r5[n][1].exec(h[1])) {
        m = r5[n][0], g = r5[n][2] !== !1;
        break;
      }
    if (m == null) {
      e._isValid = !1;
      return;
    }
    if (h[3]) {
      for (n = 0, a = D; n < a; n++)
        if (F9[n][1].exec(h[3])) {
          S = (h[2] || " ") + F9[n][0];
          break;
        }
      if (S == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!g && S != null) {
      e._isValid = !1;
      return;
    }
    if (h[4])
      if (wW.exec(h[4]))
        b = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = m + (S || "") + (b || ""), X8(e);
  } else
    e._isValid = !1;
}
function CW(e, n, a, i, h, g) {
  var m = [
    bW(e),
    tO.indexOf(n),
    parseInt(a, 10),
    parseInt(i, 10),
    parseInt(h, 10)
  ];
  return g && m.push(parseInt(g, 10)), m;
}
function bW(e) {
  var n = parseInt(e, 10);
  return n <= 49 ? 2e3 + n : n <= 999 ? 1900 + n : n;
}
function _W(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function RW(e, n, a) {
  if (e) {
    var i = uO.indexOf(e), h = new Date(
      n[0],
      n[1],
      n[2]
    ).getDay();
    if (i !== h)
      return vn(a).weekdayMismatch = !0, a._isValid = !1, !1;
  }
  return !0;
}
function EW(e, n, a) {
  if (e)
    return SW[e];
  if (n)
    return 0;
  var i = parseInt(a, 10), h = i % 100, g = (i - h) / 100;
  return g * 60 + h;
}
function hO(e) {
  var n = xW.exec(_W(e._i)), a;
  if (n) {
    if (a = CW(
      n[4],
      n[3],
      n[2],
      n[5],
      n[6],
      n[7]
    ), !RW(n[1], a, e))
      return;
    e._a = a, e._tzm = EW(n[8], n[9], n[10]), e._d = U4.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), vn(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function MW(e) {
  var n = yW.exec(e._i);
  if (n !== null) {
    e._d = /* @__PURE__ */ new Date(+n[1]);
    return;
  }
  if (dO(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (hO(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : Xe.createFromInputFallback(e);
}
Xe.createFromInputFallback = Ts(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Tp(e, n, a) {
  return e ?? n ?? a;
}
function TW(e) {
  var n = new Date(Xe.now());
  return e._useUTC ? [
    n.getUTCFullYear(),
    n.getUTCMonth(),
    n.getUTCDate()
  ] : [n.getFullYear(), n.getMonth(), n.getDate()];
}
function Q8(e) {
  var n, a, i = [], h, g, m;
  if (!e._d) {
    for (h = TW(e), e._w && e._a[H0] == null && e._a[ff] == null && OW(e), e._dayOfYear != null && (m = Tp(e._a[Wi], h[Wi]), (e._dayOfYear > H4(m) || e._dayOfYear === 0) && (vn(e)._overflowDayOfYear = !0), a = U4(m, 0, e._dayOfYear), e._a[ff] = a.getUTCMonth(), e._a[H0] = a.getUTCDate()), n = 0; n < 3 && e._a[n] == null; ++n)
      e._a[n] = i[n] = h[n];
    for (; n < 7; n++)
      e._a[n] = i[n] = e._a[n] == null ? n === 2 ? 1 : 0 : e._a[n];
    e._a[Lo] === 24 && e._a[b1] === 0 && e._a[df] === 0 && e._a[M2] === 0 && (e._nextDay = !0, e._a[Lo] = 0), e._d = (e._useUTC ? U4 : I$).apply(
      null,
      i
    ), g = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[Lo] = 24), e._w && typeof e._w.d < "u" && e._w.d !== g && (vn(e).weekdayMismatch = !0);
  }
}
function OW(e) {
  var n, a, i, h, g, m, S, b, R;
  n = e._w, n.GG != null || n.W != null || n.E != null ? (g = 1, m = 4, a = Tp(
    n.GG,
    e._a[Wi],
    Y4(oa(), 1, 4).year
  ), i = Tp(n.W, 1), h = Tp(n.E, 1), (h < 1 || h > 7) && (b = !0)) : (g = e._locale._week.dow, m = e._locale._week.doy, R = Y4(oa(), g, m), a = Tp(n.gg, e._a[Wi], R.year), i = Tp(n.w, R.week), n.d != null ? (h = n.d, (h < 0 || h > 6) && (b = !0)) : n.e != null ? (h = n.e + g, (n.e < 0 || n.e > 6) && (b = !0)) : h = g), i < 1 || i > hf(a, g, m) ? vn(e)._overflowWeeks = !0 : b != null ? vn(e)._overflowWeekday = !0 : (S = lO(a, i, h, g, m), e._a[Wi] = S.year, e._dayOfYear = S.dayOfYear);
}
Xe.ISO_8601 = function() {
};
Xe.RFC_2822 = function() {
};
function X8(e) {
  if (e._f === Xe.ISO_8601) {
    dO(e);
    return;
  }
  if (e._f === Xe.RFC_2822) {
    hO(e);
    return;
  }
  e._a = [], vn(e).empty = !0;
  var n = "" + e._i, a, i, h, g, m, S = n.length, b = 0, R, D;
  for (h = qT(e._f, e._locale).match(B8) || [], D = h.length, a = 0; a < D; a++)
    g = h[a], i = (n.match(w$(g, e)) || [])[0], i && (m = n.substr(0, n.indexOf(i)), m.length > 0 && vn(e).unusedInput.push(m), n = n.slice(
      n.indexOf(i) + i.length
    ), b += i.length), Ip[g] ? (i ? vn(e).empty = !1 : vn(e).unusedTokens.push(g), x$(g, i, e)) : e._strict && !i && vn(e).unusedTokens.push(g);
  vn(e).charsLeftOver = S - b, n.length > 0 && vn(e).unusedInput.push(n), e._a[Lo] <= 12 && vn(e).bigHour === !0 && e._a[Lo] > 0 && (vn(e).bigHour = void 0), vn(e).parsedDateParts = e._a.slice(0), vn(e).meridiem = e._meridiem, e._a[Lo] = DW(
    e._locale,
    e._a[Lo],
    e._meridiem
  ), R = vn(e).era, R !== null && (e._a[Wi] = e._locale.erasConvertYear(R, e._a[Wi])), Q8(e), K8(e);
}
function DW(e, n, a) {
  var i;
  return a == null ? n : e.meridiemHour != null ? e.meridiemHour(n, a) : (e.isPM != null && (i = e.isPM(a), i && n < 12 && (n += 12), !i && n === 12 && (n = 0)), n);
}
function AW(e) {
  var n, a, i, h, g, m, S = !1, b = e._f.length;
  if (b === 0) {
    vn(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (h = 0; h < b; h++)
    g = 0, m = !1, n = V8({}, e), e._useUTC != null && (n._useUTC = e._useUTC), n._f = e._f[h], X8(n), N8(n) && (m = !0), g += vn(n).charsLeftOver, g += vn(n).unusedTokens.length * 10, vn(n).score = g, S ? g < i && (i = g, a = n) : (i == null || g < i || m) && (i = g, a = n, m && (S = !0));
  Jd(e, a || n);
}
function jW(e) {
  if (!e._d) {
    var n = U8(e._i), a = n.day === void 0 ? n.date : n.day;
    e._a = $T(
      [n.year, n.month, a, n.hour, n.minute, n.second, n.millisecond],
      function(i) {
        return i && parseInt(i, 10);
      }
    ), Q8(e);
  }
}
function kW(e) {
  var n = new p3(K8(vO(e)));
  return n._nextDay && (n.add(1, "d"), n._nextDay = void 0), n;
}
function vO(e) {
  var n = e._i, a = e._f;
  return e._locale = e._locale || bf(e._l), n === null || a === void 0 && n === "" ? xw({ nullInput: !0 }) : (typeof n == "string" && (e._i = n = e._locale.preparse(n)), M1(n) ? new p3(K8(n)) : (v3(n) ? e._d = n : E1(a) ? AW(e) : a ? X8(e) : LW(e), N8(e) || (e._d = null), e));
}
function LW(e) {
  var n = e._i;
  $l(n) ? e._d = new Date(Xe.now()) : v3(n) ? e._d = new Date(n.valueOf()) : typeof n == "string" ? MW(e) : E1(n) ? (e._a = $T(n.slice(0), function(a) {
    return parseInt(a, 10);
  }), Q8(e)) : T2(n) ? jW(e) : gf(n) ? e._d = new Date(n) : Xe.createFromInputFallback(e);
}
function pO(e, n, a, i, h) {
  var g = {};
  return (n === !0 || n === !1) && (i = n, n = void 0), (a === !0 || a === !1) && (i = a, a = void 0), (T2(e) && P8(e) || E1(e) && e.length === 0) && (e = void 0), g._isAMomentObject = !0, g._useUTC = g._isUTC = h, g._l = a, g._i = e, g._f = n, g._strict = i, kW(g);
}
function oa(e, n, a, i) {
  return pO(e, n, a, i, !1);
}
var IW = Ts(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = oa.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : xw();
  }
), HW = Ts(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = oa.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : xw();
  }
);
function mO(e, n) {
  var a, i;
  if (n.length === 1 && E1(n[0]) && (n = n[0]), !n.length)
    return oa();
  for (a = n[0], i = 1; i < n.length; ++i)
    (!n[i].isValid() || n[i][e](a)) && (a = n[i]);
  return a;
}
function ZW() {
  var e = [].slice.call(arguments, 0);
  return mO("isBefore", e);
}
function PW() {
  var e = [].slice.call(arguments, 0);
  return mO("isAfter", e);
}
var NW = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, O4 = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function VW(e) {
  var n, a = !1, i, h = O4.length;
  for (n in e)
    if (ur(e, n) && !(eo.call(O4, n) !== -1 && (e[n] == null || !isNaN(e[n]))))
      return !1;
  for (i = 0; i < h; ++i)
    if (e[O4[i]]) {
      if (a)
        return !1;
      parseFloat(e[O4[i]]) !== Mn(e[O4[i]]) && (a = !0);
    }
  return !0;
}
function FW() {
  return this._isValid;
}
function BW() {
  return T1(NaN);
}
function Ow(e) {
  var n = U8(e), a = n.year || 0, i = n.quarter || 0, h = n.month || 0, g = n.week || n.isoWeek || 0, m = n.day || 0, S = n.hour || 0, b = n.minute || 0, R = n.second || 0, D = n.millisecond || 0;
  this._isValid = VW(n), this._milliseconds = +D + R * 1e3 + // 1000
  b * 6e4 + // 1000 * 60
  S * 1e3 * 60 * 60, this._days = +m + g * 7, this._months = +h + i * 3 + a * 12, this._data = {}, this._locale = bf(), this._bubble();
}
function d5(e) {
  return e instanceof Ow;
}
function gx(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function UW(e, n, a) {
  var i = Math.min(e.length, n.length), h = Math.abs(e.length - n.length), g = 0, m;
  for (m = 0; m < i; m++)
    Mn(e[m]) !== Mn(n[m]) && g++;
  return g + h;
}
function gO(e, n) {
  Yt(e, 0, 0, function() {
    var a = this.utcOffset(), i = "+";
    return a < 0 && (a = -a, i = "-"), i + F0(~~(a / 60), 2) + n + F0(~~a % 60, 2);
  });
}
gO("Z", ":");
gO("ZZ", "");
bt("Z", Ew);
bt("ZZ", Ew);
Ar(["Z", "ZZ"], function(e, n, a) {
  a._useUTC = !0, a._tzm = J8(Ew, e);
});
var YW = /([\+\-]|\d\d)/gi;
function J8(e, n) {
  var a = (n || "").match(e), i, h, g;
  return a === null ? null : (i = a[a.length - 1] || [], h = (i + "").match(YW) || ["-", 0, 0], g = +(h[1] * 60) + Mn(h[2]), g === 0 ? 0 : h[0] === "+" ? g : -g);
}
function eS(e, n) {
  var a, i;
  return n._isUTC ? (a = n.clone(), i = (M1(e) || v3(e) ? e.valueOf() : oa(e).valueOf()) - a.valueOf(), a._d.setTime(a._d.valueOf() + i), Xe.updateOffset(a, !1), a) : oa(e).local();
}
function wx(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
Xe.updateOffset = function() {
};
function $W(e, n, a) {
  var i = this._offset || 0, h;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = J8(Ew, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !a && (e = e * 60);
    return !this._isUTC && n && (h = wx(this)), this._offset = e, this._isUTC = !0, h != null && this.add(h, "m"), i !== e && (!n || this._changeInProgress ? xO(
      this,
      T1(e - i, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, Xe.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? i : wx(this);
}
function WW(e, n) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, n), this) : -this.utcOffset();
}
function zW(e) {
  return this.utcOffset(0, e);
}
function qW(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(wx(this), "m")), this;
}
function GW() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = J8(m$, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function KW(e) {
  return this.isValid() ? (e = e ? oa(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function QW() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function XW() {
  if (!$l(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, n;
  return V8(e, this), e = vO(e), e._a ? (n = e._isUTC ? U0(e._a) : oa(e._a), this._isDSTShifted = this.isValid() && UW(e._a, n.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function JW() {
  return this.isValid() ? !this._isUTC : !1;
}
function ez() {
  return this.isValid() ? this._isUTC : !1;
}
function wO() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var tz = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, nz = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function T1(e, n) {
  var a = e, i = null, h, g, m;
  return d5(e) ? a = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : gf(e) || !isNaN(+e) ? (a = {}, n ? a[n] = +e : a.milliseconds = +e) : (i = tz.exec(e)) ? (h = i[1] === "-" ? -1 : 1, a = {
    y: 0,
    d: Mn(i[H0]) * h,
    h: Mn(i[Lo]) * h,
    m: Mn(i[b1]) * h,
    s: Mn(i[df]) * h,
    ms: Mn(gx(i[M2] * 1e3)) * h
    // the millisecond decimal point is included in the match
  }) : (i = nz.exec(e)) ? (h = i[1] === "-" ? -1 : 1, a = {
    y: R2(i[2], h),
    M: R2(i[3], h),
    w: R2(i[4], h),
    d: R2(i[5], h),
    h: R2(i[6], h),
    m: R2(i[7], h),
    s: R2(i[8], h)
  }) : a == null ? a = {} : typeof a == "object" && ("from" in a || "to" in a) && (m = rz(
    oa(a.from),
    oa(a.to)
  ), a = {}, a.ms = m.milliseconds, a.M = m.months), g = new Ow(a), d5(e) && ur(e, "_locale") && (g._locale = e._locale), d5(e) && ur(e, "_isValid") && (g._isValid = e._isValid), g;
}
T1.fn = Ow.prototype;
T1.invalid = BW;
function R2(e, n) {
  var a = e && parseFloat(e.replace(",", "."));
  return (isNaN(a) ? 0 : a) * n;
}
function OR(e, n) {
  var a = {};
  return a.months = n.month() - e.month() + (n.year() - e.year()) * 12, e.clone().add(a.months, "M").isAfter(n) && --a.months, a.milliseconds = +n - +e.clone().add(a.months, "M"), a;
}
function rz(e, n) {
  var a;
  return e.isValid() && n.isValid() ? (n = eS(n, e), e.isBefore(n) ? a = OR(e, n) : (a = OR(n, e), a.milliseconds = -a.milliseconds, a.months = -a.months), a) : { milliseconds: 0, months: 0 };
}
function yO(e, n) {
  return function(a, i) {
    var h, g;
    return i !== null && !isNaN(+i) && (zT(
      n,
      "moment()." + n + "(period, number) is deprecated. Please use moment()." + n + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), g = a, a = i, i = g), h = T1(a, i), xO(this, h, e), this;
  };
}
function xO(e, n, a, i) {
  var h = n._milliseconds, g = gx(n._days), m = gx(n._months);
  e.isValid() && (i = i ?? !0, m && rO(e, E5(e, "Month") + m * a), g && KT(e, "Date", E5(e, "Date") + g * a), h && e._d.setTime(e._d.valueOf() + h * a), i && Xe.updateOffset(e, g || m));
}
var az = yO(1, "add"), oz = yO(-1, "subtract");
function SO(e) {
  return typeof e == "string" || e instanceof String;
}
function iz(e) {
  return M1(e) || v3(e) || SO(e) || gf(e) || uz(e) || lz(e) || e === null || e === void 0;
}
function lz(e) {
  var n = T2(e) && !P8(e), a = !1, i = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], h, g, m = i.length;
  for (h = 0; h < m; h += 1)
    g = i[h], a = a || ur(e, g);
  return n && a;
}
function uz(e) {
  var n = E1(e), a = !1;
  return n && (a = e.filter(function(i) {
    return !gf(i) && SO(e);
  }).length === 0), n && a;
}
function sz(e) {
  var n = T2(e) && !P8(e), a = !1, i = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], h, g;
  for (h = 0; h < i.length; h += 1)
    g = i[h], a = a || ur(e, g);
  return n && a;
}
function cz(e, n) {
  var a = e.diff(n, "days", !0);
  return a < -6 ? "sameElse" : a < -1 ? "lastWeek" : a < 0 ? "lastDay" : a < 1 ? "sameDay" : a < 2 ? "nextDay" : a < 7 ? "nextWeek" : "sameElse";
}
function fz(e, n) {
  arguments.length === 1 && (arguments[0] ? iz(arguments[0]) ? (e = arguments[0], n = void 0) : sz(arguments[0]) && (n = arguments[0], e = void 0) : (e = void 0, n = void 0));
  var a = e || oa(), i = eS(a, this).startOf("day"), h = Xe.calendarFormat(this, i) || "sameElse", g = n && (Y0(n[h]) ? n[h].call(this, a) : n[h]);
  return this.format(
    g || this.localeData().calendar(h, this, oa(a))
  );
}
function dz() {
  return new p3(this);
}
function hz(e, n) {
  var a = M1(e) ? e : oa(e);
  return this.isValid() && a.isValid() ? (n = Os(n) || "millisecond", n === "millisecond" ? this.valueOf() > a.valueOf() : a.valueOf() < this.clone().startOf(n).valueOf()) : !1;
}
function vz(e, n) {
  var a = M1(e) ? e : oa(e);
  return this.isValid() && a.isValid() ? (n = Os(n) || "millisecond", n === "millisecond" ? this.valueOf() < a.valueOf() : this.clone().endOf(n).valueOf() < a.valueOf()) : !1;
}
function pz(e, n, a, i) {
  var h = M1(e) ? e : oa(e), g = M1(n) ? n : oa(n);
  return this.isValid() && h.isValid() && g.isValid() ? (i = i || "()", (i[0] === "(" ? this.isAfter(h, a) : !this.isBefore(h, a)) && (i[1] === ")" ? this.isBefore(g, a) : !this.isAfter(g, a))) : !1;
}
function mz(e, n) {
  var a = M1(e) ? e : oa(e), i;
  return this.isValid() && a.isValid() ? (n = Os(n) || "millisecond", n === "millisecond" ? this.valueOf() === a.valueOf() : (i = a.valueOf(), this.clone().startOf(n).valueOf() <= i && i <= this.clone().endOf(n).valueOf())) : !1;
}
function gz(e, n) {
  return this.isSame(e, n) || this.isAfter(e, n);
}
function wz(e, n) {
  return this.isSame(e, n) || this.isBefore(e, n);
}
function yz(e, n, a) {
  var i, h, g;
  if (!this.isValid())
    return NaN;
  if (i = eS(e, this), !i.isValid())
    return NaN;
  switch (h = (i.utcOffset() - this.utcOffset()) * 6e4, n = Os(n), n) {
    case "year":
      g = h5(this, i) / 12;
      break;
    case "month":
      g = h5(this, i);
      break;
    case "quarter":
      g = h5(this, i) / 3;
      break;
    case "second":
      g = (this - i) / 1e3;
      break;
    case "minute":
      g = (this - i) / 6e4;
      break;
    case "hour":
      g = (this - i) / 36e5;
      break;
    case "day":
      g = (this - i - h) / 864e5;
      break;
    case "week":
      g = (this - i - h) / 6048e5;
      break;
    default:
      g = this - i;
  }
  return a ? g : Es(g);
}
function h5(e, n) {
  if (e.date() < n.date())
    return -h5(n, e);
  var a = (n.year() - e.year()) * 12 + (n.month() - e.month()), i = e.clone().add(a, "months"), h, g;
  return n - i < 0 ? (h = e.clone().add(a - 1, "months"), g = (n - i) / (i - h)) : (h = e.clone().add(a + 1, "months"), g = (n - i) / (h - i)), -(a + g) || 0;
}
Xe.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
Xe.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function xz() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function Sz(e) {
  if (!this.isValid())
    return null;
  var n = e !== !0, a = n ? this.clone().utc() : this;
  return a.year() < 0 || a.year() > 9999 ? f5(
    a,
    n ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : Y0(Date.prototype.toISOString) ? n ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", f5(a, "Z")) : f5(
    a,
    n ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function Cz() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", n = "", a, i, h, g;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", n = "Z"), a = "[" + e + '("]', i = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", h = "-MM-DD[T]HH:mm:ss.SSS", g = n + '[")]', this.format(a + i + h + g);
}
function bz(e) {
  e || (e = this.isUtc() ? Xe.defaultFormatUtc : Xe.defaultFormat);
  var n = f5(this, e);
  return this.localeData().postformat(n);
}
function _z(e, n) {
  return this.isValid() && (M1(e) && e.isValid() || oa(e).isValid()) ? T1({ to: this, from: e }).locale(this.locale()).humanize(!n) : this.localeData().invalidDate();
}
function Rz(e) {
  return this.from(oa(), e);
}
function Ez(e, n) {
  return this.isValid() && (M1(e) && e.isValid() || oa(e).isValid()) ? T1({ from: this, to: e }).locale(this.locale()).humanize(!n) : this.localeData().invalidDate();
}
function Mz(e) {
  return this.to(oa(), e);
}
function CO(e) {
  var n;
  return e === void 0 ? this._locale._abbr : (n = bf(e), n != null && (this._locale = n), this);
}
var bO = Ts(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function _O() {
  return this._locale;
}
var O5 = 1e3, Hp = 60 * O5, D5 = 60 * Hp, RO = (365 * 400 + 97) * 24 * D5;
function Zp(e, n) {
  return (e % n + n) % n;
}
function EO(e, n, a) {
  return e < 100 && e >= 0 ? new Date(e + 400, n, a) - RO : new Date(e, n, a).valueOf();
}
function MO(e, n, a) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, n, a) - RO : Date.UTC(e, n, a);
}
function Tz(e) {
  var n, a;
  if (e = Os(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (a = this._isUTC ? MO : EO, e) {
    case "year":
      n = a(this.year(), 0, 1);
      break;
    case "quarter":
      n = a(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      n = a(this.year(), this.month(), 1);
      break;
    case "week":
      n = a(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      n = a(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      n = a(this.year(), this.month(), this.date());
      break;
    case "hour":
      n = this._d.valueOf(), n -= Zp(
        n + (this._isUTC ? 0 : this.utcOffset() * Hp),
        D5
      );
      break;
    case "minute":
      n = this._d.valueOf(), n -= Zp(n, Hp);
      break;
    case "second":
      n = this._d.valueOf(), n -= Zp(n, O5);
      break;
  }
  return this._d.setTime(n), Xe.updateOffset(this, !0), this;
}
function Oz(e) {
  var n, a;
  if (e = Os(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (a = this._isUTC ? MO : EO, e) {
    case "year":
      n = a(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      n = a(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      n = a(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      n = a(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      n = a(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      n = a(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      n = this._d.valueOf(), n += D5 - Zp(
        n + (this._isUTC ? 0 : this.utcOffset() * Hp),
        D5
      ) - 1;
      break;
    case "minute":
      n = this._d.valueOf(), n += Hp - Zp(n, Hp) - 1;
      break;
    case "second":
      n = this._d.valueOf(), n += O5 - Zp(n, O5) - 1;
      break;
  }
  return this._d.setTime(n), Xe.updateOffset(this, !0), this;
}
function Dz() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function Az() {
  return Math.floor(this.valueOf() / 1e3);
}
function jz() {
  return new Date(this.valueOf());
}
function kz() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function Lz() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function Iz() {
  return this.isValid() ? this.toISOString() : null;
}
function Hz() {
  return N8(this);
}
function Zz() {
  return Jd({}, vn(this));
}
function Pz() {
  return vn(this).overflow;
}
function Nz() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
Yt("N", 0, 0, "eraAbbr");
Yt("NN", 0, 0, "eraAbbr");
Yt("NNN", 0, 0, "eraAbbr");
Yt("NNNN", 0, 0, "eraName");
Yt("NNNNN", 0, 0, "eraNarrow");
Yt("y", ["y", 1], "yo", "eraYear");
Yt("y", ["yy", 2], 0, "eraYear");
Yt("y", ["yyy", 3], 0, "eraYear");
Yt("y", ["yyyy", 4], 0, "eraYear");
bt("N", tS);
bt("NN", tS);
bt("NNN", tS);
bt("NNNN", Kz);
bt("NNNNN", Qz);
Ar(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, n, a, i) {
    var h = a._locale.erasParse(e, i, a._strict);
    h ? vn(a).era = h : vn(a).invalidEra = e;
  }
);
bt("y", Qp);
bt("yy", Qp);
bt("yyy", Qp);
bt("yyyy", Qp);
bt("yo", Xz);
Ar(["y", "yy", "yyy", "yyyy"], Wi);
Ar(["yo"], function(e, n, a, i) {
  var h;
  a._locale._eraYearOrdinalRegex && (h = e.match(a._locale._eraYearOrdinalRegex)), a._locale.eraYearOrdinalParse ? n[Wi] = a._locale.eraYearOrdinalParse(e, h) : n[Wi] = parseInt(e, 10);
});
function Vz(e, n) {
  var a, i, h, g = this._eras || bf("en")._eras;
  for (a = 0, i = g.length; a < i; ++a) {
    switch (typeof g[a].since) {
      case "string":
        h = Xe(g[a].since).startOf("day"), g[a].since = h.valueOf();
        break;
    }
    switch (typeof g[a].until) {
      case "undefined":
        g[a].until = 1 / 0;
        break;
      case "string":
        h = Xe(g[a].until).startOf("day").valueOf(), g[a].until = h.valueOf();
        break;
    }
  }
  return g;
}
function Fz(e, n, a) {
  var i, h, g = this.eras(), m, S, b;
  for (e = e.toUpperCase(), i = 0, h = g.length; i < h; ++i)
    if (m = g[i].name.toUpperCase(), S = g[i].abbr.toUpperCase(), b = g[i].narrow.toUpperCase(), a)
      switch (n) {
        case "N":
        case "NN":
        case "NNN":
          if (S === e)
            return g[i];
          break;
        case "NNNN":
          if (m === e)
            return g[i];
          break;
        case "NNNNN":
          if (b === e)
            return g[i];
          break;
      }
    else if ([m, S, b].indexOf(e) >= 0)
      return g[i];
}
function Bz(e, n) {
  var a = e.since <= e.until ? 1 : -1;
  return n === void 0 ? Xe(e.since).year() : Xe(e.since).year() + (n - e.offset) * a;
}
function Uz() {
  var e, n, a, i = this.localeData().eras();
  for (e = 0, n = i.length; e < n; ++e)
    if (a = this.clone().startOf("day").valueOf(), i[e].since <= a && a <= i[e].until || i[e].until <= a && a <= i[e].since)
      return i[e].name;
  return "";
}
function Yz() {
  var e, n, a, i = this.localeData().eras();
  for (e = 0, n = i.length; e < n; ++e)
    if (a = this.clone().startOf("day").valueOf(), i[e].since <= a && a <= i[e].until || i[e].until <= a && a <= i[e].since)
      return i[e].narrow;
  return "";
}
function $z() {
  var e, n, a, i = this.localeData().eras();
  for (e = 0, n = i.length; e < n; ++e)
    if (a = this.clone().startOf("day").valueOf(), i[e].since <= a && a <= i[e].until || i[e].until <= a && a <= i[e].since)
      return i[e].abbr;
  return "";
}
function Wz() {
  var e, n, a, i, h = this.localeData().eras();
  for (e = 0, n = h.length; e < n; ++e)
    if (a = h[e].since <= h[e].until ? 1 : -1, i = this.clone().startOf("day").valueOf(), h[e].since <= i && i <= h[e].until || h[e].until <= i && i <= h[e].since)
      return (this.year() - Xe(h[e].since).year()) * a + h[e].offset;
  return this.year();
}
function zz(e) {
  return ur(this, "_erasNameRegex") || nS.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function qz(e) {
  return ur(this, "_erasAbbrRegex") || nS.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function Gz(e) {
  return ur(this, "_erasNarrowRegex") || nS.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function tS(e, n) {
  return n.erasAbbrRegex(e);
}
function Kz(e, n) {
  return n.erasNameRegex(e);
}
function Qz(e, n) {
  return n.erasNarrowRegex(e);
}
function Xz(e, n) {
  return n._eraYearOrdinalRegex || Qp;
}
function nS() {
  var e = [], n = [], a = [], i = [], h, g, m = this.eras();
  for (h = 0, g = m.length; h < g; ++h)
    n.push(Du(m[h].name)), e.push(Du(m[h].abbr)), a.push(Du(m[h].narrow)), i.push(Du(m[h].name)), i.push(Du(m[h].abbr)), i.push(Du(m[h].narrow));
  this._erasRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + a.join("|") + ")",
    "i"
  );
}
Yt(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
Yt(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Dw(e, n) {
  Yt(0, [e, e.length], 0, n);
}
Dw("gggg", "weekYear");
Dw("ggggg", "weekYear");
Dw("GGGG", "isoWeekYear");
Dw("GGGGG", "isoWeekYear");
zi("weekYear", "gg");
zi("isoWeekYear", "GG");
qi("weekYear", 1);
qi("isoWeekYear", 1);
bt("G", Rw);
bt("g", Rw);
bt("GG", ia, ju);
bt("gg", ia, ju);
bt("GGGG", $8, Y8);
bt("gggg", $8, Y8);
bt("GGGGG", _w, Cw);
bt("ggggg", _w, Cw);
g3(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, n, a, i) {
    n[i.substr(0, 2)] = Mn(e);
  }
);
g3(["gg", "GG"], function(e, n, a, i) {
  n[i] = Xe.parseTwoDigitYear(e);
});
function Jz(e) {
  return TO.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function eq(e) {
  return TO.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function tq() {
  return hf(this.year(), 1, 4);
}
function nq() {
  return hf(this.isoWeekYear(), 1, 4);
}
function rq() {
  var e = this.localeData()._week;
  return hf(this.year(), e.dow, e.doy);
}
function aq() {
  var e = this.localeData()._week;
  return hf(this.weekYear(), e.dow, e.doy);
}
function TO(e, n, a, i, h) {
  var g;
  return e == null ? Y4(this, i, h).year : (g = hf(e, i, h), n > g && (n = g), oq.call(this, e, n, a, i, h));
}
function oq(e, n, a, i, h) {
  var g = lO(e, n, a, i, h), m = U4(g.year, 0, g.dayOfYear);
  return this.year(m.getUTCFullYear()), this.month(m.getUTCMonth()), this.date(m.getUTCDate()), this;
}
Yt("Q", 0, "Qo", "quarter");
zi("quarter", "Q");
qi("quarter", 7);
bt("Q", QT);
Ar("Q", function(e, n) {
  n[ff] = (Mn(e) - 1) * 3;
});
function iq(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
Yt("D", ["DD", 2], "Do", "date");
zi("date", "D");
qi("date", 9);
bt("D", ia);
bt("DD", ia, ju);
bt("Do", function(e, n) {
  return e ? n._dayOfMonthOrdinalParse || n._ordinalParse : n._dayOfMonthOrdinalParseLenient;
});
Ar(["D", "DD"], H0);
Ar("Do", function(e, n) {
  n[H0] = Mn(e.match(ia)[0]);
});
var OO = Kp("Date", !0);
Yt("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
zi("dayOfYear", "DDD");
qi("dayOfYear", 4);
bt("DDD", bw);
bt("DDDD", XT);
Ar(["DDD", "DDDD"], function(e, n, a) {
  a._dayOfYear = Mn(e);
});
function lq(e) {
  var n = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? n : this.add(e - n, "d");
}
Yt("m", ["mm", 2], 0, "minute");
zi("minute", "m");
qi("minute", 14);
bt("m", ia);
bt("mm", ia, ju);
Ar(["m", "mm"], b1);
var uq = Kp("Minutes", !1);
Yt("s", ["ss", 2], 0, "second");
zi("second", "s");
qi("second", 15);
bt("s", ia);
bt("ss", ia, ju);
Ar(["s", "ss"], df);
var sq = Kp("Seconds", !1);
Yt("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
Yt(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
Yt(0, ["SSS", 3], 0, "millisecond");
Yt(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
Yt(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
Yt(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
Yt(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
Yt(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
Yt(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
zi("millisecond", "ms");
qi("millisecond", 16);
bt("S", bw, QT);
bt("SS", bw, ju);
bt("SSS", bw, XT);
var eh, DO;
for (eh = "SSSS"; eh.length <= 9; eh += "S")
  bt(eh, Qp);
function cq(e, n) {
  n[M2] = Mn(("0." + e) * 1e3);
}
for (eh = "S"; eh.length <= 9; eh += "S")
  Ar(eh, cq);
DO = Kp("Milliseconds", !1);
Yt("z", 0, 0, "zoneAbbr");
Yt("zz", 0, 0, "zoneName");
function fq() {
  return this._isUTC ? "UTC" : "";
}
function dq() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var Ke = p3.prototype;
Ke.add = az;
Ke.calendar = fz;
Ke.clone = dz;
Ke.diff = yz;
Ke.endOf = Oz;
Ke.format = bz;
Ke.from = _z;
Ke.fromNow = Rz;
Ke.to = Ez;
Ke.toNow = Mz;
Ke.get = v$;
Ke.invalidAt = Pz;
Ke.isAfter = hz;
Ke.isBefore = vz;
Ke.isBetween = pz;
Ke.isSame = mz;
Ke.isSameOrAfter = gz;
Ke.isSameOrBefore = wz;
Ke.isValid = Hz;
Ke.lang = bO;
Ke.locale = CO;
Ke.localeData = _O;
Ke.max = HW;
Ke.min = IW;
Ke.parsingFlags = Zz;
Ke.set = p$;
Ke.startOf = Tz;
Ke.subtract = oz;
Ke.toArray = kz;
Ke.toObject = Lz;
Ke.toDate = jz;
Ke.toISOString = Sz;
Ke.inspect = Cz;
typeof Symbol < "u" && Symbol.for != null && (Ke[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
Ke.toJSON = Iz;
Ke.toString = xz;
Ke.unix = Az;
Ke.valueOf = Dz;
Ke.creationData = Nz;
Ke.eraName = Uz;
Ke.eraNarrow = Yz;
Ke.eraAbbr = $z;
Ke.eraYear = Wz;
Ke.year = iO;
Ke.isLeapYear = L$;
Ke.weekYear = Jz;
Ke.isoWeekYear = eq;
Ke.quarter = Ke.quarters = iq;
Ke.month = aO;
Ke.daysInMonth = A$;
Ke.week = Ke.weeks = V$;
Ke.isoWeek = Ke.isoWeeks = F$;
Ke.weeksInYear = rq;
Ke.weeksInWeekYear = aq;
Ke.isoWeeksInYear = tq;
Ke.isoWeeksInISOWeekYear = nq;
Ke.date = OO;
Ke.day = Ke.days = eW;
Ke.weekday = tW;
Ke.isoWeekday = nW;
Ke.dayOfYear = lq;
Ke.hour = Ke.hours = sW;
Ke.minute = Ke.minutes = uq;
Ke.second = Ke.seconds = sq;
Ke.millisecond = Ke.milliseconds = DO;
Ke.utcOffset = $W;
Ke.utc = zW;
Ke.local = qW;
Ke.parseZone = GW;
Ke.hasAlignedHourOffset = KW;
Ke.isDST = QW;
Ke.isLocal = JW;
Ke.isUtcOffset = ez;
Ke.isUtc = wO;
Ke.isUTC = wO;
Ke.zoneAbbr = fq;
Ke.zoneName = dq;
Ke.dates = Ts(
  "dates accessor is deprecated. Use date instead.",
  OO
);
Ke.months = Ts(
  "months accessor is deprecated. Use month instead",
  aO
);
Ke.years = Ts(
  "years accessor is deprecated. Use year instead",
  iO
);
Ke.zone = Ts(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  WW
);
Ke.isDSTShifted = Ts(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  XW
);
function hq(e) {
  return oa(e * 1e3);
}
function vq() {
  return oa.apply(null, arguments).parseZone();
}
function AO(e) {
  return e;
}
var sr = F8.prototype;
sr.calendar = e$;
sr.longDateFormat = a$;
sr.invalidDate = i$;
sr.ordinal = s$;
sr.preparse = AO;
sr.postformat = AO;
sr.relativeTime = f$;
sr.pastFuture = d$;
sr.set = XY;
sr.eras = Vz;
sr.erasParse = Fz;
sr.erasConvertYear = Bz;
sr.erasAbbrRegex = qz;
sr.erasNameRegex = zz;
sr.erasNarrowRegex = Gz;
sr.months = M$;
sr.monthsShort = T$;
sr.monthsParse = D$;
sr.monthsRegex = k$;
sr.monthsShortRegex = j$;
sr.week = H$;
sr.firstDayOfYear = N$;
sr.firstDayOfWeek = P$;
sr.weekdays = G$;
sr.weekdaysMin = Q$;
sr.weekdaysShort = K$;
sr.weekdaysParse = J$;
sr.weekdaysRegex = rW;
sr.weekdaysShortRegex = aW;
sr.weekdaysMinRegex = oW;
sr.isPM = lW;
sr.meridiem = cW;
function A5(e, n, a, i) {
  var h = bf(), g = U0().set(i, n);
  return h[a](g, e);
}
function jO(e, n, a) {
  if (gf(e) && (n = e, e = void 0), e = e || "", n != null)
    return A5(e, n, a, "month");
  var i, h = [];
  for (i = 0; i < 12; i++)
    h[i] = A5(e, i, a, "month");
  return h;
}
function rS(e, n, a, i) {
  typeof e == "boolean" ? (gf(n) && (a = n, n = void 0), n = n || "") : (n = e, a = n, e = !1, gf(n) && (a = n, n = void 0), n = n || "");
  var h = bf(), g = e ? h._week.dow : 0, m, S = [];
  if (a != null)
    return A5(n, (a + g) % 7, i, "day");
  for (m = 0; m < 7; m++)
    S[m] = A5(n, (m + g) % 7, i, "day");
  return S;
}
function pq(e, n) {
  return jO(e, n, "months");
}
function mq(e, n) {
  return jO(e, n, "monthsShort");
}
function gq(e, n, a) {
  return rS(e, n, a, "weekdays");
}
function wq(e, n, a) {
  return rS(e, n, a, "weekdaysShort");
}
function yq(e, n, a) {
  return rS(e, n, a, "weekdaysMin");
}
ah("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var n = e % 10, a = Mn(e % 100 / 10) === 1 ? "th" : n === 1 ? "st" : n === 2 ? "nd" : n === 3 ? "rd" : "th";
    return e + a;
  }
});
Xe.lang = Ts(
  "moment.lang is deprecated. Use moment.locale instead.",
  ah
);
Xe.langData = Ts(
  "moment.langData is deprecated. Use moment.localeData instead.",
  bf
);
var lf = Math.abs;
function xq() {
  var e = this._data;
  return this._milliseconds = lf(this._milliseconds), this._days = lf(this._days), this._months = lf(this._months), e.milliseconds = lf(e.milliseconds), e.seconds = lf(e.seconds), e.minutes = lf(e.minutes), e.hours = lf(e.hours), e.months = lf(e.months), e.years = lf(e.years), this;
}
function kO(e, n, a, i) {
  var h = T1(n, a);
  return e._milliseconds += i * h._milliseconds, e._days += i * h._days, e._months += i * h._months, e._bubble();
}
function Sq(e, n) {
  return kO(this, e, n, 1);
}
function Cq(e, n) {
  return kO(this, e, n, -1);
}
function DR(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function bq() {
  var e = this._milliseconds, n = this._days, a = this._months, i = this._data, h, g, m, S, b;
  return e >= 0 && n >= 0 && a >= 0 || e <= 0 && n <= 0 && a <= 0 || (e += DR(yx(a) + n) * 864e5, n = 0, a = 0), i.milliseconds = e % 1e3, h = Es(e / 1e3), i.seconds = h % 60, g = Es(h / 60), i.minutes = g % 60, m = Es(g / 60), i.hours = m % 24, n += Es(m / 24), b = Es(LO(n)), a += b, n -= DR(yx(b)), S = Es(a / 12), a %= 12, i.days = n, i.months = a, i.years = S, this;
}
function LO(e) {
  return e * 4800 / 146097;
}
function yx(e) {
  return e * 146097 / 4800;
}
function _q(e) {
  if (!this.isValid())
    return NaN;
  var n, a, i = this._milliseconds;
  if (e = Os(e), e === "month" || e === "quarter" || e === "year")
    switch (n = this._days + i / 864e5, a = this._months + LO(n), e) {
      case "month":
        return a;
      case "quarter":
        return a / 3;
      case "year":
        return a / 12;
    }
  else
    switch (n = this._days + Math.round(yx(this._months)), e) {
      case "week":
        return n / 7 + i / 6048e5;
      case "day":
        return n + i / 864e5;
      case "hour":
        return n * 24 + i / 36e5;
      case "minute":
        return n * 1440 + i / 6e4;
      case "second":
        return n * 86400 + i / 1e3;
      case "millisecond":
        return Math.floor(n * 864e5) + i;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function Rq() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + Mn(this._months / 12) * 31536e6 : NaN;
}
function _f(e) {
  return function() {
    return this.as(e);
  };
}
var Eq = _f("ms"), Mq = _f("s"), Tq = _f("m"), Oq = _f("h"), Dq = _f("d"), Aq = _f("w"), jq = _f("M"), kq = _f("Q"), Lq = _f("y");
function Iq() {
  return T1(this);
}
function Hq(e) {
  return e = Os(e), this.isValid() ? this[e + "s"]() : NaN;
}
function V2(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var Zq = V2("milliseconds"), Pq = V2("seconds"), Nq = V2("minutes"), Vq = V2("hours"), Fq = V2("days"), Bq = V2("months"), Uq = V2("years");
function Yq() {
  return Es(this.days() / 7);
}
var sf = Math.round, Ap = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function $q(e, n, a, i, h) {
  return h.relativeTime(n || 1, !!a, e, i);
}
function Wq(e, n, a, i) {
  var h = T1(e).abs(), g = sf(h.as("s")), m = sf(h.as("m")), S = sf(h.as("h")), b = sf(h.as("d")), R = sf(h.as("M")), D = sf(h.as("w")), T = sf(h.as("y")), A = g <= a.ss && ["s", g] || g < a.s && ["ss", g] || m <= 1 && ["m"] || m < a.m && ["mm", m] || S <= 1 && ["h"] || S < a.h && ["hh", S] || b <= 1 && ["d"] || b < a.d && ["dd", b];
  return a.w != null && (A = A || D <= 1 && ["w"] || D < a.w && ["ww", D]), A = A || R <= 1 && ["M"] || R < a.M && ["MM", R] || T <= 1 && ["y"] || ["yy", T], A[2] = n, A[3] = +e > 0, A[4] = i, $q.apply(null, A);
}
function zq(e) {
  return e === void 0 ? sf : typeof e == "function" ? (sf = e, !0) : !1;
}
function qq(e, n) {
  return Ap[e] === void 0 ? !1 : n === void 0 ? Ap[e] : (Ap[e] = n, e === "s" && (Ap.ss = n - 1), !0);
}
function Gq(e, n) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var a = !1, i = Ap, h, g;
  return typeof e == "object" && (n = e, e = !1), typeof e == "boolean" && (a = e), typeof n == "object" && (i = Object.assign({}, Ap, n), n.s != null && n.ss == null && (i.ss = n.s - 1)), h = this.localeData(), g = Wq(this, !a, i, h), a && (g = h.pastFuture(+this, g)), h.postformat(g);
}
var B9 = Math.abs;
function Ep(e) {
  return (e > 0) - (e < 0) || +e;
}
function Aw() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = B9(this._milliseconds) / 1e3, n = B9(this._days), a = B9(this._months), i, h, g, m, S = this.asSeconds(), b, R, D, T;
  return S ? (i = Es(e / 60), h = Es(i / 60), e %= 60, i %= 60, g = Es(a / 12), a %= 12, m = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", b = S < 0 ? "-" : "", R = Ep(this._months) !== Ep(S) ? "-" : "", D = Ep(this._days) !== Ep(S) ? "-" : "", T = Ep(this._milliseconds) !== Ep(S) ? "-" : "", b + "P" + (g ? R + g + "Y" : "") + (a ? R + a + "M" : "") + (n ? D + n + "D" : "") + (h || i || e ? "T" : "") + (h ? T + h + "H" : "") + (i ? T + i + "M" : "") + (e ? T + m + "S" : "")) : "P0D";
}
var Jn = Ow.prototype;
Jn.isValid = FW;
Jn.abs = xq;
Jn.add = Sq;
Jn.subtract = Cq;
Jn.as = _q;
Jn.asMilliseconds = Eq;
Jn.asSeconds = Mq;
Jn.asMinutes = Tq;
Jn.asHours = Oq;
Jn.asDays = Dq;
Jn.asWeeks = Aq;
Jn.asMonths = jq;
Jn.asQuarters = kq;
Jn.asYears = Lq;
Jn.valueOf = Rq;
Jn._bubble = bq;
Jn.clone = Iq;
Jn.get = Hq;
Jn.milliseconds = Zq;
Jn.seconds = Pq;
Jn.minutes = Nq;
Jn.hours = Vq;
Jn.days = Fq;
Jn.weeks = Yq;
Jn.months = Bq;
Jn.years = Uq;
Jn.humanize = Gq;
Jn.toISOString = Aw;
Jn.toString = Aw;
Jn.toJSON = Aw;
Jn.locale = CO;
Jn.localeData = _O;
Jn.toIsoString = Ts(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Aw
);
Jn.lang = bO;
Yt("X", 0, 0, "unix");
Yt("x", 0, 0, "valueOf");
bt("x", Rw);
bt("X", g$);
Ar("X", function(e, n, a) {
  a._d = new Date(parseFloat(e) * 1e3);
});
Ar("x", function(e, n, a) {
  a._d = new Date(Mn(e));
});
//! moment.js
Xe.version = "2.29.4";
KY(oa);
Xe.fn = Ke;
Xe.min = ZW;
Xe.max = PW;
Xe.now = NW;
Xe.utc = U0;
Xe.unix = hq;
Xe.months = pq;
Xe.isDate = v3;
Xe.locale = ah;
Xe.invalid = xw;
Xe.duration = T1;
Xe.isMoment = M1;
Xe.weekdays = gq;
Xe.parseZone = vq;
Xe.localeData = bf;
Xe.isDuration = d5;
Xe.monthsShort = mq;
Xe.weekdaysMin = yq;
Xe.defineLocale = G8;
Xe.updateLocale = vW;
Xe.locales = pW;
Xe.weekdaysShort = wq;
Xe.normalizeUnits = Os;
Xe.relativeTimeRounding = zq;
Xe.relativeTimeThreshold = qq;
Xe.calendarFormat = cz;
Xe.prototype = Ke;
Xe.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
var xx = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(e, n) {
  (function() {
    var a, i = "4.17.21", h = 200, g = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", m = "Expected a function", S = "Invalid `variable` option passed into `_.template`", b = "__lodash_hash_undefined__", R = 500, D = "__lodash_placeholder__", T = 1, A = 2, j = 4, I = 1, Z = 2, N = 1, B = 2, $ = 4, W = 8, z = 16, Y = 32, ie = 64, G = 128, pe = 256, J = 512, me = 30, oe = "...", ge = 800, ce = 16, Se = 1, Re = 2, _e = 3, Ye = 1 / 0, ue = 9007199254740991, Ae = 17976931348623157e292, Pe = NaN, dt = 4294967295, Ze = dt - 1, qe = dt >>> 1, Je = [
      ["ary", G],
      ["bind", N],
      ["bindKey", B],
      ["curry", W],
      ["curryRight", z],
      ["flip", J],
      ["partial", Y],
      ["partialRight", ie],
      ["rearg", pe]
    ], ot = "[object Arguments]", Nt = "[object Array]", Tn = "[object AsyncFunction]", Qt = "[object Boolean]", Hn = "[object Date]", ar = "[object DOMException]", Wn = "[object Error]", zn = "[object Function]", qn = "[object GeneratorFunction]", Gn = "[object Map]", wr = "[object Number]", Ta = "[object Null]", jr = "[object Object]", Mt = "[object Promise]", fn = "[object Proxy]", Sn = "[object RegExp]", jt = "[object Set]", On = "[object String]", Gr = "[object Symbol]", Ge = "[object Undefined]", $t = "[object WeakMap]", Cn = "[object WeakSet]", gn = "[object ArrayBuffer]", cr = "[object DataView]", Qe = "[object Float32Array]", at = "[object Float64Array]", Lt = "[object Int8Array]", Un = "[object Int16Array]", dr = "[object Int32Array]", ga = "[object Uint8Array]", Nr = "[object Uint8ClampedArray]", Oa = "[object Uint16Array]", br = "[object Uint32Array]", _r = /\b__p \+= '';/g, kr = /\b(__p \+=) '' \+/g, O1 = /(__e\(.*?\)|\b__t\)) \+\n'';/g, to = /&(?:amp|lt|gt|quot|#39);/g, Jo = /[&<>"']/g, D1 = RegExp(to.source), W0 = RegExp(Jo.source), z0 = /<%-([\s\S]+?)%>/g, A1 = /<%([\s\S]+?)%>/g, q0 = /<%=([\s\S]+?)%>/g, As = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, js = /^\w*$/, _i = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ei = /[\\^$.*+?()[\]{}|]/g, ti = RegExp(ei.source), ku = /^\s+/, ql = /\s/, Lu = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Iu = /\{\n\/\* \[wrapped with (.+)\] \*/, Cl = /,? & /, X = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, We = /[()=,{}\[\]\/\s]/, lt = /\\(\\)?/g, vt = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, bn = /\w*$/, Kn = /^[-+]0x[0-9a-f]+$/i, dn = /^0b[01]+$/i, ln = /^\[object .+?Constructor\]$/, Da = /^0o[0-7]+$/i, Rr = /^(?:0|[1-9]\d*)$/, Er = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Fa = /($^)/, Io = /['\n\r\u2028\u2029\\]/g, mt = "\\ud800-\\udfff", la = "\\u0300-\\u036f", Hu = "\\ufe20-\\ufe2f", G0 = "\\u20d0-\\u20ff", Zu = la + Hu + G0, Sh = "\\u2700-\\u27bf", Rf = "a-z\\xdf-\\xf6\\xf8-\\xff", K0 = "\\xac\\xb1\\xd7\\xf7", Gi = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", F2 = "\\u2000-\\u206f", Ki = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", B2 = "A-Z\\xc0-\\xd6\\xd8-\\xde", Ef = "\\ufe0e\\ufe0f", Mf = K0 + Gi + F2 + Ki, ni = "['’]", j1 = "[" + mt + "]", Gl = "[" + Mf + "]", ks = "[" + Zu + "]", Tf = "\\d+", Jp = "[" + Sh + "]", k1 = "[" + Rf + "]", Ch = "[^" + mt + Mf + Tf + Sh + Rf + B2 + "]", Ls = "\\ud83c[\\udffb-\\udfff]", Q0 = "(?:" + ks + "|" + Ls + ")", bh = "[^" + mt + "]", X0 = "(?:\\ud83c[\\udde6-\\uddff]){2}", Zn = "[\\ud800-\\udbff][\\udc00-\\udfff]", _n = "[" + B2 + "]", _h = "\\u200d", J0 = "(?:" + k1 + "|" + Ch + ")", tn = "(?:" + _n + "|" + Ch + ")", Of = "(?:" + ni + "(?:d|ll|m|re|s|t|ve))?", vo = "(?:" + ni + "(?:D|LL|M|RE|S|T|VE))?", Pu = Q0 + "?", Kl = "[" + Ef + "]?", Nu = "(?:" + _h + "(?:" + [bh, X0, Zn].join("|") + ")" + Kl + Pu + ")*", Vr = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", or = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", L1 = Kl + Pu + Nu, Ho = "(?:" + [Jp, X0, Zn].join("|") + ")" + L1, wa = "(?:" + [bh + ks + "?", ks, X0, Zn, j1].join("|") + ")", Vu = RegExp(ni, "g"), U2 = RegExp(ks, "g"), Ql = RegExp(Ls + "(?=" + Ls + ")|" + wa + L1, "g"), Y2 = RegExp([
      _n + "?" + k1 + "+" + Of + "(?=" + [Gl, _n, "$"].join("|") + ")",
      tn + "+" + vo + "(?=" + [Gl, _n + J0, "$"].join("|") + ")",
      _n + "?" + J0 + "+" + Of,
      _n + "+" + vo,
      or,
      Vr,
      Tf,
      Ho
    ].join("|"), "g"), Rh = RegExp("[" + _h + mt + Zu + Ef + "]"), Df = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, $2 = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], em = -1, Pn = {};
    Pn[Qe] = Pn[at] = Pn[Lt] = Pn[Un] = Pn[dr] = Pn[ga] = Pn[Nr] = Pn[Oa] = Pn[br] = !0, Pn[ot] = Pn[Nt] = Pn[gn] = Pn[Qt] = Pn[cr] = Pn[Hn] = Pn[Wn] = Pn[zn] = Pn[Gn] = Pn[wr] = Pn[jr] = Pn[Sn] = Pn[jt] = Pn[On] = Pn[$t] = !1;
    var Yn = {};
    Yn[ot] = Yn[Nt] = Yn[gn] = Yn[cr] = Yn[Qt] = Yn[Hn] = Yn[Qe] = Yn[at] = Yn[Lt] = Yn[Un] = Yn[dr] = Yn[Gn] = Yn[wr] = Yn[jr] = Yn[Sn] = Yn[jt] = Yn[On] = Yn[Gr] = Yn[ga] = Yn[Nr] = Yn[Oa] = Yn[br] = !0, Yn[Wn] = Yn[zn] = Yn[$t] = !1;
    var Xl = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, ec = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, W2 = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, z2 = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Af = parseFloat, tc = parseInt, I1 = typeof R4 == "object" && R4 && R4.Object === Object && R4, Eh = typeof self == "object" && self && self.Object === Object && self, yr = I1 || Eh || Function("return this")(), Is = n && !n.nodeType && n, Qi = Is && !0 && e && !e.nodeType && e, Mh = Qi && Qi.exports === Is, H1 = Mh && I1.process, Ba = function() {
      try {
        var le = Qi && Qi.require && Qi.require("util").types;
        return le || H1 && H1.binding && H1.binding("util");
      } catch {
      }
    }(), jf = Ba && Ba.isArrayBuffer, po = Ba && Ba.isDate, Fu = Ba && Ba.isMap, nc = Ba && Ba.isRegExp, Z1 = Ba && Ba.isSet, q2 = Ba && Ba.isTypedArray;
    function er(le, Ee, we) {
      switch (we.length) {
        case 0:
          return le.call(Ee);
        case 1:
          return le.call(Ee, we[0]);
        case 2:
          return le.call(Ee, we[0], we[1]);
        case 3:
          return le.call(Ee, we[0], we[1], we[2]);
      }
      return le.apply(Ee, we);
    }
    function rc(le, Ee, we, ut) {
      for (var Gt = -1, cn = le == null ? 0 : le.length; ++Gt < cn; ) {
        var Lr = le[Gt];
        Ee(ut, Lr, we(Lr), le);
      }
      return ut;
    }
    function Ua(le, Ee) {
      for (var we = -1, ut = le == null ? 0 : le.length; ++we < ut && Ee(le[we], we, le) !== !1; )
        ;
      return le;
    }
    function ac(le, Ee) {
      for (var we = le == null ? 0 : le.length; we-- && Ee(le[we], we, le) !== !1; )
        ;
      return le;
    }
    function Th(le, Ee) {
      for (var we = -1, ut = le == null ? 0 : le.length; ++we < ut; )
        if (!Ee(le[we], we, le))
          return !1;
      return !0;
    }
    function ri(le, Ee) {
      for (var we = -1, ut = le == null ? 0 : le.length, Gt = 0, cn = []; ++we < ut; ) {
        var Lr = le[we];
        Ee(Lr, we, le) && (cn[Gt++] = Lr);
      }
      return cn;
    }
    function P1(le, Ee) {
      var we = le == null ? 0 : le.length;
      return !!we && N1(le, Ee, 0) > -1;
    }
    function kf(le, Ee, we) {
      for (var ut = -1, Gt = le == null ? 0 : le.length; ++ut < Gt; )
        if (we(Ee, le[ut]))
          return !0;
      return !1;
    }
    function hr(le, Ee) {
      for (var we = -1, ut = le == null ? 0 : le.length, Gt = Array(ut); ++we < ut; )
        Gt[we] = Ee(le[we], we, le);
      return Gt;
    }
    function Bu(le, Ee) {
      for (var we = -1, ut = Ee.length, Gt = le.length; ++we < ut; )
        le[Gt + we] = Ee[we];
      return le;
    }
    function Oh(le, Ee, we, ut) {
      var Gt = -1, cn = le == null ? 0 : le.length;
      for (ut && cn && (we = le[++Gt]); ++Gt < cn; )
        we = Ee(we, le[Gt], Gt, le);
      return we;
    }
    function G2(le, Ee, we, ut) {
      var Gt = le == null ? 0 : le.length;
      for (ut && Gt && (we = le[--Gt]); Gt--; )
        we = Ee(we, le[Gt], Gt, le);
      return we;
    }
    function oc(le, Ee) {
      for (var we = -1, ut = le == null ? 0 : le.length; ++we < ut; )
        if (Ee(le[we], we, le))
          return !0;
      return !1;
    }
    var K2 = Ah("length");
    function Dh(le) {
      return le.split("");
    }
    function Q2(le) {
      return le.match(X) || [];
    }
    function X2(le, Ee, we) {
      var ut;
      return we(le, function(Gt, cn, Lr) {
        if (Ee(Gt, cn, Lr))
          return ut = cn, !1;
      }), ut;
    }
    function Ri(le, Ee, we, ut) {
      for (var Gt = le.length, cn = we + (ut ? 1 : -1); ut ? cn-- : ++cn < Gt; )
        if (Ee(le[cn], cn, le))
          return cn;
      return -1;
    }
    function N1(le, Ee, we) {
      return Ee === Ee ? Pf(le, Ee, we) : Ri(le, Lf, we);
    }
    function ic(le, Ee, we, ut) {
      for (var Gt = we - 1, cn = le.length; ++Gt < cn; )
        if (ut(le[Gt], Ee))
          return Gt;
      return -1;
    }
    function Lf(le) {
      return le !== le;
    }
    function If(le, Ee) {
      var we = le == null ? 0 : le.length;
      return we ? Xi(le, Ee) / we : Pe;
    }
    function Ah(le) {
      return function(Ee) {
        return Ee == null ? a : Ee[le];
      };
    }
    function Hs(le) {
      return function(Ee) {
        return le == null ? a : le[Ee];
      };
    }
    function jh(le, Ee, we, ut, Gt) {
      return Gt(le, function(cn, Lr, tr) {
        we = ut ? (ut = !1, cn) : Ee(we, cn, Lr, tr);
      }), we;
    }
    function Zo(le, Ee) {
      var we = le.length;
      for (le.sort(Ee); we--; )
        le[we] = le[we].value;
      return le;
    }
    function Xi(le, Ee) {
      for (var we, ut = -1, Gt = le.length; ++ut < Gt; ) {
        var cn = Ee(le[ut]);
        cn !== a && (we = we === a ? cn : we + cn);
      }
      return we;
    }
    function Fr(le, Ee) {
      for (var we = -1, ut = Array(le); ++we < le; )
        ut[we] = Ee(we);
      return ut;
    }
    function Jl(le, Ee) {
      return hr(Ee, function(we) {
        return [we, le[we]];
      });
    }
    function Hf(le) {
      return le && le.slice(0, Nf(le) + 1).replace(ku, "");
    }
    function no(le) {
      return function(Ee) {
        return le(Ee);
      };
    }
    function lc(le, Ee) {
      return hr(Ee, function(we) {
        return le[we];
      });
    }
    function ai(le, Ee) {
      return le.has(Ee);
    }
    function J2(le, Ee) {
      for (var we = -1, ut = le.length; ++we < ut && N1(Ee, le[we], 0) > -1; )
        ;
      return we;
    }
    function kh(le, Ee) {
      for (var we = le.length; we-- && N1(Ee, le[we], 0) > -1; )
        ;
      return we;
    }
    function Zf(le, Ee) {
      for (var we = le.length, ut = 0; we--; )
        le[we] === Ee && ++ut;
      return ut;
    }
    var ev = Hs(Xl), tv = Hs(ec);
    function nv(le) {
      return "\\" + z2[le];
    }
    function Zs(le, Ee) {
      return le == null ? a : le[Ee];
    }
    function V1(le) {
      return Rh.test(le);
    }
    function tm(le) {
      return Df.test(le);
    }
    function nm(le) {
      for (var Ee, we = []; !(Ee = le.next()).done; )
        we.push(Ee.value);
      return we;
    }
    function uc(le) {
      var Ee = -1, we = Array(le.size);
      return le.forEach(function(ut, Gt) {
        we[++Ee] = [Gt, ut];
      }), we;
    }
    function Uu(le, Ee) {
      return function(we) {
        return le(Ee(we));
      };
    }
    function Po(le, Ee) {
      for (var we = -1, ut = le.length, Gt = 0, cn = []; ++we < ut; ) {
        var Lr = le[we];
        (Lr === Ee || Lr === D) && (le[we] = D, cn[Gt++] = we);
      }
      return cn;
    }
    function eu(le) {
      var Ee = -1, we = Array(le.size);
      return le.forEach(function(ut) {
        we[++Ee] = ut;
      }), we;
    }
    function rv(le) {
      var Ee = -1, we = Array(le.size);
      return le.forEach(function(ut) {
        we[++Ee] = [ut, ut];
      }), we;
    }
    function Pf(le, Ee, we) {
      for (var ut = we - 1, Gt = le.length; ++ut < Gt; )
        if (le[ut] === Ee)
          return ut;
      return -1;
    }
    function rm(le, Ee, we) {
      for (var ut = we + 1; ut--; )
        if (le[ut] === Ee)
          return ut;
      return ut;
    }
    function Ps(le) {
      return V1(le) ? ov(le) : K2(le);
    }
    function oi(le) {
      return V1(le) ? iv(le) : Dh(le);
    }
    function Nf(le) {
      for (var Ee = le.length; Ee-- && ql.test(le.charAt(Ee)); )
        ;
      return Ee;
    }
    var av = Hs(W2);
    function ov(le) {
      for (var Ee = Ql.lastIndex = 0; Ql.test(le); )
        ++Ee;
      return Ee;
    }
    function iv(le) {
      return le.match(Ql) || [];
    }
    function lv(le) {
      return le.match(Y2) || [];
    }
    var am = function le(Ee) {
      Ee = Ee == null ? yr : Ns.defaults(yr.Object(), Ee, Ns.pick(yr, $2));
      var we = Ee.Array, ut = Ee.Date, Gt = Ee.Error, cn = Ee.Function, Lr = Ee.Math, tr = Ee.Object, bl = Ee.RegExp, om = Ee.String, Ei = Ee.TypeError, tu = we.prototype, Lh = cn.prototype, _l = tr.prototype, Vs = Ee["__core-js_shared__"], sc = Lh.toString, Dn = _l.hasOwnProperty, ua = 0, cc = function() {
        var s = /[^.]+$/.exec(Vs && Vs.keys && Vs.keys.IE_PROTO || "");
        return s ? "Symbol(src)_1." + s : "";
      }(), fc = _l.toString, Vf = sc.call(tr), uv = yr._, sv = bl(
        "^" + sc.call(Dn).replace(ei, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), dc = Mh ? Ee.Buffer : a, Rl = Ee.Symbol, Fs = Ee.Uint8Array, Bs = dc ? dc.allocUnsafe : a, Ji = Uu(tr.getPrototypeOf, tr), Yu = tr.create, Ff = _l.propertyIsEnumerable, Bf = tu.splice, cv = Rl ? Rl.isConcatSpreadable : a, el = Rl ? Rl.iterator : a, nu = Rl ? Rl.toStringTag : a, El = function() {
        try {
          var s = uo(tr, "defineProperty");
          return s({}, "", {}), s;
        } catch {
        }
      }(), Us = Ee.clearTimeout !== yr.clearTimeout && Ee.clearTimeout, vr = ut && ut.now !== yr.Date.now && ut.now, Ih = Ee.setTimeout !== yr.setTimeout && Ee.setTimeout, $u = Lr.ceil, Wu = Lr.floor, hc = tr.getOwnPropertySymbols, Uf = dc ? dc.isBuffer : a, Ys = Ee.isFinite, F1 = tu.join, B1 = Uu(tr.keys, tr), Kr = Lr.max, ro = Lr.min, im = ut.now, fv = Ee.parseInt, ru = Lr.random, U1 = tu.reverse, au = uo(Ee, "DataView"), zu = uo(Ee, "Map"), Y1 = uo(Ee, "Promise"), Ml = uo(Ee, "Set"), vc = uo(Ee, "WeakMap"), tl = uo(tr, "create"), $s = vc && new vc(), ou = {}, pc = sl(au), qu = sl(zu), Yf = sl(Y1), $1 = sl(Ml), Tl = sl(vc), Gu = Rl ? Rl.prototype : a, mo = Gu ? Gu.valueOf : a, iu = Gu ? Gu.toString : a;
      function P(s) {
        if (na(s) && !nn(s) && !(s instanceof Tt)) {
          if (s instanceof Qr)
            return s;
          if (Dn.call(s, "__wrapped__"))
            return _v(s);
        }
        return new Qr(s);
      }
      var W1 = /* @__PURE__ */ function() {
        function s() {
        }
        return function(f) {
          if (!$r(f))
            return {};
          if (Yu)
            return Yu(f);
          s.prototype = f;
          var y = new s();
          return s.prototype = a, y;
        };
      }();
      function Et() {
      }
      function Qr(s, f) {
        this.__wrapped__ = s, this.__actions__ = [], this.__chain__ = !!f, this.__index__ = 0, this.__values__ = a;
      }
      P.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: z0,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: A1,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: q0,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: P
        }
      }, P.prototype = Et.prototype, P.prototype.constructor = P, Qr.prototype = W1(Et.prototype), Qr.prototype.constructor = Qr;
      function Tt(s) {
        this.__wrapped__ = s, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = dt, this.__views__ = [];
      }
      function un() {
        var s = new Tt(this.__wrapped__);
        return s.__actions__ = xo(this.__actions__), s.__dir__ = this.__dir__, s.__filtered__ = this.__filtered__, s.__iteratees__ = xo(this.__iteratees__), s.__takeCount__ = this.__takeCount__, s.__views__ = xo(this.__views__), s;
      }
      function lu() {
        if (this.__filtered__) {
          var s = new Tt(this);
          s.__dir__ = -1, s.__filtered__ = !0;
        } else
          s = this.clone(), s.__dir__ *= -1;
        return s;
      }
      function Ol() {
        var s = this.__wrapped__.value(), f = this.__dir__, y = nn(s), M = f < 0, L = y ? s.length : 0, F = fa(0, L, this.__views__), K = F.start, te = F.end, se = te - K, Oe = M ? te : K - 1, je = this.__iteratees__, Ve = je.length, rt = 0, Ot = ro(se, this.__takeCount__);
        if (!y || !M && L == se && Ot == se)
          return ns(s, this.__actions__);
        var qt = [];
        e:
          for (; se-- && rt < Ot; ) {
            Oe += f;
            for (var sn = -1, Ut = s[Oe]; ++sn < Ve; ) {
              var Xt = je[sn], yn = Xt.iteratee, zo = Xt.type, ra = yn(Ut);
              if (zo == Re)
                Ut = ra;
              else if (!ra) {
                if (zo == Se)
                  continue e;
                break e;
              }
            }
            qt[rt++] = Ut;
          }
        return qt;
      }
      Tt.prototype = W1(Et.prototype), Tt.prototype.constructor = Tt;
      function ao(s) {
        var f = -1, y = s == null ? 0 : s.length;
        for (this.clear(); ++f < y; ) {
          var M = s[f];
          this.set(M[0], M[1]);
        }
      }
      function Dt() {
        this.__data__ = tl ? tl(null) : {}, this.size = 0;
      }
      function Rn(s) {
        var f = this.has(s) && delete this.__data__[s];
        return this.size -= f ? 1 : 0, f;
      }
      function go(s) {
        var f = this.__data__;
        if (tl) {
          var y = f[s];
          return y === b ? a : y;
        }
        return Dn.call(f, s) ? f[s] : a;
      }
      function Br(s) {
        var f = this.__data__;
        return tl ? f[s] !== a : Dn.call(f, s);
      }
      function Mr(s, f) {
        var y = this.__data__;
        return this.size += this.has(s) ? 0 : 1, y[s] = tl && f === a ? b : f, this;
      }
      ao.prototype.clear = Dt, ao.prototype.delete = Rn, ao.prototype.get = go, ao.prototype.has = Br, ao.prototype.set = Mr;
      function Ir(s) {
        var f = -1, y = s == null ? 0 : s.length;
        for (this.clear(); ++f < y; ) {
          var M = s[f];
          this.set(M[0], M[1]);
        }
      }
      function Mi() {
        this.__data__ = [], this.size = 0;
      }
      function Ya(s) {
        var f = this.__data__, y = $a(f, s);
        if (y < 0)
          return !1;
        var M = f.length - 1;
        return y == M ? f.pop() : Bf.call(f, y, 1), --this.size, !0;
      }
      function $f(s) {
        var f = this.__data__, y = $a(f, s);
        return y < 0 ? a : f[y][1];
      }
      function dv(s) {
        return $a(this.__data__, s) > -1;
      }
      function z1(s, f) {
        var y = this.__data__, M = $a(y, s);
        return M < 0 ? (++this.size, y.push([s, f])) : y[M][1] = f, this;
      }
      Ir.prototype.clear = Mi, Ir.prototype.delete = Ya, Ir.prototype.get = $f, Ir.prototype.has = dv, Ir.prototype.set = z1;
      function pr(s) {
        var f = -1, y = s == null ? 0 : s.length;
        for (this.clear(); ++f < y; ) {
          var M = s[f];
          this.set(M[0], M[1]);
        }
      }
      function Wf() {
        this.size = 0, this.__data__ = {
          hash: new ao(),
          map: new (zu || Ir)(),
          string: new ao()
        };
      }
      function Dl(s) {
        var f = h0(this, s).delete(s);
        return this.size -= f ? 1 : 0, f;
      }
      function q1(s) {
        return h0(this, s).get(s);
      }
      function uu(s) {
        return h0(this, s).has(s);
      }
      function zf(s, f) {
        var y = h0(this, s), M = y.size;
        return y.set(s, f), this.size += y.size == M ? 0 : 1, this;
      }
      pr.prototype.clear = Wf, pr.prototype.delete = Dl, pr.prototype.get = q1, pr.prototype.has = uu, pr.prototype.set = zf;
      function wo(s) {
        var f = -1, y = s == null ? 0 : s.length;
        for (this.__data__ = new pr(); ++f < y; )
          this.add(s[f]);
      }
      function nl(s) {
        return this.__data__.set(s, b), this;
      }
      function Ku(s) {
        return this.__data__.has(s);
      }
      wo.prototype.add = wo.prototype.push = nl, wo.prototype.has = Ku;
      function Aa(s) {
        var f = this.__data__ = new Ir(s);
        this.size = f.size;
      }
      function Qu() {
        this.__data__ = new Ir(), this.size = 0;
      }
      function su(s) {
        var f = this.__data__, y = f.delete(s);
        return this.size = f.size, y;
      }
      function sa(s) {
        return this.__data__.get(s);
      }
      function Ti(s) {
        return this.__data__.has(s);
      }
      function ii(s, f) {
        var y = this.__data__;
        if (y instanceof Ir) {
          var M = y.__data__;
          if (!zu || M.length < h - 1)
            return M.push([s, f]), this.size = ++y.size, this;
          y = this.__data__ = new pr(M);
        }
        return y.set(s, f), this.size = y.size, this;
      }
      Aa.prototype.clear = Qu, Aa.prototype.delete = su, Aa.prototype.get = sa, Aa.prototype.has = Ti, Aa.prototype.set = ii;
      function rl(s, f) {
        var y = nn(s), M = !y && Zl(s), L = !y && !M && c1(s), F = !y && !M && !L && Wc(s), K = y || M || L || F, te = K ? Fr(s.length, om) : [], se = te.length;
        for (var Oe in s)
          (f || Dn.call(s, Oe)) && !(K && // Safari 9 has enumerable `arguments.length` in strict mode.
          (Oe == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          L && (Oe == "offset" || Oe == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          F && (Oe == "buffer" || Oe == "byteLength" || Oe == "byteOffset") || // Skip index properties.
          Or(Oe, se))) && te.push(Oe);
        return te;
      }
      function al(s) {
        var f = s.length;
        return f ? s[J1(0, f - 1)] : a;
      }
      function Ws(s, f) {
        return dd(xo(s), cu(f, 0, s.length));
      }
      function hv(s) {
        return dd(xo(s));
      }
      function G1(s, f, y) {
        (y !== a && !_u(s[f], y) || y === a && !(f in s)) && ol(s, f, y);
      }
      function Xu(s, f, y) {
        var M = s[f];
        (!(Dn.call(s, f) && _u(M, y)) || y === a && !(f in s)) && ol(s, f, y);
      }
      function $a(s, f) {
        for (var y = s.length; y--; )
          if (_u(s[y][0], f))
            return y;
        return -1;
      }
      function No(s, f, y, M) {
        return oo(s, function(L, F, K) {
          f(M, L, y(L), K);
        }), M;
      }
      function xr(s, f) {
        return s && mn(f, co(f), s);
      }
      function Oi(s, f) {
        return s && mn(f, Vi(f), s);
      }
      function ol(s, f, y) {
        f == "__proto__" && El ? El(s, f, {
          configurable: !0,
          enumerable: !0,
          value: y,
          writable: !0
        }) : s[f] = y;
      }
      function qf(s, f) {
        for (var y = -1, M = f.length, L = we(M), F = s == null; ++y < M; )
          L[y] = F ? a : qv(s, f[y]);
        return L;
      }
      function cu(s, f, y) {
        return s === s && (y !== a && (s = s <= y ? s : y), f !== a && (s = s >= f ? s : f)), s;
      }
      function Vo(s, f, y, M, L, F) {
        var K, te = f & T, se = f & A, Oe = f & j;
        if (y && (K = L ? y(s, M, L, F) : y(s)), K !== a)
          return K;
        if (!$r(s))
          return s;
        var je = nn(s);
        if (je) {
          if (K = Lc(s), !te)
            return xo(s, K);
        } else {
          var Ve = fr(s), rt = Ve == zn || Ve == qn;
          if (c1(s))
            return Ec(s, te);
          if (Ve == jr || Ve == ot || rt && !L) {
            if (K = se || rt ? {} : Ca(s), !te)
              return se ? rd(s, Oi(K, s)) : t1(s, xr(K, s));
          } else {
            if (!Yn[Ve])
              return L ? s : {};
            K = Sv(s, Ve, te);
          }
        }
        F || (F = new Aa());
        var Ot = F.get(s);
        if (Ot)
          return Ot;
        F.set(s, K), Fv(s) ? s.forEach(function(Ut) {
          K.add(Vo(Ut, f, y, Ut, s, F));
        }) : f1(s) && s.forEach(function(Ut, Xt) {
          K.set(Xt, Vo(Ut, f, y, Xt, s, F));
        });
        var qt = Oe ? se ? kc : c0 : se ? Vi : co, sn = je ? a : qt(s);
        return Ua(sn || s, function(Ut, Xt) {
          sn && (Xt = Ut, Ut = s[Xt]), Xu(K, Xt, Vo(Ut, f, y, Xt, s, F));
        }), K;
      }
      function ya(s) {
        var f = co(s);
        return function(y) {
          return mc(y, s, f);
        };
      }
      function mc(s, f, y) {
        var M = y.length;
        if (s == null)
          return !M;
        for (s = tr(s); M--; ) {
          var L = y[M], F = f[L], K = s[L];
          if (K === a && !(L in s) || !F(K))
            return !1;
        }
        return !0;
      }
      function K1(s, f, y) {
        if (typeof s != "function")
          throw new Ei(m);
        return w0(function() {
          s.apply(a, y);
        }, f);
      }
      function Di(s, f, y, M) {
        var L = -1, F = P1, K = !0, te = s.length, se = [], Oe = f.length;
        if (!te)
          return se;
        y && (f = hr(f, no(y))), M ? (F = kf, K = !1) : f.length >= h && (F = ai, K = !1, f = new wo(f));
        e:
          for (; ++L < te; ) {
            var je = s[L], Ve = y == null ? je : y(je);
            if (je = M || je !== 0 ? je : 0, K && Ve === Ve) {
              for (var rt = Oe; rt--; )
                if (f[rt] === Ve)
                  continue e;
              se.push(je);
            } else F(f, Ve, M) || se.push(je);
          }
        return se;
      }
      var oo = Zi(Hr), vv = Zi(es, !0);
      function zs(s, f) {
        var y = !0;
        return oo(s, function(M, L, F) {
          return y = !!f(M, L, F), y;
        }), y;
      }
      function qs(s, f, y) {
        for (var M = -1, L = s.length; ++M < L; ) {
          var F = s[M], K = f(F);
          if (K != null && (te === a ? K === K && !Ro(K) : y(K, te)))
            var te = K, se = F;
        }
        return se;
      }
      function pv(s, f, y, M) {
        var L = s.length;
        for (y = on(y), y < 0 && (y = -y > L ? 0 : L + y), M = M === a || M > L ? L : on(M), M < 0 && (M += L), M = y > M ? 0 : E3(M); y < M; )
          s[y++] = f;
        return s;
      }
      function Ju(s, f) {
        var y = [];
        return oo(s, function(M, L, F) {
          f(M, L, F) && y.push(M);
        }), y;
      }
      function hn(s, f, y, M, L) {
        var F = -1, K = s.length;
        for (y || (y = Ic), L || (L = []); ++F < K; ) {
          var te = s[F];
          f > 0 && y(te) ? f > 1 ? hn(te, f - 1, y, M, L) : Bu(L, te) : M || (L[L.length] = te);
        }
        return L;
      }
      var et = ad(), Fo = ad(!0);
      function Hr(s, f) {
        return s && et(s, f, co);
      }
      function es(s, f) {
        return s && Fo(s, f, co);
      }
      function Q1(s, f) {
        return ri(f, function(y) {
          return gs(s[y]);
        });
      }
      function fu(s, f) {
        f = Ii(f, s);
        for (var y = 0, M = f.length; s != null && y < M; )
          s = s[ul(f[y++])];
        return y && y == M ? s : a;
      }
      function Gf(s, f, y) {
        var M = f(s);
        return nn(s) ? M : Bu(M, y(s));
      }
      function Wa(s) {
        return s == null ? s === a ? Ge : Ta : nu && nu in tr(s) ? Pi(s) : Il(s);
      }
      function Sr(s, f) {
        return s > f;
      }
      function Ai(s, f) {
        return s != null && Dn.call(s, f);
      }
      function Gs(s, f) {
        return s != null && f in tr(s);
      }
      function Hh(s, f, y) {
        return s >= ro(f, y) && s < Kr(f, y);
      }
      function gc(s, f, y) {
        for (var M = y ? kf : P1, L = s[0].length, F = s.length, K = F, te = we(F), se = 1 / 0, Oe = []; K--; ) {
          var je = s[K];
          K && f && (je = hr(je, no(f))), se = ro(je.length, se), te[K] = !y && (f || L >= 120 && je.length >= 120) ? new wo(K && je) : a;
        }
        je = s[0];
        var Ve = -1, rt = te[0];
        e:
          for (; ++Ve < L && Oe.length < se; ) {
            var Ot = je[Ve], qt = f ? f(Ot) : Ot;
            if (Ot = y || Ot !== 0 ? Ot : 0, !(rt ? ai(rt, qt) : M(Oe, qt, y))) {
              for (K = F; --K; ) {
                var sn = te[K];
                if (!(sn ? ai(sn, qt) : M(s[K], qt, y)))
                  continue e;
              }
              rt && rt.push(qt), Oe.push(Ot);
            }
          }
        return Oe;
      }
      function li(s, f, y, M) {
        return Hr(s, function(L, F, K) {
          f(M, y(L), F, K);
        }), M;
      }
      function za(s, f, y) {
        f = Ii(f, s), s = Yr(s, f);
        var M = s == null ? s : s[ul(so(f))];
        return M == null ? a : er(M, s, y);
      }
      function Kf(s) {
        return na(s) && Wa(s) == ot;
      }
      function mv(s) {
        return na(s) && Wa(s) == gn;
      }
      function du(s) {
        return na(s) && Wa(s) == Hn;
      }
      function ji(s, f, y, M, L) {
        return s === f ? !0 : s == null || f == null || !na(s) && !na(f) ? s !== s && f !== f : Qf(s, f, y, M, ji, L);
      }
      function Qf(s, f, y, M, L, F) {
        var K = nn(s), te = nn(f), se = K ? Nt : fr(s), Oe = te ? Nt : fr(f);
        se = se == ot ? jr : se, Oe = Oe == ot ? jr : Oe;
        var je = se == jr, Ve = Oe == jr, rt = se == Oe;
        if (rt && c1(s)) {
          if (!c1(f))
            return !1;
          K = !0, je = !1;
        }
        if (rt && !je)
          return F || (F = new Aa()), K || Wc(s) ? Fh(s, f, y, M, L, F) : jc(s, f, se, y, M, L, F);
        if (!(y & I)) {
          var Ot = je && Dn.call(s, "__wrapped__"), qt = Ve && Dn.call(f, "__wrapped__");
          if (Ot || qt) {
            var sn = Ot ? s.value() : s, Ut = qt ? f.value() : f;
            return F || (F = new Aa()), L(sn, Ut, y, M, F);
          }
        }
        return rt ? (F || (F = new Aa()), s0(s, f, y, M, L, F)) : !1;
      }
      function gv(s) {
        return na(s) && fr(s) == Gn;
      }
      function Ks(s, f, y, M) {
        var L = y.length, F = L, K = !M;
        if (s == null)
          return !F;
        for (s = tr(s); L--; ) {
          var te = y[L];
          if (K && te[2] ? te[1] !== s[te[0]] : !(te[0] in s))
            return !1;
        }
        for (; ++L < F; ) {
          te = y[L];
          var se = te[0], Oe = s[se], je = te[1];
          if (K && te[2]) {
            if (Oe === a && !(se in s))
              return !1;
          } else {
            var Ve = new Aa();
            if (M)
              var rt = M(Oe, je, se, s, f, Ve);
            if (!(rt === a ? ji(je, Oe, I | Z, M, Ve) : rt))
              return !1;
          }
        }
        return !0;
      }
      function Xf(s) {
        if (!$r(s) || Cv(s))
          return !1;
        var f = gs(s) ? sv : ln;
        return f.test(sl(s));
      }
      function wc(s) {
        return na(s) && Wa(s) == Sn;
      }
      function Al(s) {
        return na(s) && fr(s) == jt;
      }
      function yc(s) {
        return na(s) && t2(s.length) && !!Pn[Wa(s)];
      }
      function X1(s) {
        return typeof s == "function" ? s : s == null ? Fi : typeof s == "object" ? nn(s) ? Tr(s[0], s[1]) : xc(s) : N3(s);
      }
      function hu(s) {
        if (!yu(s))
          return B1(s);
        var f = [];
        for (var y in tr(s))
          Dn.call(s, y) && y != "constructor" && f.push(y);
        return f;
      }
      function Zh(s) {
        if (!$r(s))
          return xu(s);
        var f = yu(s), y = [];
        for (var M in s)
          M == "constructor" && (f || !Dn.call(s, M)) || y.push(M);
        return y;
      }
      function vu(s, f) {
        return s < f;
      }
      function Ph(s, f) {
        var y = -1, M = Wo(s) ? we(s.length) : [];
        return oo(s, function(L, F, K) {
          M[++y] = f(L, F, K);
        }), M;
      }
      function xc(s) {
        var f = qa(s);
        return f.length == 1 && f[0][2] ? sd(f[0][0], f[0][1]) : function(y) {
          return y === s || Ks(y, s, f);
        };
      }
      function Tr(s, f) {
        return ct(s) && g0(f) ? sd(ul(s), f) : function(y) {
          var M = qv(y, s);
          return M === a && M === f ? Td(y, s) : ji(f, M, I | Z);
        };
      }
      function Qs(s, f, y, M, L) {
        s !== f && et(f, function(F, K) {
          if (L || (L = new Aa()), $r(F))
            Sc(s, f, K, y, Qs, M, L);
          else {
            var te = M ? M(Ga(s, K), F, K + "", s, f, L) : a;
            te === a && (te = F), G1(s, K, te);
          }
        }, Vi);
      }
      function Sc(s, f, y, M, L, F, K) {
        var te = Ga(s, y), se = Ga(f, y), Oe = K.get(se);
        if (Oe) {
          G1(s, y, Oe);
          return;
        }
        var je = F ? F(te, se, y + "", s, f, K) : a, Ve = je === a;
        if (Ve) {
          var rt = nn(se), Ot = !rt && c1(se), qt = !rt && !Ot && Wc(se);
          je = se, rt || Ot || qt ? nn(te) ? je = te : _a(te) ? je = xo(te) : Ot ? (Ve = !1, je = Ec(se, !0)) : qt ? (Ve = !1, je = a0(se, !0)) : je = [] : Md(se) || Zl(se) ? (je = te, Zl(te) ? je = fi(te) : (!$r(te) || gs(te)) && (je = Ca(se))) : Ve = !1;
        }
        Ve && (K.set(se, je), L(je, se, M, F, K), K.delete(se)), G1(s, y, je);
      }
      function kt(s, f) {
        var y = s.length;
        if (y)
          return f += f < 0 ? y : 0, Or(f, y) ? s[f] : a;
      }
      function an(s, f, y) {
        f.length ? f = hr(f, function(F) {
          return nn(F) ? function(K) {
            return fu(K, F.length === 1 ? F[0] : F);
          } : F;
        }) : f = [Fi];
        var M = -1;
        f = hr(f, no(Vt()));
        var L = Ph(s, function(F, K, te) {
          var se = hr(f, function(Oe) {
            return Oe(F);
          });
          return { criteria: se, index: ++M, value: F };
        });
        return Zo(L, function(F, K) {
          return Mc(F, K, y);
        });
      }
      function Nn(s, f) {
        return nr(s, f, function(y, M) {
          return Td(s, M);
        });
      }
      function nr(s, f, y) {
        for (var M = -1, L = f.length, F = {}; ++M < L; ) {
          var K = f[M], te = fu(s, K);
          y(te, K) && ki(F, Ii(K, s), te);
        }
        return F;
      }
      function Vn(s) {
        return function(f) {
          return fu(f, s);
        };
      }
      function Ur(s, f, y, M) {
        var L = M ? ic : N1, F = -1, K = f.length, te = s;
        for (s === f && (f = xo(f)), y && (te = hr(s, no(y))); ++F < K; )
          for (var se = 0, Oe = f[F], je = y ? y(Oe) : Oe; (se = L(te, je, se, M)) > -1; )
            te !== s && Bf.call(te, se, 1), Bf.call(s, se, 1);
        return s;
      }
      function xa(s, f) {
        for (var y = s ? f.length : 0, M = y - 1; y--; ) {
          var L = f[y];
          if (y == M || L !== F) {
            var F = L;
            Or(L) ? Bf.call(s, L, 1) : t0(s, L);
          }
        }
        return s;
      }
      function J1(s, f) {
        return s + Wu(ru() * (f - s + 1));
      }
      function Cc(s, f, y, M) {
        for (var L = -1, F = Kr($u((f - s) / (y || 1)), 0), K = we(F); F--; )
          K[M ? F : ++L] = s, s += y;
        return K;
      }
      function pu(s, f) {
        var y = "";
        if (!s || f < 1 || f > ue)
          return y;
        do
          f % 2 && (y += s), f = Wu(f / 2), f && (s += s);
        while (f);
        return y;
      }
      function be(s, f) {
        return ui(ll(s, f, Fi), s + "");
      }
      function An(s) {
        return al(Dd(s));
      }
      function Wt(s, f) {
        var y = Dd(s);
        return dd(y, cu(f, 0, y.length));
      }
      function ki(s, f, y, M) {
        if (!$r(s))
          return s;
        f = Ii(f, s);
        for (var L = -1, F = f.length, K = F - 1, te = s; te != null && ++L < F; ) {
          var se = ul(f[L]), Oe = y;
          if (se === "__proto__" || se === "constructor" || se === "prototype")
            return s;
          if (L != K) {
            var je = te[se];
            Oe = M ? M(je, se, te) : a, Oe === a && (Oe = $r(je) ? je : Or(f[L + 1]) ? [] : {});
          }
          Xu(te, se, Oe), te = te[se];
        }
        return s;
      }
      var Li = $s ? function(s, f) {
        return $s.set(s, f), s;
      } : Fi, io = El ? function(s, f) {
        return El(s, "toString", {
          configurable: !0,
          enumerable: !1,
          value: l2(f),
          writable: !0
        });
      } : Fi;
      function Xr(s) {
        return dd(Dd(s));
      }
      function ca(s, f, y) {
        var M = -1, L = s.length;
        f < 0 && (f = -f > L ? 0 : L + f), y = y > L ? L : y, y < 0 && (y += L), L = f > y ? 0 : y - f >>> 0, f >>>= 0;
        for (var F = we(L); ++M < L; )
          F[M] = s[M + f];
        return F;
      }
      function ts(s, f) {
        var y;
        return oo(s, function(M, L, F) {
          return y = f(M, L, F), !y;
        }), !!y;
      }
      function jl(s, f, y) {
        var M = 0, L = s == null ? M : s.length;
        if (typeof f == "number" && f === f && L <= qe) {
          for (; M < L; ) {
            var F = M + L >>> 1, K = s[F];
            K !== null && !Ro(K) && (y ? K <= f : K < f) ? M = F + 1 : L = F;
          }
          return L;
        }
        return e0(s, f, Fi, y);
      }
      function e0(s, f, y, M) {
        var L = 0, F = s == null ? 0 : s.length;
        if (F === 0)
          return 0;
        f = y(f);
        for (var K = f !== f, te = f === null, se = Ro(f), Oe = f === a; L < F; ) {
          var je = Wu((L + F) / 2), Ve = y(s[je]), rt = Ve !== a, Ot = Ve === null, qt = Ve === Ve, sn = Ro(Ve);
          if (K)
            var Ut = M || qt;
          else Oe ? Ut = qt && (M || rt) : te ? Ut = qt && rt && (M || !Ot) : se ? Ut = qt && rt && !Ot && (M || !sn) : Ot || sn ? Ut = !1 : Ut = M ? Ve <= f : Ve < f;
          Ut ? L = je + 1 : F = je;
        }
        return ro(F, Ze);
      }
      function bc(s, f) {
        for (var y = -1, M = s.length, L = 0, F = []; ++y < M; ) {
          var K = s[y], te = f ? f(K) : K;
          if (!y || !_u(te, se)) {
            var se = te;
            F[L++] = K === 0 ? 0 : K;
          }
        }
        return F;
      }
      function _c(s) {
        return typeof s == "number" ? s : Ro(s) ? Pe : +s;
      }
      function lo(s) {
        if (typeof s == "string")
          return s;
        if (nn(s))
          return hr(s, lo) + "";
        if (Ro(s))
          return iu ? iu.call(s) : "";
        var f = s + "";
        return f == "0" && 1 / s == -Ye ? "-0" : f;
      }
      function il(s, f, y) {
        var M = -1, L = P1, F = s.length, K = !0, te = [], se = te;
        if (y)
          K = !1, L = kf;
        else if (F >= h) {
          var Oe = f ? null : Bo(s);
          if (Oe)
            return eu(Oe);
          K = !1, L = ai, se = new wo();
        } else
          se = f ? [] : te;
        e:
          for (; ++M < F; ) {
            var je = s[M], Ve = f ? f(je) : je;
            if (je = y || je !== 0 ? je : 0, K && Ve === Ve) {
              for (var rt = se.length; rt--; )
                if (se[rt] === Ve)
                  continue e;
              f && se.push(Ve), te.push(je);
            } else L(se, Ve, y) || (se !== te && se.push(Ve), te.push(je));
          }
        return te;
      }
      function t0(s, f) {
        return f = Ii(f, s), s = Yr(s, f), s == null || delete s[ul(so(f))];
      }
      function Rc(s, f, y, M) {
        return ki(s, f, y(fu(s, f)), M);
      }
      function Xs(s, f, y, M) {
        for (var L = s.length, F = M ? L : -1; (M ? F-- : ++F < L) && f(s[F], F, s); )
          ;
        return y ? ca(s, M ? 0 : F, M ? F + 1 : L) : ca(s, M ? F + 1 : 0, M ? L : F);
      }
      function ns(s, f) {
        var y = s;
        return y instanceof Tt && (y = y.value()), Oh(f, function(M, L) {
          return L.func.apply(L.thisArg, Bu([M], L.args));
        }, y);
      }
      function n0(s, f, y) {
        var M = s.length;
        if (M < 2)
          return M ? il(s[0]) : [];
        for (var L = -1, F = we(M); ++L < M; )
          for (var K = s[L], te = -1; ++te < M; )
            te != L && (F[L] = Di(F[L] || K, s[te], f, y));
        return il(hn(F, 1), f, y);
      }
      function Js(s, f, y) {
        for (var M = -1, L = s.length, F = f.length, K = {}; ++M < L; ) {
          var te = M < F ? f[M] : a;
          y(K, s[M], te);
        }
        return K;
      }
      function rs(s) {
        return _a(s) ? s : [];
      }
      function r0(s) {
        return typeof s == "function" ? s : Fi;
      }
      function Ii(s, f) {
        return nn(s) ? s : ct(s, f) ? [s] : hd($n(s));
      }
      var Jf = be;
      function Hi(s, f, y) {
        var M = s.length;
        return y = y === a ? M : y, !f && y >= M ? s : ca(s, f, y);
      }
      var as = Us || function(s) {
        return yr.clearTimeout(s);
      };
      function Ec(s, f) {
        if (f)
          return s.slice();
        var y = s.length, M = Bs ? Bs(y) : new s.constructor(y);
        return s.copy(M), M;
      }
      function e1(s) {
        var f = new s.constructor(s.byteLength);
        return new Fs(f).set(new Fs(s)), f;
      }
      function ed(s, f) {
        var y = f ? e1(s.buffer) : s.buffer;
        return new s.constructor(y, s.byteOffset, s.byteLength);
      }
      function td(s) {
        var f = new s.constructor(s.source, bn.exec(s));
        return f.lastIndex = s.lastIndex, f;
      }
      function Nh(s) {
        return mo ? tr(mo.call(s)) : {};
      }
      function a0(s, f) {
        var y = f ? e1(s.buffer) : s.buffer;
        return new s.constructor(y, s.byteOffset, s.length);
      }
      function nd(s, f) {
        if (s !== f) {
          var y = s !== a, M = s === null, L = s === s, F = Ro(s), K = f !== a, te = f === null, se = f === f, Oe = Ro(f);
          if (!te && !Oe && !F && s > f || F && K && se && !te && !Oe || M && K && se || !y && se || !L)
            return 1;
          if (!M && !F && !Oe && s < f || Oe && y && L && !M && !F || te && y && L || !K && L || !se)
            return -1;
        }
        return 0;
      }
      function Mc(s, f, y) {
        for (var M = -1, L = s.criteria, F = f.criteria, K = L.length, te = y.length; ++M < K; ) {
          var se = nd(L[M], F[M]);
          if (se) {
            if (M >= te)
              return se;
            var Oe = y[M];
            return se * (Oe == "desc" ? -1 : 1);
          }
        }
        return s.index - f.index;
      }
      function os(s, f, y, M) {
        for (var L = -1, F = s.length, K = y.length, te = -1, se = f.length, Oe = Kr(F - K, 0), je = we(se + Oe), Ve = !M; ++te < se; )
          je[te] = f[te];
        for (; ++L < K; )
          (Ve || L < F) && (je[y[L]] = s[L]);
        for (; Oe--; )
          je[te++] = s[L++];
        return je;
      }
      function yo(s, f, y, M) {
        for (var L = -1, F = s.length, K = -1, te = y.length, se = -1, Oe = f.length, je = Kr(F - te, 0), Ve = we(je + Oe), rt = !M; ++L < je; )
          Ve[L] = s[L];
        for (var Ot = L; ++se < Oe; )
          Ve[Ot + se] = f[se];
        for (; ++K < te; )
          (rt || L < F) && (Ve[Ot + y[K]] = s[L++]);
        return Ve;
      }
      function xo(s, f) {
        var y = -1, M = s.length;
        for (f || (f = we(M)); ++y < M; )
          f[y] = s[y];
        return f;
      }
      function mn(s, f, y, M) {
        var L = !y;
        y || (y = {});
        for (var F = -1, K = f.length; ++F < K; ) {
          var te = f[F], se = M ? M(y[te], s[te], te, y, s) : a;
          se === a && (se = s[te]), L ? ol(y, te, se) : Xu(y, te, se);
        }
        return y;
      }
      function t1(s, f) {
        return mn(s, Uo(s), f);
      }
      function rd(s, f) {
        return mn(s, v0(s), f);
      }
      function is(s, f) {
        return function(y, M) {
          var L = nn(y) ? rc : No, F = f ? f() : {};
          return L(y, s, Vt(M, 2), F);
        };
      }
      function mu(s) {
        return be(function(f, y) {
          var M = -1, L = y.length, F = L > 1 ? y[L - 1] : a, K = L > 2 ? y[2] : a;
          for (F = s.length > 3 && typeof F == "function" ? (L--, F) : a, K && So(y[0], y[1], K) && (F = L < 3 ? a : F, L = 1), f = tr(f); ++M < L; ) {
            var te = y[M];
            te && s(f, te, M, F);
          }
          return f;
        });
      }
      function Zi(s, f) {
        return function(y, M) {
          if (y == null)
            return y;
          if (!Wo(y))
            return s(y, M);
          for (var L = y.length, F = f ? L : -1, K = tr(y); (f ? F-- : ++F < L) && M(K[F], F, K) !== !1; )
            ;
          return y;
        };
      }
      function ad(s) {
        return function(f, y, M) {
          for (var L = -1, F = tr(f), K = M(f), te = K.length; te--; ) {
            var se = K[s ? te : ++L];
            if (y(F[se], se, F) === !1)
              break;
          }
          return f;
        };
      }
      function od(s, f, y) {
        var M = f & N, L = o0(s);
        function F() {
          var K = this && this !== yr && this instanceof F ? L : s;
          return K.apply(M ? y : this, arguments);
        }
        return F;
      }
      function Vh(s) {
        return function(f) {
          f = $n(f);
          var y = V1(f) ? oi(f) : a, M = y ? y[0] : f.charAt(0), L = y ? Hi(y, 1).join("") : f.slice(1);
          return M[s]() + L;
        };
      }
      function gu(s) {
        return function(f) {
          return Oh(Z3(jd(f).replace(Vu, "")), s, "");
        };
      }
      function o0(s) {
        return function() {
          var f = arguments;
          switch (f.length) {
            case 0:
              return new s();
            case 1:
              return new s(f[0]);
            case 2:
              return new s(f[0], f[1]);
            case 3:
              return new s(f[0], f[1], f[2]);
            case 4:
              return new s(f[0], f[1], f[2], f[3]);
            case 5:
              return new s(f[0], f[1], f[2], f[3], f[4]);
            case 6:
              return new s(f[0], f[1], f[2], f[3], f[4], f[5]);
            case 7:
              return new s(f[0], f[1], f[2], f[3], f[4], f[5], f[6]);
          }
          var y = W1(s.prototype), M = s.apply(y, f);
          return $r(M) ? M : y;
        };
      }
      function Tc(s, f, y) {
        var M = o0(s);
        function L() {
          for (var F = arguments.length, K = we(F), te = F, se = Ll(L); te--; )
            K[te] = arguments[te];
          var Oe = F < 3 && K[0] !== se && K[F - 1] !== se ? [] : Po(K, se);
          if (F -= Oe.length, F < y)
            return Jr(
              s,
              f,
              i0,
              L.placeholder,
              a,
              K,
              Oe,
              a,
              a,
              y - F
            );
          var je = this && this !== yr && this instanceof L ? M : s;
          return er(je, this, K);
        }
        return L;
      }
      function ls(s) {
        return function(f, y, M) {
          var L = tr(f);
          if (!Wo(f)) {
            var F = Vt(y, 3);
            f = co(f), y = function(te) {
              return F(L[te], te, L);
            };
          }
          var K = s(f, y, M);
          return K > -1 ? L[F ? f[K] : K] : a;
        };
      }
      function id(s) {
        return kl(function(f) {
          var y = f.length, M = y, L = Qr.prototype.thru;
          for (s && f.reverse(); M--; ) {
            var F = f[M];
            if (typeof F != "function")
              throw new Ei(m);
            if (L && !K && d0(F) == "wrapper")
              var K = new Qr([], !0);
          }
          for (M = K ? M : y; ++M < y; ) {
            F = f[M];
            var te = d0(F), se = te == "wrapper" ? f0(F) : a;
            se && m0(se[0]) && se[1] == (G | W | Y | pe) && !se[4].length && se[9] == 1 ? K = K[d0(se[0])].apply(K, se[3]) : K = F.length == 1 && m0(F) ? K[te]() : K.thru(F);
          }
          return function() {
            var Oe = arguments, je = Oe[0];
            if (K && Oe.length == 1 && nn(je))
              return K.plant(je).value();
            for (var Ve = 0, rt = y ? f[Ve].apply(this, Oe) : je; ++Ve < y; )
              rt = f[Ve].call(this, rt);
            return rt;
          };
        });
      }
      function i0(s, f, y, M, L, F, K, te, se, Oe) {
        var je = f & G, Ve = f & N, rt = f & B, Ot = f & (W | z), qt = f & J, sn = rt ? a : o0(s);
        function Ut() {
          for (var Xt = arguments.length, yn = we(Xt), zo = Xt; zo--; )
            yn[zo] = arguments[zo];
          if (Ot)
            var ra = Ll(Ut), ka = Zf(yn, ra);
          if (M && (yn = os(yn, M, L, Ot)), F && (yn = yo(yn, F, K, Ot)), Xt -= ka, Ot && Xt < Oe) {
            var En = Po(yn, ra);
            return Jr(
              s,
              f,
              i0,
              Ut.placeholder,
              y,
              yn,
              En,
              te,
              se,
              Oe - Xt
            );
          }
          var Dr = Ve ? y : this, Ru = rt ? Dr[s] : s;
          return Xt = yn.length, te ? yn = Co(yn, te) : qt && Xt > 1 && yn.reverse(), je && se < Xt && (yn.length = se), this && this !== yr && this instanceof Ut && (Ru = sn || o0(Ru)), Ru.apply(Dr, yn);
        }
        return Ut;
      }
      function Oc(s, f) {
        return function(y, M) {
          return li(y, s, f(M), {});
        };
      }
      function Dc(s, f) {
        return function(y, M) {
          var L;
          if (y === a && M === a)
            return f;
          if (y !== a && (L = y), M !== a) {
            if (L === a)
              return M;
            typeof y == "string" || typeof M == "string" ? (y = lo(y), M = lo(M)) : (y = _c(y), M = _c(M)), L = s(y, M);
          }
          return L;
        };
      }
      function Ac(s) {
        return kl(function(f) {
          return f = hr(f, no(Vt())), be(function(y) {
            var M = this;
            return s(f, function(L) {
              return er(L, M, y);
            });
          });
        });
      }
      function l0(s, f) {
        f = f === a ? " " : lo(f);
        var y = f.length;
        if (y < 2)
          return y ? pu(f, s) : f;
        var M = pu(f, $u(s / Ps(f)));
        return V1(f) ? Hi(oi(M), 0, s).join("") : M.slice(0, s);
      }
      function wv(s, f, y, M) {
        var L = f & N, F = o0(s);
        function K() {
          for (var te = -1, se = arguments.length, Oe = -1, je = M.length, Ve = we(je + se), rt = this && this !== yr && this instanceof K ? F : s; ++Oe < je; )
            Ve[Oe] = M[Oe];
          for (; se--; )
            Ve[Oe++] = arguments[++te];
          return er(rt, L ? y : this, Ve);
        }
        return K;
      }
      function wu(s) {
        return function(f, y, M) {
          return M && typeof M != "number" && So(f, y, M) && (y = M = a), f = d1(f), y === a ? (y = f, f = 0) : y = d1(y), M = M === a ? f < y ? 1 : -1 : d1(M), Cc(f, y, M, s);
        };
      }
      function us(s) {
        return function(f, y) {
          return typeof f == "string" && typeof y == "string" || (f = Pl(f), y = Pl(y)), s(f, y);
        };
      }
      function Jr(s, f, y, M, L, F, K, te, se, Oe) {
        var je = f & W, Ve = je ? K : a, rt = je ? a : K, Ot = je ? F : a, qt = je ? a : F;
        f |= je ? Y : ie, f &= ~(je ? ie : Y), f & $ || (f &= ~(N | B));
        var sn = [
          s,
          f,
          L,
          Ot,
          Ve,
          qt,
          rt,
          te,
          se,
          Oe
        ], Ut = y.apply(a, sn);
        return m0(s) && Uh(Ut, sn), Ut.placeholder = M, fd(Ut, s, f);
      }
      function Sa(s) {
        var f = Lr[s];
        return function(y, M) {
          if (y = Pl(y), M = M == null ? 0 : ro(on(M), 292), M && Ys(y)) {
            var L = ($n(y) + "e").split("e"), F = f(L[0] + "e" + (+L[1] + M));
            return L = ($n(F) + "e").split("e"), +(L[0] + "e" + (+L[1] - M));
          }
          return f(y);
        };
      }
      var Bo = Ml && 1 / eu(new Ml([, -0]))[1] == Ye ? function(s) {
        return new Ml(s);
      } : Hm;
      function ss(s) {
        return function(f) {
          var y = fr(f);
          return y == Gn ? uc(f) : y == jt ? rv(f) : Jl(f, s(f));
        };
      }
      function Bt(s, f, y, M, L, F, K, te) {
        var se = f & B;
        if (!se && typeof s != "function")
          throw new Ei(m);
        var Oe = M ? M.length : 0;
        if (Oe || (f &= ~(Y | ie), M = L = a), K = K === a ? K : Kr(on(K), 0), te = te === a ? te : on(te), Oe -= L ? L.length : 0, f & ie) {
          var je = M, Ve = L;
          M = L = a;
        }
        var rt = se ? a : f0(s), Ot = [
          s,
          f,
          y,
          M,
          L,
          je,
          Ve,
          F,
          K,
          te
        ];
        if (rt && Hc(Ot, rt), s = Ot[0], f = Ot[1], y = Ot[2], M = Ot[3], L = Ot[4], te = Ot[9] = Ot[9] === a ? se ? 0 : s.length : Kr(Ot[9] - Oe, 0), !te && f & (W | z) && (f &= ~(W | z)), !f || f == N)
          var qt = od(s, f, y);
        else f == W || f == z ? qt = Tc(s, f, te) : (f == Y || f == (N | Y)) && !L.length ? qt = wv(s, f, y, M) : qt = i0.apply(a, Ot);
        var sn = rt ? Li : Uh;
        return fd(sn(qt, Ot), s, f);
      }
      function u0(s, f, y, M) {
        return s === a || _u(s, _l[y]) && !Dn.call(M, y) ? f : s;
      }
      function ld(s, f, y, M, L, F) {
        return $r(s) && $r(f) && (F.set(f, s), Qs(s, f, a, ld, F), F.delete(f)), s;
      }
      function yv(s) {
        return Md(s) ? a : s;
      }
      function Fh(s, f, y, M, L, F) {
        var K = y & I, te = s.length, se = f.length;
        if (te != se && !(K && se > te))
          return !1;
        var Oe = F.get(s), je = F.get(f);
        if (Oe && je)
          return Oe == f && je == s;
        var Ve = -1, rt = !0, Ot = y & Z ? new wo() : a;
        for (F.set(s, f), F.set(f, s); ++Ve < te; ) {
          var qt = s[Ve], sn = f[Ve];
          if (M)
            var Ut = K ? M(sn, qt, Ve, f, s, F) : M(qt, sn, Ve, s, f, F);
          if (Ut !== a) {
            if (Ut)
              continue;
            rt = !1;
            break;
          }
          if (Ot) {
            if (!oc(f, function(Xt, yn) {
              if (!ai(Ot, yn) && (qt === Xt || L(qt, Xt, y, M, F)))
                return Ot.push(yn);
            })) {
              rt = !1;
              break;
            }
          } else if (!(qt === sn || L(qt, sn, y, M, F))) {
            rt = !1;
            break;
          }
        }
        return F.delete(s), F.delete(f), rt;
      }
      function jc(s, f, y, M, L, F, K) {
        switch (y) {
          case cr:
            if (s.byteLength != f.byteLength || s.byteOffset != f.byteOffset)
              return !1;
            s = s.buffer, f = f.buffer;
          case gn:
            return !(s.byteLength != f.byteLength || !F(new Fs(s), new Fs(f)));
          case Qt:
          case Hn:
          case wr:
            return _u(+s, +f);
          case Wn:
            return s.name == f.name && s.message == f.message;
          case Sn:
          case On:
            return s == f + "";
          case Gn:
            var te = uc;
          case jt:
            var se = M & I;
            if (te || (te = eu), s.size != f.size && !se)
              return !1;
            var Oe = K.get(s);
            if (Oe)
              return Oe == f;
            M |= Z, K.set(s, f);
            var je = Fh(te(s), te(f), M, L, F, K);
            return K.delete(s), je;
          case Gr:
            if (mo)
              return mo.call(s) == mo.call(f);
        }
        return !1;
      }
      function s0(s, f, y, M, L, F) {
        var K = y & I, te = c0(s), se = te.length, Oe = c0(f), je = Oe.length;
        if (se != je && !K)
          return !1;
        for (var Ve = se; Ve--; ) {
          var rt = te[Ve];
          if (!(K ? rt in f : Dn.call(f, rt)))
            return !1;
        }
        var Ot = F.get(s), qt = F.get(f);
        if (Ot && qt)
          return Ot == f && qt == s;
        var sn = !0;
        F.set(s, f), F.set(f, s);
        for (var Ut = K; ++Ve < se; ) {
          rt = te[Ve];
          var Xt = s[rt], yn = f[rt];
          if (M)
            var zo = K ? M(yn, Xt, rt, f, s, F) : M(Xt, yn, rt, s, f, F);
          if (!(zo === a ? Xt === yn || L(Xt, yn, y, M, F) : zo)) {
            sn = !1;
            break;
          }
          Ut || (Ut = rt == "constructor");
        }
        if (sn && !Ut) {
          var ra = s.constructor, ka = f.constructor;
          ra != ka && "constructor" in s && "constructor" in f && !(typeof ra == "function" && ra instanceof ra && typeof ka == "function" && ka instanceof ka) && (sn = !1);
        }
        return F.delete(s), F.delete(f), sn;
      }
      function kl(s) {
        return ui(ll(s, a, Pc), s + "");
      }
      function c0(s) {
        return Gf(s, co, Uo);
      }
      function kc(s) {
        return Gf(s, Vi, v0);
      }
      var f0 = $s ? function(s) {
        return $s.get(s);
      } : Hm;
      function d0(s) {
        for (var f = s.name + "", y = ou[f], M = Dn.call(ou, f) ? y.length : 0; M--; ) {
          var L = y[M], F = L.func;
          if (F == null || F == s)
            return L.name;
        }
        return f;
      }
      function Ll(s) {
        var f = Dn.call(P, "placeholder") ? P : s;
        return f.placeholder;
      }
      function Vt() {
        var s = P.iteratee || Lm;
        return s = s === Lm ? X1 : s, arguments.length ? s(arguments[0], arguments[1]) : s;
      }
      function h0(s, f) {
        var y = s.__data__;
        return p0(f) ? y[typeof f == "string" ? "string" : "hash"] : y.map;
      }
      function qa(s) {
        for (var f = co(s), y = f.length; y--; ) {
          var M = f[y], L = s[M];
          f[y] = [M, L, g0(L)];
        }
        return f;
      }
      function uo(s, f) {
        var y = Zs(s, f);
        return Xf(y) ? y : a;
      }
      function Pi(s) {
        var f = Dn.call(s, nu), y = s[nu];
        try {
          s[nu] = a;
          var M = !0;
        } catch {
        }
        var L = fc.call(s);
        return M && (f ? s[nu] = y : delete s[nu]), L;
      }
      var Uo = hc ? function(s) {
        return s == null ? [] : (s = tr(s), ri(hc(s), function(f) {
          return Ff.call(s, f);
        }));
      } : Zm, v0 = hc ? function(s) {
        for (var f = []; s; )
          Bu(f, Uo(s)), s = Ji(s);
        return f;
      } : Zm, fr = Wa;
      (au && fr(new au(new ArrayBuffer(1))) != cr || zu && fr(new zu()) != Gn || Y1 && fr(Y1.resolve()) != Mt || Ml && fr(new Ml()) != jt || vc && fr(new vc()) != $t) && (fr = function(s) {
        var f = Wa(s), y = f == jr ? s.constructor : a, M = y ? sl(y) : "";
        if (M)
          switch (M) {
            case pc:
              return cr;
            case qu:
              return Gn;
            case Yf:
              return Mt;
            case $1:
              return jt;
            case Tl:
              return $t;
          }
        return f;
      });
      function fa(s, f, y) {
        for (var M = -1, L = y.length; ++M < L; ) {
          var F = y[M], K = F.size;
          switch (F.type) {
            case "drop":
              s += K;
              break;
            case "dropRight":
              f -= K;
              break;
            case "take":
              f = ro(f, s + K);
              break;
            case "takeRight":
              s = Kr(s, f - K);
              break;
          }
        }
        return { start: s, end: f };
      }
      function xv(s) {
        var f = s.match(Iu);
        return f ? f[1].split(Cl) : [];
      }
      function Bh(s, f, y) {
        f = Ii(f, s);
        for (var M = -1, L = f.length, F = !1; ++M < L; ) {
          var K = ul(f[M]);
          if (!(F = s != null && y(s, K)))
            break;
          s = s[K];
        }
        return F || ++M != L ? F : (L = s == null ? 0 : s.length, !!L && t2(L) && Or(K, L) && (nn(s) || Zl(s)));
      }
      function Lc(s) {
        var f = s.length, y = new s.constructor(f);
        return f && typeof s[0] == "string" && Dn.call(s, "index") && (y.index = s.index, y.input = s.input), y;
      }
      function Ca(s) {
        return typeof s.constructor == "function" && !yu(s) ? W1(Ji(s)) : {};
      }
      function Sv(s, f, y) {
        var M = s.constructor;
        switch (f) {
          case gn:
            return e1(s);
          case Qt:
          case Hn:
            return new M(+s);
          case cr:
            return ed(s, y);
          case Qe:
          case at:
          case Lt:
          case Un:
          case dr:
          case ga:
          case Nr:
          case Oa:
          case br:
            return a0(s, y);
          case Gn:
            return new M();
          case wr:
          case On:
            return new M(s);
          case Sn:
            return td(s);
          case jt:
            return new M();
          case Gr:
            return Nh(s);
        }
      }
      function ud(s, f) {
        var y = f.length;
        if (!y)
          return s;
        var M = y - 1;
        return f[M] = (y > 1 ? "& " : "") + f[M], f = f.join(y > 2 ? ", " : " "), s.replace(Lu, `{
/* [wrapped with ` + f + `] */
`);
      }
      function Ic(s) {
        return nn(s) || Zl(s) || !!(cv && s && s[cv]);
      }
      function Or(s, f) {
        var y = typeof s;
        return f = f ?? ue, !!f && (y == "number" || y != "symbol" && Rr.test(s)) && s > -1 && s % 1 == 0 && s < f;
      }
      function So(s, f, y) {
        if (!$r(y))
          return !1;
        var M = typeof f;
        return (M == "number" ? Wo(y) && Or(f, y.length) : M == "string" && f in y) ? _u(y[f], s) : !1;
      }
      function ct(s, f) {
        if (nn(s))
          return !1;
        var y = typeof s;
        return y == "number" || y == "symbol" || y == "boolean" || s == null || Ro(s) ? !0 : js.test(s) || !As.test(s) || f != null && s in tr(f);
      }
      function p0(s) {
        var f = typeof s;
        return f == "string" || f == "number" || f == "symbol" || f == "boolean" ? s !== "__proto__" : s === null;
      }
      function m0(s) {
        var f = d0(s), y = P[f];
        if (typeof y != "function" || !(f in Tt.prototype))
          return !1;
        if (s === y)
          return !0;
        var M = f0(y);
        return !!M && s === M[0];
      }
      function Cv(s) {
        return !!cc && cc in s;
      }
      var bv = Vs ? gs : Pm;
      function yu(s) {
        var f = s && s.constructor, y = typeof f == "function" && f.prototype || _l;
        return s === y;
      }
      function g0(s) {
        return s === s && !$r(s);
      }
      function sd(s, f) {
        return function(y) {
          return y == null ? !1 : y[s] === f && (f !== a || s in tr(y));
        };
      }
      function cd(s) {
        var f = de(s, function(M) {
          return y.size === R && y.clear(), M;
        }), y = f.cache;
        return f;
      }
      function Hc(s, f) {
        var y = s[1], M = f[1], L = y | M, F = L < (N | B | G), K = M == G && y == W || M == G && y == pe && s[7].length <= f[8] || M == (G | pe) && f[7].length <= f[8] && y == W;
        if (!(F || K))
          return s;
        M & N && (s[2] = f[2], L |= y & N ? 0 : $);
        var te = f[3];
        if (te) {
          var se = s[3];
          s[3] = se ? os(se, te, f[4]) : te, s[4] = se ? Po(s[3], D) : f[4];
        }
        return te = f[5], te && (se = s[5], s[5] = se ? yo(se, te, f[6]) : te, s[6] = se ? Po(s[5], D) : f[6]), te = f[7], te && (s[7] = te), M & G && (s[8] = s[8] == null ? f[8] : ro(s[8], f[8])), s[9] == null && (s[9] = f[9]), s[0] = f[0], s[1] = L, s;
      }
      function xu(s) {
        var f = [];
        if (s != null)
          for (var y in tr(s))
            f.push(y);
        return f;
      }
      function Il(s) {
        return fc.call(s);
      }
      function ll(s, f, y) {
        return f = Kr(f === a ? s.length - 1 : f, 0), function() {
          for (var M = arguments, L = -1, F = Kr(M.length - f, 0), K = we(F); ++L < F; )
            K[L] = M[f + L];
          L = -1;
          for (var te = we(f + 1); ++L < f; )
            te[L] = M[L];
          return te[f] = y(K), er(s, this, te);
        };
      }
      function Yr(s, f) {
        return f.length < 2 ? s : fu(s, ca(f, 0, -1));
      }
      function Co(s, f) {
        for (var y = s.length, M = ro(f.length, y), L = xo(s); M--; ) {
          var F = f[M];
          s[M] = Or(F, y) ? L[F] : a;
        }
        return s;
      }
      function Ga(s, f) {
        if (!(f === "constructor" && typeof s[f] == "function") && f != "__proto__")
          return s[f];
      }
      var Uh = bo(Li), w0 = Ih || function(s, f) {
        return yr.setTimeout(s, f);
      }, ui = bo(io);
      function fd(s, f, y) {
        var M = f + "";
        return ui(s, ud(M, Yh(xv(M), y)));
      }
      function bo(s) {
        var f = 0, y = 0;
        return function() {
          var M = im(), L = ce - (M - y);
          if (y = M, L > 0) {
            if (++f >= ge)
              return arguments[0];
          } else
            f = 0;
          return s.apply(a, arguments);
        };
      }
      function dd(s, f) {
        var y = -1, M = s.length, L = M - 1;
        for (f = f === a ? M : f; ++y < f; ) {
          var F = J1(y, L), K = s[F];
          s[F] = s[y], s[y] = K;
        }
        return s.length = f, s;
      }
      var hd = cd(function(s) {
        var f = [];
        return s.charCodeAt(0) === 46 && f.push(""), s.replace(_i, function(y, M, L, F) {
          f.push(L ? F.replace(lt, "$1") : M || y);
        }), f;
      });
      function ul(s) {
        if (typeof s == "string" || Ro(s))
          return s;
        var f = s + "";
        return f == "0" && 1 / s == -Ye ? "-0" : f;
      }
      function sl(s) {
        if (s != null) {
          try {
            return sc.call(s);
          } catch {
          }
          try {
            return s + "";
          } catch {
          }
        }
        return "";
      }
      function Yh(s, f) {
        return Ua(Je, function(y) {
          var M = "_." + y[0];
          f & y[1] && !P1(s, M) && s.push(M);
        }), s.sort();
      }
      function _v(s) {
        if (s instanceof Tt)
          return s.clone();
        var f = new Qr(s.__wrapped__, s.__chain__);
        return f.__actions__ = xo(s.__actions__), f.__index__ = s.__index__, f.__values__ = s.__values__, f;
      }
      function cs(s, f, y) {
        (y ? So(s, f, y) : f === a) ? f = 1 : f = Kr(on(f), 0);
        var M = s == null ? 0 : s.length;
        if (!M || f < 1)
          return [];
        for (var L = 0, F = 0, K = we($u(M / f)); L < M; )
          K[F++] = ca(s, L, L += f);
        return K;
      }
      function n1(s) {
        for (var f = -1, y = s == null ? 0 : s.length, M = 0, L = []; ++f < y; ) {
          var F = s[f];
          F && (L[M++] = F);
        }
        return L;
      }
      function Ka() {
        var s = arguments.length;
        if (!s)
          return [];
        for (var f = we(s - 1), y = arguments[0], M = s; M--; )
          f[M - 1] = arguments[M];
        return Bu(nn(y) ? xo(y) : [y], hn(f, 1));
      }
      var wn = be(function(s, f) {
        return _a(s) ? Di(s, hn(f, 1, _a, !0)) : [];
      }), ba = be(function(s, f) {
        var y = so(f);
        return _a(y) && (y = a), _a(s) ? Di(s, hn(f, 1, _a, !0), Vt(y, 2)) : [];
      }), da = be(function(s, f) {
        var y = so(f);
        return _a(y) && (y = a), _a(s) ? Di(s, hn(f, 1, _a, !0), a, y) : [];
      });
      function Qa(s, f, y) {
        var M = s == null ? 0 : s.length;
        return M ? (f = y || f === a ? 1 : on(f), ca(s, f < 0 ? 0 : f, M)) : [];
      }
      function si(s, f, y) {
        var M = s == null ? 0 : s.length;
        return M ? (f = y || f === a ? 1 : on(f), f = M - f, ca(s, 0, f < 0 ? 0 : f)) : [];
      }
      function y0(s, f) {
        return s && s.length ? Xs(s, Vt(f, 3), !0, !0) : [];
      }
      function ea(s, f) {
        return s && s.length ? Xs(s, Vt(f, 3), !0) : [];
      }
      function Zc(s, f, y, M) {
        var L = s == null ? 0 : s.length;
        return L ? (y && typeof y != "number" && So(s, f, y) && (y = 0, M = L), pv(s, f, y, M)) : [];
      }
      function cl(s, f, y) {
        var M = s == null ? 0 : s.length;
        if (!M)
          return -1;
        var L = y == null ? 0 : on(y);
        return L < 0 && (L = Kr(M + L, 0)), Ri(s, Vt(f, 3), L);
      }
      function r1(s, f, y) {
        var M = s == null ? 0 : s.length;
        if (!M)
          return -1;
        var L = M - 1;
        return y !== a && (L = on(y), L = y < 0 ? Kr(M + L, 0) : ro(L, M - 1)), Ri(s, Vt(f, 3), L, !0);
      }
      function Pc(s) {
        var f = s == null ? 0 : s.length;
        return f ? hn(s, 1) : [];
      }
      function Nc(s) {
        var f = s == null ? 0 : s.length;
        return f ? hn(s, Ye) : [];
      }
      function Yo(s, f) {
        var y = s == null ? 0 : s.length;
        return y ? (f = f === a ? 1 : on(f), hn(s, f)) : [];
      }
      function $h(s) {
        for (var f = -1, y = s == null ? 0 : s.length, M = {}; ++f < y; ) {
          var L = s[f];
          M[L[0]] = L[1];
        }
        return M;
      }
      function a1(s) {
        return s && s.length ? s[0] : a;
      }
      function ci(s, f, y) {
        var M = s == null ? 0 : s.length;
        if (!M)
          return -1;
        var L = y == null ? 0 : on(y);
        return L < 0 && (L = Kr(M + L, 0)), N1(s, f, L);
      }
      function x0(s) {
        var f = s == null ? 0 : s.length;
        return f ? ca(s, 0, -1) : [];
      }
      var o1 = be(function(s) {
        var f = hr(s, rs);
        return f.length && f[0] === s[0] ? gc(f) : [];
      }), fs = be(function(s) {
        var f = so(s), y = hr(s, rs);
        return f === so(y) ? f = a : y.pop(), y.length && y[0] === s[0] ? gc(y, Vt(f, 2)) : [];
      }), vd = be(function(s) {
        var f = so(s), y = hr(s, rs);
        return f = typeof f == "function" ? f : a, f && y.pop(), y.length && y[0] === s[0] ? gc(y, a, f) : [];
      });
      function Su(s, f) {
        return s == null ? "" : F1.call(s, f);
      }
      function so(s) {
        var f = s == null ? 0 : s.length;
        return f ? s[f - 1] : a;
      }
      function ds(s, f, y) {
        var M = s == null ? 0 : s.length;
        if (!M)
          return -1;
        var L = M;
        return y !== a && (L = on(y), L = L < 0 ? Kr(M + L, 0) : ro(L, M - 1)), f === f ? rm(s, f, L) : Ri(s, Lf, L, !0);
      }
      function S0(s, f) {
        return s && s.length ? kt(s, on(f)) : a;
      }
      var Vc = be(Xa);
      function Xa(s, f) {
        return s && s.length && f && f.length ? Ur(s, f) : s;
      }
      function ha(s, f, y) {
        return s && s.length && f && f.length ? Ur(s, f, Vt(y, 2)) : s;
      }
      function Hl(s, f, y) {
        return s && s.length && f && f.length ? Ur(s, f, a, y) : s;
      }
      var _o = kl(function(s, f) {
        var y = s == null ? 0 : s.length, M = qf(s, f);
        return xa(s, hr(f, function(L) {
          return Or(L, y) ? +L : L;
        }).sort(nd)), M;
      });
      function $o(s, f) {
        var y = [];
        if (!(s && s.length))
          return y;
        var M = -1, L = [], F = s.length;
        for (f = Vt(f, 3); ++M < F; ) {
          var K = s[M];
          f(K, M, s) && (y.push(K), L.push(M));
        }
        return xa(s, L), y;
      }
      function C0(s) {
        return s == null ? s : U1.call(s);
      }
      function Fc(s, f, y) {
        var M = s == null ? 0 : s.length;
        return M ? (y && typeof y != "number" && So(s, f, y) ? (f = 0, y = M) : (f = f == null ? 0 : on(f), y = y === a ? M : on(y)), ca(s, f, y)) : [];
      }
      function i1(s, f) {
        return jl(s, f);
      }
      function lm(s, f, y) {
        return e0(s, f, Vt(y, 2));
      }
      function fl(s, f) {
        var y = s == null ? 0 : s.length;
        if (y) {
          var M = jl(s, f);
          if (M < y && _u(s[M], f))
            return M;
        }
        return -1;
      }
      function Wh(s, f) {
        return jl(s, f, !0);
      }
      function zh(s, f, y) {
        return e0(s, f, Vt(y, 2), !0);
      }
      function l1(s, f) {
        var y = s == null ? 0 : s.length;
        if (y) {
          var M = jl(s, f, !0) - 1;
          if (_u(s[M], f))
            return M;
        }
        return -1;
      }
      function qh(s) {
        return s && s.length ? bc(s) : [];
      }
      function Cu(s, f) {
        return s && s.length ? bc(s, Vt(f, 2)) : [];
      }
      function Rv(s) {
        var f = s == null ? 0 : s.length;
        return f ? ca(s, 1, f) : [];
      }
      function Ev(s, f, y) {
        return s && s.length ? (f = y || f === a ? 1 : on(f), ca(s, 0, f < 0 ? 0 : f)) : [];
      }
      function Gh(s, f, y) {
        var M = s == null ? 0 : s.length;
        return M ? (f = y || f === a ? 1 : on(f), f = M - f, ca(s, f < 0 ? 0 : f, M)) : [];
      }
      function pd(s, f) {
        return s && s.length ? Xs(s, Vt(f, 3), !1, !0) : [];
      }
      function um(s, f) {
        return s && s.length ? Xs(s, Vt(f, 3)) : [];
      }
      var Mv = be(function(s) {
        return il(hn(s, 1, _a, !0));
      }), Tv = be(function(s) {
        var f = so(s);
        return _a(f) && (f = a), il(hn(s, 1, _a, !0), Vt(f, 2));
      }), Ov = be(function(s) {
        var f = so(s);
        return f = typeof f == "function" ? f : a, il(hn(s, 1, _a, !0), a, f);
      });
      function u1(s) {
        return s && s.length ? il(s) : [];
      }
      function sm(s, f) {
        return s && s.length ? il(s, Vt(f, 2)) : [];
      }
      function b0(s, f) {
        return f = typeof f == "function" ? f : a, s && s.length ? il(s, a, f) : [];
      }
      function md(s) {
        if (!(s && s.length))
          return [];
        var f = 0;
        return s = ri(s, function(y) {
          if (_a(y))
            return f = Kr(y.length, f), !0;
        }), Fr(f, function(y) {
          return hr(s, Ah(y));
        });
      }
      function Cr(s, f) {
        if (!(s && s.length))
          return [];
        var y = md(s);
        return f == null ? y : hr(y, function(M) {
          return er(f, a, M);
        });
      }
      var cm = be(function(s, f) {
        return _a(s) ? Di(s, f) : [];
      }), Dv = be(function(s) {
        return n0(ri(s, _a));
      }), fm = be(function(s) {
        var f = so(s);
        return _a(f) && (f = a), n0(ri(s, _a), Vt(f, 2));
      }), Av = be(function(s) {
        var f = so(s);
        return f = typeof f == "function" ? f : a, n0(ri(s, _a), a, f);
      }), jv = be(md);
      function kv(s, f) {
        return Js(s || [], f || [], Xu);
      }
      function dm(s, f) {
        return Js(s || [], f || [], ki);
      }
      var Ni = be(function(s) {
        var f = s.length, y = f > 1 ? s[f - 1] : a;
        return y = typeof y == "function" ? (s.pop(), y) : a, Cr(s, y);
      });
      function gd(s) {
        var f = P(s);
        return f.__chain__ = !0, f;
      }
      function hm(s, f) {
        return f(s), s;
      }
      function dl(s, f) {
        return f(s);
      }
      var Bc = kl(function(s) {
        var f = s.length, y = f ? s[0] : 0, M = this.__wrapped__, L = function(F) {
          return qf(F, s);
        };
        return f > 1 || this.__actions__.length || !(M instanceof Tt) || !Or(y) ? this.thru(L) : (M = M.slice(y, +y + (f ? 1 : 0)), M.__actions__.push({
          func: dl,
          args: [L],
          thisArg: a
        }), new Qr(M, this.__chain__).thru(function(F) {
          return f && !F.length && F.push(a), F;
        }));
      });
      function bu() {
        return gd(this);
      }
      function hs() {
        return new Qr(this.value(), this.__chain__);
      }
      function Kh() {
        this.__values__ === a && (this.__values__ = zc(this.value()));
        var s = this.__index__ >= this.__values__.length, f = s ? a : this.__values__[this.__index__++];
        return { done: s, value: f };
      }
      function wd() {
        return this;
      }
      function Lv(s) {
        for (var f, y = this; y instanceof Et; ) {
          var M = _v(y);
          M.__index__ = 0, M.__values__ = a, f ? L.__wrapped__ = M : f = M;
          var L = M;
          y = y.__wrapped__;
        }
        return L.__wrapped__ = s, f;
      }
      function yd() {
        var s = this.__wrapped__;
        if (s instanceof Tt) {
          var f = s;
          return this.__actions__.length && (f = new Tt(this)), f = f.reverse(), f.__actions__.push({
            func: dl,
            args: [C0],
            thisArg: a
          }), new Qr(f, this.__chain__);
        }
        return this.thru(C0);
      }
      function vm() {
        return ns(this.__wrapped__, this.__actions__);
      }
      var Qh = is(function(s, f, y) {
        Dn.call(s, y) ? ++s[y] : ol(s, y, 1);
      });
      function Iv(s, f, y) {
        var M = nn(s) ? Th : zs;
        return y && So(s, f, y) && (f = a), M(s, Vt(f, 3));
      }
      function xd(s, f) {
        var y = nn(s) ? ri : Ju;
        return y(s, Vt(f, 3));
      }
      var Sd = ls(cl), Xh = ls(r1);
      function Cd(s, f) {
        return hn(vs(s, f), 1);
      }
      function Hv(s, f) {
        return hn(vs(s, f), Ye);
      }
      function s1(s, f, y) {
        return y = y === a ? 1 : on(y), hn(vs(s, f), y);
      }
      function bd(s, f) {
        var y = nn(s) ? Ua : oo;
        return y(s, Vt(f, 3));
      }
      function Uc(s, f) {
        var y = nn(s) ? ac : vv;
        return y(s, Vt(f, 3));
      }
      var Jh = is(function(s, f, y) {
        Dn.call(s, y) ? s[y].push(f) : ol(s, y, [f]);
      });
      function _d(s, f, y, M) {
        s = Wo(s) ? s : Dd(s), y = y && !M ? on(y) : 0;
        var L = s.length;
        return y < 0 && (y = Kr(L + y, 0)), $c(s) ? y <= L && s.indexOf(f, y) > -1 : !!L && N1(s, f, y) > -1;
      }
      var Zv = be(function(s, f, y) {
        var M = -1, L = typeof f == "function", F = Wo(s) ? we(s.length) : [];
        return oo(s, function(K) {
          F[++M] = L ? er(f, K, y) : za(K, f, y);
        }), F;
      }), pm = is(function(s, f, y) {
        ol(s, y, f);
      });
      function vs(s, f) {
        var y = nn(s) ? hr : Ph;
        return y(s, Vt(f, 3));
      }
      function mm(s, f, y, M) {
        return s == null ? [] : (nn(f) || (f = f == null ? [] : [f]), y = M ? a : y, nn(y) || (y = y == null ? [] : [y]), an(s, f, y));
      }
      var Yc = is(function(s, f, y) {
        s[y ? 0 : 1].push(f);
      }, function() {
        return [[], []];
      });
      function Pv(s, f, y) {
        var M = nn(s) ? Oh : jh, L = arguments.length < 3;
        return M(s, Vt(f, 4), y, L, oo);
      }
      function ps(s, f, y) {
        var M = nn(s) ? G2 : jh, L = arguments.length < 3;
        return M(s, Vt(f, 4), y, L, vv);
      }
      function o(s, f) {
        var y = nn(s) ? ri : Ju;
        return y(s, Fe(Vt(f, 3)));
      }
      function l(s) {
        var f = nn(s) ? al : An;
        return f(s);
      }
      function v(s, f, y) {
        (y ? So(s, f, y) : f === a) ? f = 1 : f = on(f);
        var M = nn(s) ? Ws : Wt;
        return M(s, f);
      }
      function w(s) {
        var f = nn(s) ? hv : Xr;
        return f(s);
      }
      function C(s) {
        if (s == null)
          return 0;
        if (Wo(s))
          return $c(s) ? Ps(s) : s.length;
        var f = fr(s);
        return f == Gn || f == jt ? s.size : hu(s).length;
      }
      function E(s, f, y) {
        var M = nn(s) ? oc : ts;
        return y && So(s, f, y) && (f = a), M(s, Vt(f, 3));
      }
      var H = be(function(s, f) {
        if (s == null)
          return [];
        var y = f.length;
        return y > 1 && So(s, f[0], f[1]) ? f = [] : y > 2 && So(f[0], f[1], f[2]) && (f = [f[0]]), an(s, hn(f, 1), []);
      }), q = vr || function() {
        return yr.Date.now();
      };
      function ee(s, f) {
        if (typeof f != "function")
          throw new Ei(m);
        return s = on(s), function() {
          if (--s < 1)
            return f.apply(this, arguments);
        };
      }
      function ye(s, f, y) {
        return f = y ? a : f, f = s && f == null ? s.length : f, Bt(s, G, a, a, a, a, f);
      }
      function Be(s, f) {
        var y;
        if (typeof f != "function")
          throw new Ei(m);
        return s = on(s), function() {
          return --s > 0 && (y = f.apply(this, arguments)), s <= 1 && (f = a), y;
        };
      }
      var $e = be(function(s, f, y) {
        var M = N;
        if (y.length) {
          var L = Po(y, Ll($e));
          M |= Y;
        }
        return Bt(s, M, f, y, L);
      }), Ne = be(function(s, f, y) {
        var M = N | B;
        if (y.length) {
          var L = Po(y, Ll(Ne));
          M |= Y;
        }
        return Bt(f, M, s, y, L);
      });
      function st(s, f, y) {
        f = y ? a : f;
        var M = Bt(s, W, a, a, a, a, a, f);
        return M.placeholder = st.placeholder, M;
      }
      function yt(s, f, y) {
        f = y ? a : f;
        var M = Bt(s, z, a, a, a, a, a, f);
        return M.placeholder = yt.placeholder, M;
      }
      function St(s, f, y) {
        var M, L, F, K, te, se, Oe = 0, je = !1, Ve = !1, rt = !0;
        if (typeof s != "function")
          throw new Ei(m);
        f = Pl(f) || 0, $r(y) && (je = !!y.leading, Ve = "maxWait" in y, F = Ve ? Kr(Pl(y.maxWait) || 0, f) : F, rt = "trailing" in y ? !!y.trailing : rt);
        function Ot(En) {
          var Dr = M, Ru = L;
          return M = L = a, Oe = En, K = s.apply(Ru, Dr), K;
        }
        function qt(En) {
          return Oe = En, te = w0(Xt, f), je ? Ot(En) : K;
        }
        function sn(En) {
          var Dr = En - se, Ru = En - Oe, Bi = f - Dr;
          return Ve ? ro(Bi, F - Ru) : Bi;
        }
        function Ut(En) {
          var Dr = En - se, Ru = En - Oe;
          return se === a || Dr >= f || Dr < 0 || Ve && Ru >= F;
        }
        function Xt() {
          var En = q();
          if (Ut(En))
            return yn(En);
          te = w0(Xt, sn(En));
        }
        function yn(En) {
          return te = a, rt && M ? Ot(En) : (M = L = a, K);
        }
        function zo() {
          te !== a && as(te), Oe = 0, M = se = L = te = a;
        }
        function ra() {
          return te === a ? K : yn(q());
        }
        function ka() {
          var En = q(), Dr = Ut(En);
          if (M = arguments, L = this, se = En, Dr) {
            if (te === a)
              return qt(se);
            if (Ve)
              return as(te), te = w0(Xt, f), Ot(se);
          }
          return te === a && (te = w0(Xt, f)), K;
        }
        return ka.cancel = zo, ka.flush = ra, ka;
      }
      var ta = be(function(s, f) {
        return K1(s, 1, f);
      }), fe = be(function(s, f, y) {
        return K1(s, Pl(f) || 0, y);
      });
      function ne(s) {
        return Bt(s, J);
      }
      function de(s, f) {
        if (typeof s != "function" || f != null && typeof f != "function")
          throw new Ei(m);
        var y = function() {
          var M = arguments, L = f ? f.apply(this, M) : M[0], F = y.cache;
          if (F.has(L))
            return F.get(L);
          var K = s.apply(this, M);
          return y.cache = F.set(L, K) || F, K;
        };
        return y.cache = new (de.Cache || pr)(), y;
      }
      de.Cache = pr;
      function Fe(s) {
        if (typeof s != "function")
          throw new Ei(m);
        return function() {
          var f = arguments;
          switch (f.length) {
            case 0:
              return !s.call(this);
            case 1:
              return !s.call(this, f[0]);
            case 2:
              return !s.call(this, f[0], f[1]);
            case 3:
              return !s.call(this, f[0], f[1], f[2]);
          }
          return !s.apply(this, f);
        };
      }
      function xt(s) {
        return Be(2, s);
      }
      var Zt = Jf(function(s, f) {
        f = f.length == 1 && nn(f[0]) ? hr(f[0], no(Vt())) : hr(hn(f, 1), no(Vt()));
        var y = f.length;
        return be(function(M) {
          for (var L = -1, F = ro(M.length, y); ++L < F; )
            M[L] = f[L].call(this, M[L]);
          return er(s, this, M);
        });
      }), It = be(function(s, f) {
        var y = Po(f, Ll(It));
        return Bt(s, Y, a, f, y);
      }), zt = be(function(s, f) {
        var y = Po(f, Ll(zt));
        return Bt(s, ie, a, f, y);
      }), ja = kl(function(s, f) {
        return Bt(s, pe, a, a, a, f);
      });
      function Fn(s, f) {
        if (typeof s != "function")
          throw new Ei(m);
        return f = f === a ? f : on(f), be(s, f);
      }
      function ms(s, f) {
        if (typeof s != "function")
          throw new Ei(m);
        return f = f == null ? 0 : Kr(on(f), 0), be(function(y) {
          var M = y[f], L = Hi(y, 0, f);
          return M && Bu(L, M), er(s, this, L);
        });
      }
      function Nv(s, f, y) {
        var M = !0, L = !0;
        if (typeof s != "function")
          throw new Ei(m);
        return $r(y) && (M = "leading" in y ? !!y.leading : M, L = "trailing" in y ? !!y.trailing : L), St(s, f, {
          leading: M,
          maxWait: f,
          trailing: L
        });
      }
      function y3(s) {
        return ye(s, 1);
      }
      function Lw(s, f) {
        return It(r0(f), s);
      }
      function Iw() {
        if (!arguments.length)
          return [];
        var s = arguments[0];
        return nn(s) ? s : [s];
      }
      function x3(s) {
        return Vo(s, j);
      }
      function gm(s, f) {
        return f = typeof f == "function" ? f : a, Vo(s, j, f);
      }
      function Hw(s) {
        return Vo(s, T | j);
      }
      function Zw(s, f) {
        return f = typeof f == "function" ? f : a, Vo(s, T | j, f);
      }
      function Pw(s, f) {
        return f == null || mc(s, f, co(f));
      }
      function _u(s, f) {
        return s === f || s !== s && f !== f;
      }
      var Nw = us(Sr), Vw = us(function(s, f) {
        return s >= f;
      }), Zl = Kf(/* @__PURE__ */ function() {
        return arguments;
      }()) ? Kf : function(s) {
        return na(s) && Dn.call(s, "callee") && !Ff.call(s, "callee");
      }, nn = we.isArray, e2 = jf ? no(jf) : mv;
      function Wo(s) {
        return s != null && t2(s.length) && !gs(s);
      }
      function _a(s) {
        return na(s) && Wo(s);
      }
      function Fw(s) {
        return s === !0 || s === !1 || na(s) && Wa(s) == Qt;
      }
      var c1 = Uf || Pm, Bw = po ? no(po) : du;
      function Vv(s) {
        return na(s) && s.nodeType === 1 && !Md(s);
      }
      function Rd(s) {
        if (s == null)
          return !0;
        if (Wo(s) && (nn(s) || typeof s == "string" || typeof s.splice == "function" || c1(s) || Wc(s) || Zl(s)))
          return !s.length;
        var f = fr(s);
        if (f == Gn || f == jt)
          return !s.size;
        if (yu(s))
          return !hu(s).length;
        for (var y in s)
          if (Dn.call(s, y))
            return !1;
        return !0;
      }
      function wm(s, f) {
        return ji(s, f);
      }
      function S3(s, f, y) {
        y = typeof y == "function" ? y : a;
        var M = y ? y(s, f) : a;
        return M === a ? ji(s, f, a, y) : !!M;
      }
      function Ed(s) {
        if (!na(s))
          return !1;
        var f = Wa(s);
        return f == Wn || f == ar || typeof s.message == "string" && typeof s.name == "string" && !Md(s);
      }
      function C3(s) {
        return typeof s == "number" && Ys(s);
      }
      function gs(s) {
        if (!$r(s))
          return !1;
        var f = Wa(s);
        return f == zn || f == qn || f == Tn || f == fn;
      }
      function ym(s) {
        return typeof s == "number" && s == on(s);
      }
      function t2(s) {
        return typeof s == "number" && s > -1 && s % 1 == 0 && s <= ue;
      }
      function $r(s) {
        var f = typeof s;
        return s != null && (f == "object" || f == "function");
      }
      function na(s) {
        return s != null && typeof s == "object";
      }
      var f1 = Fu ? no(Fu) : gv;
      function Uw(s, f) {
        return s === f || Ks(s, f, qa(f));
      }
      function Yw(s, f, y) {
        return y = typeof y == "function" ? y : a, Ks(s, f, qa(f), y);
      }
      function $w(s) {
        return _3(s) && s != +s;
      }
      function n2(s) {
        if (bv(s))
          throw new Gt(g);
        return Xf(s);
      }
      function xm(s) {
        return s === null;
      }
      function b3(s) {
        return s == null;
      }
      function _3(s) {
        return typeof s == "number" || na(s) && Wa(s) == wr;
      }
      function Md(s) {
        if (!na(s) || Wa(s) != jr)
          return !1;
        var f = Ji(s);
        if (f === null)
          return !0;
        var y = Dn.call(f, "constructor") && f.constructor;
        return typeof y == "function" && y instanceof y && sc.call(y) == Vf;
      }
      var Sm = nc ? no(nc) : wc;
      function Zr(s) {
        return ym(s) && s >= -ue && s <= ue;
      }
      var Fv = Z1 ? no(Z1) : Al;
      function $c(s) {
        return typeof s == "string" || !nn(s) && na(s) && Wa(s) == On;
      }
      function Ro(s) {
        return typeof s == "symbol" || na(s) && Wa(s) == Gr;
      }
      var Wc = q2 ? no(q2) : yc;
      function R3(s) {
        return s === a;
      }
      function Cm(s) {
        return na(s) && fr(s) == $t;
      }
      function r2(s) {
        return na(s) && Wa(s) == Cn;
      }
      var Ww = us(vu), Bv = us(function(s, f) {
        return s <= f;
      });
      function zc(s) {
        if (!s)
          return [];
        if (Wo(s))
          return $c(s) ? oi(s) : xo(s);
        if (el && s[el])
          return nm(s[el]());
        var f = fr(s), y = f == Gn ? uc : f == jt ? eu : Dd;
        return y(s);
      }
      function d1(s) {
        if (!s)
          return s === 0 ? s : 0;
        if (s = Pl(s), s === Ye || s === -Ye) {
          var f = s < 0 ? -1 : 1;
          return f * Ae;
        }
        return s === s ? s : 0;
      }
      function on(s) {
        var f = d1(s), y = f % 1;
        return f === f ? y ? f - y : f : 0;
      }
      function E3(s) {
        return s ? cu(on(s), 0, dt) : 0;
      }
      function Pl(s) {
        if (typeof s == "number")
          return s;
        if (Ro(s))
          return Pe;
        if ($r(s)) {
          var f = typeof s.valueOf == "function" ? s.valueOf() : s;
          s = $r(f) ? f + "" : f;
        }
        if (typeof s != "string")
          return s === 0 ? s : +s;
        s = Hf(s);
        var y = dn.test(s);
        return y || Da.test(s) ? tc(s.slice(2), y ? 2 : 8) : Kn.test(s) ? Pe : +s;
      }
      function fi(s) {
        return mn(s, Vi(s));
      }
      function a2(s) {
        return s ? cu(on(s), -ue, ue) : s === 0 ? s : 0;
      }
      function $n(s) {
        return s == null ? "" : lo(s);
      }
      var _0 = mu(function(s, f) {
        if (yu(f) || Wo(f)) {
          mn(f, co(f), s);
          return;
        }
        for (var y in f)
          Dn.call(f, y) && Xu(s, y, f[y]);
      }), bm = mu(function(s, f) {
        mn(f, Vi(f), s);
      }), ws = mu(function(s, f, y, M) {
        mn(f, Vi(f), s, M);
      }), qc = mu(function(s, f, y, M) {
        mn(f, co(f), s, M);
      }), Uv = kl(qf);
      function _m(s, f) {
        var y = W1(s);
        return f == null ? y : xr(y, f);
      }
      var Yv = be(function(s, f) {
        s = tr(s);
        var y = -1, M = f.length, L = M > 2 ? f[2] : a;
        for (L && So(f[0], f[1], L) && (M = 1); ++y < M; )
          for (var F = f[y], K = Vi(F), te = -1, se = K.length; ++te < se; ) {
            var Oe = K[te], je = s[Oe];
            (je === a || _u(je, _l[Oe]) && !Dn.call(s, Oe)) && (s[Oe] = F[Oe]);
          }
        return s;
      }), o2 = be(function(s) {
        return s.push(a, ld), er(D3, a, s);
      });
      function M3(s, f) {
        return X2(s, Vt(f, 3), Hr);
      }
      function $v(s, f) {
        return X2(s, Vt(f, 3), es);
      }
      function T3(s, f) {
        return s == null ? s : et(s, Vt(f, 3), Vi);
      }
      function O3(s, f) {
        return s == null ? s : Fo(s, Vt(f, 3), Vi);
      }
      function zw(s, f) {
        return s && Hr(s, Vt(f, 3));
      }
      function qw(s, f) {
        return s && es(s, Vt(f, 3));
      }
      function Wv(s) {
        return s == null ? [] : Q1(s, co(s));
      }
      function zv(s) {
        return s == null ? [] : Q1(s, Vi(s));
      }
      function qv(s, f, y) {
        var M = s == null ? a : fu(s, f);
        return M === a ? y : M;
      }
      function Gw(s, f) {
        return s != null && Bh(s, f, Ai);
      }
      function Td(s, f) {
        return s != null && Bh(s, f, Gs);
      }
      var Kw = Oc(function(s, f, y) {
        f != null && typeof f.toString != "function" && (f = fc.call(f)), s[f] = y;
      }, l2(Fi)), Qw = Oc(function(s, f, y) {
        f != null && typeof f.toString != "function" && (f = fc.call(f)), Dn.call(s, f) ? s[f].push(y) : s[f] = [y];
      }, Vt), Xw = be(za);
      function co(s) {
        return Wo(s) ? rl(s) : hu(s);
      }
      function Vi(s) {
        return Wo(s) ? rl(s, !0) : Zh(s);
      }
      function Jw(s, f) {
        var y = {};
        return f = Vt(f, 3), Hr(s, function(M, L, F) {
          ol(y, f(M, L, F), M);
        }), y;
      }
      function e6(s, f) {
        var y = {};
        return f = Vt(f, 3), Hr(s, function(M, L, F) {
          ol(y, L, f(M, L, F));
        }), y;
      }
      var t6 = mu(function(s, f, y) {
        Qs(s, f, y);
      }), D3 = mu(function(s, f, y, M) {
        Qs(s, f, y, M);
      }), n6 = kl(function(s, f) {
        var y = {};
        if (s == null)
          return y;
        var M = !1;
        f = hr(f, function(F) {
          return F = Ii(F, s), M || (M = F.length > 1), F;
        }), mn(s, kc(s), y), M && (y = Vo(y, T | A | j, yv));
        for (var L = f.length; L--; )
          t0(y, f[L]);
        return y;
      });
      function Rm(s, f) {
        return Gv(s, Fe(Vt(f)));
      }
      var Em = kl(function(s, f) {
        return s == null ? {} : Nn(s, f);
      });
      function Gv(s, f) {
        if (s == null)
          return {};
        var y = hr(kc(s), function(M) {
          return [M];
        });
        return f = Vt(f), nr(s, y, function(M, L) {
          return f(M, L[0]);
        });
      }
      function Mm(s, f, y) {
        f = Ii(f, s);
        var M = -1, L = f.length;
        for (L || (L = 1, s = a); ++M < L; ) {
          var F = s == null ? a : s[ul(f[M])];
          F === a && (M = L, F = y), s = gs(F) ? F.call(s) : F;
        }
        return s;
      }
      function r6(s, f, y) {
        return s == null ? s : ki(s, f, y);
      }
      function i2(s, f, y, M) {
        return M = typeof M == "function" ? M : a, s == null ? s : ki(s, f, y, M);
      }
      var Od = ss(co), A3 = ss(Vi);
      function j3(s, f, y) {
        var M = nn(s), L = M || c1(s) || Wc(s);
        if (f = Vt(f, 4), y == null) {
          var F = s && s.constructor;
          L ? y = M ? new F() : [] : $r(s) ? y = gs(F) ? W1(Ji(s)) : {} : y = {};
        }
        return (L ? Ua : Hr)(s, function(K, te, se) {
          return f(y, K, te, se);
        }), y;
      }
      function a6(s, f) {
        return s == null ? !0 : t0(s, f);
      }
      function o6(s, f, y) {
        return s == null ? s : Rc(s, f, r0(y));
      }
      function k3(s, f, y, M) {
        return M = typeof M == "function" ? M : a, s == null ? s : Rc(s, f, r0(y), M);
      }
      function Dd(s) {
        return s == null ? [] : lc(s, co(s));
      }
      function i6(s) {
        return s == null ? [] : lc(s, Vi(s));
      }
      function L3(s, f, y) {
        return y === a && (y = f, f = a), y !== a && (y = Pl(y), y = y === y ? y : 0), f !== a && (f = Pl(f), f = f === f ? f : 0), cu(Pl(s), f, y);
      }
      function Kv(s, f, y) {
        return f = d1(f), y === a ? (y = f, f = 0) : y = d1(y), s = Pl(s), Hh(s, f, y);
      }
      function Qv(s, f, y) {
        if (y && typeof y != "boolean" && So(s, f, y) && (f = y = a), y === a && (typeof f == "boolean" ? (y = f, f = a) : typeof s == "boolean" && (y = s, s = a)), s === a && f === a ? (s = 0, f = 1) : (s = d1(s), f === a ? (f = s, s = 0) : f = d1(f)), s > f) {
          var M = s;
          s = f, f = M;
        }
        if (y || s % 1 || f % 1) {
          var L = ru();
          return ro(s + L * (f - s + Af("1e-" + ((L + "").length - 1))), f);
        }
        return J1(s, f);
      }
      var Xv = gu(function(s, f, y) {
        return f = f.toLowerCase(), s + (y ? Ad(f) : f);
      });
      function Ad(s) {
        return km($n(s).toLowerCase());
      }
      function jd(s) {
        return s = $n(s), s && s.replace(Er, ev).replace(U2, "");
      }
      function l6(s, f, y) {
        s = $n(s), f = lo(f);
        var M = s.length;
        y = y === a ? M : cu(on(y), 0, M);
        var L = y;
        return y -= f.length, y >= 0 && s.slice(y, L) == f;
      }
      function Tm(s) {
        return s = $n(s), s && W0.test(s) ? s.replace(Jo, tv) : s;
      }
      function Om(s) {
        return s = $n(s), s && ti.test(s) ? s.replace(ei, "\\$&") : s;
      }
      var u6 = gu(function(s, f, y) {
        return s + (y ? "-" : "") + f.toLowerCase();
      }), s6 = gu(function(s, f, y) {
        return s + (y ? " " : "") + f.toLowerCase();
      }), uS = Vh("toLowerCase");
      function c6(s, f, y) {
        s = $n(s), f = on(f);
        var M = f ? Ps(s) : 0;
        if (!f || M >= f)
          return s;
        var L = (f - M) / 2;
        return l0(Wu(L), y) + s + l0($u(L), y);
      }
      function f6(s, f, y) {
        s = $n(s), f = on(f);
        var M = f ? Ps(s) : 0;
        return f && M < f ? s + l0(f - M, y) : s;
      }
      function d6(s, f, y) {
        s = $n(s), f = on(f);
        var M = f ? Ps(s) : 0;
        return f && M < f ? l0(f - M, y) + s : s;
      }
      function h6(s, f, y) {
        return y || f == null ? f = 0 : f && (f = +f), fv($n(s).replace(ku, ""), f || 0);
      }
      function v6(s, f, y) {
        return (y ? So(s, f, y) : f === a) ? f = 1 : f = on(f), pu($n(s), f);
      }
      function p6() {
        var s = arguments, f = $n(s[0]);
        return s.length < 3 ? f : f.replace(s[1], s[2]);
      }
      var Dm = gu(function(s, f, y) {
        return s + (y ? "_" : "") + f.toLowerCase();
      });
      function m6(s, f, y) {
        return y && typeof y != "number" && So(s, f, y) && (f = y = a), y = y === a ? dt : y >>> 0, y ? (s = $n(s), s && (typeof f == "string" || f != null && !Sm(f)) && (f = lo(f), !f && V1(s)) ? Hi(oi(s), 0, y) : s.split(f, y)) : [];
      }
      var g6 = gu(function(s, f, y) {
        return s + (y ? " " : "") + km(f);
      });
      function Am(s, f, y) {
        return s = $n(s), y = y == null ? 0 : cu(on(y), 0, s.length), f = lo(f), s.slice(y, y + f.length) == f;
      }
      function w6(s, f, y) {
        var M = P.templateSettings;
        y && So(s, f, y) && (f = a), s = $n(s), f = ws({}, f, M, u0);
        var L = ws({}, f.imports, M.imports, u0), F = co(L), K = lc(L, F), te, se, Oe = 0, je = f.interpolate || Fa, Ve = "__p += '", rt = bl(
          (f.escape || Fa).source + "|" + je.source + "|" + (je === q0 ? vt : Fa).source + "|" + (f.evaluate || Fa).source + "|$",
          "g"
        ), Ot = "//# sourceURL=" + (Dn.call(f, "sourceURL") ? (f.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++em + "]") + `
`;
        s.replace(rt, function(Ut, Xt, yn, zo, ra, ka) {
          return yn || (yn = zo), Ve += s.slice(Oe, ka).replace(Io, nv), Xt && (te = !0, Ve += `' +
__e(` + Xt + `) +
'`), ra && (se = !0, Ve += `';
` + ra + `;
__p += '`), yn && (Ve += `' +
((__t = (` + yn + `)) == null ? '' : __t) +
'`), Oe = ka + Ut.length, Ut;
        }), Ve += `';
`;
        var qt = Dn.call(f, "variable") && f.variable;
        if (!qt)
          Ve = `with (obj) {
` + Ve + `
}
`;
        else if (We.test(qt))
          throw new Gt(S);
        Ve = (se ? Ve.replace(_r, "") : Ve).replace(kr, "$1").replace(O1, "$1;"), Ve = "function(" + (qt || "obj") + `) {
` + (qt ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (te ? ", __e = _.escape" : "") + (se ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Ve + `return __p
}`;
        var sn = P3(function() {
          return cn(F, Ot + "return " + Ve).apply(a, K);
        });
        if (sn.source = Ve, Ed(sn))
          throw sn;
        return sn;
      }
      function jm(s) {
        return $n(s).toLowerCase();
      }
      function I3(s) {
        return $n(s).toUpperCase();
      }
      function y6(s, f, y) {
        if (s = $n(s), s && (y || f === a))
          return Hf(s);
        if (!s || !(f = lo(f)))
          return s;
        var M = oi(s), L = oi(f), F = J2(M, L), K = kh(M, L) + 1;
        return Hi(M, F, K).join("");
      }
      function x6(s, f, y) {
        if (s = $n(s), s && (y || f === a))
          return s.slice(0, Nf(s) + 1);
        if (!s || !(f = lo(f)))
          return s;
        var M = oi(s), L = kh(M, oi(f)) + 1;
        return Hi(M, 0, L).join("");
      }
      function S6(s, f, y) {
        if (s = $n(s), s && (y || f === a))
          return s.replace(ku, "");
        if (!s || !(f = lo(f)))
          return s;
        var M = oi(s), L = J2(M, oi(f));
        return Hi(M, L).join("");
      }
      function C6(s, f) {
        var y = me, M = oe;
        if ($r(f)) {
          var L = "separator" in f ? f.separator : L;
          y = "length" in f ? on(f.length) : y, M = "omission" in f ? lo(f.omission) : M;
        }
        s = $n(s);
        var F = s.length;
        if (V1(s)) {
          var K = oi(s);
          F = K.length;
        }
        if (y >= F)
          return s;
        var te = y - Ps(M);
        if (te < 1)
          return M;
        var se = K ? Hi(K, 0, te).join("") : s.slice(0, te);
        if (L === a)
          return se + M;
        if (K && (te += se.length - te), Sm(L)) {
          if (s.slice(te).search(L)) {
            var Oe, je = se;
            for (L.global || (L = bl(L.source, $n(bn.exec(L)) + "g")), L.lastIndex = 0; Oe = L.exec(je); )
              var Ve = Oe.index;
            se = se.slice(0, Ve === a ? te : Ve);
          }
        } else if (s.indexOf(lo(L), te) != te) {
          var rt = se.lastIndexOf(L);
          rt > -1 && (se = se.slice(0, rt));
        }
        return se + M;
      }
      function H3(s) {
        return s = $n(s), s && D1.test(s) ? s.replace(to, av) : s;
      }
      var b6 = gu(function(s, f, y) {
        return s + (y ? " " : "") + f.toUpperCase();
      }), km = Vh("toUpperCase");
      function Z3(s, f, y) {
        return s = $n(s), f = y ? a : f, f === a ? tm(s) ? lv(s) : Q2(s) : s.match(f) || [];
      }
      var P3 = be(function(s, f) {
        try {
          return er(s, a, f);
        } catch (y) {
          return Ed(y) ? y : new Gt(y);
        }
      }), _6 = kl(function(s, f) {
        return Ua(f, function(y) {
          y = ul(y), ol(s, y, $e(s[y], s));
        }), s;
      });
      function R6(s) {
        var f = s == null ? 0 : s.length, y = Vt();
        return s = f ? hr(s, function(M) {
          if (typeof M[1] != "function")
            throw new Ei(m);
          return [y(M[0]), M[1]];
        }) : [], be(function(M) {
          for (var L = -1; ++L < f; ) {
            var F = s[L];
            if (er(F[0], this, M))
              return er(F[1], this, M);
          }
        });
      }
      function E6(s) {
        return ya(Vo(s, T));
      }
      function l2(s) {
        return function() {
          return s;
        };
      }
      function M6(s, f) {
        return s == null || s !== s ? f : s;
      }
      var T6 = id(), O6 = id(!0);
      function Fi(s) {
        return s;
      }
      function Lm(s) {
        return X1(typeof s == "function" ? s : Vo(s, T));
      }
      function D6(s) {
        return xc(Vo(s, T));
      }
      function A6(s, f) {
        return Tr(s, Vo(f, T));
      }
      var j6 = be(function(s, f) {
        return function(y) {
          return za(y, s, f);
        };
      }), k6 = be(function(s, f) {
        return function(y) {
          return za(s, y, f);
        };
      });
      function Jv(s, f, y) {
        var M = co(f), L = Q1(f, M);
        y == null && !($r(f) && (L.length || !M.length)) && (y = f, f = s, s = this, L = Q1(f, co(f)));
        var F = !($r(y) && "chain" in y) || !!y.chain, K = gs(s);
        return Ua(L, function(te) {
          var se = f[te];
          s[te] = se, K && (s.prototype[te] = function() {
            var Oe = this.__chain__;
            if (F || Oe) {
              var je = s(this.__wrapped__), Ve = je.__actions__ = xo(this.__actions__);
              return Ve.push({ func: se, args: arguments, thisArg: s }), je.__chain__ = Oe, je;
            }
            return se.apply(s, Bu([this.value()], arguments));
          });
        }), s;
      }
      function Im() {
        return yr._ === this && (yr._ = uv), this;
      }
      function Hm() {
      }
      function L6(s) {
        return s = on(s), be(function(f) {
          return kt(f, s);
        });
      }
      var ep = Ac(hr), u2 = Ac(Th), I6 = Ac(oc);
      function N3(s) {
        return ct(s) ? Ah(ul(s)) : Vn(s);
      }
      function H6(s) {
        return function(f) {
          return s == null ? a : fu(s, f);
        };
      }
      var Z6 = wu(), P6 = wu(!0);
      function Zm() {
        return [];
      }
      function Pm() {
        return !1;
      }
      function V3() {
        return {};
      }
      function N6() {
        return "";
      }
      function V6() {
        return !0;
      }
      function F6(s, f) {
        if (s = on(s), s < 1 || s > ue)
          return [];
        var y = dt, M = ro(s, dt);
        f = Vt(f), s -= dt;
        for (var L = Fr(M, f); ++y < s; )
          f(y);
        return L;
      }
      function B6(s) {
        return nn(s) ? hr(s, ul) : Ro(s) ? [s] : xo(hd($n(s)));
      }
      function U6(s) {
        var f = ++ua;
        return $n(s) + f;
      }
      var Y6 = Dc(function(s, f) {
        return s + f;
      }, 0), $6 = Sa("ceil"), W6 = Dc(function(s, f) {
        return s / f;
      }, 1), z6 = Sa("floor");
      function q6(s) {
        return s && s.length ? qs(s, Fi, Sr) : a;
      }
      function G6(s, f) {
        return s && s.length ? qs(s, Vt(f, 2), Sr) : a;
      }
      function K6(s) {
        return If(s, Fi);
      }
      function Q6(s, f) {
        return If(s, Vt(f, 2));
      }
      function X6(s) {
        return s && s.length ? qs(s, Fi, vu) : a;
      }
      function J6(s, f) {
        return s && s.length ? qs(s, Vt(f, 2), vu) : a;
      }
      var e7 = Dc(function(s, f) {
        return s * f;
      }, 1), kd = Sa("round"), Ld = Dc(function(s, f) {
        return s - f;
      }, 0);
      function Nm(s) {
        return s && s.length ? Xi(s, Fi) : 0;
      }
      function s2(s, f) {
        return s && s.length ? Xi(s, Vt(f, 2)) : 0;
      }
      return P.after = ee, P.ary = ye, P.assign = _0, P.assignIn = bm, P.assignInWith = ws, P.assignWith = qc, P.at = Uv, P.before = Be, P.bind = $e, P.bindAll = _6, P.bindKey = Ne, P.castArray = Iw, P.chain = gd, P.chunk = cs, P.compact = n1, P.concat = Ka, P.cond = R6, P.conforms = E6, P.constant = l2, P.countBy = Qh, P.create = _m, P.curry = st, P.curryRight = yt, P.debounce = St, P.defaults = Yv, P.defaultsDeep = o2, P.defer = ta, P.delay = fe, P.difference = wn, P.differenceBy = ba, P.differenceWith = da, P.drop = Qa, P.dropRight = si, P.dropRightWhile = y0, P.dropWhile = ea, P.fill = Zc, P.filter = xd, P.flatMap = Cd, P.flatMapDeep = Hv, P.flatMapDepth = s1, P.flatten = Pc, P.flattenDeep = Nc, P.flattenDepth = Yo, P.flip = ne, P.flow = T6, P.flowRight = O6, P.fromPairs = $h, P.functions = Wv, P.functionsIn = zv, P.groupBy = Jh, P.initial = x0, P.intersection = o1, P.intersectionBy = fs, P.intersectionWith = vd, P.invert = Kw, P.invertBy = Qw, P.invokeMap = Zv, P.iteratee = Lm, P.keyBy = pm, P.keys = co, P.keysIn = Vi, P.map = vs, P.mapKeys = Jw, P.mapValues = e6, P.matches = D6, P.matchesProperty = A6, P.memoize = de, P.merge = t6, P.mergeWith = D3, P.method = j6, P.methodOf = k6, P.mixin = Jv, P.negate = Fe, P.nthArg = L6, P.omit = n6, P.omitBy = Rm, P.once = xt, P.orderBy = mm, P.over = ep, P.overArgs = Zt, P.overEvery = u2, P.overSome = I6, P.partial = It, P.partialRight = zt, P.partition = Yc, P.pick = Em, P.pickBy = Gv, P.property = N3, P.propertyOf = H6, P.pull = Vc, P.pullAll = Xa, P.pullAllBy = ha, P.pullAllWith = Hl, P.pullAt = _o, P.range = Z6, P.rangeRight = P6, P.rearg = ja, P.reject = o, P.remove = $o, P.rest = Fn, P.reverse = C0, P.sampleSize = v, P.set = r6, P.setWith = i2, P.shuffle = w, P.slice = Fc, P.sortBy = H, P.sortedUniq = qh, P.sortedUniqBy = Cu, P.split = m6, P.spread = ms, P.tail = Rv, P.take = Ev, P.takeRight = Gh, P.takeRightWhile = pd, P.takeWhile = um, P.tap = hm, P.throttle = Nv, P.thru = dl, P.toArray = zc, P.toPairs = Od, P.toPairsIn = A3, P.toPath = B6, P.toPlainObject = fi, P.transform = j3, P.unary = y3, P.union = Mv, P.unionBy = Tv, P.unionWith = Ov, P.uniq = u1, P.uniqBy = sm, P.uniqWith = b0, P.unset = a6, P.unzip = md, P.unzipWith = Cr, P.update = o6, P.updateWith = k3, P.values = Dd, P.valuesIn = i6, P.without = cm, P.words = Z3, P.wrap = Lw, P.xor = Dv, P.xorBy = fm, P.xorWith = Av, P.zip = jv, P.zipObject = kv, P.zipObjectDeep = dm, P.zipWith = Ni, P.entries = Od, P.entriesIn = A3, P.extend = bm, P.extendWith = ws, Jv(P, P), P.add = Y6, P.attempt = P3, P.camelCase = Xv, P.capitalize = Ad, P.ceil = $6, P.clamp = L3, P.clone = x3, P.cloneDeep = Hw, P.cloneDeepWith = Zw, P.cloneWith = gm, P.conformsTo = Pw, P.deburr = jd, P.defaultTo = M6, P.divide = W6, P.endsWith = l6, P.eq = _u, P.escape = Tm, P.escapeRegExp = Om, P.every = Iv, P.find = Sd, P.findIndex = cl, P.findKey = M3, P.findLast = Xh, P.findLastIndex = r1, P.findLastKey = $v, P.floor = z6, P.forEach = bd, P.forEachRight = Uc, P.forIn = T3, P.forInRight = O3, P.forOwn = zw, P.forOwnRight = qw, P.get = qv, P.gt = Nw, P.gte = Vw, P.has = Gw, P.hasIn = Td, P.head = a1, P.identity = Fi, P.includes = _d, P.indexOf = ci, P.inRange = Kv, P.invoke = Xw, P.isArguments = Zl, P.isArray = nn, P.isArrayBuffer = e2, P.isArrayLike = Wo, P.isArrayLikeObject = _a, P.isBoolean = Fw, P.isBuffer = c1, P.isDate = Bw, P.isElement = Vv, P.isEmpty = Rd, P.isEqual = wm, P.isEqualWith = S3, P.isError = Ed, P.isFinite = C3, P.isFunction = gs, P.isInteger = ym, P.isLength = t2, P.isMap = f1, P.isMatch = Uw, P.isMatchWith = Yw, P.isNaN = $w, P.isNative = n2, P.isNil = b3, P.isNull = xm, P.isNumber = _3, P.isObject = $r, P.isObjectLike = na, P.isPlainObject = Md, P.isRegExp = Sm, P.isSafeInteger = Zr, P.isSet = Fv, P.isString = $c, P.isSymbol = Ro, P.isTypedArray = Wc, P.isUndefined = R3, P.isWeakMap = Cm, P.isWeakSet = r2, P.join = Su, P.kebabCase = u6, P.last = so, P.lastIndexOf = ds, P.lowerCase = s6, P.lowerFirst = uS, P.lt = Ww, P.lte = Bv, P.max = q6, P.maxBy = G6, P.mean = K6, P.meanBy = Q6, P.min = X6, P.minBy = J6, P.stubArray = Zm, P.stubFalse = Pm, P.stubObject = V3, P.stubString = N6, P.stubTrue = V6, P.multiply = e7, P.nth = S0, P.noConflict = Im, P.noop = Hm, P.now = q, P.pad = c6, P.padEnd = f6, P.padStart = d6, P.parseInt = h6, P.random = Qv, P.reduce = Pv, P.reduceRight = ps, P.repeat = v6, P.replace = p6, P.result = Mm, P.round = kd, P.runInContext = le, P.sample = l, P.size = C, P.snakeCase = Dm, P.some = E, P.sortedIndex = i1, P.sortedIndexBy = lm, P.sortedIndexOf = fl, P.sortedLastIndex = Wh, P.sortedLastIndexBy = zh, P.sortedLastIndexOf = l1, P.startCase = g6, P.startsWith = Am, P.subtract = Ld, P.sum = Nm, P.sumBy = s2, P.template = w6, P.times = F6, P.toFinite = d1, P.toInteger = on, P.toLength = E3, P.toLower = jm, P.toNumber = Pl, P.toSafeInteger = a2, P.toString = $n, P.toUpper = I3, P.trim = y6, P.trimEnd = x6, P.trimStart = S6, P.truncate = C6, P.unescape = H3, P.uniqueId = U6, P.upperCase = b6, P.upperFirst = km, P.each = bd, P.eachRight = Uc, P.first = a1, Jv(P, function() {
        var s = {};
        return Hr(P, function(f, y) {
          Dn.call(P.prototype, y) || (s[y] = f);
        }), s;
      }(), { chain: !1 }), P.VERSION = i, Ua(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(s) {
        P[s].placeholder = P;
      }), Ua(["drop", "take"], function(s, f) {
        Tt.prototype[s] = function(y) {
          y = y === a ? 1 : Kr(on(y), 0);
          var M = this.__filtered__ && !f ? new Tt(this) : this.clone();
          return M.__filtered__ ? M.__takeCount__ = ro(y, M.__takeCount__) : M.__views__.push({
            size: ro(y, dt),
            type: s + (M.__dir__ < 0 ? "Right" : "")
          }), M;
        }, Tt.prototype[s + "Right"] = function(y) {
          return this.reverse()[s](y).reverse();
        };
      }), Ua(["filter", "map", "takeWhile"], function(s, f) {
        var y = f + 1, M = y == Se || y == _e;
        Tt.prototype[s] = function(L) {
          var F = this.clone();
          return F.__iteratees__.push({
            iteratee: Vt(L, 3),
            type: y
          }), F.__filtered__ = F.__filtered__ || M, F;
        };
      }), Ua(["head", "last"], function(s, f) {
        var y = "take" + (f ? "Right" : "");
        Tt.prototype[s] = function() {
          return this[y](1).value()[0];
        };
      }), Ua(["initial", "tail"], function(s, f) {
        var y = "drop" + (f ? "" : "Right");
        Tt.prototype[s] = function() {
          return this.__filtered__ ? new Tt(this) : this[y](1);
        };
      }), Tt.prototype.compact = function() {
        return this.filter(Fi);
      }, Tt.prototype.find = function(s) {
        return this.filter(s).head();
      }, Tt.prototype.findLast = function(s) {
        return this.reverse().find(s);
      }, Tt.prototype.invokeMap = be(function(s, f) {
        return typeof s == "function" ? new Tt(this) : this.map(function(y) {
          return za(y, s, f);
        });
      }), Tt.prototype.reject = function(s) {
        return this.filter(Fe(Vt(s)));
      }, Tt.prototype.slice = function(s, f) {
        s = on(s);
        var y = this;
        return y.__filtered__ && (s > 0 || f < 0) ? new Tt(y) : (s < 0 ? y = y.takeRight(-s) : s && (y = y.drop(s)), f !== a && (f = on(f), y = f < 0 ? y.dropRight(-f) : y.take(f - s)), y);
      }, Tt.prototype.takeRightWhile = function(s) {
        return this.reverse().takeWhile(s).reverse();
      }, Tt.prototype.toArray = function() {
        return this.take(dt);
      }, Hr(Tt.prototype, function(s, f) {
        var y = /^(?:filter|find|map|reject)|While$/.test(f), M = /^(?:head|last)$/.test(f), L = P[M ? "take" + (f == "last" ? "Right" : "") : f], F = M || /^find/.test(f);
        L && (P.prototype[f] = function() {
          var K = this.__wrapped__, te = M ? [1] : arguments, se = K instanceof Tt, Oe = te[0], je = se || nn(K), Ve = function(Xt) {
            var yn = L.apply(P, Bu([Xt], te));
            return M && rt ? yn[0] : yn;
          };
          je && y && typeof Oe == "function" && Oe.length != 1 && (se = je = !1);
          var rt = this.__chain__, Ot = !!this.__actions__.length, qt = F && !rt, sn = se && !Ot;
          if (!F && je) {
            K = sn ? K : new Tt(this);
            var Ut = s.apply(K, te);
            return Ut.__actions__.push({ func: dl, args: [Ve], thisArg: a }), new Qr(Ut, rt);
          }
          return qt && sn ? s.apply(this, te) : (Ut = this.thru(Ve), qt ? M ? Ut.value()[0] : Ut.value() : Ut);
        });
      }), Ua(["pop", "push", "shift", "sort", "splice", "unshift"], function(s) {
        var f = tu[s], y = /^(?:push|sort|unshift)$/.test(s) ? "tap" : "thru", M = /^(?:pop|shift)$/.test(s);
        P.prototype[s] = function() {
          var L = arguments;
          if (M && !this.__chain__) {
            var F = this.value();
            return f.apply(nn(F) ? F : [], L);
          }
          return this[y](function(K) {
            return f.apply(nn(K) ? K : [], L);
          });
        };
      }), Hr(Tt.prototype, function(s, f) {
        var y = P[f];
        if (y) {
          var M = y.name + "";
          Dn.call(ou, M) || (ou[M] = []), ou[M].push({ name: f, func: y });
        }
      }), ou[i0(a, B).name] = [{
        name: "wrapper",
        func: a
      }], Tt.prototype.clone = un, Tt.prototype.reverse = lu, Tt.prototype.value = Ol, P.prototype.at = Bc, P.prototype.chain = bu, P.prototype.commit = hs, P.prototype.next = Kh, P.prototype.plant = Lv, P.prototype.reverse = yd, P.prototype.toJSON = P.prototype.valueOf = P.prototype.value = vm, P.prototype.first = P.prototype.head, el && (P.prototype[el] = wd), P;
    }, Ns = am();
    Qi ? ((Qi.exports = Ns)._ = Ns, Is._ = Ns) : yr._ = Ns;
  }).call(R4);
})(xx, xx.exports);
var Kq = xx.exports, jw = { exports: {} }, IO = {
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  Ấ: "A",
  Ắ: "A",
  Ẳ: "A",
  Ẵ: "A",
  Ặ: "A",
  Æ: "AE",
  Ầ: "A",
  Ằ: "A",
  Ȃ: "A",
  Ả: "A",
  Ạ: "A",
  Ẩ: "A",
  Ẫ: "A",
  Ậ: "A",
  Ç: "C",
  Ḉ: "C",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  Ế: "E",
  Ḗ: "E",
  Ề: "E",
  Ḕ: "E",
  Ḝ: "E",
  Ȇ: "E",
  Ẻ: "E",
  Ẽ: "E",
  Ẹ: "E",
  Ể: "E",
  Ễ: "E",
  Ệ: "E",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  Ḯ: "I",
  Ȋ: "I",
  Ỉ: "I",
  Ị: "I",
  Ð: "D",
  Ñ: "N",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  Ố: "O",
  Ṍ: "O",
  Ṓ: "O",
  Ȏ: "O",
  Ỏ: "O",
  Ọ: "O",
  Ổ: "O",
  Ỗ: "O",
  Ộ: "O",
  Ờ: "O",
  Ở: "O",
  Ỡ: "O",
  Ớ: "O",
  Ợ: "O",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  Ủ: "U",
  Ụ: "U",
  Ử: "U",
  Ữ: "U",
  Ự: "U",
  Ý: "Y",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  ấ: "a",
  ắ: "a",
  ẳ: "a",
  ẵ: "a",
  ặ: "a",
  æ: "ae",
  ầ: "a",
  ằ: "a",
  ȃ: "a",
  ả: "a",
  ạ: "a",
  ẩ: "a",
  ẫ: "a",
  ậ: "a",
  ç: "c",
  ḉ: "c",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  ế: "e",
  ḗ: "e",
  ề: "e",
  ḕ: "e",
  ḝ: "e",
  ȇ: "e",
  ẻ: "e",
  ẽ: "e",
  ẹ: "e",
  ể: "e",
  ễ: "e",
  ệ: "e",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  ḯ: "i",
  ȋ: "i",
  ỉ: "i",
  ị: "i",
  ð: "d",
  ñ: "n",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  ố: "o",
  ṍ: "o",
  ṓ: "o",
  ȏ: "o",
  ỏ: "o",
  ọ: "o",
  ổ: "o",
  ỗ: "o",
  ộ: "o",
  ờ: "o",
  ở: "o",
  ỡ: "o",
  ớ: "o",
  ợ: "o",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  ủ: "u",
  ụ: "u",
  ử: "u",
  ữ: "u",
  ự: "u",
  ý: "y",
  ÿ: "y",
  Ā: "A",
  ā: "a",
  Ă: "A",
  ă: "a",
  Ą: "A",
  ą: "a",
  Ć: "C",
  ć: "c",
  Ĉ: "C",
  ĉ: "c",
  Ċ: "C",
  ċ: "c",
  Č: "C",
  č: "c",
  C̆: "C",
  c̆: "c",
  Ď: "D",
  ď: "d",
  Đ: "D",
  đ: "d",
  Ē: "E",
  ē: "e",
  Ĕ: "E",
  ĕ: "e",
  Ė: "E",
  ė: "e",
  Ę: "E",
  ę: "e",
  Ě: "E",
  ě: "e",
  Ĝ: "G",
  Ǵ: "G",
  ĝ: "g",
  ǵ: "g",
  Ğ: "G",
  ğ: "g",
  Ġ: "G",
  ġ: "g",
  Ģ: "G",
  ģ: "g",
  Ĥ: "H",
  ĥ: "h",
  Ħ: "H",
  ħ: "h",
  Ḫ: "H",
  ḫ: "h",
  Ĩ: "I",
  ĩ: "i",
  Ī: "I",
  ī: "i",
  Ĭ: "I",
  ĭ: "i",
  Į: "I",
  į: "i",
  İ: "I",
  ı: "i",
  Ĳ: "IJ",
  ĳ: "ij",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  Ḱ: "K",
  ḱ: "k",
  K̆: "K",
  k̆: "k",
  Ĺ: "L",
  ĺ: "l",
  Ļ: "L",
  ļ: "l",
  Ľ: "L",
  ľ: "l",
  Ŀ: "L",
  ŀ: "l",
  Ł: "l",
  ł: "l",
  Ḿ: "M",
  ḿ: "m",
  M̆: "M",
  m̆: "m",
  Ń: "N",
  ń: "n",
  Ņ: "N",
  ņ: "n",
  Ň: "N",
  ň: "n",
  ŉ: "n",
  N̆: "N",
  n̆: "n",
  Ō: "O",
  ō: "o",
  Ŏ: "O",
  ŏ: "o",
  Ő: "O",
  ő: "o",
  Œ: "OE",
  œ: "oe",
  P̆: "P",
  p̆: "p",
  Ŕ: "R",
  ŕ: "r",
  Ŗ: "R",
  ŗ: "r",
  Ř: "R",
  ř: "r",
  R̆: "R",
  r̆: "r",
  Ȓ: "R",
  ȓ: "r",
  Ś: "S",
  ś: "s",
  Ŝ: "S",
  ŝ: "s",
  Ş: "S",
  Ș: "S",
  ș: "s",
  ş: "s",
  Š: "S",
  š: "s",
  Ţ: "T",
  ţ: "t",
  ț: "t",
  Ț: "T",
  Ť: "T",
  ť: "t",
  Ŧ: "T",
  ŧ: "t",
  T̆: "T",
  t̆: "t",
  Ũ: "U",
  ũ: "u",
  Ū: "U",
  ū: "u",
  Ŭ: "U",
  ŭ: "u",
  Ů: "U",
  ů: "u",
  Ű: "U",
  ű: "u",
  Ų: "U",
  ų: "u",
  Ȗ: "U",
  ȗ: "u",
  V̆: "V",
  v̆: "v",
  Ŵ: "W",
  ŵ: "w",
  Ẃ: "W",
  ẃ: "w",
  X̆: "X",
  x̆: "x",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Y̆: "Y",
  y̆: "y",
  Ź: "Z",
  ź: "z",
  Ż: "Z",
  ż: "z",
  Ž: "Z",
  ž: "z",
  ſ: "s",
  ƒ: "f",
  Ơ: "O",
  ơ: "o",
  Ư: "U",
  ư: "u",
  Ǎ: "A",
  ǎ: "a",
  Ǐ: "I",
  ǐ: "i",
  Ǒ: "O",
  ǒ: "o",
  Ǔ: "U",
  ǔ: "u",
  Ǖ: "U",
  ǖ: "u",
  Ǘ: "U",
  ǘ: "u",
  Ǚ: "U",
  ǚ: "u",
  Ǜ: "U",
  ǜ: "u",
  Ứ: "U",
  ứ: "u",
  Ṹ: "U",
  ṹ: "u",
  Ǻ: "A",
  ǻ: "a",
  Ǽ: "AE",
  ǽ: "ae",
  Ǿ: "O",
  ǿ: "o",
  Þ: "TH",
  þ: "th",
  Ṕ: "P",
  ṕ: "p",
  Ṥ: "S",
  ṥ: "s",
  X́: "X",
  x́: "x",
  Ѓ: "Г",
  ѓ: "г",
  Ќ: "К",
  ќ: "к",
  A̋: "A",
  a̋: "a",
  E̋: "E",
  e̋: "e",
  I̋: "I",
  i̋: "i",
  Ǹ: "N",
  ǹ: "n",
  Ồ: "O",
  ồ: "o",
  Ṑ: "O",
  ṑ: "o",
  Ừ: "U",
  ừ: "u",
  Ẁ: "W",
  ẁ: "w",
  Ỳ: "Y",
  ỳ: "y",
  Ȁ: "A",
  ȁ: "a",
  Ȅ: "E",
  ȅ: "e",
  Ȉ: "I",
  ȉ: "i",
  Ȍ: "O",
  ȍ: "o",
  Ȑ: "R",
  ȑ: "r",
  Ȕ: "U",
  ȕ: "u",
  B̌: "B",
  b̌: "b",
  Č̣: "C",
  č̣: "c",
  Ê̌: "E",
  ê̌: "e",
  F̌: "F",
  f̌: "f",
  Ǧ: "G",
  ǧ: "g",
  Ȟ: "H",
  ȟ: "h",
  J̌: "J",
  ǰ: "j",
  Ǩ: "K",
  ǩ: "k",
  M̌: "M",
  m̌: "m",
  P̌: "P",
  p̌: "p",
  Q̌: "Q",
  q̌: "q",
  Ř̩: "R",
  ř̩: "r",
  Ṧ: "S",
  ṧ: "s",
  V̌: "V",
  v̌: "v",
  W̌: "W",
  w̌: "w",
  X̌: "X",
  x̌: "x",
  Y̌: "Y",
  y̌: "y",
  A̧: "A",
  a̧: "a",
  B̧: "B",
  b̧: "b",
  Ḑ: "D",
  ḑ: "d",
  Ȩ: "E",
  ȩ: "e",
  Ɛ̧: "E",
  ɛ̧: "e",
  Ḩ: "H",
  ḩ: "h",
  I̧: "I",
  i̧: "i",
  Ɨ̧: "I",
  ɨ̧: "i",
  M̧: "M",
  m̧: "m",
  O̧: "O",
  o̧: "o",
  Q̧: "Q",
  q̧: "q",
  U̧: "U",
  u̧: "u",
  X̧: "X",
  x̧: "x",
  Z̧: "Z",
  z̧: "z",
  й: "и",
  Й: "И",
  ё: "е",
  Ё: "Е"
}, HO = Object.keys(IO).join("|"), Qq = new RegExp(HO, "g"), Xq = new RegExp(HO, "");
function Jq(e) {
  return IO[e];
}
var ZO = function(e) {
  return e.replace(Qq, Jq);
}, eG = function(e) {
  return !!e.match(Xq);
};
jw.exports = ZO;
jw.exports.has = eG;
jw.exports.remove = ZO;
var tG = jw.exports;
const nG = /* @__PURE__ */ yE(tG);
/**
 * @name match-sorter
 * @license MIT license.
 * @copyright (c) 2020 Kent C. Dodds
 * @author Kent C. Dodds <me@kentcdodds.com> (https://kentcdodds.com)
 */
const wl = {
  CASE_SENSITIVE_EQUAL: 7,
  EQUAL: 6,
  STARTS_WITH: 5,
  WORD_STARTS_WITH: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
}, rG = (e, n) => String(e.rankedValue).localeCompare(String(n.rankedValue));
function v5(e, n, a) {
  a === void 0 && (a = {});
  const {
    keys: i,
    threshold: h = wl.MATCHES,
    baseSort: g = rG,
    sorter: m = (R) => R.sort((D, T) => lG(D, T, g))
  } = a, S = e.reduce(b, []);
  return m(S).map((R) => {
    let {
      item: D
    } = R;
    return D;
  });
  function b(R, D, T) {
    const A = aG(D, i, n, a), {
      rank: j,
      keyThreshold: I = h
    } = A;
    return j >= I && R.push({
      ...A,
      item: D,
      index: T
    }), R;
  }
}
v5.rankings = wl;
function aG(e, n, a, i) {
  if (!n) {
    const g = e;
    return {
      // ends up being duplicate of 'item' in matches but consistent
      rankedValue: g,
      rank: AR(g, a, i),
      keyIndex: -1,
      keyThreshold: i.threshold
    };
  }
  return cG(e, n).reduce((g, m, S) => {
    let {
      rank: b,
      rankedValue: R,
      keyIndex: D,
      keyThreshold: T
    } = g, {
      itemValue: A,
      attributes: j
    } = m, I = AR(A, a, i), Z = R;
    const {
      minRanking: N,
      maxRanking: B,
      threshold: $
    } = j;
    return I < N && I >= wl.MATCHES ? I = N : I > B && (I = B), I > b && (b = I, D = S, T = $, Z = A), {
      rankedValue: Z,
      rank: b,
      keyIndex: D,
      keyThreshold: T
    };
  }, {
    rankedValue: e,
    rank: wl.NO_MATCH,
    keyIndex: -1,
    keyThreshold: i.threshold
  });
}
function AR(e, n, a) {
  return e = jR(e, a), n = jR(n, a), n.length > e.length ? wl.NO_MATCH : e === n ? wl.CASE_SENSITIVE_EQUAL : (e = e.toLowerCase(), n = n.toLowerCase(), e === n ? wl.EQUAL : e.startsWith(n) ? wl.STARTS_WITH : e.includes(` ${n}`) ? wl.WORD_STARTS_WITH : e.includes(n) ? wl.CONTAINS : n.length === 1 ? wl.NO_MATCH : oG(e).includes(n) ? wl.ACRONYM : iG(e, n));
}
function oG(e) {
  let n = "";
  return e.split(" ").forEach((i) => {
    i.split("-").forEach((g) => {
      n += g.substr(0, 1);
    });
  }), n;
}
function iG(e, n) {
  let a = 0, i = 0;
  function h(b, R, D) {
    for (let T = D, A = R.length; T < A; T++)
      if (R[T] === b)
        return a += 1, T + 1;
    return -1;
  }
  function g(b) {
    const R = 1 / b, D = a / n.length;
    return wl.MATCHES + D * R;
  }
  const m = h(n[0], e, 0);
  if (m < 0)
    return wl.NO_MATCH;
  i = m;
  for (let b = 1, R = n.length; b < R; b++) {
    const D = n[b];
    if (i = h(D, e, i), !(i > -1))
      return wl.NO_MATCH;
  }
  const S = i - m;
  return g(S);
}
function lG(e, n, a) {
  const {
    rank: g,
    keyIndex: m
  } = e, {
    rank: S,
    keyIndex: b
  } = n;
  return g === S ? m === b ? a(e, n) : m < b ? -1 : 1 : g > S ? -1 : 1;
}
function jR(e, n) {
  let {
    keepDiacritics: a
  } = n;
  return e = `${e}`, a || (e = nG(e)), e;
}
function uG(e, n) {
  typeof n == "object" && (n = n.key);
  let a;
  if (typeof n == "function")
    a = n(e);
  else if (e == null)
    a = null;
  else if (Object.hasOwnProperty.call(e, n))
    a = e[n];
  else {
    if (n.includes("."))
      return sG(n, e);
    a = null;
  }
  return a == null ? [] : Array.isArray(a) ? a : [String(a)];
}
function sG(e, n) {
  const a = e.split(".");
  let i = [n];
  for (let h = 0, g = a.length; h < g; h++) {
    const m = a[h];
    let S = [];
    for (let b = 0, R = i.length; b < R; b++) {
      const D = i[b];
      if (D != null)
        if (Object.hasOwnProperty.call(D, m)) {
          const T = D[m];
          T != null && S.push(T);
        } else m === "*" && (S = S.concat(D));
    }
    i = S;
  }
  return Array.isArray(i[0]) ? [].concat(...i) : i;
}
function cG(e, n) {
  const a = [];
  for (let i = 0, h = n.length; i < h; i++) {
    const g = n[i], m = fG(g), S = uG(e, g);
    for (let b = 0, R = S.length; b < R; b++)
      a.push({
        itemValue: S[b],
        attributes: m
      });
  }
  return a;
}
const kR = {
  maxRanking: 1 / 0,
  minRanking: -1 / 0
};
function fG(e) {
  return typeof e == "string" ? kR : {
    ...kR,
    ...e
  };
}
const zl = Ma.forwardRef(
  ({
    as: e,
    align: n,
    children: a,
    direction: i,
    flex: h,
    gap: g,
    justify: m,
    wrap: S,
    width: b,
    ...R
  }, D) => (typeof S == "boolean" && (S = S ? "wrap" : void 0), /* @__PURE__ */ d.jsx(
    Rt,
    {
      as: e,
      alignItems: n,
      display: "flex",
      flexDirection: i,
      flex: h,
      justifyContent: m,
      gap: g,
      flexWrap: S,
      width: b,
      ref: D,
      ...R,
      children: a
    }
  ))
);
zl.defaultProps = {
  as: "div",
  gap: "16",
  direction: "column"
};
var dG = "_1fw0vff1 _1fw0vff0 _1faqfmv35 _1faqfmv3p _1faqfmvsz _1faqfmv9j _1faqfmvf9 _1faqfmv5 _1faqfmv1x _1faqfmv8a", PO = "_1fw0vff3 _1fw0vff2 _1faqfmv4e _1faqfmv4y _1faqfmv38 _1faqfmv3s _1faqfmvsz _1faqfmv1u _1faqfmv1x _1faqfmvuf", hG = "_1fw0vff5 _1fw0vff4 _1faqfmv37 _1faqfmv3r _1faqfmv9j _1faqfmvf9 _1faqfmv3 _1faqfmv24 _1faqfmvn5", vG = "_1fw0vff7 _1fw0vff6 _1faqfmv4e _1faqfmv4y _1faqfmv38 _1faqfmv3s _1faqfmv5w _1faqfmv6h _1faqfmv72 _1faqfmv7n _1faqfmvfl _1faqfmv3 _1faqfmv8a", pG = "_1fw0vff9 _1fw0vff8 _1faqfmvsz _1faqfmvf9 _1faqfmv3 _1faqfmv1x _1faqfmvwf";
const NO = Ma.createContext({
  checkType: "checkmark",
  displayMode: "normal",
  loading: !1
}), kw = () => {
  const e = Ma.useContext(NO);
  if (!e)
    throw new Error(
      "Select components must be used within a SelectProvider"
    );
  return e;
}, LR = ({
  children: e,
  options: n,
  value: a,
  onValueChange: i,
  ...h
}) => {
  const g = (n ?? []).map(bx), [m, S] = Kt(a), b = (R) => {
    const D = Array.isArray(m) ? m.length === 0 : !m, T = !g.length && D || h.loading;
    let A;
    g.length ? Array.isArray(R) && Array.isArray(m) ? (A = [...m], R.forEach((j) => {
      const I = g.find(
        (N) => th(N, j)
      ), Z = A.some(
        (N) => th(N, I)
      );
      I && !Z && A.push(I);
    }), A = A.filter(
      (j) => R.some((I) => th(I, j))
    )) : A = g.find(
      (j) => th(j, R)
    ) : A = Array.isArray(R) ? R.map(Z4) : Z4(R), S(A), i && !T && i(A);
  };
  return /* @__PURE__ */ d.jsx(
    NO.Provider,
    {
      value: {
        options: g,
        value: m,
        setValue: b,
        ...h
      },
      children: e
    }
  );
}, $0 = ({
  checkType: e,
  children: n,
  clearable: a,
  creatable: i,
  displayMode: h,
  filterable: g,
  loading: m,
  store: S,
  value: b,
  options: R,
  onValueChange: D,
  onCreate: T,
  ...A
}) => {
  const [j, I] = Kt(""), Z = b ?? A.defaultValue, [N, B] = Kt(
    U9(R)
  );
  i = i || !!T, S = S ?? Gp({
    defaultValue: A.defaultValue ? _x(A.defaultValue) : void 0
  });
  const $ = {
    checkType: e,
    clearable: a,
    defaultValue: A.defaultValue,
    displayMode: h,
    loading: m,
    options: N,
    value: U9(Z),
    // eslint-disable-line @typescript-eslint/no-explicit-any
    onValueChange: D,
    setOptions: B
  }, W = async (G) => {
    S == null || S.setValue(G);
  }, z = (G) => {
    B([
      ...N,
      { name: G, value: G }
    ]);
    const pe = S == null ? void 0 : S.getState().value, J = Array.isArray(pe);
    setTimeout(() => {
      W(J ? [...pe, G] : G);
    }), T && T(G);
  };
  wt(() => {
    if (S && b) {
      const G = S.getState().value, pe = _x(b);
      Kq.isEqual(pe, G) || W(pe);
    }
  }, [b]), wt(() => {
    if (S && R) {
      const { value: G } = S.getState();
      let pe = U9(R);
      if (Array.isArray(pe) && Array.isArray(G)) {
        const J = G.filter(
          (me) => !pe.some(
            (oe) => th(oe, me)
          )
        ).map((me) => ({ name: me, value: me }));
        J.length && (pe = [...pe, ...J]), B(pe);
      }
    }
  }, [R]);
  const Y = qr(
    () => g ? v5(N, j, { keys: ["name", "value"] }) : N,
    [N, j]
  ), ie = qr(
    () => g ? v5(Y, j, {
      keys: ["name", "value"],
      threshold: v5.rankings.CASE_SENSITIVE_EQUAL
    }).length > 0 : !1,
    [Y, j]
  );
  return g ? /* @__PURE__ */ d.jsx(
    _M,
    {
      resetValueOnHide: !0,
      setValue: (G) => I(G),
      children: /* @__PURE__ */ d.jsx(LR, { ...$, children: /* @__PURE__ */ d.jsxs(HR, { store: S, options: N, children: [
        /* @__PURE__ */ d.jsx(IR, { ...A }),
        /* @__PURE__ */ d.jsxs(Cx, { children: [
          /* @__PURE__ */ d.jsx(Rt, { px: "4", pb: "4", children: /* @__PURE__ */ d.jsx(
            tw,
            {
              autoSelect: !0,
              placeholder: "Search...",
              className: vG,
              value: j,
              onChange: (G) => I(G.target.value)
            }
          ) }),
          /* @__PURE__ */ d.jsxs(u8, { children: [
            j && !ie && i && /* @__PURE__ */ d.jsxs(
              N4,
              {
                className: PO,
                value: j,
                onClick: () => {
                  z(j), I("");
                },
                children: [
                  /* @__PURE__ */ d.jsx(VO, {}),
                  /* @__PURE__ */ d.jsx(
                    ma,
                    {
                      size: "small",
                      weight: "medium",
                      color: "secondaryContentOnEnabled",
                      children: j
                    }
                  )
                ]
              }
            ),
            Y.map((G) => /* @__PURE__ */ d.jsx(
              Sx,
              {
                value: String(G.value),
                render: /* @__PURE__ */ d.jsx(N4, {}),
                onClick: () => I(""),
                children: G.name
              },
              G.value
            ))
          ] })
        ] })
      ] }) })
    }
  ) : /* @__PURE__ */ d.jsx(LR, { ...$, children: /* @__PURE__ */ d.jsxs(HR, { store: S, options: N, children: [
    /* @__PURE__ */ d.jsx(IR, { ...A }),
    /* @__PURE__ */ d.jsx(Cx, { children: Array.isArray(R) ? N.map((G) => /* @__PURE__ */ d.jsx(
      Sx,
      {
        value: String(G.value),
        children: G.name
      },
      G.value
    )) : n })
  ] }) });
}, IR = ({
  renderValue: e,
  trigger: n,
  ...a
}) => {
  const i = n ?? mG, h = Cf(), g = h.useState("value"), { displayMode: m, loading: S, options: b } = kw();
  S && (a.disabled = !0);
  const R = (T) => {
    const A = h.getState().items;
    if (!(b != null && b.length) && !A.length)
      return Array.isArray(T) ? T.map(Z4) : Z4(T);
    if (!(b != null && b.length)) {
      const I = Array.isArray(T) ? T : [T], Z = A.filter(
        (N) => I.some((B) => th(N.value, B))
      );
      return Array.isArray(T) ? FO(Z) : BO(Z[0]);
    }
    const j = (I) => (b ?? []).map(
      (N) => typeof N == "string" ? {
        name: N,
        value: N
      } : N
    ).find((N) => th(N, I)) ?? Z4(I);
    return Array.isArray(T) ? T.map(j) : j(T);
  }, D = (T) => {
    if (e)
      return e(T);
    const A = R(T);
    return m === "tags" ? !A || Array.isArray(A) && !A.length ? "Select..." : /* @__PURE__ */ d.jsx(
      zl,
      {
        direction: "row",
        align: "center",
        gap: "6",
        flexWrap: "wrap",
        whiteSpace: "normal",
        width: "full",
        children: Array.isArray(A) ? A.map((j) => /* @__PURE__ */ d.jsx(PR, { value: j.value, children: j.name }, j.value)) : /* @__PURE__ */ d.jsx(PR, { value: A.value, children: A.name })
      }
    ) : Array.isArray(A) ? A.length ? A.map((j) => j.name).join(", ") : "Select..." : A.name;
  };
  return /* @__PURE__ */ d.jsx(i, { style: { opacity: a.disabled ? 0.7 : 1 }, ...a, children: g ? D(g) : /* @__PURE__ */ d.jsx(ma, { color: "secondaryContentOnEnabled", children: a.placeholder ?? "Select..." }) });
}, HR = ({ children: e, ...n }) => {
  const { value: a, setOptions: i, setValue: h } = kw(), g = n.store.useState("items");
  return wt(() => {
    i && !n.options && g.length && i(FO(g));
  }, [g]), /* @__PURE__ */ d.jsx(
    ST,
    {
      value: _x(a),
      setValue: h,
      ...n,
      children: e
    }
  );
}, mG = ({
  children: e,
  hideArrow: n,
  ...a
}) => {
  const { clearable: i, value: h, setValue: g } = kw(), m = Array.isArray(h), S = Pt(null);
  return /* @__PURE__ */ d.jsx(
    f3,
    {
      className: dG,
      ...a,
      toggleOnPress: (b) => {
        var R;
        return !((R = S.current) != null && R.contains(b.target) || S.current === b.target);
      },
      children: /* @__PURE__ */ d.jsxs(
        zl,
        {
          direction: "row",
          align: "center",
          justify: "space-between",
          width: "full",
          children: [
            typeof e == "string" ? /* @__PURE__ */ d.jsx(
              ma,
              {
                color: "secondaryContentOnEnabled",
                lines: "1",
                align: "left",
                children: e
              }
            ) : e,
            /* @__PURE__ */ d.jsxs(zl, { direction: "row", align: "center", gap: "6", children: [
              i && (m ? h.length > 0 : !!h) && /* @__PURE__ */ d.jsx(
                L8,
                {
                  ref: S,
                  icon: /* @__PURE__ */ d.jsx(HT, {}),
                  onClick: (b) => {
                    b.preventDefault(), b.stopPropagation(), Array.isArray(h) ? g([]) : g(void 0);
                  },
                  size: "xSmall",
                  emphasis: "none",
                  kind: "secondary"
                }
              ),
              !n && /* @__PURE__ */ d.jsx(vw, { render: /* @__PURE__ */ d.jsx(LT, {}) })
            ] })
          ]
        }
      )
    }
  );
}, gG = ({
  children: e,
  ...n
}) => /* @__PURE__ */ d.jsx(f3, { ...n, render: /* @__PURE__ */ d.jsx(ww, {}), children: /* @__PURE__ */ d.jsxs(zl, { direction: "row", gap: "4", align: "center", children: [
  e,
  /* @__PURE__ */ d.jsx(vw, { render: /* @__PURE__ */ d.jsx(LT, {}) })
] }) }), wG = ({ children: e, ...n }) => /* @__PURE__ */ d.jsx(mw, { ...n, children: e }), Sx = ({
  children: e,
  value: n,
  ...a
}) => {
  const i = [n];
  typeof e == "string" && (i.push(e), n === void 0 && (n = e));
  const h = Cf().useState("value"), g = Array.isArray(h) ? i.some((m) => h.includes(m)) : i.includes(h);
  return /* @__PURE__ */ d.jsxs(
    pw,
    {
      focusOnHover: !0,
      value: n,
      className: PO,
      ...a,
      children: [
        /* @__PURE__ */ d.jsx(VO, { checked: g }),
        e ? typeof e == "string" ? /* @__PURE__ */ d.jsx(
          ma,
          {
            size: "small",
            weight: "medium",
            color: "secondaryContentOnEnabled",
            children: e
          }
        ) : e : /* @__PURE__ */ d.jsx(
          ma,
          {
            size: "small",
            weight: "medium",
            color: "secondaryContentOnEnabled",
            children: n
          }
        )
      ]
    }
  );
}, VO = ({
  children: e,
  ...n
}) => {
  const { checkType: a } = kw();
  return a === "checkbox" ? /* @__PURE__ */ d.jsx(Rt, { cssClass: pG, children: n.checked && /* @__PURE__ */ d.jsx(I8, { color: "white", size: "13" }) }) : /* @__PURE__ */ d.jsx(_T, { ...n, children: e ?? /* @__PURE__ */ d.jsx(AT, { size: "16" }) });
}, Cx = ({ children: e, ...n }) => /* @__PURE__ */ d.jsxs(
  gw,
  {
    sameWidth: !0,
    gutter: 4,
    className: hG,
    ...n,
    children: [
      /* @__PURE__ */ d.jsx(qp, { size: 0 }),
      e
    ]
  }
), yG = ({ children: e }) => /* @__PURE__ */ d.jsx(bT, { children: e }), xG = ({
  children: e,
  ...n
}) => /* @__PURE__ */ d.jsx(CT, { ...n, children: e }), jp = (e) => e !== null && typeof e == "object", bx = (e) => jp(e) ? e : {
  name: String(e),
  value: String(e)
}, U9 = (e) => {
  if (e !== void 0)
    return Array.isArray(e) ? e.map(bx) : bx(e);
}, ZR = (e) => e === void 0 ? "" : jp(e) ? String(e.value) : String(e), FO = (e) => e.map(BO), BO = (e) => {
  var n;
  return {
    name: String(((n = e.element) == null ? void 0 : n.innerText) ?? e.value),
    value: e.value
  };
}, Z4 = (e) => ({
  name: String(e),
  value: e
}), _x = (e) => Array.isArray(e) ? e.map(ZR) : ZR(e), th = (e, n) => {
  if (n === void 0)
    return !1;
  if (jp(e) && jp(n)) {
    const a = [e.value, e.name].map(String), i = [n.value, n.name].map(String);
    return a.some((h) => i.includes(h));
  } else {
    if (jp(e))
      return [e.value, e.name].map(String).includes(String(n));
    if (jp(n))
      return [n.value, n.name].map(String).includes(String(e));
  }
  return String(e) === String(n);
}, PR = ({
  children: e,
  value: n
}) => {
  const a = Cf(), i = a.useState("value"), h = e;
  return /* @__PURE__ */ d.jsx(
    d3,
    {
      cursor: "pointer",
      shape: "basic",
      variant: "white",
      size: "medium",
      label: h,
      iconEnd: /* @__PURE__ */ d.jsx(IT, {}),
      onMouseDown: (g) => {
        g.preventDefault(), g.stopPropagation();
        const m = Array.isArray(i) ? i.filter(
          (S) => !th(S, { name: h, value: n })
        ) : "";
        a.setValue(m);
      }
    }
  );
};
$0.Label = wG;
$0.Group = yG;
$0.GroupLabel = xG;
$0.Option = Sx;
$0.Popover = Cx;
$0.SelectTriggerButton = gG;
$0.useContext = Cf;
$0.useStore = Gp;
var SG = Xo({ defaultClassName: "_33k3h10", variantClassNames: { truncate: { true: "_33k3h11", false: "_33k3h12" }, size: { xSmall: "_33k3h13", small: "_33k3h14" }, collapsed: { true: "_33k3h15", false: "_33k3h16" }, outline: { true: "_33k3h17", false: "_33k3h18" }, rounded: { first: "_33k3h19", middle: "_33k3h1a", last: "_33k3h1b", true: "_33k3h1c" } }, defaultVariants: { size: "small", outline: !0, truncate: !1 }, compoundVariants: [] }), CG = "_33k3h1e", bG = "_33k3h1f", NR = "_33k3h1g", VR = "_33k3h1h";
const aS = ({ label: e, name: n, tag: a, optional: i }) => /* @__PURE__ */ d.jsxs(Rt, { display: "flex", flexDirection: "row", gap: "6", children: [
  e && /* @__PURE__ */ d.jsxs(
    Rt,
    {
      display: "flex",
      alignItems: "center",
      gap: "6",
      style: { height: 16 },
      children: [
        /* @__PURE__ */ d.jsx(ZE, { name: n, children: /* @__PURE__ */ d.jsx(
          ma,
          {
            userSelect: "none",
            size: "xSmall",
            weight: "medium",
            color: "weak",
            children: e
          }
        ) }),
        a
      ]
    }
  ),
  i && /* @__PURE__ */ d.jsx(d3, { shape: "basic", size: "small", label: "Optional" })
] }), UO = ({
  children: e,
  label: n,
  name: a,
  tag: i,
  icon: h,
  optional: g = !1
}) => n ? /* @__PURE__ */ d.jsxs(Rt, { display: "flex", flexDirection: "column", width: "full", gap: "4", children: [
  /* @__PURE__ */ d.jsxs(Rt, { display: "flex", flexDirection: "row", gap: "6", alignItems: "center", children: [
    n && /* @__PURE__ */ d.jsx(aS, { label: n, name: a, tag: i }),
    g && /* @__PURE__ */ d.jsx(d3, { shape: "basic", size: "small", label: "Optional" }),
    h
  ] }),
  e
] }) : /* @__PURE__ */ d.jsx(d.Fragment, { children: e }), Ds = ({
  children: e,
  defaultValues: n,
  store: a,
  ...i
}) => /* @__PURE__ */ d.jsx(kE, { defaultValues: n, store: a, children: /* @__PURE__ */ d.jsx(jE, { ...i, role: "form", children: e }) }), _G = ({ ...e }) => /* @__PURE__ */ d.jsx(LE, { ...e, render: /* @__PURE__ */ d.jsx(Rt, { color: "bad" }) }), RG = (e) => /* @__PURE__ */ d.jsx(UE, { render: /* @__PURE__ */ d.jsx(ww, {}), ...e }), EG = Ex(
  ({
    label: e,
    labelTag: n,
    icon: a,
    cssClass: i,
    size: h,
    collapsed: g,
    truncate: m,
    outline: S,
    name: b,
    rounded: R,
    ...D
  }, T) => {
    const A = Pt(null), j = T ?? A;
    Ma.useEffect(() => {
      g && j.current && j.current.blur();
    }, [g]), j.current && j.current.value && (g = !1);
    const I = D.type === "number";
    I && (D.step = D.step ?? 1);
    const Z = () => {
      const N = new Event("change", {
        bubbles: !0
      });
      j.current.dispatchEvent(N);
    };
    return /* @__PURE__ */ d.jsx(UO, { label: e, name: b, icon: a, tag: n, children: /* @__PURE__ */ d.jsxs(Rt, { position: "relative", flex: "stretch", children: [
      /* @__PURE__ */ d.jsx(
        Kx,
        {
          ref: j,
          name: b,
          className: zr(
            SG({
              size: h,
              collapsed: g,
              outline: S,
              truncate: m,
              rounded: R
            }),
            i,
            {
              [CG]: I
            }
          ),
          ...D
        }
      ),
      I && /* @__PURE__ */ d.jsxs(
        Rt,
        {
          display: "flex",
          position: "absolute",
          flexDirection: "column",
          style: { top: 0, right: 0, bottom: 0 },
          children: [
            /* @__PURE__ */ d.jsx(
              "button",
              {
                className: NR,
                onClick: () => {
                  var N;
                  (N = j.current) == null || N.stepUp(), Z();
                },
                children: /* @__PURE__ */ d.jsx(
                  FU,
                  {
                    size: "16",
                    className: VR
                  }
                )
              }
            ),
            /* @__PURE__ */ d.jsx(Rt, { cssClass: bG }),
            /* @__PURE__ */ d.jsx(
              "button",
              {
                className: NR,
                onClick: () => {
                  var N;
                  (N = j.current) == null || N.stepDown(), Z();
                },
                children: /* @__PURE__ */ d.jsx(
                  H8,
                  {
                    size: "16",
                    className: VR
                  }
                )
              }
            )
          ]
        }
      )
    ] }) });
  }
), MG = ({
  children: e,
  label: n = "",
  tag: a,
  optional: i,
  name: h,
  options: g,
  creatable: m,
  disabled: S,
  filterable: b,
  checkType: R,
  defaultValue: D,
  displayMode: T,
  loading: A,
  trigger: j,
  onValueChange: I,
  onCreate: Z,
  renderValue: N,
  ...B
}) => {
  const $ = Sl(), W = B.value ?? $.useValue(h);
  return /* @__PURE__ */ d.jsxs(zl, { direction: "column", gap: "4", children: [
    n.trim() !== "" && /* @__PURE__ */ d.jsx(
      aS,
      {
        label: n,
        name: h,
        tag: a,
        optional: i
      }
    ),
    /* @__PURE__ */ d.jsx(
      Kx,
      {
        name: h,
        render: /* @__PURE__ */ d.jsx(
          $0,
          {
            value: W,
            options: g,
            creatable: m,
            disabled: S,
            filterable: b,
            checkType: R,
            defaultValue: D,
            displayMode: T,
            loading: A,
            trigger: j,
            renderValue: N,
            onCreate: Z,
            onValueChange: (z) => {
              $.setValue(h, z.value), I && I(z);
            }
          }
        ),
        ...B,
        children: e
      }
    )
  ] });
}, TG = ({ children: e, ...n }) => /* @__PURE__ */ d.jsx($0.Option, { ...n, children: e });
Ds.Input = EG;
Ds.Error = _G;
Ds.Submit = RG;
Ds.Label = aS;
Ds.Select = MG;
Ds.Option = TG;
Ds.NamedSection = UO;
Ds.useStore = Wx;
Ds.useContext = Sl;
var OG = "_11uj8320", DG = Xo({ defaultClassName: "_11uj8322 _11uj8321 _1faqfmv4e _1faqfmv4y _1faqfmv37 _1faqfmv3r _1faqfmvsz _1faqfmv1x _1faqfmvtn", variantClassNames: { selected: { true: "_11uj8323", false: "_11uj8324" } }, defaultVariants: { selected: !1 }, compoundVariants: [] }), AG = "_11uj8325", jG = "_11uj8326";
const Ko = ({ children: e, ...n }) => /* @__PURE__ */ d.jsx(XM, { ...n, children: e }), kG = ({
  children: e,
  ...n
}) => {
  const a = Sf(), i = n.icon && !e ? /* @__PURE__ */ d.jsx(L8, { icon: n.icon }) : /* @__PURE__ */ d.jsx(ww, {});
  return /* @__PURE__ */ d.jsx(eT, { render: i, store: a, ...n, children: e });
}, LG = ({ children: e, cssClass: n, ...a }) => {
  const i = Sf();
  return /* @__PURE__ */ d.jsxs(
    QM,
    {
      store: i,
      gutter: 4,
      className: zr(OG, n),
      ...a,
      children: [
        /* @__PURE__ */ d.jsx(JM, { size: 0 }),
        e
      ]
    }
  );
}, IG = ({ children: e, ...n }) => /* @__PURE__ */ d.jsx(
  oT,
  {
    className: DG({ selected: !1 }),
    ...n,
    children: typeof e == "string" ? /* @__PURE__ */ d.jsx(ma, { children: e }) : e
  }
), YO = ({
  children: e,
  ...n
}) => /* @__PURE__ */ d.jsx(iT, { className: AG, ...n, children: e }), HG = ({
  children: e,
  className: n,
  ...a
}) => /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
  /* @__PURE__ */ d.jsx(
    aT,
    {
      className: zr(jG, n),
      ...a,
      children: e
    }
  ),
  /* @__PURE__ */ d.jsx(YO, {})
] });
Ko.Button = kG;
Ko.List = LG;
Ko.Item = IG;
Ko.Divider = YO;
Ko.Heading = HG;
Ko.useStore = b8;
Ko.useContext = Sf;
const ZG = (e) => {
  const { selected: n, disabled: a, range: i } = e;
  return a ? "n8" : n || i == "will-be-range-start" || i == "will-be-range-end" ? "white" : "inherit";
}, PG = (e) => {
  const { range: n, selected: a, now: i } = e;
  return !a && !i && n === "" || i || a && n === "" || i && n === "will-be-range-end" || a && n === "range-start" || i && a || n === "will-be-range-start" ? "6" : "inherit";
}, NG = (e) => {
  const { range: n, selected: a, now: i } = e;
  return !a && !i && n === "" || i || a && n === "" || i && a || a && n === "range-end" || n === "will-be-range-end" ? "6" : "inherit";
}, VG = (e) => {
  const { range: n, selected: a, now: i } = e;
  return !a && !i && n === "" || i || a && n === "" || i && n === "will-be-range-end" || i && a || a && n === "range-start" || n === "will-be-range-start" ? "6" : "inherit";
}, FG = (e) => {
  const { range: n, selected: a, now: i } = e;
  return !a && !i && n === "" || i || a && n === "range-end" || i && a || a && n === "" ? "6" : a && n === "in-range" ? "inherit" : n === "will-be-range-end" ? "6" : "inherit";
}, BG = (e) => {
  const { selected: n, range: a, now: i, disabled: h } = e;
  return h ? "inherit" : i && n || i && a === "will-be-range-end" ? "p9" : i && a === "will-be-in-range" || n || a === "will-be-range-end" || a === "will-be-range-start" ? "p6" : "inherit";
}, UG = (e) => {
  const { selected: n, range: a, now: i, disabled: h } = e;
  return h ? "inherit" : i ? "lb300" : n || a == "will-be-range-end" || a == "will-be-range-start" ? "p9" : a == "will-be-in-range" || a == "in-range" ? "p6" : "inherit";
}, a5 = (e) => {
  const { selected: n, range: a, now: i } = e;
  return i ? "round" : n || a == "will-be-range-start" || a == "will-be-range-end" ? "6" : "inherit";
}, YG = (e) => {
  const { disabled: n } = e;
  return n ? "not-allowed" : "pointer";
}, $G = (e) => {
  const { now: n } = e;
  return n ? "24px" : "36px";
}, WG = (e) => {
  const { now: n } = e;
  return n ? "24px" : "34px";
}, FR = {
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}, zG = ({ children: e, day: n, onMouseEnter: a, onMouseLeave: i }) => {
  const { dayButton: h } = qY(), g = n.now ? Rt : nE, m = n.now ? {
    style: FR,
    backgroundColor: n.range === "will-be-in-range" || n.range === "in-range" || n.range === "will-be-range-end" || n.selected ? "p6" : "inherit",
    borderTopRightRadius: n.range === "range-end" || n.range === "will-be-range-end" ? "6" : "inherit",
    borderBottomRightRadius: n.range === "range-end" || n.range === "will-be-range-end" ? "6" : "inherit"
  } : {}, S = h(n);
  return /* @__PURE__ */ d.jsx(g, { ...m, children: /* @__PURE__ */ d.jsx(
    Rt,
    {
      onMouseLeave: i,
      ...S,
      onMouseEnter: function() {
        var b;
        a == null || a(), (b = S == null ? void 0 : S.onMouseEnter) == null || b.call(S);
      },
      cursor: YG(n),
      style: FR,
      backgroundColor: {
        default: BG(n),
        hover: n.disabled || n.selected || n.range === "will-be-range-end" || n.range === "will-be-range-start" ? void 0 : "p4"
      },
      borderTopLeftRadius: PG(n),
      borderTopRightRadius: NG(n),
      borderBottomLeftRadius: VG(n),
      borderBottomRightRadius: FG(
        n
      ),
      children: /* @__PURE__ */ d.jsx(
        Rt,
        {
          color: ZG(n),
          backgroundColor: UG(n),
          padding: "10",
          style: {
            width: $G(n),
            height: WG(n),
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          borderTopLeftRadius: a5(n),
          borderBottomLeftRadius: a5(n),
          borderTopRightRadius: a5(n),
          borderBottomRightRadius: a5(n),
          children: e
        }
      )
    }
  ) });
};
var BR = "xcbb8h0", qG = "xcbb8h1", GG = "xcbb8h2";
Xo({ defaultClassName: "xcbb8h3", variantClassNames: {}, defaultVariants: {}, compoundVariants: [] });
const KG = ({
  prevButton: e,
  nextButton: n,
  calendar: a,
  hasSelectedRange: i
}) => {
  const { weekDays: h } = UT(), [g, m] = Kt(!1), { days: S, month: b, year: R } = a;
  return /* @__PURE__ */ d.jsxs(Rt, { backgroundColor: "white", p: "10", cursor: "default", children: [
    /* @__PURE__ */ d.jsxs(zl, { direction: "row", align: "center", children: [
      e,
      /* @__PURE__ */ d.jsx(Rt, { flexGrow: 1, children: /* @__PURE__ */ d.jsxs(ma, { userSelect: "none", align: "center", children: [
        b,
        " ",
        R
      ] }) }),
      n
    ] }),
    /* @__PURE__ */ d.jsx("div", { className: qG, children: h.map((D) => /* @__PURE__ */ d.jsx(ma, { align: "center", userSelect: "none", children: D }, D)) }),
    /* @__PURE__ */ d.jsx(
      "main",
      {
        className: GG,
        onMouseLeave: function() {
          m(!0);
        },
        children: S.map((D) => /* @__PURE__ */ d.jsx(
          zG,
          {
            day: {
              ...D,
              range: i ? D.range : g ? "" : D.range
            },
            onMouseEnter: function() {
              m(D.disabled);
            },
            children: /* @__PURE__ */ d.jsx(ma, { userSelect: "none", align: "center", children: D.day })
          },
          D.$date.toString()
        ))
      }
    )
  ] });
}, QG = ({ hasSelectedRange: e }) => {
  const { calendars: n } = UT(), { addOffset: a, subtractOffset: i } = GY();
  return /* @__PURE__ */ d.jsx(
    KG,
    {
      hasSelectedRange: e,
      prevButton: /* @__PURE__ */ d.jsx(
        Rt,
        {
          cursor: "pointer",
          ...i({ months: 1 }),
          cssClass: BR,
          children: /* @__PURE__ */ d.jsx(VU, {})
        }
      ),
      nextButton: /* @__PURE__ */ d.jsx(
        Rt,
        {
          cursor: "pointer",
          ...a({ months: 1 }),
          cssClass: BR,
          children: /* @__PURE__ */ d.jsx(jT, {})
        }
      ),
      calendar: n[0]
    }
  );
};
function UR({ name: e, onDateChange: n, placeholder: a }) {
  const [i, h] = Kt(a), g = (S) => {
    const { value: b } = S.target;
    h(b);
  }, m = () => {
    i && n(i);
  };
  return wt(
    function() {
      h(a);
    },
    [a]
  ), /* @__PURE__ */ d.jsx(
    Ds.Input,
    {
      name: e,
      placeholder: a,
      type: "input",
      color: "n12",
      value: i,
      style: {
        border: "none",
        background: "none",
        fontSize: "13px",
        fontWeight: "500 !important",
        paddingLeft: "6px",
        width: "130px"
      },
      className: "date-input",
      onChange: g,
      onBlur: m,
      onKeyDown: (S) => {
        S.key === "Enter" && m();
      }
    }
  );
}
function YR({ placeholder: e, name: n, onTimeChange: a }) {
  const [i, h] = Kt(""), g = (S) => {
    const { value: b } = S.target;
    h(b);
  }, m = () => {
    i && a(i);
  };
  return /* @__PURE__ */ d.jsx(
    Ds.Input,
    {
      name: n,
      placeholder: e,
      type: "input",
      color: "n12",
      value: i,
      style: {
        border: "none",
        background: "none",
        fontSize: "13px",
        fontWeight: "500 !important",
        paddingLeft: "6px",
        width: "130px"
      },
      className: "date-input",
      onChange: g,
      onBlur: m,
      onKeyDown: (S) => {
        S.key === "Enter" && m();
      }
    }
  );
}
const XG = "MMM DD, YYYY", JG = "MMM DD YYYY", eK = "MMM DD", tK = "MMM D, YYYY", nK = "MMM D YYYY", rK = "MMM D", aK = "MMMM DD, YYYY", oK = "MMMM DD YYYY", iK = "MMMM DD", lK = "MMMM D, YYYY", uK = "MMMM D YYYY", sK = "MMMM D", cK = "MM/DD/YYYY", fK = "MM/DD", dK = "MM-DD-YYYY", hK = "MM-DD", vK = "MM.DD.YYYY", pK = "MM.DD", $O = "HH:mm a", mK = "HH:mma", gK = "h:mm a", wK = "h:mma", yK = "HH:mm", xK = "h:mm", SK = "h a", CK = "h", bK = "ha", _K = "HH", RK = "hh:mm a", $R = [
  cK,
  dK,
  vK,
  XG,
  JG,
  nK,
  tK,
  aK,
  iK,
  eK,
  rK,
  fK,
  hK,
  pK,
  oK,
  lK,
  uK,
  sK
], WR = [
  $O,
  mK,
  gK,
  wK,
  SK,
  bK,
  CK,
  _K,
  yK,
  xK
], zR = (e) => e ? new Date(e).toLocaleDateString("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric"
}) : "", qR = (e, n) => e ? Xe(e).format(RK) : n ? "11:59pm" : "12:00 AM", GR = (e) => {
  const n = Xe(e, $O);
  return {
    hour: n.format("HH"),
    minute: n.minute(),
    timeOfDay: n.format("a"),
    hour24: n.hour()
  };
}, oS = (e, n) => n ? Rx(n) === Rx(e) : !1, EK = ({
  presets: e,
  selectedValue: n
}) => !e.find((i) => oS(i, n.selectedPreset)), KR = (e, n) => {
  const a = {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  };
  return n && (a.year = "numeric"), e.toLocaleDateString("en-us", a);
}, o5 = (e, n, a) => {
  const i = new Date(e);
  return i.setHours(n), i.setMinutes(a), i;
}, QR = ({
  selectedValue: e,
  presets: n
}) => {
  const a = n.find((g) => oS(g, e.selectedPreset));
  if (a)
    return WO(a);
  const { startDate: i, endDate: h } = e;
  if (i && h) {
    const g = h.getFullYear() > i.getFullYear();
    return `${KR(i, g)} - ${KR(
      h,
      g
    )}`;
  }
  return "";
};
var MK = /* @__PURE__ */ ((e) => (e[e.Default = 0] = "Default", e[e.Custom = 1] = "Custom", e))(MK || {});
const TK = [
  {
    unit: "minutes",
    quantity: 15
  },
  {
    unit: "minutes",
    quantity: 60
  },
  {
    unit: "hours",
    quantity: 4
  },
  {
    unit: "hours",
    quantity: 24
  },
  {
    unit: "days",
    quantity: 7
  },
  {
    unit: "days",
    quantity: 30
  }
], Tie = TK.concat({
  unit: "months",
  quantity: 3
}), WO = (e) => e.label || `Last ${e.quantity} ${e.unit}`, Rx = (e) => e.value || `last_${e.quantity}_${e.unit}`, Oie = (e) => {
  const [, n, a] = e.split("_");
  return {
    quantity: Number(n),
    unit: a
  };
}, OK = (e) => Xe().subtract(e.quantity, e.unit).toDate(), Die = (e) => {
  const [n, a] = Kt(!1);
  return /* @__PURE__ */ d.jsx(Ko, { open: n, setOpen: a, placement: "bottom-end", children: /* @__PURE__ */ d.jsx(DK, { ...e, open: n }) });
}, XR = ({
  isSelected: e,
  size: n = 16
}) => /* @__PURE__ */ d.jsx(Rt, { style: { height: n, width: n }, color: "primaryEnabled", children: e && /* @__PURE__ */ d.jsx(AT, { size: n }) }), DK = ({
  selectedValue: e,
  onDatesChange: n,
  presets: a,
  noCustom: i,
  minDate: h,
  maxDate: g = Xe().toDate(),
  open: m,
  ...S
}) => {
  const [b, R] = Ma.useState(
    0
    /* Default */
  ), [D, T] = Kt(!0), [A, j] = Kt(!0), [I, Z] = Kt(!0), [N, B] = Kt(!0), $ = !e.selectedPreset, [W, z] = Kt(
    $ ? [e.startDate, e.endDate] : []
  ), Y = Sf();
  wt(() => {
    m || R(
      0
      /* Default */
    );
  }, [m]);
  const ie = qr(
    () => zR(e.startDate),
    [e.startDate]
  ), G = qr(
    () => zR(e.endDate),
    [e.endDate]
  ), pe = qr(
    () => qR(e.startDate),
    [e.startDate]
  ), J = qr(
    () => qR(e.endDate, !0),
    [e.endDate]
  ), [me, oe] = Kt(
    QR({ selectedValue: e, presets: a })
  ), ge = ({
    startDate: qe,
    endDate: Je,
    selectedPreset: ot
  }) => {
    n(qe, Je, ot), qe && Je && (Y.setOpen(!1), R(
      0
      /* Default */
    ));
  }, ce = (qe) => {
    const Je = $R.find(
      (ot) => Xe(qe, ot, !0).isValid()
    );
    if (T(!!Je), Je) {
      const ot = Xe(qe, Je).toDate(), Nt = o5(
        ot,
        e.startDate.getHours(),
        e.startDate.getMinutes()
      );
      n(Nt, e.endDate, void 0);
    }
  }, Se = (qe) => {
    const Je = $R.find(
      (ot) => Xe(qe, ot, !0).isValid()
    );
    if (j(!!Je), Je) {
      const ot = Xe(qe, Je).toDate(), Nt = o5(
        ot,
        e.endDate.getHours(),
        e.endDate.getMinutes()
      );
      n(e.startDate, Nt, void 0);
    }
  }, Re = (qe) => {
    const Je = WR.map(
      (ot) => Xe(qe, ot, !0).isValid()
    ).some((ot) => ot);
    if (Z(Je), Je && e.startDate) {
      const ot = GR(qe), Nt = o5(
        e.startDate,
        ot.hour24,
        ot.minute
      );
      n(Nt, e.endDate, void 0);
    }
  }, _e = (qe) => {
    const Je = WR.map(
      (ot) => Xe(qe, ot, !0).isValid()
    ).some((ot) => ot);
    if (B(Je), Je && e.endDate) {
      const ot = GR(qe), Nt = o5(
        e.endDate,
        ot.hour24,
        ot.minute
      );
      n(e.startDate, Nt, void 0);
    }
  };
  wt(() => {
    (e.selectedPreset || e.startDate && e.endDate) && oe(QR({ selectedValue: e, presets: a }));
  }, [e]);
  const Ye = qr(
    () => e.startDate && e.endDate && [e.startDate, e.endDate].filter(
      (qe) => Xe(qe).isValid()
    ).length === 2,
    [e]
  ), ue = qr(() => a.map((qe) => ({
    label: WO(qe),
    value: Rx(qe),
    quantity: qe.quantity,
    unit: qe.unit
  })), [a]), Ae = (qe) => {
    let Je = qe[0], ot = qe[1];
    Je && (Je = Xe.max(Xe(Je).startOf("day"), Xe(h)).toDate()), ot && (ot = Xe.min(Xe(ot).endOf("day"), Xe(g)).toDate()), Je && ot && ge({ startDate: Je, endDate: ot });
    const Nt = [Je, ot].filter((Tn) => !!Tn);
    z(Nt);
  }, Pe = (qe) => {
    const Je = Xe().toDate(), ot = OK(qe);
    ge({
      startDate: ot,
      endDate: Je,
      selectedPreset: qe
    });
  }, dt = D && I, Ze = A && N;
  return /* @__PURE__ */ d.jsxs(
    zY,
    {
      config: {
        selectedDates: W,
        onDatesChange: Ae,
        dates: {
          mode: "range",
          minDate: h,
          maxDate: g,
          selectSameDate: !0
        }
      },
      children: [
        /* @__PURE__ */ d.jsx(
          Ko.Button,
          {
            kind: "secondary",
            iconRight: /* @__PURE__ */ d.jsx(H8, {}),
            style: {
              whiteSpace: "nowrap",
              overflow: "hidden"
            },
            ...S,
            children: me
          }
        ),
        /* @__PURE__ */ d.jsx(Ko.List, { children: b === 0 ? /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
          ue.map((qe) => /* @__PURE__ */ d.jsx(
            Ko.Item,
            {
              onClick: (Je) => {
                Je.preventDefault(), Je.stopPropagation(), Pe(qe);
              },
              children: /* @__PURE__ */ d.jsxs(
                zl,
                {
                  py: "2",
                  direction: "row",
                  align: "center",
                  gap: "4",
                  children: [
                    /* @__PURE__ */ d.jsx(
                      XR,
                      {
                        isSelected: oS(
                          qe,
                          e.selectedPreset
                        )
                      }
                    ),
                    /* @__PURE__ */ d.jsx(ma, { userSelect: "none", children: qe.label })
                  ]
                }
              )
            },
            qe.label
          )),
          i ? null : /* @__PURE__ */ d.jsx(
            Ko.Item,
            {
              onClick: (qe) => {
                qe.preventDefault(), qe.stopPropagation(), R(
                  1
                  /* Custom */
                );
              },
              children: /* @__PURE__ */ d.jsxs(
                zl,
                {
                  width: "full",
                  display: "flex",
                  direction: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  children: [
                    /* @__PURE__ */ d.jsxs(
                      zl,
                      {
                        direction: "row",
                        align: "center",
                        gap: "4",
                        children: [
                          /* @__PURE__ */ d.jsx(
                            XR,
                            {
                              isSelected: EK({
                                presets: a,
                                selectedValue: e
                              })
                            }
                          ),
                          /* @__PURE__ */ d.jsx(ma, { userSelect: "none", children: "Custom" })
                        ]
                      }
                    ),
                    /* @__PURE__ */ d.jsx(jT, { size: 16 })
                  ]
                }
              )
            }
          )
        ] }) : /* @__PURE__ */ d.jsxs(Ds, { children: [
          /* @__PURE__ */ d.jsxs(
            Rt,
            {
              borderBottom: "divider",
              pb: "4",
              px: "4",
              display: "flex",
              gap: "4",
              children: [
                /* @__PURE__ */ d.jsxs(
                  Rt,
                  {
                    style: { width: 130 },
                    border: dt ? "secondary" : "error",
                    borderRadius: "6",
                    children: [
                      /* @__PURE__ */ d.jsx(
                        Rt,
                        {
                          borderBottom: dt ? "secondary" : "error",
                          children: /* @__PURE__ */ d.jsx(
                            UR,
                            {
                              name: "startDate",
                              placeholder: ie || "Start date",
                              onDateChange: ce
                            }
                          )
                        }
                      ),
                      /* @__PURE__ */ d.jsx(Rt, { children: /* @__PURE__ */ d.jsx(
                        YR,
                        {
                          name: "startTime",
                          placeholder: pe,
                          onTimeChange: Re
                        }
                      ) })
                    ]
                  }
                ),
                /* @__PURE__ */ d.jsxs(
                  Rt,
                  {
                    style: { width: 130 },
                    border: Ze ? "secondary" : "error",
                    borderRadius: "6",
                    children: [
                      /* @__PURE__ */ d.jsx(
                        Rt,
                        {
                          borderBottom: Ze ? "secondary" : "error",
                          children: /* @__PURE__ */ d.jsx(
                            UR,
                            {
                              name: "endDate",
                              placeholder: G || "End date",
                              onDateChange: Se
                            }
                          )
                        }
                      ),
                      /* @__PURE__ */ d.jsx(Rt, { children: /* @__PURE__ */ d.jsx(
                        YR,
                        {
                          name: "endTime",
                          placeholder: J,
                          onTimeChange: _e
                        }
                      ) })
                    ]
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ d.jsx(
            Ko.Item,
            {
              style: { padding: 0 },
              onClick: (qe) => {
                qe.preventDefault(), qe.stopPropagation();
              },
              children: /* @__PURE__ */ d.jsx(QG, { hasSelectedRange: Ye })
            }
          )
        ] }) })
      ]
    }
  );
}, AK = Xe(), Aie = () => AK.clone(), iS = ({ children: e, ...n }) => /* @__PURE__ */ d.jsx(cM, { ...n, children: e });
iS.useStore = W5;
iS.useContext = qE;
iS.Provider = fM;
var jK = Xo({ defaultClassName: "_1njg9051 _1njg9050 _1faqfmv5b", variantClassNames: { align: { center: "_1njg9052" }, level: { h1: "_1njg9053", h2: "_1njg9054", h3: "_1njg9055", h4: "_1njg9056" } }, defaultVariants: {}, compoundVariants: [] });
const jie = ({
  align: e,
  as: n,
  children: a,
  level: i = "h2",
  lines: h,
  ...g
}) => {
  const m = h ? /* @__PURE__ */ d.jsx(j8, { lines: h, children: a }) : a;
  return /* @__PURE__ */ d.jsx(
    Rt,
    {
      as: n || i,
      cssClass: jK({ align: e, level: i }),
      ...g,
      children: m
    }
  );
};
var kK = Xo({ defaultClassName: "_10i04yv0", variantClassNames: { size: { medium: "_10i04yv1" } }, defaultVariants: { size: "medium" }, compoundVariants: [] });
const kie = ({ ...e }) => {
  const [n, a] = Ma.useState(
    e.selectedKey ?? e.options[0].key
  );
  return /* @__PURE__ */ d.jsxs(Ko, { children: [
    /* @__PURE__ */ d.jsx(
      Ko.Button,
      {
        size: e.size,
        kind: "secondary",
        emphasis: "low",
        className: kK({ size: e.size }),
        children: /* @__PURE__ */ d.jsxs(Rt, { display: "flex", alignItems: "center", children: [
          /* @__PURE__ */ d.jsx(ma, { case: "capital", children: n }),
          /* @__PURE__ */ d.jsx(H8, {})
        ] })
      }
    ),
    /* @__PURE__ */ d.jsx(Ko.List, { children: e.options.map((i, h) => {
      var m;
      const g = /* @__PURE__ */ d.jsx(
        Ko.Item,
        {
          onClick: () => {
            a(i.key), e.onChange(i.key);
          },
          children: i.variants ? /* @__PURE__ */ d.jsx(Rt, { display: "flex", alignItems: "center", children: /* @__PURE__ */ d.jsx(
            d3,
            {
              size: "medium",
              label: (m = i.render) == null ? void 0 : m.toString(),
              ...i.variants
            }
          ) }) : /* @__PURE__ */ d.jsx(Rt, { paddingLeft: "2", children: /* @__PURE__ */ d.jsx(ma, { children: i.render }) })
        },
        i.key
      );
      return e.divider && e.options.length > 2 && h === 0 ? /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
        g,
        /* @__PURE__ */ d.jsx(Ko.Divider, {})
      ] }) : g;
    }) })
  ] });
};
var LK = "v28rj20", IK = "v28rj21", HK = "v28rj22", ZK = "v28rj23", PK = "v28rj24", NK = "v28rj25";
const Lie = ({
  label: e,
  icon: n,
  defaultValue: a,
  value: i,
  options: h,
  onChange: g,
  selected: m
}) => {
  const S = Gp({
    defaultValue: a ? [a] : [],
    value: i,
    setValue: (b) => g(b)
  });
  return /* @__PURE__ */ d.jsxs(Rt, { children: [
    /* @__PURE__ */ d.jsx(
      mw,
      {
        store: S,
        className: LK,
        children: e
      }
    ),
    /* @__PURE__ */ d.jsx(
      f3,
      {
        store: S,
        className: zr(IK, {
          [HK]: m
        }),
        children: /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
          n,
          /* @__PURE__ */ d.jsx(
            ma,
            {
              size: "xSmall",
              color: m ? "white" : "secondaryContentText",
              children: e
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ d.jsxs(
      gw,
      {
        store: S,
        gutter: 4,
        className: ZK,
        children: [
          /* @__PURE__ */ d.jsx(qp, { size: 0 }),
          h.map((b) => /* @__PURE__ */ d.jsxs(
            pw,
            {
              value: b.key,
              className: PK,
              children: [
                /* @__PURE__ */ d.jsx("div", { className: NK, children: b.clearsOnClick && !i.includes(b.key) ? /* @__PURE__ */ d.jsx(YU, { color: "grey" }) : /* @__PURE__ */ d.jsx(I8, { color: "white" }) }),
                b.render
              ]
            },
            b.key
          ))
        ]
      }
    )
  ] });
};
var VK = "high", FK = "primary", BK = "rounded", UK = "medium", JR = Xo({ defaultClassName: "p08wka0", variantClassNames: { size: { small: "p08wka1", medium: "p08wka2", large: "p08wka3" } }, defaultVariants: { size: "medium" }, compoundVariants: [] }), YK = Xo({ defaultClassName: "p08wkak p08wka4 _1faqfmv4b _1faqfmv4v _1faqfmv35 _1faqfmv3p _1faqfmvsz _1faqfmvex _1faqfmv21 _1faqfmv2g", variantClassNames: { emphasis: { low: "p08wkal", medium: "p08wkam", high: "p08wkan" }, kind: { primary: "p08wkao", secondary: "p08wkap" }, shape: { rounded: "p08wkaq", basic: "p08wkar", leftBasic: "p08wkas", rightBasic: "p08wkat", square: "p08wkau" }, size: { small: "p08wkav", medium: "p08wkaw", large: "p08wkax" } }, defaultVariants: { emphasis: "high", kind: "primary", size: "medium", shape: "rounded" }, compoundVariants: [[{ kind: "primary", emphasis: "high" }, "p08wkay"], [{ kind: "primary", emphasis: "medium" }, "p08wkaz"], [{ kind: "primary", emphasis: "low" }, "p08wka10"], [{ kind: "secondary", emphasis: "high" }, "p08wka11"], [{ kind: "secondary", emphasis: "medium" }, "p08wka12"], [{ kind: "secondary", emphasis: "low" }, "p08wka13"], [{ size: "small", shape: "rounded" }, "p08wka14 p08wka5 _1faqfmv4c _1faqfmv4w _1faqfmv33 _1faqfmv3n _1faqfmvu7 _1faqfmva"], [{ size: "medium", shape: "rounded" }, "p08wka15 p08wka6 _1faqfmv4e _1faqfmv4y _1faqfmv35 _1faqfmv3p _1faqfmvub _1faqfmv9"], [{ size: "large", shape: "rounded" }, "p08wka16 p08wka7 _1faqfmv4g _1faqfmv50 _1faqfmv35 _1faqfmv3p _1faqfmvub _1faqfmv7"], [{ size: "small", shape: "basic" }, "p08wka17 p08wka8 _1faqfmv4b _1faqfmv4v _1faqfmv33 _1faqfmv3n _1faqfmvu7 _1faqfmv2"], [{ size: "medium", shape: "basic" }, "p08wka18 p08wka9 _1faqfmv4b _1faqfmv4v _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmv4"], [{ size: "large", shape: "basic" }, "p08wka19 p08wkaa _1faqfmv4c _1faqfmv4w _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmv5"], [{ size: "small", shape: "leftBasic" }, "p08wka1a p08wkab _1faqfmv4b _1faqfmv4v _1faqfmv33 _1faqfmv3n _1faqfmvu7 _1faqfmvf _1faqfmv15"], [{ size: "medium", shape: "leftBasic" }, "p08wka1b p08wkac _1faqfmv4b _1faqfmv4v _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmvh _1faqfmv17"], [{ size: "large", shape: "leftBasic" }, "p08wka1c p08wkad _1faqfmv4c _1faqfmv4w _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmvi _1faqfmv18"], [{ size: "small", shape: "square" }, "p08wka1d p08wkae _1faqfmv4b _1faqfmv4v _1faqfmv33 _1faqfmv3n _1faqfmvu7"], [{ size: "medium", shape: "square" }, "p08wka1e p08wkaf _1faqfmv4b _1faqfmv4v _1faqfmv35 _1faqfmv3p _1faqfmvu7"], [{ size: "large", shape: "square" }, "p08wka1f p08wkag _1faqfmv4c _1faqfmv4w _1faqfmv35 _1faqfmv3p _1faqfmvu7"], [{ size: "small", shape: "rightBasic" }, "p08wka1g p08wkah _1faqfmv4b _1faqfmv4v _1faqfmv33 _1faqfmv3n _1faqfmvu7 _1faqfmvs _1faqfmv1i"], [{ size: "medium", shape: "rightBasic" }, "p08wka1h p08wkai _1faqfmv4b _1faqfmv4v _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmvu _1faqfmv1k"], [{ size: "large", shape: "rightBasic" }, "p08wka1i p08wkaj _1faqfmv4c _1faqfmv4w _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmvv _1faqfmv1l"]] });
const $K = {
  small: "xSmall",
  medium: "xSmall",
  large: "small"
}, lS = ({
  children: e,
  className: n,
  icon: a,
  iconLeft: i,
  iconRight: h,
  emphasis: g = VK,
  shape: m = BK,
  size: S = UK,
  kind: b = FK,
  lines: R,
  wordBreak: D,
  onIconLeftClick: T,
  onIconRightClick: A,
  ...j
}) => {
  const I = $K[S];
  return a = a || i, /* @__PURE__ */ d.jsxs(
    N5,
    {
      render: /* @__PURE__ */ d.jsx("button", {}),
      className: zr([
        n,
        YK({
          emphasis: g,
          kind: b,
          size: S,
          shape: m
        })
      ]),
      style: { cursor: j.onClick ? "pointer" : "default" },
      type: "button",
      ...j,
      children: [
        a && /* @__PURE__ */ d.jsx(
          Rt,
          {
            as: "span",
            display: "inline-flex",
            cssClass: JR({ size: S }),
            onClick: T,
            children: a
          }
        ),
        e && /* @__PURE__ */ d.jsx(
          ma,
          {
            lines: R,
            size: I,
            userSelect: "none",
            color: "inherit",
            display: "inline-flex",
            break: D,
            children: e
          }
        ),
        h && /* @__PURE__ */ d.jsx(
          Rt,
          {
            as: "span",
            display: "inline-flex",
            cssClass: JR({ size: S }),
            onClick: A,
            children: h
          }
        )
      ]
    }
  );
}, Xp = ({
  children: e,
  ...n
}) => /* @__PURE__ */ d.jsx(NM, { placement: "bottom", ...n, children: e }), WK = ({
  children: e,
  ...n
}) => {
  const a = wh();
  return /* @__PURE__ */ d.jsx(
    iw,
    {
      store: a,
      render: /* @__PURE__ */ d.jsx(ww, {}),
      ...n,
      children: e
    }
  );
}, zK = ({
  children: e,
  ...n
}) => {
  const a = wh();
  return /* @__PURE__ */ d.jsx(iw, { store: a, render: /* @__PURE__ */ d.jsx(lS, {}), ...n, children: e });
}, qK = ({ children: e, ...n }) => {
  const a = wh();
  return /* @__PURE__ */ d.jsx(iw, { store: a, render: /* @__PURE__ */ d.jsx(Rt, {}), ...n, children: e });
}, GK = ({ children: e, className: n, ...a }) => {
  const i = wh();
  return /* @__PURE__ */ d.jsxs(
    ZM,
    {
      ...a,
      className: n,
      store: i,
      gutter: 4,
      children: [
        /* @__PURE__ */ d.jsx(qp, { size: 0 }),
        e
      ]
    }
  );
};
Xp.ButtonTrigger = WK;
Xp.TagTrigger = zK;
Xp.BoxTrigger = qK;
Xp.Content = GK;
Xp.useContext = wh;
Xp.useStore = o8;
var KK = Xo({ defaultClassName: "_1c7l6so1 _1c7l6so0 _1faqfmv5", variantClassNames: { size: { xxSmall: "_1c7l6so2", xSmall: "_1c7l6so3", small: "_1c7l6so4", medium: "_1c7l6so5" }, variant: { checked: "_1c7l6so6", unchecked: "_1c7l6so7" } }, defaultVariants: { variant: "unchecked" }, compoundVariants: [] });
const Iie = ({
  onChange: e,
  checked: n,
  size: a,
  iconLeft: i,
  iconRight: h,
  children: g,
  ...m
}) => {
  const S = KK({
    size: a,
    variant: n ? "checked" : "unchecked"
  }), b = W4();
  return /* @__PURE__ */ d.jsxs(
    TE,
    {
      render: /* @__PURE__ */ d.jsx("button", {}),
      className: S,
      store: b,
      onChange: e,
      checked: n,
      ...m,
      children: [
        i && /* @__PURE__ */ d.jsx(Rt, { as: "span", display: "inline-flex", children: i }),
        g && /* @__PURE__ */ d.jsx(ma, { size: "xSmall", children: g }),
        h && /* @__PURE__ */ d.jsx(Rt, { as: "span", display: "inline-flex", children: h })
      ]
    }
  );
}, QK = Ma.forwardRef(
  ({ children: e, ...n }, a) => /* @__PURE__ */ d.jsx(Rt, { ref: a, ...n, children: e })
);
var XK = "_1j3v9ks0";
const zO = ({ children: e, icon: n, ...a }) => /* @__PURE__ */ d.jsxs(
  Rt,
  {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    cursor: a.onClick ? "pointer" : void 0,
    gap: "6",
    cssClass: XK,
    borderRadius: "6",
    p: "8",
    ...a,
    children: [
      n && /* @__PURE__ */ d.jsx(Rt, { as: "span", display: "inline-flex", children: n }),
      e
    ]
  }
);
var JK = "_13pq1ik0", eQ = "_13pq1ik1", tQ = "_13pq1ik2", nQ = "_13pq1ik3";
const rQ = ({
  children: e,
  trigger: n = "cell"
}) => /* @__PURE__ */ d.jsx(
  Rt,
  {
    display: "flex",
    cssClass: zr(JK, {
      [eQ]: n === "row",
      [tQ]: n === "cell",
      [nQ]: n === "header"
    }),
    children: e
  }
);
var aQ = "_1kalioo0", oQ = "_1kalioo1";
const qO = ({
  children: e,
  gridColumns: n,
  selected: a,
  forwardRef: i,
  className: h,
  ...g
}) => {
  const S = Ma.Children.toArray(e).map(() => "1fr").join(" ");
  return /* @__PURE__ */ d.jsx(
    Rt,
    {
      ref: i,
      cssClass: zr(aQ, h, {
        [oQ]: a
      }),
      cursor: g.onClick ? "pointer" : void 0,
      style: {
        gridTemplateColumns: n ? n.join(" ") : S
      },
      ...g,
      children: e
    }
  );
}, iQ = ({ children: e }) => /* @__PURE__ */ d.jsx(qO, { gridColumns: ["100%"], children: /* @__PURE__ */ d.jsx(zO, { justifyContent: "center", my: "8", children: e }) });
var lQ = "_1pj3g9p0";
const uQ = ({ children: e, className: n }) => /* @__PURE__ */ d.jsx(Rt, { cssClass: zr(lQ, n), children: e });
var sQ = "_1z0mwsn0", cQ = "_1z0mwsn1";
const fQ = Ex(
  ({ children: e, noPadding: n, ...a }, i) => /* @__PURE__ */ d.jsx(
    Rt,
    {
      cssClass: zr(sQ, {
        [cQ]: n
      }),
      ref: i,
      ...a,
      children: /* @__PURE__ */ d.jsx(ma, { size: "xSmall", children: e })
    }
  )
);
var dQ = "_16l1zil1 _16l1zil0 _1faqfmv38 _1faqfmv3s", hQ = "_16l1zil2";
const vQ = ({ placeholder: e, handleChange: n }) => {
  const a = J4();
  return /* @__PURE__ */ d.jsxs(
    Rt,
    {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      cssClass: dQ,
      px: "8",
      gap: "8",
      children: [
        /* @__PURE__ */ d.jsx(kT, { color: nh.theme.static.content.default }),
        /* @__PURE__ */ d.jsx(
          h3,
          {
            store: a,
            name: "search",
            placeholder: e ?? "Search...",
            className: hQ,
            onChange: n
          }
        )
      ]
    }
  );
};
var pQ = "_84yol10", mQ = "_84yol11";
const gQ = ({
  children: e,
  className: n,
  height: a,
  noBorder: i
}) => /* @__PURE__ */ d.jsx(
  Rt,
  {
    cssClass: zr(pQ, n, {
      [mQ]: i
    }),
    height: a,
    width: "full",
    children: e
  }
), xh = gQ;
xh.Body = QK;
xh.Cell = zO;
xh.Discoverable = rQ;
xh.FullRow = iQ;
xh.Head = uQ;
xh.Header = fQ;
xh.Row = qO;
xh.Search = vQ;
const GO = Za({
  size: "sm"
}), w3 = ({
  children: e,
  defaultSelectedId: n,
  selectedId: a,
  size: i = "sm",
  onChange: h,
  scrollable: g
}) => {
  const m = hw({
    defaultSelectedId: n,
    setSelectedId: (S) => {
      h && h(S);
    }
  });
  return /* @__PURE__ */ d.jsx(GO.Provider, { value: { size: i }, children: /* @__PURE__ */ d.jsx(wT, { store: m, selectedId: a, children: /* @__PURE__ */ d.jsx(
    zl,
    {
      direction: "column",
      flexGrow: 1,
      gap: "0",
      width: "full",
      overflowY: g ? "hidden" : void 0,
      children: e
    }
  ) }) });
}, wQ = ({
  children: e,
  gap: n = "16",
  ...a
}) => /* @__PURE__ */ d.jsx(
  yT,
  {
    ...a,
    render: /* @__PURE__ */ d.jsx(
      zl,
      {
        align: "center",
        direction: "row",
        gap: n,
        borderBottom: "dividerWeak",
        children: e
      }
    )
  }
), yQ = ({ badgeText: e, children: n, icon: a, ...i }) => {
  const { size: h } = Qo(GO), m = A8().useState("selectedId") === i.id, [S, b] = Kt(!1), R = S || m;
  return /* @__PURE__ */ d.jsx(
    gT,
    {
      ...i,
      render: /* @__PURE__ */ d.jsxs(
        Rt,
        {
          display: "flex",
          gap: "4",
          pb: "6",
          flexDirection: "row",
          alignItems: "center",
          position: "relative",
          cursor: "pointer",
          onMouseEnter: () => b(!0),
          onMouseLeave: () => b(!1),
          children: [
            /* @__PURE__ */ d.jsx(
              lS,
              {
                shape: "basic",
                size: h === "xs" ? "medium" : "large",
                emphasis: "low",
                kind: m ? "primary" : "secondary",
                icon: a,
                children: n
              }
            ),
            e && /* @__PURE__ */ d.jsx(
              d3,
              {
                label: e,
                variant: m ? "purple" : "gray",
                shape: "basic",
                size: "small"
              }
            ),
            R && /* @__PURE__ */ d.jsx(
              Rt,
              {
                position: "absolute",
                backgroundColor: m ? "p9" : "n7",
                borderTopLeftRadius: "2",
                borderTopRightRadius: "2",
                width: "full",
                style: {
                  height: 2,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  width: "100%"
                }
              }
            )
          ]
        }
      )
    }
  );
}, xQ = ({
  children: e,
  scrollable: n,
  unmountOnHide: a = !0,
  ...i
}) => /* @__PURE__ */ d.jsx(
  xT,
  {
    ...i,
    unmountOnHide: a,
    render: /* @__PURE__ */ d.jsx(
      zl,
      {
        direction: "column",
        flexGrow: 1,
        id: i.id,
        overflowY: n ? "auto" : void 0,
        children: e
      }
    )
  }
);
w3.Tab = yQ;
w3.List = wQ;
w3.Panel = xQ;
w3.useStore = hw;
w3.useContext = A8;
const Hie = ({
  background: e = !0,
  defaultValue: n,
  name: a,
  options: i,
  onChange: h,
  cssClass: g
}) => {
  const [m, S] = Kt(
    n ?? i[0]
  ), b = (R) => {
    S(R), h && h(R);
  };
  return /* @__PURE__ */ d.jsx(MT, { children: /* @__PURE__ */ d.jsx(
    TT,
    {
      "data-testid": "radio-group",
      className: zr(g),
      children: /* @__PURE__ */ d.jsx(
        zl,
        {
          direction: "row",
          gap: "4",
          p: "4",
          borderRadius: "8",
          backgroundColor: e ? "elevated" : void 0,
          flexGrow: 0,
          style: { borderRadius: 9 },
          children: i.map((R, D) => {
            const T = m === R;
            return /* @__PURE__ */ d.jsx(
              BE,
              {
                name: a,
                value: R,
                render: /* @__PURE__ */ d.jsx(
                  lS,
                  {
                    kind: T ? "primary" : "secondary",
                    emphasis: T ? "high" : "low",
                    size: "large",
                    shape: "basic",
                    onClick: () => b(R),
                    style: {
                      alignItems: "center",
                      justifyContent: "center",
                      flex: 1,
                      textAlign: "center"
                    },
                    "data-testid": "radio-option",
                    type: "button",
                    children: R
                  },
                  R
                )
              },
              D
            );
          })
        }
      )
    }
  ) });
};
var SQ = Xo({ defaultClassName: "cuhupy0", variantClassNames: { underline: { none: "cuhupy1", solid: "cuhupy2" }, color: { none: "cuhupy3", default: "cuhupy4" } }, defaultVariants: { underline: "none" }, compoundVariants: [] });
const Zie = ({
  children: e,
  href: n,
  underline: a,
  target: i,
  rel: h,
  color: g
}) => /* @__PURE__ */ d.jsx(
  "a",
  {
    className: SQ({ underline: a, color: g }),
    href: n,
    target: i ?? "_blank",
    rel: h ?? "noreferrer",
    children: e
  }
), CQ = 500, Pie = ({
  children: e,
  trigger: n,
  disabled: a,
  style: i,
  delayed: h,
  renderInLine: g,
  maxWidth: m,
  shift: S,
  ...b
}) => {
  const R = M8({
    placement: "top",
    timeout: h ? CQ : 0,
    ...b
  });
  return /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    /* @__PURE__ */ d.jsx(
      sT,
      {
        store: R,
        style: { display: "flex", ...i },
        children: n
      }
    ),
    !a && /* @__PURE__ */ d.jsxs(
      uT,
      {
        store: R,
        gutter: 4,
        style: { zIndex: 20001 },
        portal: !g,
        shift: S,
        children: [
          /* @__PURE__ */ d.jsx(cT, { size: 0 }),
          /* @__PURE__ */ d.jsx(bQ, { maxWidth: m, children: e })
        ]
      }
    )
  ] });
}, bQ = ({ children: e, maxWidth: n = 350 }) => /* @__PURE__ */ d.jsx(
  Rt,
  {
    backgroundColor: "white",
    border: "secondary",
    p: "4",
    borderRadius: "6",
    shadow: "small",
    wordBreak: "break-word",
    style: { maxWidth: n },
    children: e
  }
);
export {
  DQ as Ariakit,
  d3 as Badge,
  Rt as Box,
  ww as Button,
  HU as ButtonContent,
  L8 as ButtonIcon,
  LQ as ButtonLink,
  bie as Callout,
  _ie as Card,
  tY as Column,
  h3 as Combobox,
  Eie as ComboboxSelect,
  Mie as Container,
  TK as DEFAULT_TIME_PRESETS,
  Die as DateRangePicker,
  iS as Dialog,
  Tie as EXTENDED_TIME_PRESETS,
  _G as Error,
  Ds as Form,
  aY as Group,
  oY as GroupLabel,
  jie as Heading,
  IQ as IconOutlineAcademicCap,
  HQ as IconOutlineAdjustments,
  ZQ as IconOutlineAnnotation,
  PQ as IconOutlineArchive,
  NQ as IconOutlineArrowCircleDown,
  VQ as IconOutlineArrowCircleLeft,
  FQ as IconOutlineArrowCircleRight,
  BQ as IconOutlineArrowCircleUp,
  UQ as IconOutlineArrowDown,
  YQ as IconOutlineArrowLeft,
  $Q as IconOutlineArrowNarrowDown,
  WQ as IconOutlineArrowNarrowLeft,
  zQ as IconOutlineArrowNarrowRight,
  qQ as IconOutlineArrowNarrowUp,
  GQ as IconOutlineArrowRight,
  QQ as IconOutlineArrowSmDown,
  XQ as IconOutlineArrowSmLeft,
  JQ as IconOutlineArrowSmRight,
  eX as IconOutlineArrowSmUp,
  tX as IconOutlineArrowUp,
  KQ as IconOutlineArrowsExpand,
  nX as IconOutlineAtSymbol,
  rX as IconOutlineBackspace,
  aX as IconOutlineBadgeCheck,
  oX as IconOutlineBan,
  iX as IconOutlineBeaker,
  lX as IconOutlineBell,
  cX as IconOutlineBookOpen,
  uX as IconOutlineBookmark,
  sX as IconOutlineBookmarkAlt,
  fX as IconOutlineBriefcase,
  dX as IconOutlineCake,
  hX as IconOutlineCalculator,
  vX as IconOutlineCalendar,
  pX as IconOutlineCamera,
  mX as IconOutlineCash,
  gX as IconOutlineChartBar,
  wX as IconOutlineChartPie,
  yX as IconOutlineChartSquareBar,
  xX as IconOutlineChat,
  SX as IconOutlineChatAlt,
  CX as IconOutlineChatAlt_2,
  bX as IconOutlineCheck,
  _X as IconOutlineCheckCircle,
  RX as IconOutlineCheveronDown,
  EX as IconOutlineCheveronLeft,
  MX as IconOutlineCheveronRight,
  TX as IconOutlineCheveronUp,
  OX as IconOutlineChevronDoubleDown,
  DX as IconOutlineChevronDoubleLeft,
  AX as IconOutlineChevronDoubleRight,
  jX as IconOutlineChevronDoubleUp,
  kX as IconOutlineChip,
  LX as IconOutlineClipboard,
  IX as IconOutlineClipboardCheck,
  HX as IconOutlineClipboardCopy,
  ZX as IconOutlineClipboardList,
  PX as IconOutlineClock,
  NX as IconOutlineCloud,
  VX as IconOutlineCloudDownload,
  FX as IconOutlineCloudUpload,
  BX as IconOutlineCode,
  UX as IconOutlineCog,
  YX as IconOutlineCollection,
  $X as IconOutlineColorSwatch,
  WX as IconOutlineCreditCard,
  zX as IconOutlineCube,
  qX as IconOutlineCubeTransparent,
  GX as IconOutlineCurrencyBangladeshi,
  KX as IconOutlineCurrencyDollar,
  QX as IconOutlineCurrencyEuro,
  XX as IconOutlineCurrencyPound,
  JX as IconOutlineCurrencyRupee,
  eJ as IconOutlineCurrencyYen,
  tJ as IconOutlineCursorClick,
  nJ as IconOutlineDatabase,
  rJ as IconOutlineDesktopComputer,
  aJ as IconOutlineDeviceMobile,
  oJ as IconOutlineDeviceTablet,
  iJ as IconOutlineDocument,
  lJ as IconOutlineDocumentAdd,
  uJ as IconOutlineDocumentDownload,
  sJ as IconOutlineDocumentDuplicate,
  cJ as IconOutlineDocumentRemove,
  fJ as IconOutlineDocumentReport,
  dJ as IconOutlineDocumentSearch,
  hJ as IconOutlineDocumentText,
  vJ as IconOutlineDotsCircleHorizontal,
  pJ as IconOutlineDotsHorizontal,
  mJ as IconOutlineDotsVertical,
  gJ as IconOutlineDownload,
  wJ as IconOutlineDuplicate,
  yJ as IconOutlineEmojiHappy,
  xJ as IconOutlineEmojiSad,
  SJ as IconOutlineExclamation,
  CJ as IconOutlineExclamationCircle,
  bJ as IconOutlineExit,
  _J as IconOutlineExternalLink,
  RJ as IconOutlineEye,
  EJ as IconOutlineEyeOff,
  MJ as IconOutlineFastForward,
  TJ as IconOutlineFilm,
  OJ as IconOutlineFilter,
  DJ as IconOutlineFingerPrint,
  AJ as IconOutlineFire,
  jJ as IconOutlineFlag,
  kJ as IconOutlineFolder,
  LJ as IconOutlineFolderAdd,
  IJ as IconOutlineFolderDownload,
  HJ as IconOutlineFolderOpen,
  ZJ as IconOutlineFolderRemove,
  PJ as IconOutlineGift,
  NJ as IconOutlineGlobe,
  VJ as IconOutlineGlobeAlt,
  FJ as IconOutlineHand,
  BJ as IconOutlineHashtag,
  UJ as IconOutlineHeart,
  YJ as IconOutlineHome,
  $J as IconOutlineIconUserRemove,
  WJ as IconOutlineIdentification,
  zJ as IconOutlineInbox,
  qJ as IconOutlineInboxIn,
  GJ as IconOutlineInformationCircle,
  KJ as IconOutlineKey,
  QJ as IconOutlineLibrary,
  XJ as IconOutlineLightBulb,
  JJ as IconOutlineLightningBolt,
  eee as IconOutlineLink,
  tee as IconOutlineLocationMarker,
  nee as IconOutlineLockClosed,
  ree as IconOutlineLockOpen,
  aee as IconOutlineLogout,
  oee as IconOutlineMail,
  iee as IconOutlineMailOpen,
  lee as IconOutlineMap,
  uee as IconOutlineMenu,
  see as IconOutlineMenuAlt_1,
  cee as IconOutlineMenuAlt_2,
  fee as IconOutlineMenuAlt_3,
  dee as IconOutlineMenuAlt_4,
  hee as IconOutlineMicrophone,
  vee as IconOutlineMinus,
  pee as IconOutlineMinusCircle,
  mee as IconOutlineMinusSm,
  gee as IconOutlineMoon,
  wee as IconOutlineMusicNote,
  yee as IconOutlineNewspaper,
  xee as IconOutlineOfficeBuilding,
  See as IconOutlinePaperAirplane,
  Cee as IconOutlinePaperClip,
  bee as IconOutlinePauseCircle,
  _ee as IconOutlinePencil,
  Ree as IconOutlinePencilAlt,
  Eee as IconOutlinePhone,
  Mee as IconOutlinePhoneIncoming,
  Tee as IconOutlinePhoneMissedCall,
  Oee as IconOutlinePhoneOutgoing,
  Dee as IconOutlinePhotograph,
  Aee as IconOutlinePlayCircle,
  jee as IconOutlinePlus,
  kee as IconOutlinePlusCircle,
  Lee as IconOutlinePlusSm,
  Iee as IconOutlinePresentationChartBar,
  Hee as IconOutlinePresentationChartLine,
  Zee as IconOutlinePrinter,
  Pee as IconOutlinePuzzle,
  Nee as IconOutlineQrCode,
  Vee as IconOutlineQuestionMarkCircle,
  Fee as IconOutlineReceiptRefund,
  Bee as IconOutlineReceiptTax,
  Uee as IconOutlineRefresh,
  Yee as IconOutlineReply,
  $ee as IconOutlineRewind,
  Wee as IconOutlineRss,
  zee as IconOutlineSankeyChart,
  qee as IconOutlineSave,
  Gee as IconOutlineSaveAs,
  Kee as IconOutlineScale,
  Qee as IconOutlineScissors,
  Xee as IconOutlineSearch,
  Jee as IconOutlineSearchCircle,
  ete as IconOutlineSelector,
  tte as IconOutlineServer,
  nte as IconOutlineShare,
  rte as IconOutlineShieldCheck,
  ate as IconOutlineShieldExclamation,
  ote as IconOutlineShoppingBag,
  ite as IconOutlineShoppingCart,
  lte as IconOutlineSixDotsVertical,
  ute as IconOutlineSmViewGridAdd,
  ste as IconOutlineSortAscending,
  cte as IconOutlineSortDescending,
  fte as IconOutlineSparkles,
  dte as IconOutlineSpeakerphone,
  hte as IconOutlineStackedBarChart,
  vte as IconOutlineStar,
  pte as IconOutlineStatusOffline,
  mte as IconOutlineStatusOnline,
  gte as IconOutlineStopCircle,
  wte as IconOutlineSun,
  yte as IconOutlineSunburstChart,
  xte as IconOutlineSupport,
  Ste as IconOutlineSwitchHorizontal,
  Cte as IconOutlineSwitchVertical,
  bte as IconOutlineTable,
  _te as IconOutlineTag,
  Rte as IconOutlineTemplate,
  Ete as IconOutlineTerminal,
  Mte as IconOutlineThumbDown,
  Tte as IconOutlineThumbUp,
  Ote as IconOutlineTicket,
  Dte as IconOutlineTranslate,
  Ate as IconOutlineTrash,
  jte as IconOutlineTrendingDown,
  kte as IconOutlineTrendingUp,
  Lte as IconOutlineTruck,
  Ite as IconOutlineUpload,
  Hte as IconOutlineUser,
  Zte as IconOutlineUserAdd,
  Pte as IconOutlineUserCircle,
  Nte as IconOutlineUserGroup,
  Vte as IconOutlineUsers,
  Fte as IconOutlineVariable,
  Bte as IconOutlineVideoCamera,
  Ute as IconOutlineViewBoards,
  Yte as IconOutlineViewGrid,
  $te as IconOutlineViewList,
  Wte as IconOutlineVolumeOff,
  zte as IconOutlineVolumeUp,
  qte as IconOutlineWifi,
  Gte as IconOutlineX,
  Kte as IconOutlineXCircle,
  Qte as IconOutlineZoomIn,
  Xte as IconOutlineZoomOut,
  Jte as IconSolidAcademicCap,
  ene as IconSolidAdjustments,
  tne as IconSolidAnnotation,
  nne as IconSolidArchive,
  rne as IconSolidArrowCircleDown,
  ane as IconSolidArrowCircleLeft,
  one as IconSolidArrowCircleRight,
  ine as IconSolidArrowCircleUp,
  lne as IconSolidArrowDown,
  une as IconSolidArrowLeft,
  sne as IconSolidArrowNarrowDown,
  cne as IconSolidArrowNarrowLeft,
  fne as IconSolidArrowNarrowRight,
  dne as IconSolidArrowNarrowUp,
  hne as IconSolidArrowRight,
  pne as IconSolidArrowSmDown,
  mne as IconSolidArrowSmLeft,
  gne as IconSolidArrowSmRight,
  wne as IconSolidArrowSmUp,
  yne as IconSolidArrowUp,
  vne as IconSolidArrowsExpand,
  xne as IconSolidAtSymbol,
  Sne as IconSolidBackspace,
  Cne as IconSolidBadgeCheck,
  bne as IconSolidBan,
  _ne as IconSolidBeaker,
  Rne as IconSolidBell,
  Tne as IconSolidBookOpen,
  Ene as IconSolidBookmark,
  Mne as IconSolidBookmarkAlt,
  One as IconSolidBriefcase,
  Dne as IconSolidCake,
  Ane as IconSolidCalculator,
  jne as IconSolidCalendar,
  kne as IconSolidCamera,
  Lne as IconSolidCart,
  Ine as IconSolidCash,
  Hne as IconSolidChartBar,
  Zne as IconSolidChartPie,
  Pne as IconSolidChartSquareBar,
  Nne as IconSolidChartSquareLine,
  Vne as IconSolidChat,
  Fne as IconSolidChatAlt,
  Bne as IconSolidChatAlt_2,
  AT as IconSolidCheck,
  I8 as IconSolidCheckCircle,
  H8 as IconSolidCheveronDown,
  VU as IconSolidCheveronLeft,
  jT as IconSolidCheveronRight,
  FU as IconSolidCheveronUp,
  Une as IconSolidChevronDoubleDown,
  Yne as IconSolidChevronDoubleLeft,
  $ne as IconSolidChevronDoubleRight,
  Wne as IconSolidChevronDoubleUp,
  zne as IconSolidChip,
  qne as IconSolidClickUp,
  Gne as IconSolidClipboard,
  Kne as IconSolidClipboardCheck,
  Qne as IconSolidClipboardCopy,
  Xne as IconSolidClipboardList,
  Jne as IconSolidClock,
  ere as IconSolidCloud,
  tre as IconSolidCloudDownload,
  nre as IconSolidCloudUpload,
  rre as IconSolidCode,
  are as IconSolidCog,
  ore as IconSolidCollection,
  ire as IconSolidColorSwatch,
  lre as IconSolidCreditCard,
  ure as IconSolidCube,
  sre as IconSolidCubeTransparent,
  cre as IconSolidCurrencyBangladeshi,
  fre as IconSolidCurrencyDollar,
  dre as IconSolidCurrencyEuro,
  hre as IconSolidCurrencyPound,
  vre as IconSolidCurrencyRupee,
  pre as IconSolidCurrencyYen,
  mre as IconSolidCursorClick,
  gre as IconSolidDatabase,
  wre as IconSolidDesktopComputer,
  yre as IconSolidDeviceMobile,
  xre as IconSolidDiscord,
  Sre as IconSolidDocument,
  Cre as IconSolidDocumentAdd,
  bre as IconSolidDocumentDownload,
  _re as IconSolidDocumentDuplicate,
  Rre as IconSolidDocumentRemove,
  Ere as IconSolidDocumentReport,
  Mre as IconSolidDocumentSearch,
  Tre as IconSolidDocumentText,
  Ore as IconSolidDotsCircleHorizontal,
  Dre as IconSolidDotsHorizontal,
  Are as IconSolidDotsVertical,
  jre as IconSolidDownload,
  kre as IconSolidDuplicate,
  Lre as IconSolidEmojiHappy,
  Ire as IconSolidEmojiSad,
  BU as IconSolidExclamation,
  Hre as IconSolidExclamationCircle,
  Zre as IconSolidExitRight,
  Pre as IconSolidExternalLink,
  Nre as IconSolidEye,
  Vre as IconSolidEyeOff,
  Fre as IconSolidFastForward,
  Bre as IconSolidFilm,
  Ure as IconSolidFilter,
  Yre as IconSolidFingerPrint,
  $re as IconSolidFire,
  Wre as IconSolidFlag,
  zre as IconSolidFolder,
  qre as IconSolidFolderAdd,
  Gre as IconSolidFolderDownload,
  Kre as IconSolidFolderOpen,
  Qre as IconSolidFolderRemove,
  Xre as IconSolidGift,
  Jre as IconSolidGithub,
  eae as IconSolidGitlab,
  tae as IconSolidGlobe,
  nae as IconSolidGlobeAlt,
  rae as IconSolidGoogle,
  aae as IconSolidGrafana,
  oae as IconSolidHand,
  iae as IconSolidHashtag,
  lae as IconSolidHeart,
  uae as IconSolidHeight,
  sae as IconSolidHighlight,
  cae as IconSolidHome,
  fae as IconSolidIdentification,
  dae as IconSolidInbox,
  hae as IconSolidInboxIn,
  UU as IconSolidInformationCircle,
  vae as IconSolidInspect,
  pae as IconSolidJira,
  mae as IconSolidKey,
  gae as IconSolidLightBulb,
  wae as IconSolidLightningBolt,
  yae as IconSolidLinear,
  xae as IconSolidLink,
  Sae as IconSolidLoading,
  Cae as IconSolidLoadingProgress,
  bae as IconSolidLocationMarker,
  _ae as IconSolidLockClosed,
  Rae as IconSolidLockOpen,
  Eae as IconSolidLogout,
  Mae as IconSolidLogs,
  Tae as IconSolidMail,
  Oae as IconSolidMailOpen,
  Dae as IconSolidMap,
  Aae as IconSolidMdLibrary,
  jae as IconSolidMenu,
  kae as IconSolidMenuAlt_1,
  Lae as IconSolidMenuAlt_2,
  Iae as IconSolidMenuAlt_3,
  Hae as IconSolidMenuAlt_4,
  Zae as IconSolidMicrophone,
  Pae as IconSolidMicrosoftTeams,
  YU as IconSolidMinus,
  Nae as IconSolidMinusCircle,
  Vae as IconSolidMinusSm,
  Fae as IconSolidMoon,
  Bae as IconSolidMusicNote,
  Uae as IconSolidNewspaper,
  Yae as IconSolidOfficeBuilding,
  $ae as IconSolidPaperAirplane,
  Wae as IconSolidPaperClip,
  zae as IconSolidPause,
  qae as IconSolidPauseCircle,
  Gae as IconSolidPencil,
  Kae as IconSolidPencilAlt,
  Qae as IconSolidPhone,
  Xae as IconSolidPhoneIncoming,
  Jae as IconSolidPhoneMissedCall,
  eoe as IconSolidPhoneOutgoing,
  toe as IconSolidPhotograph,
  noe as IconSolidPlay,
  roe as IconSolidPlayCircle,
  aoe as IconSolidPlus,
  ooe as IconSolidPlusCircle,
  ioe as IconSolidPlusSm,
  loe as IconSolidPresentationChartBar,
  uoe as IconSolidPresentationChartLine,
  soe as IconSolidPrinter,
  coe as IconSolidPuzzle,
  foe as IconSolidQrCode,
  doe as IconSolidQuestionMarkCircle,
  hoe as IconSolidReceiptRefund,
  voe as IconSolidReceiptTax,
  poe as IconSolidRefresh,
  moe as IconSolidReply,
  goe as IconSolidRewind,
  woe as IconSolidRss,
  yoe as IconSolidSave,
  xoe as IconSolidSaveAs,
  Soe as IconSolidScale,
  Coe as IconSolidScissors,
  kT as IconSolidSearch,
  boe as IconSolidSearchCircle,
  _oe as IconSolidSegment,
  LT as IconSolidSelector,
  Roe as IconSolidServer,
  Eoe as IconSolidShare,
  Moe as IconSolidShieldCheck,
  Toe as IconSolidShieldExclamation,
  Ooe as IconSolidShoppingBag,
  Doe as IconSolidSkip,
  Aoe as IconSolidSkipLeft,
  joe as IconSolidSlack,
  koe as IconSolidSmartphone,
  Loe as IconSolidSortAscending,
  Ioe as IconSolidSortDescending,
  Hoe as IconSolidSparkles,
  Zoe as IconSolidSpeakerphone,
  Poe as IconSolidStar,
  Noe as IconSolidStatusOffline,
  Voe as IconSolidStatusOnline,
  Foe as IconSolidStopCircle,
  Boe as IconSolidSun,
  Uoe as IconSolidSupport,
  Yoe as IconSolidSwitchHorizontal,
  $oe as IconSolidSwitchVertical,
  Woe as IconSolidTable,
  zoe as IconSolidTag,
  qoe as IconSolidTemplate,
  Goe as IconSolidTerminal,
  Koe as IconSolidThumbDown,
  Qoe as IconSolidThumbUp,
  Xoe as IconSolidTicket,
  Joe as IconSolidTraces,
  eie as IconSolidTranslate,
  tie as IconSolidTrash,
  nie as IconSolidTrendingDown,
  rie as IconSolidTrendingUp,
  aie as IconSolidTruck,
  oie as IconSolidUpload,
  iie as IconSolidUser,
  lie as IconSolidUserAdd,
  uie as IconSolidUserCircle,
  sie as IconSolidUserGroup,
  cie as IconSolidUserRemove,
  fie as IconSolidUsers,
  die as IconSolidVariable,
  hie as IconSolidVideoCamera,
  vie as IconSolidViewBoards,
  pie as IconSolidViewGrid,
  mie as IconSolidViewGridAdd,
  gie as IconSolidViewList,
  wie as IconSolidVolumeOff,
  yie as IconSolidVolumeUp,
  xie as IconSolidWifi,
  IT as IconSolidX,
  HT as IconSolidXCircle,
  Sie as IconSolidZoomIn,
  Cie as IconSolidZoomOut,
  EG as Input,
  rY as Item,
  aS as Label,
  Ko as Menu,
  kie as MenuButton,
  MK as MenuState,
  Lie as MultiSelectButton,
  UO as NamedSection,
  TG as Option,
  Xp as Popover,
  $0 as Select,
  zl as Stack,
  RG as Submit,
  Iie as SwitchButton,
  xh as Table,
  w3 as Tabs,
  lS as Tag,
  Hie as TagSwitchGroup,
  ma as Text,
  Zie as TextLink,
  Pie as Tooltip,
  bQ as TooltipContent,
  kQ as buttonStyles,
  Aie as getNow,
  Oie as parsePreset,
  WO as presetLabel,
  OK as presetStartDate,
  Rx as presetValue,
  AQ as sMonotype,
  jQ as typographyStyles,
  Rie as useComboboxStore
};
//# sourceMappingURL=components.js.map
